(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This helper contains parameters that track actions across pages
 * when appended to request URLs
 */

var URLTrackingParams = exports.URLTrackingParams = {
  //Tracking used for the nav search
  FROM_SEARCH_PARAM: "from_search=true",
  SEARCH_RANK_PARAM: "rank",
  SEARCH_IDENTIFIER_PARAM: "qid",

  // Interactions with the nav search that redirect to book#show should
  // include this param for tracking purposes:
  // https://w.amazon.com/index.php/Goodreads/Teams/Discovery/Metrics/Search#desktop_web
  BOOK_SHOW_INTERACTION_PARAM: "ac=1",

  // Tracking refs used for the nav bar discussions pane
  DISCUSSIONS_PANE_DISCUSSION: "nav_bar_discussions_pane_discussion"
};

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*eslint-disable camelcase*/
var TRACKED_CLASSES = exports.TRACKED_CLASSES = {
  // If you change the click_type here, please make sure to also change dfp_entry.rb
  //
  // The classes listed here are all classes tracked, other than the "more"
  // class found in mobile.

  // Book Ads
  book_image: {
    dfp: true,
    pmet: { click_type: "book_image" }
  },
  book_title: {
    dfp: true,
    pmet: { click_type: "book_title" }
  },
  author_link: {
    dfp: true,
    pmet: { click_type: "author_name" }
  },
  full_content_link: {
    dfp: true,
    pmet: { click_type: "body_click" }
  },
  user_profile: {
    dfp: true,
    pmet: { click_type: "social" }
  },
  want_to_read_button: {
    dfp: true,
    pmet: { click_type: "wtr_button" }
  },

  // Custom Ads
  sponsored_update_body_image: {
    dfp: true,
    pmet: { click_type: "image" }
  },
  cta_link: {
    dfp: true,
    pmet: { click_type: "cta_click" }
  },
  sponsored_label: {
    dfp: true,
    pmet: { click_type: "sponsored" }
  },

  // Other click tracking
  newsfeed_caret_not_interested: {
    dfp: false,
    pmet: { click_type: "not_interested" }
  },
  newsfeed_caret_help: {
    dfp: false,
    pmet: { click_type: "why" }
  },
  newsfeed_caret: {
    dfp: false,
    pmet: { click_type: "caret" }
  },

  // Desktop-Only
  user_rating_star: {
    dfp: true,
    pmet: { click_type: "rating" }
  },
  preview_book: {
    dfp: true,
    pmet: { click_type: "preview" }
  },
  sponsored_update_body_title_link: {
    dfp: true,
    pmet: { click_type: "sponsored_title" }
  }
};

var TRACKED_CLASSES_AUDIBLE = exports.TRACKED_CLASSES_AUDIBLE = {
  AEP_Desktop_Browse_Image: {
    dfp: true,
    pmet: { pmet_click_tid: "AEP_Desktop_Browse_Image" }
  },
  AEP_Desktop_Browse_Title: {
    dfp: true,
    pmet: { pmet_click_tid: "AEP_Desktop_Browse_Title" }
  },
  AEP_Desktop_Browse_ExploreButton: {
    dfp: true,
    pmet: { pmet_click_tid: "AEP_Desktop_Browse_ExploreButton" }
  },
  AEP_Desktop_Browse_SponsoredBy: {
    dfp: true,
    pmet: { pmet_click_tid: "AEP_Desktop_Browse_SponsoredBy" }
  },
  AEP_Desktop_Video_ExternalLink: {
    pmet: { pmet_click_tid: "AEP_Desktop_Video_ExternalLink",
      no_redirect: true }
  },
  AEP_Desktop_Sponsored_BookImage: {
    pmet: { pmet_click_tid: "AEP_Desktop_Sponsored_BookImage",
      no_redirect: true }
  },
  AEP_Desktop_Sponsored_BookTitle: {
    pmet: { pmet_click_tid: "AEP_Desktop_Sponsored_BookTitle",
      no_redirect: true }
  },
  AEP_Desktop_Sponsored_AuthorLink: {
    pmet: { pmet_click_tid: "AEP_Desktop_Sponsored_AuthorLink",
      no_redirect: true }
  },
  AEP_Desktop_Sponsored_WantToRead: {
    pmet: { pmet_click_tid: "AEP_Desktop_Sponsored_WantToRead",
      no_redirect: true }
  },
  AEP_Desktop_Sponsored_Stars: {
    pmet: { pmet_click_tid: "AEP_Desktop_Sponsored_Stars",
      no_redirect: true }
  },
  AEP_Desktop_Sponsored_BookDescription: {
    pmet: { pmet_click_tid: "AEP_Desktop_Sponsored_BookDescription",
      no_redirect: true }
  },
  AEP_Desktop_Sponsored_BookExternalLink: {
    pmet: { pmet_click_tid: "AEP_Desktop_Sponsored_BookExternalLink",
      no_redirect: true }
  },
  AEP_Desktop_Carousel_BookImage: {
    pmet: { pmet_click_tid: "AEP_Desktop_Carousel_BookImage",
      no_redirect: true }
  },
  AEP_Desktop_Carousel_WantToRead: {
    pmet: { pmet_click_tid: "AEP_Desktop_Carousel_WantToRead",
      no_redirect: true }
  },
  AEP_Mobile_Carousel_BookImage: {
    pmet: { pmet_click_tid: "AEP_Mobile_Carousel_BookImage",
      no_redirect: true }
  },
  AEP_Mobile_Carousel_WantToRead: {
    pmet: { pmet_click_tid: "AEP_Mobile_Carousel_WantToRead",
      no_redirect: true }
  },
  AEP_Mobile_Carousel_BookTitle: {
    pmet: { pmet_click_tid: "AEP_Mobile_Carousel_BookTitle",
      no_redirect: true }
  },
  AEP_Mobile_Carousel_Author: {
    pmet: { pmet_click_tid: "AEP_Mobile_Carousel_Author",
      no_redirect: true }
  }

};

var TRACKED_CLASSES_PREMIUM_CAMPAIGN = exports.TRACKED_CLASSES_PREMIUM_CAMPAIGN = {
  fcm_blog_title: {
    dfp: true,
    pmet: { click_type: "fcm_blog_title" }
  },
  fcm_blog_image: {
    dfp: true,
    pmet: { click_type: "fcm_blog_image" }
  },
  fcm_blog_button: {
    dfp: true,
    pmet: { click_type: "fcm_blog_button" }
  },
  fcm_book_author: {
    dfp: true,
    pmet: { click_type: "fcm_book_author" }
  },
  fcm_book_image: {
    dfp: true,
    pmet: { click_type: "fcm_book_image" }
  },
  fcm_book_title: {
    dfp: true,
    pmet: { click_type: "fcm_book_title" }
  },
  fcm_book_button: {
    dfp: true,
    pmet: { click_type: "fcm_book_button" }
  },
  fcm_book_description: {
    dfp: true,
    pmet: { click_type: "fcm_book_description" }
  },
  fcm_giveaway_author: {
    dfp: true,
    pmet: { click_type: "fcm_giveaway_author" }
  },
  fcm_giveaway_button: {
    dfp: true,
    pmet: { click_type: "fcm_giveaway_button" }
  },
  fcm_giveaway_image: {
    dfp: true,
    pmet: { click_type: "fcm_giveaway_image" }
  },
  fcm_giveaway_title: {
    dfp: true,
    pmet: { click_type: "fcm_giveaway_title" }
  },
  fcm_list_button: {
    dfp: true,
    pmet: { click_type: "fcm_list_button" }
  },
  fcm_list_books: {
    dfp: true,
    pmet: { click_type: "fcm_list_books" }
  },
  fcm_list_title: {
    dfp: true,
    pmet: { click_type: "fcm_list_title" }
  },
  fcm_genre_title: {
    dfp: true,
    pmet: { click_type: "fcm_genre_title" }
  },
  fcm_genre_image: {
    dfp: true,
    pmet: { click_type: "fcm_genre_image" }
  },
  fcm_genre_button: {
    dfp: true,
    pmet: { click_type: "fcm_genre_button" }
  }
};
/*eslint-enable*/

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchApstagBids = exports.requestCreative = undefined;
exports.requestCreativeForAdSlot = requestCreativeForAdSlot;
exports.defineSlot = defineSlot;
exports.enableServices = enableServices;
exports.dimensionsExplode = dimensionsExplode;
exports.validateA9Sizes = validateA9Sizes;
exports.getA9Sizes = getA9Sizes;
exports.slotToHash = slotToHash;
exports.lazyLoadOnView = lazyLoadOnView;
exports.lazyLoadInit = lazyLoadInit;
exports.adSlotsDefined = adSlotsDefined;

var _google_ads_store = require("../../react_stores/google_ads_store");

var _google_ads_actions = require("../../react_actions/google_ads_actions");

var _google_ads_actions2 = _interopRequireDefault(_google_ads_actions);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj; }

// Lazy load expand controls when we start loading ads before they become viewable
// The default from lazysizes is 370 which is too sensitive for our ads metrics
var LAZY_LOAD_EXPAND = 200;

var A9_SIZES = ["300x250", "728x90", "970x90", "320x50"];

// googletag helper methods
var allGptSlots = function allGptSlots() {
  return window.googletag.pubads().getSlots();
};
var getIdFromGptSlot = function getIdFromGptSlot(slot) {
  return slot.getSlotElementId();
};
var refreshSlots = function refreshSlots(slots) {
  return window.googletag.pubads().refresh(slots);
};

/*
 * This method defines the behavior after DFP indicates that a slot has finished
 * rendering. Here we track impressions. If the slot is a native ad, we will call
 * `attachServedNativeAdAttributesAndTracking` to insert the native creative.
 */
var attachCallbacksAfterSlotRender = function attachCallbacksAfterSlotRender(adId, params) {
  window.googletag.pubads().addEventListener("slotRenderEnded", function (event) {
    if (event.slot.getSlotId().getDomId() === adId) {
      if (event.isEmpty) {
        _google_ads_actions2.default.removeAdSlot(adId);
        _google_ads_actions2.default.trackImpression({ slotId: adId, impressionCode: _google_ads_store.ImpressionCode.empty });
      } else {
        var iframe = $j(params.googleHookSelector).find("iframe[id^=\"google_ads_iframe_\"]");
        var creative = iframe.contents().find(params.creativeSelector);
        var adUnit = event.slot.getAdUnitPath().split("/", 3)[2];

        /** Ad element to track in CSA */
        var impressionElement = document.getElementById("" + adId);

        if (params.isNativeAd) {
          var sponsoredId = creative.data("id");
          var clickUrl = creative.data("url");

          if (sponsoredId && clickUrl) {
            _google_ads_actions2.default.attachServedNativeAdAttributesAndTracking({
              slotId: adId,
              campaignId: event.campaignId,
              lineItemId: event.lineItemId,
              creative: creative,
              sponsoredId: sponsoredId,
              impressionCode: _google_ads_store.ImpressionCode.success,
              dfpUrl: creative.data("url"),
              adUnit: adUnit,
              impressionElement: impressionElement
            });
          } else {
            _google_ads_actions2.default.trackImpression({ slotId: adId, impressionCode: _google_ads_store.ImpressionCode.empty });
          }
        } else {
          _google_ads_actions2.default.attachServedBannerAdAttributesAndTracking({ slotId: adId,
            campaignId: event.campaignId,
            lineItemId: event.lineItemId,
            creative: creative,
            impressionCode: _google_ads_store.ImpressionCode.success,
            delayImpressionTracking: params.delayImpressionTracking,
            impressionElement: impressionElement
          });
        }
        if (params.dimensions === "160x600") {
          $j(".mainContentContainer").addClass("adSkinEnabled");
        }
      }
    }
  });
};

/**
* This method is responsible for attaching an event listener to the ad slot and
* for calling `display` on it. If the ad is lazy loaded, it will additionally
* define and refresh the slot.
*
* @param adId (required) id used by google to find the ad on the page
* @param params (required) contains information about the ad slot
        googleHookSelector (required) used to find the iframe within ad div
        creativeSelector (required) used to find the creatixve ID in the iframe
        dimensions (required) used to add styling to ad units
        isNativeAd (required) check if ad unit is native and look for sponsored update
        deviceType (optional) only used for poll requests to track device type
        delayImpressionTracking (optional) delay impression tracking
              until ad is viewed in navbar
*/
var requestCreative = exports.requestCreative = function requestCreative(adId) {
  var params = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  var googletag = window.googletag;

  attachCallbacksAfterSlotRender(adId, params);
  _google_ads_actions2.default.hasAttachedDfpCallbackForSlot(adId);

  if (params.lazyLoadedNewsfeedAd) {
    // For lazy loaded newsfeed ads, manually define the slot and refresh it
    // after calling googletag.display. We do this here to ensure that
    // the above listener is defined first.
    var ad = params.lazyLoadedNewsfeedAd;
    var slot = window.googletag.defineSlot("/4215/" + ad.name, ad.dimensions, adId);
    if (!slot) return;
    slot.addService(window.googletag.pubads());
    googletag.display(adId);
    refreshSlots([slot]);
  } else if (params.isLazyLoaded) {
    var creativeSize = dimensionsExplode(params.dimensions);
    var slot = googletag.defineSlot(params.path, creativeSize, adId);
    if (!slot) return;

    // Override forceSafeFrame for native ads
    if (params.isNativeAd) {
      slot.setConfig({
        safeFrame: {
          forceSafeFrame: false
        }
      });
    }

    slot.addService(googletag.pubads());
    var slotHash = [{
      slotID: adId, slotName: params.path, sizes: [creativeSize]
    }];
    // A9 only allows the following ad slot sizes
    // 300x250, 728x90, 970x90 and 320x50
    var a9Sizes = getA9Sizes(params.dimensions);
    var a9Hash = _lodash2.default.isEmpty(a9Sizes) ? [] : [slotToHash(params.path, adId, a9Sizes)];
    fetchApstagBids(slotHash, a9Hash);
  } else {
    googletag.cmd.push(function () {
      googletag.display(adId);
    });
  }
};

/**
 * Request Creative callback for ad slot
 * and mark ad as requested
 *
 */
function requestCreativeForAdSlot(adId) {
  var params = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  _google_ads_actions2.default.requestCreativeForSlot(adId, params);
}

/**
 * Define Ad Slot for ad units defined in dfp ads resources.
 * All ad units are defined when the store is initialized for
 * roadblock ads
 *
 * @param adId (required) add Id to the slot for googletags callback
 * @param slotPath (required) define path for ad unit
 * (i.e. /4215/goodr.book.show.300x250)
 * @param dimension (required) slot size (e.g. "300x250"). For multi-size ads,
 * this should be an array of slot sizes (e.g. ["970x66", "970x90", "970x250"])
 */
function defineSlot(adId, slotPath, dimension, adSizeMapping) {
  var isNativeAd = arguments.length <= 4 || arguments[4] === undefined ? false : arguments[4];

  if (window.googletag && window.googletag.cmd) {
    window.googletag.cmd.push(function () {
      var googletag = window.googletag;
      // If this is a multiple-sized ad slot, pass DFP an array of the eligible
      // slot sizes
      var creativeSize = dimensionsExplode(dimension);
      var slot = undefined;

      if (adSizeMapping) {
        var _ret = (function () {
          var mapping = googletag.sizeMapping();
          _lodash2.default.map(adSizeMapping, function (pair) {
            var pairingArray = _lodash2.default.map(pair, function (val) {
              var splitStr = val.split("x");
              return splitStr[0] ? [parseInt(splitStr[0]), parseInt(splitStr[1])] : [];
            });
            mapping = mapping.addSize(pairingArray[0], pairingArray[1]);
          });
          slot = googletag.defineSlot(slotPath, creativeSize, adId);
          if (!slot) return {
              v: undefined
            };
          slot.defineSizeMapping(mapping.build()).setCollapseEmptyDiv(true);
        })();

        if ((typeof _ret === "undefined" ? "undefined" : _typeof(_ret)) === "object") return _ret.v;
      } else {
        slot = googletag.defineSlot(slotPath, creativeSize, adId);
        if (!slot) return;
      }

      // Override forceSafeFrame for native ads
      if (isNativeAd) {
        slot.setConfig({
          safeFrame: {
            forceSafeFrame: false
          }
        });
      }

      slot.addService(googletag.pubads());
    });
  }
}

function enableServices() {
  if (window.googletag && window.googletag.cmd) {
    window.googletag.cmd.push(function () {
      var googletag = window.googletag;
      googletag.enableServices();
    });
  }
}

function dimensionsExplode(dimensions) {
  var dimensionsArray = undefined;
  if (Array.isArray(dimensions)) {
    dimensionsArray = _lodash2.default.map(dimensions, function (val) {
      var splitStr = val.split("x");
      return [parseInt(splitStr[0]), parseInt(splitStr[1])];
    });
  } else {
    var splitStr = dimensions.split("x");
    dimensionsArray = [parseInt(splitStr[0]), parseInt(splitStr[1])];
  }
  return dimensionsArray;
}

// A9 only allows the following ad slot sizes
// 300x250, 728x90, 970x90 and 320x50
function validateA9Sizes(val) {
  if (A9_SIZES.includes(val)) {
    return true;
  } else {
    return false;
  }
}

// Dimensions is either an array of sizes for the ad
// slot or one size represented as a string.
function getA9Sizes(dimensions) {
  var dimensionsArray = [];
  if (Array.isArray(dimensions)) {
    var validA9Dimensions = _lodash2.default.filter(dimensions, function (val) {
      return validateA9Sizes(val);
    });
    dimensionsArray = _lodash2.default.map(validA9Dimensions, function (val) {
      var splitStr = val.split("x");
      return [parseInt(splitStr[0]), parseInt(splitStr[1])];
    });
  } else {
    if (validateA9Sizes(dimensions)) {
      var splitStr = dimensions.split("x");
      dimensionsArray = [[parseInt(splitStr[0]), parseInt(splitStr[1])]];
    }
  }
  return dimensionsArray;
}

// This function converts an ad object (from the Google Ads Store data)
// into a hash compatible with the apstag library.
function slotToHash(ad, adId) {
  var a9Sizes = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];

  // Prepare slot data for apstag

  var dimensions = Array.isArray(ad.dimensions) ? ad.dimensions : [ad.dimensions];
  var dimensionsMapped = _lodash2.default.isEmpty(a9Sizes) ? _lodash2.default.map(dimensions, function (val) {
    var splitStr = val.split("x");
    return [parseInt(splitStr[0]), parseInt(splitStr[1])];
  }) : a9Sizes;
  return {
    slotID: adId,
    slotName: ad.path,
    sizes: dimensionsMapped
  };
}

// This function takes an array of slot hashes (outputs from slotToHash) and
// submits them to apstag, which returns bids on those slots from A9. These bids
// are added to the targeting values of the slots, and a
// googletag.pubads().refresh() request is made for all slots passed in.
//
// NOTE: ADS WILL NOT DISPLAY PROPERLY UNTIL THIS FUNCTION IS CALLED FOR THE
// SLOTS TO BE DISPLAYED!
var fetchApstagBids = exports.fetchApstagBids = function fetchApstagBids(gptSlots, apsSlots) {
  var googletag = window.googletag;
  if (googletag && googletag.cmd) {
    googletag.cmd.push(function () {
      var apstag = window.apstag;
      if (Array.isArray(gptSlots) && gptSlots.length) {
        _lodash2.default.isEmpty(apsSlots) ? googletag.cmd.push(function () {
          return checkCallbacksAndRefresh(gptSlots);
        }) : apstag.fetchBids({
          slots: apsSlots
        }, function () {
          googletag.cmd.push(function () {
            return checkCallbacksAndRefresh(gptSlots);
          });
        });
      }
    });
  }
};

var checkCallbacksAndRefresh = function checkCallbacksAndRefresh(apsSlots) {
  var apstag = window.apstag;
  var apsSlotIds = apsSlots.map(function (apsSlot) {
    return apsSlot.slotID;
  });
  var gptSlots = allGptSlots().filter(function (gptSlot) {
    return apsSlotIds.includes(getIdFromGptSlot(gptSlot));
  });
  new Promise(function (resolve, reject) {
    return _google_ads_actions2.default.checkCallbacksAttached(resolve, reject, apsSlotIds);
  }).then(function () {
    apstag.setDisplayBids();
    refreshSlots(gptSlots);
  }).catch(function () {
    return null;
  });
};

// This is here because jQuery can't be stubbed directly in tests.
function lazyLoadOnView(callback) {
  $j(document).on("lazybeforeunveil", callback);
}

// Set Lazyload params on google ad store initialization
function lazyLoadInit() {
  window.lazySizesConfig = window.lazySizesConfig || {};
  window.lazySizesConfig.expand = LAZY_LOAD_EXPAND;
}

function adSlotsDefined() {
  var googletag = window.googletag;
  return typeof googletag === "function" && googletag.pubads().getSlots().length > 0;
}

},{"../../react_actions/google_ads_actions":34,"../../react_stores/google_ads_store":240,"lodash":"lodash"}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_ERROR_MESSAGE = undefined;
exports.httpRequest = httpRequest;
exports.httpPost = httpPost;
exports.httpDelete = httpDelete;
exports.httpGet = httpGet;

var _default_auth_failure_handler = require("./default_auth_failure_handler");

var _lodash = require("lodash");

/**
 * Make an ajax request for the provided url. The returned promise
 * may never be fulfilled and will instead redirect the browser
 * to an authentication page if the URL requires that the user is
 * signed in and they are currently not signed in.
 *
 * If you want the user to be successfully returned to your
 * page, look into setting session[:jumpto] in your controller
 * action. :return_url and other mechanisms do not work generically.
 *
 * TODO-GR-44007: replace jQuery as underlying library
 *
 * @param url - Required. String URL for the desired resource
 * @param options
 *        options.method = "GET" (default), "POST", "DELETE"
 *        all other options are passed along unchanged to jQuery.ajax
 *        see https://api.jquery.com/jQuery.ajax/ for API. For example, pass
 *        {contentType: "json"} to have response parsed as JSON and returned
 *        as an Object. Pass a `data` key with your request arguments.
 * @return jQuery.Promise
 *         will resolve with the same arguments as the done/success callback
 *         or reject with the same arguments as the fail callback
 */
function httpRequest(url) {
  var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  options = (0, _lodash.merge)({}, options, { type: options.method });
  options = (0, _lodash.omit)(options, "method");

  var deferred = $j.Deferred();
  var jQueryPromise = $j.ajax(url, options);

  jQueryPromise.done(deferred.resolve);

  jQueryPromise.fail(function (jqXHR, textStatus, errorThrown) {
    if ((0, _default_auth_failure_handler.redirectOnAuthFailure)(jqXHR)) {
      return; // never fulfill or reject because we just want the redirect to go through
    } else {
        deferred.reject(jqXHR, textStatus, errorThrown);
      }
  });

  return deferred.promise();
}

/**
 * convenience method for httpRequest with the desired
 * method of POST. see doc for httpRequest for complete
 * details.
 *
 * @param url
 * @param options
 * @return {jQuery.Promise}
 */
function httpPost(url) {
  var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  return httpRequest(url, (0, _lodash.merge)({}, options, { method: "POST" }));
}

/**
 * convenience method for httpRequest with the desired
 * method of DELETE. see doc for httpRequest for complete
 * details.

 * @param url
 * @param options
 * @return {jQuery.Promise}
 */
function httpDelete(url) {
  var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  return httpRequest(url, (0, _lodash.merge)({}, options, { method: "DELETE" }));
}

/**
 * convenience method for httpRequest with the desired
 * method of GET. see doc for httpRequest for complete
 * details.
 *
 * @param url
 * @param options
 * @return {jQuery.Promise}
 */
function httpGet(url) {
  var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  return httpRequest(url, (0, _lodash.merge)({}, options, { method: "GET" }));
}

var DEFAULT_ERROR_MESSAGE = exports.DEFAULT_ERROR_MESSAGE = "Something went wrong with your request. Please\n  try again later.";

},{"./default_auth_failure_handler":5,"lodash":"lodash"}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redirectOnAuthFailure = redirectOnAuthFailure;

var _env_utils = require("../env_utils");

/**
 * If we receive a 403, redirect.
 *
 * Port of the Flight mixin app/assets/javascripts/components/mixins/auth_redirect.js
 *
 * @param jqXHR
 * @returns {boolean} true if it was a 403 and will be redirected. false otherwise.
 *                    if true, it's best not to try to execute any more code since it
 *                    may not have time to run before window.unload
 */
function redirectOnAuthFailure(jqXHR) {
  if (jqXHR && jqXHR.status === 403) {
    var data = jqXHR.responseJSON;
    if (data.redirect) {
      (0, _env_utils.setLocationUrl)(data.redirect);
      return true;
    }
  }
  return false;
}

},{"../env_utils":13}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var BOOK_ORIGINS = exports.BOOK_ORIGINS = {
  CURRENTLY_READING_WIDGET: "currently-reading-widget",
  UPDATE_READING_PROGRESS: "hp_status_editor"
};

},{}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _appendQuery = require("append-query");

var _appendQuery2 = _interopRequireDefault(_appendQuery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

  /**
   * Opens child window for sharing on external social platforms
   * 
   * @param baseUrl - url to connect to platform
   * @param options - object of url parameters that send share item data to social window
   * @param windowSpecs - position and dimensions of child window
   */

  openSocialShareWindow: function openSocialShareWindow(baseUrl, options, windowSpecs) {
    var socialShareUrl = (0, _appendQuery2.default)(baseUrl, options);
    var shareWindowPosition = "left=" + windowSpecs.left + ", top=" + windowSpecs.top;
    var shareWindowDimensions = "width=" + windowSpecs.width + ", height=" + windowSpecs.height;
    var shareWindowSpecs = shareWindowPosition + ", " + shareWindowDimensions + ", menubar=no, scrollbar=no";
    window.open(socialShareUrl, "_blank", shareWindowSpecs);
  }
};

},{"append-query":"append-query"}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRACKING_URLS = undefined;
exports.trackClick = trackClick;
exports.trackView = trackView;
exports.trackNavEngage = trackNavEngage;
exports.trackNavEngageClick = trackNavEngageClick;

var _ajax_helper = require("./ajax/ajax_helper");

var _env_utils = require("../modules/env_utils");

var _env_utils2 = _interopRequireDefault(_env_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Helper module for making AJAX posts to track_controller from React
 */

var TRACKING_URLS = exports.TRACKING_URLS = {
  CLICK: "/track/track_click",
  MOBILE_SETTINGS: "/track/track_mobile_settings"
};

/*
 * Track event via AJAX post to the tracking url
 * Format the type and metric labels to comply with the action's expectation
 * The url param value must be a url in TRACKING_URLS
 */
function track(type, url, metric) {
  switch (url) {
    case TRACKING_URLS.CLICK:
      (0, _ajax_helper.httpPost)(url, {
        data: {
          feature: type + "_" + metric
        }
      });
      break;
    case TRACKING_URLS.MOBILE_SETTINGS:
      (0, _ajax_helper.httpPost)(url, {
        data: {
          type: type,
          metric: metric
        }
      });
      break;
    default:
      break;
  }
}

function trackClick(url, metric) {
  track("click", url, metric);
}

function trackView(url, metric) {
  track("view", url, metric);
}

/*
 * Track engagement with header/nav feature
 * Namespace nav engagement metrics with Nav prefix
 * Do not use for onClick events; use trackNavEngageClick
 */
function trackNavEngage(feature) {
  track("Nav", TRACKING_URLS.CLICK, feature);
}

/*
 * Track clicks on header/nav feature
 * Handle link targets, so AJAX is fired before navigation
 */
function trackNavEngageClick(e, feature) {
  if (e && e.target) {
    var target = e.target;
    if (target.tagName === "A" && !e.defaultPrevented) {
      e.preventDefault();
      trackNavEngage(feature);
      _env_utils2.default.setLocationUrl(target.href);
    } else {
      trackNavEngage(feature);
    }
  }
}

},{"../modules/env_utils":13,"./ajax/ajax_helper":4}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var VARIANTS = exports.VARIANTS = {
  DEFAULT: "default",
  DARK_BG: "darkBg"
};

},{}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleDataTracking = handleDataTracking;

var _data_tracking_actions = require("../../react_actions/data_tracking/data_tracking_actions");

var _data_tracking_actions2 = _interopRequireDefault(_data_tracking_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isTrackingEnabled = function isTrackingEnabled(sourceElement) {
  return sourceElement.getAttribute("data-tracking-enabletracking") === "true";
};

/**
 * This function is a JavaScript DOM event listener implementation to handle any type of
 * user interaction on a DOM Element. The listener is attached by
 * react_mixins/tracking_data_attributes_mixin.js mixin for components with
 * `trackingOptions.enableTracking` prop set to true. The listener will trigger a react action when
 * it first encounters data-tracking-enabletracking="true" data attribute within the source element.
 *
 * @param event Object - JavaScript event object
 */
function handleDataTracking(event) {
  var source = event.target;
  var trackingRootNode = event.currentTarget;

  var dataTrackingEnabled = false;

  if (source === trackingRootNode) {
    dataTrackingEnabled = isTrackingEnabled(source);
  } else {
    //when clicked on one of the child elements of trackingRootNode element.
    while (trackingRootNode.contains(source)) {
      dataTrackingEnabled = isTrackingEnabled(source);
      if (dataTrackingEnabled) {
        break;
      }
      source = source.parentNode;
    }
  }

  if (dataTrackingEnabled) {
    _data_tracking_actions2.default.trackClickEvent(event, source);
  }
}

},{"../../react_actions/data_tracking/data_tracking_actions":30}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fromNow = fromNow;
exports.getFormattedDate = getFormattedDate;

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Refer to moment docs for default duration.humanize thresholds
// http://momentjs.com/docs/*/customization/relative-time-threshold/
/**
 * A util library to support custom date functions.
 */
_moment2.default.relativeTimeThreshold("s", 60);
_moment2.default.relativeTimeThreshold("m", 60);
_moment2.default.relativeTimeThreshold("h", 24);
_moment2.default.relativeTimeThreshold("d", 25);
_moment2.default.relativeTimeThreshold("M", 10);

_moment2.default.locale("en-abbreviated", { // Define custom relative time formats
  relativeTime: {
    future: "in %s",
    past: "%s",
    s: "Just now",
    m: "1m",
    mm: "%dm",
    h: "1h",
    hh: "%dh",
    d: "1d",
    dd: "%dd",
    M: "a month",
    MM: "%d months",
    y: "a year",
    yy: "%d years"
  }
});
_moment2.default.locale("en"); // Reset to default

/**
 * Returns relative time
 * Refer to http://momentjs.com/docs/ for more on Relativetime settings
 *
 * @param pastTime Date - A JavaScript date
 * @param currentTime moment - (Optional) if passed calculates the relative from
 * that moment. Default is moment() which is now
 * @param mockPastTime moment - (Optional) only used as di for tests
 *
 * @returns String - relative time from now in the below format
 *
 * Just Now = under a minute ago
 * 1m = 1 minute, for use in 1-59 minutes
 * 1h = 1 hour, for use in 1-23 hours
 * 1d = 1 day, for use in 1-6 days
 * 1w = 1 week, for use in anything under a month
 * 15 Mar = day and month, for use or anything older than a month
 * 15 Mar 12 = anything in previous year
 */
function fromNow(pastTime) {
  var currentTime = arguments.length <= 1 || arguments[1] === undefined ? (0, _moment2.default)() : arguments[1];
  var mockPastTime = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

  currentTime.locale("en-abbreviated");
  if (mockPastTime !== null) {
    pastTime = mockPastTime;
  } else {
    pastTime = (0, _moment2.default)(pastTime).locale("en-abbreviated");
  }

  var pastDays = currentTime.diff(pastTime, "days");
  var pastMonths = currentTime.diff(pastTime, "months");
  var pastDaysPrecise = currentTime.diff(pastTime, "days", true);
  var relativeWeekThreshold = 6.5; // 6.5 days is considered a week

  if (_lodash2.default.inRange(pastMonths, 1, 13)) {
    // under a year
    return currentTime.subtract(pastDays, "days").format("DD MMM");
  } else if (pastMonths > 12) {
    // over a year
    return currentTime.subtract(pastDays, "days").format("DD MMM YY");
  } else if (_lodash2.default.inRange(pastDays, 7, 28)) {
    // under a month
    return Math.ceil(pastDays / 7) + "w";
  } else if (pastDaysPrecise >= relativeWeekThreshold && pastDaysPrecise <= 28) {
    // same as above but handles a special case where > 6.5 days should be "1w" instead of "7d"
    return Math.round(pastDaysPrecise / relativeWeekThreshold) + "w";
  } else {
    // under a week uses moment relative threshold configuration above
    return pastTime.fromNow();
  }
}

/**
 * Returns a formatted date
 * Refer to http://momentjs.com/docs/#/parsing/string/ for details on parsing
 *
 * @param date String
 * @param format String - deisred output format, defaults to YYYY-MM-DD
 * @return String - date string in the specified format
 */
function getFormattedDate(date) {
  var format = arguments.length <= 1 || arguments[1] === undefined ? "YYYY-MM-DD" : arguments[1];

  if (date) {
    var parsedDate = (0, _moment2.default)(date);
    return parsedDate.format(format);
  }
  return "";
}

},{"lodash":"lodash","moment":"moment"}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkIconClassnames = exports.getExclusiveShelfType = exports.SHELF_TYPES = exports.DEFAULT_SHELVES = undefined;

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_SHELVES = exports.DEFAULT_SHELVES = {
  READ: {
    name: "read",
    displayName: "Read"
  },
  CURRENTLY_READING: {
    name: "currently-reading",
    displayName: "Currently Reading"
  },
  WANT_TO_READ: {
    name: "to-read",
    displayName: "Want to Read"
  },
  DID_NOT_FINISH: {
    name: "did-not-finish",
    displayName: "Did Not Finish"
  }
};

var SHELF_TYPES = exports.SHELF_TYPES = {
  DEFAULT: "defaultShelves",
  CUSTOM_EXCLUSIVE: "customExclusiveShelves",
  NONEXCLUSIVE: "nonExclusiveShelves"
};

var getExclusiveShelfType = exports.getExclusiveShelfType = function getExclusiveShelfType(shelfName) {
  if (shelfName === DEFAULT_SHELVES.READ.name || shelfName === DEFAULT_SHELVES.CURRENTLY_READING.name || shelfName === DEFAULT_SHELVES.WANT_TO_READ.name || shelfName === DEFAULT_SHELVES.DID_NOT_FINISH.name) {
    return SHELF_TYPES.DEFAULT;
  } else {
    return SHELF_TYPES.CUSTOM_EXCLUSIVE;
  }
};

// returns check icon style that matches exclusive shelf
var checkIconClassnames = exports.checkIconClassnames = function checkIconClassnames(shelfName) {
  return (0, _classnames2.default)({
    "wantToReadButton__checkIcon--toRead": shelfName === DEFAULT_SHELVES.WANT_TO_READ.name,
    "wantToReadButton__checkIcon--currentlyReading": shelfName === DEFAULT_SHELVES.CURRENTLY_READING.name,
    "wantToReadButton__checkIcon--read": shelfName === DEFAULT_SHELVES.READ.name,
    "wantToReadButton__checkIcon--didNotFinish": shelfName === DEFAULT_SHELVES.DID_NOT_FINISH.name,
    "wantToReadButton__checkIcon--other": shelfName && getExclusiveShelfType(shelfName) === SHELF_TYPES.CUSTOM_EXCLUSIVE
  });
};

},{"classnames":"classnames"}],13:[function(require,module,exports){
"use strict";

/**
 * Environment specific utility module to support shared code. Its using commonJS style exports instead
 * of ES6 exports as its used in gulpfile.js which is not ES6 yet.
 */
module.exports = {
  PRODUCTION: "production",
  DEVELOPMENT: "development",
  TEST: "test",

  /**
   * Returns true if DOM is available for rendering.
   * @return {boolean}
   */
  hasDom: function hasDom() {
    return !!window.document;
  },

  /**
   * Returns true if there is no DOM available for rendering.
   * @return {boolean}
   */
  domUnavailable: function domUnavailable() {
    return !this.hasDom();
  },
  isDevelopment: function isDevelopment() {
    return "production" === this.DEVELOPMENT;
  },
  getCurrentPath: function getCurrentPath() {
    if (window && window.location) {
      return window.encodeURIComponent(window.location.pathname + window.location.search);
    }
  },

  /**
   * Sets window location href to the given url. Why a separate method? To easily test it as its
   * not trivial to mock object attributes in unit testing.
   *
   * @param url String - new location url
   */
  setLocationUrl: function setLocationUrl(url) {
    if (window) {
      window.location.href = url;
    }
  },
  getLocationUrl: function getLocationUrl() {
    if (window && window.location) {
      return window.location.href;
    }
  },

  // Another window.location accessor, to make stubbing in tests easier.
  getLocationPathname: function getLocationPathname() {
    if (window && window.location) {
      return window.location.pathname;
    }
  }
};

},{}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var clearFlashMessage = exports.clearFlashMessage = function clearFlashMessage() {
  $j("#flashMessages").trigger("clearFlashMessage");
};

// Hide any error message displayed in flash; display success flash message
var flashSuccessMessage = exports.flashSuccessMessage = function flashSuccessMessage(msg) {
  clearFlashMessage();
  $j("#flashMessages").trigger("addFlashMessage", [msg, "success"]);
};

var flashErrorMessage = exports.flashErrorMessage = function flashErrorMessage(msg) {
  $j("#flashMessages").trigger("addFlashMessage", [msg, "error"]);
};

},{}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

exports.default = {

  /*
    Reports an error.
    Always logs the error and message to the console.
    It used to send to bugsnag but no longer.
     params
      - error: the error with relevant stack trace.
      - message: friendly title for searching
   */

  notifyException: function notifyException(error, message) {
    if (error) {
      if (window.console && (0, _lodash.isFunction)(window.console.error)) {
        window.console.error(message, error.stack); //eslint-disable-line no-console
      }
    } else if (window.console && (0, _lodash.isFunction)(window.console.warn)) {
        window.console.warn("Attempted to notifyException without providing error,\n                           message: " + message);
      }
  },

  /**
   * Notify a user of an error. Currently just uses the browser's alert dialog
   * but may eventually use a custom, stylized dialog.
   *
   * @param message (required) text to show the user
   */
  notifyUser: function notifyUser(message) {
    if (window && (0, _lodash.isFunction)(window.alert)) {
      window.alert(message);
    }
  }
};

},{"lodash":"lodash"}],16:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var KEYCODES = {
  enter: 13,
  escape: 27,
  space: 32,
  leftArrow: 37,
  upArrow: 38,
  rightArrow: 39,
  downArrow: 40
};

exports.default = {
  isEnter: function isEnter(keyCode) {
    return keyCode === KEYCODES.enter;
  },
  isEscape: function isEscape(keyCode) {
    return keyCode === KEYCODES.escape;
  },
  isSpace: function isSpace(keyCode) {
    return keyCode === KEYCODES.space;
  },
  isArrowLeft: function isArrowLeft(keyCode) {
    return keyCode === KEYCODES.leftArrow;
  },
  isArrowUp: function isArrowUp(keyCode) {
    return keyCode === KEYCODES.upArrow;
  },
  isArrowRight: function isArrowRight(keyCode) {
    return keyCode === KEYCODES.rightArrow;
  },
  isArrowDown: function isArrowDown(keyCode) {
    return keyCode === KEYCODES.downArrow;
  },
  isDropdownOpenerKey: function isDropdownOpenerKey(keyCode) {
    return this.isEnter(keyCode) || this.isSpace(keyCode) || this.isArrowDown(keyCode);
  },
  isDefaultOpenerKey: function isDefaultOpenerKey(keyCode) {
    return this.isEnter(keyCode) || this.isSpace(keyCode);
  },
  isDefaultCloserKey: function isDefaultCloserKey(keyCode) {
    return this.isEscape(keyCode);
  },

  KEYCODES: KEYCODES
};

},{}],17:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * A modal id library to help modals find the corresponding modal id.
 */

// friend/follow confirmation modal helpers
var addDropdownSuffix = function addDropdownSuffix(prefix) {
  var add = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return add ? prefix + "Dropdown" : prefix;
};

var getUnfollowModalId = exports.getUnfollowModalId = function getUnfollowModalId(userId) {
  var fromDropdown = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return addDropdownSuffix("confirmUnfollow" + userId, fromDropdown);
};

var getCancelFriendRequestModalId = exports.getCancelFriendRequestModalId = function getCancelFriendRequestModalId(userId) {
  var fromDropdown = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return addDropdownSuffix("confirmCancelFriendRequest" + userId, fromDropdown);
};

var getUnfriendModalId = exports.getUnfriendModalId = function getUnfriendModalId(userId) {
  var fromDropdown = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return addDropdownSuffix("confirmUnfriend" + userId, fromDropdown);
};

var getBlockUserModalId = exports.getBlockUserModalId = function getBlockUserModalId(userId) {
  var fromDropdown = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return addDropdownSuffix("confirmBlockUser" + userId, fromDropdown);
};

var getUnblockUserModalId = exports.getUnblockUserModalId = function getUnblockUserModalId(userId) {
  var fromDropdown = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return addDropdownSuffix("confirmUnblockUser" + userId, fromDropdown);
};

},{}],18:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var BOOK_LOAD_ERROR_MSG = exports.BOOK_LOAD_ERROR_MSG = "Sorry, we’re having trouble loading your books right now. Please try again later.";

},{}],19:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ICON_SIZES = exports.ICON_SIZES = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large"
};

var ICON_SHAPES = exports.ICON_SHAPES = {
  CIRCLE: "circular",
  ROUND_SQUARE: "roundSquare",
  RECTANGULAR: "rectangular"
};

},{}],20:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getImages = getImages;
/**
 * gr_image_registry.js.erb stores Rails-generated image paths in window.
 * This module serves as an interface to those image paths; JavaScript code under app/gulp
 * should import this module rather than try to access `window` directly.
 *
 * refer to:
 * /rails-root/app/assets/javascripts/shared_all_formats/gr_image_registry.js.erb
 * @returns {*}
 */

function getImages() {
  // window.GrImageRegistry is not available to server side rendering and throws
  // JS errors when accessing images from the object. Returning an empty object to avoid those
  // server side errors.
  return window.GrImageRegistry || {};
}

},{}],21:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.acknowledgeEvent = acknowledgeEvent;
/**
 * Acknowledge event for Touch Not Ready (TNR) metrics
 * If an event is acknowledged, the TNR count should not be incremented
 * The custom ACK count for the element should be incremented
 * See custom_touch_not_ready.js
 * The native browser event must be accessed from React's SyntheticEvent wrapper
 *
 * References:
 * https://w.amazon.com/bin/view/Latency/Projects/TouchNotReady/DeveloperDocs
 * https://reactjs.org/docs/events.html
 */

function acknowledgeEvent(event) {
  // Only acknowledge if native event available and TNR library loaded
  if (event && event.nativeEvent && event.nativeEvent.acknowledge) {
    event.nativeEvent.acknowledge(event.currentTarget);
  }
}

},{}],22:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var astralLength = exports.astralLength = function astralLength(string) {
  return string.replace(/(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g, "_").length;
};

var countWords = exports.countWords = function countWords(text) {
  return text ? text.split(" ").length : 0;
};

},{}],23:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             This module is a JS version of ruby's #to_sentence method, which converts an
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             array to a comma-separated sentence where the last element is joined by a
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             connector word.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  toSentence: function toSentence(items) {
    var lastWordConnector = arguments.length <= 1 || arguments[1] === undefined ? "and" : arguments[1];

    var sentence = [];
    var numItems = items.length;
    switch (numItems) {
      case 0:
        return "";
      case 1:
        sentence.push(items[0]);
        break;
      case 2:
        sentence.push(items[0]);
        sentence.push(" " + lastWordConnector + " ");
        sentence.push(items[1]);
        break;
      default:
        _lodash2.default.each(items.slice(0, -1), function (item) {
          sentence.push(item);
          sentence.push(", ");
        });
        sentence.push(lastWordConnector + " ");
        sentence.push(items[numItems - 1]); // last item
        break;
    }
    return _jsx("span", {}, void 0, sentence);
  },
  sentenceJoin: function sentenceJoin(items) {
    var separator = arguments.length <= 1 || arguments[1] === undefined ? ", " : arguments[1];

    var sentence = [];
    _lodash2.default.each(items.slice(0, -1), function (item) {
      sentence.push(item);
      sentence.push(separator);
    });
    sentence.push(items[items.length - 1]);
    return _jsx("span", {}, void 0, sentence);
  }
};

},{"lodash":"lodash"}],24:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Valid status from friendship_status(user) method in friend_helper.rb
var FRIEND_STATUS = exports.FRIEND_STATUS = {
  SELF: "self",
  FRIEND: "friend",
  REQUEST_PENDING_FROM: "request_pending_from",
  REQUEST_PENDING_TO: "request_pending_to",
  NONE: "none"
};

},{}],25:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["follow", "unFollow"]);

},{"reflux":"reflux"}],26:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return _reflux2.default.createActions([
  // selects a specific result based on mouse movement
  "selectSpecificResult",
  // selects the next active result index based on arrow key input
  "selectNextResult",
  // selects the previous active result index based on arrow key input
  "selectPreviousResult",
  // queries the search controller for search results based on user input
  "search",
  // hides searching spinner and shows the results
  "searchResultsFound",
  // either shows/hides the results based on the input
  "setShowResultsContainer"]);
};

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

},{"reflux":"reflux"}],27:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getACopyClickedHandler = exports.getACopyClosed = exports.getACopyLoadedSuccess = exports.GET_A_COPY_ACTIONS = undefined;

var _ajax_helper = require("../../modules/ajax/ajax_helper");

var GET_A_COPY_ACTIONS = exports.GET_A_COPY_ACTIONS = {
  LOADED_SUCCESS: "GET_A_COPY_LOADED_SUCCESS",
  INTERSTITIAL_CLOSED: "GET_A_COPY_INTERSTITIAL_CLOSED"
};

var getACopyLoadedSuccess = exports.getACopyLoadedSuccess = function getACopyLoadedSuccess(data) {
  return {
    type: GET_A_COPY_ACTIONS.LOADED_SUCCESS,
    data: data
  };
};

var getACopyClosed = exports.getACopyClosed = function getACopyClosed() {
  return {
    type: GET_A_COPY_ACTIONS.INTERSTITIAL_CLOSED
  };
};

var getACopyClickedHandler = exports.getACopyClickedHandler = function getACopyClickedHandler(getACopyDataUrl) {
  return function (dispatch) {
    (0, _ajax_helper.httpGet)(getACopyDataUrl).done(function (data) {
      dispatch(getACopyLoadedSuccess(data));
    });
  };
};

},{"../../modules/ajax/ajax_helper":4}],28:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions({
  addNewComment: {},
  commentEntered: { sync: true },
  deleteComment: {},
  showCommentsForPage: {},
  showSeeMoreLoadingSpinner: {},
  textareaFocused: {},
  textareaFocusRequested: {},
  textareaUnfocused: {}
});

},{"reflux":"reflux"}],29:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["updatePreference"]);

},{"reflux":"reflux"}],30:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions([
// expect event object with additional trackingOptions object
"trackClickEvent"]);

},{"reflux":"reflux"}],31:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions([
/*
 * Indicates a user has changed their favorite genres
 * required arg: array of favorited genre strings
 *                This should be the complete set of their favorite genres,
 *                even if they were previously favorited.
*/
"changeFavoriteGenres"]);

},{"reflux":"reflux"}],32:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["selectFavoriteGenre", "deselectFavoriteGenre", "submitSelectedGenres"]);

},{"reflux":"reflux"}],33:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["displayError", "requestFeaturedBooks", "trackMenuImpression"]);

},{"reflux":"reflux"}],34:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions([
// accepts a single string arg that is the contents of the message
"requestCreativeForSlot", "displayCreativeForSlot", "removeAdSlot", "trackImpression", "attachServedNativeAdAttributesAndTracking", "attachServedBannerAdAttributesAndTracking", "hasAttachedDfpCallbackForSlot", "checkCallbacksAttached"]);

},{"reflux":"reflux"}],35:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var TOGGLE_SEARCH = exports.TOGGLE_SEARCH = "TOGGLE_SEARCH";

var toggleSearch = exports.toggleSearch = function toggleSearch(searchIsActive) {
  return {
    type: TOGGLE_SEARCH,
    searchIsActive: searchIsActive
  };
};

},{}],36:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["like", "unLike"]);

},{"reflux":"reflux"}],37:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["openModal", "closeModal"]);

},{"reflux":"reflux"}],38:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions({
  loadMoreUpdates: {},
  newsfeedItemsLoaded: { sync: true },
  updateNativeAdSlot: {},
  userNotInterested: {},
  undoUserNotInterested: {},
  hideStory: {},
  previewBook: {},
  setUpdatesFeedPreferences: {}
});

},{"reflux":"reflux"}],39:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["loadError", "loadNotifications", "requestNotifications"]);

},{"reflux":"reflux"}],40:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["loadAnnotatedBooks"]);

},{"reflux":"reflux"}],41:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["updateProgress", "closeUpdateProgressForm", "openUpdateProgressForm", "refreshReadingSessions", "shelveBookSuccess", "loadAllReadingSessions"]);

},{"reflux":"reflux"}],42:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions({
  updateSharingTextInputValue: { sync: true },
  submitShare: {},
  openShareModal: {}
});

},{"reflux":"reflux"}],43:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions({
  addShelvings: {},
  bookShelved: {},
  bookUnshelved: {},
  shelveBook: {},
  toggleNonExclusiveShelving: {},
  rateBook: { children: ["newBook", "failed"] },
  unshelveBook: {}
});

},{"reflux":"reflux"}],44:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["deselectTab", // Could result in no tabs being activated
"selectTab"]);

},{"reflux":"reflux"}],45:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["blockMember"]);

},{"reflux":"reflux"}],46:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["follow", "unFollow"]);

},{"reflux":"reflux"}],47:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["userAgentGainsTouch", "userAgentLosesTouch"]);

},{"reflux":"reflux"}],48:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["userNotInterested", "undoUserNotInterested", "isFlashMessageForBook", "closeFlashMessage", "addBookIDToState"]);

},{"reflux":"reflux"}],49:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["unfriend", "acceptFriendRequest", "cancelFriendRequest", "follow", "unfollow"]);

},{"reflux":"reflux"}],50:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["addNonExclusiveShelf", "removeNonExclusiveShelf"]);

},{"reflux":"reflux"}],51:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["openAddShelfTextbox", "closeAddShelfTextbox", "updateShelfNameFilter", "updateShelves"]);

},{"reflux":"reflux"}],52:[function(require,module,exports){
"use strict";

require("./_polyfills");

var _dom_ready_initializers = require("./_dom_ready_initializers");

var _dom_ready_initializers2 = _interopRequireDefault(_dom_ready_initializers);

var _public_actions = require("./_public_actions");

var _public_actions2 = _interopRequireDefault(_public_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.ReactActions = _public_actions2.default;

// initialize any routines that are required to execute on DOM Ready
_dom_ready_initializers2.default.initializeModernizrTouchCheck();

},{"./_dom_ready_initializers":53,"./_polyfills":54,"./_public_actions":55}],53:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {

  /**
   * Initializes modernizr touch check on DOM Ready
   */
  initializeModernizrTouchCheck: function initializeModernizrTouchCheck() {
    document.addEventListener("DOMContentLoaded", function () {
      if (Modernizr && Modernizr.touchevents) {
        window.ReactActions.UserAgentCapabilitiesActions.userAgentGainsTouch();
      } else {
        window.ReactActions.UserAgentCapabilitiesActions.userAgentLosesTouch();
      }
    });
  }
};

},{}],54:[function(require,module,exports){
"use strict";

var _objectAssign = require("object-assign");

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("../react_isomorphic/shims/Array.prototype.find");

window.Object.assign = _objectAssign2.default;

},{"../react_isomorphic/shims/Array.prototype.find":222,"object-assign":"object-assign"}],55:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _user_agent_capabilities_actions = require("../react_actions/user_agent_capabilities_actions");

var _user_agent_capabilities_actions2 = _interopRequireDefault(_user_agent_capabilities_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  UserAgentCapabilitiesActions: _user_agent_capabilities_actions2.default
};

},{"../react_actions/user_agent_capabilities_actions":47}],56:[function(require,module,exports){
"use strict";

require("./_common");

var _global = require("../react_isomorphic/global");

var _site_header = require("../react_isomorphic/site_header");

var _reading_notes = require("../react_isomorphic/reading_notes");

var _friend_follow_module = require("../react_isomorphic/friend_follow_module");

var _news = require("../react_isomorphic/news");

var _experiments = require("../react_isomorphic/experiments");

var _lodash = require("lodash");

/*
  For simplicity we are just including any components and stores that can
  appear on different pages based on deploy service settings so we don't need
  different bundles based on settings and pages...yet.
*/

window.ReactComponents = (0, _lodash.merge)({}, _global.GlobalComponents, _site_header.HeaderComponents, _experiments.ExperimentComponents, _reading_notes.ReadingNotesComponents, _friend_follow_module.FriendFollowModuleComponents, _news.NewsComponents);

window.ReactStores = (0, _lodash.merge)({}, _global.GlobalStores, _site_header.HeaderStores, _experiments.ExperimentStores, _reading_notes.ReadingNotesStores, _friend_follow_module.FriendFollowModuleStores);

},{"../react_isomorphic/experiments":215,"../react_isomorphic/friend_follow_module":218,"../react_isomorphic/global":219,"../react_isomorphic/news":220,"../react_isomorphic/reading_notes":221,"../react_isomorphic/site_header":223,"./_common":52,"lodash":"lodash"}],57:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _google_ads_store = require("../../react_stores/google_ads_store");

var _google_ads_store2 = _interopRequireDefault(_google_ads_store);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _google_ad_helper = require("../../modules/ads/google_ad_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var BLOCK_CLASS_NAME = "googleBannerAd";

exports.default = _gr_component_factory2.default.createClass({
  displayName: "GoogleBannerAd",

  mixins: [_reflux2.default.connectFilter(_google_ads_store2.default, "googleAdsStore", function (adsStoreState) {
    return adsStoreState.ads[this.props.adId];
  })],

  propTypes: {
    adId: _react2.default.PropTypes.string.isRequired,
    className: _react2.default.PropTypes.string,
    delayImpressionTracking: _react2.default.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      delayImpressionTracking: false
    };
  },
  getStoreState: function getStoreState() {
    return this.state.googleAdsStore;
  },
  componentDidMount: function componentDidMount() {
    var adId = this.props.adId;
    if (this.getStoreState()) {
      var params = {
        googleHookSelector: this.refs.googleHook,
        creativeSelector: this.getStoreState().creativeSelector,
        dimensions: this.getStoreState().dimensions,
        isNativeAd: this.getStoreState().isNativeAd,
        delayImpressionTracking: this.props.delayImpressionTracking,
        isLazyLoaded: this.getStoreState().isLazyLoaded,
        path: this.getStoreState().path
      };
      if (this.getStoreState().isLazyLoaded) {
        (0, _google_ad_helper.lazyLoadOnView)((function (event) {
          if (event.target.id === this.adId) {
            (0, _google_ad_helper.requestCreativeForAdSlot)(this.adId, this.params);
          }
        }).bind({ adId: adId, params: params }));
      } else {
        (0, _google_ad_helper.requestCreativeForAdSlot)(this.props.adId, params);
      }
    }
  },
  getWidthFromDimensions: function getWidthFromDimensions(dimensionsStr) {
    return parseInt(dimensionsStr.split("x")[0]);
  },
  getBannerAdSizingStyle: function getBannerAdSizingStyle(dimensions) {
    var _this = this;

    var width = undefined;
    if (Array.isArray(dimensions)) {
      var _Math;

      // Per DFP recommendations regarding multi-size ads, we should set the
      // width to the widest creative to avoid ads being cropped.
      width = (_Math = Math).max.apply(_Math, _toConsumableArray(dimensions.map(function (x) {
        return _this.getWidthFromDimensions(x);
      })));
    } else {
      width = this.getWidthFromDimensions(dimensions);
    }
    return { width: width, height: "auto" };
  },
  render: function render() {
    if (this.getStoreState()) {
      var classes = (0, _classnames2.default)(this.props.className, BLOCK_CLASS_NAME, {
        lazyload: this.getStoreState().isLazyLoaded
      });
      return _react2.default.createElement("div", { className: classes,
        id: this.props.adId,
        style: this.getBannerAdSizingStyle(this.getStoreState().dimensions),
        ref: "googleHook" });
    } else {
      return null;
    }
  }
});

},{"../../modules/ads/google_ad_helper":3,"../../react_stores/google_ads_store":240,"../gr_component_factory":102,"classnames":"classnames","react":"react","reflux":"reflux"}],58:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _google_ads_store = require("../../react_stores/google_ads_store");

var _google_ads_store2 = _interopRequireDefault(_google_ads_store);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _featured_content_module = require("../featured_content_module");

var _featured_content_module2 = _interopRequireDefault(_featured_content_module);

var _google_ad_helper = require("../../modules/ads/google_ad_helper");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BLOCK_CLASS_NAME = "googleFeaturedContentModule";

exports.default = _gr_component_factory2.default.createClass({
  displayName: "GoogleFeaturedContentModule",

  mixins: [_reflux2.default.connectFilter(_google_ads_store2.default, "googleAdsStore", function (adsStoreState) {
    return adsStoreState.nativeAds[this.props.adId];
  })],

  propTypes: {
    adId: React.PropTypes.string.isRequired,
    trackingOptions: React.PropTypes.shape({
      enableTracking: React.PropTypes.bool,
      adId: React.PropTypes.string
    }).isRequired,
    isMobile: React.PropTypes.bool,
    hasBottomBorder: React.PropTypes.bool,
    isInline: React.PropTypes.bool
  },

  defaultProps: {
    isMobile: false,
    isInline: false,
    hasBottomBorder: false
  },

  getStoreState: function getStoreState() {
    return this.state.googleAdsStore;
  },
  componentDidMount: function componentDidMount() {
    if (this.getStoreState() && !this.getStoreState().creative) {
      var params = {
        googleHookSelector: this.refs.googleHook,
        creativeSelector: this.getStoreState().creativeSelector,
        dimensions: this.getStoreState().dimensions,
        isNativeAd: this.getStoreState().isNativeAd,
        path: this.getStoreState().path
      };
      (0, _google_ad_helper.requestCreativeForAdSlot)(this.props.adId, params);
    }
  },
  renderCreative: function renderCreative() {
    var creative = this.getStoreState().creative;
    return _jsx(_featured_content_module2.default, {
      type: creative.type,
      resource: creative.resource,
      sponsorName: creative.sponsorName,
      isSponsored: creative.isSponsored,
      isMobile: this.props.isMobile,
      isInline: this.props.isInline,
      hasBottomBorder: this.props.hasBottomBorder
    });
  },
  render: function render() {
    if (this.getStoreState()) {
      var className = (0, _classnames2.default)(BLOCK_CLASS_NAME, this.getStoreState().className);
      var creativeBody = this.getStoreState().creative ? this.renderCreative() : null;
      return _jsx("div", {}, void 0, creativeBody, React.createElement("div", { className: className, id: this.props.adId, ref: "googleHook" }));
    } else {
      return null;
    }
  }
});

},{"../../modules/ads/google_ad_helper":3,"../../react_stores/google_ads_store":240,"../featured_content_module":98,"../gr_component_factory":102,"classnames":"classnames","reflux":"reflux"}],59:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _google_ads_store = require("../../react_stores/google_ads_store");

var _google_ads_store2 = _interopRequireDefault(_google_ads_store);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _page_skin = require("../page_skin");

var _page_skin2 = _interopRequireDefault(_page_skin);

var _google_ad_helper = require("../../modules/ads/google_ad_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "GooglePageSkin",

  mixins: [_reflux2.default.connectFilter(_google_ads_store2.default, "googleAdsStore", function (adsStoreState) {
    return adsStoreState.nativeAds[this.props.adId];
  })],

  propTypes: {
    adId: React.PropTypes.string.isRequired,
    image: React.PropTypes.string,
    trackingOptions: React.PropTypes.shape({
      enableTracking: React.PropTypes.bool,
      adId: React.PropTypes.string
    }).isRequired
  },

  getStoreState: function getStoreState() {
    return this.state.googleAdsStore;
  },
  componentDidMount: function componentDidMount() {
    if (this.getStoreState() && !this.getStoreState().creative) {
      var params = {
        googleHookSelector: this.refs.googleHook,
        creativeSelector: this.getStoreState().creativeSelector,
        dimensions: this.getStoreState().dimensions,
        isNativeAd: this.getStoreState().isNativeAd,
        path: this.getStoreState().path
      };
      (0, _google_ad_helper.requestCreativeForAdSlot)(this.props.adId, params);
    }
  },
  renderCreative: function renderCreative() {
    return _jsx(_page_skin2.default, {
      imageUrl: this.getStoreState().creative.image_url,
      backgroundColor: this.getStoreState().creative.background_color
    });
  },
  render: function render() {
    if (this.getStoreState()) {
      var classes = this.getStoreState().className;
      var creativeBody = this.getStoreState().creative ? this.renderCreative() : null;
      return _jsx("div", {
        className: "pageskinContainer"
      }, void 0, creativeBody, React.createElement("div", { className: classes, id: this.props.adId, ref: "googleHook" }));
    } else {
      return null;
    }
  }
});

},{"../../modules/ads/google_ad_helper":3,"../../react_stores/google_ads_store":240,"../gr_component_factory":102,"../page_skin":141,"reflux":"reflux"}],60:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // Google ad store connection to native ads
// This component calls request native ad which pull the native ad id from the iframe
// and requests the native ad from ajax_native_ad in dfp_controller

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _google_ads_store = require("../../../react_stores/google_ads_store");

var _google_ads_store2 = _interopRequireDefault(_google_ads_store);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _native_ad_body = require("./native_ad_body");

var _native_ad_body2 = _interopRequireDefault(_native_ad_body);

var _google_ad_helper = require("../../../modules/ads/google_ad_helper");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "GoogleNativeAd",

  mixins: [_reflux2.default.connectFilter(_google_ads_store2.default, "googleAdsStore", function (adsStoreState) {
    return adsStoreState.nativeAds[this.props.adId];
  })],

  propTypes: {
    adId: React.PropTypes.string.isRequired,
    trackingOptions: React.PropTypes.shape({
      enableTracking: React.PropTypes.bool,
      adId: React.PropTypes.string
    }).isRequired,
    className: React.PropTypes.string,
    signedIn: React.PropTypes.bool,
    allowBehavioralTargeting: React.PropTypes.bool,
    isMobile: React.PropTypes.bool,
    isNewsfeed: React.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      isMobile: false,
      isNewsfeed: true,
      signedIn: true
    };
  },
  getStoreState: function getStoreState() {
    return this.state.googleAdsStore;
  },
  componentDidMount: function componentDidMount() {
    if (this.getStoreState() && !this.getStoreState().creative) {
      var params = {
        googleHookSelector: this.refs.googleHook,
        creativeSelector: this.getStoreState().creativeSelector,
        dimensions: this.getStoreState().dimensions,
        isNativeAd: this.getStoreState().isNativeAd,
        lazyLoadedNewsfeedAd: this.getStoreState().lazyLoadedNewsfeedAd,
        path: this.getStoreState().path,
        isLazyLoaded: this.getStoreState().isLazyLoaded
      };
      if (this.getStoreState().lazyLoadedNewsfeedAd || this.getStoreState().isLazyLoaded) {
        (0, _google_ad_helper.lazyLoadOnView)((function (event) {
          if (event.target.id === this.adId) {
            (0, _google_ad_helper.requestCreativeForAdSlot)(this.adId, this.params);
          }
        }).bind({ adId: this.props.adId, params: params }));
      } else {
        (0, _google_ad_helper.requestCreativeForAdSlot)(this.props.adId, params);
      }
    }
  },
  render: function render() {
    if (this.getStoreState()) {
      // IMPORTANT: We must keep the googleHook div visible in order to preserve
      //            viewable impressions!
      var googleHookClasses = (0, _classnames2.default)("googleNativeAd__googleHook", this.getStoreState().className, "lazyload");
      var nativeAdClasses = (0, _classnames2.default)("googleNativeAd", this.props.className);
      var nativeAdBody = this.getStoreState().creative ? _jsx(_native_ad_body2.default, {
        creative: this.getStoreState().creative,
        adId: this.props.adId,
        deviceType: this.getStoreState().deviceType,
        signedIn: this.props.signedIn,
        allowBehavioralTargeting: this.props.allowBehavioralTargeting,
        isMobile: this.props.isMobile,
        isNewsfeed: this.props.isNewsfeed
      }) : null;
      return _jsx("div", {
        className: nativeAdClasses
      }, void 0, React.createElement(
        "div",
        { className: googleHookClasses, id: this.props.adId, ref: "googleHook" },
        nativeAdBody
      ));
    } else {
      return null;
    }
  }
});

},{"../../../modules/ads/google_ad_helper":3,"../../../react_stores/google_ads_store":240,"../../gr_component_factory":102,"./native_ad_body":62,"classnames":"classnames","reflux":"reflux"}],61:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _google_ads_store = require("../../../react_stores/google_ads_store");

var _google_ads_store2 = _interopRequireDefault(_google_ads_store);

var _google_native_ad = require("./google_native_ad");

var _google_native_ad2 = _interopRequireDefault(_google_native_ad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "NativeAd",

  mixins: [_reflux2.default.connectFilter(_google_ads_store2.default, "googleAdsStore", function (adsStoreState) {
    return adsStoreState.nativeAds[this.props.adId];
  })],

  propTypes: {
    adId: _react2.default.PropTypes.string.isRequired,
    trackingOptions: _react2.default.PropTypes.shape({
      enableTracking: _react2.default.PropTypes.bool,
      adId: _react2.default.PropTypes.string
    }).isRequired,
    className: _react2.default.PropTypes.string,
    signedIn: _react2.default.PropTypes.bool,
    allowBehavioralTargeting: _react2.default.PropTypes.bool,
    isMobile: _react2.default.PropTypes.bool,
    isNewsfeed: _react2.default.PropTypes.bool
  },

  getAdsStoreState: function getAdsStoreState() {
    return this.state.googleAdsStore;
  },
  getDefaultProps: function getDefaultProps() {
    return {
      signedIn: true,
      isMobile: false,
      isNewsfeed: true
    };
  },
  render: function render() {
    if (!this.getAdsStoreState()) {
      return null;
    }
    return _react2.default.createElement(_google_native_ad2.default, this.props);
  }
}); // Entry point for native ads

},{"../../../react_stores/google_ads_store":240,"../../gr_component_factory":102,"./google_native_ad":60,"react":"react","reflux":"reflux"}],62:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _user_not_interested_store = require("../../../react_stores/user_not_interested_store");

var _user_not_interested_store2 = _interopRequireDefault(_user_not_interested_store);

var _user_not_interested_actions = require("../../../react_actions/user_not_interested_actions");

var _user_not_interested_actions2 = _interopRequireDefault(_user_not_interested_actions);

var _native_book_ad = require("./native_book_ad");

var _native_book_ad2 = _interopRequireDefault(_native_book_ad);

var _native_flex_ad = require("./native_flex_ad");

var _native_flex_ad2 = _interopRequireDefault(_native_flex_ad);

var _user_not_interested_message = require("./user_not_interested_message");

var _user_not_interested_message2 = _interopRequireDefault(_user_not_interested_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "NativeAdBody",

  mixins: [_reflux2.default.connect(_user_not_interested_store2.default, "userNotInterestedStore")],

  propTypes: {
    adId: React.PropTypes.string,
    creative: React.PropTypes.object.isRequired,
    adDeviceType: React.PropTypes.string,
    signedIn: React.PropTypes.bool,
    allowBehavioralTargeting: React.PropTypes.bool,
    isMobile: React.PropTypes.bool,
    isNewsfeed: React.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      isNewsfeed: true,
      isMobile: false,
      signedIn: true
    };
  },
  getUserNotInterestedStoreState: function getUserNotInterestedStoreState() {
    return this.state.userNotInterestedStore;
  },
  render: function render() {
    if (this.props.creative && this.props.creative.book) {
      var bookId = this.props.creative.book.bookId;
      if (this.getUserNotInterestedStoreState()[bookId]) {
        if (this.getUserNotInterestedStoreState()[bookId].isClosed) {
          return null;
        } else if (this.getUserNotInterestedStoreState()[bookId].isFlashMessage) {
          return _jsx(_user_not_interested_message2.default, {
            id: this.props.adId,
            isNewsfeed: this.props.isNewsfeed,
            className: this.props.className,
            creative: this.props.creative
          });
        }
      } else {
        _user_not_interested_actions2.default.addBookIDToState(bookId);
      }
    }
    if (this.props.creative && this.props.creative.book) {
      return _jsx(_native_book_ad2.default, {
        isNewsfeed: this.props.isNewsfeed,
        isMobile: this.props.isMobile,
        creative: this.props.creative,
        adDeviceType: this.props.adDeviceType,
        signedIn: this.props.signedIn,
        allowBehavioralTargeting: this.props.allowBehavioralTargeting,
        id: this.props.adId
      });
    } else {
      return _jsx(_native_flex_ad2.default, {
        id: this.props.adId,
        creative: this.props.creative,
        signedIn: this.props.signedIn,
        allowBehavioralTargeting: this.props.allowBehavioralTargeting,
        isNewsfeed: this.props.isNewsfeed,
        isMobile: this.props.isMobile
      });
    }
  }
});

},{"../../../react_actions/user_not_interested_actions":48,"../../../react_stores/user_not_interested_store":252,"../../gr_component_factory":102,"./native_book_ad":65,"./native_flex_ad":67,"./user_not_interested_message":69,"reflux":"reflux"}],63:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NativeAdCaret = undefined;

var _react = require("react");

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _dropdown = require("../../dropdown");

var _dropdown2 = _interopRequireDefault(_dropdown);

var _click_tracking_wrapper = require("../../click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _user_not_interested_actions = require("../../../react_actions/user_not_interested_actions");

var _user_not_interested_actions2 = _interopRequireDefault(_user_not_interested_actions);

var _click_tracking_helper = require("../../../modules/ads/click_tracking_helper");

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NativeAdCaret = exports.NativeAdCaret = (function (_Component) {
  _inherits(NativeAdCaret, _Component);

  function NativeAdCaret(props) {
    _classCallCheck(this, NativeAdCaret);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(NativeAdCaret).call(this, props));
  }

  _createClass(NativeAdCaret, [{
    key: "renderNotInterested",
    value: function renderNotInterested() {
      var _this2 = this;

      if (this.props.book && this.props.signedIn) {
        var notInterButtonAction = function notInterButtonAction() {
          return _user_not_interested_actions2.default.userNotInterested(_this2.props.book.bookId);
        };
        var notInterButton = _jsx("button", {
          className: "gr-buttonAsLink nativeAdCaretMenu__button",
          onClick: notInterButtonAction
        }, void 0, "I’m not interested in this book");
        return _jsx(_click_tracking_wrapper2.default, {
          children: notInterButton,
          trackingOptions: _click_tracking_helper.TRACKED_CLASSES.newsfeed_caret_not_interested
        });
      } else {
        return null;
      }
    }
  }, {
    key: "caretList",
    value: function caretList() {
      var whyAmISeeingThisLink = _jsx("a", {
        className: "nativeAdCaretMenu__link",
        href: this.props.helpLink
      }, void 0, "Why am I seeing this?");
      return _jsx("div", {
        className: "nativeAdCaretMenu"
      }, void 0, this.renderNotInterested(), (0, _lodash.map)(this.props.additionalLinks, function (link) {
        return _jsx("div", {
          className: "nativeAdCaretMenu__button"
        }, link, "link");
      }), _jsx(_click_tracking_wrapper2.default, {
        children: whyAmISeeingThisLink,
        trackingOptions: _click_tracking_helper.TRACKED_CLASSES.newsfeed_caret_help
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return _jsx("div", {
        className: "nativeAdCaret"
      }, void 0, _jsx(_dropdown2.default, {
        trigger: _jsx("div", {
          className: "nativeAdCaret nativeAdCaret__image",
          "aria-label": "Sponsored item options"
        }),
        triggerEventType: _dropdown2.default.TriggerEventTypes.CLICK,
        bemModifiers: "caret",
        children: this.caretList()
      }));
    }
  }]);

  return NativeAdCaret;
})(_react.Component);

NativeAdCaret.propTypes = {
  book: _gr_prop_types2.default.book(),
  helpLink: _react.PropTypes.string,
  updateId: _react.PropTypes.string,
  additionalLinks: _react.PropTypes.arrayOf(_react.PropTypes.elements),
  signedIn: _react.PropTypes.bool
};

NativeAdCaret.defaultProps = {
  trackingOptions: _click_tracking_helper.TRACKED_CLASSES.newsfeed_caret,
  signedIn: true
};

exports.default = NativeAdCaret;

},{"../../../modules/ads/click_tracking_helper":2,"../../../react_actions/user_not_interested_actions":48,"../../click_tracking_wrapper":81,"../../dropdown":90,"../../shared/gr_prop_types":171,"lodash":"lodash","react":"react"}],64:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NativeAdSponsoredLabel = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _click_tracking_wrapper = require("../../click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _click_tracking_helper = require("../../../modules/ads/click_tracking_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NativeAdSponsoredLabel = exports.NativeAdSponsoredLabel = (function (_Component) {
  _inherits(NativeAdSponsoredLabel, _Component);

  function NativeAdSponsoredLabel(props) {
    _classCallCheck(this, NativeAdSponsoredLabel);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(NativeAdSponsoredLabel).call(this, props));
  }

  _createClass(NativeAdSponsoredLabel, [{
    key: "render",
    value: function render() {
      var sponsoredLabel = this.props.sponsoredBy ? "Sponsored by " : "Sponsored";
      var sponsoredFooter = _jsx("div", {
        className: "nativeAd__sponsoredLabel"
      }, void 0, _jsx("span", {
        className: "googleNativeAd__sponsoredBadgeIcon"
      }), _jsx("span", {
        className: "googleNativeAd__sponsoredLabel"
      }, void 0, sponsoredLabel), _jsx("a", {
        target: "_blank",
        href: this.props.sponsoredUrl,
        className: "gr-hyperlink"
      }, void 0, this.props.sponsoredBy));
      return _jsx(_click_tracking_wrapper2.default, {
        trackingOptions: _click_tracking_helper.TRACKED_CLASSES.sponsored_label,
        children: sponsoredFooter
      });
    }
  }]);

  return NativeAdSponsoredLabel;
})(_react.Component);

NativeAdSponsoredLabel.propTypes = {
  sponsoredBy: _react2.default.PropTypes.string,
  sponsoredUrl: _react2.default.PropTypes.string
};

exports.default = NativeAdSponsoredLabel;

},{"../../../modules/ads/click_tracking_helper":2,"../../click_tracking_wrapper":81,"react":"react"}],65:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NativeBookAd = undefined;

var _react = require("react");

var _native_book_ad_header = require("./native_book_ad_header");

var _native_book_ad_header2 = _interopRequireDefault(_native_book_ad_header);

var _book = require("../../book");

var _book2 = _interopRequireDefault(_book);

var _book_with_wtr_button = require("../../book_with_wtr_button");

var _book_with_wtr_button2 = _interopRequireDefault(_book_with_wtr_button);

var _preview_book = require("../../preview_book/preview_book");

var _preview_book2 = _interopRequireDefault(_preview_book);

var _expandable_html = require("../../user_content/expandable_html");

var _expandable_html2 = _interopRequireDefault(_expandable_html);

var _book_description = require("../../book_description");

var _book_description2 = _interopRequireDefault(_book_description);

var _community_rating = require("../../community_rating");

var _community_rating2 = _interopRequireDefault(_community_rating);

var _click_tracking_wrapper = require("../../click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _click_tracking_helper = require("../../../modules/ads/click_tracking_helper");

var _shape_icon = require("../../shape_icon");

var _shape_icon2 = _interopRequireDefault(_shape_icon);

var _user_icon = require("../../user/user_icon");

var _user_icon2 = _interopRequireDefault(_user_icon);

var _shape_icon_values = require("../../../modules/shape_icon_values");

var _native_ad_caret = require("./native_ad_caret");

var _native_ad_caret2 = _interopRequireDefault(_native_ad_caret);

var _native_ad_sponsored_label = require("./native_ad_sponsored_label");

var _native_ad_sponsored_label2 = _interopRequireDefault(_native_ad_sponsored_label);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NativeBookAd = exports.NativeBookAd = (function (_Component) {
  _inherits(NativeBookAd, _Component);

  function NativeBookAd(props) {
    _classCallCheck(this, NativeBookAd);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(NativeBookAd).call(this, props));
  }

  _createClass(NativeBookAd, [{
    key: "isDesktopNewsfeed",
    value: function isDesktopNewsfeed() {
      return this.props.isNewsfeed && !this.props.isMobile;
    }
  }, {
    key: "isMobileNewsfeed",
    value: function isMobileNewsfeed() {
      return this.props.isNewsfeed && this.props.isMobile;
    }
  }, {
    key: "renderBookDescription",
    value: function renderBookDescription() {
      var previewBook = !this.props.isMobile ? _jsx(_preview_book2.default, {
        book: this.props.creative.book
      }) : null;
      if (this.props.creative.customText) {
        return _jsx("div", {
          className: "gr-book__description u-marginTopXSmall"
        }, void 0, React.createElement(_expandable_html2.default, this.props.creative.customText), _jsx("div", {
          className: "u-paddingTopSmall"
        }, void 0, previewBook));
      } else {
        return _jsx("div", {}, void 0, _jsx(_book_description2.default, {
          className: "u-marginTopXSmall",
          bookDescription: this.props.creative.book.description
        }), _jsx("div", {
          className: "u-paddingTopSmall"
        }, void 0, previewBook));
      }
    }
  }, {
    key: "renderLearnMoreButton",
    value: function renderLearnMoreButton() {
      var bookLink = _jsx("a", {
        href: this.props.creative.book.bookUrl,
        rel: "noopener noreferrer",
        className: "gr-button u-marginTopMedium"
      }, void 0, "Learn More");
      return _jsx(_click_tracking_wrapper2.default, {
        trackingOptions: _click_tracking_helper.TRACKED_CLASSES.cta_link,
        children: bookLink
      });
    }
  }, {
    key: "renderBook",
    value: function renderBook() {
      var bodyContainerClassnames = (0, _classnames2.default)({
        "gr-newsfeedItem__body": this.isDesktopNewsfeed(),
        bookAdBody: !this.isDesktopNewsfeed()
      });
      var book = this.props.creative.book;
      if (this.props.signedIn) {
        return _jsx(_book_with_wtr_button2.default, {
          body: this.renderBookDescription(),
          book: book,
          responsiveWtrButton: this.props.isMobile,
          bookClassName: bodyContainerClassnames
        });
      } else {
        return React.createElement(
          _book2.default,
          _extends({}, book, {
            className: bodyContainerClassnames,
            size: _book.VALID_BOOK_SIZES.LARGE }),
          this.props.isMobile ? _jsx(_community_rating2.default, {
            rating: parseFloat(book.avgRating),
            displayAvgRatingText: false,
            ratingsCount: book.ratingsCount,
            size: _community_rating2.default.ICON_SIZES.MEDIUM
          }) : null,
          this.renderBookDescription(),
          this.renderLearnMoreButton()
        );
      }
    }
  }, {
    key: "renderCaret",
    value: function renderCaret() {
      return _jsx("div", {
        className: "googleNativeAd__caret"
      }, void 0, _jsx(_native_ad_caret2.default, {
        book: this.props.creative.book,
        helpLink: this.props.creative.helpLink,
        updateId: this.props.id,
        signedIn: this.props.signedIn
      }));
    }
  }, {
    key: "renderIconBody",
    value: function renderIconBody() {
      if (this.props.creative.firstFriend) {
        return _jsx(_user_icon2.default, {
          user: this.props.creative.firstFriend,
          size: _shape_icon_values.ICON_SIZES.MEDIUM
        });
      } else {
        return _jsx(_shape_icon2.default, {
          imageUrl: this.props.creative.defaultIcon,
          size: _shape_icon_values.ICON_SIZES.MEDIUM,
          imageAlt: "Sponsored Newsfeed Item Icon",
          border: true
        });
      }
    }
  }, {
    key: "renderIcon",
    value: function renderIcon() {
      return _jsx("div", {
        className: "gr-newsfeedItem__headerIcon gr-mediaBox__media gr-mediaBox__media--marginSmall"
      }, void 0, this.renderIconBody());
    }
  }, {
    key: "render",
    value: function render() {
      var sponsoredLine = _jsx(_native_ad_sponsored_label2.default, {
        sponsoredBy: this.props.creative.sponsoredBy,
        sponsoredUrl: this.props.creative.sponsoredUrl
      });

      var bodyClasses = (0, _classnames2.default)("gr-mediaBox", {
        "feedItem feedItem--ad": this.isMobileNewsfeed(),
        "gr-newsfeedItem gr-mediaBox": this.isDesktopNewsfeed(),
        "googleNativeAd__item ": !this.isDesktopNewsfeed()
      });
      var bookClasses = (0, _classnames2.default)({
        nativeAd__newsfeedBody: this.isDesktopNewsfeed()
      });
      return React.createElement(
        "div",
        { className: bodyClasses, ref: "nativeAd" },
        this.isDesktopNewsfeed() && this.renderIcon(),
        _jsx("div", {
          className: "u-marginBottomSmall"
        }, void 0, this.renderCaret(), _jsx("div", {
          className: "nativeAd__headerText"
        }, void 0, _jsx(_native_book_ad_header2.default, {
          creative: this.props.creative,
          signedIn: this.props.signedIn,
          allowBehavioralTargeting: this.props.allowBehavioralTargeting
        })), this.props.creative.isSponsored ? sponsoredLine : null, _jsx("div", {
          className: bookClasses
        }, void 0, this.renderBook()))
      );
    }
  }]);

  return NativeBookAd;
})(_react.Component);

NativeBookAd.propTypes = {
  isNewsfeed: _react.PropTypes.bool,
  isMobile: _react.PropTypes.bool,
  creative: _react.PropTypes.shape().isRequired,
  adDeviceType: _react.PropTypes.string,
  signedIn: _react.PropTypes.bool,
  allowBehavioralTargeting: React.PropTypes.bool,
  id: _react.PropTypes.string
};

exports.default = NativeBookAd;

},{"../../../modules/ads/click_tracking_helper":2,"../../../modules/shape_icon_values":19,"../../book":72,"../../book_description":74,"../../book_with_wtr_button":75,"../../click_tracking_wrapper":81,"../../community_rating":87,"../../preview_book/preview_book":144,"../../shape_icon":166,"../../user/user_icon":193,"../../user_content/expandable_html":195,"./native_ad_caret":63,"./native_ad_sponsored_label":64,"./native_book_ad_header":66,"classnames":"classnames","react":"react"}],66:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _user_profile_link = require("../../user/user_profile_link");

var _user_profile_link2 = _interopRequireDefault(_user_profile_link);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "NativeBookAdHeader",

  propTypes: {
    creative: _gr_prop_types2.default.creative().isRequired,
    signedIn: React.PropTypes.bool,
    allowBehavioralTargeting: React.PropTypes.bool
  },

  // Setting default to true for signed in homepage newsfeed
  getDefaultProps: function getDefaultProps() {
    return {
      signedIn: true
    };
  },
  renderLink: function renderLink(text, url) {
    return _jsx("a", {
      className: "gr-hyperlink gr-hyperlink--bold",
      href: url
    }, void 0, text);
  },
  renderFriendHeader: function renderFriendHeader() {
    var firstFriend = _lodash2.default.head(this.props.creative.topFriends);
    return _jsx("span", {
      className: "gr-newsfeedItem__headerText"
    }, void 0, _jsx(_user_profile_link2.default, {
      user: firstFriend
    }), this.renderHeaderText(), " ", this.props.creative.friendActionText);
  },
  renderHeaderText: function renderHeaderText() {
    if (this.props.creative.numAdditionalFriends === 1) {
      return _jsx("span", {}, void 0, " and ", _jsx(_user_profile_link2.default, {
        user: this.props.creative.topFriends[1]
      }));
    } else if (this.props.creative.numAdditionalFriends > 1) {
      return _jsx("span", {}, void 0, " and ", this.renderLink(this.props.creative.numAdditionalFriends + " other friends", this.props.creative.book.bookUrl + "#friendReviews"));
    } else {
      return null;
    }
  },
  renderSimilarBook: function renderSimilarBook() {
    return _jsx("div", {
      className: "gr-newsfeedItem__headerText gr-newsfeedItem__headerText--truncateWithEllipsis"
    }, void 0, "This is similar to ", this.renderLink(this.props.creative.similarBook.title, this.props.creative.similarBook.bookUrl));
  },
  renderGenres: function renderGenres() {
    var topGenre = _lodash2.default.head(this.props.creative.genres);
    return _jsx("div", {
      className: "gr-newsfeedItem__headerText"
    }, void 0, "This book has been shelved by members as ", this.renderLink(topGenre.genre, topGenre.url), this.props.creative.genres.length > 1 ? _jsx("span", {}, void 0, " and ", this.renderLink(this.props.creative.genres[1].genre, this.props.creative.genres[1].url)) : null);
  },
  renderDefault: function renderDefault() {
    return _jsx("div", {
      className: "gr-newsfeedItem__headerText"
    }, void 0, "Based on your reading preferences, you might enjoy");
  },
  renderSignedOutText: function renderSignedOutText() {
    return _jsx("div", {
      className: "gr-newsfeedItem__headerText"
    }, void 0, "Recommended");
  },
  renderContextualHeader: function renderContextualHeader() {
    return _jsx("div", {
      className: "gr-newsfeedItem__headerText"
    }, void 0, this.props.creative.headerText);
  },
  render: function render() {
    if (this.props.creative.headerText) {
      return this.renderContextualHeader();
    } else if (!this.props.allowBehavioralTargeting) {
      return this.renderSignedOutText();
    } else if (!this.props.signedIn) {
      return this.renderSignedOutText();
    } else if (this.props.creative.topFriends) {
      return this.renderFriendHeader();
    } else if (this.props.creative.similarBook) {
      return this.renderSimilarBook();
    } else if (this.props.creative.genres) {
      return this.renderGenres();
    } else {
      return this.renderDefault();
    }
  }
});

},{"../../gr_component_factory":102,"../../shared/gr_prop_types":171,"../../user/user_profile_link":194,"lodash":"lodash"}],67:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NativeFlexAd = undefined;

var _react = require("react");

var _native_flex_ad_body = require("./native_flex_ad_body");

var _native_flex_ad_body2 = _interopRequireDefault(_native_flex_ad_body);

var _shape_icon = require("../../shape_icon");

var _shape_icon2 = _interopRequireDefault(_shape_icon);

var _shape_icon_values = require("../../../modules/shape_icon_values");

var _native_ad_caret = require("./native_ad_caret");

var _native_ad_caret2 = _interopRequireDefault(_native_ad_caret);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _native_ad_sponsored_label = require("./native_ad_sponsored_label");

var _native_ad_sponsored_label2 = _interopRequireDefault(_native_ad_sponsored_label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NativeFlexAd = exports.NativeFlexAd = (function (_Component) {
  _inherits(NativeFlexAd, _Component);

  function NativeFlexAd(props) {
    _classCallCheck(this, NativeFlexAd);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(NativeFlexAd).call(this, props));
  }

  _createClass(NativeFlexAd, [{
    key: "getHeaderText",
    value: function getHeaderText() {
      return {
        __html: this.props.creative.headerText
      };
    }
  }, {
    key: "renderCaret",
    value: function renderCaret() {
      return _jsx("div", {
        className: "googleNativeAd__caret"
      }, void 0, _jsx(_native_ad_caret2.default, {
        helpLink: this.props.creative.helpLink,
        updateId: this.props.id,
        signedIn: this.props.signedIn
      }));
    }
  }, {
    key: "isDesktopNewsfeed",
    value: function isDesktopNewsfeed() {
      return this.props.isNewsfeed && !this.props.isMobile;
    }
  }, {
    key: "isMobileNewsfeed",
    value: function isMobileNewsfeed() {
      return this.props.isNewsfeed && this.props.isMobile;
    }
  }, {
    key: "renderIcon",
    value: function renderIcon() {
      return _jsx("div", {
        className: "gr-newsfeedItem__headerIcon gr-mediaBox__media gr-mediaBox__media--marginSmall"
      }, void 0, _jsx(_shape_icon2.default, {
        imageUrl: this.props.creative.defaultIcon,
        size: _shape_icon_values.ICON_SIZES.MEDIUM,
        imageAlt: "Sponsored Item Icon",
        border: true
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var bodyClassNames = (0, _classnames2.default)({
        "gr-newsfeedItem__body nativeAd__newsfeedBody": this.isDesktopNewsfeed()
      });
      var sponsoredLine = _jsx(_native_ad_sponsored_label2.default, {
        sponsoredBy: this.props.creative.sponsoredBy,
        sponsoredUrl: this.props.creative.sponsoredUrl
      });

      var bodyClasses = (0, _classnames2.default)("gr-mediaBox", {
        "gr-newsfeedItem gr-mediaBox": this.isDesktopNewsfeed(),
        "googleNativeAd__item ": !this.isDesktopNewsfeed(),
        "feedItem feedItem--ad": this.isMobileNewsfeed()
      });
      return React.createElement(
        "div",
        { className: bodyClasses, ref: "nativeAd" },
        this.isDesktopNewsfeed() && this.renderIcon(),
        _jsx("div", {
          className: "u-marginBottomSmall"
        }, void 0, this.renderCaret(), _jsx("div", {
          className: "nativeAd__headerText"
        }, void 0, _jsx("div", {
          className: "gr-newsfeedItem__headerText",
          dangerouslySetInnerHTML: this.getHeaderText()
        })), this.props.creative.isSponsored ? sponsoredLine : null, _jsx(_native_flex_ad_body2.default, {
          creative: this.props.creative,
          bodyClassNames: bodyClassNames
        }))
      );
    }
  }]);

  return NativeFlexAd;
})(_react.Component);

NativeFlexAd.propTypes = {
  id: _react.PropTypes.string,
  creative: _react.PropTypes.shape().isRequired,
  signedIn: _react.PropTypes.bool,
  isNewsfeed: _react.PropTypes.bool,
  isMobile: _react.PropTypes.bool
};

exports.default = NativeFlexAd;

},{"../../../modules/shape_icon_values":19,"../../shape_icon":166,"./native_ad_caret":63,"./native_ad_sponsored_label":64,"./native_flex_ad_body":68,"classnames":"classnames","react":"react"}],68:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _click_tracking_wrapper = require("../../click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _expandable_html = require("../../user_content/expandable_html");

var _expandable_html2 = _interopRequireDefault(_expandable_html);

var _click_tracking_helper = require("../../../modules/ads/click_tracking_helper");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "NativeFlexAdBody",

  propTypes: {
    creative: _gr_prop_types2.default.creative().isRequired,
    bodyClassNames: _react2.default.PropTypes.string
  },

  renderImage: function renderImage() {
    var bodyImageClasses = (0, _classnames2.default)("gr-mediaBox__media", this.withBemModifiers("flexAdBody__image"));
    var bodyImage = _jsx("a", {
      target: this.props.creative.externalLink ? "_blank" : "_self",
      rel: "noopener noreferrer",
      href: this.props.creative.updateUrl,
      className: "flexAdBody__imageLink"
    }, void 0, _jsx("img", {
      alt: this.props.creative.title,
      className: bodyImageClasses,
      src: this.props.creative.image
    }));
    return _jsx(_click_tracking_wrapper2.default, {
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES.sponsored_update_body_image,
      children: bodyImage
    });
  },
  renderExploreButton: function renderExploreButton() {
    var micrositeLink = _jsx("a", {
      target: this.props.creative.externalLink ? "_blank" : "_self",
      rel: "noopener noreferrer",
      href: this.props.creative.callToActionUrl,
      className: "gr-button u-marginTopMedium gr-microsite-link"
    }, void 0, this.props.creative.callToActionText);
    return _jsx(_click_tracking_wrapper2.default, {
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES.cta_link,
      children: micrositeLink
    });
  },
  render: function render() {
    var bodyClasses = (0, _classnames2.default)(this.props.bodyClassNames, "gr-mediaBox", "flexAdBody");
    var bodyTitleLinkClasses = (0, _classnames2.default)("flexAdBody__titleLink", "gr-hyperlink", "gr-hyperlink--naked");
    var titleLink = _jsx("a", {
      target: this.props.creative.externalLink ? "_blank" : "_self",
      rel: "noopener noreferrer",
      href: this.props.creative.updateUrl,
      className: bodyTitleLinkClasses
    }, void 0, this.props.creative.title);
    return _jsx("div", {
      className: bodyClasses
    }, void 0, this.renderImage(), _jsx("div", {
      className: "gr-mediaBox__desc"
    }, void 0, _jsx("div", {
      className: "flexAdBody__title"
    }, void 0, _jsx(_click_tracking_wrapper2.default, {
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES.sponsored_update_body_title_link,
      children: titleLink
    })), _jsx("div", {
      className: "flexAdBody__description"
    }, void 0, _react2.default.createElement(_expandable_html2.default, this.props.creative.description)), this.renderExploreButton()));
  }
});

},{"../../../modules/ads/click_tracking_helper":2,"../../click_tracking_wrapper":81,"../../gr_component_factory":102,"../../shared/gr_prop_types":171,"../../user_content/expandable_html":195,"classnames":"classnames","react":"react"}],69:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserNotInterestedMessage = undefined;

var _react = require("react");

var _close_button = require("../../close_button");

var _close_button2 = _interopRequireDefault(_close_button);

var _user_not_interested_actions = require("../../../react_actions/user_not_interested_actions");

var _user_not_interested_actions2 = _interopRequireDefault(_user_not_interested_actions);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserNotInterestedMessage = exports.UserNotInterestedMessage = (function (_Component) {
  _inherits(UserNotInterestedMessage, _Component);

  function UserNotInterestedMessage(props) {
    _classCallCheck(this, UserNotInterestedMessage);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(UserNotInterestedMessage).call(this, props));
  }

  _createClass(UserNotInterestedMessage, [{
    key: "renderUndoButton",
    value: function renderUndoButton(book) {
      var _this2 = this;

      return _jsx("button", {
        className: "gr-buttonAsLink",
        onClick: function onClick() {
          _user_not_interested_actions2.default.undoUserNotInterested(book.bookId, _this2.props.id);
        }
      }, void 0, "Undo");
    }
  }, {
    key: "render",
    value: function render() {
      var book = this.props.creative.book;
      if (this.props.isNewsfeed) {
        var userNotInterestedMessage = _jsx("span", {
          className: "gr-newsfeedItem__flashMessage--body"
        }, void 0, "Thanks! We won't recommend", " ", _jsx("a", {
          href: book.bookUrl
        }, void 0, book.title), " ", "again!", " ", this.renderUndoButton(book));
        return _jsx("div", {
          className: "gr-newsfeedItem gr-newsfeedItem__flashMessage",
          role: "alert"
        }, void 0, _jsx("div", {
          className: "gr-newsfeedItem__close"
        }, void 0, _jsx(_close_button2.default, {
          action: function action() {
            _user_not_interested_actions2.default.closeFlashMessage(book.bookId);
          }
        })), userNotInterestedMessage);
      } else {
        var userNotInterestedMessage = _jsx("span", {
          className: "userNotInterested__message"
        }, void 0, "Thanks! We won't recommend", " ", _jsx("a", {
          href: book.bookUrl
        }, void 0, book.title), " ", "again!", " ", this.renderUndoButton(book));
        var userNotInterestedClassname = (0, _classnames2.default)(this.props.className, "userNotInterested");
        return _jsx("div", {
          className: userNotInterestedClassname,
          role: "alert"
        }, void 0, _jsx("div", {
          className: "userNotInterested__close"
        }, void 0, _jsx(_close_button2.default, {
          action: function action() {
            _user_not_interested_actions2.default.closeFlashMessage(book.bookId);
          }
        })), userNotInterestedMessage);
      }
    }
  }]);

  return UserNotInterestedMessage;
})(_react.Component);

UserNotInterestedMessage.propTypes = {
  id: _react.PropTypes.string,
  isNewsfeed: _react.PropTypes.bool,
  className: _react.PropTypes.string,
  creative: _react.PropTypes.shape()
};

exports.default = UserNotInterestedMessage;

},{"../../../react_actions/user_not_interested_actions":48,"../../close_button":82,"classnames":"classnames","react":"react"}],70:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _react = require("react");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AUTHOR_BADGE_SIZES = {
  SMALL: "small",
  LARGE: "large"
};

exports.default = _gr_component_factory2.default.createClass({
  displayName: "AuthorBadge",

  statics: {
    AUTHOR_BADGE_SIZES: AUTHOR_BADGE_SIZES
  },

  propTypes: {
    size: React.PropTypes.oneOf([AUTHOR_BADGE_SIZES.SMALL, AUTHOR_BADGE_SIZES.LARGE]),
    isGoodreadsAuthor: _react.PropTypes.bool.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      size: AUTHOR_BADGE_SIZES.SMALL
    };
  },
  getClasses: function getClasses() {
    return (0, _classnames2.default)("gr-icon", {
      "gr-icon--authorBadge": this.props.size === AUTHOR_BADGE_SIZES.SMALL,
      "gr-icon--authorBadgeLarge": this.props.size === AUTHOR_BADGE_SIZES.LARGE
    });
  },
  renderBadge: function renderBadge() {
    return _jsx("span", {
      className: this.getClasses(),
      title: "Goodreads Author"
    });
  },
  render: function render() {
    return this.props.isGoodreadsAuthor ? this.renderBadge() : null;
  }
});

},{"../gr_component_factory":102,"classnames":"classnames","react":"react"}],71:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _author_follow_actions = require("../../react_actions/author_follow_actions");

var _author_follow_actions2 = _interopRequireDefault(_author_follow_actions);

var _author_follow_store = require("../../react_stores/author_follow_store");

var _author_follow_store2 = _interopRequireDefault(_author_follow_store);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "AuthorFollowButton",

  mixins: [_reflux2.default.connectFilter(_author_follow_store2.default, "authorFollowStore", function (follows) {
    return follows[this.props.authorId];
  })],

  propTypes: {
    authorId: _react2.default.PropTypes.number.isRequired,
    className: _react2.default.PropTypes.string
  },

  handleButtonClicked: function handleButtonClicked() {
    if (this.state.authorFollowStore.isFollowing) {
      _author_follow_actions2.default.unFollow(this.props.authorId);
    } else {
      _author_follow_actions2.default.follow(this.props.authorId);
      // After a follow attempt "Unfollow" should not appear until
      // mouse leaves and re-enters button
      this.setState({ isHovering: false });
    }
  },
  getButtonText: function getButtonText() {
    if (this.state.authorFollowStore.isFollowing) {
      if (this.state.isHovering) {
        return "Unfollow";
      } else {
        return "Following";
      }
    } else {
      return "Follow author";
    }
  },
  render: function render() {
    var _this = this;

    var cx = (0, _classnames2.default)("gr-button", this.props.className);
    return _jsx("button", {
      className: cx,
      onClick: this.handleButtonClicked,
      onMouseEnter: function onMouseEnter() {
        _this.setState({ isHovering: true });
      },
      onMouseLeave: function onMouseLeave() {
        _this.setState({ isHovering: false });
      },
      disabled: this.state.authorFollowStore.buttonEnabled ? false : "disabled"
    }, void 0, this.getButtonText());
  }
});

},{"../../react_actions/author_follow_actions":25,"../../react_stores/author_follow_store":232,"../gr_component_factory":102,"classnames":"classnames","react":"react","reflux":"reflux"}],72:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VALID_BOOK_SIZES = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("./shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _click_tracking_wrapper = require("./click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _click_tracking_helper = require("../modules/ads/click_tracking_helper");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _author_badge = require("./author/author_badge");

var _author_badge2 = _interopRequireDefault(_author_badge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VALID_BOOK_SIZES = exports.VALID_BOOK_SIZES = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large"
};

exports.default = _gr_component_factory2.default.createClass({
  displayName: "Book",

  propTypes: {
    imageUrl: _react2.default.PropTypes.string.isRequired,
    bookUrl: _react2.default.PropTypes.string.isRequired,
    bookCoverUrl: _react2.default.PropTypes.string, // if book cover should link somewhere besides book page
    title: _react2.default.PropTypes.string.isRequired,
    size: _react2.default.PropTypes.oneOf(_lodash2.default.values(VALID_BOOK_SIZES)),
    titleSize: _react2.default.PropTypes.oneOf(_lodash2.default.values(VALID_BOOK_SIZES)),
    author: _gr_prop_types2.default.author(),
    mediaBoxModifier: _react2.default.PropTypes.string,
    className: _react2.default.PropTypes.string,
    sponsored: _react2.default.PropTypes.bool,
    bookImageTrackingData: _react2.default.PropTypes.object,
    bookTitleTrackingData: _react2.default.PropTypes.object,
    authorLinkTrackingData: _react2.default.PropTypes.object,
    label: _react2.default.PropTypes.element
  },
  getDefaultProps: function getDefaultProps() {
    return {
      size: VALID_BOOK_SIZES.MEDIUM,
      bookImageTrackingData: _click_tracking_helper.TRACKED_CLASSES.book_image,
      bookTitleTrackingData: _click_tracking_helper.TRACKED_CLASSES.book_title,
      authorLinkTrackingData: _click_tracking_helper.TRACKED_CLASSES.author_link
    };
  },
  render: function render() {
    var bookClasses = (0, _classnames2.default)("gr-mediaBox", "gr-book--" + this.props.size, this.withBemModifiers("gr-book"), this.props.className);
    var bookImageClasses = (0, _classnames2.default)("gr-mediaBox__media", this.withBemModifiers("gr-book__image"), { "gr-book__image--large": this.props.size === VALID_BOOK_SIZES.LARGE });
    var titleSize = this.props.titleSize == null ? this.props.size : this.props.titleSize;
    var bookTitleLinkClasses = (0, _classnames2.default)(this.withBemModifiers("gr-book__titleLink"), { "gr-book__titleLink--large": titleSize === VALID_BOOK_SIZES.LARGE }, "gr-hyperlink gr-hyperlink--naked");
    var bookTitleClasses = (0, _classnames2.default)(this.withBemModifiers("gr-book__title"));
    var mediaBoxClasses = this.withBemModifiers("gr-mediaBox__desc", this.props.mediaBoxModifier);
    var bookImage = _jsx("img", {
      alt: this.props.title,
      className: bookImageClasses,
      src: this.props.imageUrl
    });
    var bookLink = _jsx("a", {
      href: this.props.bookUrl,
      className: bookTitleLinkClasses
    }, void 0, this.props.title);
    return _jsx("div", {
      className: bookClasses
    }, void 0, _jsx("a", {
      href: this.props.bookCoverUrl || this.props.bookUrl
    }, void 0, _jsx(_click_tracking_wrapper2.default, {
      children: bookImage,
      trackingOptions: this.props.bookImageTrackingData
    })), _jsx("div", {
      className: mediaBoxClasses
    }, void 0, this.props.label, _jsx("div", {
      className: bookTitleClasses
    }, void 0, _jsx(_click_tracking_wrapper2.default, {
      children: bookLink,
      trackingOptions: this.props.bookTitleTrackingData
    })), this.renderAuthorLink(), _jsx("div", {
      className: "gr-book__additionalContent"
    }, void 0, this.props.children)));
  },
  renderAuthorLink: function renderAuthorLink() {
    var authorSize = this.props.titleSize == null ? this.props.size : this.props.titleSize;
    var bookAuthorClasses = (0, _classnames2.default)(this.withBemModifiers("gr-book__author"), { "gr-book__author--large": authorSize === VALID_BOOK_SIZES.LARGE });

    if (this.props.author) {
      var authorLink = _jsx("a", {
        href: this.props.author.profileUrl,
        className: "gr-book__authorLink gr-hyperlink gr-hyperlink--naked"
      }, void 0, this.props.author.name);

      return _jsx("div", {
        className: bookAuthorClasses
      }, void 0, "by ", _jsx(_click_tracking_wrapper2.default, {
        children: authorLink,
        trackingOptions: this.props.authorLinkTrackingData
      }), _react2.default.createElement(_author_badge2.default, this.props.author));
    } else {
      return _jsx("div", {
        className: bookAuthorClasses
      }, void 0, "by deleted author");
    }
  }
});

},{"../modules/ads/click_tracking_helper":2,"./author/author_badge":70,"./click_tracking_wrapper":81,"./gr_component_factory":102,"./shared/gr_prop_types":171,"classnames":"classnames","lodash":"lodash","react":"react"}],73:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CTA_TEXT_SIGNED_OUT = exports.CTA_TEXT_SIGNED_IN = undefined;

var _react = require("react");

var _shape_icon_values = require("../../modules/shape_icon_values");

var _modal = require("../modal");

var _modal2 = _interopRequireDefault(_modal);

var _modal_trigger = require("../modal_trigger");

var _modal_trigger2 = _interopRequireDefault(_modal_trigger);

var _user_rating = require("../user_rating");

var _user_rating2 = _interopRequireDefault(_user_rating);

var _user_icon = require("../user/user_icon");

var _user_icon2 = _interopRequireDefault(_user_icon);

var _user_profile_link = require("../user/user_profile_link");

var _user_profile_link2 = _interopRequireDefault(_user_profile_link);

var _write_a_review_button = require("../review/write_a_review_button");

var _write_a_review_button2 = _interopRequireDefault(_write_a_review_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*doc
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               title: Review Cta
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               category: React
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               This component displays the review Cta to the user to prompt them to leave a
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               review or rating on a book. 
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               Required props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * `bookId`: Book ID
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * `user`: Current user
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * `destinationPath`: The destination Url on clicking on the write a review button or rating widget
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * `bookTitle`: Title of the book
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               Optional props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * `actionType`: The Clickstream metric for the write a review button click
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * `ratingClickstreamRef`: The ref tag for the Clickstream rating action context
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

var CTA_TEXT_SIGNED_IN = exports.CTA_TEXT_SIGNED_IN = " start your review of ";
var CTA_TEXT_SIGNED_OUT = exports.CTA_TEXT_SIGNED_OUT = "Start your review of ";

var ReviewCta = (function (_Component) {
  _inherits(ReviewCta, _Component);

  function ReviewCta(props) {
    _classCallCheck(this, ReviewCta);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(ReviewCta).call(this, props));
  }

  _createClass(ReviewCta, [{
    key: "goToDestination",
    value: function goToDestination() {
      window.location.assign(this.props.destinationPath);
    }
  }, {
    key: "render",
    value: function render() {
      return _jsx("div", {
        className: "reviewCta"
      }, void 0, _jsx("div", {
        className: "reviewCta__left"
      }, void 0, _jsx(_user_icon2.default, {
        user: this.props.user,
        shape: _shape_icon_values.ICON_SHAPES.RECTANGULAR
      })), _jsx("div", {
        className: "reviewCta__right"
      }, void 0, _jsx("div", {
        className: "u-marginLeftXSmall reviewCta__label"
      }, void 0, _jsx(_user_profile_link2.default, {
        className: "reviewCta__userProfileLink",
        user: this.props.user
      }), this.props.user.viewableName ? CTA_TEXT_SIGNED_IN : CTA_TEXT_SIGNED_OUT, this.props.bookTitle), _jsx("div", {
        className: "reviewCta__controls"
      }, void 0, _jsx(_user_rating2.default, {
        bookId: this.props.bookId,
        starSize: _user_rating.STAR_SIZES.MEDIUM,
        handleClick: this.goToDestination.bind(this),
        displayLabel: false,
        clickstreamRef: this.props.ratingClickstreamRef
      }), _jsx(_write_a_review_button2.default, {
        destinationPath: this.props.destinationPath,
        actionType: this.props.actionType,
        bookId: this.props.bookId,
        className: "reviewCta__writeButton"
      }))));
    }
  }]);

  return ReviewCta;
})(_react.Component);

exports.default = ReviewCta;

ReviewCta.propTypes = {
  bookId: _react.PropTypes.string.isRequired,
  user: _react.PropTypes.object.isRequired,
  destinationPath: _react.PropTypes.string.isRequired,
  bookTitle: _react.PropTypes.string.isRequired,
  actionType: _react.PropTypes.string,
  ratingClickstreamRef: _react.PropTypes.string
};

},{"../../modules/shape_icon_values":19,"../modal":136,"../modal_trigger":137,"../review/write_a_review_button":159,"../user/user_icon":193,"../user/user_profile_link":194,"../user_rating":200,"react":"react"}],74:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _truncated_html = require("./user_content/truncated_html");

var _truncated_html2 = _interopRequireDefault(_truncated_html);

var _gr_prop_types = require("./shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "BookDescription",

  propTypes: {
    bookDescription: _gr_prop_types2.default.bookDescription().isRequired,
    className: React.PropTypes.string,
    bookDescriptionTargetingData: React.PropTypes.object
  },

  getDefaultProps: function getDefaultProps() {
    return {
      bookDescription: {
        html: "",
        truncated: false,
        fullContentUrl: ""
      }
    };
  },
  render: function render() {
    var cx = (0, _classnames2.default)(this.props.className, "gr-book__description");
    var description = this.props.bookDescription;
    return _jsx("div", {
      className: cx
    }, void 0, description.html ? React.createElement(_truncated_html2.default, _extends({}, description, {
      fullContentText: "Continue reading",
      bookDescriptionTargetingData: this.props.bookDescriptionTargetingData })) : null, this.props.children);
  }
});

},{"./gr_component_factory":102,"./shared/gr_prop_types":171,"./user_content/truncated_html":199,"classnames":"classnames"}],75:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("./shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _book = require("./book");

var _book2 = _interopRequireDefault(_book);

var _want_to_read_button = require("./want_to_read/want_to_read_button");

var _want_to_read_button2 = _interopRequireDefault(_want_to_read_button);

var _lodash = require("lodash");

var _community_rating = require("./community_rating");

var _community_rating2 = _interopRequireDefault(_community_rating);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "BookWithWTRButton",

  propTypes: {
    book: _gr_prop_types2.default.book().isRequired,
    body: React.PropTypes.element,
    bookSize: React.PropTypes.oneOf((0, _lodash.values)(_book.VALID_BOOK_SIZES)),
    bookClassName: React.PropTypes.string,
    responsiveWtrButton: React.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      bookSize: _book.VALID_BOOK_SIZES.LARGE,
      responsiveWtrButton: false
    };
  },
  renderBookBody: function renderBookBody() {
    return this.props.body ? this.props.body : null;
  },
  renderCommunityRating: function renderCommunityRating() {
    var book = this.props.book;
    return _jsx(_community_rating2.default, {
      rating: parseFloat(book.avgRating),
      displayAvg: false,
      displayAvgRatingText: false,
      ratingsCount: book.ratingsCount,
      size: _community_rating2.default.ICON_SIZES.MEDIUM
    });
  },
  renderWtrButton: function renderWtrButton() {
    return _jsx(_want_to_read_button2.default, {
      bookTitle: this.props.book.title,
      uniqueId: (0, _lodash.random)(1000000).toString(),
      bookId: this.props.book.bookId,
      withModalShelvingMenu: this.props.responsiveWtrButton,
      showStars: !this.props.responsiveWtrButton
    });
  },
  render: function render() {
    return React.createElement(
      _book2.default,
      _extends({ className: this.props.bookClassName }, this.props.book, { size: this.props.bookSize }),
      this.props.responsiveWtrButton && this.renderCommunityRating(),
      this.renderWtrButton(),
      this.renderBookBody()
    );
  }
});

},{"./book":72,"./community_rating":87,"./gr_component_factory":102,"./shared/gr_prop_types":171,"./want_to_read/want_to_read_button":209,"lodash":"lodash"}],76:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GetACopyButton = undefined;

var _react = require("react");

var _reactRedux = require("react-redux");

var _get_a_copy_store = require("../../react_stores/buy_buttons/get_a_copy_store");

var _get_a_copy_store2 = _interopRequireDefault(_get_a_copy_store);

var _get_a_copy_actions = require("../../react_actions/buy_buttons/get_a_copy_actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GetACopyButton = exports.GetACopyButton = function GetACopyButton(_ref) {
  var getACopyDataUrl = _ref.getACopyDataUrl;
  var getACopyClickedHandler = _ref.getACopyClickedHandler;
  return _jsx("div", {}, void 0, _jsx("button", {
    className: "gr-button gr-button--fullWidth u-paddingTopTiny u-paddingBottomTiny u-defaultType",
    onClick: function onClick() {
      return getACopyClickedHandler(getACopyDataUrl);
    }
  }, void 0, "Get a copy"));
};

GetACopyButton.propTypes = {
  getACopyDataUrl: _react.PropTypes.string.isRequired,
  getACopyClickedHandler: _react.PropTypes.func.isRequired
};

var stateToProps = function stateToProps() {
  return {};
};
var dispatchToProps = function dispatchToProps(dispatch) {
  return {
    getACopyClickedHandler: function getACopyClickedHandler(dataUrl) {
      return dispatch((0, _get_a_copy_actions.getACopyClickedHandler)(dataUrl));
    }
  };
};

var ConnectedButton = (0, _reactRedux.connect)(stateToProps, dispatchToProps)(GetACopyButton);

var ButtonWithProviderRoot = function ButtonWithProviderRoot(props) {
  return _jsx(_reactRedux.Provider, {
    store: _get_a_copy_store2.default
  }, void 0, React.createElement(ConnectedButton, props));
};

exports.default = ButtonWithProviderRoot;

},{"../../react_actions/buy_buttons/get_a_copy_actions":27,"../../react_stores/buy_buttons/get_a_copy_store":234,"react":"react","react-redux":"react-redux"}],77:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _modal = require("../modal");

var _modal2 = _interopRequireDefault(_modal);

var _book = require("../book");

var _book2 = _interopRequireDefault(_book);

var _community_rating = require("../community_rating");

var _community_rating2 = _interopRequireDefault(_community_rating);

var _glide_button = require("./glide_button");

var _glide_button2 = _interopRequireDefault(_glide_button);

var _get_a_copy_link = require("./get_a_copy_link");

var _get_a_copy_link2 = _interopRequireDefault(_get_a_copy_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GetACopyInterstitial = function GetACopyInterstitial(_ref) {
  var book = _ref.book;
  var bookLinks = _ref.bookLinks;
  var glideButton = _ref.glideButton;
  var onCloseHandler = _ref.onCloseHandler;
  return _jsx(_modal2.default, {
    id: "GetACopyInterstitial",
    onCloseHandler: onCloseHandler,
    showByDefault: true,
    centered: true,
    bemModifiers: "small"
  }, void 0, _jsx("h3", {
    className: "gr-h3 gr-h3--noTopMargin"
  }, void 0, "Get a Copy"), React.createElement(
    _book2.default,
    _extends({}, book, {
      className: "u-paddingBottomSmall u-bottomGrayBorder u-marginBottomSmall",
      size: "large" }),
    _jsx(_community_rating2.default, {
      rating: parseFloat(book.avgRating),
      displayAvg: true,
      displayAvgRatingText: false,
      size: "medium"
    })
  ), _jsx("div", {
    className: "u-textAlignCenter"
  }, void 0, _jsx("p", {
    className: "gr-metaText gr-metaText--upper u-fontSizeDefault"
  }, void 0, "Available At:"), glideButton ? React.createElement(_glide_button2.default, _extends({}, glideButton, { bookId: book.bookId })) : null, bookLinks.map(function (link) {
    return React.createElement(_get_a_copy_link2.default, _extends({ key: link.name }, link));
  }), _jsx("p", {
    className: "u-fontSizeDefault"
  }, void 0, _jsx("a", {
    href: book.moreStoresUrl
  }, void 0, "More store options"))));
};

GetACopyInterstitial.propTypes = {
  book: _react.PropTypes.shape(_book2.default.propTypes).isRequired,
  bookLinks: _react.PropTypes.array.isRequired,
  glideButton: _react.PropTypes.object,
  onCloseHandler: _react.PropTypes.func
};

exports.default = GetACopyInterstitial;

},{"../book":72,"../community_rating":87,"../modal":136,"./get_a_copy_link":79,"./glide_button":80,"react":"react"}],78:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConditionalInterstitial = undefined;

var _reactRedux = require("react-redux");

var _get_a_copy_store = require("../../react_stores/buy_buttons/get_a_copy_store");

var _get_a_copy_store2 = _interopRequireDefault(_get_a_copy_store);

var _get_a_copy_actions = require("../../react_actions/buy_buttons/get_a_copy_actions");

var _get_a_copy_interstitial = require("./get_a_copy_interstitial");

var _get_a_copy_interstitial2 = _interopRequireDefault(_get_a_copy_interstitial);

var _react = require("react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConditionalInterstitial = exports.ConditionalInterstitial = function ConditionalInterstitial(_ref) {
  var interstitial = _ref.interstitial;
  var onClose = _ref.onClose;
  return interstitial ? React.createElement(_get_a_copy_interstitial2.default, _extends({}, interstitial, {
    onCloseHandler: onClose })) : _jsx("noscript", {});
};

ConditionalInterstitial.propTypes = {
  interstitial: _react.PropTypes.shape({
    book: _react.PropTypes.object,
    bookLinks: _react.PropTypes.array,
    glideButton: _react.PropTypes.object
  }),
  onClose: _react.PropTypes.func
};

var stateToProps = function stateToProps(state) {
  return {
    interstitial: state.activeGetACopyInterstitial
  };
};

var dispatchToProps = function dispatchToProps(dispatch) {
  return {
    onClose: function onClose() {
      return dispatch((0, _get_a_copy_actions.getACopyClosed)());
    }
  };
};

var ConnectedInterstitial = (0, _reactRedux.connect)(stateToProps, dispatchToProps)(ConditionalInterstitial);

var GetACopyInterstitialWrapper = function GetACopyInterstitialWrapper() {
  return _jsx(_reactRedux.Provider, {
    store: _get_a_copy_store2.default
  }, void 0, _jsx(ConnectedInterstitial, {}));
};

exports.default = GetACopyInterstitialWrapper;

},{"../../react_actions/buy_buttons/get_a_copy_actions":27,"../../react_stores/buy_buttons/get_a_copy_store":234,"./get_a_copy_interstitial":77,"react":"react","react-redux":"react-redux"}],79:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var GetACopyLink = function GetACopyLink(_ref) {
  var name = _ref.name;
  var url = _ref.url;
  return _jsx("div", {
    className: "u-marginBottomTiny"
  }, void 0, _jsx("a", {
    href: url,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "gr-button gr-button--fullWidth"
  }, void 0, name));
};

GetACopyLink.propTypes = {
  name: _react.PropTypes.string.isRequired,
  url: _react.PropTypes.string.isRequired
};

exports.default = GetACopyLink;

},{"react":"react"}],80:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _get_a_copy_link = require("./get_a_copy_link");

var _get_a_copy_link2 = _interopRequireDefault(_get_a_copy_link);

var _ajax_helper = require("../../modules/ajax/ajax_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GlideButton = function GlideButton(_ref) {
  var price = _ref.price;
  var url = _ref.url;
  var bookId = _ref.bookId;

  function handleClick() {
    (0, _ajax_helper.httpPost)("/track/track_clickstream", {
      data: {
        hit_type: "actionOnly",
        action_type: "bb_click-amazon"
      }
    });
  }
  return _jsx("div", {
    onClick: handleClick
  }, void 0, _jsx(_get_a_copy_link2.default, {
    name: "Kindle Store " + price,
    url: url
  }));
};

GlideButton.propTypes = {
  price: _react.PropTypes.string.isRequired,
  url: _react.PropTypes.string.isRequired,
  bookId: _react.PropTypes.string.isRequired
};

exports.default = GlideButton;

},{"../../modules/ajax/ajax_helper":4,"./get_a_copy_link":79,"react":"react"}],81:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*doc
---
title: Click Tracking Wrapper
name: click_tracking_wrapper
category: React
---

Wrappers an object in order to attach click tracking options to component

See also [tracking_data_attributes_mixin].

You can pass in children such as links or buttons that will report to dfp and pmet.

```rails_example
<%= react_component 'ReactComponents.StyleGuideExampleComponentWrapper',
                        componentName: 'ReactComponents.ClickTrackingWrapper',
                        propsToEval: {
                          children: "React.createElement('a', {href: '#'}, 'Random author name');"
                        },
                        trackingOptions: {
                          dfp: true,
                          pmet: {
                            click_type: "author_name"
                          }
                        }
                    %>
```
*/
exports.default = _gr_component_factory2.default.createClass({
  displayName: "ClickTrackingWrapper",

  propTypes: {
    trackingOptions: _react2.default.PropTypes.shape({
      dfp: _react2.default.PropTypes.bool,
      pmet: _react2.default.PropTypes.object.isRequired
    }).isRequired,
    children: _react2.default.PropTypes.element.isRequired
  },

  render: function render() {
    return this.props.children;
  }
});

},{"./gr_component_factory":102,"react":"react"}],82:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _image_registry = require("../modules/shared/image_registry");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _close_button_values = require("../modules/close_button_values");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "CloseButton",

  propTypes: {
    action: _react2.default.PropTypes.func.isRequired,
    variant: _react2.default.PropTypes.oneOf([_close_button_values.VARIANTS.DEFAULT, _close_button_values.VARIANTS.DARK_BG])
  },

  getDefaultProps: function getDefaultProps() {
    return { variant: _close_button_values.VARIANTS.DEFAULT };
  },
  render: function render() {
    var cx = (0, _classnames2.default)("gr-iconButton", this.props.className);
    var buttonImage = undefined;
    if (this.props.variant === _close_button_values.VARIANTS.DARK_BG) {
      buttonImage = (0, _image_registry.getImages)().closeIcons.darkBackground;
    } else {
      buttonImage = (0, _image_registry.getImages)().closeIcon;
    }
    return _jsx("button", {
      type: "button",
      className: cx,
      onClick: this.props.action
    }, void 0, _jsx("img", {
      alt: "Dismiss",
      src: buttonImage
    }));
  }
});

},{"../modules/close_button_values":9,"../modules/shared/image_registry":20,"./gr_component_factory":102,"classnames":"classnames","react":"react"}],83:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _expandable_html = require("../user_content/expandable_html");

var _expandable_html2 = _interopRequireDefault(_expandable_html);

var _hidden_html = require("../user_content/hidden_html");

var _hidden_html2 = _interopRequireDefault(_hidden_html);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _user_profile_link = require("../user/user_profile_link");

var _user_profile_link2 = _interopRequireDefault(_user_profile_link);

var _user_icon = require("../user/user_icon");

var _user_icon2 = _interopRequireDefault(_user_icon);

var _right_side_information = require("./right_side_information");

var _right_side_information2 = _interopRequireDefault(_right_side_information);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 Comment displays a single comment from a user.
*/
exports.default = _gr_component_factory2.default.createClass({
  displayName: "Comment",

  propTypes: {
    body: _react2.default.PropTypes.shape(_gr_prop_types2.default.expandableHtml()),
    createdAt: _gr_prop_types2.default.date.isRequired,
    authorUser: _gr_prop_types2.default.user().isRequired,
    subjectKey: _react2.default.PropTypes.string.isRequired,
    subject: _gr_prop_types2.default.commentSubject(),
    deletableByCurrentUser: _react2.default.PropTypes.bool.isRequired,
    blockedByCurrentUser: _react2.default.PropTypes.bool,
    showTimestamp: _react2.default.PropTypes.bool,
    uri: _react2.default.PropTypes.string.isRequired,
    flagForAbuseUrl: _react2.default.PropTypes.string.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      blockedByCurrentUser: false
    };
  },
  getInitialState: function getInitialState() {
    return { showCommentDeletingSpinner: false };
  },
  renderBody: function renderBody() {
    if (this.props.blockedByCurrentUser) {
      var unhideText = "unhide comment";
      return _jsx(_hidden_html2.default, {
        unhideText: unhideText
      }, void 0, _react2.default.createElement(_expandable_html2.default, this.props.body));
    } else {
      return _react2.default.createElement(_expandable_html2.default, this.props.body);
    }
  },
  render: function render() {
    return _jsx("div", {
      className: "gr-comment gr-mediaBox"
    }, void 0, _jsx("div", {
      className: "gr-mediaBox__media"
    }, void 0, _jsx(_user_icon2.default, {
      user: this.props.authorUser
    })), _jsx("div", {
      className: "gr-mediaBox__desc\n                              gr-mediaBox__desc--clearfixOverflow"
    }, void 0, _react2.default.createElement(_right_side_information2.default, this.props), _jsx(_user_profile_link2.default, {
      user: this.props.authorUser
    }), this.props.blockedByCurrentUser ? _jsx("strong", {}, void 0, " (blocked)") : null, _jsx("div", {
      className: "gr-comment__body"
    }, void 0, this.renderBody())));
  }
});

},{"../gr_component_factory":102,"../shared/gr_prop_types":171,"../user/user_icon":193,"../user/user_profile_link":194,"../user_content/expandable_html":195,"../user_content/hidden_html":196,"./right_side_information":86,"react":"react"}],84:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _comment_actions = require("../../react_actions/comment_actions");

var _comment_actions2 = _interopRequireDefault(_comment_actions);

var _comments_store = require("../../react_stores/comments_store");

var _comments_store2 = _interopRequireDefault(_comments_store);

var _user_icon = require("../user/user_icon");

var _user_icon2 = _interopRequireDefault(_user_icon);

var _gr_reflux = require("../../react_mixins/gr_reflux");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "CommentForm",

  propTypes: {
    authorUser: _gr_prop_types2.default.user().isRequired,
    subjectKey: _react2.default.PropTypes.string.isRequired,
    subject: _react2.default.PropTypes.shape({
      type: _react2.default.PropTypes.string,
      id: _react2.default.PropTypes.number,
      uri: _react2.default.PropTypes.string }),
    placeholder: _react2.default.PropTypes.string
  },

  mixins: [(0, _gr_reflux.connectToLazyStore)(_comments_store2.default, "subjectKey")],

  getDefaultProps: function getDefaultProps() {
    return {
      placeholder: "Write a comment…"
    };
  },
  addNewComment: function addNewComment(event) {
    if (!this.isCommentEmpty()) {
      _comment_actions2.default.addNewComment({
        subjectKey: this.props.subjectKey,
        subject: this.props.subject,
        body: this.state.unsavedComment,
        authorUser: this.props.authorUser
      });
    }
    event.preventDefault();
  },
  isCommentEmpty: function isCommentEmpty() {
    return _lodash2.default.isEmpty(_lodash2.default.trim(this.state.unsavedComment));
  },
  onTextChange: function onTextChange(event) {
    _comment_actions2.default.commentEntered(this.props.subjectKey, event.target.value);
  },
  onFocus: function onFocus() {
    _comment_actions2.default.textareaFocused(this.props.subjectKey);
  },
  onBlur: function onBlur() {
    _comment_actions2.default.textareaUnfocused(this.props.subjectKey);
  },
  componentDidUpdate: function componentDidUpdate() {
    if (this.state.textareaFocusRequested === true) {
      this.refs.commentBodyTextarea.focus();
    }
  },
  render: function render() {
    var commentFormClassName = (0, _classnames2.default)(this.withBemModifiers("gr-commentForm"), "gr-mediaBox");
    return _jsx("div", {
      className: commentFormClassName
    }, void 0, _jsx("div", {
      className: "gr-mediaBox__media u-noLineHeight"
    }, void 0, _jsx(_user_icon2.default, {
      user: this.props.authorUser
    })), _jsx("form", {
      className: "gr-mediaBox__desc",
      method: "post",
      action: "/comment"
    }, void 0, _jsx("input", {
      type: "hidden",
      name: "id",
      value: this.props.subject.id
    }), _jsx("input", {
      type: "hidden",
      name: "type",
      value: this.props.subject.type
    }), _react2.default.createElement("textarea", { className: "gr-textarea gr-commentForm__textarea",
      name: "comment[body_usertext]",
      disabled: this.state.saveInProgress,
      onChange: this.onTextChange,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      rows: this.state.textareaRows,
      value: this.state.unsavedComment,
      ref: "commentBodyTextarea",
      placeholder: this.props.placeholder,
      "aria-label": this.props.placeholder }), this.state.showCommentButton ? _jsx("button", {
      className: "gr-commentForm__submitButton gr-button gr-button--small",
      disabled: this.state.saveInProgress || this.isCommentEmpty(),
      onClick: this.addNewComment,
      type: "submit"
    }, void 0, "Comment") : null));
  }
});

},{"../../react_actions/comment_actions":28,"../../react_mixins/gr_reflux":227,"../../react_stores/comments_store":235,"../gr_component_factory":102,"../shared/gr_prop_types":171,"../user/user_icon":193,"classnames":"classnames","lodash":"lodash","react":"react"}],85:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _comment = require("./comment");

var _comment2 = _interopRequireDefault(_comment);

var _pagination_links = require("../pagination_links");

var _pagination_links2 = _interopRequireDefault(_pagination_links);

var _comments_store = require("../../react_stores/comments_store");

var _comments_store2 = _interopRequireDefault(_comments_store);

var _comment_actions = require("../../react_actions/comment_actions");

var _comment_actions2 = _interopRequireDefault(_comment_actions);

var _spinner = require("../spinner");

var _spinner2 = _interopRequireDefault(_spinner);

var _gr_reflux = require("../../react_mixins/gr_reflux");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_MAX_COMMENTS = 3;
var FIRST_PAGE = 1;

/*
 Comments displays a list of comments.
*/
exports.default = _gr_component_factory2.default.createClass({
  displayName: "Comments",

  propTypes: {
    subjectKey: _react2.default.PropTypes.string.isRequired,
    subject: _gr_prop_types2.default.commentSubject(),
    subjectUrl: _react2.default.PropTypes.string,
    showTimestamp: _react2.default.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return { showTimestamp: true };
  },

  mixins: [(0, _gr_reflux.connectToLazyStore)(_comments_store2.default, "subjectKey")],

  seeMoreCommentsText: function seeMoreCommentsText() {
    if (this.state.numComments == 1) {
      return "See 1 comment";
    } else {
      return "See all " + this.state.numComments + " comments";
    }
  },
  showCommentsForPage: function showCommentsForPage(page) {
    _comment_actions2.default.showCommentsForPage({
      subjectKey: this.props.subjectKey,
      subject: this.props.subject,
      page: page
    });
  },
  showMoreClicked: function showMoreClicked(event) {
    _comment_actions2.default.showSeeMoreLoadingSpinner(this.props.subjectKey);
    this.showCommentsForPage(FIRST_PAGE);
    event.preventDefault();
  },
  renderSeeMoreComments: function renderSeeMoreComments() {
    var numComments = this.state.numComments;
    if (numComments > DEFAULT_MAX_COMMENTS || numComments > this.state.comments.length) {
      return _jsx("div", {
        className: "gr-comments__seeAllLinkBox"
      }, void 0, this.state.showSeeMoreLoadingSpinner ? _jsx("span", {}, void 0, _jsx("span", {
        className: "gr-hyperlink gr-hyperlink--bold"
      }, void 0, this.seeMoreCommentsText()), _jsx("span", {
        id: "showMoreSpinner",
        className: "u-marginLeftTiny"
      }, void 0, _jsx(_spinner2.default, {}))) : _jsx("a", {
        href: this.props.subjectUrl,
        className: "gr-hyperlink gr-hyperlink--bold",
        onClick: this.showMoreClicked
      }, void 0, this.seeMoreCommentsText()));
    } else {
      return null;
    }
  },
  renderComments: function renderComments() {
    var _this = this;

    var comments = this.state.showPagination ? this.state.comments : _lodash2.default.takeRight(this.state.comments, DEFAULT_MAX_COMMENTS);
    return _lodash2.default.map(comments, function (comment) {
      return _react2.default.createElement(_comment2.default, _extends({ key: comment.uri,
        subjectKey: _this.props.subjectKey,
        subject: _this.props.subject,
        showTimestamp: _this.props.showTimestamp
      }, comment));
    });
  },
  render: function render() {
    var commentsClassName = (0, _classnames2.default)(this.withBemModifiers("gr-comments"), "gr-box", "gr-box--hiddenOverflow", "u-defaultType");
    if (this.state.numComments > 0) {
      return _jsx("div", {
        className: commentsClassName
      }, void 0, this.state.showPagination ? null : this.renderSeeMoreComments(), this.renderComments(), this.state.showPagination ? _jsx("div", {
        className: "u-topGrayBorder"
      }, void 0, _jsx(_pagination_links2.default, {
        subjectKey: this.props.subjectKey,
        totalSize: this.state.numComments,
        currentPageNumber: this.state.currentPage,
        perPage: 10,
        changePageAction: this.showCommentsForPage,
        className: "gr-paginationLinks__links"
      })) : null);
    } else {
      return null;
    }
  }
});

},{"../../react_actions/comment_actions":28,"../../react_mixins/gr_reflux":227,"../../react_stores/comments_store":235,"../gr_component_factory":102,"../pagination_links":142,"../shared/gr_prop_types":171,"../spinner":186,"./comment":83,"classnames":"classnames","lodash":"lodash","react":"react"}],86:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _spinner = require("../spinner");

var _spinner2 = _interopRequireDefault(_spinner);

var _flag_for_abuse_link = require("../flagged_resources/flag_for_abuse_link");

var _flag_for_abuse_link2 = _interopRequireDefault(_flag_for_abuse_link);

var _relative_time = require("../time/relative_time");

var _relative_time2 = _interopRequireDefault(_relative_time);

var _dot_separated_elements = require("../dot_separated_elements");

var _dot_separated_elements2 = _interopRequireDefault(_dot_separated_elements);

var _comment_actions = require("../../react_actions/comment_actions");

var _comment_actions2 = _interopRequireDefault(_comment_actions);

var _user_agent_capabilities_store = require("../../react_stores/user_agent_capabilities_store");

var _user_agent_capabilities_store2 = _interopRequireDefault(_user_agent_capabilities_store);

var _env_utils = require("../../modules/env_utils");

var _env_utils2 = _interopRequireDefault(_env_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "CommentRightSideInformation",
  mixins: [_reflux2.default.connect(_user_agent_capabilities_store2.default, "userAgentCapabilities")],
  propTypes: {
    showTimestamp: _react2.default.PropTypes.bool,
    deletableByCurrentUser: _react2.default.PropTypes.bool.isRequired,
    subject: _gr_prop_types2.default.commentSubject().isRequired,
    uri: _react2.default.PropTypes.string.isRequired,
    subjectKey: _react2.default.PropTypes.string.isRequired,
    createdAt: _gr_prop_types2.default.date.isRequired,
    flagForAbuseUrl: _react2.default.PropTypes.string.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return { showTimestamp: true };
  },
  getInitialState: function getInitialState() {
    return { showCommentDeletingSpinner: false };
  },
  deleteComment: function deleteComment() {
    var commentData = { subject: this.props.subject,
      subjectKey: this.props.subjectKey };
    if (window.confirm("Are you sure you want to delete this comment?")) {
      this.setState({ showCommentDeletingSpinner: true });
      _comment_actions2.default.deleteComment(this.props.subjectKey, this.props.uri, commentData);
    }
  },
  getDeleteLink: function getDeleteLink() {
    if (this.props.deletableByCurrentUser) {
      if (this.state.showCommentDeletingSpinner) {
        return _react2.default.createElement(_spinner2.default, { ref: "spinner" });
      } else {
        return _react2.default.createElement(
          "a",
          { className: "gr-comment__deleteLink gr-hyperlink--naked gr-hyperlink",
            ref: "deleteLink",
            href: "",
            onClick: this.deleteComment,
            "aria-label": "Delete comment" },
          "Delete"
        );
      }
    }
  },
  getFlag: function getFlag() {
    var fullFlagUrl = this.props.flagForAbuseUrl + "&return_url=" + encodeURIComponent(_env_utils2.default.getLocationUrl());
    return _jsx(_flag_for_abuse_link2.default, {
      flagForAbuseUrl: fullFlagUrl
    });
  },
  getTimestamp: function getTimestamp() {
    if (this.props.showTimestamp) {
      return _jsx("small", {
        className: "gr-comment__timestamp"
      }, void 0, _jsx(_relative_time2.default, {
        time: this.props.createdAt
      }));
    }
  },
  getRightSideElements: function getRightSideElements() {
    return [this.getTimestamp(), this.getDeleteLink(), this.getFlag()];
  },
  render: function render() {
    return _jsx("div", {
      className: "gr-comment__rightSideInformation"
    }, void 0, _jsx(_dot_separated_elements2.default, {
      elements: this.getRightSideElements()
    }));
  }
});

},{"../../modules/env_utils":13,"../../react_actions/comment_actions":28,"../../react_stores/user_agent_capabilities_store":251,"../dot_separated_elements":88,"../flagged_resources/flag_for_abuse_link":99,"../gr_component_factory":102,"../shared/gr_prop_types":171,"../spinner":186,"../time/relative_time":191,"react":"react","reflux":"reflux"}],87:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             This component renders a line of basic book details/stats.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             The component always includes an average star rating,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             and optionally includes avg rating text, ratings count,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             text reviews count, publication date, and editions count.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _dot_separated_elements = require("./dot_separated_elements");

var _dot_separated_elements2 = _interopRequireDefault(_dot_separated_elements);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ICON_SIZES = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large"
};
var MAX_RATING = 5;
exports.default = _gr_component_factory2.default.createClass({
  displayName: "CommunityRating",

  statics: {
    ICON_SIZES: ICON_SIZES
  },
  propTypes: {
    rating: _react2.default.PropTypes.number.isRequired,
    size: _react2.default.PropTypes.oneOf([ICON_SIZES.SMALL, ICON_SIZES.MEDIUM, ICON_SIZES.LARGE]),
    displayAvg: _react2.default.PropTypes.bool,
    displayAvgRatingText: _react2.default.PropTypes.bool,
    ratingsCount: _react2.default.PropTypes.number,
    textReviewsCount: _react2.default.PropTypes.number,
    publication: _react2.default.PropTypes.shape({
      toBePublished: _react2.default.PropTypes.bool,
      date: _react2.default.PropTypes.string
    }),
    editions: _react2.default.PropTypes.shape({
      countString: _react2.default.PropTypes.string,
      url: _react2.default.PropTypes.string
    }),
    className: _react2.default.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      displayAvg: false,
      size: ICON_SIZES.SMALL
    };
  },
  wrapperClasses: function wrapperClasses() {
    return (0, _classnames2.default)("communityRating__starsWrapper", {
      "communityRating__starsWrapper--small": this.props.size === ICON_SIZES.SMALL,
      "communityRating__starsWrapper--medium": this.props.size === ICON_SIZES.MEDIUM,
      "communityRating__starsWrapper--large": this.props.size === ICON_SIZES.LARGE
    });
  },
  starClasses: function starClasses() {
    return (0, _classnames2.default)("communityRating__stars", {
      "communityRating__stars--small": this.props.size === ICON_SIZES.SMALL,
      "communityRating__stars--medium": this.props.size === ICON_SIZES.MEDIUM,
      "communityRating__stars--large": this.props.size === ICON_SIZES.LARGE
    });
  },

  // Emulate behavior in application_helper.rb, adjusted for SVG sizing
  getRoundedRating: function getRoundedRating(rating) {
    var flooredRating = Math.floor(rating);
    if (rating === flooredRating) {
      return rating;
    }
    if (rating - flooredRating < 0.5) {
      return flooredRating + 0.45;
    } else {
      return flooredRating + 0.6;
    }
  },
  renderRating: function renderRating() {
    var roundedRating = this.getRoundedRating(this.props.rating);
    var starsStyle = {
      width: roundedRating / MAX_RATING * 100 + "%"
    };
    var ratingStarsLabel = "Rated " + this.props.rating.toFixed(2) + " of " + MAX_RATING;

    var displayAvgRatingText = this.props.displayAvgRatingText === null ? this.props.displayAvg : this.props.displayAvgRatingText;

    return _jsx("span", {}, void 0, _jsx("div", {
      className: this.wrapperClasses()
    }, void 0, _jsx("div", {
      className: this.starClasses(),
      style: starsStyle,
      "aria-label": ratingStarsLabel
    })), this.props.displayAvg ? _jsx("span", {
      className: "gr-metaText"
    }, void 0, this.props.rating.toFixed(2), displayAvgRatingText ? " avg. rating" : "") : null);
  },
  renderRatingsCount: function renderRatingsCount() {
    return _jsx("span", {
      className: "gr-metaText u-inlineBlock"
    }, void 0, this.props.ratingsCount.toLocaleString(), " Ratings");
  },
  renderTextReviewsCount: function renderTextReviewsCount() {
    return _jsx("span", {
      className: "gr-metaText u-inlineBlock"
    }, void 0, this.props.textReviewsCount.toLocaleString(), " Reviews");
  },
  renderPublicationDate: function renderPublicationDate() {
    return _jsx("span", {
      className: "gr-metaText u-inlineBlock"
    }, void 0, (this.props.publication.toBePublished ? "expected publication" : "published") + " " + this.props.publication.date);
  },
  renderEditionsCount: function renderEditionsCount() {
    return _jsx("span", {
      className: "gr-metaText"
    }, void 0, _jsx("a", {
      className: "gr-hyperlink gr-hyperlink--naked u-inlineBlock",
      href: this.props.editions.url
    }, void 0, this.props.editions.countString));
  },
  render: function render() {
    var ratingClassName = (0, _classnames2.default)("communityRating", this.props.className);
    var ratingStarsLabel = "Rated " + this.props.rating.toFixed(2) + " of " + MAX_RATING;

    var elements = [this.renderRating()];

    if (this.props.ratingsCount) {
      elements.push(this.renderRatingsCount());
    }

    if (this.props.textReviewsCount) {
      elements.push(this.renderTextReviewsCount());
    }

    if (this.props.publication && this.props.publication.date) {
      elements.push(this.renderPublicationDate());
    }

    if (this.props.editions && this.props.editions.countString) {
      elements.push(this.renderEditionsCount());
    }

    return _jsx("div", {
      className: ratingClassName,
      "aria-label": ratingStarsLabel
    }, void 0, _jsx(_dot_separated_elements2.default, {
      elements: elements
    }));
  }
});

},{"./dot_separated_elements":88,"./gr_component_factory":102,"classnames":"classnames","react":"react"}],88:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "DotSeparatedElements",

  propTypes: {
    elements: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.oneOfType([_react2.default.PropTypes.element, _react2.default.PropTypes.string])).isRequired,
    separator: _react2.default.PropTypes.element
  },

  getDefaultProps: function getDefaultProps() {
    return {
      separator: _jsx("span", {}, void 0, " · ")
    };
  },
  joinElementsWithSeparator: function joinElementsWithSeparator() {
    var _this = this;

    var elements = (0, _lodash.compact)(this.props.elements);
    return (0, _lodash.transform)(elements, function (result, element, index) {
      result.push(element);
      if (index + 1 !== elements.length) {
        result.push(_this.props.separator);
      }
    });
  },
  render: function render() {
    return _jsx("span", {
      className: this.props.className
    }, void 0, (0, _lodash.map)(this.joinElementsWithSeparator(), function (element, index) {
      return _jsx("span", {}, index, element);
    }));
  }
});

},{"./gr_component_factory":102,"lodash":"lodash","react":"react"}],89:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*doc
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           title: Drop Down List
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           name: drop_down_list
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           category: React
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           This is a basic menu list component that will take in arbitrary component
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           children and display them in a list view. If the number of children is > the
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           passed in maxListItems prop, the children will be appropriately truncated, and
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           a "More" link will appear that will link to a passed in moreURL prop.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           PROPS:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           OPTIONAL - moreLinkURL - url for the "More" link to redirect to. Does not display
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    the "More" link if no URL is passed in.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      moreLinkText - display text for the link. Defaults to "More"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "DropDownList",

  propTypes: {
    showMoreLink: _react2.default.PropTypes.bool,
    moreLinkURL: _react2.default.PropTypes.string,
    moreLinkText: _react2.default.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return { showMoreLink: false,
      moreLinkURL: null,
      moreLinkText: "…More" };
  },
  render: function render() {
    return _jsx("div", {}, void 0, this.props.children, this.props.showMoreLink && this.props.moreLinkURL !== null ? _jsx("a", {
      className: "dropDownList__listItem--moreLink",
      href: this.props.moreLinkURL
    }, void 0, this.props.moreLinkText) : null);
  }
});

},{"./gr_component_factory":102,"react":"react"}],90:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*doc
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           title: Dropdown
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           name: dropdown
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           category: React
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           A dropdown component. Includes a trigger and content area.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           NOTE: We tried to make Dropdown a single reusable component for anything with
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           dropdown-style interaction. Unfortunately, because of special styling and
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           interaction cases (e.g., navbar menus, "want to read" button),
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           it ended up a giant pile of special cases and logic forks. It's now an unwieldy mess.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           PROPS:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           REQUIRED - trigger: element that will trigger the dropdown to open
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      triggerEventType: the event that will open the dropdown (e.g. click, hover)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        Note: On touch devices the component will render as if you
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        had specified triggerEventType of "click"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           OPTIONAL - tooltipText: text to render as a `title` attribute on the trigger
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   element
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ```rails_example
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           <%= react_component 'ReactComponents.Dropdown',
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  {
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   trigger: 'Browse ▾',
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   triggerEventType: 'hover',
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   children: 'Link item one' } %>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ```
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

/* react-onclickoutside is a deprecated package that should not be used for new
   code. Instead of having an outside click close a module, there should be an
   explicit close affordances in the spec. */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _hover_intent = require("../react_mixins/hover_intent");

var _hover_intent2 = _interopRequireDefault(_hover_intent);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactOnclickoutside = require("react-onclickoutside");

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _keys = require("../modules/keys");

var _keys2 = _interopRequireDefault(_keys);

var _user_agent_capabilities_store = require("../react_stores/user_agent_capabilities_store");

var _user_agent_capabilities_store2 = _interopRequireDefault(_user_agent_capabilities_store);

var _touch_not_ready_helper = require("../modules/shared/touch_not_ready_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TriggerEventTypes = {
  HOVER: "hover",
  CLICK: "click"
};

var alignments = {
  LEFT: "left",
  RIGHT: "right"
};

var mouseOverDelay = 100;
var mouseOutDelay = mouseOverDelay;

exports.default = _gr_component_factory2.default.createClass({
  displayName: "Dropdown",

  mixins: [_hover_intent2.default, _reactOnclickoutside2.default, _reflux2.default.connect(_user_agent_capabilities_store2.default, "userAgentCapabilities")],

  propTypes: {
    alignment: _react2.default.PropTypes.oneOf(_lodash2.default.values(alignments)),
    fallbackUrl: _react2.default.PropTypes.string,
    onShowCallback: _react2.default.PropTypes.func,
    tooltipText: _react2.default.PropTypes.string,
    trigger: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.element]).isRequired,
    triggerEventType: _react2.default.PropTypes.oneOf(_lodash2.default.values(TriggerEventTypes))
  },

  statics: {
    TriggerEventTypes: TriggerEventTypes
  },

  getTriggerEventType: function getTriggerEventType() {
    if (this.state.userAgentCapabilities.touch) {
      return TriggerEventTypes.CLICK;
    }
    return this.props.triggerEventType;
  },
  getInitialState: function getInitialState() {
    return {
      dropdownOpen: false
    };
  },
  getDefaultProps: function getDefaultProps() {
    return {
      triggerEventType: TriggerEventTypes.CLICK,
      alignment: alignments.LEFT
    };
  },
  hide: function hide() {
    this.setState({ dropdownOpen: false });
  },
  show: function show() {
    this.setState({ dropdownOpen: true });
    if (this.props.onShowCallback) {
      this.props.onShowCallback();
    }
  },
  toggle: function toggle(ev) {
    if (this.props.children) {
      ev.preventDefault();
    }
    this.state.dropdownOpen ? this.hide() : this.show();
  },
  openList: function openList(ev) {
    if (_keys2.default.isDropdownOpenerKey(ev.keyCode)) {
      ev.preventDefault();
      if (_keys2.default.isArrowDown(ev.keyCode)) {
        this.show();
      } else {
        this.toggle(ev);
      }
    } else if (_keys2.default.isDefaultCloserKey(ev.keyCode)) {
      ev.preventDefault();
      this.hide();
    }
  },
  handleClickOutside: function handleClickOutside() {
    // On touch devices that display dropdown components, touch gestures such as
    // panning and zooming trigger this event listener. We disabled hiding in
    // this listener for touch devices because hiding the dropdown on touch
    // gestures is disruptive.
    if (!this.state.userAgentCapabilities.touch) {
      this.hide();
    }
  },
  handleMouseEnter: function handleMouseEnter() {
    this.onEnterIntent(this.show, mouseOverDelay);
  },
  handleMouseLeave: function handleMouseLeave() {
    this.onLeaveIntent(this.hide, mouseOutDelay);
  },
  handleTriggerClick: function handleTriggerClick(event) {
    (0, _touch_not_ready_helper.acknowledgeEvent)(event);
    // After hovering to open the dropdown, don't close on click
    if (this.state.dropdownOpen && this.props.triggerEventType === TriggerEventTypes.HOVER && this.state.userAgentCapabilities.touch !== true) {
      event.preventDefault();
      return;
    } else {
      this.toggle(event);
    }
  },
  triggerClasses: function triggerClasses() {
    return (0, _classnames2.default)(this.withBemModifiers(["dropdown__trigger"]), { "dropdown__trigger--buttonReset": _lodash2.default.isUndefined(this.props.fallbackUrl) }, { "dropdown__trigger--triggerEventTypeHover": this.props.triggerEventType === TriggerEventTypes.HOVER }, { "dropdown__trigger--personalNav": this.props.isInPersonalNav === "true" }, { "dropdown__trigger--personalNavActive": this.props.isInPersonalNav === "true" && this.state.dropdownOpen });
  },
  renderTriggerButton: function renderTriggerButton() {
    return _jsx("button", {
      className: this.triggerClasses(),
      "aria-haspopup": "true",
      "aria-expanded": this.state.dropdownOpen,
      onClick: this.handleTriggerClick,
      onKeyDown: this.openList,
      title: this.props.tooltipText,
      "data-ux-click": this.props.isInPersonalNav === "true"
    }, void 0, this.props.trigger);
  },
  renderTriggerLink: function renderTriggerLink() {
    return _jsx("a", {
      className: this.triggerClasses(),
      href: this.props.fallbackUrl,
      onClick: this.handleTriggerClick,
      onKeyDown: this.openList,
      role: "button",
      "aria-haspopup": "true",
      "aria-expanded": this.state.dropdownOpen,
      title: this.props.tooltipText,
      "data-ux-click": this.props.isInPersonalNav === "true"
    }, void 0, this.props.trigger);
  },
  render: function render() {
    var dropdownClasses = (0, _classnames2.default)(this.withBemModifiers("dropdown"));
    var dropdownShowOption = this.props.bemModifiers === "authorModule" || this.props.bemModifiers === "friendFollowModuleMobile" ? { "dropdown__menu--showMobile": this.state.dropdownOpen } : { "dropdown__menu--show": this.state.dropdownOpen };
    var dropdownContentsClasses = (0, _classnames2.default)(this.withBemModifiers("dropdown__menu"), "gr-box gr-box--withShadowLarge", dropdownShowOption);
    var trigger = _lodash2.default.isUndefined(this.props.fallbackUrl) ? this.renderTriggerButton() : this.renderTriggerLink();
    var dropdownContents = _jsx("div", {
      className: dropdownContentsClasses,
      role: "menu"
    }, void 0, this.props.children);

    switch (this.getTriggerEventType()) {
      case TriggerEventTypes.HOVER:
        return _jsx("div", {
          className: dropdownClasses,
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave
        }, void 0, trigger, dropdownContents);
      case TriggerEventTypes.CLICK:
        return _jsx("div", {
          className: dropdownClasses
        }, void 0, trigger, dropdownContents);
    }
  }
});

},{"../modules/keys":16,"../modules/shared/touch_not_ready_helper":21,"../react_mixins/hover_intent":228,"../react_stores/user_agent_capabilities_store":251,"./gr_component_factory":102,"classnames":"classnames","lodash":"lodash","react":"react","react-onclickoutside":"react-onclickoutside","reflux":"reflux"}],91:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: "error_message.js",

  propTypes: {
    componentName: _react2.default.PropTypes.string.isRequired
  },
  render: function render() {
    return _jsx("div", {
      className: "gr-errorMessage"
    }, void 0, "There was an issue rendering ", this.props.componentName);
  }
});

},{"react":"react"}],92:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _genre_checkbox = require("./genre_checkbox");

var _genre_checkbox2 = _interopRequireDefault(_genre_checkbox);

var _modal_actions = require("./../react_actions/modal_actions");

var _modal_actions2 = _interopRequireDefault(_modal_actions);

var _favorite_genres_form_actions = require("../react_actions/favorite_genres_form_actions");

var _favorite_genres_form_actions2 = _interopRequireDefault(_favorite_genres_form_actions);

var _favorite_genres_form_store = require("../react_stores/favorite_genres_form_store");

var _favorite_genres_form_store2 = _interopRequireDefault(_favorite_genres_form_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "FavoriteGenresForm",

  mixins: [_reflux2.default.connect(_favorite_genres_form_store2.default, "favoriteGenresFormStore")],

  propTypes: {
    favoriteGenres: _react2.default.PropTypes.array,
    genres: _react2.default.PropTypes.array.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      favoriteGenres: []
    };
  },
  onSubmit: function onSubmit(event) {
    _favorite_genres_form_actions2.default.submitSelectedGenres();
    _modal_actions2.default.closeModal();
    event.preventDefault();
  },
  renderGenreCheckboxes: function renderGenreCheckboxes() {
    var _this = this;

    return _jsx("div", {
      className: "gr-genresForm__checkBoxes"
    }, void 0, _lodash2.default.map(this.props.genres, function (genre) {
      return _jsx(_genre_checkbox2.default, {
        genre: genre.name,
        isFavorited: _lodash2.default.includes(_this.state.favoriteGenresFormStore.selectedGenres, genre.name)
      }, genre.name);
    }));
  },
  render: function render() {
    return _jsx("div", {
      className: "gr-genresForm"
    }, void 0, _jsx("div", {
      className: "gr-genresForm__title"
    }, void 0, "Follow Your Favorite Genres"), _jsx("div", {
      className: "gr-genresForm__description"
    }, void 0, "We use your favorite genres to make better book recommendations and tailor what you see in your Updates feed."), _jsx("form", {
      action: "/user/edit_fav_genres",
      "data-remote": "true",
      method: "post"
    }, void 0, this.renderGenreCheckboxes(), _jsx("button", {
      type: "submit",
      onClick: this.onSubmit,
      className: "gr-button gr-button--large"
    }, void 0, "Save")));
  }
});

},{"../react_actions/favorite_genres_form_actions":32,"../react_stores/favorite_genres_form_store":237,"./../react_actions/modal_actions":37,"./genre_checkbox":101,"./gr_component_factory":102,"lodash":"lodash","react":"react","reflux":"reflux"}],93:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _dot_separated_elements = require("./dot_separated_elements");

var _dot_separated_elements2 = _interopRequireDefault(_dot_separated_elements);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _click_tracking_wrapper = require("./click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _click_tracking_helper = require("../modules/ads/click_tracking_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var READ_MORE = "Read More";

exports.default = _gr_component_factory2.default.createClass({
  displayName: "FeaturedContentBlog",
  propTypes: {
    blog: _react2.default.PropTypes.shape({
      likeCount: _react2.default.PropTypes.number.isRequired,
      commentCount: _react2.default.PropTypes.number.isRequired,
      imageUrl: _react2.default.PropTypes.string.isRequired,
      blogUrl: _react2.default.PropTypes.string.isRequired,
      title: _react2.default.PropTypes.string.isRequired
    }).isRequired,
    isMobile: _react2.default.PropTypes.bool,
    isInline: _react2.default.PropTypes.bool
  },

  defaultProps: {
    isMobile: false,
    isInline: false
  },

  renderImage: function renderImage() {
    var linkClassName = (0, _classnames2.default)("featuredContentImageBody__imageLink", {
      "featuredContentImageBody__imageLink--inline": this.props.isInline
    });
    var imageClassName = (0, _classnames2.default)("featuredContentImageBody__image", {
      featuredContentImageBody__imageMobile: this.props.isMobile
    });
    if (this.props.blog.imageUrl) {
      var bodyImage = _jsx("a", {
        className: linkClassName,
        href: this.props.blog.blogUrl
      }, void 0, _jsx("img", {
        className: imageClassName,
        src: this.props.blog.imageUrl,
        alt: "" + this.props.blog.title
      }));
      return _jsx(_click_tracking_wrapper2.default, {
        trackingOptions: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_blog_image,
        children: bodyImage
      });
    } else {
      return null;
    }
  },
  renderTitle: function renderTitle() {
    var titleClass = (0, _classnames2.default)("featuredContentImageBody__title", {
      "featuredContentImageBody__title--mobile": this.props.isMobile,
      "featuredContentImageBody__title--inline": this.props.isInline
    });
    var titleLink = _jsx("a", {
      href: this.props.blog.blogUrl,
      className: titleClass
    }, void 0, this.props.blog.title);
    return _jsx(_click_tracking_wrapper2.default, {
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_blog_title,
      children: titleLink
    });
  },
  renderLikesText: function renderLikesText(text) {
    return _jsx("span", {
      className: "gr-metaText featuredContentImageBody__likes"
    }, void 0, text, " likes");
  },
  renderCommentsText: function renderCommentsText(text) {
    return _jsx("span", {
      className: "gr-metaText featuredContentImageBody__comments"
    }, void 0, text, " comments");
  },
  renderReadMore: function renderReadMore() {
    var readMoreClassName = (0, _classnames2.default)("gr-button", "featuredContentImageBody__button", {
      "featuredContentImageBody__button--mobile": this.props.isMobile,
      "featuredContentImageBody__button--inline": this.props.isInline
    });
    var readMore = _jsx("a", {
      href: this.props.blog.blogUrl,
      className: readMoreClassName
    }, void 0, READ_MORE);
    return _jsx(_click_tracking_wrapper2.default, {
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_blog_button,
      children: readMore
    });
  },
  renderLikesAndComments: function renderLikesAndComments() {
    return _jsx("div", {
      className: "featuredContentImageBody__likesAndComments"
    }, void 0, this.renderLikesAndCommentsText());
  },
  renderLikesAndCommentsText: function renderLikesAndCommentsText() {
    var blog = this.props.blog;
    var likesText = this.renderLikesText(blog.likeCount);
    var commentsText = this.renderCommentsText(blog.commentCount);
    if (blog.likeCount && blog.commentCount) {
      return _jsx(_dot_separated_elements2.default, {
        elements: [likesText, commentsText]
      });
    } else if (blog.likeCount) {
      return likesText;
    } else if (blog.commentCount) {
      return commentsText;
    } else {
      return null;
    }
  },
  render: function render() {
    if (this.props.isInline) {
      return _jsx("div", {
        className: "featuredContentImageBody--inline genreFeatureContainer"
      }, void 0, this.renderImage(), _jsx("div", {}, void 0, this.renderTitle(), this.renderLikesAndComments(), this.renderReadMore()));
    } else {
      return _jsx("div", {
        className: "featuredContentImageBody genreFeatureContainer"
      }, void 0, this.renderTitle(), this.renderImage(), this.renderLikesAndComments(), this.renderReadMore());
    }
  }
});

},{"../modules/ads/click_tracking_helper":2,"./click_tracking_wrapper":81,"./dot_separated_elements":88,"./gr_component_factory":102,"classnames":"classnames","react":"react"}],94:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _book = require("./book");

var _book2 = _interopRequireDefault(_book);

var _book_description = require("./book_description");

var _book_description2 = _interopRequireDefault(_book_description);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _click_tracking_wrapper = require("./click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _click_tracking_helper = require("../modules/ads/click_tracking_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "FeaturedContentBook",
  propTypes: {
    book: _react2.default.PropTypes.object.isRequired,
    isMobile: _react2.default.PropTypes.bool,
    isInline: _react2.default.PropTypes.bool
  },

  defaultProps: {
    isMobile: false,
    isInline: false
  },

  renderImage: function renderImage() {
    var bookImage = _jsx("img", {
      alt: this.props.book.title,
      src: this.props.book.imageUrl,
      className: (0, _classnames2.default)("featuredContentBook__imageMobile")
    });
    var bodyImage = _jsx("a", {
      href: this.props.book.bookCoverUrl || this.props.book.bookUrl,
      className: (0, _classnames2.default)("featuredContentBook__imageLinkMobile")
    }, void 0, bookImage);
    return _jsx(_click_tracking_wrapper2.default, {
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_book_image,
      children: bodyImage
    });
  },
  renderDescription: function renderDescription() {
    if (this.props.book.description) {
      return _jsx(_book_description2.default, {
        bookDescription: this.props.book.description,
        className: (0, _classnames2.default)("featuredContentBook__description"),
        bookDescriptionTargetingData: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_book_description
      });
    } else {
      return null;
    }
  },
  renderLearnMore: function renderLearnMore() {
    var classesObject = (0, _classnames2.default)("gr-button", "featuredContentBook__button", {
      "featuredContentBook__button--mobile": this.props.isMobile,
      "featuredContentBook__button--inline": this.props.isInline
    });
    var learnMore = _jsx("a", {
      href: this.props.book.bookUrl,
      className: classesObject
    }, void 0, "Learn more");
    return _jsx(_click_tracking_wrapper2.default, {
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_book_button,
      children: learnMore
    });
  },
  render: function render() {
    if (this.props.isMobile) {
      return _jsx("div", {
        className: (0, _classnames2.default)("featuredContentBook", "featuredContentBook--mobile")
      }, void 0, this.renderImage(), this.renderDescription(), this.renderLearnMore());
    } else {
      return _jsx("div", {
        className: "featuredContentBook"
      }, void 0, _react2.default.createElement(
        _book2.default,
        _extends({}, this.props.book, {
          bookImageTrackingData: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_book_image,
          bookTitleTrackingData: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_book_title,
          authorLinkTrackingData: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_book_author }),
        this.renderDescription(),
        this.renderLearnMore()
      ));
    }
  }
});

},{"../modules/ads/click_tracking_helper":2,"./book":72,"./book_description":74,"./click_tracking_wrapper":81,"./gr_component_factory":102,"classnames":"classnames","react":"react"}],95:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _click_tracking_wrapper = require("./click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _click_tracking_helper = require("../modules/ads/click_tracking_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LEARN_MORE = "Learn More";

exports.default = _gr_component_factory2.default.createClass({
  displayName: "FeaturedContentGenre",
  propTypes: {
    genre: _react2.default.PropTypes.shape({
      imageUrl: _react2.default.PropTypes.string.isRequired,
      genreUrl: _react2.default.PropTypes.string.isRequired,
      tagline: _react2.default.PropTypes.string.isRequired
    }).isRequired,
    isMobile: _react2.default.PropTypes.bool,
    isInline: _react2.default.PropTypes.bool
  },

  defaultProps: {
    isMobile: false,
    isInline: false
  },

  renderImage: function renderImage() {
    var imageClassName = (0, _classnames2.default)("featuredContentImageBody__image", {
      featuredContentImageBody__imageMobile: this.props.isMobile
    });
    var linkClassName = (0, _classnames2.default)("featuredContentImageBody__imageLink", {
      "featuredContentImageBody__imageLink--inline": this.props.isInline
    });
    if (this.props.genre.imageUrl) {
      var bodyImage = _jsx("a", {
        className: linkClassName,
        href: this.props.genre.genreUrl
      }, void 0, _jsx("img", {
        className: imageClassName,
        src: this.props.genre.imageUrl,
        alt: "" + this.props.genre.tagline
      }));
      return _jsx(_click_tracking_wrapper2.default, {
        trackingOptions: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_genre_image,
        children: bodyImage
      });
    } else {
      return null;
    }
  },
  renderTitle: function renderTitle() {
    var titleClass = this.props.isMobile ? (0, _classnames2.default)("featuredContentImageBody__title", "featuredContentImageBody__title--mobile") : "featuredContentImageBody__title";
    var titleLink = _jsx("a", {
      href: this.props.genre.genreUrl,
      className: titleClass
    }, void 0, this.props.genre.tagline);
    return _jsx(_click_tracking_wrapper2.default, {
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_genre_title,
      children: titleLink
    });
  },
  renderCTAButton: function renderCTAButton() {
    var ctaLinkClassNames = (0, _classnames2.default)("gr-button gr-microsite-link", { featuredContentImageBody__button: this.props.isMobile,
      "u-marginTopMedium": !this.props.isInline });
    var ctaLink = _jsx("a", {
      href: this.props.genre.genreUrl,
      className: ctaLinkClassNames
    }, void 0, LEARN_MORE);
    return _jsx(_click_tracking_wrapper2.default, {
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_genre_button,
      children: ctaLink
    });
  },
  render: function render() {
    if (this.props.isInline) {
      return _jsx("div", {
        className: "featuredContentImageBody--inline genreFeatureContainer"
      }, void 0, this.renderImage(), _jsx("div", {}, void 0, this.renderTitle(), this.renderCTAButton()));
    } else {
      return _jsx("div", {
        className: "featuredContentImageBody genreFeatureContainer"
      }, void 0, this.renderTitle(), this.renderImage(), this.props.isMobile ? this.renderCTAButton() : null);
    }
  }
});

},{"../modules/ads/click_tracking_helper":2,"./click_tracking_wrapper":81,"./gr_component_factory":102,"classnames":"classnames","react":"react"}],96:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _book = require("./book");

var _book2 = _interopRequireDefault(_book);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _relative_time = require("./time/relative_time");

var _relative_time2 = _interopRequireDefault(_relative_time);

var _expandable_html = require("./user_content/expandable_html");

var _expandable_html2 = _interopRequireDefault(_expandable_html);

var _gr_prop_types = require("./shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _click_tracking_wrapper = require("./click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _click_tracking_helper = require("../modules/ads/click_tracking_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "FeaturedContentGiveaway",
  propTypes: {
    giveaway: _react2.default.PropTypes.shape({
      book: _react2.default.PropTypes.object.isRequired,
      description: _gr_prop_types2.default.expandableHtml().isRequired,
      endAt: _react2.default.PropTypes.string.isRequired,
      giveawayUrl: _react2.default.PropTypes.string.isRequired
    }).isRequired,
    isMobile: _react2.default.PropTypes.bool
  },

  defaultProps: {
    isMobile: false
  },

  render: function render() {
    var giveaway = this.props.giveaway;
    return _jsx("div", {
      className: "featuredContentGiveaway"
    }, void 0, _react2.default.createElement(
      _book2.default,
      _extends({}, giveaway.book, { bookImageTrackingData: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_giveaway_image,
        bookTitleTrackingData: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_giveaway_title,
        authorLinkTrackingData: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_giveaway_author,
        bemModifiers: this.props.isMobile ? "mobile" : "" }),
      _react2.default.createElement(_expandable_html2.default, _extends({}, giveaway.description, { className: "featuredContentGiveaway__description" })),
      _jsx("div", {
        className: "featuredContentGiveaway__expiration gr-metaText"
      }, void 0, "Ends ", _jsx(_relative_time2.default, {
        time: giveaway.endAt,
        longFormat: true
      })),
      _jsx(_click_tracking_wrapper2.default, {
        trackingOptions: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_giveaway_button
      }, void 0, _jsx("a", {
        href: giveaway.giveawayUrl,
        className: "gr-button"
      }, void 0, "Learn more"))
    ));
  }
});

},{"../modules/ads/click_tracking_helper":2,"./book":72,"./click_tracking_wrapper":81,"./gr_component_factory":102,"./shared/gr_prop_types":171,"./time/relative_time":191,"./user_content/expandable_html":195,"react":"react"}],97:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _click_tracking_wrapper = require("./click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _click_tracking_helper = require("../modules/ads/click_tracking_helper");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "FeaturedContentList",
  propTypes: {
    list: _react2.default.PropTypes.shape({
      listUrl: _react2.default.PropTypes.string.isRequired,
      title: _react2.default.PropTypes.string.isRequired,
      topBooksCovers: _react2.default.PropTypes.array.isRequired
    }).isRequired,
    isMobile: _react2.default.PropTypes.bool,
    isInline: _react2.default.PropTypes.bool
  },

  defaultProps: {
    isMobile: false,
    isInline: false
  },

  renderBookCovers: function renderBookCovers() {
    var _this = this;

    var bookCoverImageClassName = this.props.isMobile ? "featuredContentList__bookCoverImage--allowOverlap" : "featuredContentList__bookCoverImage--noOverlap";
    var bookCoverClassName = (0, _classnames2.default)("featuredContentList__bookCovers", { "featuredContentList__bookCovers--inline": this.props.isInline });

    return _jsx("div", {
      className: bookCoverClassName
    }, void 0, _jsx(_click_tracking_wrapper2.default, {
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_list_books
    }, void 0, _jsx("a", {
      href: this.props.list.listUrl
    }, void 0, (0, _lodash.map)(this.props.list.topBooksCovers, function (bookCoverUrl) {
      return _jsx("div", {
        className: "featuredContentList__bookCoverContainer"
      }, bookCoverUrl, _jsx("img", {
        src: bookCoverUrl,
        alt: _this.props.list.title,
        className: bookCoverImageClassName
      }));
    }))));
  },
  renderCTA: function renderCTA() {
    if (this.props.isMobile) {
      return _jsx(_click_tracking_wrapper2.default, {
        trackingOptions: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_list_button
      }, void 0, _jsx("a", {
        className: "gr-button gr-button--fullWidth u-marginBottomSmall u-marginTopSmall",
        href: this.props.list.listUrl
      }, void 0, "View list"));
    } else {
      return null;
    }
  },
  render: function render() {
    var list = this.props.list;
    var fcmListClassNames = (0, _classnames2.default)("featuredContentList", { "featuredContentList--inline": this.props.isInline });
    var fcmListTitleClassNames = (0, _classnames2.default)("u-bold featuredContentList__title", { "featuredContentList__title--inline": this.props.isInline });
    var fcmListDetailsContainerClassNames = (0, _classnames2.default)("u-bold featuredContentList__listDetailsContainer", { "featuredContentList__listDetailsContainer--inline": this.props.isInline });
    var fcmListDetailsClassNames = (0, _classnames2.default)("u-bold featuredContentList__listDetails", { "featuredContentList__listDetails--inline": this.props.isInline });
    return _jsx("div", {
      className: fcmListClassNames
    }, void 0, this.renderBookCovers(), _jsx(_click_tracking_wrapper2.default, {
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_list_title
    }, void 0, _jsx("a", {
      href: list.listUrl,
      className: fcmListTitleClassNames
    }, void 0, list.title)), _jsx("div", {
      className: fcmListDetailsContainerClassNames
    }, void 0, _jsx("div", {
      className: fcmListDetailsClassNames
    }, void 0, list.numBooks.toLocaleString(), " books · ", list.numVoters.toLocaleString(), " voters")), this.renderCTA());
  }
});

},{"../modules/ads/click_tracking_helper":2,"./click_tracking_wrapper":81,"./gr_component_factory":102,"classnames":"classnames","lodash":"lodash","react":"react"}],98:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _featured_content_blog = require("./featured_content_blog");

var _featured_content_blog2 = _interopRequireDefault(_featured_content_blog);

var _featured_content_book = require("./featured_content_book");

var _featured_content_book2 = _interopRequireDefault(_featured_content_book);

var _featured_content_list = require("./featured_content_list");

var _featured_content_list2 = _interopRequireDefault(_featured_content_list);

var _featured_content_genre = require("./featured_content_genre");

var _featured_content_genre2 = _interopRequireDefault(_featured_content_genre);

var _featured_content_giveaway = require("./featured_content_giveaway");

var _featured_content_giveaway2 = _interopRequireDefault(_featured_content_giveaway);

var _sponsored_footer = require("./sponsored_footer");

var _sponsored_footer2 = _interopRequireDefault(_sponsored_footer);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "FeaturedContentModule",
  propTypes: {
    type: _react2.default.PropTypes.string.isRequired,
    resource: _react2.default.PropTypes.object.isRequired,
    sponsorName: _react2.default.PropTypes.string,
    isSponsored: _react2.default.PropTypes.bool,
    isMobile: _react2.default.PropTypes.bool,
    hasBottomBorder: _react2.default.PropTypes.bool,
    isInline: _react2.default.PropTypes.bool
  },

  defaultProps: {
    isMobile: false,
    isInline: false,
    hasBottomBorder: false
  },

  headerText: function headerText() {
    switch (this.props.type) {
      case "Blog":
        return "Featured Blog Post";
      case "Book":
        return "Featured Book";
      case "Giveaway":
        return "Featured Giveaway";
      case "List":
        return "Featured List";
      case "Genre":
        return "Featured Genre";
      default:
        return "Featured Content";
    }
  },
  renderContent: function renderContent() {
    switch (this.props.type) {
      case "Blog":
        return this.renderBlog();
      case "Book":
        return this.renderBook();
      case "Giveaway":
        return this.renderGiveaway();
      case "List":
        return this.renderList();
      case "Genre":
        return this.renderGenre();
      default:
        return null;
    }
  },
  renderHeader: function renderHeader() {
    if (this.props.isMobile) {
      return _jsx("h3", {
        className: "gr-h3"
      }, void 0, this.headerText());
    } else {
      var headerClassNames = (0, _classnames2.default)("featuredContentModule__header", {
        "featuredContentModule__header--inline": this.props.isInline
      });
      return _jsx("div", {
        className: headerClassNames
      }, void 0, this.headerText());
    }
  },
  renderFooter: function renderFooter() {
    if (this.props.isSponsored) {
      return _jsx(_sponsored_footer2.default, {
        isSponsored: true,
        sponsoredName: this.props.sponsorName
      });
    } else {
      return null;
    }
  },
  renderBlog: function renderBlog() {
    return _jsx(_featured_content_blog2.default, {
      blog: this.props.resource,
      isMobile: this.props.isMobile,
      isInline: this.props.isInline
    });
  },
  renderBook: function renderBook() {
    return _jsx(_featured_content_book2.default, {
      book: this.props.resource,
      isMobile: this.props.isMobile,
      isInline: this.props.isInline
    });
  },
  renderGiveaway: function renderGiveaway() {
    return _jsx(_featured_content_giveaway2.default, {
      giveaway: this.props.resource,
      isMobile: this.props.isMobile
    });
  },
  renderList: function renderList() {
    return _jsx(_featured_content_list2.default, {
      list: this.props.resource,
      isMobile: this.props.isMobile,
      isInline: this.props.isInline
    });
  },
  renderGenre: function renderGenre() {
    return _jsx(_featured_content_genre2.default, {
      genre: this.props.resource,
      isMobile: this.props.isMobile,
      isInline: this.props.isInline
    });
  },
  render: function render() {
    var moduleClasses = (0, _classnames2.default)("featuredContentModule", {
      "featuredContentModule--mobile": this.props.isMobile,
      "featuredContentModule--inline": this.props.isInline
    });
    var borderClass = "";
    if (this.props.isMobile) {
      if (this.props.hasBottomBorder) {
        borderClass = "featuredContentBorder__underline";
      } else {
        borderClass = "featuredContentBorder__overline";
      }
    }
    return _jsx("div", {
      className: borderClass
    }, void 0, _jsx("section", {
      className: moduleClasses
    }, void 0, this.renderHeader(), this.renderContent(), this.renderFooter()));
  }
});

},{"./featured_content_blog":93,"./featured_content_book":94,"./featured_content_genre":95,"./featured_content_giveaway":96,"./featured_content_list":97,"./gr_component_factory":102,"./sponsored_footer":187,"classnames":"classnames","react":"react"}],99:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "FlagForAbuseLink",
  propTypes: {
    flagForAbuseUrl: _react2.default.PropTypes.string.isRequired,
    resourceType: _react2.default.PropTypes.string
  },

  render: function render() {
    var flagClasses = (0, _classnames2.default)("gr-metaText", "gr-hyperlink--naked", "gr-hyperlink", "gr-flag");
    var flagTitle = "Flag this " + (this.props.resourceType || "comment") + " as inappropriate.";
    return _jsx("a", {
      href: this.props.flagForAbuseUrl,
      className: flagClasses,
      title: flagTitle
    }, void 0, "Flag");
  }
});

},{"../gr_component_factory":102,"classnames":"classnames","react":"react"}],100:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _close_button = require("./close_button");

var _close_button2 = _interopRequireDefault(_close_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// Should be kept in sync with ApplicationController::FLASH_MESSAGE_TYPES
var validCategories = {
  ERROR: "error",
  INFO: "info",
  NOTICE_DEPRECATED: "notice",
  SUCCESS: "success",
  WARNING: "warning"
};

exports.default = _react2.default.createClass({
  displayName: "FlashMessage",
  propTypes: {
    category: _react2.default.PropTypes.oneOf((0, _lodash.values)(validCategories)),
    message: _react2.default.PropTypes.string.isRequired,
    dismissable: _react2.default.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      undismissable: false
    };
  },
  getInitialState: function getInitialState() {
    return {
      isVisible: true
    };
  },
  componentDidMount: function componentDidMount() {
    // Set focus to the flash message when it mounts so VoiceOver announces it
    if (this.state.isVisible && this.flashMessageRef) {
      this.flashMessageRef.focus();
    }
  },
  hideMessage: function hideMessage() {
    this.setState({ isVisible: false });
  },
  flashMessageMarkup: function flashMessageMarkup() {
    return { __html: this.props.message };
  },
  renderCloseButton: function renderCloseButton() {
    if (!this.props.undismissable) {
      return _jsx(_close_button2.default, {
        action: this.hideMessage,
        className: "gr-flashMessage__dismissButton"
      });
    }
  },
  render: function render() {
    var _this = this;

    var _props = this.props;
    var category = _props.category;
    var message = _props.message;

    var props = _objectWithoutProperties(_props, ["category", "message"]);

    if (!(0, _lodash.isEmpty)(this.props.message)) {
      var cx = (0, _classnames2.default)("gr-flashMessage", {
        "gr-flashMessage--dismissed": !this.state.isVisible,
        "gr-flashMessage--error": category === validCategories.ERROR,
        "gr-flashMessage--info": category === validCategories.INFO,
        "gr-flashMessage--warning": category === validCategories.WARNING,
        "gr-flashMessage--success": category === validCategories.SUCCESS
      });

      return _react2.default.createElement(
        "div",
        { className: cx,
          role: "alert",
          tabIndex: -1,
          ref: function ref(_ref) {
            _this.flashMessageRef = _ref;
          } },
        _jsx("span", {
          dangerouslySetInnerHTML: this.flashMessageMarkup()
        }),
        this.renderCloseButton()
      );
    } else {
      return null;
    }
  }
});

},{"./close_button":82,"classnames":"classnames","lodash":"lodash","react":"react"}],101:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _favorite_genres_form_actions = require("../react_actions/favorite_genres_form_actions");

var _favorite_genres_form_actions2 = _interopRequireDefault(_favorite_genres_form_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "GenreCheckbox",

  propTypes: {
    genre: _react2.default.PropTypes.string,
    isFavorited: _react2.default.PropTypes.bool.isRequired
  },

  onCheckboxChange: function onCheckboxChange() {
    if (this.props.isFavorited) {
      _favorite_genres_form_actions2.default.deselectFavoriteGenre(this.props.genre);
    } else {
      _favorite_genres_form_actions2.default.selectFavoriteGenre(this.props.genre);
    }
  },
  render: function render() {
    var genreLabelClasses = (0, _classnames2.default)("gr-genresForm__genreLabel", { "gr-genresForm__genreLabel--selected": this.props.isFavorited });
    return _jsx("label", {
      className: genreLabelClasses
    }, void 0, _jsx("input", {
      name: "favorites[" + this.props.genre + "]",
      type: "hidden",
      value: "false"
    }), _react2.default.createElement("input", { name: "favorites[" + this.props.genre + "]", type: "checkbox", value: "true",
      "data-genre": this.props.genre, ref: "checkbox",
      defaultChecked: this.props.isFavorited, onChange: this.onCheckboxChange }), _jsx("span", {
      className: "u-verticalAlignMiddle u-marginLeftTiny"
    }, void 0, this.props.genre));
  }
});

},{"../react_actions/favorite_genres_form_actions":32,"./gr_component_factory":102,"classnames":"classnames","react":"react"}],102:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _bem_modifiers = require("../react_mixins/bem_modifiers");

var _bem_modifiers2 = _interopRequireDefault(_bem_modifiers);

var _deploy_service = require("../react_mixins/deploy_service");

var _deploy_service2 = _interopRequireDefault(_deploy_service);

var _reactAddonsPureRenderMixin = require("react-addons-pure-render-mixin");

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _tracking_data_attributes_mixin = require("../react_mixins/tracking_data_attributes_mixin");

var _tracking_data_attributes_mixin2 = _interopRequireDefault(_tracking_data_attributes_mixin);

var _error_message = require("./error_message");

var _error_message2 = _interopRequireDefault(_error_message);

var _env_utils = require("../modules/env_utils");

var _env_utils2 = _interopRequireDefault(_env_utils);

var _gr_error_reporting = require("../modules/gr_error_reporting");

var _gr_error_reporting2 = _interopRequireDefault(_gr_error_reporting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_MIXINS = [_reactAddonsPureRenderMixin2.default, _bem_modifiers2.default, _deploy_service2.default, _tracking_data_attributes_mixin2.default];

/**
 * A factory that creates React class
 *
 * Params:
 * spec: object - React component definition. The definition expects `render`
 * function and `displayName` attribute. If not an error will be thrown.
 * options: {
 *   showErrorMessage: boolean - if true, shows an error message
 * }
 */

var DEFAULT_OPTIONS = {
  showErrorMessage: "production" === _env_utils2.default.DEVELOPMENT
};

var wrapRenderFunction = function wrapRenderFunction(spec, options) {
  var originalRender = spec.render;
  options = (0, _lodash.merge)({}, DEFAULT_OPTIONS, options);
  spec.render = function () {
    try {
      return originalRender.apply(this, arguments);
    } catch (error) {
      _gr_error_reporting2.default.notifyException(error, "Failed to render " + spec.displayName);
      if (options.showErrorMessage) {
        return _jsx(_error_message2.default, {
          componentName: spec.displayName
        });
      } else {
        return null;
      }
    }
  };
};

// throw an error if a valid component name. The component name is useful for debugging.
var validateComponentNameRequired = function validateComponentNameRequired(componentName) {
  if ((0, _lodash.isEmpty)(componentName)) {
    throw new Error("GrError: Missing component name. Please " + "make sure `displayName` attribute is defined while creating a React class " + "using GrComponentFactory.createClass.");
  }
};

var addMixins = function addMixins(spec) {
  var mixins = spec.mixins || [];
  spec.mixins = mixins.concat(DEFAULT_MIXINS);
};

var getComponentSpec = function getComponentSpec(spec, options) {
  addMixins(spec);
  // If we are in a test environment (TEST var set in gulpfile), do not catch
  // rendering errors in components
  if ("production" !== _env_utils2.default.TEST) {
    wrapRenderFunction(spec, options);
  }
  return spec;
};

exports.default = {
  createClass: function createClass(spec) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    validateComponentNameRequired(spec.displayName);
    return _react2.default.createClass(getComponentSpec(spec, options));
  }
};

},{"../modules/env_utils":13,"../modules/gr_error_reporting":15,"../react_mixins/bem_modifiers":224,"../react_mixins/deploy_service":225,"../react_mixins/tracking_data_attributes_mixin":229,"./error_message":91,"lodash":"lodash","react":"react","react-addons-pure-render-mixin":"react-addons-pure-render-mixin"}],103:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           React Component: PreviewBroadcast
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           React Component for previewing group broadcast message, rendered in group/broadcast.html.erb.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           props: previewBroadcastURL - route for group#preview_broadcast
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _modal_trigger = require("../modal_trigger");

var _modal_trigger2 = _interopRequireDefault(_modal_trigger);

var _modal = require("../modal");

var _modal2 = _interopRequireDefault(_modal);

var _spinner = require("../spinner");

var _spinner2 = _interopRequireDefault(_spinner);

var _ajax_helper = require("../../modules/ajax/ajax_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "PreviewBroadcast",

  propTypes: {
    previewBroadcastURL: _react2.default.PropTypes.string.isRequired
  },

  getInitialState: function getInitialState() {
    return { fetching: false };
  },
  requestPreview: function requestPreview(subject, body) {
    var _this = this;

    (0, _ajax_helper.httpRequest)(this.props.previewBroadcastURL, {
      method: "GET",
      data: {
        message: {
          subject: subject,
          body: body
        }
      }
    }).done(function (data) {
      _this.setState({ modalHTML: { __html: data }, fetching: false });
    }).fail(function () {
      _this.setState({ modalHTML: { __html: "<div>There was an error processing your request.</div>" }, fetching: false });
    });
  },

  // gets subject and body, send AJAX request to group#preview_broadcast for GR specific inline html
  // handling. Sets fetching to true to prevent modal from opening before response
  // is received + replaces "preview" link to loading gif.
  handlePreview: function handlePreview() {
    var _this2 = this;

    var body = document.getElementById("message_body").value;
    var subject = document.getElementById("message_subject").value;
    this.setState({ fetching: true }, function () {
      return _this2.requestPreview(subject, body);
    });
  },
  renderModal: function renderModal() {
    if (this.state.fetching) {
      return null;
    } else {
      return _jsx(_modal2.default, {
        id: "previewBroadcast",
        centered: true,
        bemModifiers: "previewBroadcast"
      }, void 0, _jsx("div", {
        className: "modalMessageBox"
      }, void 0, _jsx("h3", {
        className: "modalMessageBox__headerText"
      }, void 0, "Message Preview"), _jsx("div", {
        dangerouslySetInnerHTML: this.state.modalHTML
      })));
    }
  },
  renderModalTrigger: function renderModalTrigger() {
    if (this.state.fetching) {
      return _jsx(_spinner2.default, {
        isSmall: true
      });
    } else {
      return _jsx(_modal_trigger2.default, {
        id: "previewBroadcast"
      }, void 0, _jsx("button", {
        className: "gr-buttonAsLink previewBroadcast__linkText",
        onClick: this.handlePreview
      }, void 0, "(preview)"));
    }
  },
  render: function render() {
    var modal = this.renderModal();
    var modalTrigger = this.renderModalTrigger();
    return _jsx("div", {
      className: "previewBroadcast"
    }, void 0, _jsx("div", {
      className: "previewBroadcast__openPreviewContainer"
    }, void 0, modalTrigger, modal));
  }
});

},{"../../modules/ajax/ajax_helper":4,"../gr_component_factory":102,"../modal":136,"../modal_trigger":137,"../spinner":186,"react":"react"}],104:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

// COMPONENTS

// ACTIONS

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrowseMenu = undefined;

var _react = require("react");

var _lodash = require("lodash");

var _click_and_view_tracking = require("../../modules/click_and_view_tracking");

var _favorite_genres_pane = require("./favorite_genres_pane");

var _favorite_genres_pane2 = _interopRequireDefault(_favorite_genres_pane);

var _featured_genres = require("./featured_genres");

var _featured_genres2 = _interopRequireDefault(_featured_genres);

var _genre_list = require("./genre_list");

var _genre_list2 = _interopRequireDefault(_genre_list);

var _menu_link = require("../menu_link");

var _menu_link2 = _interopRequireDefault(_menu_link);

var _primary_nav_menu = require("./primary_nav_menu");

var _primary_nav_menu2 = _interopRequireDefault(_primary_nav_menu);

var _featured_genres_actions = require("../../react_actions/featured_genres_actions");

var _featured_genres_actions2 = _interopRequireDefault(_featured_genres_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SpotLight = function SpotLight(_ref) {
  var signedIn = _ref.signedIn;
  var favoriteGenres = _ref.favoriteGenres;
  var genres = _ref.genres;

  var classesWithModifier = function classesWithModifier(modifier) {
    return "siteHeader__spotlight siteHeader__spotlight--" + modifier;
  };

  if (signedIn) {
    if (!(0, _lodash.isEmpty)(favoriteGenres)) {
      return _jsx("div", {
        className: classesWithModifier("browseMenu"),
        onClick: function onClick(e) {
          return (0, _click_and_view_tracking.trackNavEngageClick)(e, "Browse_Spotlight");
        }
      }, void 0, _jsx(_featured_genres2.default, {
        favoriteGenres: favoriteGenres
      }));
    } else {
      return _jsx("div", {
        className: classesWithModifier("withoutSubMenu"),
        onClick: function onClick(e) {
          return (0, _click_and_view_tracking.trackNavEngageClick)(e, "Browse_Spotlight");
        }
      }, void 0, _jsx(_favorite_genres_pane2.default, {
        genres: genres
      }));
    }
  } else {
    return _jsx("div", {
      className: classesWithModifier("withoutSubMenu"),
      onClick: function onClick(e) {
        return (0, _click_and_view_tracking.trackNavEngageClick)(e, "Browse_Spotlight");
      }
    }, void 0, _jsx(_genre_list2.default, {
      genres: genres
    }));
  }
};

SpotLight.propTypes = {
  signedIn: _react.PropTypes.bool,
  favoriteGenres: _react.PropTypes.array,
  genres: _react.PropTypes.array.isRequired
};

var BrowseMenu = exports.BrowseMenu = function BrowseMenu(props) {
  return _jsx(_primary_nav_menu2.default, {
    tabName: "siteHeaderBrowseMenu",
    trigger: _jsx("span", {}, void 0, "Browse ▾"),
    fallbackUrl: props.browseUrl,
    bemModifiers: ["siteHeaderBrowseMenu"],
    showingFavoriteGenres: (0, _lodash.isEmpty)(props.favoriteGenres),
    onShowCallback: function onShowCallback() {
      (0, _click_and_view_tracking.trackNavEngage)("BrowseShow");
      _featured_genres_actions2.default.trackMenuImpression();
      _featured_genres_actions2.default.requestFeaturedBooks();
    }
  }, void 0, _jsx("div", {
    className: "siteHeader__browseMenuDropdown"
  }, void 0, _jsx("ul", {
    className: "siteHeader__subNav"
  }, void 0, _jsx(_menu_link2.default, {
    href: props.recommendationsUrl,
    linkText: "Recommendations",
    linkClass: "siteHeader__subNavLink"
  }), _jsx(_menu_link2.default, {
    href: props.choiceAwardsUrl,
    linkText: "Choice Awards",
    linkClass: "siteHeader__subNavLink"
  }), _jsx(_menu_link2.default, {
    href: props.genresIndexUrl,
    linkText: "Genres",
    linkClass: "siteHeader__subNavLink siteHeader__subNavLink--genresIndex"
  }), _jsx(_menu_link2.default, {
    href: props.giveawayUrl,
    linkText: "Giveaways",
    linkClass: "siteHeader__subNavLink"
  }), _jsx(_menu_link2.default, {
    href: props.newReleasesUrl,
    linkText: "New Releases",
    linkClass: "siteHeader__subNavLink"
  }), _jsx(_menu_link2.default, {
    href: props.listUrl,
    linkText: "Lists",
    linkClass: "siteHeader__subNavLink"
  }), _jsx(_menu_link2.default, {
    href: props.exploreUrl,
    linkText: "Explore",
    linkClass: "siteHeader__subNavLink"
  }), _jsx(_menu_link2.default, {
    href: props.newsUrl,
    linkText: "News & Interviews",
    linkClass: "siteHeader__subNavLink"
  })), React.createElement(SpotLight, props)));
};

BrowseMenu.propTypes = {
  adId: _react.PropTypes.string,
  browseUrl: _react.PropTypes.string.isRequired,
  choiceAwardsUrl: _react.PropTypes.string.isRequired,
  genresIndexUrl: _react.PropTypes.string.isRequired,
  exploreUrl: _react.PropTypes.string.isRequired,
  giveawayUrl: _react.PropTypes.string.isRequired,
  listUrl: _react.PropTypes.string.isRequired,
  newReleasesUrl: _react.PropTypes.string.isRequired,
  recommendationsUrl: _react.PropTypes.string.isRequired,
  newsUrl: _react.PropTypes.string.isRequired
};

exports.default = BrowseMenu;

},{"../../modules/click_and_view_tracking":8,"../../react_actions/featured_genres_actions":33,"../menu_link":135,"./favorite_genres_pane":106,"./featured_genres":107,"./genre_list":109,"./primary_nav_menu":118,"lodash":"lodash","react":"react"}],105:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _menu_link = require("../menu_link");

var _menu_link2 = _interopRequireDefault(_menu_link);

var _primary_nav_menu = require("./primary_nav_menu");

var _primary_nav_menu2 = _interopRequireDefault(_primary_nav_menu);

var _click_and_view_tracking = require("../../modules/click_and_view_tracking");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "CommunityMenu",

  propTypes: {
    communityUrl: _react2.default.PropTypes.string.isRequired,
    featuredAskAuthorUrl: _react2.default.PropTypes.string.isRequired,
    groupsUrl: _react2.default.PropTypes.string.isRequired,
    discussionsUrl: _react2.default.PropTypes.string.isRequired,
    quotesUrl: _react2.default.PropTypes.string.isRequired,
    peopleUrl: _react2.default.PropTypes.string
  },

  renderMenuLink: function renderMenuLink(url, linkText) {
    if (url) {
      return _jsx(_menu_link2.default, {
        href: url,
        linkText: linkText,
        linkClass: "siteHeader__subNavLink"
      });
    } else {
      return null;
    }
  },
  render: function render() {
    var communityTrigger = _jsx("span", {}, void 0, "Community ▾");
    return _jsx(_primary_nav_menu2.default, {
      tabName: "siteHeaderCommunityMenu",
      trigger: communityTrigger,
      fallbackUrl: this.props.communityUrl,
      onShowCallback: function onShowCallback() {
        return (0, _click_and_view_tracking.trackNavEngage)("CommunityShow");
      }
    }, void 0, _jsx("ul", {
      className: "siteHeader__subNav"
    }, void 0, this.renderMenuLink(this.props.groupsUrl, "Groups"), this.renderMenuLink(this.props.discussionsUrl, "Discussions"), this.renderMenuLink(this.props.quotesUrl, "Quotes"), this.renderMenuLink(this.props.featuredAskAuthorUrl, "Ask the Author"), this.renderMenuLink(this.props.peopleUrl, "People")));
  }
});

},{"../../modules/click_and_view_tracking":8,"../gr_component_factory":102,"../menu_link":135,"./primary_nav_menu":118,"react":"react","reflux":"reflux"}],106:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _modal_trigger = require("../modal_trigger");

var _modal_trigger2 = _interopRequireDefault(_modal_trigger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "FavoriteGenresPane",

  propTypes: {
    favoriteGenres: _react2.default.PropTypes.array,
    genres: _react2.default.PropTypes.array.isRequired
  },

  render: function render() {
    return _jsx("div", {
      className: "favoriteGenresPane"
    }, void 0, _jsx("div", {
      className: "favoriteGenresPane__title"
    }, void 0, "What do you like to read?"), _jsx("div", {
      className: "favoriteGenresPane__description"
    }, void 0, "Choose your favorite genres to get personalized book recommendations."), _jsx("div", {
      className: "favoriteGenresPane__buttonContainer"
    }, void 0, _jsx(_modal_trigger2.default, {
      id: "favGenres"
    }, void 0, _jsx("button", {
      className: "gr-button gr-button--dark"
    }, void 0, "Choose Favorite Genres"))), _jsx("a", {
      href: "/genres",
      className: "favoriteGenresPane__browseGenres"
    }, void 0, "Browse Genres"));
  }
});

},{"../gr_component_factory":102,"../modal_trigger":137,"react":"react"}],107:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _featured_genres_list = require("./featured_genres_list");

var _featured_genres_list2 = _interopRequireDefault(_featured_genres_list);

var _spinner = require("../spinner");

var _spinner2 = _interopRequireDefault(_spinner);

var _featured_genres_store = require("../../react_stores/featured_genres_store");

var _featured_genres_store2 = _interopRequireDefault(_featured_genres_store);

var _user_agent_capabilities_store = require("../../react_stores/user_agent_capabilities_store");

var _user_agent_capabilities_store2 = _interopRequireDefault(_user_agent_capabilities_store);

var _tab_content = require("./../tab_content");

var _tab_content2 = _interopRequireDefault(_tab_content);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This number should match the $nav-spotlight-min-width variable in
// gr/shared_values/dimensions.scss
var MIN_WIDTH_FOR_SPOTLIGHT_DISPLAY = 1108;

exports.default = _gr_component_factory2.default.createClass({
  displayName: "FeaturedGenres",

  mixins: [_reflux2.default.connect(_featured_genres_store2.default, "featuredGenres"), _reflux2.default.connect(_user_agent_capabilities_store2.default, "userAgentCapabilities")],

  render: function render() {
    if (this.state.featuredGenres.featuredGenreBookInfo) {
      return _jsx("div", {
        className: "featuredGenres"
      }, void 0, _jsx("span", {
        className: "featuredGenres__genreList"
      }, void 0, _jsx(_featured_genres_list2.default, {
        genres: _lodash2.default.pluck(this.state.featuredGenres.featuredGenreBookInfo, "genre")
      })));
    } else if (this.state.featuredGenres.errorMessage) {
      return _jsx("span", {}, void 0, this.state.featuredGenres.errorMessage);
    } else {
      return _jsx("div", {
        className: "featuredGenres featuredGenres--sparse"
      }, void 0, _jsx(_spinner2.default, {}));
    }
  }
});

},{"../../react_stores/featured_genres_store":239,"../../react_stores/user_agent_capabilities_store":251,"../gr_component_factory":102,"../spinner":186,"./../tab_content":190,"./featured_genres_list":108,"lodash":"lodash","reflux":"reflux"}],108:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _dropdown = require("../dropdown");

var _dropdown2 = _interopRequireDefault(_dropdown);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _tab = require("./../tab");

var _tab2 = _interopRequireDefault(_tab);

var _user_agent_capabilities_store = require("../../react_stores/user_agent_capabilities_store");

var _user_agent_capabilities_store2 = _interopRequireDefault(_user_agent_capabilities_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MAX_GENRES = 8;

exports.default = _gr_component_factory2.default.createClass({
  displayName: "FeaturedGenresList",

  mixins: [_reflux2.default.connect(_user_agent_capabilities_store2.default, "userAgentCapabilities")],

  propTypes: {
    adId: _react2.default.PropTypes.string,
    genres: _react2.default.PropTypes.array.isRequired
  },

  onClick: function onClick(ev) {
    ev.preventDefault();
  },
  allGenresLink: function allGenresLink() {
    return _jsx("li", {
      role: "menuitem",
      className: "genreList__genre",
      "aria-label": "All Genres"
    }, "allGenres", _jsx("a", {
      href: "/genres",
      className: "siteHeader__subNavLink"
    }, void 0, "All Genres"));
  },
  renderGenreLink: function renderGenreLink(genre) {
    var cx = (0, _classnames2.default)(["genreList__genreLink", "gr-hyperlink", "gr-hyperlink--naked"]);
    var link = _jsx("a", {
      href: genre.url,
      className: cx
    }, void 0, genre.name);
    if (this.state.userAgentCapabilities.touch === true) {
      return link;
    } else {
      return _jsx(_tab2.default, {
        group: "featuredGenres",
        name: "featuredGenre-" + genre.name,
        triggerEventType: _dropdown2.default.TriggerEventTypes.HOVER
      }, void 0, link);
    }
  },
  renderFavoritesList: function renderFavoritesList() {
    var _this = this;

    var numGenres = MAX_GENRES;
    return _jsx("div", {
      className: "featuredGenres__list genreList genreList--sidebar"
    }, void 0, _jsx("div", {
      className: "siteHeader__title siteHeader__heading"
    }, void 0, _jsx("span", {
      className: "featuredGenres__listTitle"
    }, void 0, "Favorite Genres")), _jsx("ul", {}, void 0, (0, _lodash.map)((0, _lodash.take)(this.props.genres, numGenres), function (genre, index) {
      return _jsx("li", {
        role: "menuitem",
        className: "genreList__genre",
        "aria-label": genre.name
      }, genre.name, _this.renderGenreLink(genre));
    }), this.allGenresLink()));
  },
  render: function render() {
    return _jsx("div", {}, void 0, this.renderFavoritesList());
  }
});

},{"../../react_stores/user_agent_capabilities_store":251,"../dropdown":90,"../gr_component_factory":102,"./../tab":189,"classnames":"classnames","lodash":"lodash","react":"react","reflux":"reflux"}],109:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "GenreList",

  renderMoreGenresLink: function renderMoreGenresLink() {
    return _jsx("li", {
      role: "menuitem",
      className: "genreList__genre"
    }, void 0, _jsx("a", {
      href: "/genres",
      className: "genreList__genreLink gr-hyperlink gr-hyperlink--naked"
    }, void 0, "More Genres"));
  },
  render: function render() {
    var _this = this;

    var GENRES_IN_COLUMN = 10;
    // Generate columns of genres as sub-arrays
    var genreArrays = [];
    var genreCopy = this.props.genres.slice(0);
    while (genreArrays.length * GENRES_IN_COLUMN < this.props.genres.length) {
      genreArrays.push(genreCopy.splice(0, GENRES_IN_COLUMN));
    }
    var columnsCount = genreArrays.length;
    return _jsx("div", {
      className: "genreListContainer"
    }, void 0, _jsx("div", {
      className: "siteHeader__heading siteHeader__title"
    }, void 0, "Genres"), _lodash2.default.map(genreArrays, function (genreList, col) {
      return _jsx("ul", {
        className: "genreList"
      }, "genreList" + col, _lodash2.default.map(genreList, function (genre) {
        return _jsx("li", {
          role: "menuitem",
          className: "genreList__genre"
        }, genre.name, _jsx("a", {
          href: genre.url,
          className: "genreList__genreLink gr-hyperlink gr-hyperlink--naked"
        }, void 0, genre.name));
      }), columnsCount === col + 1 ? _this.renderMoreGenresLink() : null);
    }));
  }
});

},{"../gr_component_factory":102,"lodash":"lodash"}],110:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

// COMPONENTS

// REDUCER

// CONSTANTS

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cookies = require("../shared/cookies");

var _cookies2 = _interopRequireDefault(_cookies);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _redux = require("redux");

var _reactRedux = require("react-redux");

var _reduxLogger = require("redux-logger");

var _reduxLogger2 = _interopRequireDefault(_reduxLogger);

var _lodash = require("lodash");

var _touch_not_ready_helper = require("../../modules/shared/touch_not_ready_helper");

var _click_and_view_tracking = require("../../modules/click_and_view_tracking");

var _favorite_genres_form = require("../favorite_genres_form");

var _favorite_genres_form2 = _interopRequireDefault(_favorite_genres_form);

var _modal = require("../modal");

var _modal2 = _interopRequireDefault(_modal);

var _modal_trigger = require("../modal_trigger");

var _modal_trigger2 = _interopRequireDefault(_modal_trigger);

var _personal_nav = require("./personal_nav");

var _personal_nav2 = _interopRequireDefault(_personal_nav);

var _personal_nav_drawer = require("./personal_nav_drawer");

var _personal_nav_drawer2 = _interopRequireDefault(_personal_nav_drawer);

var _primary_nav_menus = require("./primary_nav_menus");

var _primary_nav_menus2 = _interopRequireDefault(_primary_nav_menus);

var _profile_menu_jewel = require("./profile_menu_jewel");

var _profile_menu_jewel2 = _interopRequireDefault(_profile_menu_jewel);

var _header_logo = require("./header_logo");

var _header_logo2 = _interopRequireDefault(_header_logo);

var _search_toggle = require("../search/search_toggle");

var _search_toggle2 = _interopRequireDefault(_search_toggle);

var _nav_search = require("./nav_search");

var _nav_search2 = _interopRequireDefault(_nav_search);

var _primary_nav_separate_line = require("./primary_nav_separate_line");

var _primary_nav_separate_line2 = _interopRequireDefault(_primary_nav_separate_line);

var _header_reducer = require("../../react_reducers/header/header_reducer");

var _header_reducer2 = _interopRequireDefault(_header_reducer);

var _env_utils = require("../../modules/env_utils");

var _env_utils2 = _interopRequireDefault(_env_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var middlewares = [];
if (_env_utils2.default.isDevelopment() && _env_utils2.default.hasDom()) {
  middlewares.push((0, _reduxLogger2.default)());
}

var store = (0, _redux.createStore)(_header_reducer2.default, {}, _redux.applyMiddleware.apply(undefined, middlewares));

exports.default = _gr_component_factory2.default.createClass({
  displayName: "Header",

  getInitialState: function getInitialState() {
    return { scrolling: false, userLikelyHasAccount: false };
  },

  propTypes: {
    adId: _react2.default.PropTypes.string,
    autocomleteUrl: _react2.default.PropTypes.string,
    browseUrl: _react2.default.PropTypes.string,
    choiceAwardsUrl: _react2.default.PropTypes.string,
    communityUrl: _react2.default.PropTypes.string,
    discussionsUrl: _react2.default.PropTypes.string,
    favoriteGenres: _react2.default.PropTypes.array,
    friendIconUrl: _react2.default.PropTypes.string,
    genres: _react2.default.PropTypes.array.isRequired,
    genresIndexUrl: _react2.default.PropTypes.string,
    exploreUrl: _react2.default.PropTypes.string,
    giveawayUrl: _react2.default.PropTypes.string,
    groupsUrl: _react2.default.PropTypes.string,
    featuredAskAuthorUrl: _react2.default.PropTypes.string,
    helpUrl: _react2.default.PropTypes.string,
    homeUrl: _react2.default.PropTypes.string,
    listUrl: _react2.default.PropTypes.string,
    logo: _react2.default.PropTypes.shape({
      imageUrl: _react2.default.PropTypes.string,
      clickthroughUrl: _react2.default.PropTypes.string,
      altText: _react2.default.PropTypes.string
    }),
    messageIconUrl: _react2.default.PropTypes.string,
    myBooksUrl: _react2.default.PropTypes.string,
    myFriendsUrl: _react2.default.PropTypes.string,
    myGroupsUrl: _react2.default.PropTypes.string,
    myQuotesUrl: _react2.default.PropTypes.string,
    myReadingChallengeUrl: _react2.default.PropTypes.string,
    myRecsUrl: _react2.default.PropTypes.string,
    name: _react2.default.PropTypes.string,
    newReleasesUrl: _react2.default.PropTypes.string,
    notificationIconUrl: _react2.default.PropTypes.string,
    peopleUrl: _react2.default.PropTypes.string,
    preferences: _react2.default.PropTypes.object,
    profileImage: _react2.default.PropTypes.string,
    profileUrl: _react2.default.PropTypes.string,
    quotesUrl: _react2.default.PropTypes.string,
    recommendationsUrl: _react2.default.PropTypes.string,
    signedIn: _react2.default.PropTypes.bool,
    searchPath: _react2.default.PropTypes.string,
    signInUrl: _react2.default.PropTypes.string,
    signInWithReturnUrl: _react2.default.PropTypes.bool,
    signUpUrl: _react2.default.PropTypes.string,
    tempFriendRequestCount: _react2.default.PropTypes.number,
    tempUnreadMessageCount: _react2.default.PropTypes.number,
    topFullImage: _react2.default.PropTypes.shape({
      clickthroughUrl: _react2.default.PropTypes.string,
      altText: _react2.default.PropTypes.string,
      backgroundColor: _react2.default.PropTypes.string,
      xs: _react2.default.PropTypes.object,
      md: _react2.default.PropTypes.object
    })
  },

  componentDidMount: function componentDidMount() {
    // See also ApplicationHelper#set_sign_in_user_cookies
    if (_cookies2.default.get("likely_has_account") === "true") {
      this.setState({ userLikelyHasAccount: true });
    }
  },
  handleScrollBegin: function handleScrollBegin() {
    this.setState({ scrolling: true });
  },
  handleScrollEnd: function handleScrollEnd() {
    this.setState({ scrolling: false });
  },
  handleProfileModalTriggerClick: function handleProfileModalTriggerClick(e) {
    (0, _touch_not_ready_helper.acknowledgeEvent)();
    e.preventDefault();
    (0, _click_and_view_tracking.trackNavEngageClick)(e, "ProfileModalTrigger");
  },
  render: function render() {
    return _jsx(_reactRedux.Provider, {
      store: store
    }, void 0, _jsx("header", {}, void 0, this.renderTopFullImage(), _jsx("div", {
      className: "siteHeader__topLine gr-box gr-box--withShadow"
    }, void 0, _jsx("div", {
      className: "siteHeader__contents"
    }, void 0, _jsx("div", {
      className: "siteHeader__topLevelItem siteHeader__topLevelItem--searchIcon"
    }, void 0, _jsx(_search_toggle2.default, {
      toggleType: _search_toggle.SEARCH_TOGGLE_TYPES.ICON
    })), _react2.default.createElement(_header_logo2.default, this.props.logo), _jsx("nav", {
      className: "siteHeader__primaryNavInline"
    }, void 0, _react2.default.createElement(_primary_nav_menus2.default, this.props)), _react2.default.createElement(_nav_search2.default, this.props), this.props.signedIn ? this.renderPersonalNav() : this.renderLoginLinks(), this.renderProfileDrawerTrigger(), this.renderModals(), this.renderPersonalNavDrawer())), _react2.default.createElement(_primary_nav_separate_line2.default, this.props)));
  },
  renderPersonalNav: function renderPersonalNav() {
    return _jsx("div", {
      className: "siteHeader__personal"
    }, void 0, _react2.default.createElement(_personal_nav2.default, this.props));
  },
  renderPersonalNavDrawer: function renderPersonalNavDrawer() {
    return _react2.default.createElement(_personal_nav_drawer2.default, this.props);
  },
  renderProfileDrawerTrigger: function renderProfileDrawerTrigger() {
    var _this = this;

    if (this.props.signedIn) {
      var user = {
        viewableName: this.props.name,
        profileImage: this.props.profileImage,
        profileUrl: this.props.profileUrl
      };
      return _jsx("div", {
        className: "siteHeader__topLevelItem siteHeader__topLevelItem--profileIcon"
      }, void 0, _jsx("span", {
        className: "headerPersonalNav",
        "data-ux-click": true,
        onClick: function onClick(e) {
          return _this.handleProfileModalTriggerClick(e);
        }
      }, void 0, _jsx(_modal_trigger2.default, {
        id: _personal_nav_drawer.personalNavDrawerModalId
      }, void 0, _react2.default.createElement(_profile_menu_jewel2.default, _extends({}, this.props, { user: user })))));
    } else {
      var buttonClass = (0, _classnames2.default)("gr-button", "gr-button--dark");
      if (this.state.userLikelyHasAccount) {
        return _jsx("div", {
          className: "siteHeader__topLevelItem siteHeader__topLevelItem--signUp"
        }, void 0, _jsx("a", {
          href: this.getSignInUrl(),
          className: buttonClass,
          rel: "nofollow",
          onClick: function onClick(e) {
            return (0, _click_and_view_tracking.trackNavEngageClick)(e, "SignIn");
          }
        }, void 0, "Sign in"));
      } else {
        return _jsx("div", {
          className: "siteHeader__topLevelItem siteHeader__topLevelItem--signUp"
        }, void 0, _jsx("a", {
          href: this.props.signUpUrl,
          className: buttonClass,
          rel: "nofollow",
          onClick: function onClick(e) {
            return (0, _click_and_view_tracking.trackNavEngageClick)(e, "SignUp");
          }
        }, void 0, "Sign up"));
      }
    }
  },
  getSignInUrl: function getSignInUrl() {
    var currentPath = _env_utils2.default.getCurrentPath();
    if (this.props.signInWithReturnUrl) {
      return this.props.signInUrl + "?returnurl=" + currentPath;
    } else {
      return this.props.signInUrl;
    }
  },
  renderLoginLinks: function renderLoginLinks() {
    return _jsx("ul", {
      className: "siteHeader__personal"
    }, void 0, _jsx("li", {
      className: "siteHeader__topLevelItem siteHeader__topLevelItem--signedOut"
    }, void 0, _jsx("a", {
      href: this.getSignInUrl(),
      rel: "nofollow",
      className: "siteHeader__topLevelLink",
      onClick: function onClick(e) {
        return (0, _click_and_view_tracking.trackNavEngageClick)(e, "SignIn");
      }
    }, void 0, "Sign In")), _jsx("li", {
      className: "siteHeader__topLevelItem siteHeader__topLevelItem--signedOut"
    }, void 0, _jsx("a", {
      href: this.props.signUpUrl,
      rel: "nofollow",
      className: "siteHeader__topLevelLink",
      onClick: function onClick(e) {
        return (0, _click_and_view_tracking.trackNavEngageClick)(e, "Join");
      }
    }, void 0, "Join")));
  },
  renderModals: function renderModals() {
    if (this.props.signedIn) {
      return _jsx(_modal2.default, {
        id: "favGenres"
      }, void 0, _jsx(_favorite_genres_form2.default, {
        favoriteGenres: this.props.favoriteGenres,
        genres: this.props.genres
      }));
    } else {
      return null;
    }
  },
  renderTopFullImage: function renderTopFullImage() {
    if (!(0, _lodash.isEmpty)(this.props.topFullImage)) {
      return _jsx("div", {
        className: "siteHeader__topFullImageContainer",
        style: { backgroundColor: this.props.topFullImage.backgroundColor }
      }, void 0, _jsx("a", {
        className: "siteHeader__topFullImageLink",
        href: this.props.topFullImage.clickthroughUrl
      }, void 0, _jsx("picture", {}, void 0, _jsx("source", {
        media: "(min-width: 768px)",
        srcSet: this.props.topFullImage.md["1x"] + " 1x, " + this.props.topFullImage.md["2x"] + " 2x"
      }), _jsx("img", {
        alt: this.props.topFullImage.altText,
        className: "siteHeader__topFullImage",
        src: this.props.topFullImage.xs["1x"],
        srcSet: this.props.topFullImage.xs["2x"] + " 2x"
      }))));
    }
  }
});

},{"../../modules/click_and_view_tracking":8,"../../modules/env_utils":13,"../../modules/shared/touch_not_ready_helper":21,"../../react_reducers/header/header_reducer":231,"../favorite_genres_form":92,"../gr_component_factory":102,"../modal":136,"../modal_trigger":137,"../search/search_toggle":165,"../shared/cookies":170,"./header_logo":111,"./nav_search":113,"./personal_nav":116,"./personal_nav_drawer":117,"./primary_nav_menus":119,"./primary_nav_separate_line":120,"./profile_menu_jewel":122,"classnames":"classnames","lodash":"lodash","react":"react","react-redux":"react-redux","redux":"redux","redux-logger":"redux-logger"}],111:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomDoodleLogo = exports.DefaultLogo = undefined;

var _react = require("react");

var _click_and_view_tracking = require("../../modules/click_and_view_tracking");

var DefaultLogo = exports.DefaultLogo = function DefaultLogo(_ref) {
  var clickthroughUrl = _ref.clickthroughUrl;
  var altText = _ref.altText;
  return _jsx("a", {
    href: clickthroughUrl,
    className: "siteHeader__logo",
    "aria-label": altText,
    title: altText,
    onClick: function onClick(e) {
      return (0, _click_and_view_tracking.trackNavEngageClick)(e, "HeaderLogo");
    }
  });
};

DefaultLogo.propTypes = {
  clickthroughUrl: _react.PropTypes.string,
  altText: _react.PropTypes.string
};

var CustomDoodleLogo = exports.CustomDoodleLogo = function CustomDoodleLogo(_ref2) {
  var imageUrl = _ref2.imageUrl;
  var clickthroughUrl = _ref2.clickthroughUrl;
  var altText = _ref2.altText;
  return _jsx("a", {
    href: clickthroughUrl,
    className: "siteHeader__logo siteHeader__logo--doodle",
    onClick: function onClick(e) {
      return (0, _click_and_view_tracking.trackNavEngageClick)(e, "HeaderLogo");
    }
  }, void 0, _jsx("picture", {}, void 0, _jsx("img", {
    src: imageUrl,
    alt: altText
  })));
};

CustomDoodleLogo.propTypes = _extends({}, DefaultLogo.propTypes, {
  imageUrl: _react.PropTypes.string
});

var HeaderLogo = function HeaderLogo(props) {
  return props.imageUrl ? React.createElement(CustomDoodleLogo, props) : React.createElement(DefaultLogo, props);
};

exports.default = HeaderLogo;

},{"../../modules/click_and_view_tracking":8,"react":"react"}],112:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _header = require("./header");

var _header2 = _interopRequireDefault(_header);

var _current_user_store = require("../../react_stores/current_user_store");

var _current_user_store2 = _interopRequireDefault(_current_user_store);

var _favorite_genres_store = require("../../react_stores/favorite_genres_store");

var _favorite_genres_store2 = _interopRequireDefault(_favorite_genres_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "HeaderStoreConnector",

  mixins: [_reflux2.default.connect(_current_user_store2.default, "currentUser"), _reflux2.default.connect(_favorite_genres_store2.default, "favoriteGenres")],

  render: function render() {
    var currentUser = this.state.currentUser.currentUser;
    var signedIn = !_lodash2.default.isEmpty(currentUser);
    var props = {
      adId: this.state.favoriteGenres.adId,
      signedIn: signedIn,
      genres: this.state.favoriteGenres.allGenres,
      favoriteGenres: this.state.favoriteGenres.favoriteGenres
    };
    if (signedIn) {
      _lodash2.default.merge(props, currentUser);
    }
    _lodash2.default.merge(props, this.props);

    return React.createElement(_header2.default, props);
  }
});

},{"../../react_stores/current_user_store":236,"../../react_stores/favorite_genres_store":238,"../gr_component_factory":102,"./header":110,"lodash":"lodash","reflux":"reflux"}],113:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _url_tracking_params = require("../../analytics/url_tracking_params");

var _env_utils = require("../../modules/env_utils");

var _env_utils2 = _interopRequireDefault(_env_utils);

var _book_search = require("../search/book_search");

var _book_search2 = _interopRequireDefault(_book_search);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({

  displayName: "NavSearch",

  propTypes: {
    autocompleteUrl: _react2.default.PropTypes.string,
    autoFocus: _react2.default.PropTypes.bool,
    searchPath: _react2.default.PropTypes.string,
    bemModifiers: _react2.default.PropTypes.string,
    signedIn: _react2.default.PropTypes.bool,
    mobviousDeviceType: _react2.default.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return { autoFocus: false, bemModifiers: "navbar" };
  },
  onSearchSelection: function onSearchSelection(result) {
    var url = result.bookUrl + "?" + _url_tracking_params.URLTrackingParams.BOOK_SHOW_INTERACTION_PARAM + "&" + _url_tracking_params.URLTrackingParams.FROM_SEARCH_PARAM;
    if (result.qid !== null) {
      url = url.concat("&" + _url_tracking_params.URLTrackingParams.SEARCH_IDENTIFIER_PARAM + "=" + result.qid);
      if (result.rank !== null && result.rank > 0) {
        url = url.concat("&" + _url_tracking_params.URLTrackingParams.SEARCH_RANK_PARAM + "=" + result.rank);
      }
    }
    _env_utils2.default.setLocationUrl(url);
  },
  render: function render() {
    // Note: The BookSearch component is also called by add_book_search, which has a different onChooseResult action.
    //       These should probably be separated into two separate components, with some shared styles and UI logic.
    return _jsx(_book_search2.default, {
      autoFocus: this.props.autoFocus,
      bemModifiers: this.props.bemModifiers,
      searchPath: this.props.searchPath,
      autocompleteUrl: this.props.autocompleteUrl,
      signedIn: this.props.signedIn,
      deviceType: this.props.mobviousDeviceType,
      onChooseResult: this.onSearchSelection
    });
  }
});

},{"../../analytics/url_tracking_params":1,"../../modules/env_utils":13,"../gr_component_factory":102,"../search/book_search":161,"react":"react"}],114:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _lodash = require("lodash");

var _image_registry = require("../../modules/shared/image_registry");

var _to_sentence = require("../../modules/to_sentence");

var _to_sentence2 = _interopRequireDefault(_to_sentence);

var _user_icon = require("../user/user_icon");

var _user_icon2 = _interopRequireDefault(_user_icon);

var _relative_time = require("../time/relative_time");

var _relative_time2 = _interopRequireDefault(_relative_time);

var _shape_icon = require("../shape_icon");

var _shape_icon2 = _interopRequireDefault(_shape_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "Notification",

  mixins: [_to_sentence2.default],

  propTypes: {
    notification: React.PropTypes.object.isRequired
  },

  userLink: function userLink(user, notification) {
    if (notification && notification.resource && typeof notification.resource.url === 'string' && notification.resource.url.toLowerCase().includes("choiceawards")) {
      return _jsx("a", {
        href: user.profileUrl,
        className: "u-defaultType"
      }, user.profileUrl, _jsx("b", {}, void 0));
    } else {
      return _jsx("a", {
        href: user.profileUrl,
        className: "u-defaultType"
      }, user.profileUrl, _jsx("b", {}, void 0, user.viewableName));
    }
  },
  userLinks: function userLinks(notification) {
    var _this = this;

    var userLinks = (0, _lodash.map)(notification.actors, function (user) {
      return _this.userLink(user, notification);
    });
    return notification.moreActors ? this.sentenceJoin(userLinks) : this.toSentence(userLinks);
  },
  renderActorIcon: function renderActorIcon(notification) {
    if (!notification.actor) {
      return _jsx(_shape_icon2.default, {
        imageUrl: (0, _image_registry.getImages)().notificationFromGRIcon || "",
        imageAlt: "Goodreads Notification"
      });
    } else {
      return _jsx(_user_icon2.default, {
        user: notification.actor
      });
    }
  },
  renderNewNotificationFlag: function renderNewNotificationFlag(notification) {
    if (!notification.viewed) {
      return _jsx("small", {
        className: "gr-smallAlert u-marginRightTiny"
      }, void 0, "New");
    }
  },
  renderHistoryMessage: function renderHistoryMessage(notification) {
    if (notification.historyMessage) {
      return _jsx("small", {
        className: "gr-notification__historyMessage"
      }, void 0, notification.historyMessage);
    }
  },
  render: function render() {
    var notification = this.props.notification;

    if (notification.error) {
      return null;
    }

    return _jsx("div", {
      className: "gr-mediaBox gr-notification"
    }, void 0, _jsx("div", {
      className: "gr-mediaBox__media u-marginRightMedium"
    }, void 0, this.renderActorIcon(notification)), _jsx("div", {
      className: "gr-mediaBox__desc u-defaultType"
    }, void 0, this.userLinks(notification), !notification.actor || notification.moreActors ? "" : notification.directlyAddressed ? ", " : " ", notification.body + " ", notification.resource ? _jsx("a", {
      className: "gr-hyperlink",
      href: notification.resource.url
    }, void 0, notification.resource.text) : null, _jsx("div", {}, void 0, this.renderNewNotificationFlag(notification), _jsx("small", {}, void 0, _jsx(_relative_time2.default, {
      time: notification.createdAt,
      longFormat: true
    }))), _jsx("div", {}, void 0, this.renderHistoryMessage(notification))));
  }
});

},{"../../modules/shared/image_registry":20,"../../modules/to_sentence":23,"../gr_component_factory":102,"../shape_icon":166,"../time/relative_time":191,"../user/user_icon":193,"lodash":"lodash"}],115:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _spinner = require("../spinner");

var _spinner2 = _interopRequireDefault(_spinner);

var _dropdown = require("../dropdown");

var _dropdown2 = _interopRequireDefault(_dropdown);

var _notifications_store = require("../../react_stores/notifications_store");

var _notifications_store2 = _interopRequireDefault(_notifications_store);

var _notifications_actions = require("../../react_actions/notifications_actions");

var _notifications_actions2 = _interopRequireDefault(_notifications_actions);

var _notification = require("./notification");

var _notification2 = _interopRequireDefault(_notification);

var _click_and_view_tracking = require("../../modules/click_and_view_tracking");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "Notifications",

  mixins: [_reflux2.default.connect(_notifications_store2.default, "notificationsStore")],

  propTypes: {
    notificationIconUrl: _react2.default.PropTypes.string.isRequired,
    withDropdowns: _react2.default.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return { withDropdowns: true };
  },
  getStoreState: function getStoreState() {
    return this.state.notificationsStore;
  },
  generateKey: function generateKey(notification) {
    if (notification.actor) {
      return "" + notification.actor.profileUrl + notification.createdAt;
    } else if (notification.resource) {
      return "" + notification.resource.url + notification.createdAt;
    } else {
      return "" + notification.body + notification.createdAt;
    }
  },
  notificationsCountString: function notificationsCountString() {
    var state = this.getStoreState();
    return state.unreadCount + (state.unreadCountMore ? "+" : "");
  },
  dropdownShowCallback: function dropdownShowCallback() {
    (0, _click_and_view_tracking.trackNavEngage)("NotificationsShow");
    _notifications_actions2.default.requestNotifications();
  },
  renderNotificationList: function renderNotificationList() {
    var _this = this;

    var state = this.getStoreState();
    var notifications = state.notifications;
    if (state.errorOccurred) {
      return _jsx("div", {
        className: "dropdown__container\n                        gr-notifications\n                        gr-notifications--sparse"
      }, void 0, _jsx("span", {}, void 0, "An error occurred loading your notifications"));
    } else if (_lodash2.default.isUndefined(notifications)) {
      return _jsx("div", {
        className: "dropdown__container\n                        gr-notifications\n                        gr-notifications--sparse"
      }, void 0, _jsx(_spinner2.default, {}));
    } else if (_lodash2.default.isEmpty(notifications)) {
      return _jsx("div", {
        className: "dropdown__container\n                        gr-notifications\n                        gr-notifications--sparse"
      }, void 0, _jsx("span", {}, void 0, "No notifications"));
    } else {
      return _jsx("section", {
        className: "dropdown__container"
      }, void 0, _jsx("a", {
        className: "u-displayBlock gr-hyperlink gr-hyperlink--noUnderline",
        href: "/notifications",
        onClick: function onClick(e) {
          return (0, _click_and_view_tracking.trackNavEngageClick)(e, "Notifications_ViewAll");
        }
      }, void 0, _jsx("div", {
        className: "siteHeader__dropdownHeading"
      }, void 0, _jsx("h3", {
        className: "siteHeader__heading siteHeader__dropdownHeader"
      }, void 0, "Notifications"), _jsx("span", {}, void 0, "View all notifications"))), _jsx("div", {
        className: "gr-notifications gr-box gr-box--forceScrollBar",
        onClick: function onClick(e) {
          return (0, _click_and_view_tracking.trackNavEngageClick)(e, "Notifications_List");
        }
      }, void 0, _lodash2.default.map(notifications, function (notification) {
        return _jsx(_notification2.default, {
          notification: notification
        }, _this.generateKey(notification));
      })));
    }
  },
  render: function render() {
    var _this2 = this;

    var state = this.getStoreState();
    var notificationIcon = _jsx("span", {
      className: "headerPersonalNav__icon\n                       headerPersonalNav__icon--notifications",
      "aria-label": "Notifications"
    }, void 0, state.unreadCount > 0 ? _jsx("span", {
      className: "headerPersonalNav__flag"
    }, void 0, this.notificationsCountString()) : null);

    if (this.props.withDropdowns) {
      return _jsx("div", {}, void 0, _jsx(_dropdown2.default, {
        trigger: notificationIcon,
        triggerEventType: _dropdown2.default.TriggerEventTypes.CLICK,
        fallbackUrl: this.props.notificationIconUrl,
        tooltipText: "Notifications",
        onShowCallback: function onShowCallback() {
          return _this2.dropdownShowCallback();
        },
        bemModifiers: "notifications",
        isInPersonalNav: "true"
      }, void 0, this.renderNotificationList()));
    } else {
      return _jsx("a", {
        href: this.props.notificationIconUrl,
        className: "headerPersonalNav",
        onClick: function onClick(e) {
          return (0, _click_and_view_tracking.trackNavEngageClick)(e, "NotificationsLink");
        }
      }, void 0, notificationIcon);
    }
  }
});

},{"../../modules/click_and_view_tracking":8,"../../react_actions/notifications_actions":39,"../../react_stores/notifications_store":243,"../dropdown":90,"../gr_component_factory":102,"../spinner":186,"./notification":114,"lodash":"lodash","react":"react","reflux":"reflux"}],116:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

// COMPONENTS

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _appendQuery = require("append-query");

var _appendQuery2 = _interopRequireDefault(_appendQuery);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _click_and_view_tracking = require("../../modules/click_and_view_tracking");

var _url_tracking_params = require("../../analytics/url_tracking_params");

var _dropdown = require("../dropdown");

var _dropdown2 = _interopRequireDefault(_dropdown);

var _notifications = require("./notifications");

var _notifications2 = _interopRequireDefault(_notifications);

var _profile_menu = require("./profile_menu");

var _profile_menu2 = _interopRequireDefault(_profile_menu);

var _profile_menu_jewel = require("./profile_menu_jewel");

var _profile_menu_jewel2 = _interopRequireDefault(_profile_menu_jewel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "PersonalNav",

  propTypes: {
    author: _react2.default.PropTypes.shape({
      id: _react2.default.PropTypes.number,
      editProfileUrl: _react2.default.PropTypes.string,
      profileUrl: _react2.default.PropTypes.string,
      dashboardUrl: _react2.default.PropTypes.string,
      listAGiveawayUrl: _react2.default.PropTypes.string
    }),
    commentsUrl: _react2.default.PropTypes.string,
    discussionsUrl: _react2.default.PropTypes.string,
    editFavGenresUrl: _react2.default.PropTypes.string,
    includeProfileMenu: _react2.default.PropTypes.bool,
    groupInvitesCount: _react2.default.PropTypes.number,
    messageIconUrl: _react2.default.PropTypes.string,
    myFriendsUrl: _react2.default.PropTypes.string,
    myQuotesUrl: _react2.default.PropTypes.string,
    myReadingChallengeUrl: _react2.default.PropTypes.string,
    name: _react2.default.PropTypes.string,
    pendingRecsCount: _react2.default.PropTypes.number,
    preferences: _react2.default.PropTypes.object,
    profileEditUrl: _react2.default.PropTypes.string,
    profileImage: _react2.default.PropTypes.string,
    profileUrl: _react2.default.PropTypes.string,
    signOutUrl: _react2.default.PropTypes.string,
    tempFriendRequestCount: _react2.default.PropTypes.number,
    tempUnreadMessageCount: _react2.default.PropTypes.number,
    withDropdowns: _react2.default.PropTypes.bool },

  // Does not affect profile menu. See also includeProfileMenu.
  getDefaultProps: function getDefaultProps() {
    return { includeProfileMenu: true, withDropdowns: true };
  },
  trackClickIncludeDropdownsSuffix: function trackClickIncludeDropdownsSuffix(e, prefix) {
    var trackingFeatureName = this.props.withDropdowns ? prefix + "_WithDropdowns" : prefix + "_WithoutDropdowns";
    (0, _click_and_view_tracking.trackNavEngageClick)(e, trackingFeatureName);
  },
  render: function render() {
    var _this = this;

    var groupDiscussionTrigger = _jsx("span", {
      className: "headerPersonalNav__icon headerPersonalNav__icon--discussions",
      "aria-label": "My group discussions"
    }, void 0);
    var messageTrigger = _jsx("span", {
      className: "headerPersonalNav__icon headerPersonalNav__icon--inbox",
      "aria-label": "Inbox"
    }, void 0, this.props.tempUnreadMessageCount > 0 ? _jsx("span", {
      className: "headerPersonalNav__flag"
    }, void 0, this.props.tempUnreadMessageCount) : null);

    var friendRequestTrigger = _jsx("span", {
      className: "headerPersonalNav__icon headerPersonalNav__icon--friendRequests",
      "aria-label": "Friend Requests"
    }, void 0, this.props.tempFriendRequestCount > 0 ? _jsx("span", {
      className: "headerPersonalNav__flag"
    }, void 0, this.props.tempFriendRequestCount) : null);

    return _jsx("ul", {
      className: "personalNav"
    }, void 0, _jsx("li", {
      className: "personalNav__listItem"
    }, void 0, this.renderNotifications()), _jsx("li", {
      className: "personalNav__listItem",
      onClick: function onClick(e) {
        return (0, _click_and_view_tracking.trackNavEngageClick)(e, "DiscussionsLink");
      }
    }, void 0, _jsx("a", {
      href: (0, _appendQuery2.default)(this.props.discussionsUrl, { discussion_filter: "groups",
        ref: _url_tracking_params.URLTrackingParams.DISCUSSIONS_PANE_DISCUSSION }),
      title: "My group discussions",
      className: "headerPersonalNav"
    }, void 0, groupDiscussionTrigger)), _jsx("li", {
      className: "personalNav__listItem",
      onClick: function onClick(e) {
        return _this.trackClickIncludeDropdownsSuffix(e, "MessagesLink");
      }
    }, void 0, _jsx("a", {
      href: this.props.messageIconUrl,
      title: "Messages",
      className: "headerPersonalNav"
    }, void 0, messageTrigger)), _jsx("li", {
      className: "personalNav__listItem",
      onClick: function onClick(e) {
        return _this.trackClickIncludeDropdownsSuffix(e, "FriendsLink");
      }
    }, void 0, _jsx("a", {
      href: this.props.friendIconUrl,
      title: "Friends",
      className: "headerPersonalNav"
    }, void 0, friendRequestTrigger)), this.renderProfileMenu());
  },
  renderNotifications: function renderNotifications() {
    return _jsx(_notifications2.default, {
      notificationIconUrl: this.props.notificationIconUrl,
      preferences: this.props.preferences,
      withDropdowns: this.props.withDropdowns
    });
  },
  renderProfileName: function renderProfileName() {
    // limit of 23 characters is about the width of the dropdown menu
    // visually approved by @ericf and @ohyes
    var name = this.props.name;
    if (name.length > 23) {
      name = name.substring(0, 22) + "…";
    }
    return _jsx("span", {
      className: "siteHeader__subNavLink gr-h3 gr-h3--noMargin"
    }, void 0, " ", name, " ");
  },
  renderProfileMenu: function renderProfileMenu() {
    if (this.props.includeProfileMenu === true) {
      var user = { viewableName: this.props.name,
        profileImage: this.props.profileImage,
        profileUrl: this.props.profileUrl };
      var profileIcon = _react2.default.createElement(_profile_menu_jewel2.default, _extends({}, this.props, { user: user, showNotificationsFlag: false }));
      var profileUrl = _lodash2.default.size(this.props.author) === 0 ? this.props.profileUrl : this.props.author.profileUrl;

      return _jsx("li", {
        className: "personalNav__listItem"
      }, void 0, _jsx(_dropdown2.default, {
        trigger: profileIcon,
        fallbackUrl: profileUrl,
        bemModifiers: "profileMenu",
        isInPersonalNav: "true",
        onShowCallback: function onShowCallback() {
          return (0, _click_and_view_tracking.trackNavEngage)("ProfileShow");
        }
      }, void 0, _jsx("div", {
        className: "siteHeader__subNav siteHeader__subNav--profile gr-box gr-box--withShadowLarge"
      }, void 0, this.renderProfileName(), _react2.default.createElement(_profile_menu2.default, _extends({}, this.props, { profileUrl: profileUrl })))));
    } else {
      return null;
    }
  }
});

},{"../../analytics/url_tracking_params":1,"../../modules/click_and_view_tracking":8,"../dropdown":90,"../gr_component_factory":102,"./notifications":115,"./profile_menu":121,"./profile_menu_jewel":122,"append-query":"append-query","lodash":"lodash","react":"react"}],117:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.personalNavDrawerModalId = undefined;

var _modal = require("../modal");

var _modal2 = _interopRequireDefault(_modal);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _personal_nav = require("./personal_nav");

var _personal_nav2 = _interopRequireDefault(_personal_nav);

var _profile_menu = require("./profile_menu");

var _profile_menu2 = _interopRequireDefault(_profile_menu);

var _user_icon = require("../user/user_icon");

var _user_icon2 = _interopRequireDefault(_user_icon);

var _shape_icon_values = require("../../modules/shape_icon_values");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var personalNavDrawerModalId = exports.personalNavDrawerModalId = "personalNavDrawerModal";

exports.default = _gr_component_factory2.default.createClass({
  displayName: "PersonalNavDrawer",

  render: function render() {
    var userIconUserProp = { viewableName: this.props.name,
      profileImage: this.props.profileImage,
      profileUrl: this.props.profileUrl };
    return _jsx(_modal2.default, {
      asDrawer: true,
      id: personalNavDrawerModalId
    }, void 0, _jsx("div", {
      className: "personalNavDrawer"
    }, void 0, _jsx("div", {
      className: "personalNavDrawer__personalNavContainer"
    }, void 0, React.createElement(_personal_nav2.default, _extends({}, this.props, {
      includeProfileMenu: false,
      withDropdowns: false }))), _jsx("div", {
      className: "personalNavDrawer__profileAndLinksContainer"
    }, void 0, _jsx("div", {
      className: "personalNavDrawer__profileContainer gr-mediaFlexbox gr-mediaFlexbox--alignItemsCenter"
    }, void 0, _jsx("div", {
      className: "gr-mediaFlexbox__media"
    }, void 0, _jsx(_user_icon2.default, {
      user: userIconUserProp,
      size: _shape_icon_values.ICON_SIZES.LARGE
    })), _jsx("div", {
      className: "gr-mediaFlexbox__desc"
    }, void 0, _jsx("a", {
      href: this.props.profileUrl,
      className: "gr-hyperlink gr-hyperlink--bold"
    }, void 0, this.props.name), _jsx("div", {
      className: "u-displayBlock"
    }, void 0, _jsx("a", {
      href: this.props.profileUrl,
      className: "gr-hyperlink gr-hyperlink--naked"
    }, void 0, "View profile")))), _jsx("div", {
      className: "personalNavDrawer__profileMenuContainer"
    }, void 0, React.createElement(_profile_menu2.default, this.props)))));
  }
});

},{"../../modules/shape_icon_values":19,"../gr_component_factory":102,"../modal":136,"../user/user_icon":193,"./personal_nav":116,"./profile_menu":121}],118:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Component to implement the "Browse" and "Community" menus in the responsive
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           navbar, and possibly other similar menus in the future.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Requires a "tabName" prop, similar to the "name" prop of Tab, to identify this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           menu among all navbar menus.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Originally forked from Dropdown.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRIMARY_NAV_MENU_TAB_GROUP = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactOnclickoutside = require("react-onclickoutside");

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _keys = require("../../modules/keys");

var _keys2 = _interopRequireDefault(_keys);

var _tab_actions = require("../../react_actions/tab_actions");

var _tab_actions2 = _interopRequireDefault(_tab_actions);

var _tabs_store = require("../../react_stores/tabs_store");

var _tabs_store2 = _interopRequireDefault(_tabs_store);

var _user_agent_capabilities_store = require("../../react_stores/user_agent_capabilities_store");

var _user_agent_capabilities_store2 = _interopRequireDefault(_user_agent_capabilities_store);

var _touch_not_ready_helper = require("../../modules/shared/touch_not_ready_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PRIMARY_NAV_MENU_TAB_GROUP = exports.PRIMARY_NAV_MENU_TAB_GROUP = "siteHeaderPrimaryNav";

exports.default = _gr_component_factory2.default.createClass({
  displayName: "Dropdown",

  mixins: [_reactOnclickoutside2.default, _reflux2.default.connect(_tabs_store2.default, "tabsStore"), _reflux2.default.connect(_user_agent_capabilities_store2.default, "userAgentCapabilities")],

  propTypes: {
    fallbackUrl: _react2.default.PropTypes.string,
    onShowCallback: _react2.default.PropTypes.func,
    tabName: _react2.default.PropTypes.string.isRequired,
    tooltipText: _react2.default.PropTypes.string,
    showingFavoriteGenres: _react2.default.PropTypes.bool,
    trigger: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.element]).isRequired
  },

  hide: function hide() {
    _tab_actions2.default.deselectTab(this.props.tabName, PRIMARY_NAV_MENU_TAB_GROUP);
  },
  isMenuActive: function isMenuActive() {
    return this.props.tabName === this.state.tabsStore[PRIMARY_NAV_MENU_TAB_GROUP];
  },
  show: function show() {
    _tab_actions2.default.selectTab(this.props.tabName, PRIMARY_NAV_MENU_TAB_GROUP);
    if (this.props.onShowCallback) {
      this.props.onShowCallback();
    }
  },
  toggle: function toggle(ev) {
    (0, _touch_not_ready_helper.acknowledgeEvent)(ev);
    if (this.props.children) {
      ev.preventDefault();
    }
    this.isMenuActive() ? this.hide() : this.show();
  },
  openList: function openList(ev) {
    if (_keys2.default.isDropdownOpenerKey(ev.keyCode)) {
      ev.preventDefault();
      if (_keys2.default.isArrowDown(ev.keyCode)) {
        this.show();
      } else {
        this.toggle(ev);
      }
    } else if (_keys2.default.isDefaultCloserKey(ev.keyCode)) {
      ev.preventDefault();
      this.hide();
    }
  },
  handleClickOutside: function handleClickOutside() {
    // On touch devices that display dropdown components, touch gestures such as
    // panning and zooming trigger this event listener. We disabled hiding in
    // this listener for touch devices because hiding the dropdown on touch
    // gestures is disruptive.
    if (!this.state.userAgentCapabilities.touch) {
      this.hide();
    }
  },
  triggerClasses: function triggerClasses() {
    return (0, _classnames2.default)(this.withBemModifiers(["primaryNavMenu__trigger"]), { "primaryNavMenu__trigger--buttonReset": _lodash2.default.isUndefined(this.props.fallbackUrl) }, { "primaryNavMenu__trigger--active": this.isMenuActive() });
  },
  renderTriggerButton: function renderTriggerButton() {
    return _jsx("button", {
      className: this.triggerClasses(),
      "aria-haspopup": "true",
      "aria-expanded": this.isMenuActive(),
      onClick: this.toggle,
      onKeyDown: this.openList,
      title: this.props.tooltipText,
      "data-ux-click": true
    }, void 0, this.props.trigger);
  },
  renderTriggerLink: function renderTriggerLink() {
    return _jsx("a", {
      className: this.triggerClasses(),
      href: this.props.fallbackUrl,
      onClick: this.toggle,
      onKeyDown: this.openList,
      role: "button",
      "aria-haspopup": "true",
      "aria-expanded": this.isMenuActive(),
      title: this.props.tooltipText,
      "data-ux-click": true
    }, void 0, this.props.trigger);
  },
  render: function render() {
    /* Setting "ignore-react-onclickoutside" prevents a bug I was seeing where
       the menu was closing unexpectedly when clicking on the menu. (Should
       only close on clicks outside.) This *shouldn't* be necessary, but it
       fixes the problem, so I am going to run with it.
       Ref: https://github.com/Pomax/react-onclickoutside/tree/v4.5.0#marking-elements-as-skip-over-this-one-during-the-event-loop */
    var dropdownClasses = (0, _classnames2.default)(this.withBemModifiers("primaryNavMenu"), "ignore-react-onclickoutside");

    var dropdownContentsClasses = (0, _classnames2.default)("primaryNavMenu__menu", { "primaryNavMenu__menu--show": this.isMenuActive() }, "gr-box gr-box--withShadowLarge", { "wide": this.props.showingFavoriteGenres });

    var trigger = _lodash2.default.isUndefined(this.props.fallbackUrl) ? this.renderTriggerButton() : this.renderTriggerLink();
    var dropdownContents = _jsx("div", {
      className: dropdownContentsClasses,
      role: "menu"
    }, void 0, this.props.children);

    return _jsx("div", {
      className: dropdownClasses
    }, void 0, trigger, dropdownContents);
  }
});

},{"../../modules/keys":16,"../../modules/shared/touch_not_ready_helper":21,"../../react_actions/tab_actions":44,"../../react_stores/tabs_store":248,"../../react_stores/user_agent_capabilities_store":251,"../gr_component_factory":102,"classnames":"classnames","lodash":"lodash","react":"react","react-onclickoutside":"react-onclickoutside","reflux":"reflux"}],119:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

// COMPONENTS

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _click_and_view_tracking = require("../../modules/click_and_view_tracking");

var _community_menu = require("./community_menu");

var _community_menu2 = _interopRequireDefault(_community_menu);

var _browse_menu = require("./browse_menu");

var _browse_menu2 = _interopRequireDefault(_browse_menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "PrimaryNavMenus",

  propTypes: {
    adId: _react2.default.PropTypes.string,
    browseUrl: _react2.default.PropTypes.string,
    choiceAwardsUrl: _react2.default.PropTypes.string,
    communityUrl: _react2.default.PropTypes.string,
    discussionsUrl: _react2.default.PropTypes.string,
    favoriteGenres: _react2.default.PropTypes.array,
    featuredAskAuthorUrl: _react2.default.PropTypes.string,
    genres: _react2.default.PropTypes.array.isRequired,
    giveawayUrl: _react2.default.PropTypes.string,
    exploreUrl: _react2.default.PropTypes.string,
    groupsUrl: _react2.default.PropTypes.string,
    homeUrl: _react2.default.PropTypes.string,
    listUrl: _react2.default.PropTypes.string,
    myBooksUrl: _react2.default.PropTypes.string,
    newReleasesUrl: _react2.default.PropTypes.string,
    peopleUrl: _react2.default.PropTypes.string,
    quotesUrl: _react2.default.PropTypes.string,
    recommendationsUrl: _react2.default.PropTypes.string,
    signedIn: _react2.default.PropTypes.bool
  },

  render: function render() {
    return _jsx("ul", {
      role: "menu",
      className: "siteHeader__menuList"
    }, void 0, _jsx("li", {
      className: "siteHeader__topLevelItem siteHeader__topLevelItem--home",
      onClick: function onClick(e) {
        return (0, _click_and_view_tracking.trackNavEngageClick)(e, "Home");
      }
    }, void 0, _jsx("a", {
      href: this.props.homeUrl,
      className: "siteHeader__topLevelLink"
    }, void 0, "Home")), _jsx("li", {
      className: "siteHeader__topLevelItem",
      onClick: function onClick(e) {
        return (0, _click_and_view_tracking.trackNavEngageClick)(e, "MyBooks");
      }
    }, void 0, _jsx("a", {
      href: this.props.myBooksUrl,
      className: "siteHeader__topLevelLink"
    }, void 0, "My Books")), _jsx("li", {
      className: "siteHeader__topLevelItem"
    }, void 0, _react2.default.createElement(_browse_menu2.default, this.props)), _jsx("li", {
      className: "siteHeader__topLevelItem siteHeader__topLevelItem--community"
    }, void 0, _react2.default.createElement(_community_menu2.default, this.props)));
  }
});

},{"../../modules/click_and_view_tracking":8,"../gr_component_factory":102,"./browse_menu":104,"./community_menu":105,"react":"react"}],120:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports.component = undefined;

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _primary_nav_menus = require("./primary_nav_menus");

var _primary_nav_menus2 = _interopRequireDefault(_primary_nav_menus);

var _reactHeadroom = require("react-headroom");

var _reactHeadroom2 = _interopRequireDefault(_reactHeadroom);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _search_mobile_nav = require("../search/search_mobile_nav");

var _search_mobile_nav2 = _interopRequireDefault(_search_mobile_nav);

var _tabs_store = require("../../react_stores/tabs_store");

var _tabs_store2 = _interopRequireDefault(_tabs_store);

var _reactRedux = require("react-redux");

var _primary_nav_menu = require("./primary_nav_menu");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var component = exports.component = _gr_component_factory2.default.createClass({
  displayName: "PrimaryNavSeparateLine",

  mixins: [_reflux2.default.connect(_tabs_store2.default, "tabs")],

  propTypes: {
    autocompleteUrl: _react2.default.PropTypes.string.isRequired,
    searchPath: _react2.default.PropTypes.string.isRequired,
    signedIn: _react2.default.PropTypes.bool.isRequired,
    mobviousDeviceType: _react2.default.PropTypes.string,
    searchIsActive: _react2.default.PropTypes.bool,
    adId: _react2.default.PropTypes.string,
    browseUrl: _react2.default.PropTypes.string,
    choiceAwardsUrl: _react2.default.PropTypes.string,
    communityUrl: _react2.default.PropTypes.string,
    discussionsUrl: _react2.default.PropTypes.string,
    favoriteGenres: _react2.default.PropTypes.array,
    featuredAskAuthorUrl: _react2.default.PropTypes.string,
    genres: _react2.default.PropTypes.array.isRequired,
    giveawayUrl: _react2.default.PropTypes.string,
    groupsUrl: _react2.default.PropTypes.string,
    homeUrl: _react2.default.PropTypes.string,
    exploreUrl: _react2.default.PropTypes.string,
    listUrl: _react2.default.PropTypes.string,
    myBooksUrl: _react2.default.PropTypes.string,
    newReleasesUrl: _react2.default.PropTypes.string,
    peopleUrl: _react2.default.PropTypes.string,
    quotesUrl: _react2.default.PropTypes.string,
    recommendationsUrl: _react2.default.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return { searchIsActive: false };
  },
  isNavPinned: function isNavPinned() {
    // Keep the navbar visible if search or a menu is open
    return this.props.searchIsActive || !_lodash2.default.isEmpty(this.state.tabs[_primary_nav_menu.PRIMARY_NAV_MENU_TAB_GROUP]);
  },
  renderDefaultSeparateLine: function renderDefaultSeparateLine() {
    return _jsx("nav", {
      className: "siteHeader__primaryNavSeparateLine gr-box gr-box--withShadow"
    }, void 0, _react2.default.createElement(_primary_nav_menus2.default, this.props));
  },
  renderSearch: function renderSearch() {
    return _react2.default.createElement(_search_mobile_nav2.default, this.props);
  },
  render: function render() {
    return _jsx(_reactHeadroom2.default, {
      disable: this.isNavPinned()
    }, void 0, this.props.searchIsActive ? this.renderSearch() : this.renderDefaultSeparateLine());
  }
});

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return Object.assign({}, ownProps, state);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(component);

},{"../../react_stores/tabs_store":248,"../gr_component_factory":102,"../search/search_mobile_nav":164,"./primary_nav_menu":118,"./primary_nav_menus":119,"lodash":"lodash","react":"react","react-headroom":"react-headroom","react-redux":"react-redux","reflux":"reflux"}],121:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();
// COMPONENTS

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _click_and_view_tracking = require("../../modules/click_and_view_tracking");

var _menu_link = require("../menu_link");

var _menu_link2 = _interopRequireDefault(_menu_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ProfileMenu",

  propTypes: {
    author: _react2.default.PropTypes.shape({
      id: _react2.default.PropTypes.number,
      editProfileUrl: _react2.default.PropTypes.string,
      profileUrl: _react2.default.PropTypes.string,
      dashboardUrl: _react2.default.PropTypes.string,
      listAGiveawayUrl: _react2.default.PropTypes.string
    }),
    commentsUrl: _react2.default.PropTypes.string,
    discussionsUrl: _react2.default.PropTypes.string,
    editFavGenresUrl: _react2.default.PropTypes.string,
    groupInvitesCount: _react2.default.PropTypes.number,
    helpUrl: _react2.default.PropTypes.string,
    myFriendsUrl: _react2.default.PropTypes.string,
    myGroupsUrl: _react2.default.PropTypes.string,
    myQuotesUrl: _react2.default.PropTypes.string,
    myReadingChallengeUrl: _react2.default.PropTypes.string,
    myRecsUrl: _react2.default.PropTypes.string,
    name: _react2.default.PropTypes.string,
    pendingRecsCount: _react2.default.PropTypes.number,
    profileEditUrl: _react2.default.PropTypes.string,
    profileUrl: _react2.default.PropTypes.string,
    readingNotesUrl: _react2.default.PropTypes.string,
    signOutUrl: _react2.default.PropTypes.string
  },

  isAuthor: function isAuthor() {
    return !_lodash2.default.isUndefined(this.props.author);
  },
  groupInvitesMessage: function groupInvitesMessage() {
    var invitesCount = this.props.groupInvitesCount;
    if (invitesCount === 0) {
      return "No invitations";
    } else if (invitesCount === 1) {
      return "1 invitation";
    } else {
      return invitesCount + " invitations";
    }
  },
  renderGroupInvites: function renderGroupInvites() {
    if (this.props.groupInvitesCount > 0) {
      return _jsx("span", {
        className: "gr-smallAlert u-marginLeftXSmall"
      }, void 0, this.groupInvitesMessage());
    }
  },
  renderPendingRecs: function renderPendingRecs() {
    if (this.props.pendingRecsCount > 0) {
      return _jsx("span", {
        className: "gr-smallAlert u-marginLeftXSmall"
      }, void 0, this.props.pendingRecsCount + " new");
    }
  },
  renderAuthorDashboardLink: function renderAuthorDashboardLink() {
    if (this.isAuthor()) {
      return _jsx(_menu_link2.default, {
        href: this.props.author.dashboardUrl,
        linkText: "Author Dashboard",
        linkClass: "siteHeader__subNavLink"
      });
    }
  },
  renderListAGiveawayLink: function renderListAGiveawayLink() {
    if (this.isAuthor()) {
      return _jsx(_menu_link2.default, {
        href: this.props.author.listAGiveawayUrl,
        linkText: "List a Giveaway",
        linkClass: "siteHeader__subNavLink"
      });
    }
  },
  render: function render() {
    var editProfileUrl = !this.isAuthor() ? this.props.profileEditUrl : this.props.author.editProfileUrl;

    return _jsx("ul", {}, void 0, _jsx(_menu_link2.default, {
      linkText: "Profile"
    }, void 0, _jsx("a", {
      href: this.props.profileUrl,
      className: "siteHeader__subNavLink",
      onClick: function onClick(e) {
        return (0, _click_and_view_tracking.trackNavEngageClick)(e, _menu_link.MENU_LINK_TRACKING_PREFIX + "_Profile");
      }
    }, void 0, "Profile")), this.renderAuthorDashboardLink(), this.renderListAGiveawayLink(), _jsx(_menu_link2.default, {
      href: this.props.myFriendsUrl,
      linkText: "Friends",
      linkClass: "siteHeader__subNavLink"
    }), _jsx(_menu_link2.default, {
      linkText: "Groups"
    }, void 0, _jsx("a", {
      href: this.props.myGroupsUrl,
      className: "siteHeader__subNavLink",
      onClick: function onClick(e) {
        return (0, _click_and_view_tracking.trackNavEngageClick)(e, _menu_link.MENU_LINK_TRACKING_PREFIX + "_MyGroups");
      }
    }, void 0, "Groups", this.renderGroupInvites())), _jsx(_menu_link2.default, {
      href: this.props.discussionsUrl,
      linkText: "Discussions",
      linkClass: "siteHeader__subNavLink"
    }), _jsx(_menu_link2.default, {
      href: this.props.commentsUrl,
      linkText: "Comments",
      linkClass: "siteHeader__subNavLink"
    }), _jsx(_menu_link2.default, {
      href: this.props.myReadingChallengeUrl,
      linkText: "Reading Challenge",
      linkClass: "siteHeader__subNavLink"
    }), _jsx(_menu_link2.default, {
      href: this.props.readingNotesUrl,
      linkText: "Kindle Notes & Highlights",
      linkClass: "siteHeader__subNavLink"
    }), _jsx(_menu_link2.default, {
      href: this.props.myQuotesUrl,
      linkText: "Quotes",
      linkClass: "siteHeader__subNavLink"
    }), _jsx(_menu_link2.default, {
      href: this.props.editFavGenresUrl,
      linkText: "Favorite genres",
      linkClass: "siteHeader__subNavLink"
    }), _jsx(_menu_link2.default, {
      linkText: "Friends' recommendations"
    }, void 0, _jsx("a", {
      href: this.props.myRecsUrl,
      className: "siteHeader__subNavLink",
      onClick: function onClick(e) {
        return (0, _click_and_view_tracking.trackNavEngageClick)(e, _menu_link.MENU_LINK_TRACKING_PREFIX + "_FriendsRecommendations");
      }
    }, void 0, "Friends’ recommendations", this.renderPendingRecs())), _jsx(_menu_link2.default, {
      href: editProfileUrl,
      linkText: "Account settings",
      linkClass: "siteHeader__subNavLink u-topGrayBorder"
    }), _jsx(_menu_link2.default, {
      href: this.props.helpUrl,
      linkText: "Help",
      linkClass: "siteHeader__subNavLink"
    }), _jsx(_menu_link2.default, {
      href: this.props.signOutUrl,
      linkText: "Sign out",
      linkClass: "siteHeader__subNavLink",
      method: "POST"
    }));
  }
});

},{"../../modules/click_and_view_tracking":8,"../gr_component_factory":102,"../menu_link":135,"lodash":"lodash","react":"react"}],122:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _notifications_store = require("../../react_stores/notifications_store");

var _notifications_store2 = _interopRequireDefault(_notifications_store);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _user_icon = require("../user/user_icon");

var _user_icon2 = _interopRequireDefault(_user_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ProfileMenuJewel",

  mixins: [_reflux2.default.connect(_notifications_store2.default, "notificationsStore")],

  propTypes: {
    notificationIconUrl: _react2.default.PropTypes.string,
    showNotificationsFlag: _react2.default.PropTypes.bool,
    tempFriendRequestCount: _react2.default.PropTypes.number,
    tempUnreadMessageCount: _react2.default.PropTypes.number,
    user: _react2.default.PropTypes.shape({
      viewableName: _react2.default.PropTypes.string.isRequired,
      profileImage: _react2.default.PropTypes.string.isRequired,
      profileUrl: _react2.default.PropTypes.string
    }).isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      showNotificationsFlag: true,
      tempFriendRequestCount: 0,
      tempUnreadMessageCount: 0
    };
  },
  notificationsCountString: function notificationsCountString() {
    var state = this.state.notificationsStore;
    return state.unreadCount + this.props.tempFriendRequestCount + this.props.tempUnreadMessageCount + (state.unreadCountMore ? "+" : "");
  },
  render: function render() {
    return _jsx("span", {
      className: "headerPersonalNav__icon"
    }, void 0, this.renderNotificationsCountFlag(), _jsx(_user_icon2.default, {
      user: this.props.user,
      includeLink: false
    }));
  },
  renderNotificationsCountFlag: function renderNotificationsCountFlag() {
    if (this.props.showNotificationsFlag === true) {
      if (this.state.notificationsStore.unreadCount > 0 || this.props.tempFriendRequestCount > 0 || this.props.tempUnreadMessageCount > 0) {
        return _jsx("span", {
          className: "headerPersonalNav__flag"
        }, void 0, this.notificationsCountString());
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
});

},{"../../react_stores/notifications_store":243,"../gr_component_factory":102,"../user/user_icon":193,"react":"react","reflux":"reflux"}],123:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _dot_separated_elements = require("../dot_separated_elements");

var _dot_separated_elements2 = _interopRequireDefault(_dot_separated_elements);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "EditorialBlogThumbnail",
  propTypes: {
    likesCountText: _react2.default.PropTypes.string,
    commentsCountText: _react2.default.PropTypes.string,
    imageUrl: _react2.default.PropTypes.string,
    blogPostUrl: _react2.default.PropTypes.string.isRequired,
    title: _react2.default.PropTypes.string.isRequired,
    header: _react2.default.PropTypes.string.isRequired
  },

  renderBlogLink: function renderBlogLink(text) {
    return _jsx("span", {
      className: "gr-metaText"
    }, void 0, text);
  },
  renderImage: function renderImage() {
    if (this.props.imageUrl) {
      return _jsx("a", {
        href: this.props.blogPostUrl
      }, void 0, _jsx("img", {
        className: "gr-editorialBlogPost__image",
        src: this.props.imageUrl,
        alt: "" + this.props.title
      }));
    } else {
      return null;
    }
  },
  renderLikesAndComments: function renderLikesAndComments() {
    var likesLink = this.renderBlogLink(this.props.likesCountText);
    var commentsLink = this.renderBlogLink(this.props.commentsCountText);
    if (this.props.likesCountText && this.props.commentsCountText) {
      return _jsx(_dot_separated_elements2.default, {
        elements: [likesLink, commentsLink]
      });
    } else if (this.props.likesCountText) {
      return likesLink;
    } else if (this.props.commentsCountText) {
      return commentsLink;
    } else {
      return null;
    }
  },
  render: function render() {
    return _jsx("section", {
      className: "gr-editorialBlogPost"
    }, void 0, _jsx("article", {}, void 0, _jsx("h3", {}, void 0, this.props.header), _jsx("a", {
      href: this.props.blogPostUrl,
      className: "gr-editorialBlogPost__title"
    }, void 0, this.props.title), this.renderImage(), _jsx("div", {
      className: "gr-editorialBlogPost__likesAndComments"
    }, void 0, this.renderLikesAndComments())));
  }
});

},{"../dot_separated_elements":88,"../gr_component_factory":102,"react":"react"}],124:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();
// react-router imports

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JobsListComponent = undefined;

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _react = require("react");

var _env_utils = require("../modules/env_utils");

var _env_utils2 = _interopRequireDefault(_env_utils);

var _lodash = require("lodash");

var _Router = require("react-router/lib/Router");

var _Router2 = _interopRequireDefault(_Router);

var _RouterContext = require("react-router/lib/RouterContext");

var _RouterContext2 = _interopRequireDefault(_RouterContext);

var _Route = require("react-router/lib/Route");

var _Route2 = _interopRequireDefault(_Route);

var _Link = require("react-router/lib/Link");

var _Link2 = _interopRequireDefault(_Link);

var _browserHistory = require("react-router/lib/browserHistory");

var _browserHistory2 = _interopRequireDefault(_browserHistory);

var _match = require("react-router/lib/match");

var _match2 = _interopRequireDefault(_match);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JOBS_BASE_PATH = "/jobs";
var HEADING_TITLE_TEXT = "Find your next job";
var HEADING_SUBTITLE_TEXT = "Want to be part of creating innovative experiences for the largest community of readers? We’re hiring!";
var HEADING_SUBTITLE_NO_JOBS_TEXT = "Sorry, we do not have any open positions at this time. Please check again soon!";
var LOCATION_HEADING_TEXT = "Location City";
var SUBMITTED_APP_TEXT = "Check on a submitted application";
var SUBMITTED_APP_URL = "https://account.amazon.jobs";
var JOB_TITLE_SUBSTRINGS_TO_STRIP = [" - Goodreads", ", Goodreads"];
var BACK_TO_JOBS_TEXT = "Back to all jobs";
var BASIC_QUALS_HEADING_TEXT = "Basic Qualifications:";
var PREF_QUALS_HEADING_TEXT = "Preferred Qualifications:";
var LEGAL_TEXT = "Qualified applicants with criminal histories will be considered in a manner consistent with all applicable local, state and federal laws, including the San Francisco Fair Chance Ordinance.";
var APPLY_BUTTON_TEXT = "Apply now";
var APPLY_URL_EXTENSION = "apply";
var BODY_CLASS = "jobsListBody";

var JobsListComponent = exports.JobsListComponent = _gr_component_factory2.default.createClass({
  displayName: "JobsList",

  getJobs: function getJobs() {
    return this.props.route.jobs;
  },
  getSelectedJobData: function getSelectedJobData() {
    return this.getJobs() ? this.getJobs()[this.props.location.query.id] : null;
  },
  displayableJobTitle: function displayableJobTitle(title) {
    var titleToDisplay = title;
    JOB_TITLE_SUBSTRINGS_TO_STRIP.forEach(function (substring) {
      titleToDisplay = titleToDisplay.replace(substring, "");
    });
    return titleToDisplay;
  },
  renderBackToAllJobsButton: function renderBackToAllJobsButton() {
    return _jsx(_Link2.default, {
      to: JOBS_BASE_PATH
    }, void 0, _jsx("span", {
      className: "gr-hyperlink"
    }, void 0, BACK_TO_JOBS_TEXT));
  },
  renderHeading: function renderHeading() {
    var jobsListHeadingSubtitleClass = (0, _classnames2.default)(this.withBemModifiers("jobsListHeading__subtitle"), { "jobsListHeading__subtitle--jobSelected": this.getSelectedJobData() });
    return _jsx("div", {
      className: "gr-row gr-justify-content-center"
    }, void 0, _jsx("div", {
      className: "gr-col gr-col-md-7 gr-col-lg-8"
    }, void 0, _jsx("h2", {
      className: "gr-marketingPageH2 jobsListHeading__title"
    }, void 0, HEADING_TITLE_TEXT), _jsx("p", {
      className: jobsListHeadingSubtitleClass
    }, void 0, this.getJobs() ? HEADING_SUBTITLE_TEXT : HEADING_SUBTITLE_NO_JOBS_TEXT)));
  },
  renderLocation: function renderLocation(normalizedLocation) {
    var locationClass = (0, _classnames2.default)(this.withBemModifiers("jobsListItem__location"), { "jobsListItem__location--jobSelected": this.getSelectedJobData() });
    return _jsx("div", {
      className: locationClass
    }, void 0, normalizedLocation.replace(", USA", ""));
  },
  renderJobItem: function renderJobItem(id) {
    var job = this.getJobs()[id];
    if (job) {
      return _jsx("div", {
        id: id,
        className: "gr-row jobsListItem"
      }, id, _jsx("div", {
        className: "gr-col gr-col-md-6 gr-col-lg-7 gr-col-md-offset-1"
      }, void 0, _jsx(_Link2.default, {
        to: JOBS_BASE_PATH + "?id=" + id
      }, void 0, _jsx("span", {
        className: "gr-hyperlink gr-d-block jobsListItem__link"
      }, void 0, this.displayableJobTitle(job.title))), _jsx("div", {
        className: "gr-d-block gr-d-md-none"
      }, void 0, this.renderLocation(job.location))), _jsx("div", {
        className: "gr-col gr-col-md-4 gr-col-lg-3 gr-d-none gr-d-md-flex"
      }, void 0, this.renderLocation(job.location)));
    } else {
      return null;
    }
  },
  renderLocationHeading: function renderLocationHeading() {
    return _jsx("div", {
      className: "gr-col gr-col-md-4 gr-col-lg-3 gr-d-none gr-d-md-flex"
    }, void 0, _jsx("h3", {
      className: "gr-h3"
    }, void 0, LOCATION_HEADING_TEXT));
  },
  renderCategoryHeading: function renderCategoryHeading(category) {
    var categoryKeys = Object.keys(this.props.route.categories);
    var isFirstCategoryHeading = category === categoryKeys[0];
    return _jsx("div", {
      className: "gr-row"
    }, void 0, _jsx("div", {
      className: "gr-col gr-col-md-6 gr-col-lg-7 gr-col-md-offset-1"
    }, void 0, _jsx("h3", {
      className: "gr-h3"
    }, void 0, category)), isFirstCategoryHeading && this.renderLocationHeading());
  },
  getJobMarkup: function getJobMarkup(markup) {
    return { __html: markup };
  },
  renderSelectedJob: function renderSelectedJob() {
    var jobData = this.getSelectedJobData();
    var selectedJobTitle = this.displayableJobTitle(jobData.title);
    return _jsx("div", {
      className: "jobsListSelectedJob"
    }, void 0, _jsx("h4", {
      className: "gr-marketingPageH4"
    }, void 0, selectedJobTitle), this.renderLocation(jobData.location), _jsx("p", {
      dangerouslySetInnerHTML: this.getJobMarkup(jobData.description),
      className: "jobsListSelectedJob__description"
    }), _jsx("h5", {
      className: "gr-marketingPageH5"
    }, void 0, BASIC_QUALS_HEADING_TEXT), _jsx("div", {
      dangerouslySetInnerHTML: this.getJobMarkup(jobData.basic_qualifications),
      className: "jobsListSelectedJob__basicQuals"
    }), _jsx("h5", {
      className: "gr-marketingPageH5"
    }, void 0, PREF_QUALS_HEADING_TEXT), _jsx("div", {
      dangerouslySetInnerHTML: this.getJobMarkup(jobData.preferred_qualifications),
      className: "jobsListSelectedJob__preferredQuals"
    }));
  },
  renderCheckJobApp: function renderCheckJobApp() {
    var checkAppClass = (0, _classnames2.default)({ "gr-hyperlink": this.getSelectedJobData() }, { "gr-button gr-button--large gr-button--fullWidth gr-button--teal": !this.getSelectedJobData() });
    return _jsx("a", {
      href: SUBMITTED_APP_URL,
      className: checkAppClass
    }, void 0, SUBMITTED_APP_TEXT);
  },
  renderApplicationButtons: function renderApplicationButtons() {
    var jobData = this.getSelectedJobData();
    return _jsx("div", {
      className: "jobsListSelectedJob__applicationButtons"
    }, void 0, _jsx("div", {
      className: "jobsListApplyButton gr-d-md-inline"
    }, void 0, _jsx("a", {
      href: "" + SUBMITTED_APP_URL + JOBS_BASE_PATH + "/" + jobData.id_icims + "/" + APPLY_URL_EXTENSION,
      className: "gr-button gr-button--large gr-button--teal"
    }, void 0, APPLY_BUTTON_TEXT)), _jsx("div", {
      className: "jobsListCheckJobAppContainer gr-d-md-inline"
    }, void 0, this.renderCheckJobApp()));
  },
  render: function render() {
    var _this = this;

    if (this.getSelectedJobData()) {
      return _jsx("div", {
        className: BODY_CLASS
      }, void 0, this.renderHeading(), _jsx("div", {
        className: "gr-row gr-justify-content-center"
      }, void 0, _jsx("div", {
        className: "gr-col gr-col-md-10 gr-col-lg-8"
      }, void 0, _jsx("div", {
        className: "jobsListBackToAllJobsContainer--top"
      }, void 0, this.renderBackToAllJobsButton()), this.renderSelectedJob(), _jsx("div", {
        className: "jobsListLegalText"
      }, void 0, LEGAL_TEXT), this.renderApplicationButtons(), _jsx("div", {
        className: "jobsListBackToAllJobsContainer--bottom"
      }, void 0, this.renderBackToAllJobsButton()))));
    } else {
      var jobsListCheckJobAppContainerClass = (0, _classnames2.default)("gr-row gr-justify-content-center jobsListCheckJobAppContainer--jobList", { "jobsListCheckJobAppContainer--noJobs": !this.getJobs() });
      return _jsx("div", {
        className: BODY_CLASS
      }, void 0, this.renderHeading(), (0, _lodash.map)(this.props.route.categories, function (jobIds, category) {
        return _jsx("div", {
          className: "jobsListCategory"
        }, category, _this.renderCategoryHeading(category), (0, _lodash.map)(jobIds, function (jobId) {
          return _this.renderJobItem(jobId);
        }));
      }), _jsx("div", {
        className: jobsListCheckJobAppContainerClass
      }, void 0, _jsx("div", {
        className: "gr-col gr-col-10 gr-col-md-6 gr-col-lg-4"
      }, void 0, this.renderCheckJobApp())));
    }
  }
});

var JobsListRouter = function JobsListRouter(props) {
  var routes = React.createElement(_Route2.default, _extends({ path: JOBS_BASE_PATH + "(?id=*)",
    component: JobsListComponent,
    onChange: function onChange() {
      var scrollToElement = document.getElementsByClassName(BODY_CLASS)[0].parentElement;
      if (scrollToElement !== null) {
        scrollToElement.scrollIntoView(true);
      }
    }
  }, props));
  // server side rendering
  if (_env_utils2.default.domUnavailable()) {
    var routeProps = undefined;
    var location = JOBS_BASE_PATH;
    if (props.selectedId) {
      location += "?id=" + props.selectedId;
    }
    (0, _match2.default)({ routes: routes, location: location }, function (_error, _redirectLocation, _routeProps) {
      routeProps = _routeProps;
    });
    return React.createElement(_RouterContext2.default, routeProps);
  } else {
    return _jsx(_Router2.default, {
      history: _browserHistory2.default
    }, void 0, routes);
  }
};

JobsListRouter.propTypes = {
  selectedId: _react.PropTypes.string,
  categories: _react.PropTypes.object,
  jobs: _react.PropTypes.object
};

exports.default = JobsListRouter;

},{"../modules/env_utils":13,"./gr_component_factory":102,"classnames":"classnames","lodash":"lodash","react":"react","react-router/lib/Link":259,"react-router/lib/Route":263,"react-router/lib/Router":265,"react-router/lib/RouterContext":266,"react-router/lib/browserHistory":269,"react-router/lib/match":277}],125:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LibrarianQuiz = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _ajax_helper = require("../../modules/ajax/ajax_helper");

var _env_utils = require("../../modules/env_utils");

var _flash_message = require("../flash_message");

var _flash_message2 = _interopRequireDefault(_flash_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LibrarianQuiz = exports.LibrarianQuiz = (function (_React$Component) {
  _inherits(LibrarianQuiz, _React$Component);

  function LibrarianQuiz(props) {
    _classCallCheck(this, LibrarianQuiz);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(LibrarianQuiz).call(this, props));

    _this.state = _extends({}, _this.props, {
      userAnswers: {},
      gradingInProgress: false
    });

    _this.renderManualLinkBox = _this.renderManualLinkBox.bind(_this);
    _this.gradeQuiz = _this.gradeQuiz.bind(_this);
    _this.addUserAnswer = _this.addUserAnswer.bind(_this);
    _this.renderAnswerRadioInput = _this.renderAnswerRadioInput.bind(_this);
    _this.renderButton = _this.renderButton.bind(_this);
    _this.renderStatusFlashMessage = _this.renderStatusFlashMessage.bind(_this);
    return _this;
  }

  _createClass(LibrarianQuiz, [{
    key: "gradeQuiz",
    value: function gradeQuiz() {
      this.setState({ gradingInProgress: true });
      (0, _ajax_helper.httpPost)("/librarian/submit_quiz", {
        data: { userAnswers: this.state.userAnswers }
      }).done(function (response) {
        (0, _env_utils.setLocationUrl)(response.redirect);
      });
    }
  }, {
    key: "addUserAnswer",
    value: function addUserAnswer(questionId, answerId) {
      var newUserAnswers = this.state.userAnswers;
      newUserAnswers[questionId] = answerId;
      this.setState({ userAnswers: newUserAnswers });
    }
  }, {
    key: "renderStatusFlashMessage",
    value: function renderStatusFlashMessage() {
      if (this.state.statusMessage && !this.state.adminViewing) {
        if (!this.state.passedQuiz) {
          return _jsx(_flash_message2.default, {
            category: "error",
            message: this.state.statusMessage
          });
        } else {
          return _jsx(_flash_message2.default, {
            category: "info",
            message: this.state.statusMessage
          });
        }
      } else {
        return null;
      }
    }
  }, {
    key: "renderAnswerRadioInput",
    value: function renderAnswerRadioInput(question, answerId) {
      var _this2 = this;

      var questionId = question.questionId;
      if (this.state.finishedQuiz) {
        return _jsx("input", {
          name: "quizQuestion" + questionId,
          value: answerId,
          type: "radio",
          checked: question.userAnswer === answerId,
          disabled: true,
          className: "gr-radioButtonGroup__button"
        });
      } else {
        return _jsx("input", {
          name: "quizQuestion" + questionId,
          value: answerId,
          type: "radio",
          onChange: function onChange() {
            _this2.addUserAnswer(questionId, answerId);
          },
          className: "gr-radioButtonGroup__button"
        });
      }
    }
  }, {
    key: "renderManualLinkBox",
    value: function renderManualLinkBox(question) {
      if (this.state.finishedQuiz && !question.isUserAnswerCorrect) {
        return _jsx("div", {
          className: "gr-infoMessageBox"
        }, void 0, "Incorrect answer! Please consult the", " ", _jsx("a", {
          href: question.manualLink,
          className: "gr-hyperlink"
        }, void 0, "Librarian Manual"), " ", "for more information.");
      } else {
        return null;
      }
    }
  }, {
    key: "renderButton",
    value: function renderButton() {
      if (this.state.finishedQuiz) {
        if (this.state.passedQuiz && !this.state.adminViewing) {
          return _jsx("a", {
            className: "gr-button",
            href: "/librarian/apply_librarian"
          }, void 0, "Apply");
        } else {
          return null;
        }
      } else {
        return _jsx("button", {
          className: "gr-button",
          onClick: this.gradeQuiz,
          disabled: this.state.gradingInProgress
        }, void 0, "Submit");
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return _jsx("div", {}, void 0, this.renderStatusFlashMessage(), (0, _lodash.map)(this.state.attemptAnswers, function (question) {
        return _jsx("fieldset", {
          className: "gr-radioButtonGroup u-marginTopMedium u-marginBottomMedium"
        }, question.questionId, _this3.renderManualLinkBox(question), _jsx("legend", {
          className: "mediumLargeText fullSizeContainer"
        }, void 0, question.questionText), (0, _lodash.map)(question.answers, function (answer, index) {
          return _jsx("label", {
            className: "gr-radioButtonGroup__choice gr-label gr-label--muted"
          }, answer.answerId, _this3.renderAnswerRadioInput(question, answer.answerId), String.fromCharCode(65 + index), ": ", answer.answerText);
        }));
      }), this.renderButton());
    }
  }]);

  return LibrarianQuiz;
})(_react2.default.Component);

LibrarianQuiz.propTypes = {
  finishedQuiz: _react2.default.PropTypes.bool,
  passedQuiz: _react2.default.PropTypes.bool,
  adminViewing: _react2.default.PropTypes.bool,
  statusMessage: _react2.default.PropTypes.string,
  attemptAnswers: _react2.default.PropTypes.array
};

exports.default = LibrarianQuiz;

},{"../../modules/ajax/ajax_helper":4,"../../modules/env_utils":13,"../flash_message":100,"lodash":"lodash","react":"react"}],126:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_reflux = require("../../react_mixins/gr_reflux");

var _like_actions = require("../../react_actions/like_actions");

var _like_actions2 = _interopRequireDefault(_like_actions);

var _like_store = require("../../react_stores/like_store");

var _like_store2 = _interopRequireDefault(_like_store);

var _spinner = require("../spinner");

var _spinner2 = _interopRequireDefault(_spinner);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "LikeButton",

  mixins: [(0, _gr_reflux.connectToLazyStore)(_like_store2.default, "resourceKey")],

  propTypes: {
    resourceKey: _react2.default.PropTypes.string.isRequired,
    resourceLabel: _react2.default.PropTypes.string.isRequired,
    showAsLink: _react2.default.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return { showAsLink: true };
  },
  componentDidUpdate: function componentDidUpdate() {
    if (this.likeFocused && !this.state.showLoadingSpinner) {
      this.refs.likeButton.focus();
      this.likeFocused = false;
    }
  },
  buttonClicked: function buttonClicked() {
    if (this.state.isLiked) {
      _like_actions2.default.unLike(this.props.resourceKey);
    } else {
      _like_actions2.default.like(this.props.resourceKey);
    }
  },
  render: function render() {
    var _this = this;

    var linkText = this.state.isLiked ? "Unlike" : "Like";
    var buttonClasses = (0, _classnames2.default)({ "gr-buttonAsLink": this.props.showAsLink }, { "gr-button gr-button--small": !this.props.showAsLink });
    return _jsx("span", {
      "aria-live": "polite"
    }, void 0, this.state.showLoadingSpinner ? _jsx(_spinner2.default, {}) : _react2.default.createElement(
      "button",
      { "aria-label": linkText + " " + this.props.resourceLabel,
        ref: "likeButton",
        className: buttonClasses,
        onClick: this.buttonClicked,
        onFocus: function onFocus() {
          _this.likeFocused = true;
        } },
      linkText
    ));
  }
});

},{"../../react_actions/like_actions":36,"../../react_mixins/gr_reflux":227,"../../react_stores/like_store":241,"../gr_component_factory":102,"../spinner":186,"classnames":"classnames","react":"react"}],127:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _like_store = require("../../react_stores/like_store");

var _like_store2 = _interopRequireDefault(_like_store);

var _gr_reflux = require("../../react_mixins/gr_reflux");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "LikeCount",

  mixins: [(0, _gr_reflux.connectToLazyStore)(_like_store2.default, "resourceKey")],

  propTypes: {
    resourceKey: _react2.default.PropTypes.string.isRequired
  },

  getPluralLike: function getPluralLike(likeCount) {
    if (likeCount === 1) {
      return "like";
    } else {
      return "likes";
    }
  },
  render: function render() {
    if (this.state.likeCount > 0) {
      return _jsx("span", {}, void 0, _jsx("a", {
        className: "gr-hyperlink--quiet",
        href: this.state.likersListUrl
      }, void 0, this.state.likeCount, " ", this.getPluralLike(this.state.likeCount)), " · ");
    } else {
      return null;
    }
  }
});

},{"../../react_mixins/gr_reflux":227,"../../react_stores/like_store":241,"../gr_component_factory":102,"react":"react"}],128:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _like_store = require("../../react_stores/like_store");

var _like_store2 = _interopRequireDefault(_like_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "LikeInformation",

  mixins: [_reflux2.default.connectFilter(_like_store2.default, "likeStore", function (likes) {
    return likes[this.props.resourceKey];
  })],

  propTypes: {
    resourceKey: _react2.default.PropTypes.string.isRequired
  },

  getNameLink: function getNameLink() {
    var likedBy = this.state.likeStore.likedBy;
    var likedByUser = !_lodash2.default.isUndefined(likedBy.friends) ? likedBy.friends[0] : likedBy.others[0];

    return _jsx("a", {
      href: likedByUser.profile_url,
      className: "gr-hyperlink gr-hyperlink--bold likeInformation__name"
    }, void 0, likedByUser.name);
  },
  getPluralPerson: function getPluralPerson(count) {
    if (count > 1) {
      return "people";
    }
    return "person";
  },
  getYouLikeMessage: function getYouLikeMessage() {
    return _jsx("span", {
      className: "likeInformation__name"
    }, void 0, "You");
  },
  getYouAndAnotherPersonLikeMessage: function getYouAndAnotherPersonLikeMessage() {
    return _jsx("span", {}, void 0, this.getYouLikeMessage(), " and ", this.getNameLink());
  },
  getYouAndManyPeopleLikeMessage: function getYouAndManyPeopleLikeMessage() {
    var likeState = this.state.likeStore;
    var count = likeState.likeCount - 2;
    return _jsx("span", {}, void 0, this.getYouLikeMessage(), ", ", this.getNameLink(), ",", " and ", _jsx("a", {
      className: "gr-hyperlink gr-hyperlink--bold",
      href: likeState.likersListUrl
    }, void 0, count, " other ", this.getPluralPerson(count)));
  },
  getSomeoneLikeMessage: function getSomeoneLikeMessage() {
    return _jsx("span", {}, void 0, this.getNameLink());
  },
  getManyPeopleLikeMessage: function getManyPeopleLikeMessage() {
    var likeState = this.state.likeStore;
    var count = likeState.likeCount - 1;
    return _jsx("span", {}, void 0, this.getNameLink(), " and ", _jsx("a", {
      className: "gr-hyperlink gr-hyperlink--bold",
      href: likeState.likersListUrl
    }, void 0, count, " other ", this.getPluralPerson(count)));
  },
  getLikeMessage: function getLikeMessage() {
    var likeState = this.state.likeStore;
    if (likeState.isLiked) {
      switch (likeState.likeCount) {
        case 1:
          return this.getYouLikeMessage();
        case 2:
          return this.getYouAndAnotherPersonLikeMessage();
        default:
          return this.getYouAndManyPeopleLikeMessage();
      }
    } else {
      switch (likeState.likeCount) {
        case 1:
          return this.getSomeoneLikeMessage();
        default:
          return this.getManyPeopleLikeMessage();
      }
    }
  },
  render: function render() {
    var likeState = this.state.likeStore;
    if (!likeState.isLiked) {
      if (_lodash2.default.isEmpty(likeState.likedBy)) {
        return null;
      }
    }
    return _jsx("div", {
      className: "likeInformation u-defaultType"
    }, void 0, this.getLikeMessage(), " liked this");
  }
});

},{"../../react_stores/like_store":241,"../gr_component_factory":102,"lodash":"lodash","react":"react","reflux":"reflux"}],129:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _like_count = require("./like_count");

var _like_count2 = _interopRequireDefault(_like_count);

var _like_button = require("./like_button");

var _like_button2 = _interopRequireDefault(_like_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "LikeSimpleFooter",

  propTypes: {
    resourceKey: _react2.default.PropTypes.string.isRequired,
    resourceLabel: _react2.default.PropTypes.string.isRequired,
    isLikeable: _react2.default.PropTypes.bool.isRequired,
    showAsLink: _react2.default.PropTypes.bool
  },

  render: function render() {
    return _jsx("span", {}, void 0, _jsx(_like_count2.default, {
      resourceKey: this.props.resourceKey
    }), this.props.isLikeable ? _jsx(_like_button2.default, {
      resourceKey: this.props.resourceKey,
      resourceLabel: this.props.resourceLabel,
      showAsLink: this.props.showAsLink
    }) : null);
  }
});

},{"../gr_component_factory":102,"./like_button":126,"./like_count":127,"react":"react"}],130:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MEDIUM_DEVICE_BREAKPOINT = 768;

exports.default = _gr_component_factory2.default.createClass({
  displayName: "AmazonLoginButton",

  getInitialState: function getInitialState() {
    return {
      popup: false
    };
  },

  propTypes: {
    amazonSignInUrl: _react2.default.PropTypes.string.isRequired,
    enabled: _react2.default.PropTypes.bool,
    fullWidth: _react2.default.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      enabled: false,
      fullWidth: false
    };
  },
  componentDidMount: function componentDidMount() {
    this.setState({
      popup: window.innerWidth > MEDIUM_DEVICE_BREAKPOINT });
  },
  // or smaller
  handleButtonPress: function handleButtonPress() {
    if (this.state.popup) {
      window.open(this.props.amazonSignInUrl, "", "width=900,height=540");
    } else {
      window.location.assign(this.props.amazonSignInUrl);
    }
  },
  render: function render() {
    if (this.props.enabled) {
      return _jsx("button", {
        className: "gr-button gr-button--amazon gr-button--auth " + (this.props.fullWidth ? "gr-button--fullWidth" : ""),
        onClick: this.handleButtonPress
      }, void 0, _jsx("div", {
        className: "gr-mediaFlexbox gr-mediaFlexbox--alignItemsCenter gr-mediaFlexbox--justifyHorizontalContentCenter"
      }, void 0, _jsx("div", {
        className: "gr-mediaFlexbox__media gr-button--amazon__icon"
      }), _jsx("div", {
        className: "gr-mediaFlexbox__desc"
      }, void 0, "Continue with Amazon")));
    }
    return null;
  }
});

},{"../gr_component_factory":102,"react":"react"}],131:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MEDIUM_DEVICE_BREAKPOINT = 768;

exports.default = _gr_component_factory2.default.createClass({
  displayName: "FacebookLoginButton",

  getInitialState: function getInitialState() {
    return {
      popup: false
    };
  },

  propTypes: {
    enabled: _react2.default.PropTypes.bool,
    facebookRedirectUrl: _react2.default.PropTypes.string.isRequired,
    facebookSignInUrl: _react2.default.PropTypes.string.isRequired,
    fullWidth: _react2.default.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      enabled: false,
      fullWidth: false
    };
  },
  componentDidMount: function componentDidMount() {
    this.setState({
      popup: window.innerWidth > MEDIUM_DEVICE_BREAKPOINT });
  },
  // or smaller
  handleButtonPress: function handleButtonPress() {
    if (this.state.popup && typeof $grfb !== "undefined") {
      $grfb.login({
        redirect: this.props.facebookRedirectUrl
      });
    } else {
      window.location.assign(this.props.facebookSignInUrl);
    }
  },
  render: function render() {
    if (this.props.enabled && typeof $grfb !== "undefined") {
      return _jsx("button", {
        className: "gr-button gr-button--facebook gr-button--auth " + (this.props.fullWidth ? "gr-button--fullWidth" : ""),
        onClick: this.handleButtonPress
      }, void 0, _jsx("div", {
        className: "gr-mediaFlexbox gr-mediaFlexbox--alignItemsCenter gr-mediaFlexbox--justifyHorizontalContentCenter"
      }, void 0, _jsx("div", {
        className: "gr-mediaFlexbox__media gr-button--facebook__icon"
      }), _jsx("div", {
        className: "gr-mediaFlexbox__desc"
      }, void 0, "Continue with Facebook")));
    }
    return null;
  }
});

},{"../gr_component_factory":102,"react":"react"}],132:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Renders a Modal inviting the user to sign up or sign in. Aimed at signed out
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           visitors, with server-side business logic checking whether or not it should be
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           displayed, so calls an AJAX endpoint in componentDidMount.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _amazon_login_button = require("../../login/amazon_login_button");

var _amazon_login_button2 = _interopRequireDefault(_amazon_login_button);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _facebook_login_button = require("../../login/facebook_login_button");

var _facebook_login_button2 = _interopRequireDefault(_facebook_login_button);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _modal = require("../../modal");

var _modal2 = _interopRequireDefault(_modal);

var _register_button = require("../../login/register_button");

var _register_button2 = _interopRequireDefault(_register_button);

var _service_terms_and_privacy = require("../../login/service_terms_and_privacy");

var _service_terms_and_privacy2 = _interopRequireDefault(_service_terms_and_privacy);

var _ajax_helper = require("../../../modules/ajax/ajax_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "LoginInterstitial",

  propTypes: {
    allowAmazonSignIn: React.PropTypes.bool,
    allowFacebookSignIn: React.PropTypes.bool,
    overrideSignedOutPageCount: React.PropTypes.bool.isRequired,
    path: React.PropTypes.shape({
      termsUrl: React.PropTypes.string.isRequired,
      privacyUrl: React.PropTypes.string.isRequired
    }).isRequired
  },

  componentDidMount: function componentDidMount() {
    var _this = this;

    (0, _ajax_helper.httpGet)("/sign_in_prompt", {
      data: {
        countOverride: this.props.overrideSignedOutPageCount
      } }).done(function (promptValues, responseStatus) {
      if (responseStatus === "success") {
        _this.setState({
          signInUrl: promptValues.signInUrl,
          signUpUrl: promptValues.signUpUrl,
          thirdPartyRedirectUrl: promptValues.thirdPartyRedirectUrl,
          amazonSignInUrl: promptValues.amazonSignInUrl,
          deviceType: promptValues.deviceType,
          facebookSignInUrl: promptValues.facebookSignInUrl,
          isShown: promptValues.showPrompt === true && promptValues.isDelayed === false
        });
        if (promptValues.showPrompt === true && promptValues.isDelayed === true) {
          _this.timer = setTimeout(function () {
            _this.setState({ isShown: true });
          }, 20000);
        }
      } else if (responseStatus === "nocontent") {
        // HTTP 204 means "no prompt"
        _this.setState({ isShown: false });
      }
    }).fail(function () {
      // If call returns other failure, don't show.
      _this.setState({ isShown: false });
    });
  },
  getDefaultProps: function getDefaultProps() {
    return {
      allowAmazonSignIn: false,
      allowFacebookSignIn: false
    };
  },
  getInitialState: function getInitialState() {
    return { isShown: false };
  },
  isResponsive: function isResponsive() {
    // Design decision to show the responsive variant of the pop-up on mobile
    // devices. I think we want to make that the only variant, eventually.
    return this.state.deviceType === "mobile";
  },
  onCloseHandler: function onCloseHandler() {
    (0, _ajax_helper.httpPost)("/track/track_click", {
      data: { feature: "LoginInterstitial:dismiss" }
    });
    if (this.state.deviceType) {
      (0, _ajax_helper.httpPost)("/track/track_click", {
        data: { feature: "LoginInterstitial:" + this.state.deviceType + ":" + ":dismiss" }
      });
    }
  },
  showPopUpBook: function showPopUpBook() {
    return this.state.deviceType === "desktop";
  },
  renderAmazonLoginButton: function renderAmazonLoginButton() {
    if (this.state.amazonSignInUrl) {
      return _jsx("div", {
        className: "loginModal__button"
      }, void 0, _jsx(_amazon_login_button2.default, {
        enabled: this.props.allowAmazonSignIn,
        amazonSignInUrl: this.state.amazonSignInUrl,
        fullWidth: true
      }));
    }
  },
  renderFacebookLoginButton: function renderFacebookLoginButton() {
    if (this.state.facebookSignInUrl) {
      return _jsx("div", {
        className: "loginModal__button"
      }, void 0, _jsx(_facebook_login_button2.default, {
        enabled: this.props.allowFacebookSignIn,
        facebookRedirectUrl: this.state.thirdPartyRedirectUrl,
        facebookSignInUrl: this.state.facebookSignInUrl,
        fullWidth: true
      }));
    }
  },
  renderContent: function renderContent() {
    var containerClasses = (0, _classnames2.default)("loginModal", { "loginModal--responsive": this.isResponsive() });
    var modalContent = _jsx("div", {
      className: containerClasses
    }, void 0, this.showPopUpBook() ? "" : _jsx("div", {
      className: "loginModal__icon",
      alt: "Goodreads"
    }), _jsx("div", {
      className: "loginModal__header"
    }, void 0, _jsx("h3", {
      className: "gr-h3 gr-h3--serif gr-h3--noMargin"
    }, void 0, "Discover & read more")), this.showPopUpBook() ? _jsx("div", {
      className: "loginModal__popUpBook"
    }) : "", _jsx("div", {
      className: "loginModal__body"
    }, void 0, _jsx("span", {
      className: "u-defaultType"
    }, void 0, "Sign up to get better recommendations with a free account."), _jsx("div", {
      className: "loginModal__cta"
    }, void 0, this.renderAmazonLoginButton(), _jsx("div", {
      className: "loginModal__button"
    }, void 0, _jsx(_register_button2.default, {
      fullWidth: true,
      signUpUrl: this.state.signUpUrl
    })), _jsx("span", {
      className: "u-defaultType"
    }, void 0, "Already a member?  ", _jsx("a", {
      href: this.state.signInUrl,
      rel: "nofollow"
    }, void 0, "Sign in"))), _jsx(_service_terms_and_privacy2.default, {
      termsUrl: this.props.path.termsUrl,
      privacyUrl: this.props.path.privacyUrl
    })));
    return modalContent;
  },
  render: function render() {
    if (this.state.isShown) {
      var modal = _jsx(_modal2.default, {
        id: "LoginInterstitial",
        centered: true,
        onCloseHandler: this.onCloseHandler,
        responsive: this.isResponsive(),
        showByDefault: true
      }, void 0, this.renderContent());
      return modal;
    } else {
      return null;
    }
  }
});

},{"../../../modules/ajax/ajax_helper":4,"../../gr_component_factory":102,"../../login/amazon_login_button":130,"../../login/facebook_login_button":131,"../../login/register_button":133,"../../login/service_terms_and_privacy":134,"../../modal":136,"classnames":"classnames"}],133:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "RegisterButton",

  propTypes: {
    fullWidth: _react2.default.PropTypes.bool,
    signUpUrl: _react2.default.PropTypes.string.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      fullWidth: false
    };
  },
  render: function render() {
    var registerButton = _jsx("a", {
      className: "gr-button gr-button--large " + (this.props.fullWidth ? "gr-button--fullWidth" : ""),
      href: this.props.signUpUrl
    }, void 0, "Sign up with email");
    return registerButton;
  }
});

},{"../gr_component_factory":102,"react":"react"}],134:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ServiceTermsAndPrivacy",

  propTypes: {
    privacyUrl: _react2.default.PropTypes.string.isRequired,
    termsUrl: _react2.default.PropTypes.string.isRequired
  },

  render: function render() {
    var serviceTermsAndPrivacy = _jsx("small", {}, void 0, "By clicking “Sign up” I agree to the Goodreads ", _jsx("a", {
      href: this.props.termsUrl,
      rel: "nofollow",
      target: "_blank"
    }, void 0, "Terms of Service"), " and confirm that I am at least 13 years old.  Read our ", _jsx("a", {
      href: this.props.privacyUrl,
      rel: "nofollow",
      target: "_blank"
    }, void 0, "Privacy Policy"));
    return serviceTermsAndPrivacy;
  }
});

},{"../gr_component_factory":102,"react":"react"}],135:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MENU_LINK_TRACKING_PREFIX = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _lodash = require("lodash");

var _click_and_view_tracking = require("../modules/click_and_view_tracking");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MENU_LINK_TRACKING_PREFIX = exports.MENU_LINK_TRACKING_PREFIX = "MenuLink";

exports.default = _gr_component_factory2.default.createClass({
  displayName: "MenuLink",

  propTypes: {
    href: _react2.default.PropTypes.string,
    linkText: _react2.default.PropTypes.any,
    linkClass: _react2.default.PropTypes.string,
    method: _react2.default.PropTypes.oneOf(["POST", "PUT", "DELETE"])
  },

  getFriendlyMenuLinkTrackingName: function getFriendlyMenuLinkTrackingName(linkText) {
    if (typeof linkText === "string") {
      var camelCaseName = (0, _lodash.camelCase)(linkText);
      var pascalCaseName = camelCaseName[0].toUpperCase() + camelCaseName.slice(1);
      return MENU_LINK_TRACKING_PREFIX + "_" + pascalCaseName;
    } else {
      return MENU_LINK_TRACKING_PREFIX + "_Unknown";
    }
  },
  render: function render() {
    var _this = this;

    return _jsx("li", {
      role: "menuitem " + this.props.linkText,
      className: "menuLink",
      "aria-label": this.props.linkText
    }, void 0, this.props.children ? _jsx("span", {}, void 0, this.props.children) : _jsx("a", {
      href: this.props.href,
      className: this.props.linkClass,
      "data-method": this.props.method,
      onClick: function onClick(e) {
        return (0, _click_and_view_tracking.trackNavEngageClick)(e, _this.getFriendlyMenuLinkTrackingName(_this.props.linkText));
      }
    }, void 0, this.props.linkText));
  }
});

},{"../modules/click_and_view_tracking":8,"./gr_component_factory":102,"lodash":"lodash","react":"react"}],136:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             Modal dialog: halt/block other page content, display new content, and force
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             the user to interact with or dismiss that content before doing anything else.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             Display options, controlled by props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * Default: "Lightbox" style modal window overlaying page
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * Centered (centered: true): Center modal window within screen (?). May be
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          combined with Responsive variant. If
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          you're trying to center your contents within the
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          modal area, use your content's markup and
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          styling; Modal is not responsible for
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          styling its contents.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * Drawer (asDrawer: true): Display as "drawer" sliding in from side of screen.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        Does not make sense combined with Centered or
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        Responsive.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * Responsive (responsive: true): Same as Default, but display like drawer at
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              smaller screen sizes. Mutually exclusive with
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              Drawer mode.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _modal_store = require("../react_stores/modal_store");

var _modal_store2 = _interopRequireDefault(_modal_store);

var _modal_actions = require("../react_actions/modal_actions");

var _modal_actions2 = _interopRequireDefault(_modal_actions);

var _close_button = require("./close_button");

var _close_button2 = _interopRequireDefault(_close_button);

var _keys = require("../modules/keys");

var _keys2 = _interopRequireDefault(_keys);

var _lodash = require("lodash");

var _close_button_values = require("../modules/close_button_values");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "Modal",

  mixins: [_reflux2.default.connect(_modal_store2.default, "modalStore")],

  propTypes: {
    asDrawer: _react2.default.PropTypes.bool,
    id: _react2.default.PropTypes.string.isRequired,
    centered: _react2.default.PropTypes.bool,
    showByDefault: _react2.default.PropTypes.bool,

    // This callback is run after the modal is hidden so it currently cannot
    // prevent closure. If you need such functionality, you need to
    // add another specific prop.
    onCloseHandler: _react2.default.PropTypes.func,

    // Provides a pair of Confirm/Cancel buttons that'll fire this callback
    // after user clicks Confirm. Both buttons close the Modal on click.
    onConfirmHandler: _react2.default.PropTypes.func,
    lockBodyScroll: _react2.default.PropTypes.bool,

    responsive: _react2.default.PropTypes.bool
  },

  getCloseButtonVariant: function getCloseButtonVariant() {
    if (this.props.asDrawer) {
      return _close_button_values.VARIANTS.DARK_BG;
    } else {
      return _close_button_values.VARIANTS.DEFAULT;
    }
  },
  getDefaultProps: function getDefaultProps() {
    return {
      asDrawer: false,
      centered: false,
      showByDefault: false,
      lockBodyScroll: true,
      responsive: false
    };
  },
  componentDidMount: function componentDidMount() {
    if (this.props.showByDefault) {
      _modal_actions2.default.openModal(this.props.id);
    }
  },
  componentDidUpdate: function componentDidUpdate() {
    this.updateBodyScrollability();
  },

  // prevent body from scrolling when modal is open
  updateBodyScrollability: function updateBodyScrollability() {
    if (this.props.lockBodyScroll && this.isActive()) {
      document.body.classList.add("modalOpened");
    } else if (!this.state.modalStore.currentActiveModal) {
      document.body.classList.remove("modalOpened");
    }
  },
  hide: function hide() {
    _modal_actions2.default.closeModal();
    if (this.props.onCloseHandler && (0, _lodash.isFunction)(this.props.onCloseHandler)) {
      this.props.onCloseHandler();
    }
  },
  isActive: function isActive() {
    return this.state.modalStore.currentActiveModal === this.props.id;
  },
  hideOnOverlayClick: function hideOnOverlayClick(ev) {
    if (ev.target.className.indexOf("modal--overlay") > -1) {
      this.hide();
    }
  },
  hideOnEscape: function hideOnEscape(ev) {
    if (_keys2.default.isDefaultCloserKey(ev.keyCode)) {
      this.hide();
    }
  },
  handleConfirm: function handleConfirm() {
    if (this.props.onConfirmHandler) {
      this.props.onConfirmHandler();
    }
    this.hide();
  },
  renderConfirmButtons: function renderConfirmButtons() {
    // Confirm/Cancel
    return _jsx("div", {
      className: "modal__confirmButtonsContainer"
    }, void 0, _jsx("button", {
      className: "gr-button gr-button--large gr-button--dark u-marginRightMedium",
      "data-testid": "confirm",
      onClick: this.handleConfirm,
      type: "button"
    }, void 0, "Confirm"), _jsx("button", {
      className: "gr-button gr-button--large",
      "data-testid": "cancel",
      onClick: this.hide,
      type: "button"
    }, void 0, "Cancel"));
  },
  render: function render() {
    var modalClass = (0, _classnames2.default)("modal", "modal--overlay", { "modal--show": this.isActive() && !this.props.centered,
      "modal--centered": this.isActive() && this.props.centered,
      "modal--drawer": this.props.asDrawer && !this.props.responsive,
      "modal--responsive": this.props.responsive });
    return _react2.default.createElement(
      "div",
      { className: modalClass, ref: "modalContent", tabIndex: "0",
        onClick: this.hideOnOverlayClick, onKeyDown: this.hideOnEscape },
      this.renderContents()
    );
  },
  renderContents: function renderContents() {
    if (this.props.asDrawer) {
      // In "drawer" mode, close button appears in overlay area, not content area
      return _jsx("div", {}, void 0, _jsx("div", {
        className: "modal__close"
      }, void 0, _jsx(_close_button2.default, {
        action: this.hide,
        variant: this.getCloseButtonVariant()
      })), _jsx("div", {
        className: this.withBemModifiers("modal__content")
      }, void 0, this.props.children));
    } else {
      return _jsx("div", {
        className: this.withBemModifiers("modal__content")
      }, void 0, _jsx("div", {
        className: "modal__close"
      }, void 0, _jsx(_close_button2.default, {
        action: this.hide,
        variant: this.getCloseButtonVariant()
      })), this.props.children, this.props.onConfirmHandler && this.renderConfirmButtons());
    }
  }
});

},{"../modules/close_button_values":9,"../modules/keys":16,"../react_actions/modal_actions":37,"../react_stores/modal_store":242,"./close_button":82,"./gr_component_factory":102,"classnames":"classnames","lodash":"lodash","react":"react","reflux":"reflux"}],137:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _modal_actions = require("../react_actions/modal_actions");

var _modal_actions2 = _interopRequireDefault(_modal_actions);

var _modal_store = require("../react_stores/modal_store");

var _modal_store2 = _interopRequireDefault(_modal_store);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ModalTrigger",

  mixins: [_reflux2.default.connect(_modal_store2.default, "modalStore")],

  propTypes: {
    id: _react2.default.PropTypes.string.isRequired,
    clickHandler: _react2.default.PropTypes.func
  },

  isActive: function isActive() {
    return this.state.modalStore.currentActiveModal === this.props.id;
  },
  openModal: function openModal() {
    if (this.props.clickHandler) {
      this.props.clickHandler();
    }
    _modal_actions2.default.openModal(this.props.id);
  },
  render: function render() {
    return _jsx("a", {
      className: this.withBemModifiers("modalTrigger"),
      onClick: this.openModal,
      role: "button",
      "aria-expanded": this.isActive(),
      "aria-haspopup": true
    }, void 0, this.props.children);
  }
});

},{"../react_actions/modal_actions":37,"../react_stores/modal_store":242,"./gr_component_factory":102,"react":"react","reflux":"reflux"}],138:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var AuthorBookImage = function AuthorBookImage(props) {
  return _jsx("div", {}, void 0, _jsx("a", {
    href: props.newsUrl
  }, void 0, _jsx("div", {
    className: "editorialCard__image--interview editorialCard__image--interviewAuthor",
    style: { backgroundImage: "url(" + props.authorImageUrl + ")" }
  }), _jsx("div", {
    className: "editorialCard__image--interview editorialCard__image--interviewBook",
    style: { backgroundImage: "url(" + props.bookImageUrl + ")" }
  })));
};

AuthorBookImage.propTypes = {
  authorImageUrl: _react.PropTypes.string.isRequired,
  bookImageUrl: _react.PropTypes.string.isRequired,
  newsUrl: _react.PropTypes.string.isRequired
};

exports.default = AuthorBookImage;

},{"react":"react"}],139:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var NewsImage = function NewsImage(props) {
  return _jsx("div", {}, void 0, _jsx("a", {
    href: props.newsUrl
  }, void 0, _jsx("img", {
    className: "newsPreview__newsImage",
    src: props.newsImageUrl
  })));
};

NewsImage.propTypes = {
  newsImageUrl: _react.PropTypes.string.isRequired,
  newsUrl: _react.PropTypes.string.isRequired
};

exports.default = NewsImage;

},{"react":"react"}],140:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _dot_separated_elements = require("../dot_separated_elements");

var _dot_separated_elements2 = _interopRequireDefault(_dot_separated_elements);

var _news_image = require("./news_image");

var _news_image2 = _interopRequireDefault(_news_image);

var _author_book_image = require("./author_book_image");

var _author_book_image2 = _interopRequireDefault(_author_book_image);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NewsPreview = (function (_Component) {
  _inherits(NewsPreview, _Component);

  function NewsPreview() {
    _classCallCheck(this, NewsPreview);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(NewsPreview).apply(this, arguments));
  }

  _createClass(NewsPreview, [{
    key: "renderImageSection",
    value: function renderImageSection(item) {
      var newsUrl = item.newsUrl;
      var newsImageUrl = item.newsImageUrl;
      var authorImageUrl = item.authorImageUrl;
      var bookImageUrl = item.bookImageUrl;

      if (newsImageUrl) {
        return _jsx(_news_image2.default, {
          newsImageUrl: newsImageUrl,
          newsUrl: newsUrl
        });
      } else if (authorImageUrl && bookImageUrl) {
        return _jsx(_author_book_image2.default, {
          newsUrl: newsUrl,
          authorImageUrl: authorImageUrl,
          bookImageUrl: bookImageUrl
        });
      }

      return null;
    }
  }, {
    key: "renderTextSection",
    value: function renderTextSection(item) {
      var likeCount = item.likeCount;
      var commentCount = item.commentCount;
      var title = item.title;
      var excerpt = item.excerpt;
      var newsUrl = item.newsUrl;
      var _props = this.props;
      var isMobile = _props.isMobile;
      var showLikesComments = _props.showLikesComments;

      var NewsHeader = isMobile ? "h4" : "a";

      var newsHeaderClass = (0, _classnames2.default)("gr-h4 gr-h4--serif", {
        "newsPreview__newsHeader--mobile": isMobile,
        newsPreview__newsHeader: !isMobile
      });

      var likesAndCommentsTextClass = (0, _classnames2.default)({
        newsPreview__likesAndComments__text: !isMobile
      });

      return _jsx("div", {
        className: "newsPreview__textSection"
      }, void 0, _jsx("div", {}, void 0, _jsx(NewsHeader, {
        className: newsHeaderClass,
        href: newsUrl
      }, void 0, title)), _jsx("div", {
        className: "newsPreview__excerpt",
        dangerouslySetInnerHTML: { __html: "" + excerpt }
      }), _jsx("div", {
        className: "newsPreview__readMore"
      }, void 0, _jsx("a", {
        href: newsUrl
      }, void 0, "Read more...")), showLikesComments && _jsx("div", {
        className: "newsPreview__likesAndComments"
      }, void 0, _jsx("small", {
        className: likesAndCommentsTextClass
      }, void 0, _jsx(_dot_separated_elements2.default, {
        elements: [likeCount + " likes", commentCount + " comments"]
      }))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props2 = this.props;
      var isMobile = _props2.isMobile;
      var imageOnLeft = _props2.imageOnLeft;
      var isBookPage = _props2.isBookPage;

      var sectionHeaderClass = (0, _classnames2.default)({
        brownBackground: !isMobile,
        "newsPreview__sectionHeader--mobile": isMobile,
        "newsPreview__sectionHeader--bookPage": isBookPage && !isMobile
      });

      var itemClass = (0, _classnames2.default)("newsPreview__item", {
        "newsPreview__item--mobile": isMobile
      });

      return _jsx("div", {
        className: "bigBox clearFloats"
      }, void 0, _jsx("div", {
        className: "h2Container gradientHeaderContainer"
      }, void 0, _jsx("h2", {
        className: sectionHeaderClass
      }, void 0, this.props.sectionHeader)), this.props.newsItems.map(function (item) {
        return _jsx("div", {
          className: itemClass
        }, item.key, isMobile || imageOnLeft ? _this2.renderImageSection(item) : _this2.renderTextSection(item), isMobile || imageOnLeft ? _this2.renderTextSection(item) : _this2.renderImageSection(item));
      }));
    }
  }]);

  return NewsPreview;
})(_react.Component);

NewsPreview.defaultProps = {
  likeCount: 0,
  commentCount: 0,
  isMobile: false,
  isBookPage: false,
  showLikesComments: true,
  imageOnLeft: false
};

NewsPreview.propTypes = {
  sectionHeader: _react.PropTypes.string,
  isMobile: _react.PropTypes.bool,
  isBookPage: _react.PropTypes.bool,
  showLikesComments: _react.PropTypes.bool,
  imageOnLeft: _react.PropTypes.bool,
  newsItems: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    likeCount: _react.PropTypes.number,
    commentCount: _react.PropTypes.number,
    title: _react.PropTypes.string.isRequired,
    excerpt: _react.PropTypes.string.isRequired,
    newsImageUrl: _react.PropTypes.string,
    authorImageUrl: _react.PropTypes.string,
    bookImageUrl: _react.PropTypes.string,
    newsUrl: _react.PropTypes.string.isRequired
  }))
};

exports.default = NewsPreview;

},{"../dot_separated_elements":88,"./author_book_image":138,"./news_image":139,"classnames":"classnames","react":"react"}],141:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "PageSkin",
  propTypes: {
    imageUrl: _react2.default.PropTypes.string,
    backgroundColor: _react2.default.PropTypes.string
  },

  render: function render() {
    var divStyle = {};
    if (this.props.imageUrl) {
      divStyle.backgroundImage = "url(" + this.props.imageUrl + ")";
      divStyle.backgroundRepeat = "no-repeat";
      divStyle.backgroundPosition = "center top";
    }
    if (this.props.backgroundColor) {
      divStyle.backgroundColor = this.props.backgroundColor;
    }
    // Add link for background
    return _jsx("div", {
      className: "pageskin",
      style: divStyle
    });
  }
});

},{"./gr_component_factory":102,"react":"react"}],142:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Renders a set of links for pagination: previous, next, plus some direct page
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           links.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Comes in a default (links) flavor and a "buttons" flavor. The "buttons" flavor,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           activated by passing the `asButtons` prop, was created for GR-42011. The two
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           variants are somewhat arbitrary, and might need revision over time...maybe one
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           becomes a "small"/"one line" variant, and the other becomes a "large"/"multiline"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           variant. Or, ideally, we converge on a single way to display pagination.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _pagination_single_page_link = require("./pagination_single_page_link");

var _pagination_single_page_link2 = _interopRequireDefault(_pagination_single_page_link);

var _gr_prop_types = require("./shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "PaginationLinks",

  propTypes: {
    asButtons: _react2.default.PropTypes.bool,
    totalSize: _gr_prop_types2.default.naturalNumber.isRequired,
    currentPageNumber: _react2.default.PropTypes.number.isRequired,
    className: _react2.default.PropTypes.string,
    perPage: _gr_prop_types2.default.naturalNumber.isRequired,
    changePageAction: _react2.default.PropTypes.func.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return { asButtons: false };
  },
  maxPageNumber: function maxPageNumber() {
    return Math.ceil(this.props.totalSize / this.props.perPage);
  },
  renderLinkToPage: function renderLinkToPage(pageNumber) {
    return _jsx(_pagination_single_page_link2.default, {
      pageNumber: pageNumber,
      currentPageNumber: this.props.currentPageNumber,
      changePageAction: this.props.changePageAction
    }, pageNumber);
  },
  renderPageLinks: function renderPageLinks() {
    var _this = this;

    var numPages = this.maxPageNumber();
    if (numPages !== 1) {
      if (numPages <= 6) {
        return _jsx("span", {
          className: "gr-paginationLinks__pageLinksWrapper"
        }, void 0, _lodash2.default.times(numPages, function (n) {
          return _this.renderLinkToPage(n + 1);
        }));
      } else {
        if (this.props.currentPageNumber <= 3) {
          // Render links for the the first four pages, then ellipsis, then the last page
          return _jsx("span", {
            className: "gr-paginationLinks__pageLinksWrapper"
          }, void 0, _lodash2.default.times(4, function (n) {
            return _this.renderLinkToPage(n + 1);
          }), "…", this.renderLinkToPage(this.maxPageNumber()));
        } else if (this.props.currentPageNumber >= this.maxPageNumber() - 3) {
          // First page, ellipsis, last four pages
          return _jsx("span", {
            className: "gr-paginationLinks__pageLinksWrapper"
          }, void 0, this.renderLinkToPage(1), "…", this.renderLinkToPage(this.maxPageNumber() - 3), this.renderLinkToPage(this.maxPageNumber() - 2), this.renderLinkToPage(this.maxPageNumber() - 1), this.renderLinkToPage(this.maxPageNumber()));
        } else {
          // First page, ellipsis, three middle pages starting from current, ellipsis, last
          return _jsx("span", {
            className: "gr-paginationLinks__pageLinksWrapper"
          }, void 0, this.renderLinkToPage(1), "…", this.renderLinkToPage(this.props.currentPageNumber), this.renderLinkToPage(this.props.currentPageNumber + 1), this.renderLinkToPage(this.props.currentPageNumber + 2), "…", this.renderLinkToPage(this.maxPageNumber()));
        }
      }
    }
  },
  renderPrevLink: function renderPrevLink() {
    if (this.maxPageNumber() === 1) {
      return null;
    } else {
      var cx = (0, _classnames2.default)({
        "gr-paginationLinks__previousLink": !this.props.asButtons,
        "gr-paginationLinks__previousButton": this.props.asButtons,
        "gr-button": this.props.asButtons,
        "gr-button--large": this.props.asButtons
      });
      return _jsx("button", {
        "aria-label": "Previous page",
        className: cx,
        onClick: this.moveToPrevPage,
        disabled: this.props.currentPageNumber === 1
      }, void 0, "← Previous");
    }
  },
  renderNextLink: function renderNextLink() {
    if (this.maxPageNumber() === 1) {
      return null;
    } else {
      var cx = (0, _classnames2.default)({
        "gr-paginationLinks__nextLink": !this.props.asButtons,
        "gr-paginationLinks__nextButton": this.props.asButtons,
        "gr-button": this.props.asButtons,
        "gr-button--large": this.props.asButtons
      });
      return _jsx("button", {
        "aria-label": "Next page",
        className: cx,
        onClick: this.moveToNextPage,
        disabled: this.props.currentPageNumber === this.maxPageNumber()
      }, void 0, "Next →");
    }
  },
  moveToNextPage: function moveToNextPage(event) {
    event.preventDefault();
    this.props.changePageAction(this.props.currentPageNumber + 1);
  },
  moveToPrevPage: function moveToPrevPage(event) {
    event.preventDefault();
    this.props.changePageAction(this.props.currentPageNumber - 1);
  },
  render: function render() {
    var cx = (0, _classnames2.default)("gr-paginationLinks", { "gr-paginationLinks--asButtons": this.props.asButtons }, this.props.className);
    // <div>s around next/prev links so that grid item sizing applied to wrapper
    // instead of the link/buttons themselves
    return _jsx("div", {
      className: cx
    }, void 0, _jsx("span", {
      className: "gr-paginationLinks__previousLinkWrapper"
    }, void 0, this.renderPrevLink()), this.renderPageLinks(), _jsx("span", {
      className: "gr-paginationLinks__nextLinkWrapper"
    }, void 0, this.renderNextLink()));
  }
});

},{"./gr_component_factory":102,"./pagination_single_page_link":143,"./shared/gr_prop_types":171,"classnames":"classnames","lodash":"lodash","react":"react"}],143:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "PaginationSinglePageLink",

  propTypes: {
    pageNumber: _react2.default.PropTypes.number,
    currentPageNumber: _react2.default.PropTypes.number,
    changePageAction: _react2.default.PropTypes.func.isRequired
  },

  render: function render() {
    if (this.props.pageNumber === this.props.currentPageNumber) {
      return _jsx("span", {
        "aria-label": this.props.pageNumber + " current page",
        className: "gr-paginationLinks__pageNumLink\n                         gr-paginationLinks__pageNumLink--selected"
      }, void 0, this.props.pageNumber);
    } else {
      return _jsx("button", {
        className: "gr-paginationLinks__pageNumLink",
        onClick: this.jumpToPage
      }, void 0, this.props.pageNumber);
    }
  },
  jumpToPage: function jumpToPage(event) {
    event.preventDefault();
    this.props.changePageAction(this.props.pageNumber);
  }
});

},{"./gr_component_factory":102,"react":"react"}],144:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldDisplayPreviewBookButton = undefined;

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _modal = require("../modal");

var _modal2 = _interopRequireDefault(_modal);

var _modal_trigger = require("../modal_trigger");

var _modal_trigger2 = _interopRequireDefault(_modal_trigger);

var _modal_store = require("../../react_stores/modal_store");

var _modal_store2 = _interopRequireDefault(_modal_store);

var _newsfeed_actions = require("../../react_actions/newsfeed_actions");

var _newsfeed_actions2 = _interopRequireDefault(_newsfeed_actions);

var _report_wrong_book_button = require("./report_wrong_book_button");

var _report_wrong_book_button2 = _interopRequireDefault(_report_wrong_book_button);

var _report_wrong_book_form = require("./report_wrong_book_form");

var _report_wrong_book_form2 = _interopRequireDefault(_report_wrong_book_form);

var _wrong_book_report_acknowledgment = require("./wrong_book_report_acknowledgment");

var _wrong_book_report_acknowledgment2 = _interopRequireDefault(_wrong_book_report_acknowledgment);

var _user_agent_capabilities_store = require("../../react_stores/user_agent_capabilities_store");

var _user_agent_capabilities_store2 = _interopRequireDefault(_user_agent_capabilities_store);

var _click_tracking_helper = require("../../modules/ads/click_tracking_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shouldDisplayPreviewBookButton = exports.shouldDisplayPreviewBookButton = function shouldDisplayPreviewBookButton(book, userAgentCapabilities) {
  if (userAgentCapabilities && userAgentCapabilities.touch === true) {
    return false;
  }
  return !!book.kcrPreviewUrl;
};

exports.default = _gr_component_factory2.default.createClass({
  displayName: "PreviewBook",

  mixins: [_reflux2.default.connect(_modal_store2.default, "modalStore"), _reflux2.default.connect(_user_agent_capabilities_store2.default, "userAgentCapabilities")],

  propTypes: {
    book: _gr_prop_types2.default.book().isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES.preview_book
    };
  },
  getInitialState: function getInitialState() {
    return {
      previewViewed: false,
      uniqueId: Math.random(1000000)
    };
  },
  getReportWrongBookModalId: function getReportWrongBookModalId() {
    return "report-" + this.props.book.kcrPreviewUrl + this.state.uniqueId;
  },
  getPreviewModalId: function getPreviewModalId() {
    return this.props.book.kcrPreviewUrl + this.state.uniqueId;
  },
  getAcknowledgmentModalId: function getAcknowledgmentModalId() {
    return "acknowledge-" + this.props.book.kcrPreviewUrl + this.state.uniqueId;
  },
  openBookPreview: function openBookPreview() {
    _newsfeed_actions2.default.previewBook();
    this.setState({ previewViewed: true });
  },
  render: function render() {
    var previewBookModalContents = null;
    var wrongBookForm = null;
    var acknowledgmentModal = null;

    var previewModalId = this.getPreviewModalId();
    var reportWrongBookModalId = this.getReportWrongBookModalId();
    var acknowledgmentModalId = this.getAcknowledgmentModalId();

    if (this.state.modalStore.currentActiveModal === previewModalId) {
      previewBookModalContents = _jsx("div", {
        className: "previewBook__container"
      }, void 0, _jsx("div", {
        className: "previewBook__topBanner"
      }, void 0, _jsx("div", {
        className: "previewBook__headerText"
      }, void 0, "Preview - ", _jsx("cite", {}, void 0, this.props.book.title)), _jsx(_report_wrong_book_button2.default, {
        book: this.props.book,
        modalId: reportWrongBookModalId
      })), _jsx("iframe", {
        className: "previewBook__kcrPreview",
        src: this.props.book.kcrPreviewUrl
      }));
    }

    if (this.state.previewViewed) {
      wrongBookForm = _jsx(_report_wrong_book_form2.default, {
        book: this.props.book,
        modalId: reportWrongBookModalId,
        acknowledgmentModalId: acknowledgmentModalId
      });
      acknowledgmentModal = _jsx(_wrong_book_report_acknowledgment2.default, {
        modalId: acknowledgmentModalId
      });
    }
    if (shouldDisplayPreviewBookButton(this.props.book, this.state.userAgentCapabilities)) {
      return _jsx("span", {
        className: "previewBook"
      }, void 0, _jsx(_modal_trigger2.default, {
        id: previewModalId
      }, void 0, _jsx("button", {
        "aria-label": "Preview " + this.props.book.title,
        className: "gr-buttonAsLink\n                             previewBook__openPreview",
        onClick: this.openBookPreview
      }, void 0, "Preview Book")), wrongBookForm, acknowledgmentModal, _jsx(_modal2.default, {
        id: previewModalId,
        bemModifiers: "preview"
      }, void 0, previewBookModalContents));
    } else {
      return null;
    }
  }
});

},{"../../modules/ads/click_tracking_helper":2,"../../react_actions/newsfeed_actions":38,"../../react_stores/modal_store":242,"../../react_stores/user_agent_capabilities_store":251,"../gr_component_factory":102,"../modal":136,"../modal_trigger":137,"../shared/gr_prop_types":171,"./report_wrong_book_button":145,"./report_wrong_book_form":146,"./wrong_book_report_acknowledgment":147,"reflux":"reflux"}],145:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           This component displays the 'Report Wrong Book' button.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Required props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `book`: Book JSON referring to the book this link lets you preview
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `modalId`: ID of the corresponding modal this button opens (ReportWrongBookForm)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _modal_trigger = require("../modal_trigger");

var _modal_trigger2 = _interopRequireDefault(_modal_trigger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ReportWrongBookButton",

  propTypes: {
    book: _gr_prop_types2.default.book().isRequired,
    modalId: _react2.default.PropTypes.string.isRequired
  },

  render: function render() {
    return _jsx("div", {
      className: "previewBook__reportWrongBookButtonContainer"
    }, void 0, _jsx(_modal_trigger2.default, {
      id: this.props.modalId
    }, void 0, _jsx("button", {
      "aria-label": "This is not the right book.",
      className: "gr-buttonAsLink\n                               previewBook__reportWrongBookButton"
    }, void 0, "Not the book you’re looking for?")));
  }
});

},{"../gr_component_factory":102,"../modal_trigger":137,"../shared/gr_prop_types":171,"react":"react"}],146:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           This component displays the 'Report Wrong Book' form.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Required props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `book`: Book JSON referring to the book this link lets you preview
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `modalId`: This component expects to be assigned an ID (since it relies on being opened by ReportWrongBookButton)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `acknowledgmentModalId`: The ID of the acknowledgment modal to be displayed if this form is submitted.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _modal = require("../modal");

var _modal2 = _interopRequireDefault(_modal);

var _modal_actions = require("../../react_actions/modal_actions");

var _modal_actions2 = _interopRequireDefault(_modal_actions);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FLAG_BOOK_REASONS = {
  wrongBook: "It’s the wrong book",
  wrongEdition: "It’s the wrong edition",
  other: "Other"
};

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ReportWrongBookForm",

  propTypes: {
    book: _gr_prop_types2.default.book().isRequired,
    modalId: _react2.default.PropTypes.string.isRequired,
    acknowledgmentModalId: _react2.default.PropTypes.string.isRequired
  },

  getAuthorString: function getAuthorString() {
    return "by " + this.props.book.authorName;
  },
  showReportAcknowledgement: function showReportAcknowledgement() {
    _modal_actions2.default.openModal(this.props.acknowledgmentModalId);
  },
  closeModal: function closeModal(ev) {
    ev.preventDefault();
    _modal_actions2.default.closeModal();
  },
  renderWrongBookForm: function renderWrongBookForm() {
    var wrongBookOptions = [];

    _lodash2.default.forEach(FLAG_BOOK_REASONS, function (reasonText, reason) {
      wrongBookOptions.push(_jsx("option", {
        value: reason
      }, reason, reasonText));
    });

    return _jsx("form", {
      className: "previewBook__reportWrongBookForm",
      action: "/kindle_book_mapping_flags",
      "data-remote": "true",
      method: "post"
    }, void 0, "We’d love your help. Let us know what’s wrong with this preview of ", _jsx("cite", {}, void 0, this.props.book.title), this.props.book.authorName ? this.getAuthorString() : "", ".", _jsx("br", {}), _jsx("input", {
      type: "hidden",
      name: "kindle_book_mapping_flag[book_id]",
      value: this.props.book.bookId
    }), _jsx("div", {
      className: "gr-formInputContainer"
    }, void 0, _jsx("label", {
      className: "gr-label",
      htmlFor: "kindle_book_mapping_flag_reason"
    }, void 0, "Problem"), _jsx("select", {
      name: "kindle_book_mapping_flag[reason]",
      id: "kindle_book_mapping_flag_reason"
    }, void 0, wrongBookOptions)), _jsx("div", {
      className: "gr-formInputContainer"
    }, void 0, _jsx("label", {
      className: "gr-label",
      htmlFor: "kindle_book_mapping_flag_other_reason"
    }, void 0, "Details (if other)"), _jsx("input", {
      name: "kindle_book_mapping_flag[other_reason]",
      id: "kindle_book_mapping_flag_other_reason"
    })), _jsx("button", {
      className: "gr-button gr-button--modalPrimaryLeft",
      type: "submit",
      onClick: this.showReportAcknowledgement
    }, void 0, "Report Problem"), _jsx("button", {
      className: "gr-buttonAsLink",
      onClick: this.closeModal,
      type: "button"
    }, void 0, "Cancel"));
  },
  render: function render() {
    return _jsx(_modal2.default, {
      id: this.props.modalId
    }, void 0, _jsx("h2", {}, void 0, "See a Problem?"), this.renderWrongBookForm());
  }
});

},{"../../react_actions/modal_actions":37,"../gr_component_factory":102,"../modal":136,"../shared/gr_prop_types":171,"lodash":"lodash","react":"react"}],147:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           This component displays the acknowledgment after reporting a wrong book preview.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Required props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `modalId`: This component expects to be assigned an ID (since it relies on
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        being opened by submitting a wrong book report from the book preview
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        modal)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _modal = require("../modal");

var _modal2 = _interopRequireDefault(_modal);

var _modal_actions = require("../../react_actions/modal_actions");

var _modal_actions2 = _interopRequireDefault(_modal_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "WrongBookReportAcknowledgment",

  propTypes: {
    modalId: _react2.default.PropTypes.string.isRequired
  },

  render: function render() {
    return _jsx("div", {
      className: "previewBook__wrongBookReportAcknowledgment"
    }, void 0, _jsx(_modal2.default, {
      id: this.props.modalId
    }, void 0, "Thanks for telling us about the problem.", _jsx("div", {}, void 0, _jsx("button", {
      className: "gr-button",
      onClick: _modal_actions2.default.closeModal
    }, void 0, "Close"))));
  }
});

},{"../../react_actions/modal_actions":37,"../gr_component_factory":102,"../modal":136,"react":"react"}],148:[function(require,module,exports){
"use strict";

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _qualtrics_survey_modal = require("./qualtrics_survey_modal");

var _qualtrics_survey_modal2 = _interopRequireDefault(_qualtrics_survey_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Wrapper component of QualtricsSurveyModal. Adds a couple event listeners
// onto the book show page's nonReact WTR button that fire when a user clicks
// WTR via button or dropdown.
// Note that all it does is render the child modal, which has its own rendering
// logic.
// Also note that this is pretty hacky due to interaction between React and
// nonReact components - pls no copy

var BookShowSurveyModal = (function (_Component) {
  _inherits(BookShowSurveyModal, _Component);

  function BookShowSurveyModal(props) {
    _classCallCheck(this, BookShowSurveyModal);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(BookShowSurveyModal).call(this, props));

    _this.state = { renderModal: false };

    _this.handleWTR = _this.handleWTR.bind(_this);
    return _this;
  }

  _createClass(BookShowSurveyModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var button = document.getElementById(this.props.buttonId);
      if (!button) return null;
      // there are two event listeners to add on the WTR button:
      // 1. when the user clicks WTR on the WTR button
      // 2. when the user clicks WTR on the WTR dropdown
      var nodes = button.querySelectorAll("button.wtrExclusiveShelf[value='to-read'], button.wtrToRead[type='submit']");
      [].concat(_toConsumableArray(nodes)).forEach(function (node) {
        return node.addEventListener("click", _this2.handleWTR);
      });
    }
  }, {
    key: "handleWTR",
    value: function handleWTR() {
      var _this3 = this;

      // Hack: set a timeout so you can see that WTR click did something.
      if (!this.state.renderModal) {
        setTimeout(function () {
          return _this3.setState({ renderModal: true });
        }, 2500);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.state.renderModal ? React.createElement(_qualtrics_survey_modal2.default, this.props) : null;
    }
  }]);

  return BookShowSurveyModal;
})(_react.Component);

exports.default = BookShowSurveyModal;

BookShowSurveyModal.propTypes = {
  buttonId: _react.PropTypes.string.isRequired
};

},{"./qualtrics_survey_modal":150,"react":"react"}],149:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _book_show_survey_modal = require("./book_show_survey_modal");

var _book_show_survey_modal2 = _interopRequireDefault(_book_show_survey_modal);

var _qualtrics_survey_modal = require("./qualtrics_survey_modal");

var _qualtrics_survey_modal2 = _interopRequireDefault(_qualtrics_survey_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SURVEY_MAP = {
  signed_in_book_show: _book_show_survey_modal2.default
}; // maps which qualtrics survey goes to which page

var QualtricsSurvey = function QualtricsSurvey(props) {
  var Component = SURVEY_MAP[props.type] || _qualtrics_survey_modal2.default;
  return React.createElement(Component, props);
};

QualtricsSurvey.propTypes = {
  type: _react.PropTypes.oneOf(Object.keys(SURVEY_MAP))
};

exports.default = QualtricsSurvey;

},{"./book_show_survey_modal":148,"./qualtrics_survey_modal":150,"react":"react"}],150:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QUALTRICS_COOKIE = undefined;

var _react = require("react");

var _modal = require("../modal");

var _modal2 = _interopRequireDefault(_modal);

var _cookies = require("../shared/cookies");

var _cookies2 = _interopRequireDefault(_cookies);

var _ajax_helper = require("../../modules/ajax/ajax_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               React component that renders a survey prompt in a Modal that shows by default,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               and then renders a Qualtrics survey in an iframe if user consents.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

var QUALTRICS_COOKIE = exports.QUALTRICS_COOKIE = "hide_qualtrics_survey";

var QualtricsSurveyModal = (function (_Component) {
  _inherits(QualtricsSurveyModal, _Component);

  function QualtricsSurveyModal(props) {
    _classCallCheck(this, QualtricsSurveyModal);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(QualtricsSurveyModal).call(this, props));

    _this.state = { isShown: false };
    return _this;
  }

  _createClass(QualtricsSurveyModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var isShown = this.shouldShow();
      if (isShown) {
        (0, _ajax_helper.httpPost)("/track/track", {
          data: { tid: "QualtricsSurveyModal:" + (this.props.type || "default") }
        });
        this.setState({ isShown: isShown });
      }
    }
  }, {
    key: "shouldShow",
    value: function shouldShow() {
      // No repeat showings before a certain time period
      if (_cookies2.default.get(QUALTRICS_COOKIE)) {
        return false;
      }
      // If user is signed out, make sure they've seen the login interstitial
      // before prompting a survey.
      if (this.props.signedOut) {
        return !!_cookies2.default.get("blocking_sign_in_interstitial");
      }
      return true;
    }
  }, {
    key: "onCloseHandler",
    value: function onCloseHandler() {
      _cookies2.default.set(QUALTRICS_COOKIE, true, 90);
    }
  }, {
    key: "renderSurvey",
    value: function renderSurvey() {
      return _jsx("div", {
        className: "qualtricsSurvey"
      }, void 0, _jsx("iframe", {
        className: "qualtricsSurvey__iframe",
        src: this.props.qualtricsUrl
      }));
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.isShown) {
        return null;
      }

      return _jsx(_modal2.default, {
        id: "QualtricsSurveyModal",
        showByDefault: true,
        onCloseHandler: this.onCloseHandler
      }, void 0, this.renderSurvey());
    }
  }]);

  return QualtricsSurveyModal;
})(_react.Component);

QualtricsSurveyModal.propTypes = {
  signedOut: _react.PropTypes.bool.isRequired,
  qualtricsUrl: _react.PropTypes.string.isRequired,
  type: _react.PropTypes.string
};

exports.default = QualtricsSurveyModal;

},{"../../modules/ajax/ajax_helper":4,"../modal":136,"../shared/cookies":170,"react":"react"}],151:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderCta = function renderCta(annotatedBookData) {
  if (annotatedBookData.noSharedAnnotations) {
    return _jsx("div", {}, void 0, _jsx("div", {
      className: "annotatedBookItem__bookInfo__knhCta annotatedBookItem__bookInfo__knhCta--noneVisible"
    }, void 0, annotatedBookData.knhCta));
  } else {
    return _jsx("div", {}, void 0, _jsx("div", {
      className: "annotatedBookItem__bookInfo__knhCta"
    }, void 0, annotatedBookData.knhCta));
  }
};

var AnnotatedBookItem = function AnnotatedBookItem(props) {
  return _jsx("div", {
    className: "annotatedBookItem"
  }, void 0, _jsx("a", {
    className: "annotatedBookItem__knhLink",
    href: props.annotatedBookData.readingNotesUrl
  }, void 0, _jsx("div", {
    className: "annotatedBookItem__box gr-row"
  }, void 0, _jsx("div", {
    className: "annotatedBookItem__imageColumn gr-col-12 gr-col-lg-auto"
  }, void 0, _jsx("img", {
    src: props.annotatedBookData.imageUrl
  })), _jsx("div", {
    className: "annotatedBookItem__mainColumn gr-col-12 gr-col-lg-auto"
  }, void 0, _jsx("div", {
    className: "annotatedBookItem__bookInfo"
  }, void 0, _jsx("div", {
    className: "annotatedBookItem__bookInfo__bookTitle"
  }, void 0, props.annotatedBookData.title), _jsx("div", {
    className: "annotatedBookItem__bookInfo__bookAuthor"
  }, void 0, "By ", props.annotatedBookData.authorName), renderCta(props.annotatedBookData))))));
};

AnnotatedBookItem.propTypes = {
  annotatedBookData: _gr_prop_types2.default.readingNotesAnnotatedBookItem().isRequired
};

exports.default = AnnotatedBookItem;

},{"../shared/gr_prop_types":171}],152:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _react = require("react");

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _reading_notes_header = require("./reading_notes_header");

var _reading_notes_header2 = _interopRequireDefault(_reading_notes_header);

var _annotated_books_page = require("./annotated_books_page");

var _annotated_books_page2 = _interopRequireDefault(_annotated_books_page);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "AnnotatedBooksLandingPage",

  propTypes: {
    user: _gr_prop_types2.default.user().isRequired,
    viewerIsOwner: _react.PropTypes.bool.isRequired,
    canViewProfile: _react.PropTypes.bool.isRequired,
    ownerHasLinkedAmazonAccount: _react.PropTypes.bool.isRequired,
    headline: _react.PropTypes.string.isRequired,
    createLinking: _react.PropTypes.string,
    updateLinking: _react.PropTypes.string,
    learnMore: _react.PropTypes.string,
    contactUs: _react.PropTypes.string,
    isSignedIn: React.PropTypes.bool.isRequired,
    signInRedirectUrl: React.PropTypes.string.isRequired
  },

  renderView: function renderView() {
    return _jsx("div", {}, void 0, _jsx(_reading_notes_header2.default, {
      user: this.props.user,
      headline: this.props.headline,
      isSignedIn: this.props.isSignedIn,
      signInRedirectUrl: this.props.signInRedirectUrl,
      viewerIsOwner: this.props.viewerIsOwner
    }), _jsx(_annotated_books_page2.default, {
      user: this.props.user,
      viewerIsOwner: this.props.viewerIsOwner,
      canViewProfile: this.props.canViewProfile,
      ownerHasLinkedAmazonAccount: this.props.ownerHasLinkedAmazonAccount,
      createLinking: this.props.createLinking,
      updateLinking: this.props.updateLinking,
      learnMore: this.props.learnMore,
      contactUs: this.props.contactUs
    }));
  },
  render: function render() {
    return _jsx("div", {
      className: "gr-annotatedBooksPage"
    }, void 0, this.renderView());
  }
});

},{"../gr_component_factory":102,"../shared/gr_prop_types":171,"./annotated_books_page":154,"./reading_notes_header":156,"react":"react"}],153:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _react = require("react");

var _lodash = require("lodash");

var _annotated_book_item = require("./annotated_book_item");

var _annotated_book_item2 = _interopRequireDefault(_annotated_book_item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "AnnotatedBooksList",

  propTypes: {
    annotatedBooksCollection: _react.PropTypes.array.isRequired
  },

  render: function render() {
    return _jsx("div", {
      className: "annotatedBooksList"
    }, void 0, (0, _lodash.map)(this.props.annotatedBooksCollection, function (annotatedBookData) {
      return _jsx(_annotated_book_item2.default, {
        annotatedBookData: annotatedBookData
      }, annotatedBookData.asin);
    }));
  }
});

},{"../gr_component_factory":102,"./annotated_book_item":151,"lodash":"lodash","react":"react"}],154:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _react = require("react");

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _lodash = require("lodash");

var _reading_notes_helper = require("../../modules/reading_notes/reading_notes_helper");

var _annotated_books_list = require("./annotated_books_list");

var _annotated_books_list2 = _interopRequireDefault(_annotated_books_list);

var _flash_message = require("../flash_message");

var _flash_message2 = _interopRequireDefault(_flash_message);

var _annotated_books_actions = require("../../react_actions/reading_notes/annotated_books_actions");

var _annotated_books_actions2 = _interopRequireDefault(_annotated_books_actions);

var _annotated_books_store = require("../../react_stores/reading_notes/annotated_books_store");

var _annotated_books_store2 = _interopRequireDefault(_annotated_books_store);

var _spinner = require("../spinner");

var _spinner2 = _interopRequireDefault(_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "AnnotatedBooksPage",

  mixins: [_reflux2.default.connect(_annotated_books_store2.default, "annotatedBooksStore")],

  propTypes: {
    user: _gr_prop_types2.default.user().isRequired,
    viewerIsOwner: _react.PropTypes.bool.isRequired,
    canViewProfile: _react.PropTypes.bool.isRequired,
    ownerHasLinkedAmazonAccount: _react.PropTypes.bool.isRequired,
    createLinking: _react.PropTypes.string,
    updateLinking: _react.PropTypes.string,
    learnMore: _react.PropTypes.string,
    contactUs: _react.PropTypes.string
  },

  loadAnnotatedBooksHandler: function loadAnnotatedBooksHandler() {
    _annotated_books_actions2.default.loadAnnotatedBooks(this.props.user.id);
  },
  componentWillMount: function componentWillMount() {
    if (this.props.ownerHasLinkedAmazonAccount) {
      _annotated_books_actions2.default.loadAnnotatedBooks(this.props.user.id);
    }
  },
  render: function render() {
    var state = this.state.annotatedBooksStore;
    var view = undefined;

    if (this.props.viewerIsOwner) {
      if (!this.props.ownerHasLinkedAmazonAccount) {
        view = this.renderUnlinkedView();
      } else if ((0, _lodash.isEmpty)(state.annotatedBooksCollection)) {
        if (state.showSpinner) {
          view = this.renderLoadingView();
        } else {
          view = this.renderEmptyOwnerView();
        }
      } else {
        view = this.renderOwnerCollection();
      }
    } else {
      if (!this.props.canViewProfile || !this.props.ownerHasLinkedAmazonAccount) {
        view = this.renderEmptyVisitorView();
      } else if ((0, _lodash.isEmpty)(state.annotatedBooksCollection)) {
        if (state.showSpinner) {
          view = this.renderLoadingView();
        } else {
          view = this.renderEmptyVisitorView();
        }
      } else {
        view = this.renderVisitorCollection();
      }
    }

    return _jsx("div", {
      className: "annotatedBooksPage"
    }, void 0, state.showError ? _jsx(_flash_message2.default, {
      category: "error",
      message: _reading_notes_helper.BOOK_LOAD_ERROR_MSG
    }) : null, view);
  },
  renderLoadingView: function renderLoadingView() {
    return _jsx("div", {
      className: "annotatedBooksPage__loading"
    }, void 0, _jsx(_spinner2.default, {}));
  },
  renderUnlinkedView: function renderUnlinkedView() {
    return _jsx("div", {
      className: "annotatedBooksPage__unlinked"
    }, void 0, _jsx("div", {
      className: "annotatedBooksPage__unlinked__gkLogo"
    }), _jsx("div", {}, void 0, _jsx("p", {
      className: "annotatedBooksPage__unlinked__description"
    }, void 0, "Link your Goodreads and Amazon accounts to access your Kindle notes and highlights on Goodreads."), _jsx("p", {
      className: "annotatedBooksPage__unlinked__learnMore"
    }, void 0, _jsx("a", {
      href: this.props.learnMore
    }, void 0, "Learn More about Kindle Notes & Highlights")), _jsx("p", {
      className: "annotatedBooksPage__unlinked__linkBtn"
    }, void 0, _jsx("a", {
      href: this.props.createLinking
    }, void 0, _jsx("button", {
      className: "gr-button gr-button--dark gr-button--fullWidth"
    }, void 0, "Connect your accounts")))));
  },
  renderEmptyOwnerView: function renderEmptyOwnerView() {
    return _jsx("div", {
      className: "annotatedBooksPage__empty"
    }, void 0, _jsx("div", {
      className: "annotatedBooksPage__empty__description"
    }, void 0, "It looks like you don’t have any Kindle ebooks with notes or highlights.", _jsx("a", {
      className: "annotatedBooksPage__empty__description__link",
      href: this.props.learnMore
    }, void 0, "Learn More"), "about Kindle Notes & Highlights and", _jsx("a", {
      className: "annotatedBooksPage__empty__description__link",
      href: this.props.contactUs
    }, void 0, "contact us"), "if you have any questions."), _jsx("div", {
      className: "annotatedBooksPage__empty__content"
    }, void 0, _jsx("div", {
      className: "annotatedBooksPage__empty__gkLogo"
    }), _jsx("p", {
      className: "annotatedBooksPage__emptyOwner__status"
    }, void 0, "Your Goodreads account is connected to your Amazon account."), _jsx("div", {
      className: "annotatedBooksPage__empty__updateLink"
    }, void 0, _jsx("a", {
      href: this.props.updateLinking
    }, void 0, "Update account linking"))));
  },

  // This should not occur since the visitor is linked to this page from
  // an already existing KNH set belonging to the owner. This means that
  // the owner already has notes shared, is linked and that the visitor already
  // belongs to the visibility group set in preferences.
  renderEmptyVisitorView: function renderEmptyVisitorView() {
    return _jsx("div", {
      className: "annotatedBooksPage__empty"
    }, void 0, _jsx("div", {
      className: "annotatedBooksPage__empty__description"
    }, void 0, this.props.user.firstName, " has not posted any Kindle Notes & Highlights yet.", _jsx("a", {
      className: "annotatedBooksPage__empty__description__link",
      href: this.props.learnMore
    }, void 0, "Learn More about Kindle Notes & Highlights")));
  },
  renderOwnerCollection: function renderOwnerCollection() {
    var state = this.state.annotatedBooksStore;
    return _jsx("div", {
      className: "annotatedBooksPage__collection"
    }, void 0, _jsx("div", {
      className: "annotatedBooksPage__collection__descriptionContainer"
    }, void 0, _jsx("div", {
      className: "annotatedBooksPage__collection__description"
    }, void 0, "It’s easy to review, edit, and share the notes and highlights you make in Kindle books."), _jsx("div", {
      className: "annotatedBooksPage__collection__description"
    }, void 0, "Below are all of the books in your Kindle Library with highlights, starting with the most recently updated.")), _jsx(_annotated_books_list2.default, {
      annotatedBooksCollection: state.annotatedBooksCollection
    }), this.renderLoadMore());
  },
  renderVisitorCollection: function renderVisitorCollection() {
    var state = this.state.annotatedBooksStore;
    return _jsx("div", {
      className: "annotatedBooksPage__collection"
    }, void 0, _jsx("div", {
      className: "annotatedBooksPage__collection__descriptionContainer"
    }, void 0, "Join in the conversation. View, like, and comment on ", this.props.user.firstName, "’s notes and highlights."), _jsx(_annotated_books_list2.default, {
      annotatedBooksCollection: state.annotatedBooksCollection
    }));
  },
  renderLoadMore: function renderLoadMore() {
    var state = this.state.annotatedBooksStore;
    return _jsx("div", {
      className: "annotatedBooksPage__collection__loadMoreContainer"
    }, void 0, state.showSpinner ? _jsx(_spinner2.default, {}) : state.nextToken ? _jsx("button", {
      className: "annotatedBooksPage__collection__loadMoreButton gr-button gr-button--dark",
      onClick: this.loadAnnotatedBooksHandler
    }, void 0, "Load More") : null);
  }
});

},{"../../modules/reading_notes/reading_notes_helper":18,"../../react_actions/reading_notes/annotated_books_actions":40,"../../react_stores/reading_notes/annotated_books_store":244,"../flash_message":100,"../gr_component_factory":102,"../shared/gr_prop_types":171,"../spinner":186,"./annotated_books_list":153,"lodash":"lodash","react":"react","reflux":"reflux"}],155:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _react = require("react");

var _author_follow_button = require("../author/author_follow_button");

var _author_follow_button2 = _interopRequireDefault(_author_follow_button);

var _shape_icon_values = require("../../modules/shape_icon_values");

var _user_follow_widget = require("../user/user_follow_widget");

var _user_follow_widget2 = _interopRequireDefault(_user_follow_widget);

var _user_icon = require("../user/user_icon");

var _user_icon2 = _interopRequireDefault(_user_icon);

var _user_profile_link = require("../user/user_profile_link");

var _user_profile_link2 = _interopRequireDefault(_user_profile_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ReadingNotesAnnotator",

  propTypes: {
    displayUser: _gr_prop_types2.default.user().isRequired,
    isSignedIn: React.PropTypes.bool.isRequired,
    showFollowWidget: _react.PropTypes.bool,
    signInRedirectUrl: React.PropTypes.string.isRequired
  },

  defaultProps: {
    showFollowWidget: false
  },

  renderFollowComponentIfNeeded: function renderFollowComponentIfNeeded() {
    if (this.props.showFollowWidget) {
      if (this.props.isSignedIn) {
        if (this.props.displayUser.authorId) {
          return _jsx(_author_follow_button2.default, {
            authorId: this.props.displayUser.authorId,
            className: "gr-button--small u-displayBlock"
          });
        } else {
          return _jsx(_user_follow_widget2.default, {
            displayUser: this.props.displayUser
          });
        }
      } else {
        return _jsx("a", {
          href: this.props.signInRedirectUrl,
          className: "gr-button gr-button--small gr-box gr-box--inline gr-box--marginRightSmall",
          rel: "nofollow"
        }, void 0, "Follow");
      }
    }
  },
  render: function render() {
    return _jsx("div", {
      className: "readingNotesAnnotator gr-mediaFlexbox gr-mediaFlexbox--alignItemsCenter"
    }, void 0, _jsx("div", {
      className: "readingNotesAnnotator__userIcon gr-mediaFlexbox__media"
    }, void 0, _jsx(_user_icon2.default, {
      user: this.props.displayUser,
      size: _shape_icon_values.ICON_SIZES.MEDIUM
    })), _jsx("div", {
      className: "gr-mediaFlexbox__desc"
    }, void 0, _jsx("div", {
      className: "readingNotesAnnotator__name"
    }, void 0, "by ", _jsx(_user_profile_link2.default, {
      user: this.props.displayUser,
      className: "u-defaultType"
    })), this.renderFollowComponentIfNeeded()));
  }
});

},{"../../modules/shape_icon_values":19,"../author/author_follow_button":71,"../gr_component_factory":102,"../shared/gr_prop_types":171,"../user/user_follow_widget":192,"../user/user_icon":193,"../user/user_profile_link":194,"react":"react"}],156:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _react = require("react");

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _reading_notes_annotator = require("./reading_notes_annotator");

var _reading_notes_annotator2 = _interopRequireDefault(_reading_notes_annotator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ReadingNotesHeader",

  propTypes: {
    user: _gr_prop_types2.default.user().isRequired,
    headline: _react.PropTypes.string.isRequired,
    isSignedIn: React.PropTypes.bool.isRequired,
    signInRedirectUrl: React.PropTypes.string.isRequired,
    viewerIsOwner: _react.PropTypes.bool.isRequired
  },

  renderAnnotator: function renderAnnotator() {
    if (!this.props.viewerIsOwner) {
      return _jsx(_reading_notes_annotator2.default, {
        displayUser: this.props.user,
        isSignedIn: this.props.isSignedIn,
        showFollowWidget: !this.props.viewerIsOwner,
        signInRedirectUrl: this.props.signInRedirectUrl
      });
    }
  },
  render: function render() {
    return _jsx("div", {
      className: "readingNotesHeader"
    }, void 0, _jsx("div", {
      className: "gr-h3 gr-h3--serif readingNotesHeader__headline"
    }, void 0, this.props.headline), this.renderAnnotator());
  }
});

},{"../gr_component_factory":102,"../shared/gr_prop_types":171,"./reading_notes_annotator":155,"react":"react"}],157:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*doc
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           title: Reading notes shelving modal
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           name: reading_notes_shelving_modal
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           category: React
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           This component contains the reading note shelving modal, which is shown when a user attempts to make a note and/or highlight
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           visible before shelving a book. There should only be one ReadingNotesShelvingModal per page. In order for the WTR to work properly,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           the UserShelvesStore and ShelvingsStore must be initialized.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Required props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * `book` (shape): Contains information about the book needed for the WTR button and book image
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * `id` (string): Book's ActiveRecord id
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * `title` (string): Title of the book
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * `imageUrl` (string): Image url for the book's cover
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ```rails_example
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           <% @book = Book.first %>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           <%= react_component 'ReactComponents.ReadingNotesShelvingModal',
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               {book: {id: @book.id, title: @book.title, imageUrl: @book.large_image_url}} %>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ```
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MESSAGE = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _modal = require("../modal");

var _modal2 = _interopRequireDefault(_modal);

var _want_to_read_button = require("../../react_components/want_to_read/want_to_read_button");

var _want_to_read_button2 = _interopRequireDefault(_want_to_read_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MESSAGE = exports.MESSAGE = "To make your notes and highlights visible, first add this book to one of your shelves.";

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ReadingNotesShelvingModal",

  propTypes: {
    book: _react2.default.PropTypes.shape({
      id: _react2.default.PropTypes.string.isRequired,
      title: _react2.default.PropTypes.string.isRequired,
      imageUrl: _react2.default.PropTypes.string.isRequired
    }).isRequired
  },

  renderModalContent: function renderModalContent() {
    return _jsx("div", {
      className: "gr-mediaFlexbox"
    }, void 0, _jsx("img", {
      className: "gr-mediaFlexbox__media u-marginRightMedium",
      src: this.props.book.imageUrl,
      alt: this.props.book.title
    }), _jsx("div", {
      className: "gr-mediaFlexbox__desc"
    }, void 0, _jsx("h3", {
      className: "gr-h3 gr-h3--noTopMargin gr-h3--serif"
    }, void 0, "Add your book"), _jsx("div", {
      className: "readingNotesShelvingModal__text"
    }, void 0, MESSAGE), _jsx(_want_to_read_button2.default, {
      bookId: this.props.book.id,
      bookTitle: this.props.book.title,
      uniqueId: "readingNotesShelvingModalWTR"
    })));
  },
  render: function render() {
    return _jsx(_modal2.default, {
      id: "readingNotesShelvingModal",
      bemModifiers: "readingNotesShelving"
    }, void 0, this.renderModalContent());
  }
});

},{"../../react_components/want_to_read/want_to_read_button":209,"../gr_component_factory":102,"../modal":136,"react":"react"}],158:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*doc
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           title: Reading notes shelving modal trigger
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           name: reading_notes_shelving_modal_trigger
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           category: React
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           This component contains the reading note shelving modal trigger, which wraps the given html (innerHtml prop) in
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           a ModalTrigger for the ReadingNotesShelvingModal IF the given book is unshelved. In this case, the innerHtml
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           will be made "unclickable" so the user must shelve the book before they are able to make KNH visible.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           If the book is shelved, this will simply render the innerHtml, which will function as expected.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           At the time of writing, we have two distinct features on the KNH owner view that need to trigger the
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ReadingNotesShelvingModal when clicked: the Share All KNH button in the banner, and each visibility toggle
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           for the individual reading notes. In the fullness of time, the button and the toggle may be rewritten in
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           React (as well as the entire page) and then we will not have to do strange/dangerous things with innerHtml.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           The ShelvingsStore must be populated in order for this to function correctly.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Required props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * `bookId` (string): Book's ActiveRecord id
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * `innerHtml` (string): Html to act as the modal trigger. Needs to be html_safe
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ```rails_example
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           <% book = Book.first %>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           <% html = "<div> Hey </div>" %>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           <%= react_component 'ReactComponents.ReadingNotesShelvingModalTrigger',
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               {bookId: book.id.to_s, innerHtml: html.html_safe} %>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ```
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _modal_trigger = require("../modal_trigger");

var _modal_trigger2 = _interopRequireDefault(_modal_trigger);

var _shelvings_store = require("../../react_stores/shelvings_store");

var _shelvings_store2 = _interopRequireDefault(_shelvings_store);

var _gr_reflux = require("../../react_mixins/gr_reflux");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ReadingNotesShelvingModalTrigger",

  propTypes: {
    bookId: _react2.default.PropTypes.string.isRequired,
    innerHtml: _react2.default.PropTypes.string.isRequired
  },
  mixins: [(0, _gr_reflux.connectToLazyStore)(_shelvings_store2.default, "bookId", { stateKey: "shelvings" })],

  renderInnerHtml: function renderInnerHtml() {
    return _jsx("span", {
      dangerouslySetInnerHTML: { __html: this.props.innerHtml }
    });
  },
  render: function render() {
    if (this.state.shelvings.exclusiveShelfName === null) {
      return _jsx(_modal_trigger2.default, {
        id: "readingNotesShelvingModal",
        bemModifiers: "readingNotesShelving"
      }, void 0, _jsx("div", {
        className: "readingNotesShelvingModalTrigger__unclickableInnerHtml"
      }, void 0, this.renderInnerHtml()));
    } else {
      return this.renderInnerHtml();
    }
  }
});

},{"../../react_mixins/gr_reflux":227,"../../react_stores/shelvings_store":247,"../gr_component_factory":102,"../modal_trigger":137,"react":"react"}],159:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WRITE_A_REVIEW = undefined;

var _react = require("react");

var _ajax_helper = require("../../modules/ajax/ajax_helper");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*doc
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               title: Write a review button
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               category: React
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               This component displays the "Write a review" button and also redirects to the destinationPath
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               on button click.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               In addition, if an actionType metric is provided, the event will be fired off to Clickstream.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               Required props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * `destinationPath`: The destination Url on clicking on the WTR button or rating widget
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               Optional props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * `bookId`: Clickstream event metadata
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * `actionType`: The Clickstream metric for the WTR button click
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

var WRITE_A_REVIEW = exports.WRITE_A_REVIEW = "Write a review";

var WriteAReviewButton = (function (_Component) {
  _inherits(WriteAReviewButton, _Component);

  function WriteAReviewButton(props) {
    _classCallCheck(this, WriteAReviewButton);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(WriteAReviewButton).call(this, props));
  }

  _createClass(WriteAReviewButton, [{
    key: "handleButtonClick",
    value: function handleButtonClick() {
      var _this2 = this;

      if (this.props.actionType && this.props.bookId) {
        var ratePostUrl = "/review/rateable";
        var ratePostData = {
          id: this.props.bookId
        };
        (0, _ajax_helper.httpGet)(ratePostUrl, {
          data: ratePostData
        }).done(function (promptValues, responseStatus) {
          if (responseStatus === "success") {
            (0, _ajax_helper.httpPost)("/track/track_clickstream", {
              data: {
                action_type: _this2.props.actionType,
                book_id: _this2.props.bookId
              }
            });
            window.location.assign(_this2.props.destinationPath);
          } else {
            if (xhr.status === 403 && xhr.getResponseHeader("errorType") === "frozen") {
              window.alert("This book has temporary limitations on submitting ratings and reviews. This may be because we've detected unusual behavior that doesn't follow our review guidelines.");
            } else if (xhr.status !== 403) {
              window.alert("There was an error saving your rating, please try again.");
            }
          }
        }).fail(function () {
          window.alert("There was an error saving your rating, please try again.");
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var classNames = "gr-button u-marginTopBottomXSmall " + this.props.className;
      return _jsx("button", {
        className: classNames,
        onClick: this.handleButtonClick.bind(this)
      }, void 0, WRITE_A_REVIEW);
    }
  }]);

  return WriteAReviewButton;
})(_react.Component);

exports.default = WriteAReviewButton;

WriteAReviewButton.propTypes = {
  destinationPath: _react.PropTypes.string.isRequired
};

},{"../../modules/ajax/ajax_helper":4,"react":"react"}],160:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _google_ad_helper = require("../modules/ads/google_ad_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ScrollTracker",

  propTypes: {
    trackedEventId: _react2.default.PropTypes.string.isRequired,
    viewportExpansion: _react2.default.PropTypes.number
  },

  getDefaultProps: function getDefaultProps() {
    return {
      viewportExpansion: 0
    };
  },
  componentDidMount: function componentDidMount() {
    var _this = this;

    (0, _google_ad_helper.lazyLoadOnView)(function (event) {
      if (event.target.id === _this.props.trackedEventId) {
        $j.post("/track/track", {
          tid: _this.props.trackedEventId
        });
      }
    });
  },
  render: function render() {
    return _jsx("div", {
      id: this.props.trackedEventId,
      className: "lazyload",
      "data-expand": "" + this.props.viewportExpansion
    });
  }
});

},{"../modules/ads/google_ad_helper":3,"./gr_component_factory":102,"react":"react"}],161:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();
/* react-onclickoutside is a deprecated package that should not be used for new
   code. Instead of having an outside click close a module, there should be an
   explicit close affordances in the spec. */

// STORE

// COMPONENTS

// MIXINS

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _reactOnclickoutside = require("react-onclickoutside");

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _keys = require("../../modules/keys");

var _keys2 = _interopRequireDefault(_keys);

var _book_search_store_factory = require("../../react_stores/book_search_store_factory");

var _book_search_store_factory2 = _interopRequireDefault(_book_search_store_factory);

var _book_search_results = require("./book_search_results");

var _book_search_results2 = _interopRequireDefault(_book_search_results);

var _spinner = require("../spinner");

var _spinner2 = _interopRequireDefault(_spinner);

var _factory_store_mixin = require("../../react_mixins/factory_store_mixin");

var _factory_store_mixin2 = _interopRequireDefault(_factory_store_mixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DELAYED_SEARCH_MS = 300;

exports.default = _gr_component_factory2.default.createClass({
  displayName: "BookSearch",

  mixins: [_reactOnclickoutside2.default, _reflux2.default.ListenerMixin, (0, _factory_store_mixin2.default)(_book_search_store_factory2.default)],

  propTypes: {
    autoFocus: _react2.default.PropTypes.bool,
    onChooseResult: _react2.default.PropTypes.func.isRequired,
    maxResults: _react2.default.PropTypes.number,
    shelfName: _react2.default.PropTypes.string,
    searchPath: _react2.default.PropTypes.string.isRequired,
    closeAfterResultChosen: _react2.default.PropTypes.bool,
    autocompleteUrl: _react2.default.PropTypes.string.isRequired,
    signedIn: _react2.default.PropTypes.bool,
    deviceType: _react2.default.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      autoFocus: false,
      maxResults: 5,
      closeAfterResultChosen: false
    };
  },
  componentDidMount: function componentDidMount() {
    var _this = this;

    this.delayedSearch = _lodash2.default.debounce(function (event) {
      _this.actions.search(event.target.value, _this.props.autocompleteUrl);
    }, DELAYED_SEARCH_MS);
    this.signedInStr = this.props.signedIn ? "SignedIn" : "SignedOut";
  },
  hide: function hide() {
    this.actions.setShowResultsContainer(false);
  },
  show: function show() {
    this.actions.setShowResultsContainer(true);
  },
  handleClickOutside: function handleClickOutside() {
    this.hide();
  },
  handleSearch: function handleSearch(event) {
    this.setState({ searchBoxValue: event.target.value });

    if (!_lodash2.default.isEmpty(event.target.value)) {
      event.persist();
      this.delayedSearch(event);
    } else {
      this.hide();
    }
  },
  handleClick: function handleClick(event) {
    if (!_lodash2.default.isEmpty(this.state.query)) {
      this.handleSearch(event);
    }
  },
  handleChoice: function handleChoice(book) {
    $j.post("/track/track_click", {
      feature: "NavSearch:" + this.props.deviceType + ":" + this.signedInStr + ":suggestion_click",
      pmet_value: book.rank
    });

    this.props.onChooseResult(book);
    if (this.props.closeAfterResultChosen) {
      this.hide();
    }
  },

  // Note: This method manipulates a datastore of the book objects, marking one as "active," which triggers
  //       book_search_result (which is listening) to add a special class. Only problem is that we don't know
  //       which link element is currently selected, so we can't trigger a click on the active one when a user
  //       presses Enter. Which is why the current method does a hard window.location move when an item is
  //       activated, which is all kinds of wrong. The implementation of this entire component set prevents
  //       normal browser behavior, and for that reason this should be re-engineered from the ground up. -Joey
  handleKeyPress: function handleKeyPress(event) {
    var maxResults = Math.min(this.props.maxResults, this.state.results.length);
    if (_keys2.default.isEnter(event.keyCode)) {
      if (this.state.activeResult !== null) {
        this.handleChoice(this.state.activeResult);
        event.preventDefault();
      } else if (_lodash2.default.isEmpty(event.target.value)) {
        event.preventDefault();
      }
    } else if (_keys2.default.isArrowDown(event.keyCode)) {
      this.actions.selectNextResult(maxResults);
    } else if (_keys2.default.isArrowUp(event.keyCode)) {
      this.actions.selectPreviousResult(maxResults);
    } else if (_keys2.default.isEscape(event.keyCode)) {
      this.hide();
    }
  },
  logSubmit: function logSubmit() {
    $j.post("/track/track_click", { feature: "NavSearch:" + this.props.deviceType + ":" + this.signedInStr + ":see_all_click" });
  },
  renderInputIcon: function renderInputIcon() {
    var searchSpinnerClasses = this.withBemModifiers("searchBox__icon", "loadingSpinner");
    var searchIconClasses = (0, _classnames2.default)("searchBox__icon--magnifyingGlass gr-iconButton", this.withBemModifiers("searchBox__icon"));
    if (this.state.showLoadingSpinner) {
      return _jsx("span", {
        className: searchSpinnerClasses
      }, void 0, _jsx(_spinner2.default, {}));
    } else {
      return _jsx("button", {
        type: "submit",
        className: searchIconClasses,
        "aria-label": "Search"
      });
    }
  },
  renderResultsContainer: function renderResultsContainer() {
    if (!_lodash2.default.isEmpty(this.state.query)) {
      return _react2.default.createElement(_book_search_results2.default, _extends({}, this.props, this.state, {
        onChooseResult: this.handleChoice,
        mouseoverAction: this.actions.selectSpecificResult
      }));
    }
  },
  render: function render() {
    var searchBoxClasses = (0, _classnames2.default)(this.withBemModifiers("searchBox"));
    var searchInputClasses = (0, _classnames2.default)(this.withBemModifiers("searchBox__input"));

    return _jsx("div", {
      acceptCharset: "UTF-8",
      className: searchBoxClasses,
      onKeyDown: this.handleKeyPress
    }, void 0, _jsx("form", {
      autoComplete: "off",
      action: this.props.searchPath,
      className: "searchBox__form",
      role: "search",
      "aria-label": "Search for books to add to your shelves",
      onSubmit: this.logSubmit
    }, void 0, _jsx("input", {
      className: searchInputClasses,
      autoComplete: "off",
      autoFocus: this.props.autoFocus,
      name: "q",
      type: "text",
      placeholder: "Search books",
      "aria-label": "Search books",
      onFocus: this.show,
      onClick: this.handleClick,
      onChange: this.handleSearch,
      value: this.state.searchBoxValue,
      "aria-controls": "searchResults"
    }), _jsx("input", {
      type: "hidden",
      name: "qid",
      value: this.state.results.length > 0 ? this.state.results[0].qid : ""
    }), this.renderInputIcon(), this.state.showResultsContainer ? this.renderResultsContainer() : null));
  }
});

},{"../../modules/keys":16,"../../react_mixins/factory_store_mixin":226,"../../react_stores/book_search_store_factory":233,"../gr_component_factory":102,"../spinner":186,"./book_search_results":163,"classnames":"classnames","lodash":"lodash","react":"react","react-onclickoutside":"react-onclickoutside","reflux":"reflux"}],162:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _author_badge = require("../author/author_badge");

var _author_badge2 = _interopRequireDefault(_author_badge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "BookSearchResult",

  propTypes: {
    book: _gr_prop_types2.default.book({ qid: _react2.default.PropTypes.string, rank: _react2.default.PropTypes.number }).isRequired,
    onChooseResult: _react2.default.PropTypes.func.isRequired
  },

  render: function render() {
    var _this = this;

    var linkClasses = (0, _classnames2.default)("gr-mediaFlexbox", "gr-book--navbar", "gr-hyperlink", "gr-hyperlink--naked", "gr-hyperlink--noUnderline", "gr-bookSearchResults__result");
    // Note: We should be adding a url to the href attribute on these links elements, but we can't
    //       because there are JS handlers up and down this component chain that hijack normal link
    //       element behavior. That should not be - this whole thing should be re-engineered to make
    //       better use of default browser behavior.
    return _jsx("a", {
      className: linkClasses,
      href: "#",
      "aria-label": "Search result",
      onClick: function onClick() {
        _this.props.onChooseResult(_this.props.book);
      }
    }, void 0, _jsx("img", {
      className: "gr-mediaFlexbox__media",
      src: this.props.book.imageUrl,
      alt: ""
    }), _jsx("div", {
      className: "gr-mediaFlexbox__desc"
    }, void 0, _jsx("div", {
      className: "gr-book__title gr-book__title--navbar u-defaultType"
    }, void 0, this.props.book.title), _jsx("div", {
      className: "gr-book__author gr-book__author--navbar"
    }, void 0, "by ", this.props.book.author.name, _react2.default.createElement(_author_badge2.default, this.props.book.author))));
  }
});

},{"../author/author_badge":70,"../gr_component_factory":102,"../shared/gr_prop_types":171,"classnames":"classnames","react":"react"}],163:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _drop_down_list = require("../drop_down_list");

var _drop_down_list2 = _interopRequireDefault(_drop_down_list);

var _book_search_result = require("./book_search_result");

var _book_search_result2 = _interopRequireDefault(_book_search_result);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "BookSearchResults",

  propTypes: {
    maxResults: _react2.default.PropTypes.number.isRequired,
    query: _react2.default.PropTypes.string,
    results: _react2.default.PropTypes.array.isRequired,
    shelfName: _react2.default.PropTypes.string,
    searchPath: _react2.default.PropTypes.string,
    onChooseResult: _react2.default.PropTypes.func.isRequired,
    mouseoverAction: _react2.default.PropTypes.func.isRequired,
    activeResult: _react2.default.PropTypes.shape({
      title: _react2.default.PropTypes.string.isRequired,
      bookId: _react2.default.PropTypes.string.isRequired
    }),
    signedIn: _react2.default.PropTypes.string,
    deviceType: _react2.default.PropTypes.string
  },

  componentDidMount: function componentDidMount() {
    $j.post("/track/track_click", { feature: "NavSearch:" + this.props.deviceType + ":" + (this.props.signedIn ? "SignedIn" : "SignedOut") + ":overlay_shown" });
  },
  renderLastSearchResultItem: function renderLastSearchResultItem(text) {
    var searchResultsLastItemClasses = (0, _classnames2.default)("gr-buttonAsLink", "gr-bookSearchResults__lastItem", this.withBemElement("gr-bookSearchResults", "lastItem"));

    return _jsx("button", {
      className: searchResultsLastItemClasses,
      type: "submit"
    }, void 0, text);
  },
  render: function render() {
    var _this = this;

    var searchResultsClasses = (0, _classnames2.default)(this.withBemModifiers("gr-bookSearchResults"), "gr-box", "gr-box--withShadow");

    return _jsx("div", {
      className: searchResultsClasses,
      id: "bookSearchResults" + this.props.query + this.props.results.length,
      "aria-live": "polite",
      "aria-label": "Book search results"
    }, void 0, _jsx(_drop_down_list2.default, {
      maxListItems: this.props.maxResults
    }, void 0, this.props.results.length > 0 ? _lodash2.default.map(_lodash2.default.slice(this.props.results, 0, this.props.maxResults), function (result) {
      return _jsx("div", {
        className: (0, _classnames2.default)("gr-bookSearchResults__item", { "gr-bookSearchResults__item--active": result === _this.props.activeResult }),
        onMouseOver: function onMouseOver() {
          _this.props.mouseoverAction(result.bookId);
        }
      }, result.bookId, _jsx(_book_search_result2.default, {
        book: result,
        onChooseResult: _this.props.onChooseResult
      }));
    }) : this.renderLastSearchResultItem("Search for \"" + this.props.query + "\"…"), this.props.results.length > 0 ? this.renderLastSearchResultItem("See all results for \"" + this.props.query + "\"") : null));
  }
});

},{"../drop_down_list":89,"../gr_component_factory":102,"./book_search_result":162,"classnames":"classnames","lodash":"lodash","react":"react"}],164:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _nav_search = require("../header/nav_search");

var _nav_search2 = _interopRequireDefault(_nav_search);

var _search_toggle = require("../search/search_toggle");

var _search_toggle2 = _interopRequireDefault(_search_toggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "SearchMobileNav",

  propTypes: {
    autocompleteUrl: _react2.default.PropTypes.string.isRequired,
    searchPath: _react2.default.PropTypes.string.isRequired
  },

  render: function render() {
    return _jsx("div", {
      className: "siteHeader__primaryNavSeparateLine siteHeader__primaryNavSeparateLine--search"
    }, void 0, _react2.default.createElement(_nav_search2.default, _extends({}, this.props, {
      autoFocus: true,
      bemModifiers: "primaryNavSeparateLine" })), _jsx(_search_toggle2.default, {
      toggleType: _search_toggle.SEARCH_TOGGLE_TYPES.CANCEL
    }));
  }
});

},{"../gr_component_factory":102,"../header/nav_search":113,"../search/search_toggle":165,"react":"react"}],165:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = exports.component = exports.SEARCH_TOGGLE_TYPES = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _lodash = require("lodash");

var _search_actions = require("../../react_actions/header/search_actions");

var _touch_not_ready_helper = require("../../modules/shared/touch_not_ready_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SEARCH_TOGGLE_TYPES = exports.SEARCH_TOGGLE_TYPES = {
  ICON: "icon",
  CANCEL: "Cancel"
};

var component = exports.component = _gr_component_factory2.default.createClass({
  displayName: "SearchToggle",

  propTypes: {
    searchIsActive: _react2.default.PropTypes.bool.isRequired,
    toggleType: _react2.default.PropTypes.oneOf((0, _lodash.values)(SEARCH_TOGGLE_TYPES)),
    onToggleSearch: _react2.default.PropTypes.func.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return { searchIsActive: false };
  },
  toggleSearch: function toggleSearch(event) {
    (0, _touch_not_ready_helper.acknowledgeEvent)(event);
    return this.props.onToggleSearch(!this.props.searchIsActive);
  },
  hideSearch: function hideSearch() {
    return this.props.onToggleSearch(false);
  },
  render: function render() {
    switch (this.props.toggleType) {
      case SEARCH_TOGGLE_TYPES.ICON:
        return _jsx("button", {
          className: "siteHeader__searchIcon gr-iconButton",
          onClick: this.toggleSearch,
          "aria-label": "Toggle search",
          type: "button",
          "data-ux-click": true
        });
      case SEARCH_TOGGLE_TYPES.CANCEL:
        return _jsx("button", {
          className: "gr-buttonAsLink",
          onClick: this.hideSearch,
          "aria-label": "Hide search",
          type: "button"
        }, void 0, SEARCH_TOGGLE_TYPES.CANCEL);
      default:
        return null;
    }
  }
});

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return Object.assign({}, ownProps, state);
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onToggleSearch: function onToggleSearch(searchIsActive) {
      return dispatch((0, _search_actions.toggleSearch)(searchIsActive));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(component);

},{"../../modules/shared/touch_not_ready_helper":21,"../../react_actions/header/search_actions":35,"../gr_component_factory":102,"lodash":"lodash","react":"react","react-redux":"react-redux"}],166:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _shape_icon_values = require("../modules/shape_icon_values");

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ShapeIcon",

  propTypes: {
    imageUrl: _react2.default.PropTypes.string.isRequired,
    imageAlt: _react2.default.PropTypes.string.isRequired,
    includeLink: _react2.default.PropTypes.bool,
    linkUrl: _react2.default.PropTypes.string,
    size: _react2.default.PropTypes.oneOf((0, _lodash.values)(_shape_icon_values.ICON_SIZES)),
    shape: _react2.default.PropTypes.oneOf((0, _lodash.values)(_shape_icon_values.ICON_SHAPES)),
    border: _react2.default.PropTypes.bool
  },

  getShapeClass: function getShapeClass() {
    var modifier = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];

    var name = this.props.shape + "Icon";
    if (modifier) {
      name += "--" + modifier;
    }
    return name;
  },
  getDefaultProps: function getDefaultProps() {
    return {
      includeLink: false,
      size: _shape_icon_values.ICON_SIZES.SMALL,
      shape: _shape_icon_values.ICON_SHAPES.CIRCLE,
      border: false
    };
  },
  render: function render() {
    var _classNames;

    var classes = (0, _classnames2.default)(this.props.className, (_classNames = {}, _defineProperty(_classNames, "" + this.getShapeClass(), true), _defineProperty(_classNames, "" + this.getShapeClass("medium"), this.props.size === _shape_icon_values.ICON_SIZES.MEDIUM), _defineProperty(_classNames, "" + this.getShapeClass("large"), this.props.size === _shape_icon_values.ICON_SIZES.LARGE), _defineProperty(_classNames, "" + this.getShapeClass("border"), this.props.border), _classNames));

    if (this.props.includeLink && this.props.linkUrl) {
      return _jsx("a", {
        href: this.props.linkUrl
      }, void 0, _jsx("img", {
        className: classes,
        src: this.props.imageUrl,
        alt: this.props.imageAlt
      }));
    } else {
      return _jsx("img", {
        className: classes,
        src: this.props.imageUrl,
        alt: this.props.imageAlt
      });
    }
  }
});

},{"../modules/shape_icon_values":19,"./gr_component_factory":102,"classnames":"classnames","lodash":"lodash","react":"react"}],167:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ShareButton",

  propTypes: {
    textLabel: _react2.default.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return { textLabel: "Share" };
  },
  render: function render() {
    return _jsx("button", {
      className: "gr-shareButton",
      type: "button"
    }, void 0, _jsx("span", {
      className: "gr-shareButton__innerWrapper"
    }, void 0, _jsx("span", {
      className: "gr-shareButton__icon"
    }), _jsx("span", {
      className: "gr-shareButton__textLabel"
    }, void 0, this.props.textLabel)));
  }
});

},{"./gr_component_factory":102,"react":"react"}],168:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

// Preview Components

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("./shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _modal_trigger = require("./modal_trigger");

var _modal_trigger2 = _interopRequireDefault(_modal_trigger);

var _share_button = require("./share_button");

var _share_button2 = _interopRequireDefault(_share_button);

var _modal = require("./modal");

var _modal2 = _interopRequireDefault(_modal);

var _share_social = require("./share_social");

var _share_social2 = _interopRequireDefault(_share_social);

var _string_counter = require("./user_content/string_counter");

var _string_counter2 = _interopRequireDefault(_string_counter);

var _share_dialog_store = require("../react_stores/share_dialog_store");

var _share_dialog_store2 = _interopRequireDefault(_share_dialog_store);

var _share_dialog_actions = require("../react_actions/share_dialog_actions");

var _share_dialog_actions2 = _interopRequireDefault(_share_dialog_actions);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _env_utils = require("../modules/env_utils");

var _env_utils2 = _interopRequireDefault(_env_utils);

var _flash_message = require("./flash_message");

var _flash_message2 = _interopRequireDefault(_flash_message);

var _share_dialog_book_preview = require("./sharing/previews/share_dialog_book_preview");

var _share_dialog_book_preview2 = _interopRequireDefault(_share_dialog_book_preview);

var _share_dialog_topic_preview = require("./sharing/previews/share_dialog_topic_preview");

var _share_dialog_topic_preview2 = _interopRequireDefault(_share_dialog_topic_preview);

var _share_dialog_blog_preview = require("./sharing/previews/share_dialog_blog_preview");

var _share_dialog_blog_preview2 = _interopRequireDefault(_share_dialog_blog_preview);

var _share_dialog_interview_preview = require("./sharing/previews/share_dialog_interview_preview");

var _share_dialog_interview_preview2 = _interopRequireDefault(_share_dialog_interview_preview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ShareDialog",

  mixins: [_reflux2.default.connect(_share_dialog_store2.default, "sharingDialog")],

  propTypes: _gr_prop_types2.default.shareDialog(),

  getDefaultProps: function getDefaultProps() {
    return {
      includePreview: false
    };
  },
  getInitialState: function getInitialState() {
    return {
      uniqueId: Math.random(1000000)
    };
  },
  getResourceTypeIdentifier: function getResourceTypeIdentifier() {
    return this.props.sharingData.resourceTypeFriendlyText.replace(/\s/g, "").toLowerCase();
  },
  getShareModalId: function getShareModalId() {
    return "share-" + this.getResourceTypeIdentifier() + "-modal" + this.state.uniqueId;
  },
  socialExists: function socialExists(location) {
    return this.props.social[location].facebook || this.props.social[location].twitter || this.props.social[location].pinterest || this.props.social[location].copyLink;
  },

  // Optional preview components go here
  renderPreview: function renderPreview() {
    if (this.props.includePreview) {
      var preview = undefined;
      var friendlyResourceName = this.props.sharingData.resourceTypeFriendlyText;

      // add a case for your resource's friendly name here
      switch (friendlyResourceName) {
        case "book":
          preview = React.createElement(_share_dialog_book_preview2.default, this.props.previewData);
          break;
        case "discussion":
          preview = React.createElement(_share_dialog_topic_preview2.default, this.props.previewData);
          break;
        case "blog":
          preview = React.createElement(_share_dialog_blog_preview2.default, this.props.previewData);
          break;
        case "interview":
          preview = React.createElement(_share_dialog_interview_preview2.default, this.props.previewData);
          break;
        default:
        // do nothing
      }

      if (preview) {
        return preview;
      }
    } else {
      return null;
    }
  },
  renderSocialInModal: function renderSocialInModal(socialPromptStart) {
    if (this.socialExists("inModal")) {
      var socialPrompt = socialPromptStart + " share on:";
      return _jsx("div", {
        className: "shareModal__socialContainer"
      }, void 0, _jsx("div", {
        className: "shareModal__socialPrompt"
      }, void 0, socialPrompt), React.createElement(_share_social2.default, _extends({}, this.props.social.inModal, {
        bemModifiers: "modal",
        fbOptions: this.props.social.fbOptions,
        twitterOptions: this.props.social.twitterOptions,
        pinterestOptions: this.props.social.pinterestOptions,
        metricName: this.getResourceTypeIdentifier() + "_sharingModal" })));
    } else {
      return null;
    }
  },
  renderCharacterCounter: function renderCharacterCounter() {
    var text = this.state.sharingDialog.sharingTextInputValue || "";

    return _jsx(_string_counter2.default, {
      counterType: "character",
      maxLength: _share_dialog_store.MAXIMUM_SHARING_TEXT_LENGTH,
      warnLength: _share_dialog_store.WARNING_SHARING_TEXT_LENGTH,
      text: text
    });
  },
  handleShare: function handleShare() {
    var data = this.props.sharingData;
    var value = this.state.sharingDialog.sharingTextInputValue;
    _share_dialog_actions2.default.submitShare(data, value);
  },
  renderSharePrompt: function renderSharePrompt() {
    var bottomClassNames = (0, _classnames2.default)("shareModal__bottomContainer", { "shareModal__bottomContainer--noSocial": !this.socialExists("inModal"),
      "shareModal__bottomContainer--social": this.socialExists("inModal") });
    return _jsx("span", {
      className: "shareModal"
    }, void 0, _jsx("h2", {
      className: "gr-h3 gr-h3--serif shareModal__heading"
    }, void 0, "Share this ", this.props.sharingData.resourceTypeFriendlyText, " on Goodreads"), this.renderShareError(), _jsx("textarea", {
      "aria-label": "Share text",
      placeholder: "Say something about this " + this.props.sharingData.resourceTypeFriendlyText + "...",
      value: this.state.sharingDialog.sharingTextInputValue,
      onChange: function onChange(e) {
        _share_dialog_actions2.default.updateSharingTextInputValue(e.target.value);
      },
      className: "gr-textInput shareModal__textInput"
    }), this.renderCharacterCounter(), this.renderPreview(), _jsx("button", {
      className: "gr-button gr-button--Large shareModal__button",
      onClick: this.handleShare,
      type: "button",
      disabled: this.state.sharingDialog.shareModalButtonDisabled
    }, void 0, "Share"), _jsx("div", {
      className: bottomClassNames
    }, void 0, this.renderSocialInModal("Or")));
  },
  renderShareSuccess: function renderShareSuccess() {
    return _jsx("span", {
      className: "shareModal"
    }, void 0, _jsx("h2", {
      className: "gr-h3 gr-h3--serif shareModal__heading"
    }, void 0, "Shared!"), _jsx("h3", {
      className: "gr-hyperlink shareModal__link"
    }, void 0, _jsx("a", {
      href: this.state.sharingDialog.sharingUrl,
      "aria-label": "Link to " + this.state.sharingDialog.sharingDisplayName
    }, void 0, "View post")), _jsx("div", {
      className: "shareModal__bottomContainer shareModal__bottomContainer--shared"
    }, void 0, this.renderSocialInModal("Also")));
  },
  renderShareError: function renderShareError() {
    if (this.state.sharingDialog.error) {
      var resourceType = this.props.sharingData.resourceTypeFriendlyText;
      var flashMessage = this.state.sharingDialog.errorText || "Something went wrong, and your " + resourceType + " wasn't shared. Please try again later.";
      return _jsx(_flash_message2.default, {
        category: "error",
        message: flashMessage
      });
    } else {
      return null;
    }
  },
  renderModalContent: function renderModalContent() {
    if (this.state.sharingDialog.shared) {
      return this.renderShareSuccess();
    } else {
      return this.renderSharePrompt();
    }
  },
  renderSocialOutsideModal: function renderSocialOutsideModal() {
    if (this.socialExists("outsideModal")) {
      return React.createElement(_share_social2.default, _extends({}, this.props.social.outsideModal, {
        fbOptions: this.props.social.fbOptions,
        twitterOptions: this.props.social.twitterOptions,
        pinterestOptions: this.props.social.pinterestOptions,
        metricName: this.getResourceTypeIdentifier() + "_shareModuleBar",
        bemModifiers: "shareBar" }));
    } else {
      return null;
    }
  },
  shouldRedirect: function shouldRedirect() {
    return this.props.signInUrl && !this.props.signedIn;
  },
  handleClick: function handleClick() {
    if (this.shouldRedirect()) {
      this.redirectToSignIn();
    } else {
      _share_dialog_actions2.default.openShareModal(this.getResourceTypeIdentifier());
    }
  },
  getSignInUrl: function getSignInUrl() {
    var currentPath = _env_utils2.default.getCurrentPath();
    return this.props.signInUrl + "?returnurl=" + currentPath;
  },
  redirectToSignIn: function redirectToSignIn() {
    _env_utils2.default.setLocationUrl(this.getSignInUrl());
  },

  // prevents modal from opening while redirecting to login if user is signed out
  renderModal: function renderModal() {
    if (this.shouldRedirect()) {
      return null;
    } else {
      return _jsx(_modal2.default, {
        id: this.getShareModalId(),
        bemModifiers: "share"
      }, void 0, this.renderModalContent());
    }
  },
  render: function render() {
    return _jsx("div", {}, void 0, this.renderModal(), _jsx("div", {
      className: "shareModuleBar"
    }, void 0, _jsx(_modal_trigger2.default, {
      id: this.getShareModalId(),
      clickHandler: this.handleClick,
      bemModifiers: "shareModule"
    }, void 0, _jsx(_share_button2.default, {})), this.renderSocialOutsideModal()));
  }
});

},{"../modules/env_utils":13,"../react_actions/share_dialog_actions":42,"../react_stores/share_dialog_store":245,"./flash_message":100,"./gr_component_factory":102,"./modal":136,"./modal_trigger":137,"./share_button":167,"./share_social":169,"./shared/gr_prop_types":171,"./sharing/previews/share_dialog_blog_preview":176,"./sharing/previews/share_dialog_book_preview":177,"./sharing/previews/share_dialog_interview_preview":178,"./sharing/previews/share_dialog_topic_preview":180,"./user_content/string_counter":198,"classnames":"classnames","reflux":"reflux"}],169:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*doc
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           title: Share social
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           name: share_social
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           category: React
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           This component displays sharing buttons for external social platforms and a copy link button.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Platforms supported:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             - Facebook
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             - Twitter
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             - Pinterest
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Required props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             None
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Optional props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `facebook` (bool): Inclusion/exclusion switch for Facebook sharing
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               default: false
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `twitter` (bool): Inclusion/exclusion switch for Twitter sharing
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               default: false
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `pinterest` (bool): Inclusion/exclusion switch for Pinterest sharing
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               default: false
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `copyLink` (bool): Inclusion/exclusion switch for copy link button
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               default: false
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `fbOptions` (object): Options for facebook share, generated with fb_feed_options
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `twitterOptions` (object): Options for twitter share (text, url)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `pinterestOptions` (object): Options for pinterest share (description, url, media)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `metricName` (string): Full name or modifier for metric name
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               default: ""
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

// TODO-GR-38350, add copy link functionality

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _facebook_share = require("./sharing/facebook_share");

var _facebook_share2 = _interopRequireDefault(_facebook_share);

var _twitter_share = require("./sharing/twitter_share");

var _twitter_share2 = _interopRequireDefault(_twitter_share);

var _pinterest_share = require("./sharing/pinterest_share");

var _pinterest_share2 = _interopRequireDefault(_pinterest_share);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ShareSocial",

  propTypes: {
    facebook: _react2.default.PropTypes.bool,
    twitter: _react2.default.PropTypes.bool,
    pinterest: _react2.default.PropTypes.bool,
    copyLink: _react2.default.PropTypes.bool,
    fbOptions: _react2.default.PropTypes.object,
    twitterOptions: _react2.default.PropTypes.object,
    pinterestOptions: _react2.default.PropTypes.object,
    metricName: _react2.default.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      facebook: false,
      twitter: false,
      pinterest: false,
      copyLink: false,
      metricName: ""
    };
  },
  renderSocialPlatform: function renderSocialPlatform(platform) {
    if (this.props[platform]) {
      var fullMetricName = "SocialSharing_" + this.props.metricName + "_" + platform;
      switch (platform) {
        case "facebook":
          return _jsx(_facebook_share2.default, {
            options: this.props.fbOptions,
            metricName: fullMetricName,
            bemModifiers: this.props.bemModifiers
          });
        case "twitter":
          return _jsx(_twitter_share2.default, {
            options: this.props.twitterOptions,
            metricName: fullMetricName,
            bemModifiers: this.props.bemModifiers
          });
        case "pinterest":
          return _jsx(_pinterest_share2.default, {
            options: this.props.pinterestOptions,
            metricName: fullMetricName,
            bemModifiers: this.props.bemModifiers
          });
      }
    } else {
      return null;
    }
  },
  render: function render() {
    var classes = (0, _classnames2.default)(this.withBemModifiers("shareSocialButtons"), this.props.className);
    return _jsx("div", {
      className: classes
    }, void 0, this.renderSocialPlatform("facebook"), this.renderSocialPlatform("twitter"), this.renderSocialPlatform("pinterest"));
  }
});

},{"./gr_component_factory":102,"./sharing/facebook_share":174,"./sharing/pinterest_share":175,"./sharing/twitter_share":181,"classnames":"classnames","react":"react"}],170:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Cookie manipulation functions. Originally copied from javascripts/shared_all
// formats/cookies with the intention to replace with the react-cookies package,
// but that never happened.

exports.default = {
  get: function get(name) {
    var value = null;
    var $j = window.$j;
    if ($j) {
      $j.each(document.cookie.split("; "), function (i, cookie) {
        var cookiePair = cookie.split("=");
        if (cookiePair[0] === name) {
          value = cookiePair[1];
        }
      });
    }
    return value;
  },
  set: function set(name, value, daysToExpire) {
    daysToExpire = daysToExpire || 365;

    var date = new Date();
    date.setTime(date.getTime() + daysToExpire * 24 * 60 * 60 * 1000);
    var expires = "; expires=" + date.toGMTString();
    document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/";
  }
};

},{}],171:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dateValidator = function dateValidator(props, propName, componentName) {
  var value = props[propName];
  var coercedValue = _lodash2.default.isString(value) ? new Date(value) : value;
  if (!_lodash2.default.isDate(coercedValue) || _lodash2.default.isNaN(coercedValue.getTime())) {
    return new Error("Property '" + propName + "' must be a Date. " + componentName + " was supplied: '" + value + "'.");
  }
};

var naturalNumberValidator = function naturalNumberValidator(props, propName, componentName) {
  var value = props[propName];
  if (value <= 0) {
    return new Error("Property '" + propName + "' must be > 0. " + componentName + " was supplied: '" + value + "'.");
  }
};

// adapted from ReactPropTypes.js since it's not exported publicly
function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName) {
    /* istanbul ignore next */
    if (!componentName) {
      componentName = "<<anonymous>>";
    }
    if (_lodash2.default.isNull(props[propName]) || _lodash2.default.isUndefined(props[propName])) {
      if (isRequired) {
        return new Error("Required property `" + propName + "` was not specified in " + ("`" + componentName + "`."));
      }
      return null;
    } else {
      return validate(props, propName, componentName);
    }
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}

var merge = function merge(oldValue, newValue) {
  return _lodash2.default.merge({}, oldValue, newValue);
};

var user = function user() {
  var props = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var defaultProps = {
    viewableName: _react2.default.PropTypes.string.isRequired,
    profileImage: _react2.default.PropTypes.string.isRequired,
    profileUrl: _react2.default.PropTypes.string,
    informalName: _react2.default.PropTypes.string
  };

  return _react2.default.PropTypes.shape(merge(defaultProps, props));
};

var book = function book() {
  var props = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var defaultProps = {
    bookId: _react2.default.PropTypes.string,
    workId: _react2.default.PropTypes.string,
    bookUrl: _react2.default.PropTypes.string,
    authorName: _react2.default.PropTypes.string,
    title: _react2.default.PropTypes.string,
    imageUrl: _react2.default.PropTypes.string,
    numPages: _react2.default.PropTypes.number
  };

  return _react2.default.PropTypes.shape(merge(defaultProps, props));
};

var bookDescription = function bookDescription() {
  var props = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var defaultProps = truncatedHtml();

  return _react2.default.PropTypes.shape(merge(defaultProps, props));
};

var author = function author() {
  return _react2.default.PropTypes.shape({
    id: _react2.default.PropTypes.number.isRequired,
    name: _react2.default.PropTypes.string.isRequired,
    isGoodreadsAuthor: _react2.default.PropTypes.bool,
    profileImage: _react2.default.PropTypes.string,
    profileUrl: _react2.default.PropTypes.string.isRequired
  });
};

var expandableHtml = function expandableHtml() {
  return {
    html: _react2.default.PropTypes.string.isRequired,
    truncatedHtml: _react2.default.PropTypes.string
  };
};

var truncatedHtml = function truncatedHtml() {
  return {
    html: _react2.default.PropTypes.string,
    fullContentUrl: _react2.default.PropTypes.string,
    fullContentText: _react2.default.PropTypes.string,
    truncated: _react2.default.PropTypes.bool.isRequired,
    className: _react2.default.PropTypes.string,
    bookDescriptionTargetingData: _react2.default.PropTypes.object
  };
};

var friendNewsfeedResource = function friendNewsfeedResource() {
  return _react2.default.PropTypes.shape({
    user: user().isRequired,
    friendUser: user().isRequired,
    isMyFriend: _react2.default.PropTypes.bool.isRequired,
    addFriendUrl: _react2.default.PropTypes.string,
    compareBooksUrl: _react2.default.PropTypes.string,
    ratingDetailsText: _react2.default.PropTypes.string,
    currentlyReadingBook: book()
  });
};

var userFollowingNewsfeedResource = function userFollowingNewsfeedResource() {
  return _react2.default.PropTypes.shape({
    user: user().isRequired,
    followingUser: user().isRequired,
    ratingDetailsText: _react2.default.PropTypes.string,
    currentlyReadingBook: book()
  });
};

var commentSubject = function commentSubject() {
  return _react2.default.PropTypes.shape({
    type: _react2.default.PropTypes.string,
    id: _react2.default.PropTypes.number,
    uri: _react2.default.PropTypes.string
  });
};

var comment = function comment() {
  return _react2.default.PropTypes.shape({
    canComment: _react2.default.PropTypes.bool.isRequired,
    commentable: _react2.default.PropTypes.bool.isRequired,
    subjectKey: _react2.default.PropTypes.string.isRequired,
    subject: commentSubject(),
    subjectUrl: _react2.default.PropTypes.string
  });
};

var like = function like() {
  return _react2.default.PropTypes.shape({
    key: _react2.default.PropTypes.string.isRequired,
    label: _react2.default.PropTypes.string.isRequired,
    isLikeable: _react2.default.PropTypes.bool.isRequired
  });
};

var authorBlogPostNewsfeedResource = function authorBlogPostNewsfeedResource() {
  return _react2.default.PropTypes.shape({
    author: author().isRequred,
    title: _react2.default.PropTypes.string,
    url: _react2.default.PropTypes.string
  });
};

var blogNewsfeedResource = function blogNewsfeedResource() {
  return _react2.default.PropTypes.shape({
    title: _react2.default.PropTypes.string,
    body: _react2.default.PropTypes.object.isRequired,
    url: _react2.default.PropTypes.string,
    imageUrl: _react2.default.PropTypes.string,
    typeDisplayName: _react2.default.PropTypes.string
  });
};

var interviewNewsfeedResource = function interviewNewsfeedResource() {
  return _react2.default.PropTypes.shape({
    title: _react2.default.PropTypes.string,
    body: _react2.default.PropTypes.object,
    url: _react2.default.PropTypes.string,
    imageUrl: _react2.default.PropTypes.string,
    authorImageUrl: _react2.default.PropTypes.string,
    author: _react2.default.PropTypes.string,
    bookImageUrl: _react2.default.PropTypes.string,
    bookTitle: _react2.default.PropTypes.string,
    typeDisplayName: _react2.default.PropTypes.string
  });
};

var authorFollowNewsfeedResource = function authorFollowNewsfeedResource() {
  return _react2.default.PropTypes.shape({
    user: user().isRequired,
    author: author().isRequred,
    userAuthorFollowingsUrl: _react2.default.PropTypes.string
  });
};

var authorQaSettingNewsfeedResource = function authorQaSettingNewsfeedResource() {
  return _react2.default.PropTypes.shape({
    author: author().isRequired,
    message: _react2.default.PropTypes.string,
    url: _react2.default.PropTypes.string.isRequired
  });
};

var quote = function quote() {
  return _react2.default.PropTypes.shape({
    author: author().isRequired,
    body: _react2.default.PropTypes.object.isRequired,
    url: _react2.default.PropTypes.string.isRequired,
    quotesAuthorUrl: _react2.default.PropTypes.string.isRequired
  });
};

var group = function group() {
  return _react2.default.PropTypes.shape({
    allUnreadPostsUrl: _react2.default.PropTypes.string.isRequired,
    description: _react2.default.PropTypes.string.isRequired,
    iconUrl: _react2.default.PropTypes.string.isRequired,
    id: _react2.default.PropTypes.number.isRequired,
    lastActiveAt: createChainableTypeChecker(dateValidator),
    membersCount: _react2.default.PropTypes.number,
    name: _react2.default.PropTypes.string.isRequired,
    url: _react2.default.PropTypes.string.isRequired
  });
};

var topic = function topic() {
  return _react2.default.PropTypes.shape({
    id: _react2.default.PropTypes.number.isRequired,
    title: _react2.default.PropTypes.string.isRequired,
    url: _react2.default.PropTypes.string.isRequired,
    totalPosts: _react2.default.PropTypes.string.isRequired,
    newPosts: _react2.default.PropTypes.string,
    newCommentsUrl: _react2.default.PropTypes.string,
    updatedAt: createChainableTypeChecker(dateValidator),
    folder: _react2.default.PropTypes.shape({
      name: _react2.default.PropTypes.string,
      url: _react2.default.PropTypes.string
    })
  });
};

var defaultPollVoteProps = {
  user: user().isRequired,
  pollName: _react2.default.PropTypes.string.isRequired,
  answer: _react2.default.PropTypes.object.isRequired,
  url: _react2.default.PropTypes.string.isRequired,
  imageUrl: _react2.default.PropTypes.string.isRequired,
  isGroupPoll: _react2.default.PropTypes.bool.isRequired,
  isChoicePoll: _react2.default.PropTypes.bool.isRequired,
  groupName: _react2.default.PropTypes.string,
  groupUrl: _react2.default.PropTypes.string
};

var pollVoteNewsfeedResource = function pollVoteNewsfeedResource() {
  return _react2.default.PropTypes.shape(defaultPollVoteProps);
};

var choicePollVoteNewsfeedResource = function choicePollVoteNewsfeedResource() {
  return _react2.default.PropTypes.shape(merge(defaultPollVoteProps, {
    choiceYear: _react2.default.PropTypes.number.isRequired,
    choiceUrl: _react2.default.PropTypes.string.isRequired,
    badgeUrl: _react2.default.PropTypes.string.isRequired,
    votedBook: book().isRequired
  }));
};

var communityQuestion = function communityQuestion() {
  return {
    category: _react2.default.PropTypes.number.isRequired,
    questionText: _react2.default.PropTypes.string.isRequired,
    isSpoiler: _react2.default.PropTypes.bool.isRequired,
    questionUrl: _react2.default.PropTypes.string.isRequired,
    user: user().isRequired,
    authorQuestionsUrl: _react2.default.PropTypes.string,
    book: book()
  };
};

var communityAnswer = function communityAnswer() {
  return {
    user: user().isRequired,
    answerText: _react2.default.PropTypes.shape(truncatedHtml()),
    isSpoiler: _react2.default.PropTypes.bool.isRequired,
    communityQuestion: _react2.default.PropTypes.shape(communityQuestion()).isRequired
  };
};

var creative = function creative() {
  return _react2.default.PropTypes.shape({
    book: book(),
    customText: _react2.default.PropTypes.object,
    helpLink: _react2.default.PropTypes.string,
    defaultIcon: _react2.default.PropTypes.string,
    numAdditionalFriends: _react2.default.PropTypes.number,
    friendActionText: _react2.default.PropTypes.string,
    firstFriend: user(),
    customTextReview: _react2.default.PropTypes.object,
    similarBook: book(),
    similarBookShelf: _react2.default.PropTypes.string,
    similarBookShelfUrl: _react2.default.PropTypes.string,
    genres: _react2.default.PropTypes.array
  });
};

var notification = function notification() {
  var props = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var defaultProps = {
    actor: _react2.default.PropTypes.shape({
      viewableName: _react2.default.PropTypes.string,
      profileImage: _react2.default.PropTypes.string,
      profileUrl: _react2.default.PropTypes.string
    }),
    actors: _react2.default.PropTypes.array,
    createdAt: _react2.default.PropTypes.string,
    body: _react2.default.PropTypes.string,
    resource: _react2.default.PropTypes.shape({
      text: _react2.default.PropTypes.string,
      url: _react2.default.PropTypes.string
    }),
    viewed: _react2.default.PropTypes.boolean,
    moreActors: _react2.default.PropTypes.boolean
  };

  return _react2.default.PropTypes.shape(merge(defaultProps, props));
};

var searchResult = function searchResult(searchProp) {
  return _react2.default.PropTypes.shape({
    destination: _react2.default.PropTypes.string.isRequired,
    type: _react2.default.PropTypes.string.isRequired,
    object: searchProp
  });
};

var authorSearchResult = function authorSearchResult() {
  return searchResult(_react2.default.PropTypes.shape({
    id: _react2.default.PropTypes.string.isRequired,
    name: _react2.default.PropTypes.string.isRequired,
    isGoodreadsAuthor: _react2.default.PropTypes.bool,
    profileImage: _react2.default.PropTypes.string
  }));
};

var bookSearchResult = function bookSearchResult() {
  return searchResult(_react2.default.PropTypes.shape({
    id: _react2.default.PropTypes.string.isRequired,
    authorName: _react2.default.PropTypes.string.isRequired,
    isGoodreadsAuthor: _react2.default.PropTypes.bool,
    title: _react2.default.PropTypes.string.isRequired,
    imageUrl: _react2.default.PropTypes.string
  }));
};

var userSearchResult = function userSearchResult() {
  return searchResult(_react2.default.PropTypes.shape({
    id: _react2.default.PropTypes.string.isRequired,
    name: _react2.default.PropTypes.string.isRequired,
    profileImage: _react2.default.PropTypes.string
  }));
};

var readingNotesAnnotatedBookItem = function readingNotesAnnotatedBookItem() {
  return _react2.default.PropTypes.shape({
    asin: _react2.default.PropTypes.string.isRequired,
    imageUrl: _react2.default.PropTypes.string.isRequired,
    title: _react2.default.PropTypes.string.isRequired,
    authorName: _react2.default.PropTypes.string.isRequired,
    sharedCount: _react2.default.PropTypes.number.isRequired,
    highlightCount: _react2.default.PropTypes.number,
    noteCount: _react2.default.PropTypes.number,
    readingNotesUrl: _react2.default.PropTypes.string.isRequired,
    knhCta: _react2.default.PropTypes.string.isRequired,
    noSharedAnnotations: _react2.default.PropTypes.bool.isRequired
  });
};

var readingChallenge = function readingChallenge() {
  return _react2.default.PropTypes.shape({
    title: _react2.default.PropTypes.string.isRequired,
    url: _react2.default.PropTypes.string.isRequired,
    id: _react2.default.PropTypes.number.isRequired,
    year: _react2.default.PropTypes.number.isRequired,
    type: _react2.default.PropTypes.string.isRequired,
    maxGoal: _react2.default.PropTypes.number.isRequired,
    isFinished: _react2.default.PropTypes.bool,
    primaryColor: _react2.default.PropTypes.string.isRequired,
    secondaryColor: _react2.default.PropTypes.string.isRequired,
    images: _react2.default.PropTypes.shape({
      badge: _react2.default.PropTypes.string.isRequired,
      completed: _react2.default.PropTypes.string.isRequired
    })
  });
};

var shareDialog = function shareDialog() {
  return {
    signedIn: _react2.default.PropTypes.bool,
    signInUrl: _react2.default.PropTypes.string,

    social: _react2.default.PropTypes.shape({
      inModal: _react2.default.PropTypes.shape({
        facebook: _react2.default.PropTypes.bool.isRequired,
        twitter: _react2.default.PropTypes.bool.isRequired,
        pinterest: _react2.default.PropTypes.bool.isRequired,
        copyLink: _react2.default.PropTypes.bool.isRequired
      }).isRequired,

      outsideModal: _react2.default.PropTypes.shape({
        facebook: _react2.default.PropTypes.bool.isRequired,
        twitter: _react2.default.PropTypes.bool.isRequired,
        pinterest: _react2.default.PropTypes.bool.isRequired,
        copyLink: _react2.default.PropTypes.bool.isRequired
      }).isRequired,

      fbOptions: _react2.default.PropTypes.object,
      twitterOptions: _react2.default.PropTypes.object,
      pinterestOptions: _react2.default.PropTypes.object
    }).isRequired,

    sharingData: _react2.default.PropTypes.shape({
      resourceTypeFriendlyText: _react2.default.PropTypes.string.isRequired,
      resourceId: _react2.default.PropTypes.number.isRequired,
      sharerUserId: _react2.default.PropTypes.number
    }).isRequired,

    includePreview: _react2.default.PropTypes.bool,
    previewData: _react2.default.PropTypes.object
  };
};

var giveawayLogEntry = function giveawayLogEntry() {
  return _react2.default.PropTypes.shape({
    giveaway_uri: _react2.default.PropTypes.string,
    created_at: _react2.default.PropTypes.string,
    user_uri: _react2.default.PropTypes.string,
    start_at: _react2.default.PropTypes.string,
    end_at: _react2.default.PropTypes.string,
    release_at: _react2.default.PropTypes.string,
    book_uri: _react2.default.PropTypes.string,
    country_codes: _react2.default.PropTypes.string,
    book_count: _react2.default.PropTypes.string,
    adults_only_flag: _react2.default.PropTypes.string,
    description: _react2.default.PropTypes.string,
    primary_genre: _react2.default.PropTypes.string,
    secondary_genre: _react2.default.PropTypes.string,
    contact_info: _react2.default.PropTypes.string,
    nonwinner_message: _react2.default.PropTypes.string
  });
};

var reviewDraftItem = function reviewDraftItem() {
  return {
    reviewDraftUri: _react2.default.PropTypes.string.isRequired,
    book: book().isRequired,
    reviewEditPath: _react2.default.PropTypes.string.isRequired,
    reviewText: _react2.default.PropTypes.shape(expandableHtml()).isRequired
  };
};

exports.default = {
  user: user,
  author: author,
  blogNewsfeedResource: blogNewsfeedResource,
  interviewNewsfeedResource: interviewNewsfeedResource,
  book: book,
  bookDescription: bookDescription,
  quote: quote,
  commentSubject: commentSubject,
  comment: comment,
  like: like,
  group: group,
  topic: topic,
  authorBlogPostNewsfeedResource: authorBlogPostNewsfeedResource,
  authorFollowNewsfeedResource: authorFollowNewsfeedResource,
  authorQaSettingNewsfeedResource: authorQaSettingNewsfeedResource,
  communityQuestion: communityQuestion,
  communityAnswer: communityAnswer,
  friendNewsfeedResource: friendNewsfeedResource,
  userFollowingNewsfeedResource: userFollowingNewsfeedResource,
  pollVoteNewsfeedResource: pollVoteNewsfeedResource,
  expandableHtml: expandableHtml,
  truncatedHtml: truncatedHtml,
  choicePollVoteNewsfeedResource: choicePollVoteNewsfeedResource,
  date: createChainableTypeChecker(dateValidator),
  naturalNumber: createChainableTypeChecker(naturalNumberValidator),
  creative: creative,
  notification: notification,
  searchResults: {
    book: bookSearchResult,
    author: authorSearchResult,
    user: userSearchResult
  },
  readingNotesAnnotatedBookItem: readingNotesAnnotatedBookItem,
  readingChallenge: readingChallenge,
  reviewDraftItem: reviewDraftItem,
  shareDialog: shareDialog,
  giveawayLogEntry: giveawayLogEntry
};

},{"lodash":"lodash","react":"react"}],172:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _spoiler = require("../user_content/spoiler");

var _spoiler2 = _interopRequireDefault(_spoiler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Methods from our TextHelpers Ruby module can return text marked with <spoiler>
 * tags, possibly including inline JavaScript to show/hide their contents. This
 * library replaces that markup with the Spoiler React component.
 */
exports.default = {
  replaceSpoilerHTMLWithReactComponents: function replaceSpoilerHTMLWithReactComponents(rootDOMNode, jQuery) {
    /* istanbul ignore next */
    var $j = jQuery || window.$j;
    var spoilerLinks = $j(".jsShowSpoiler", rootDOMNode);

    _lodash2.default.each(spoilerLinks, function (spoilerLink) {
      var $spoilerLink = $j(spoilerLink);
      var spoilerContainer = $spoilerLink.next(".spoilerContainer");
      if (spoilerContainer) {
        var spoilerText = spoilerContainer.text().replace("(hide spoiler)", "");
        var spoiler = _react2.default.createElement(_spoiler2.default, { html: spoilerText });
        var placeholder = $j("<span></span>");
        $spoilerLink.replaceWith(placeholder);
        _reactDom2.default.render(spoiler, $j(placeholder)[0]);
      }
    });
  }
};

},{"../user_content/spoiler":197,"lodash":"lodash","react":"react","react-dom":"react-dom"}],173:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           React Component: ShareableLinkButton
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Modal with shareable link and description. Includes a copy link button
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           for copying shareable link to clipboard.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _modal_trigger = require("../modal_trigger");

var _modal_trigger2 = _interopRequireDefault(_modal_trigger);

var _modal = require("../modal");

var _modal2 = _interopRequireDefault(_modal);

var _spinner = require("../spinner");

var _spinner2 = _interopRequireDefault(_spinner);

var _ajax_helper = require("../../modules/ajax/ajax_helper");

var _flash_message = require("../flash_message");

var _flash_message2 = _interopRequireDefault(_flash_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ShareableLinkbutton",

  propTypes: {
    getShareableLinkURL: _react.PropTypes.string.isRequired,
    resourceType: _react.PropTypes.string.isRequired,
    buttonText: _react.PropTypes.string
  },

  getShareableLinkModalId: function getShareableLinkModalId() {
    return "shareableLinkModal";
  },
  getInitialState: function getInitialState() {
    return {
      error: false,
      fetching: false,
      copiedToClipboard: false,
      shareableLink: null,
      ttl: null
    };
  },

  // Expects a JSON response with a link(string) and a ttl(seconds)
  requestLink: function requestLink() {
    var _this = this;

    (0, _ajax_helper.httpRequest)(this.props.getShareableLinkURL, {
      method: "GET"
    }).done(function (_ref) {
      var link = _ref.link;
      var ttl = _ref.ttl;

      _this.setState({ shareableLink: link, ttl: ttl });
    }).fail(function () {
      _this.setState({ error: true });
    }).always(function () {
      _this.setState({ fetching: false });
    });
  },

  // Initially requests a link. Subsequent modal triggers keep fetched link.
  handleClick: function handleClick() {
    if (this.state.shareableLink) {
      return null;
    } else {
      return this.setState({ fetching: true, error: false }, this.requestLink);
    }
  },
  copyLinkToClipboard: function copyLinkToClipboard() {
    this.selectShareableLinkInput();
    document.execCommand("copy");
    return this.setState({ copiedToClipboard: true });
  },
  selectShareableLinkInput: function selectShareableLinkInput() {
    return this.shareableLinkInput.select();
  },
  getButtonText: function getButtonText() {
    return this.props.buttonText || "Get Link";
  },
  renderError: function renderError() {
    if (this.state.error) {
      var flashMessage = "Oops, something went wrong. Please try again.";
      return _jsx(_flash_message2.default, {
        category: "error",
        message: flashMessage
      });
    } else {
      return null;
    }
  },
  renderModal: function renderModal() {
    var _this2 = this;

    if (!this.state.shareableLink) {
      return null;
    } else {
      var expireTime = parseInt(this.state.ttl / 86400); // seconds to days
      return _jsx(_modal2.default, {
        id: this.getShareableLinkModalId(),
        centered: true,
        bemModifiers: "share"
      }, void 0, _jsx("div", {
        className: "shareableLinkModalContainer"
      }, void 0, _jsx("div", {
        className: "u-paddingBottomMedium"
      }, void 0, _jsx("h2", {
        className: "gr-h2"
      }, void 0, "Share this ", this.props.resourceType, " link with others")), _jsx("div", {
        className: "u-fullWidth u-paddingBottomTiny"
      }, void 0, _jsx("label", {
        htmlFor: "inviteUrl"
      }, void 0, "Invite Link:"), React.createElement("input", { className: "shareableLinkInput",
        ref: function ref(input) {
          _this2.shareableLinkInput = input;
        },
        readOnly: true,
        id: "inviteUrl",
        type: "text",
        value: this.state.shareableLink,
        onClick: this.selectShareableLinkInput })), _jsx("div", {
        className: "u-paddingBottomMedium"
      }, void 0, this.state.ttl && "This link will expire after " + expireTime + " days. ", this.state.copiedToClipboard && "Link copied to clipboard!"), _jsx("div", {}, void 0, _jsx("button", {
        type: "button",
        className: "gr-button",
        onClick: this.copyLinkToClipboard
      }, void 0, "Copy link to clipboard"))));
    }
  },
  renderModalTrigger: function renderModalTrigger() {
    if (this.state.fetching) {
      return _jsx(_spinner2.default, {
        isSmall: true
      });
    } else {
      return _jsx(_modal_trigger2.default, {
        id: "shareableLinkModal"
      }, void 0, _jsx("button", {
        type: "button",
        className: "gr-button",
        onClick: this.handleClick
      }, void 0, this.getButtonText()));
    }
  },
  render: function render() {
    return _jsx("div", {
      className: "u-paddingTopBottomTiny"
    }, void 0, _jsx("div", {}, void 0, this.renderModalTrigger(), this.renderModal(), this.renderError()));
  }
});

},{"../../modules/ajax/ajax_helper":4,"../flash_message":100,"../gr_component_factory":102,"../modal":136,"../modal_trigger":137,"../spinner":186,"react":"react"}],174:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*doc
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           title: Facebook share
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           name: facebook_share
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           category: React
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           This component displays the facebook share button that is used in the share module.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Required props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `options` (object): Options for facebook share, generated with fb_feed_options
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Optional props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `metricName` (string): Full name or modifier for metric name
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _ajax_helper = require("../../modules/ajax/ajax_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "FacebookShare",

  propTypes: {
    options: _react2.default.PropTypes.shape({
      name: _react2.default.PropTypes.string,
      link: _react2.default.PropTypes.string,
      description: _react2.default.PropTypes.string,
      caption: _react2.default.PropTypes.string,
      picture: _react2.default.PropTypes.string,
      properties: _react2.default.PropTypes.object,
      action_link_text: _react2.default.PropTypes.string,
      resource_type: _react2.default.PropTypes.string
    }).isRequired,
    metricName: _react2.default.PropTypes.string
  },

  onFacebookButtonClick: function onFacebookButtonClick() {
    if (this.props.metricName) {
      (0, _ajax_helper.httpPost)("/track/track_click", {
        data: {
          feature: this.props.metricName
        }
      });
    }
    $grfb.feedDialog(this.props.options);
  },
  render: function render() {
    var _this = this;

    return _jsx("button", {
      className: this.withBemModifiers("shareSocialButtons__button") + " shareSocialButtons__button--facebook",
      "aria-label": "Share to Facebook",
      type: "button",
      onClick: function onClick() {
        return _this.onFacebookButtonClick();
      }
    });
  }
});

},{"../../modules/ajax/ajax_helper":4,"./../gr_component_factory":102,"react":"react"}],175:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*doc
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           title: Pinterest share
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           name: pinterest_share
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           category: React
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           This component displays the pinterest share button that is used in the share module.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Required props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `options` (object): Options for pinterest share (description, url, media)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Optional props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `metricName` (string): Full name or modifier for metric name
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `windowSpecs` (shape): Options for pinterest child window
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _ajax_helper = require("../../modules/ajax/ajax_helper");

var _child_window_helper = require("../../modules/child_window_helper");

var _child_window_helper2 = _interopRequireDefault(_child_window_helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "PinterestShare",

  propTypes: {
    options: _react2.default.PropTypes.shape({
      desription: _react2.default.PropTypes.string,
      url: _react2.default.PropTypes.string,
      media: _react2.default.PropTypes.string
    }).isRequired,
    metricName: _react2.default.PropTypes.string,
    windowSpecs: _react2.default.PropTypes.object
  },

  getDefaultProps: function getDefaultProps() {
    return {
      // default window specs hard-coded here - cannot access browser window on server-side for centering
      windowSpecs: { left: 400,
        top: 200,
        width: 700,
        height: 800 }
    };
  },
  onPinterestButtonClick: function onPinterestButtonClick() {
    if (this.props.metricName) {
      (0, _ajax_helper.httpPost)("/track/track_click", {
        data: {
          feature: this.props.metricName
        }
      });
    }
    _child_window_helper2.default.openSocialShareWindow("https://pinterest.com/pin/create/link/", this.props.options, this.props.windowSpecs);
  },
  render: function render() {
    var _this = this;

    return _jsx("button", {
      className: this.withBemModifiers("shareSocialButtons__button") + " shareSocialButtons__button--pinterest",
      "aria-label": "Share to Pinterest",
      type: "button",
      onClick: function onClick() {
        return _this.onPinterestButtonClick();
      }
    });
  }
});

},{"../../modules/ajax/ajax_helper":4,"../../modules/child_window_helper":7,"./../gr_component_factory":102,"react":"react"}],176:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // React Component for blog preview card in share dialog

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _truncated_html = require("../../user_content/truncated_html");

var _truncated_html2 = _interopRequireDefault(_truncated_html);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ShareDialogBlogPreview",

  propTypes: {
    title: _react.PropTypes.string.isRequired,
    imageUrl: _react.PropTypes.string,
    description: _react.PropTypes.string.isRequired
  },

  // Because of unique template, cannot reuse ShareDialogPreview
  render: function render() {
    return _jsx("div", {
      className: "gr-mediaFlexbox shareModal__previewContainer shareModal__previewContainer--blog"
    }, void 0, _jsx("div", {
      className: "gr-mediaFlexbox__media sharePreview__image sharePreview__image--blog"
    }, void 0, _jsx("img", {
      className: "gr-mediaFlexbox__media sharePreview__imageFullWidth",
      src: this.props.imageUrl,
      alt: this.props.title
    })), _jsx("div", {
      className: "gr-mediaFlexbox__desc"
    }, void 0, _jsx("div", {
      className: "gr-h3 gr-h3--serif gr-h3--noMargin"
    }, void 0, this.props.title), _jsx("div", {
      className: "u-marginTopXSmall"
    }, void 0, _jsx("div", {
      className: "sharePreview__description"
    }, void 0, _jsx(_truncated_html2.default, {
      html: this.props.description,
      truncated: false
    })))));
  }
});

},{"../../gr_component_factory":102,"../../user_content/truncated_html":199,"react":"react"}],177:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // React Component for book preview card in share dialog. Similar to Book Component
// but display only (no links).

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _share_dialog_preview = require("./share_dialog_preview");

var _share_dialog_preview2 = _interopRequireDefault(_share_dialog_preview);

var _community_rating = require("../../community_rating");

var _community_rating2 = _interopRequireDefault(_community_rating);

var _author_badge = require("../../author/author_badge");

var _author_badge2 = _interopRequireDefault(_author_badge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ShareDialogBookPreview",

  propTypes: {
    author: _react.PropTypes.shape({
      name: _react.PropTypes.string.isRequired,
      isGoodreadsAuthor: _react.PropTypes.bool.isRequired
    }).isRequired,

    rating: _react.PropTypes.string.isRequired,
    title: _react.PropTypes.string.isRequired,
    imageUrl: _react.PropTypes.string.isRequired,
    ratingsCount: _react.PropTypes.number.isRequired,
    textReviewsCount: _react.PropTypes.number.isRequired
  },

  renderAuthorText: function renderAuthorText() {
    return _jsx("div", {}, void 0, "by ", this.props.author.name, _jsx(_author_badge2.default, {
      isGoodreadsAuthor: this.props.author.isGoodreadsAuthor
    }));
  },
  render: function render() {
    return _jsx(_share_dialog_preview2.default, {
      primaryText: this.props.title,
      secondaryText: this.renderAuthorText(),
      imageUrl: this.props.imageUrl
    }, void 0, _jsx("div", {
      className: "u-marginTopXSmall"
    }, void 0, _jsx(_community_rating2.default, {
      rating: parseFloat(this.props.rating),
      displayAvg: true,
      displayAvgRatingText: false,
      ratingsCount: this.props.ratingsCount,
      size: _community_rating2.default.ICON_SIZES.MEDIUM,
      textReviewsCount: this.props.textReviewsCount
    })));
  }
});

},{"../../author/author_badge":70,"../../community_rating":87,"../../gr_component_factory":102,"./share_dialog_preview":179,"react":"react"}],178:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // React Component for interview preview card in share dialog

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _truncated_html = require("../../user_content/truncated_html");

var _truncated_html2 = _interopRequireDefault(_truncated_html);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ShareDialogInterviewPreview",

  propTypes: {
    title: _react.PropTypes.string.isRequired,
    description: _react.PropTypes.string.isRequired,
    author: _react.PropTypes.string.isRequired,
    authorImageUrl: _react.PropTypes.string,
    bookImageUrl: _react.PropTypes.string,
    bookTitle: _react.PropTypes.string,
    imageUrl: _react.PropTypes.string
  },

  renderImage: function renderImage() {
    if (this.props.imageUrl) {
      return _jsx("img", {
        className: "gr-mediaFlexbox__media sharePreview__imageFullWidth",
        src: this.props.imageUrl,
        alt: this.props.title
      });
    } else if (this.props.authorImageUrl && this.props.bookImageUrl) {
      return _jsx("div", {
        className: "gr-mediaFlexbox__media sharePreview__image",
        style: { display: "contents" }
      }, void 0, _jsx("div", {
        className: "editorialCard__image--interview\n                          editorialCard__image--interviewAuthor",
        style: { backgroundImage: "url(" + this.props.authorImageUrl + ")" }
      }, void 0, _jsx("span", {
        className: "u-visuallyHidden"
      }, void 0, this.props.author)), _jsx("div", {
        className: "editorialCard__image--interview\n                          editorialCard__image--interviewBook",
        style: { backgroundImage: "url(" + this.props.bookImageUrl + ")" }
      }, void 0, _jsx("span", {
        className: "u-visuallyHidden"
      }, void 0, this.props.bookTitle)));
    } else {
      return null;
    }
  },

  // Because of unique image, cannot reuse ShareDialogPreview
  render: function render() {
    return _jsx("div", {}, void 0, _jsx("div", {
      className: "gr-mediaFlexbox shareModal__previewContainer",
      style: { display: "block" }
    }, void 0, this.renderImage(), _jsx("div", {
      className: "gr-mediaFlexbox__desc"
    }, void 0, _jsx("div", {
      className: "gr-h3 gr-h3--serif gr-h3--noMargin"
    }, void 0, this.props.title), _jsx("div", {
      className: "u-marginTopXSmall"
    }, void 0, _jsx("div", {
      className: "sharePreview__description"
    }, void 0, _jsx(_truncated_html2.default, {
      html: this.props.description,
      truncated: false
    }))))));
  }
});

},{"../../gr_component_factory":102,"../../user_content/truncated_html":199,"react":"react"}],179:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*doc
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           title: Share Dialog Preview
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           name: share_dialog_preview
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           category: React
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           A generic container for a preview of your Sharing resource in the Share Dialog modal.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Use if your preview card follows media box format with a title and image. Children
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           are rendered under secondaryText.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Required props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `primaryText`: header of preview card
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `imageUrl`: url of image
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Optional props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `secondaryText`: either string or element
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ```rails_example
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           <%= react_component 'ReactComponents.ShareDialogPreview',
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               {
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 primaryText: 'This is the primaryText',
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 imageUrl: 'https://d.gr-assets.com/books/1363934734s/1842.jpg',
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 secondaryText: 'This is the secondaryText'
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               }
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           %>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ```
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ShareDialogPreview",

  propTypes: {
    imageUrl: _react.PropTypes.string.isRequired,
    primaryText: _react.PropTypes.string.isRequired,
    secondaryText: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.string])
  },

  renderSecondaryText: function renderSecondaryText() {
    if (this.props.secondaryText) {
      return _jsx("div", {
        className: "sharePreview__secondaryText"
      }, void 0, this.props.secondaryText);
    } else {
      return null;
    }
  },
  render: function render() {
    return _jsx("div", {
      className: "gr-mediaFlexbox shareModal__previewContainer"
    }, void 0, _jsx("img", {
      className: "gr-mediaFlexbox__media sharePreview__image",
      src: this.props.imageUrl,
      alt: this.props.primaryText
    }), _jsx("div", {
      className: "gr-mediaFlexbox__desc"
    }, void 0, _jsx("div", {
      className: "gr-h3 gr-h3--serif gr-h3--noMargin"
    }, void 0, this.props.primaryText), this.renderSecondaryText(), _jsx("div", {
      className: "u-marginTopXSmall"
    }, void 0, this.props.children)));
  }
});

},{"../../gr_component_factory":102,"react":"react"}],180:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // Share Preview card for topics

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _share_dialog_preview = require("./share_dialog_preview");

var _share_dialog_preview2 = _interopRequireDefault(_share_dialog_preview);

var _react = require("react");

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _truncated_html = require("../../user_content/truncated_html");

var _truncated_html2 = _interopRequireDefault(_truncated_html);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ShareDialogTopicPreview",

  propTypes: {
    topicTitle: _react.PropTypes.string.isRequired,
    groupTitle: _react.PropTypes.string.isRequired,
    imageUrl: _react.PropTypes.string.isRequired,
    description: _react.PropTypes.string
  },

  render: function render() {
    var secondaryText = this.props.groupTitle + " - Discussion";
    return _jsx(_share_dialog_preview2.default, {
      primaryText: this.props.topicTitle,
      secondaryText: secondaryText,
      imageUrl: this.props.imageUrl
    }, void 0, _jsx("div", {
      className: "sharePreview__description"
    }, void 0, _jsx(_truncated_html2.default, {
      html: this.props.description,
      truncated: false
    })));
  }
});

},{"../../gr_component_factory":102,"../../user_content/truncated_html":199,"./share_dialog_preview":179,"react":"react"}],181:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*doc
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           title: Twitter share
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           name: twitter_share
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           category: React
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           This component displays the twitter share button that is used in the share module.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Required props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `options` (object): Options for twitter share (text, url)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Optional props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `metricName` (string): Full name or modifier for metric name
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `windowSpecs` (shape): Options for twitter child window
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _ajax_helper = require("../../modules/ajax/ajax_helper");

var _child_window_helper = require("../../modules/child_window_helper");

var _child_window_helper2 = _interopRequireDefault(_child_window_helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "TwitterShare",

  propTypes: {
    options: _react2.default.PropTypes.shape({
      text: _react2.default.PropTypes.string,
      url: _react2.default.PropTypes.string,
      via: _react2.default.PropTypes.string
    }).isRequired,
    metricName: _react2.default.PropTypes.string,
    windowSpecs: _react2.default.PropTypes.object
  },

  getDefaultProps: function getDefaultProps() {
    return {
      // default window specs hard-coded here - cannot access browser window on server-side for centering
      windowSpecs: { left: 400,
        top: 200,
        width: 600,
        height: 500 }
    };
  },
  onTwitterButtonClick: function onTwitterButtonClick() {
    if (this.props.metricName) {
      (0, _ajax_helper.httpPost)("/track/track_click", {
        data: {
          feature: this.props.metricName
        }
      });
    }
    _child_window_helper2.default.openSocialShareWindow("https://twitter.com/intent/tweet/", this.props.options, this.props.windowSpecs);
  },
  render: function render() {
    var _this = this;

    return _jsx("button", {
      className: this.withBemModifiers("shareSocialButtons__button") + " shareSocialButtons__button--twitter",
      "aria-label": "Share to Twitter",
      type: "button",
      onClick: function onClick() {
        return _this.onTwitterButtonClick();
      }
    });
  }
});

},{"../../modules/ajax/ajax_helper":4,"../../modules/child_window_helper":7,"./../gr_component_factory":102,"react":"react"}],182:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ChoiceSiteAnnouncement",

  propTypes: {
    imageUrl: React.PropTypes.string.isRequired,
    announcementText: React.PropTypes.string.isRequired,
    description: React.PropTypes.string.isRequired,
    targetUrl: React.PropTypes.string,
    totalVotes: React.PropTypes.number.isRequired
  },

  getAriaLabel: function getAriaLabel() {
    return "Read more " + this.props.announcementText;
  },
  hasTargetUrl: function hasTargetUrl() {
    return !_lodash2.default.isEmpty(this.props.targetUrl);
  },
  renderAnnouncementTitle: function renderAnnouncementTitle() {
    var isLink = this.hasTargetUrl();
    var textClassName = "siteAnnouncement__title";
    if (isLink) {
      return _jsx("a", {
        className: (0, _classnames2.default)(textClassName, "gr-hyperlink"),
        "aria-label": this.getAriaLabel(),
        href: this.props.targetUrl
      }, void 0, this.props.announcementText);
    } else {
      return _jsx("span", {
        className: textClassName
      }, void 0, this.props.announcementText);
    }
  },
  render: function render() {
    return _jsx("div", {
      className: "siteAnnouncement gr-mediaFlexbox gr-mediaFlexbox--columnDirection"
    }, void 0, _jsx("a", {
      className: "gr-mediaFlexbox__media siteAnnouncement__masthead",
      href: this.props.targetUrl
    }, void 0, _jsx("img", {
      src: this.props.imageUrl,
      alt: this.props.imageAlt
    })), _jsx("div", {
      className: "gr-mediaFlexbox__desc siteAnnouncement__body"
    }, void 0, this.renderAnnouncementTitle(), _jsx("div", {
      className: "siteAnnouncement__description"
    }, void 0, this.props.description), _jsx("div", {
      className: "siteAnnouncement__choiceVoteCount"
    }, void 0, this.props.totalVotes.toLocaleString(), " votes")));
  }
});

},{"../gr_component_factory":102,"classnames":"classnames","lodash":"lodash"}],183:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _shape_icon = require("../shape_icon");

var _shape_icon2 = _interopRequireDefault(_shape_icon);

var _shape_icon_values = require("../../modules/shape_icon_values");

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "SimpleSiteAnnouncement",

  propTypes: {
    imageUrl: React.PropTypes.string.isRequired,
    announcementText: React.PropTypes.string.isRequired,
    targetUrl: React.PropTypes.string
  },

  getAriaLabel: function getAriaLabel() {
    return "Read more " + this.props.announcementText;
  },
  hasTargetUrl: function hasTargetUrl() {
    return !_lodash2.default.isEmpty(this.props.targetUrl);
  },
  renderIcon: function renderIcon() {
    return _jsx(_shape_icon2.default, {
      imageUrl: this.props.imageUrl,
      size: _shape_icon_values.ICON_SIZES.MEDIUM,
      imageAlt: "Site Announcement",
      border: true
    });
  },
  renderAnnouncementText: function renderAnnouncementText() {
    var isLink = this.hasTargetUrl();
    var textClassName = "siteAnnouncement__simpleText";
    if (isLink) {
      return _jsx("a", {
        className: (0, _classnames2.default)(textClassName, "gr-hyperlink"),
        "aria-label": this.getAriaLabel(),
        href: this.props.targetUrl
      }, void 0, this.props.announcementText);
    } else {
      return _jsx("span", {
        className: textClassName
      }, void 0, this.props.announcementText);
    }
  },
  renderSecondaryLinkSection: function renderSecondaryLinkSection() {
    return this.hasTargetUrl() ? _jsx("span", {
      className: "siteAnnouncement__simpleSecondaryLinkSection"
    }, void 0, _jsx("a", {
      className: "gr-button gr-button--quiet",
      "aria-label": this.getAriaLabel(),
      href: this.props.targetUrl
    }, void 0, "Read more")) : null;
  },
  render: function render() {
    return _jsx("div", {
      className: "siteAnnouncement\n                      siteAnnouncement--simple\n                      gr-mediaFlexbox\n                      gr-mediaFlexbox--alignItemsCenter"
    }, void 0, _jsx("div", {
      className: "gr-mediaFlexbox__media"
    }, void 0, this.renderIcon()), _jsx("div", {
      className: "gr-mediaFlexbox__desc siteAnnouncement__simpleBody"
    }, void 0, _jsx("h5", {
      className: "gr-h5 gr-h5--noMargin siteAnnouncement__simpleHeader"
    }, void 0, "Goodreads news"), this.renderAnnouncementText()), this.renderSecondaryLinkSection());
  }
});

},{"../../modules/shape_icon_values":19,"../gr_component_factory":102,"../shape_icon":166,"classnames":"classnames","lodash":"lodash"}],184:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // See documentation on https://www.goodreads.com/style_guide

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _simple_site_announcement = require("./simple_site_announcement");

var _simple_site_announcement2 = _interopRequireDefault(_simple_site_announcement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "SiteAnnouncement",
  propTypes: {
    title: _react.PropTypes.string.isRequired,
    targetUrl: _react.PropTypes.string,
    displayData: _react.PropTypes.shape({
      description: _react.PropTypes.string,
      mastheadUrl: _react.PropTypes.string,
      imageUrl: _react.PropTypes.string
    }).isRequired
  },

  shouldRenderLargeAnnouncement: function shouldRenderLargeAnnouncement() {
    var largeAnnouncementData = this.props.displayData;
    return largeAnnouncementData && largeAnnouncementData.description && largeAnnouncementData.mastheadUrl;
  },
  renderLargeAnnouncement: function renderLargeAnnouncement() {
    return _jsx("div", {
      className: "siteAnnouncement gr-mediaFlexbox gr-mediaFlexbox--columnDirection"
    }, void 0, _jsx("a", {
      className: "gr-mediaFlexbox__media siteAnnouncement__masthead",
      href: this.props.targetUrl,
      "aria-label": this.props.title
    }, void 0, _jsx("img", {
      src: this.props.displayData.mastheadUrl,
      alt: this.props.title
    })), _jsx("div", {
      className: "gr-mediaFlexbox__desc siteAnnouncement__body"
    }, void 0, _jsx("a", {
      className: "siteAnnouncement__title gr-hyperlink",
      href: this.props.targetUrl
    }, void 0, this.props.title), _jsx("div", {
      className: "siteAnnouncement__description"
    }, void 0, this.props.displayData.description)));
  },
  render: function render() {
    if (this.shouldRenderLargeAnnouncement()) {
      return this.renderLargeAnnouncement();
    } else {
      return _jsx(_simple_site_announcement2.default, {
        imageUrl: this.props.displayData.imageUrl,
        announcementText: this.props.title,
        targetUrl: this.props.targetUrl
      });
    }
  }
});

},{"../gr_component_factory":102,"./simple_site_announcement":183,"react":"react"}],185:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _shape_icon = require("../shape_icon");

var _shape_icon2 = _interopRequireDefault(_shape_icon);

var _shape_icon_values = require("../../modules/shape_icon_values");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "WelcomeAnnouncement",

  propTypes: {
    imageUrl: React.PropTypes.string.isRequired
  },

  renderIcon: function renderIcon() {
    return _jsx(_shape_icon2.default, {
      imageUrl: this.props.imageUrl,
      size: _shape_icon_values.ICON_SIZES.MEDIUM,
      imageAlt: "Welcome to Goodreads",
      border: true
    });
  },
  render: function render() {
    return _jsx("div", {
      className: "siteAnnouncement siteAnnouncement--welcome"
    }, void 0, _jsx("div", {
      className: "siteAnnouncement__welcomeIcon"
    }, void 0, this.renderIcon()), _jsx("div", {
      className: "siteAnnouncement__welcomeBody"
    }, void 0, _jsx("h5", {
      className: "siteAnnouncement__announcementText"
    }, void 0, "Welcome to Goodreads"), _jsx("span", {}, void 0, "Meet your favorite book, find your reading community, and manage your reading life.")));
  }
});

},{"../../modules/shape_icon_values":19,"../gr_component_factory":102,"../shape_icon":166}],186:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "Spinner",

  propTypes: {
    isSmall: React.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      isSmall: false
    };
  },
  render: function render() {
    var cx = (0, _classnames2.default)("spinnerContainer", this.props.className);
    var bemModifier = this.props.isSmall ? "small" : null;
    return _jsx("div", {
      className: cx
    }, void 0, _jsx("div", {
      className: this.withBemModifiers("spinner", bemModifier)
    }, void 0, _jsx("div", {
      className: this.withBemModifiers("spinner__mask", bemModifier)
    }, void 0, _jsx("div", {
      className: this.withBemModifiers("spinner__maskedCircle", bemModifier)
    }))), _jsx("div", {
      className: "spinnerFallbackText"
    }, void 0, "Loading…"));
  }
});

},{"./gr_component_factory":102,"classnames":"classnames"}],187:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "SponsoredFooter",

  propTypes: {
    sponsoredName: _react2.default.PropTypes.string
  },

  renderSponsoredName: function renderSponsoredName() {
    if (this.props.sponsoredName) {
      return _jsx("span", {
        className: "featuredContentModule__sponsoredName"
      }, void 0, this.props.sponsoredName);
    }
  },
  render: function render() {
    var footerClasses = "featuredContentModule__sponsoredFooter";
    var sponsoredLabel = this.props.sponsoredName ? "Sponsored by " : "Sponsored";
    return _jsx("div", {
      className: footerClasses
    }, void 0, _jsx("span", {
      className: "featuredContentModule__sponsoredBadgeIcon"
    }), _jsx("span", {
      className: "featuredContentModule__sponsoredLabel"
    }, void 0, sponsoredLabel), this.renderSponsoredName());
  }
});

},{"./gr_component_factory":102,"react":"react"}],188:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "StoresInitializer",

  render: function render() {
    return null;
  }
}); // This is a component used exlusively for initializing a store. Since that is
// its sole purpose, it renders nothing

},{"./gr_component_factory":102}],189:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _tab_actions = require("../react_actions/tab_actions");

var _tab_actions2 = _interopRequireDefault(_tab_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var eventTypes = {
  CLICK: "click",
  HOVER: "hover"
}; // See documentation on https://www.goodreads.com/style_guide

exports.default = _gr_component_factory2.default.createClass({
  displayName: "Tab",

  propTypes: {
    group: _react2.default.PropTypes.string.isRequired,
    name: _react2.default.PropTypes.string.isRequired,
    initiallySelected: _react2.default.PropTypes.bool,
    triggerEventType: _react2.default.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      initiallySelected: false,
      triggerEventType: eventTypes.CLICK
    };
  },
  componentDidMount: function componentDidMount() {
    if (this.props.initiallySelected) {
      this.selectTab();
    }
  },
  selectTab: function selectTab() {
    _tab_actions2.default.selectTab(this.props.name, this.props.group);
  },
  render: function render() {
    var tabAttrs = {};
    switch (this.props.triggerEventType) {
      case eventTypes.CLICK:
        tabAttrs.onClick = this.selectTab;
        break;
      case eventTypes.HOVER:
        tabAttrs.onMouseOver = this.selectTab;
        break;
    }
    return _react2.default.createElement(
      "span",
      tabAttrs,
      this.props.children
    );
  }
});

},{"../react_actions/tab_actions":44,"./gr_component_factory":102,"react":"react"}],190:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _tabs_store = require("../react_stores/tabs_store");

var _tabs_store2 = _interopRequireDefault(_tabs_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "TabContent",

  mixins: [_reflux2.default.connect(_tabs_store2.default, "tabsStore")],

  propTypes: {
    group: _react2.default.PropTypes.string.isRequired,
    name: _react2.default.PropTypes.string.isRequired
  },

  isActive: function isActive() {
    return this.props.name === this.state.tabsStore[this.props.group];
  },
  render: function render() {
    return _jsx("div", {}, void 0, this.isActive() ? this.props.children : null);
  }
});

},{"../react_stores/tabs_store":248,"./gr_component_factory":102,"react":"react","reflux":"reflux"}],191:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // See documentation on https://www.goodreads.com/style_guide

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _date_utils = require("../../modules/date_utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "RelativeTime",

  propTypes: {
    time: _gr_prop_types2.default.date.isRequired,
    longFormat: _react2.default.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      longFormat: false
    };
  },
  getRelativeTime: function getRelativeTime() {
    if (this.props.longFormat) {
      return (0, _moment2.default)(new Date(this.props.time)).fromNow();
    } else {
      return (0, _date_utils.fromNow)(this.props.time);
    }
  },
  render: function render() {
    return _jsx("time", {
      dateTime: this.props.time,
      "aria-label": (0, _moment2.default)(new Date(this.props.time)).fromNow()
    }, void 0, this.getRelativeTime());
  }
});

},{"../../modules/date_utils":11,"../gr_component_factory":102,"../shared/gr_prop_types":171,"moment":"moment","react":"react"}],192:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _friend_status_values = require("../../modules/user/friend_status_values");

var _user_follow_actions = require("../../react_actions/user/user_follow_actions");

var _user_follow_actions2 = _interopRequireDefault(_user_follow_actions);

var _user_follow_store = require("../../react_stores/user/user_follow_store");

var _user_follow_store2 = _interopRequireDefault(_user_follow_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Display follow actions for a user.
/  Note, if user is an author, use AuthorFollowButton instead
/  Note, does not currently work on signed-out view (ajax returns error state)
/   see https://issues.labcollab.net/browse/KCW-10729
*/
exports.default = _gr_component_factory2.default.createClass({
  displayName: "UserFollowWidget",

  mixins: [_reflux2.default.connectFilter(_user_follow_store2.default, "userFollowStore", function (follows) {
    return follows[this.props.displayUser.id];
  })],

  propTypes: {
    displayUser: _gr_prop_types2.default.user().isRequired
  },

  renderFollowStatus: function renderFollowStatus() {
    var _this = this;

    var store = this.state.userFollowStore;
    if (store.isFollowing) {
      // Use first name if available, otherwise use viewableName (which could contain last name)
      var name = this.props.displayUser.firstName || this.props.displayUser.viewableName;
      return _jsx("div", {
        className: "gr-box gr-box--inline gr-box--marginRightSmall"
      }, void 0, "You are following ", name, ".");
    } else {
      return _jsx("button", {
        className: "gr-button gr-button--small gr-box gr-box--inline gr-box--marginRightSmall",
        onClick: function onClick() {
          return _user_follow_actions2.default.follow(_this.props.displayUser.id);
        },
        disabled: store.buttonEnabled ? false : "disabled"
      }, void 0, "Follow");
    }
  },
  renderUnfollowButtonIfNeeded: function renderUnfollowButtonIfNeeded() {
    var _this2 = this;

    var store = this.state.userFollowStore;
    if (store.isFollowing && store.friendshipStatus !== _friend_status_values.FRIEND_STATUS.REQUEST_PENDING_TO) {
      // You cannot unfollow if you have a friend request pending to this user
      // (you can only cancel friend requests on another page like the profile page)
      return _jsx("button", {
        className: "gr-button gr-buttonAsLink gr-buttonAsLink--quiet",
        onClick: function onClick() {
          return _user_follow_actions2.default.unFollow(_this2.props.displayUser.id);
        },
        disabled: store.buttonEnabled ? false : "disabled"
      }, void 0, _jsx("span", {
        className: "gr-metaText"
      }, void 0, "Unfollow"));
    }
  },
  shouldHideFollowButtons: function shouldHideFollowButtons() {
    /* Do not render follow buttons if
    /  - you are looking at your own profile (don't follow self)
    /  - you are already friends (to avoid friend status confusion)
    /  - the other user does not allow follows without friending
    /  - the other user has blocked you
    */
    var followStoreData = this.state.userFollowStore;
    return followStoreData.friendshipStatus == _friend_status_values.FRIEND_STATUS.FRIEND || followStoreData.friendshipStatus == _friend_status_values.FRIEND_STATUS.SELF || followStoreData.isBlocked || !followStoreData.allowsFollow;
  },
  render: function render() {
    if (this.shouldHideFollowButtons()) {
      return null;
    }

    return _jsx("div", {
      className: "userFollowWidget"
    }, void 0, this.renderFollowStatus(), this.renderUnfollowButtonIfNeeded());
  }
});

},{"../../modules/user/friend_status_values":24,"../../react_actions/user/user_follow_actions":46,"../../react_stores/user/user_follow_store":250,"../gr_component_factory":102,"../shared/gr_prop_types":171,"reflux":"reflux"}],193:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _shape_icon = require("../shape_icon");

var _shape_icon2 = _interopRequireDefault(_shape_icon);

var _shape_icon_values = require("../../modules/shape_icon_values");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "UserIcon",

  propTypes: {
    user: _react2.default.PropTypes.shape({
      viewableName: _react2.default.PropTypes.string.isRequired,
      profileImage: _react2.default.PropTypes.string.isRequired,
      profileUrl: _react2.default.PropTypes.string
    }).isRequired,
    includeLink: _react2.default.PropTypes.bool,
    size: _react2.default.PropTypes.oneOf([_shape_icon_values.ICON_SIZES.SMALL, _shape_icon_values.ICON_SIZES.MEDIUM, _shape_icon_values.ICON_SIZES.LARGE])
  },

  getDefaultProps: function getDefaultProps() {
    return {
      includeLink: true,
      size: _shape_icon_values.ICON_SIZES.SMALL
    };
  },
  render: function render() {
    var user = this.props.user;

    return _react2.default.createElement(_shape_icon2.default, _extends({ imageUrl: user.profileImage,
      imageAlt: user.viewableName,
      linkUrl: user.profileUrl,
      border: true
    }, this.props));
  }
});

},{"../../modules/shape_icon_values":19,"../gr_component_factory":102,"../shape_icon":166,"react":"react"}],194:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // See documentation on https://www.goodreads.com/style_guide

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _click_tracking_wrapper = require("../click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _click_tracking_helper = require("../../modules/ads/click_tracking_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "UserProfileLink",

  propTypes: {
    user: _gr_prop_types2.default.user().isRequired,
    className: _react2.default.PropTypes.string
  },

  userName: function userName() {
    return { __html: this.props.user.viewableName };
  },
  render: function render() {
    var className = (0, _classnames2.default)("gr-hyperlink", "gr-hyperlink--bold", "gr-user__profileLink", this.props.className);
    var profileLink = _jsx("a", {
      className: className,
      href: this.props.user.profileUrl,
      dangerouslySetInnerHTML: this.userName()
    });
    if (this.props.user.profileUrl && this.props.user.viewableName) {
      return _jsx(_click_tracking_wrapper2.default, {
        children: profileLink,
        trackingOptions: _click_tracking_helper.TRACKED_CLASSES.user_profile
      });
    } else if (this.props.user.viewableName) {
      return _jsx("b", {}, void 0, this.props.user.viewableName);
    } else {
      return null;
    }
  }
});

},{"../../modules/ads/click_tracking_helper":2,"../click_tracking_wrapper":81,"../gr_component_factory":102,"../shared/gr_prop_types":171,"classnames":"classnames","react":"react"}],195:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // See documentation on https://www.goodreads.com/style_guide

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _gr_spoiler_handler = require("../shared/gr_spoiler_handler");

var _gr_spoiler_handler2 = _interopRequireDefault(_gr_spoiler_handler);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ExpandableHtml",

  propTypes: _gr_prop_types2.default.expandableHtml(),

  getInitialState: function getInitialState() {
    return {
      expanded: false
    };
  },
  collapse: function collapse() {
    this.setState({ expanded: false });
  },
  expand: function expand() {
    this.setState({ expanded: true });
  },
  expandable: function expandable() {
    return !_lodash2.default.isEmpty(this.props.truncatedHtml);
  },
  visibleHtml: function visibleHtml() {
    if (!this.expandable() || this.state.expanded === true) {
      return this.props.html;
    } else {
      return this.props.truncatedHtml;
    }
  },
  renderToggleButton: function renderToggleButton() {
    if (!this.expandable()) {
      return null;
    }

    var action = this.state.expanded ? this.collapse : this.expand;
    var label = this.state.expanded ? "Less" : "More";

    var cx = (0, _classnames2.default)("gr-buttonAsLink", "u-marginLeftTiny");

    return _jsx("button", {
      className: cx,
      onClick: action
    }, void 0, label);
  },
  componentDidMount: function componentDidMount() {
    if (this.refs.rootNode) {
      _gr_spoiler_handler2.default.replaceSpoilerHTMLWithReactComponents(this.refs.rootNode);
    }
  },
  componentDidUpdate: function componentDidUpdate() {
    if (this.refs.rootNode) {
      _gr_spoiler_handler2.default.replaceSpoilerHTMLWithReactComponents(this.refs.rootNode);
    }
  },
  render: function render() {
    if (_lodash2.default.isEmpty(this.props.html)) {
      return null;
    }

    var expandableClass = (0, _classnames2.default)("expandableHtml", this.props.className);
    return React.createElement(
      "div",
      { className: expandableClass, ref: "rootNode" },
      _jsx("span", {
        dangerouslySetInnerHTML: { __html: this.visibleHtml() }
      }),
      this.renderToggleButton()
    );
  }
});

},{"../gr_component_factory":102,"../shared/gr_prop_types":171,"../shared/gr_spoiler_handler":172,"classnames":"classnames","lodash":"lodash"}],196:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // See documentation on https://www.goodreads.com/style_guide

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "HiddenHtml",

  propTypes: {
    unhideText: React.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      unhideText: "unhide"
    };
  },
  getInitialState: function getInitialState() {
    return {
      expanded: false
    };
  },
  expand: function expand() {
    this.setState({ expanded: true });
  },
  renderUnhideButton: function renderUnhideButton() {
    return _jsx("button", {
      className: "gr-buttonAsLink",
      onClick: this.expand
    }, void 0, this.props.unhideText);
  },
  renderContent: function renderContent() {
    if (this.state.expanded) {
      return this.props.children;
    } else {
      return _jsx("span", {}, void 0, this.renderUnhideButton());
    }
  },
  render: function render() {
    return _jsx("div", {}, void 0, this.renderContent());
  }
});

},{"../gr_component_factory":102}],197:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // See documentation on https://www.goodreads.com/style_guide

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "Spoiler",

  propTypes: {
    html: _react2.default.PropTypes.string,
    spoilerWarning: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.element])
  },

  componentWillMount: function componentWillMount() {
    if (this.props.html === null && this.props.children === null) {
      throw new Error("props.children and props.html cannot both be null");
    }
  },
  getDefaultProps: function getDefaultProps() {
    return {
      html: null,
      spoilerWarning: null
    };
  },
  getInitialState: function getInitialState() {
    return {
      showSpoiler: false
    };
  },
  onClickShowSpoiler: function onClickShowSpoiler() {
    this.setState({
      showSpoiler: true
    });
  },
  onClickHideSpoiler: function onClickHideSpoiler() {
    this.setState({
      showSpoiler: false
    });
  },
  getSpoilerHtml: function getSpoilerHtml() {
    return {
      __html: this.props.html
    };
  },
  renderSpoiler: function renderSpoiler() {
    if (this.props.html) {
      return _jsx("span", {
        className: "spoiler__text u-marginRightTiny",
        dangerouslySetInnerHTML: this.getSpoilerHtml()
      });
    } else {
      return this.props.children;
    }
  },
  render: function render() {
    return _jsx("span", {}, void 0, this.state.showSpoiler ? _jsx("span", {
      className: "spoiler__textContainer"
    }, void 0, this.renderSpoiler(), _jsx("button", {
      className: "gr-buttonAsLink",
      onClick: this.onClickHideSpoiler
    }, void 0, "(hide spoiler)")) : _jsx("span", {}, void 0, this.props.spoilerWarning, _jsx("button", {
      className: "gr-buttonAsLink",
      onClick: this.onClickShowSpoiler
    }, void 0, "(view spoiler)")));
  }
});

},{"../gr_component_factory":102,"react":"react"}],198:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           StringCounter React component
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           counterType: count by "character" or by "word"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           maxLength: max text length, inclusive
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           text: string to count
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           warnLength: number of elements remaining to display a counter
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             - ex. warnLength: 100 //displays at 100 elements remaining
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             - if omitted, will always show counter
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * becomes visible: maxLength - text.length <= warnLength
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * becomes (red) alert: text.length > maxLength
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _string_helper = require("../../modules/string_helper");

var _pluralize = require("pluralize");

var _pluralize2 = _interopRequireDefault(_pluralize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "StringCounter",

  propTypes: {
    counterType: _react.PropTypes.oneOf(["character", "word"]).isRequired,
    maxLength: _react.PropTypes.number.isRequired,
    text: _react.PropTypes.string.isRequired,
    warnLength: _react.PropTypes.number
  },

  renderWarning: function renderWarning(diff) {
    var cname = undefined;
    if (diff < 0) {
      cname = "gr-smallAlert";
    }

    return _jsx("span", {
      className: cname,
      role: "alert"
    }, void 0, diff, " ", (0, _pluralize2.default)(this.props.counterType, diff), " left");
  },
  countType: function countType() {
    if (this.props.counterType === "character") {
      return (0, _string_helper.astralLength)(this.props.text);
    } else if (this.props.counterType === "word") {
      return (0, _string_helper.countWords)(this.props.text);
    } else {
      return null;
    }
  },
  render: function render() {
    var textLength = this.countType(this.props.text);

    var diff = this.props.maxLength - textLength;
    var shouldRender = this.props.warnLength ? diff <= this.props.warnLength : true;
    if (shouldRender) {
      return _jsx("div", {}, void 0, this.renderWarning(diff));
    } else {
      return null;
    }
  }
});

},{"../../modules/string_helper":22,"../gr_component_factory":102,"pluralize":"pluralize","react":"react"}],199:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // See documentation on https://www.goodreads.com/style_guide

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _gr_spoiler_handler = require("../shared/gr_spoiler_handler");

var _gr_spoiler_handler2 = _interopRequireDefault(_gr_spoiler_handler);

var _click_tracking_wrapper = require("../click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _click_tracking_helper = require("../../modules/ads/click_tracking_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "TruncatedHtml",

  propTypes: _gr_prop_types2.default.truncatedHtml(),

  getDefaultProps: function getDefaultProps() {
    return {
      fullContentText: "More",
      bookDescriptionTargetingData: _click_tracking_helper.TRACKED_CLASSES.full_content_link
    };
  },
  componentDidMount: function componentDidMount() {
    _gr_spoiler_handler2.default.replaceSpoilerHTMLWithReactComponents(this.refs.rootNode);
  },
  render: function render() {
    var fullContentLink = _jsx("a", {
      className: "u-marginLeftTiny fullContentLink",
      href: this.props.fullContentUrl
    }, void 0, this.props.fullContentText);
    return React.createElement(
      "div",
      { ref: "rootNode", className: this.props.className },
      _jsx("span", {
        dangerouslySetInnerHTML: { __html: this.props.html }
      }),
      this.props.truncated ? _jsx(_click_tracking_wrapper2.default, {
        children: fullContentLink,
        trackingOptions: this.props.bookDescriptionTargetingData
      }) : null
    );
  }
});

},{"../../modules/ads/click_tracking_helper":2,"../click_tracking_wrapper":81,"../gr_component_factory":102,"../shared/gr_prop_types":171,"../shared/gr_spoiler_handler":172}],200:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // See documentation on https://www.goodreads.com/style_guide

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STAR_SIZES = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _shelvings_actions = require("../react_actions/shelvings_actions");

var _shelvings_actions2 = _interopRequireDefault(_shelvings_actions);

var _shelvings_store = require("../react_stores/shelvings_store");

var _shelvings_store2 = _interopRequireDefault(_shelvings_store);

var _click_tracking_wrapper = require("./click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _gr_reflux = require("../react_mixins/gr_reflux");

var _click_tracking_helper = require("../modules/ads/click_tracking_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STAR_SIZES = exports.STAR_SIZES = {
  SMALL: "smallStars",
  MEDIUM: "mediumStars",
  LARGE: "largeStars"
};

exports.default = _gr_component_factory2.default.createClass({
  displayName: "UserRating",

  mixins: [(0, _gr_reflux.connectToLazyStore)(_shelvings_store2.default, "bookId")],

  propTypes: {
    bookId: _react2.default.PropTypes.string.isRequired,
    bookTitle: _react2.default.PropTypes.string,
    starsTrackingOptions: _react2.default.PropTypes.object,
    starSize: _react2.default.PropTypes.string,
    displayLabel: _react2.default.PropTypes.bool,
    handleClick: _react2.default.PropTypes.func,
    clickstreamRef: _react2.default.PropTypes.string,
    isPreRelease: _react2.default.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      starsTrackingOptions: _click_tracking_helper.TRACKED_CLASSES.user_rating_star,
      displayLabel: true,
      starSize: STAR_SIZES.SMALL
    };
  },
  setHoverRating: function setHoverRating(rating) {
    this.setState({ hoverRating: rating });
  },
  removeHoverRating: function removeHoverRating() {
    this.setState({ hoverRating: null });
  },
  isShelved: function isShelved() {
    return this.state.exclusiveShelfName !== null;
  },
  updateRating: function updateRating(starNum, ev) {
    ev.preventDefault();

    // Check for pre-release book and show confirmation dialog
    if (this.props.isPreRelease) {
      var message = "This edition has not yet been published. Only readers with advanced copies of this book can rate it. Go to the book's page to verify you have an advanced copy and rate this book?";

      if (confirm(message)) {
        // User confirmed, redirect to book page with rating parameters
        var bookId = this.isShelved() ? this.state.book.bookId : this.props.bookId;
        window.location.href = "/book/show/" + bookId + "?rating=" + starNum + "&preReleaseChallengeQuestion=true";
      }
      // If user cancels, do nothing (no page refresh)
      return false;
    } else {
      // Not a pre-release book, proceed normally
      if (this.isShelved()) {
        _shelvings_actions2.default.rateBook(this.state.book.bookId, starNum, this.state.book.title, this.props.clickstreamRef || null, this.refs.ratingContainer, this.props.handleClick);
      } else {
        _shelvings_actions2.default.rateBook(this.props.bookId, starNum, this.props.bookTitle, this.props.clickstreamRef || null, this.refs.ratingContainer, this.props.handleClick);
      }
    }
  },
  starLabel: function starLabel(starNum) {
    var starLabel = undefined;
    if (this.state.exclusiveShelfName !== null && this.state.rating > 0) {
      starLabel = "Change rating from " + this.state.rating + " to " + starNum + " ";
    } else {
      starLabel = "Rate " + starNum + " ";
    }
    starLabel += starNum === 1 ? "star" : "stars";
    return starLabel;
  },
  renderStar: function renderStar(starIndex) {
    var starNum = starIndex + 1;
    var savedRating = this.state.exclusiveShelfName !== null ? this.state.rating : 0;
    var currentRating = this.state.hoverRating ? this.state.hoverRating : savedRating;
    var starClass = (0, _classnames2.default)("userRating__star", { "userRating__star--selected": starNum <= currentRating }, "userRating__star--" + this.props.starSize);
    var starButton = _jsx("button", {
      className: starClass,
      title: this.starLabel(starNum),
      onClick: this.updateRating.bind(this, starNum),
      onMouseEnter: this.setHoverRating.bind(this, starNum)
    });
    return _jsx(_click_tracking_wrapper2.default, {
      children: starButton,
      trackingOptions: this.props.starsTrackingOptions
    }, starNum);
  },
  renderTextLabel: function renderTextLabel() {
    if (this.props.displayLabel) {
      var labelClass = (0, _classnames2.default)("userRating__label", "gr-metaText", { "userRating__label--largeStars": this.props.starSize === STAR_SIZES.LARGE });
      return _jsx("div", {
        className: labelClass
      }, void 0, this.state.exclusiveShelfName !== null && this.state.rating > 0 ? "Your rating:" : "Rate it:");
    }
  },
  render: function render() {
    var containerClass = (0, _classnames2.default)("userRating", { "userRating--largeStars": this.props.starSize === STAR_SIZES.LARGE });
    return _jsx("div", {
      className: containerClass
    }, void 0, this.renderTextLabel(), _react2.default.createElement(
      "div",
      { className: "userRating__starsWrapper",
        tabIndex: "0",
        ref: "ratingContainer",
        role: "group",
        onMouseLeave: this.removeHoverRating },
      _lodash2.default.times(5, function (starIndex) {
        return this.renderStar(starIndex);
      }, this)
    ));
  }
});

},{"../modules/ads/click_tracking_helper":2,"../react_actions/shelvings_actions":43,"../react_mixins/gr_reflux":227,"../react_stores/shelvings_store":247,"./click_tracking_wrapper":81,"./gr_component_factory":102,"classnames":"classnames","lodash":"lodash","react":"react"}],201:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // Confirmation modal that handles block/unblocking display user

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _modal = require("../../modal");

var _modal2 = _interopRequireDefault(_modal);

var _block_user_actions = require("../../../react_actions/user/show/block_user_actions");

var _block_user_actions2 = _interopRequireDefault(_block_user_actions);

var _modal_id_helper = require("../../../modules/modal_id_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "BlockUserConfirmationModal",

  propTypes: {
    displayUser: _react.PropTypes.shape({
      firstName: React.PropTypes.string.isRequired,
      viewableName: React.PropTypes.string.isRequired,
      userId: React.PropTypes.number.isRequired
    }).isRequired,

    fromDropdown: _react.PropTypes.bool,
    isBlocked: _react.PropTypes.bool.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return { fromDropdown: false };
  },
  handleConfirmBlockUser: function handleConfirmBlockUser() {
    _block_user_actions2.default.blockMember(this.props.displayUser.userId);
  },
  render: function render() {
    if (this.props.isBlocked) {
      return _jsx(_modal2.default, {
        id: (0, _modal_id_helper.getUnblockUserModalId)(this.props.displayUser.userId, this.props.fromDropdown),
        bemModifiers: "friendFollowModule",
        onConfirmHandler: this.handleConfirmBlockUser
      }, void 0, _jsx("div", {
        className: "friendFollowConfirmModal"
      }, void 0, _jsx("h2", {
        className: "gr-h2 gr-h2--serif"
      }, void 0, "Unblock ", this.props.displayUser.viewableName, "?"), _jsx("div", {
        className: "friendFollowConfirmModal__body"
      }, void 0, "Your profile will appear to ", this.props.displayUser.firstName, " as it would to any other Goodreads member. Their comments on discussion boards will be displayed normally. Are you sure?")));
    } else {
      return _jsx(_modal2.default, {
        id: (0, _modal_id_helper.getBlockUserModalId)(this.props.displayUser.userId, this.props.fromDropdown),
        bemModifiers: "friendFollowModule",
        onConfirmHandler: this.handleConfirmBlockUser
      }, void 0, _jsx("div", {
        className: "friendFollowConfirmModal"
      }, void 0, _jsx("h2", {
        className: "gr-h2 gr-h2--serif"
      }, void 0, "Block ", this.props.displayUser.viewableName, "?"), _jsx("div", {
        className: "friendFollowConfirmModal__body"
      }, void 0, "This will prevent ", this.props.displayUser.firstName, " from sending you messages, friend request or from viewing your profile. They will not be notified. Comments on discussion boards from them will be hidden by default.")));
    }
  }
});

},{"../../../modules/modal_id_helper":17,"../../../react_actions/user/show/block_user_actions":45,"../../gr_component_factory":102,"../../modal":136,"react":"react"}],202:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // Confirmation modal for canceling friend request

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _modal = require("../../modal");

var _modal2 = _interopRequireDefault(_modal);

var _friend_follow_actions = require("../../../react_actions/user_relationships/friend_follow_actions");

var _friend_follow_actions2 = _interopRequireDefault(_friend_follow_actions);

var _modal_id_helper = require("../../../modules/modal_id_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "CancelFriendRequestConfirmationModal",

  propTypes: {
    displayUser: _react.PropTypes.shape({
      firstName: React.PropTypes.string.isRequired,
      viewableName: React.PropTypes.string.isRequired,
      userId: React.PropTypes.number.isRequired
    }).isRequired,

    fromDropdown: _react.PropTypes.bool,
    friendRequestToId: _react.PropTypes.number.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return { fromDropdown: false };
  },
  handleConfirmCancelFriendRequest: function handleConfirmCancelFriendRequest() {
    _friend_follow_actions2.default.cancelFriendRequest(this.props.displayUser.userId, this.props.friendRequestToId);
  },
  render: function render() {
    return _jsx(_modal2.default, {
      id: (0, _modal_id_helper.getCancelFriendRequestModalId)(this.props.displayUser.userId, this.props.fromDropdown),
      bemModifiers: "friendFollowModule",
      onConfirmHandler: this.handleConfirmCancelFriendRequest
    }, void 0, _jsx("div", {
      className: "friendFollowConfirmModal"
    }, void 0, _jsx("h2", {
      className: "gr-h2 gr-h2--serif"
    }, void 0, "Cancel Friend Request to ", this.props.displayUser.viewableName, "?"), _jsx("div", {
      className: "friendFollowConfirmModal__body"
    }, void 0, "This will cancel your friend request and also unfollow ", this.props.displayUser.firstName, ", removing their activity from your updates feed.")));
  }
});

},{"../../../modules/modal_id_helper":17,"../../../react_actions/user_relationships/friend_follow_actions":49,"../../gr_component_factory":102,"../../modal":136,"react":"react"}],203:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _modal = require("../../modal");

var _modal2 = _interopRequireDefault(_modal);

var _friend_follow_actions = require("../../../react_actions/user_relationships/friend_follow_actions");

var _friend_follow_actions2 = _interopRequireDefault(_friend_follow_actions);

var _modal_id_helper = require("../../../modules/modal_id_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "UnfollowConfirmationModal",

  propTypes: {
    displayUser: _react.PropTypes.shape({
      firstName: React.PropTypes.string.isRequired,
      viewableName: React.PropTypes.string.isRequired,
      userId: React.PropTypes.number.isRequired
    }).isRequired,

    fromDropdown: _react.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return { fromDropdown: false };
  },
  handleConfirmUnfollow: function handleConfirmUnfollow() {
    _friend_follow_actions2.default.unfollow(this.props.displayUser.userId);
  },
  render: function render() {
    return _jsx(_modal2.default, {
      id: (0, _modal_id_helper.getUnfollowModalId)(this.props.displayUser.userId, this.props.fromDropdown),
      bemModifiers: "friendFollowModule",
      onConfirmHandler: this.handleConfirmUnfollow
    }, void 0, _jsx("div", {
      className: "friendFollowConfirmModal"
    }, void 0, _jsx("h2", {
      className: "gr-h2 gr-h2--serif"
    }, void 0, "Unfollow ", this.props.displayUser.viewableName, "?"), _jsx("div", {
      className: "friendFollowConfirmModal__body"
    }, void 0, "This will remove ", this.props.displayUser.firstName, "'s activity from your updates feed.")));
  }
});

},{"../../../modules/modal_id_helper":17,"../../../react_actions/user_relationships/friend_follow_actions":49,"../../gr_component_factory":102,"../../modal":136,"react":"react"}],204:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _modal = require("../../modal");

var _modal2 = _interopRequireDefault(_modal);

var _friend_follow_actions = require("../../../react_actions/user_relationships/friend_follow_actions");

var _friend_follow_actions2 = _interopRequireDefault(_friend_follow_actions);

var _modal_id_helper = require("../../../modules/modal_id_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "UnfriendConfirmationModal",

  propTypes: {
    displayUser: _react.PropTypes.shape({
      firstName: React.PropTypes.string.isRequired,
      viewableName: React.PropTypes.string.isRequired,
      userId: React.PropTypes.number.isRequired
    }).isRequired,

    fromDropdown: _react.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return { fromDropdown: false };
  },
  handleConfirmUnfriend: function handleConfirmUnfriend() {
    _friend_follow_actions2.default.unfriend(this.props.displayUser.userId);
  },
  render: function render() {
    return _jsx(_modal2.default, {
      id: (0, _modal_id_helper.getUnfriendModalId)(this.props.displayUser.userId, this.props.fromDropdown),
      bemModifiers: "friendFollowModule",
      onConfirmHandler: this.handleConfirmUnfriend
    }, void 0, _jsx("div", {
      className: "friendFollowConfirmModal"
    }, void 0, _jsx("h2", {
      className: "gr-h2 gr-h2--serif"
    }, void 0, "Unfriend ", this.props.displayUser.viewableName, "?"), _jsx("div", {
      className: "friendFollowConfirmModal__body"
    }, void 0, "This will remove ", this.props.displayUser.firstName, "'s activity from your updates feed, and your own activity will stop appearing in their updates feed. ", this.props.displayUser.firstName, " will not be notified.")));
  }
});

},{"../../../modules/modal_id_helper":17,"../../../react_actions/user_relationships/friend_follow_actions":49,"../../gr_component_factory":102,"../../modal":136,"react":"react"}],205:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // React Component for follow button in FriendFollowModule. Handles both
// follow/unfollow states.

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _friend_follow_actions = require("../../react_actions/user_relationships/friend_follow_actions");

var _friend_follow_actions2 = _interopRequireDefault(_friend_follow_actions);

var _unfollow_confirmation_modal = require("./confirmation_modals/unfollow_confirmation_modal");

var _unfollow_confirmation_modal2 = _interopRequireDefault(_unfollow_confirmation_modal);

var _cancel_friend_request_confirmation_modal = require("./confirmation_modals/cancel_friend_request_confirmation_modal");

var _cancel_friend_request_confirmation_modal2 = _interopRequireDefault(_cancel_friend_request_confirmation_modal);

var _modal_id_helper = require("../../modules/modal_id_helper");

var _modal_trigger = require("../modal_trigger");

var _modal_trigger2 = _interopRequireDefault(_modal_trigger);

var _spinner = require("../spinner");

var _spinner2 = _interopRequireDefault(_spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "FollowButton",

  propTypes: {
    displayUser: _react2.default.PropTypes.shape({
      firstName: _react2.default.PropTypes.string.isRequired,
      viewableName: _react2.default.PropTypes.string.isRequired,
      userId: _react2.default.PropTypes.number.isRequired
    }).isRequired,
    isFollowing: _react2.default.PropTypes.bool.isRequired,
    isPendingFriendRequestTo: _react2.default.PropTypes.bool.isRequired,
    friendRequestToId: _react2.default.PropTypes.number,
    fromUserShowPage: _react2.default.PropTypes.bool,
    inProgress: _react2.default.PropTypes.bool
  },

  getInitialState: function getInitialState() {
    return {
      isHovering: false
    };
  },
  getDefaultProps: function getDefaultProps() {
    return {
      fromUserShowPage: false,
      inProgress: false
    };
  },
  handleMouseEnter: function handleMouseEnter() {
    this.setState({ isHovering: true });
  },
  handleMouseLeave: function handleMouseLeave() {
    this.setState({ isHovering: false });
  },
  handleFollow: function handleFollow() {
    _friend_follow_actions2.default.follow(this.props.displayUser.userId, {
      from_user_show_page: this.props.fromUserShowPage
    });
  },
  renderFollowButton: function renderFollowButton() {
    var className = (0, _classnames2.default)(this.withBemModifiers("friendFollowButton"), "friendFollowButton--dark");
    return _jsx("button", {
      className: className,
      onClick: this.handleFollow,
      type: "button"
    }, void 0, "Follow");
  },
  renderInProgressButton: function renderInProgressButton() {
    return _jsx("button", {
      className: this.withBemModifiers("friendFollowButton"),
      onClick: this.handleFollow,
      type: "button"
    }, void 0, _jsx(_spinner2.default, {}));
  },
  renderUnfollowButton: function renderUnfollowButton() {
    var className = (0, _classnames2.default)(this.withBemModifiers("friendFollowCheckmark"), "u-inlineBlock");
    var buttonText = this.state.isHovering ? "Unfollow" : _jsx("span", {}, void 0, _jsx("div", {
      className: className
    }), "Following");

    // render cancel friend request modal over unfollow modal when user clicks
    // "Unfollow" if current user has pending friend request to display user
    var modal = undefined,
        modalId = undefined;
    if (this.props.isPendingFriendRequestTo && this.props.friendRequestToId) {
      modal = _jsx(_cancel_friend_request_confirmation_modal2.default, {
        displayUser: this.props.displayUser,
        friendRequestToId: this.props.friendRequestToId
      });
      modalId = (0, _modal_id_helper.getCancelFriendRequestModalId)(this.props.displayUser.userId);
    } else {
      modal = _jsx(_unfollow_confirmation_modal2.default, {
        displayUser: this.props.displayUser
      });
      modalId = (0, _modal_id_helper.getUnfollowModalId)(this.props.displayUser.userId);
    }

    return _jsx("div", {
      className: "u-inlineBlock"
    }, void 0, _jsx(_modal_trigger2.default, {
      id: modalId
    }, void 0, _jsx("button", {
      className: this.withBemModifiers("friendFollowButton"),
      onMouseEnter: this.handleMouseEnter,
      onMouseLeave: this.handleMouseLeave,
      type: "button"
    }, void 0, buttonText)), modal);
  },
  render: function render() {
    if (this.props.inProgress) {
      return this.renderInProgressButton();
    }
    return this.props.isFollowing ? this.renderUnfollowButton() : this.renderFollowButton();
  }
});

},{"../../modules/modal_id_helper":17,"../../react_actions/user_relationships/friend_follow_actions":49,"../gr_component_factory":102,"../modal_trigger":137,"../spinner":186,"./confirmation_modals/cancel_friend_request_confirmation_modal":202,"./confirmation_modals/unfollow_confirmation_modal":203,"classnames":"classnames","react":"react"}],206:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // React Component for friend button in FriendFollowModule. Handles both
// friend and unfriend states

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _modal_trigger = require("../modal_trigger");

var _modal_trigger2 = _interopRequireDefault(_modal_trigger);

var _unfriend_confirmation_modal = require("./confirmation_modals/unfriend_confirmation_modal");

var _unfriend_confirmation_modal2 = _interopRequireDefault(_unfriend_confirmation_modal);

var _friend_follow_actions = require("../../react_actions/user_relationships/friend_follow_actions");

var _friend_follow_actions2 = _interopRequireDefault(_friend_follow_actions);

var _modal_id_helper = require("../../modules/modal_id_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "FriendButton",

  propTypes: {
    displayUser: _react2.default.PropTypes.shape({
      firstName: _react2.default.PropTypes.string.isRequired,
      viewableName: _react2.default.PropTypes.string.isRequired,
      userId: _react2.default.PropTypes.number.isRequired
    }).isRequired,
    addFriendUrl: _react2.default.PropTypes.string.isRequired,
    isFriend: _react2.default.PropTypes.bool.isRequired,
    isPendingFriendRequestFrom: _react2.default.PropTypes.bool.isRequired,
    isPendingFriendRequestTo: _react2.default.PropTypes.bool.isRequired,
    friendRequestFromId: _react2.default.PropTypes.number
  },

  getInitialState: function getInitialState() {
    return {
      isHovering: false
    };
  },
  handleMouseEnter: function handleMouseEnter() {
    this.setState({ isHovering: true });
  },
  handleMouseLeave: function handleMouseLeave() {
    this.setState({ isHovering: false });
  },
  handleAcceptFriendRequest: function handleAcceptFriendRequest() {
    _friend_follow_actions2.default.acceptFriendRequest(this.props.displayUser.userId, this.props.friendRequestFromId);
  },

  // handles 3 states:
  // 1. isPendingFriendRequestFrom: render confirm request button
  // 2. isPendingFriendRequestTo: render "Pending"
  // 3. no friend requests either direction: link to send friend request page
  renderFriendButton: function renderFriendButton() {
    if (this.props.isPendingFriendRequestFrom && this.props.friendRequestFromId) {
      return _jsx("button", {
        className: "friendFollowButton",
        onClick: this.handleAcceptFriendRequest,
        type: "button"
      }, void 0, "Accept request");
    } else if (this.props.isPendingFriendRequestTo) {
      return _jsx("button", {
        className: "friendFollowButton",
        type: "button",
        disabled: true
      }, void 0, "Pending");
    } else {
      return _jsx("a", {
        className: "friendFollowButton",
        href: this.props.addFriendUrl
      }, void 0, "Add friend");
    }
  },
  renderUnfriendButton: function renderUnfriendButton() {
    var buttonText = this.state.isHovering ? "Unfriend" : _jsx("span", {}, void 0, _jsx("div", {
      className: "u-inlineBlock friendFollowCheckmark"
    }), "Friends");

    return _jsx("div", {
      className: "u-inlineBlock"
    }, void 0, _jsx(_modal_trigger2.default, {
      id: (0, _modal_id_helper.getUnfriendModalId)(this.props.displayUser.userId)
    }, void 0, _jsx("button", {
      className: "friendFollowButton",
      onMouseEnter: this.handleMouseEnter,
      onMouseLeave: this.handleMouseLeave,
      type: "button"
    }, void 0, buttonText)), _jsx(_unfriend_confirmation_modal2.default, {
      displayUser: this.props.displayUser
    }));
  },
  render: function render() {
    return this.props.isFriend ? this.renderUnfriendButton() : this.renderFriendButton();
  }
});

},{"../../modules/modal_id_helper":17,"../../react_actions/user_relationships/friend_follow_actions":49,"../gr_component_factory":102,"../modal_trigger":137,"./confirmation_modals/unfriend_confirmation_modal":204,"react":"react"}],207:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // React component for dropdown list in FriendFollowModule.
// Handles logic for what available options there are depending on
// friend/follow state.

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _friend_follow_module_store = require("../../react_stores/user_relationships/friend_follow_module_store");

var _friend_follow_module_store2 = _interopRequireDefault(_friend_follow_module_store);

var _block_user_store = require("../../react_stores/user/show/block_user_store");

var _block_user_store2 = _interopRequireDefault(_block_user_store);

var _dropdown = require("../dropdown");

var _dropdown2 = _interopRequireDefault(_dropdown);

var _modal_trigger = require("../modal_trigger");

var _modal_trigger2 = _interopRequireDefault(_modal_trigger);

var _cancel_friend_request_confirmation_modal = require("./confirmation_modals/cancel_friend_request_confirmation_modal");

var _cancel_friend_request_confirmation_modal2 = _interopRequireDefault(_cancel_friend_request_confirmation_modal);

var _unfriend_confirmation_modal = require("./confirmation_modals/unfriend_confirmation_modal");

var _unfriend_confirmation_modal2 = _interopRequireDefault(_unfriend_confirmation_modal);

var _unfollow_confirmation_modal = require("./confirmation_modals/unfollow_confirmation_modal");

var _unfollow_confirmation_modal2 = _interopRequireDefault(_unfollow_confirmation_modal);

var _block_user_confirmation_modal = require("./confirmation_modals/block_user_confirmation_modal");

var _block_user_confirmation_modal2 = _interopRequireDefault(_block_user_confirmation_modal);

var _modal_id_helper = require("../../modules/modal_id_helper");

var _React = require("react/lib/React");

var _React2 = _interopRequireDefault(_React);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "FriendFollowDropdown",

  mixins: [_reflux2.default.connect(_friend_follow_module_store2.default, "ffStore"), _reflux2.default.connect(_block_user_store2.default, "buStore")],

  propTypes: {
    displayUser: _React2.default.PropTypes.shape({
      firstName: _React2.default.PropTypes.string.isRequired,
      viewableName: _React2.default.PropTypes.string.isRequired,
      userId: _React2.default.PropTypes.number.isRequired
    }).isRequired,
    displayMobileDropdown: _React2.default.PropTypes.bool.isRequired,
    sendMessageUrl: _React2.default.PropTypes.string.isRequired,
    recommendBooksUrl: _React2.default.PropTypes.string.isRequired,
    compareBooksUrl: _React2.default.PropTypes.string.isRequired,
    flagAbuseUrl: _React2.default.PropTypes.string.isRequired,
    addFriendUrl: _React2.default.PropTypes.string.isRequired,
    renderFriendButton: _React2.default.PropTypes.bool.isRequired,
    friendButtonInDropdown: _React2.default.PropTypes.bool.isRequired,
    friendRequestToId: _React2.default.PropTypes.number,
    // TODO: Remove messageLinkRestricted after completion of https://issues.amazon.com/issues/CaR-8657
    messageLinkRestricted: _React2.default.PropTypes.bool
  },

  // TODO: Remove renderMessageLink after completion of https://issues.amazon.com/issues/CaR-8657
  renderMessageLink: function renderMessageLink() {
    if (!this.props.messageLinkRestricted) {
      return _jsx("a", {
        className: "friendFollowModuleDropdownMenu__dropdownLink",
        href: this.props.sendMessageUrl,
        rel: "nofollow",
        "data-testid": "message"
      }, void 0, "Message");
    }
  },
  renderRecommendBooksLink: function renderRecommendBooksLink() {
    if (this.state.ffStore.isFriend) {
      return _jsx("a", {
        className: "friendFollowModuleDropdownMenu__dropdownLink",
        href: this.props.recommendBooksUrl,
        rel: "nofollow",
        "data-testid": "recommendBooks"
      }, void 0, "Recommend books");
    }
  },
  shouldRenderCancelFriendRequestModal: function shouldRenderCancelFriendRequestModal() {
    return this.state.ffStore.isFollowing && this.state.ffStore.isPendingFriendRequestTo && this.props.friendRequestToId;
  },
  shouldRenderUnfollowModal: function shouldRenderUnfollowModal() {
    return this.state.ffStore.isFollowing && !this.state.ffStore.isPendingFriendRequestTo;
  },
  renderFollowingLinks: function renderFollowingLinks() {
    if (this.shouldRenderCancelFriendRequestModal()) {
      return _jsx("div", {
        className: "friendFollowModuleDropdownMenu__dropdownLink"
      }, void 0, _jsx(_modal_trigger2.default, {
        id: (0, _modal_id_helper.getCancelFriendRequestModalId)(this.props.displayUser.userId, true)
      }, void 0, _jsx("button", {
        className: "gr-buttonAsLink gr-buttonAsLink--black",
        type: "button",
        "data-testid": "cancelFriendRequest"
      }, void 0, "Cancel friend request")));
    } else if (this.shouldRenderUnfollowModal()) {
      return _jsx("div", {
        className: "friendFollowModuleDropdownMenu__dropdownLink"
      }, void 0, _jsx(_modal_trigger2.default, {
        id: (0, _modal_id_helper.getUnfollowModalId)(this.props.displayUser.userId, true)
      }, void 0, _jsx("button", {
        className: "gr-buttonAsLink gr-buttonAsLink--black",
        type: "button",
        "data-testid": "unfollow"
      }, void 0, "Unfollow")));
    }
  },
  shouldRenderUnfriendModal: function shouldRenderUnfriendModal() {
    return this.state.ffStore.isFriend;
  },
  renderFriendLinks: function renderFriendLinks() {
    if (this.state.ffStore.isFriend) {
      return _jsx("div", {}, void 0, _jsx("div", {
        className: "friendFollowModuleDropdownMenu__dropdownLink"
      }, void 0, _jsx(_modal_trigger2.default, {
        id: (0, _modal_id_helper.getUnfriendModalId)(this.props.displayUser.userId, true)
      }, void 0, _jsx("button", {
        className: "gr-buttonAsLink gr-buttonAsLink--black",
        type: "button",
        "data-testid": "unfriend"
      }, void 0, "Unfriend ", this.props.displayUser.firstName))));
    } else {
      if (this.props.friendButtonInDropdown && this.props.renderFriendButton && !this.state.ffStore.isPendingFriendRequestTo) {
        return _jsx("a", {
          className: "friendFollowModuleDropdownMenu__dropdownLink",
          href: this.props.addFriendUrl,
          rel: "nofollow",
          "data-testid": "addFriend"
        }, void 0, "Add friend");
      }
    }
  },
  renderBlockUserText: function renderBlockUserText() {
    if (this.state.buStore.isBlocked) {
      return "Unblock";
    } else {
      return "Block this member";
    }
  },
  renderBlockUserLink: function renderBlockUserLink() {
    var buttonText = this.renderBlockUserText();

    var modalId = this.state.buStore.isBlocked ? (0, _modal_id_helper.getUnblockUserModalId)(this.props.displayUser.userId, true) : (0, _modal_id_helper.getBlockUserModalId)(this.props.displayUser.userId, true);

    return _jsx("div", {
      className: "friendFollowModuleDropdownMenu__dropdownLink"
    }, void 0, _jsx(_modal_trigger2.default, {
      id: modalId
    }, void 0, _jsx("button", {
      className: "gr-buttonAsLink friendFollowModule__blockedUserText friendFollowModule__blockedUserText--black",
      type: "button",
      "data-testid": "blockUser"
    }, void 0, buttonText)));
  },
  renderBlockUserConfirmationModal: function renderBlockUserConfirmationModal() {
    return _jsx(_block_user_confirmation_modal2.default, {
      displayUser: this.props.displayUser,
      isBlocked: this.state.buStore.isBlocked,
      fromDropdown: true
    });
  },

  // TODO: Remove renderMessageLink after completion of https://issues.amazon.com/issues/CaR-8657
  renderDropdownList: function renderDropdownList() {
    return _jsx("div", {
      className: "friendFollowModuleDropdownMenu"
    }, void 0, this.renderMessageLink(), this.renderRecommendBooksLink(), _jsx("a", {
      className: "friendFollowModuleDropdownMenu__dropdownLink",
      href: this.props.compareBooksUrl,
      rel: "nofollow",
      "data-testid": "compareBooks"
    }, void 0, "Compare books"), this.renderFollowingLinks(), this.renderFriendLinks(), _jsx("a", {
      className: "friendFollowModuleDropdownMenu__dropdownLink",
      href: this.props.flagAbuseUrl,
      rel: "nofollow",
      "data-testid": "flagAbuse"
    }, void 0, "Report this account"), this.renderBlockUserLink());
  },
  renderMobileDropdownList: function renderMobileDropdownList() {
    return _jsx("div", {
      className: "friendFollowModuleDropdownMenu"
    }, void 0, _jsx("a", {
      className: "friendFollowModuleDropdownMenu__dropdownLink",
      href: this.props.flagAbuseUrl,
      rel: "nofollow",
      "data-testid": "flagAbuse"
    }, void 0, "Report this account"), this.renderBlockUserLink());
  },
  renderDropdownTrigger: function renderDropdownTrigger() {
    return _jsx("div", {}, void 0, _jsx("span", {
      className: "friendFollowModuleCaret__text"
    }, void 0, "More"), _jsx("div", {
      className: "friendFollowModuleCaret__image"
    }));
  },
  renderMobileDropdownTrigger: function renderMobileDropdownTrigger() {
    return _jsx("div", {
      className: "friendFollowModuleMobileDropdownTrigger"
    });
  },
  render: function render() {
    if (this.props.displayMobileDropdown) {
      return _jsx("div", {
        className: "friendFollowModuleMobileDropdown"
      }, void 0, _jsx(_dropdown2.default, {
        trigger: this.renderMobileDropdownTrigger(),
        triggerEventType: _dropdown2.default.TriggerEventTypes.CLICK,
        tooltipText: "More",
        bemModifiers: "friendFollowModuleMobile",
        fallbackUrl: this.props.flagAbuseUrl,
        children: this.renderMobileDropdownList()
      }), this.renderBlockUserConfirmationModal());
    }
    return _jsx("div", {
      className: "friendFollowModuleCaret"
    }, void 0, _jsx(_dropdown2.default, {
      trigger: this.renderDropdownTrigger(),
      triggerEventType: _dropdown2.default.TriggerEventTypes.CLICK,
      tooltipText: "More",
      bemModifiers: "friendFollowModule",
      children: this.renderDropdownList()
    }), this.shouldRenderCancelFriendRequestModal() && _jsx(_cancel_friend_request_confirmation_modal2.default, {
      displayUser: this.props.displayUser,
      isPendingFriendRequestTo: this.state.ffStore.isPendingFriendRequestTo,
      friendRequestToId: this.props.friendRequestToId,
      fromDropdown: true
    }), this.shouldRenderUnfollowModal() && _jsx(_unfollow_confirmation_modal2.default, {
      displayUser: this.props.displayUser,
      fromDropdown: true
    }), this.shouldRenderUnfriendModal() && _jsx(_unfriend_confirmation_modal2.default, {
      displayUser: this.props.displayUser,
      fromDropdown: true
    }), this.renderBlockUserConfirmationModal());
  }
});

},{"../../modules/modal_id_helper":17,"../../react_stores/user/show/block_user_store":249,"../../react_stores/user_relationships/friend_follow_module_store":253,"../dropdown":90,"../gr_component_factory":102,"../modal_trigger":137,"./confirmation_modals/block_user_confirmation_modal":201,"./confirmation_modals/cancel_friend_request_confirmation_modal":202,"./confirmation_modals/unfollow_confirmation_modal":203,"./confirmation_modals/unfriend_confirmation_modal":204,"react/lib/React":323,"reflux":"reflux"}],208:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // React Component for friend/follow button module on user show page.
// Handles logic for when to render Friend/Follow buttons - "Un" states are
// handled by the individual button components

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _follow_button = require("./follow_button");

var _follow_button2 = _interopRequireDefault(_follow_button);

var _friend_button = require("./friend_button");

var _friend_button2 = _interopRequireDefault(_friend_button);

var _friend_follow_dropdown = require("./friend_follow_dropdown");

var _friend_follow_dropdown2 = _interopRequireDefault(_friend_follow_dropdown);

var _spinner = require("../spinner");

var _spinner2 = _interopRequireDefault(_spinner);

var _modal_trigger = require("../modal_trigger");

var _modal_trigger2 = _interopRequireDefault(_modal_trigger);

var _block_user_confirmation_modal = require("./confirmation_modals/block_user_confirmation_modal");

var _block_user_confirmation_modal2 = _interopRequireDefault(_block_user_confirmation_modal);

var _modal_id_helper = require("../../modules/modal_id_helper");

var _friend_follow_module_store = require("../../react_stores/user_relationships/friend_follow_module_store");

var _friend_follow_module_store2 = _interopRequireDefault(_friend_follow_module_store);

var _block_user_store = require("../../react_stores/user/show/block_user_store");

var _block_user_store2 = _interopRequireDefault(_block_user_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "FriendFollowModule",

  mixins: [_reflux2.default.connectFilter(_friend_follow_module_store2.default, "ffStore", function (store) {
    return store[this.props.displayUser.userId];
  }), _reflux2.default.connect(_block_user_store2.default, "buStore")],

  propTypes: {
    displayUser: _react2.default.PropTypes.shape({
      firstName: _react2.default.PropTypes.string.isRequired,
      viewableName: _react2.default.PropTypes.string.isRequired,
      userId: _react2.default.PropTypes.number.isRequired
    }).isRequired,
    hideDropdown: _react2.default.PropTypes.bool.isRequired,
    displayMobileDropdown: _react2.default.PropTypes.bool.isRequired,
    sendMessageUrl: _react2.default.PropTypes.string.isRequired,
    recommendBooksUrl: _react2.default.PropTypes.string.isRequired,
    compareBooksUrl: _react2.default.PropTypes.string.isRequired,
    flagAbuseUrl: _react2.default.PropTypes.string.isRequired,
    addFriendUrl: _react2.default.PropTypes.string.isRequired,
    friendRequestToId: _react2.default.PropTypes.number,
    friendRequestFromId: _react2.default.PropTypes.number,
    renderFollowButton: _react2.default.PropTypes.bool.isRequired,
    renderFriendButton: _react2.default.PropTypes.bool.isRequired,
    friendButtonInDropdown: _react2.default.PropTypes.bool.isRequired,

    // adds additional tracking param for Follows on user show page
    fromUserShowPage: _react2.default.PropTypes.bool,
    // TODO: Remove messageLinkRestricted after completion of https://issues.amazon.com/issues/CaR-8657
    messageLinkRestricted: _react2.default.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      fromUserShowPage: false
    };
  },
  shouldRenderFriendButton: function shouldRenderFriendButton() {
    return this.props.renderFriendButton && !this.props.friendButtonInDropdown;
  },
  shouldRenderFollowButton: function shouldRenderFollowButton() {
    return this.props.renderFollowButton && !this.state.ffStore.isFriend;
  },
  render: function render() {
    if (this.state.ffStore.inProgress || this.state.buStore.blockInProgress) {
      return _jsx("div", {
        className: "u-clearBoth"
      }, void 0, _jsx(_spinner2.default, {}));
    }

    var followCx = (0, _classnames2.default)("u-inlineBlock", {
      "u-marginRightMedium": this.shouldRenderFriendButton()
    });

    return _jsx("div", {
      className: "friendFollowModule"
    }, void 0, this.state.buStore.isBlocked && _jsx("div", {
      className: "friendFollowModule__blockedUserText",
      "data-testid": "blockText"
    }, void 0, "You've blocked ", this.props.displayUser.firstName, ".", _jsx("div", {
      className: "friendFollowModule__blockedUserTextTrigger"
    }, void 0, _jsx(_modal_trigger2.default, {
      id: (0, _modal_id_helper.getUnblockUserModalId)(this.props.displayUser.userId)
    }, void 0, _jsx("button", {
      className: "gr-buttonAsLink friendFollowModule__blockedUserText friendFollowModule__blockedUserText--red",
      type: "button"
    }, void 0, "Unblock")), _jsx(_block_user_confirmation_modal2.default, {
      isBlocked: this.state.buStore.isBlocked,
      displayUser: this.props.displayUser,
      isPendingFriendRequestTo: this.state.ffStore.isPendingFriendRequestTo
    }))), _jsx("div", {
      className: "u-marginAuto"
    }, void 0, this.shouldRenderFollowButton() && _jsx("div", {
      className: followCx
    }, void 0, _jsx(_follow_button2.default, {
      displayUser: this.props.displayUser,
      isFollowing: this.state.ffStore.isFollowing,
      isPendingFriendRequestTo: this.state.ffStore.isPendingFriendRequestTo,
      friendRequestToId: this.props.friendRequestToId,
      fromUserShowPage: this.props.fromUserShowPage
    })), this.shouldRenderFriendButton() && _jsx(_friend_button2.default, {
      displayUser: this.props.displayUser,
      addFriendUrl: this.props.addFriendUrl,
      isFriend: this.state.ffStore.isFriend,
      isPendingFriendRequestFrom: this.state.ffStore.isPendingFriendRequestFrom,
      isPendingFriendRequestTo: this.state.ffStore.isPendingFriendRequestTo,
      friendRequestFromId: this.props.friendRequestFromId
    }), !this.props.hideDropdown && _react2.default.createElement(_friend_follow_dropdown2.default, this.props)));
  }
});

},{"../../modules/modal_id_helper":17,"../../react_stores/user/show/block_user_store":249,"../../react_stores/user_relationships/friend_follow_module_store":253,"../gr_component_factory":102,"../modal_trigger":137,"../spinner":186,"./confirmation_modals/block_user_confirmation_modal":201,"./follow_button":205,"./friend_button":206,"./friend_follow_dropdown":207,"classnames":"classnames","react":"react","reflux":"reflux"}],209:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ALWAYS_DISPLAY_STARS_PROP = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _gr_reflux = require("../../react_mixins/gr_reflux");

var _click_tracking_helper = require("../../modules/ads/click_tracking_helper");

var _default_shelves = require("../../modules/default_shelves");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _shelvings_store = require("../../react_stores/shelvings_store");

var _shelvings_store2 = _interopRequireDefault(_shelvings_store);

var _user_shelves_store = require("../../react_stores/user_shelves_store");

var _user_shelves_store2 = _interopRequireDefault(_user_shelves_store);

var _want_to_read_menu_store = require("../../react_stores/want_to_read_menu_store");

var _want_to_read_menu_store2 = _interopRequireDefault(_want_to_read_menu_store);

var _want_to_read_menu_actions = require("../../react_actions/want_to_read_menu_actions");

var _want_to_read_menu_actions2 = _interopRequireDefault(_want_to_read_menu_actions);

var _user_agent_capabilities_store = require("../../react_stores/user_agent_capabilities_store");

var _user_agent_capabilities_store2 = _interopRequireDefault(_user_agent_capabilities_store);

var _shelvings_actions = require("../../react_actions/shelvings_actions");

var _shelvings_actions2 = _interopRequireDefault(_shelvings_actions);

var _dropdown = require("../dropdown");

var _dropdown2 = _interopRequireDefault(_dropdown);

var _modal = require("../modal");

var _modal2 = _interopRequireDefault(_modal);

var _modal_trigger = require("../modal_trigger");

var _modal_trigger2 = _interopRequireDefault(_modal_trigger);

var _modal_actions = require("../../react_actions/modal_actions");

var _modal_actions2 = _interopRequireDefault(_modal_actions);

var _modal_store = require("../../react_stores/modal_store");

var _modal_store2 = _interopRequireDefault(_modal_store);

var _want_to_read_menu = require("../want_to_read/want_to_read_menu");

var _want_to_read_menu2 = _interopRequireDefault(_want_to_read_menu);

var _user_rating = require("../user_rating");

var _user_rating2 = _interopRequireDefault(_user_rating);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SAVING_BUTTON_TEXT = "Saving…";
var BOOK_ALSO_MARKED_AS_READ_TEXT = "This book has also been marked as Read";
var ALWAYS_DISPLAY_STARS_PROP = exports.ALWAYS_DISPLAY_STARS_PROP = "ALWAYS_DISPLAY_STARS_PROP";

exports.default = _gr_component_factory2.default.createClass({
  displayName: "WantToReadButton",

  propTypes: {
    bookId: _react2.default.PropTypes.string.isRequired,
    bookTitle: _react2.default.PropTypes.string.isRequired,
    uniqueId: _react2.default.PropTypes.string.isRequired,
    // Defaults to `display: none` for breakpoints under $large-site-width (1220px).
    // Set `showStars` to ALWAYS_DISPLAY_STARS_PROP to always display regardless of breakpoint
    showStars: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.bool, _react2.default.PropTypes.string]),
    showMenu: _react2.default.PropTypes.bool,
    origin: _react2.default.PropTypes.string,
    trackingOptions: _react2.default.PropTypes.object,
    starsTrackingOptions: _react2.default.PropTypes.object,
    withModalShelvingMenu: _react2.default.PropTypes.bool
  },
  mixins: [(0, _gr_reflux.connectToLazyStore)(_shelvings_store2.default, "bookId", { stateKey: "shelvings" }), (0, _gr_reflux.connectToLazyStore)(_want_to_read_menu_store2.default, "uniqueId", { stateKey: "wantToReadMenu" }), _reflux2.default.connect(_user_shelves_store2.default, "userShelves"), _reflux2.default.connect(_user_agent_capabilities_store2.default, "userAgentCapabilities"), _reflux2.default.connect(_modal_store2.default, "modalStore")],

  getDefaultProps: function getDefaultProps() {
    return {
      showStars: false,
      showMenu: true,
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES.want_to_read_button,
      withModalShelvingMenu: false
    };
  },
  shelveBook: function shelveBook() {
    _shelvings_actions2.default.shelveBook(this.props.bookId, _user_shelves_store2.default.defaultShelves().WANT_TO_READ, this.props.origin);
  },
  unshelveBook: function unshelveBook() {
    if (window.confirm("Removing a book deletes your rating, review, etc. Remove this book from all your shelves?")) {
      _shelvings_actions2.default.unshelveBook(this.state.shelvings.book.bookId);
    }
  },

  /*
    A note about this.restoreFocusOnUpdate:
     This was a bit tricky because we have to a) save which specific button was
    pressed to change a shelving, and b) refocus on the same button after
    multiple instances of the component updated. We needed some way to uniquely
    identify each button even if they have the same state, which ruled out
    adding another state variable to the store. Also, setting state would in
    turn cause the component to re-render, which made problems for us.
     This feels hacky, but it's the best solution we have at the time.
  */
  focusButton: function focusButton(button) {
    if (button && this.restoreFocusOnUpdate && !this.state.isShelvingInProgress) {
      this.forgetFocus();
      button.focus();
    }
  },
  rememberFocus: function rememberFocus() {
    this.restoreFocusOnUpdate = true;
  },
  forgetFocus: function forgetFocus() {
    this.restoreFocusOnUpdate = false;
  },
  checkmarkClass: function checkmarkClass() {
    return (0, _default_shelves.checkIconClassnames)(this.state.shelvings.exclusiveShelfName);
  },
  unshelved: function unshelved() {
    return this.state.shelvings.exclusiveShelfName === null;
  },
  getBookId: function getBookId() {
    return this.unshelved() ? this.props.bookId : this.state.shelvings.book.bookId;
  },
  getBookTitle: function getBookTitle() {
    return this.unshelved() ? this.props.bookTitle : this.state.shelvings.book.title;
  },
  renderWantToReadLeftUnshelved: function renderWantToReadLeftUnshelved() {
    var buttonText = this.state.shelvings.isShelvingInProgress ? SAVING_BUTTON_TEXT : "Want to Read";
    var wantToReadLeftClasses = (0, _classnames2.default)("wantToReadButton__leftUnshelvedButton", { "wantToReadButton__leftUnshelvedButton--noOutline": this.state.shelvings.isShelvingInProgress });
    var shelvingLabel = "Add " + this.props.bookTitle + " to your want to read shelf";
    return _react2.default.createElement(
      "button",
      { "aria-label": shelvingLabel,
        ref: this.focusButton,
        className: wantToReadLeftClasses,
        onClick: this.shelveBook,
        onFocus: this.rememberFocus,
        onBlur: this.forgetFocus },
      buttonText
    );
  },
  renderWantToReadLeftShelved: function renderWantToReadLeftShelved() {
    var buttonClasses = (0, _classnames2.default)("wantToReadButton__leftShelvedButton");
    var checkmarkClasses = (0, _classnames2.default)({ wantToReadButton__checkIcon: !this.state.shelvings.isShelvingInProgress }, this.checkmarkClass());
    var shelvingLabel = "Remove " + this.state.shelvings.book.title + " from my shelves";
    var buttonText = this.state.shelvings.isShelvingInProgress ? SAVING_BUTTON_TEXT : this.state.shelvings.exclusiveShelfDisplayName;
    if (this.state.userAgentCapabilities.touch) {
      return _react2.default.createElement(
        "button",
        { "aria-label": shelvingLabel,
          onClick: this.unshelveBook,
          onFocus: this.rememberFocus,
          onBlur: this.forgetFocus,
          ref: this.focusButton,
          className: buttonClasses },
        _jsx("span", {
          className: checkmarkClasses + " u-inlineBlock"
        }),
        _jsx("div", {
          className: "wantToReadButton__shelvedButtonText"
        }, void 0, buttonText)
      );
    } else {
      return _jsx("span", {}, void 0, _react2.default.createElement("button", { "aria-label": shelvingLabel,
        ref: this.focusButton,
        onClick: this.unshelveBook,
        onFocus: this.rememberFocus,
        onBlur: this.forgetFocus,
        className: buttonClasses + " " + checkmarkClasses }), _jsx("div", {
        className: "wantToReadButton__shelvedButtonText"
      }, void 0, buttonText));
    }
  },
  renderWantToReadRight: function renderWantToReadRight() {
    var bookId = this.getBookId();
    var bookTitle = this.getBookTitle();

    var dropdownModifiers = ["wantToReadMenu"];
    if (this.props.withModalShelvingMenu) {
      dropdownModifiers.push("wtrMenuToggleDropdown");
    }

    if (this.props.showMenu && !this.isWTRModalOpen()) {
      return _jsx(_dropdown2.default, {
        trigger: this.renderWantToReadRightButtonContents(),
        triggerEventType: _dropdown2.default.TriggerEventTypes.HOVER,
        bemModifiers: dropdownModifiers
      }, void 0, _jsx(_want_to_read_menu2.default, {
        uniqueId: this.props.uniqueId,
        bookId: bookId,
        bookTitle: bookTitle,
        userShelves: this.state.userShelves,
        shelvings: this.state.shelvings
      }));
    } else {
      return null;
    }
  },
  getModalId: function getModalId() {
    return "wtrModal" + this.getBookId();
  },
  isWTRModalOpen: function isWTRModalOpen() {
    return this.state.modalStore.currentActiveModal && this.state.modalStore.currentActiveModal === this.getModalId();
  },
  hideBookAlsoMarkedAsReadMessage: function hideBookAlsoMarkedAsReadMessage() {
    if (this.state.showBookAlsoMarkedAsReadMessage) {
      this.setState({ showBookAlsoMarkedAsReadMessage: false });
    }
  },
  handleWTRMenuNonExclusiveShelvingWithoutExclusive: function handleWTRMenuNonExclusiveShelvingWithoutExclusive() {
    this.setState({ showBookAlsoMarkedAsReadMessage: true });
  },
  handleModalClose: function handleModalClose() {
    _want_to_read_menu_actions2.default.closeAddShelfTextbox(this.props.uniqueId);
    this.hideBookAlsoMarkedAsReadMessage();
  },
  handleDoneClick: function handleDoneClick() {
    _modal_actions2.default.closeModal();
    this.hideBookAlsoMarkedAsReadMessage();
  },
  renderModal: function renderModal() {
    var bookId = this.getBookId();
    var bookTitle = this.getBookTitle();
    if (this.props.showMenu && this.props.withModalShelvingMenu) {
      // Class `wtrMenuToggleModal` sets display to none when window is past
      // sm breakpoint, which can lead to the Modal being in active
      // state while not being displayed (say, if user resizes the window).
      // This is no bueno because we stop body scroll when Modal is active,
      // so instead we check and make sure the modal is closed before adding the
      // toggle class.
      var cx = (0, _classnames2.default)("wtrModalContainer", {
        wtrMenuToggleModal: !this.isWTRModalOpen()
      });
      return _jsx("div", {
        className: cx
      }, void 0, _jsx(_modal_trigger2.default, {
        id: this.getModalId()
      }, void 0, _jsx("button", {
        type: "button",
        className: "wtrModalContainer__trigger"
      }, void 0, this.renderWantToReadRightButtonContents())), _jsx(_modal2.default, {
        id: this.getModalId(),
        centered: true,
        onCloseHandler: this.handleModalClose
      }, void 0, _jsx("div", {
        className: "wtrModal"
      }, void 0, _jsx("h3", {
        className: "gr-h3 gr-h3--serif gr-h3--noMargin u-paddingBottomXSmall"
      }, void 0, "Shelve ", this.props.bookTitle), _jsx(_want_to_read_menu2.default, {
        uniqueId: this.props.uniqueId,
        bookId: bookId,
        bookTitle: bookTitle,
        userShelves: this.state.userShelves,
        shelvings: this.state.shelvings,
        useModalView: true,
        bemModifiers: "modalView",
        onNonExclusiveShelvingWithoutExclusive: this.handleWTRMenuNonExclusiveShelvingWithoutExclusive,
        onExclusiveShelvingChange: this.hideBookAlsoMarkedAsReadMessage
      })),
      /* Done button gets replaced by add/cancel buttons when AddNewShelf
         is enabled */
      !this.state.wantToReadMenu.showAddShelfTextbox && _jsx("button", {
        type: "button",
        className: "gr-button wtrModal__closeButton",
        "aria-label": "Close want to read menu",
        onClick: this.handleDoneClick
      }, void 0, "Done"), this.state.showBookAlsoMarkedAsReadMessage && _jsx("div", {
        className: "wtrModal__alsoMarkedAsReadMessage"
      }, void 0, BOOK_ALSO_MARKED_AS_READ_TEXT)));
    } else {
      return null;
    }
  },
  renderWantToReadRightButtonContents: function renderWantToReadRightButtonContents() {
    return _jsx("div", {
      className: "wantToReadButton__right"
    }, void 0, _jsx("span", {
      className: "u-visuallyHidden"
    }, void 0, "Shelving menu"));
  },
  render: function render() {
    var wantToReadLeft = "";
    var wantToReadClassLeft = (0, _classnames2.default)("wantToReadButton__left", { "wantToReadButton__left--standalone": !this.props.showMenu }, { wantToReadButton__leftUnshelved: this.unshelved() }, { wantToReadButton__leftShelved: !this.unshelved() });

    if (this.unshelved()) {
      wantToReadLeft = this.renderWantToReadLeftUnshelved();
    } else {
      wantToReadLeft = this.renderWantToReadLeftShelved();
    }
    var starsCx = (0, _classnames2.default)("wtrStarsContainer", {
      "wtrStarsContainer--alwaysDisplay": this.props.showStars === ALWAYS_DISPLAY_STARS_PROP
    });
    return _jsx("div", {}, void 0, _jsx("div", {
      className: "wantToReadButton"
    }, void 0, _jsx("div", {
      className: wantToReadClassLeft
    }, void 0, wantToReadLeft), this.renderModal(), this.renderWantToReadRight()), this.props.showStars ? _jsx("div", {
      className: starsCx
    }, void 0, _jsx(_user_rating2.default, {
      bookId: this.props.bookId,
      starsTrackingOptions: this.props.starsTrackingOptions
    })) : null);
  }
});

},{"../../modules/ads/click_tracking_helper":2,"../../modules/default_shelves":12,"../../react_actions/modal_actions":37,"../../react_actions/shelvings_actions":43,"../../react_actions/want_to_read_menu_actions":51,"../../react_mixins/gr_reflux":227,"../../react_stores/modal_store":242,"../../react_stores/shelvings_store":247,"../../react_stores/user_agent_capabilities_store":251,"../../react_stores/user_shelves_store":254,"../../react_stores/want_to_read_menu_store":255,"../dropdown":90,"../gr_component_factory":102,"../modal":136,"../modal_trigger":137,"../user_rating":200,"../want_to_read/want_to_read_menu":210,"classnames":"classnames","react":"react","reflux":"reflux"}],210:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            WantToReadMenu component is used only within the WantToReadButton component
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            right now. It generates a list of shelves, along with a filter box and 'add
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            new shelf' button.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_reflux = require("../../react_mixins/gr_reflux");

var _default_shelves = require("../../modules/default_shelves");

var _want_to_read_menu_store = require("../../react_stores/want_to_read_menu_store");

var _want_to_read_menu_store2 = _interopRequireDefault(_want_to_read_menu_store);

var _want_to_read_menu_filter = require("./want_to_read_menu_filter");

var _want_to_read_menu_filter2 = _interopRequireDefault(_want_to_read_menu_filter);

var _shelvings_actions = require("../../react_actions/shelvings_actions");

var _shelvings_actions2 = _interopRequireDefault(_shelvings_actions);

var _want_to_read_menu_shelf_creator = require("./want_to_read_menu_shelf_creator");

var _want_to_read_menu_shelf_creator2 = _interopRequireDefault(_want_to_read_menu_shelf_creator);

var _spinner = require("../spinner");

var _spinner2 = _interopRequireDefault(_spinner);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MIN_SHELVES_TO_SHOW_FILTER = 7;

exports.default = _gr_component_factory2.default.createClass({
  displayName: "WantToReadMenu",

  mixins: [(0, _gr_reflux.connectToLazyStore)(_want_to_read_menu_store2.default, "uniqueId")],

  propTypes: {
    bookId: React.PropTypes.string.isRequired,
    bookTitle: React.PropTypes.string.isRequired,
    uniqueId: React.PropTypes.string.isRequired,
    userShelves: React.PropTypes.object.isRequired,
    shelvings: React.PropTypes.object.isRequired,
    useModalView: React.PropTypes.bool,
    onNonExclusiveShelvingWithoutExclusive: React.PropTypes.func,
    onExclusiveShelvingChange: React.PropTypes.func
  },

  defaultPropTypes: function defaultPropTypes() {
    return { useModalView: false };
  },
  shelveBook: function shelveBook(shelf) {
    _shelvings_actions2.default.shelveBook(this.props.bookId, shelf);
  },
  unshelveBook: function unshelveBook() {
    if (window.confirm("Removing a book deletes your rating, review, etc. Remove this book from all your shelves?")) {
      _shelvings_actions2.default.unshelveBook(this.props.bookId);
    }
  },
  modifyExclusiveShelving: function modifyExclusiveShelving(shelved, shelf) {
    if (this.props.onExclusiveShelvingChange && _lodash2.default.isFunction(this.props.onExclusiveShelvingChange)) {
      this.props.onExclusiveShelvingChange();
    }
    shelved ? this.unshelveBook() : this.shelveBook(shelf);
  },
  toggleNonExclusiveShelving: function toggleNonExclusiveShelving(shelf) {
    if (this.props.shelvings.exclusiveShelfName === null && this.props.onNonExclusiveShelvingWithoutExclusive && _lodash2.default.isFunction(this.props.onNonExclusiveShelvingWithoutExclusive)) {
      this.props.onNonExclusiveShelvingWithoutExclusive();
    }
    _shelvings_actions2.default.toggleNonExclusiveShelving(this.props.bookId, shelf, false, this.props.bookTitle);
  },
  renderFilter: function renderFilter() {
    var allShelves = this.props.userShelves.customExclusiveShelves.concat(this.props.userShelves.nonExclusiveShelves);
    var showFilterMenu = allShelves.length >= MIN_SHELVES_TO_SHOW_FILTER;
    if (showFilterMenu) {
      return _jsx(_want_to_read_menu_filter2.default, {
        bookId: this.props.bookId,
        uniqueId: this.props.uniqueId,
        shelvings: this.props.shelvings,
        wantToReadMenu: this.state,
        bemModifiers: this.props.bemModifiers
      });
    }
  },
  renderEmptyMessage: function renderEmptyMessage() {
    var displayableExclusiveShelves = this.state.displayableExclusiveShelves;
    var displayableNonExclusiveShelves = this.state.displayableNonExclusiveShelves;
    var displayedShelvesCount = displayableNonExclusiveShelves.concat(displayableExclusiveShelves).length;
    if (displayedShelvesCount === 0) {
      return _jsx("li", {
        className: "wantToReadMenu__genericItem"
      }, void 0, "No Matching Shelves");
    }
  },
  renderExclusiveShelves: function renderExclusiveShelves() {
    var _this = this;

    var displayableExclusiveShelves = this.state.displayableExclusiveShelves;
    return _lodash2.default.map(displayableExclusiveShelves, function (shelf) {
      var shelved = shelf.name === _this.props.shelvings.exclusiveShelfName;
      var humanShelfName = shelf.displayName;
      var shelvingLabel = shelved ? "Unshelve  " + _this.props.bookTitle : "Shelve " + _this.props.bookTitle + " as " + humanShelfName;
      var exclusiveShelfClassnames = (0, _classnames2.default)(_this.withBemModifiers("wantToReadMenu__exclusiveShelf"), { "wantToReadMenu__exclusiveShelf--shelved": shelved });
      var shelvingStatusIcon = _this.props.useModalView ? _this.renderExclusiveShelfStatusIcon(shelf) : null;
      return _jsx("li", {
        className: "wantToReadMenu__shelfItem"
      }, humanShelfName, _jsx("button", {
        className: exclusiveShelfClassnames,
        "aria-label": shelvingLabel,
        onClick: function onClick() {
          _this.modifyExclusiveShelving(shelved, shelf);
        }
      }, void 0, shelvingStatusIcon && _jsx("div", {
        className: "wantToReadMenu__shelfStatusContainer"
      }, void 0, shelvingStatusIcon), humanShelfName));
    });
  },
  renderExclusiveShelfStatusIcon: function renderExclusiveShelfStatusIcon(shelf) {
    // (1) if book is shelved and shelving not in progress, render check icon
    // if shelving in progress:
    // (2) if being unshelved (no target), render spinner on shelved exclusive shelf
    // (3) if being shelved (target == shelf.name), render spinner on target shelf
    var shelvingStatusIcon = null;
    var shelved = shelf.name === this.props.shelvings.exclusiveShelfName;
    if (shelved && !this.props.shelvings.isShelvingInProgress) {
      // (1)
      var checkIconCx = (0, _classnames2.default)("wantToReadButton__checkIcon", "wantToReadButton__checkIcon--modalView", (0, _default_shelves.checkIconClassnames)(this.props.shelvings.exclusiveShelfName));
      shelvingStatusIcon = _jsx("span", {
        className: checkIconCx
      });
    } else if (this.props.shelvings.isShelvingInProgress && (!this.props.shelvings.targetExclusiveShelfName && shelved || // (2)
    this.props.shelvings.targetExclusiveShelfName === shelf.name)) {
      // (3)
      shelvingStatusIcon = _jsx(_spinner2.default, {
        isSmall: true
      });
    }

    return shelvingStatusIcon;
  },
  renderNonExclusiveShelves: function renderNonExclusiveShelves() {
    var _this2 = this;

    var displayableNonExclusiveShelves = this.state.displayableNonExclusiveShelves;
    return _lodash2.default.map(displayableNonExclusiveShelves, function (shelf) {
      var shelfChecked = false;
      if (_this2.props.shelvings.exclusiveShelfName !== null && _lodash2.default.includes(_this2.props.shelvings.nonExclusiveShelfNames, shelf.name)) {
        shelfChecked = true;
      }
      var humanShelfName = shelf.displayName;
      var shelvingLabel = "Shelve " + _this2.props.bookTitle + " as " + humanShelfName;
      var nonExclusiveShelfClassnames = _this2.withBemModifiers("wantToReadMenu__nonExclusiveShelf");
      return _jsx("li", {
        className: "wantToReadMenu__shelfItem"
      }, humanShelfName, _jsx("label", {
        className: nonExclusiveShelfClassnames
      }, void 0, _jsx("input", {
        className: "wantToReadMenu__shelfCheckbox",
        checked: shelfChecked,
        type: "checkbox",
        name: "shelf[" + shelf.name + "]",
        "aria-label": shelvingLabel,
        onChange: function onChange() {
          _this2.toggleNonExclusiveShelving(shelf);
        }
      }), humanShelfName));
    });
  },
  renderAddNewShelfButton: function renderAddNewShelfButton() {
    var allShelves = this.props.userShelves.customExclusiveShelves.concat(this.props.userShelves.nonExclusiveShelves).concat(this.props.userShelves.defaultShelves);
    var shelfNames = _lodash2.default.map(allShelves, function (shelf) {
      return shelf.name;
    });
    var userCanAddShelf = !_lodash2.default.includes(shelfNames, this.state.shelfNameFilter);
    var newShelfClassnames = this.withBemModifiers("wantToReadMenu__newShelfButtonContainer");
    return _jsx("li", {
      className: newShelfClassnames
    }, void 0, React.createElement(_want_to_read_menu_shelf_creator2.default, _extends({
      shelfNameFilter: this.state.shelfNameFilter,
      userCanAddShelf: userCanAddShelf,
      uniqueId: this.props.uniqueId,
      bookId: this.props.bookId,
      bemModifiers: this.props.bemModifiers,
      useModalView: this.props.useModalView,
      bookTitle: this.props.bookTitle
    }, this.state)));
  },
  render: function render() {
    return _jsx("div", {
      className: "wantToReadMenu"
    }, void 0, this.props.useModalView && _jsx("div", {
      className: "wantToReadMenu__headerContainer"
    }, void 0, this.renderFilter()), _jsx("div", {
      className: "wantToReadMenu__scrollableContainer"
    }, void 0, !this.props.useModalView && this.renderFilter(), this.renderEmptyMessage(), this.renderExclusiveShelves(), this.renderNonExclusiveShelves()), this.renderAddNewShelfButton());
  }
});

},{"../../modules/default_shelves":12,"../../react_actions/shelvings_actions":43,"../../react_mixins/gr_reflux":227,"../../react_stores/want_to_read_menu_store":255,"../gr_component_factory":102,"../spinner":186,"./want_to_read_menu_filter":211,"./want_to_read_menu_shelf_creator":212,"classnames":"classnames","lodash":"lodash"}],211:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            WantToReadMenuFilter is used to filter shelf names within the Want to Read
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            button
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _want_to_read_menu_actions = require("../../react_actions/want_to_read_menu_actions");

var _want_to_read_menu_actions2 = _interopRequireDefault(_want_to_read_menu_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "WantToReadMenuFilter",
  propTypes: {
    bookId: _react2.default.PropTypes.string.isRequired,
    uniqueId: _react2.default.PropTypes.string.isRequired,
    shelvings: _react2.default.PropTypes.object.isRequired,
    wantToReadMenu: _react2.default.PropTypes.object.isRequired
  },

  handleKeyPress: function handleKeyPress(event) {
    var exclusiveShelfName = null;
    if (this.props.shelvings.exclusiveShelfName !== null) {
      exclusiveShelfName = this.props.shelvings.exclusiveShelfName;
    }
    _want_to_read_menu_actions2.default.updateShelfNameFilter(event.target.value, this.props.uniqueId, exclusiveShelfName);
  },
  render: function render() {
    var classNames = this.withBemModifiers("wantToReadMenuFilter");
    return _jsx("form", {
      className: classNames,
      onSubmit: function onSubmit(ev) {
        return ev.preventDefault();
      }
    }, void 0, _jsx("input", {
      className: "gr-textInput\n                               gr-textInput--small\n                               wantToReadMenuFilter--textInput",
      type: "text",
      placeholder: "Filter Shelves",
      "aria-label": "Filter Shelf Names",
      value: this.props.wantToReadMenu.shelfNameFilter,
      onChange: this.handleKeyPress
    }));
  }
});

},{"../../react_actions/want_to_read_menu_actions":51,"../gr_component_factory":102,"react":"react"}],212:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            WantToReadMenuShelfCreator is a component that lets you add a new shelf to your
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            UserShelves for the current user.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _want_to_read_menu_actions = require("../../react_actions/want_to_read_menu_actions");

var _want_to_read_menu_actions2 = _interopRequireDefault(_want_to_read_menu_actions);

var _shelvings_actions = require("../../react_actions/shelvings_actions");

var _shelvings_actions2 = _interopRequireDefault(_shelvings_actions);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "WantToReadMenuShelfCreator",

  propTypes: {
    userCanAddShelf: _react2.default.PropTypes.bool.isRequired,
    shelfNameFilter: _react2.default.PropTypes.string,
    uniqueId: _react2.default.PropTypes.string.isRequired,
    bookId: _react2.default.PropTypes.string.isRequired,
    bookTitle: _react2.default.PropTypes.string.isRequired,
    useModalView: _react2.default.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return { useModalView: false };
  },
  getInitialState: function getInitialState() {
    return {
      unsavedShelfName: ""
    };
  },
  openAddShelfTextbox: function openAddShelfTextbox() {
    _want_to_read_menu_actions2.default.openAddShelfTextbox(this.props.uniqueId);
  },
  closeAddShelfTextbox: function closeAddShelfTextbox() {
    _want_to_read_menu_actions2.default.closeAddShelfTextbox(this.props.uniqueId);
  },
  checkIfCommentIsEmpty: function checkIfCommentIsEmpty(event) {
    this.setState({ unsavedShelfName: event.target.value });
  },
  shelveAsNewShelfName: function shelveAsNewShelfName(shelfName, event) {
    event.preventDefault();
    _want_to_read_menu_actions2.default.updateShelfNameFilter("", this.props.uniqueId);
    _shelvings_actions2.default.toggleNonExclusiveShelving(this.props.bookId, { name: shelfName }, true, this.props.bookTitle);
  },
  render: function render() {
    var _this = this;

    if (this.props.shelfNameFilter !== "" && this.props.userCanAddShelf) {
      var buttonClassnames = this.withBemModifiers("wantToReadShelfCreator__addNamedShelfButton");
      return _jsx("span", {
        className: "wantToReadShelfCreator"
      }, void 0, _jsx("button", {
        className: buttonClassnames,
        "aria-label": "Add new " + this.props.shelfNameFilter + " shelf",
        onClick: function onClick(event) {
          _this.shelveAsNewShelfName(_this.props.shelfNameFilter, event);
        }
      }, void 0, "Add new “", _jsx("span", {
        className: "wantToReadShelfCreator__addShelfButtonShelfName"
      }, void 0, this.props.shelfNameFilter), "” shelf"));
    } else if (this.props.showAddShelfTextbox) {
      var containerCx = (0, _classnames2.default)(this.withBemModifiers("wantToReadShelfCreator"), "wantToReadShelfCreator--wrap");

      var textInputCx = (0, _classnames2.default)("gr-textInput", this.withBemModifiers("wantToReadShelfCreator__textInput"), {
        "gr-textInput--small": !this.props.useModalView
      });

      var submitCx = (0, _classnames2.default)(this.withBemModifiers("wantToReadShelfCreator__addShelfButton"), "gr-button", { "gr-button--small": !this.props.useModalView,
        "gr-button--dark gr-button--fullWidth": this.props.useModalView });

      return _jsx("form", {
        className: containerCx,
        onSubmit: function onSubmit(event) {
          _this.shelveAsNewShelfName(_this.state.unsavedShelfName, event);
        }
      }, void 0, _jsx("input", {
        className: textInputCx,
        type: "text",
        placeholder: "New Shelf Name",
        "aria-label": "Add new shelf name",
        autoFocus: true,
        onChange: this.checkIfCommentIsEmpty
      }), _jsx("div", {
        className: "wantToReadShelfCreator__buttonContainer"
      }, void 0, _jsx("input", {
        type: "submit",
        className: submitCx,
        disabled: _lodash2.default.isEmpty(_lodash2.default.trim(this.state.unsavedShelfName)),
        value: "Add"
      }), this.props.useModalView && _jsx("button", {
        type: "button",
        className: "gr-button gr-button--fullWidth wantToReadShelfCreator__cancelButton",
        onClick: this.closeAddShelfTextbox,
        "aria-label": "Close add new shelf form"
      }, void 0, "Cancel")));
    } else if (!this.props.userCanAddShelf) {
      // User cannot create a new shelf if they have typed in the name
      return null;
    } else {
      var buttonClassnames = this.withBemModifiers("wantToReadShelfCreator__showAddShelfTextboxButton");
      return _jsx("span", {
        className: "wantToReadShelfCreator"
      }, void 0, _jsx("button", {
        className: buttonClassnames,
        "aria-label": "Add new shelf",
        onClick: this.openAddShelfTextbox
      }, void 0, "Add New Shelf"));
    }
  }
});

},{"../../react_actions/shelvings_actions":43,"../../react_actions/want_to_read_menu_actions":51,"../gr_component_factory":102,"classnames":"classnames","lodash":"lodash","react":"react"}],213:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            WantToReadWithStars is a wrapper component around the WantToReadButton
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            component and the UserRating component.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _want_to_read_button = require("./want_to_read_button");

var _want_to_read_button2 = _interopRequireDefault(_want_to_read_button);

var _user_rating = require("../user_rating");

var _user_rating2 = _interopRequireDefault(_user_rating);

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "WantToReadWithStars",

  propTypes: {
    bookId: _react2.default.PropTypes.string.isRequired,
    uniqueId: _react2.default.PropTypes.string.isRequired,
    bookTitle: _react2.default.PropTypes.string.isRequired
  },

  render: function render() {
    return _jsx("div", {}, void 0, _jsx(_want_to_read_button2.default, {
      bookId: this.props.bookId,
      uniqueId: (0, _lodash.random)(1000000).toString(),
      bookTitle: this.props.bookTitle
    }), _jsx(_user_rating2.default, {
      bookId: this.props.bookId,
      bookTitle: this.props.bookTitle
    }));
  }
});

},{"../gr_component_factory":102,"../user_rating":200,"./want_to_read_button":209,"lodash":"lodash","react":"react"}],214:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConversationsStores = exports.ConversationsComponents = undefined;

var _like_store = require("../../react_stores/like_store");

var _like_store2 = _interopRequireDefault(_like_store);

var _comments_store = require("../../react_stores/comments_store");

var _comments_store2 = _interopRequireDefault(_comments_store);

var _comment_form = require("../../react_components/comment/comment_form");

var _comment_form2 = _interopRequireDefault(_comment_form);

var _comments = require("../../react_components/comment/comments");

var _comments2 = _interopRequireDefault(_comments);

var _like_button = require("../../react_components/like/like_button");

var _like_button2 = _interopRequireDefault(_like_button);

var _like_information = require("../../react_components/like/like_information");

var _like_information2 = _interopRequireDefault(_like_information);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConversationsComponents = exports.ConversationsComponents = {
  CommentForm: _comment_form2.default,
  Comments: _comments2.default,
  LikeButton: _like_button2.default,
  LikeInformation: _like_information2.default
};

var ConversationsStores = exports.ConversationsStores = {
  CommentsStore: _comments_store2.default,
  LikeStore: _like_store2.default
};

},{"../../react_components/comment/comment_form":84,"../../react_components/comment/comments":85,"../../react_components/like/like_button":126,"../../react_components/like/like_information":128,"../../react_stores/comments_store":235,"../../react_stores/like_store":241}],215:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
                                          value: true
});
exports.ExperimentStores = exports.ExperimentComponents = undefined;

var _conversations = require("./conversations");

var _old_homepage = require("./old_homepage");

var _review_show = require("./review_show");

var _lodash = require("lodash");

/*
These components and stores are only needed depending on the settings of certain
Deploy Services (often more than one in combination). Rather than create lots
of different bundles for each combination, for now we're just including all of
these in one file for simplicity for inclusion elsewhere but still showing
what feature area each supports to make it easier to (re)move them later.
*/
var ExperimentComponents = exports.ExperimentComponents = (0, _lodash.merge)({}, _conversations.ConversationsComponents, _old_homepage.OldHomepageComponents, _review_show.ReviewShowComponents);

var ExperimentStores = exports.ExperimentStores = (0, _lodash.merge)({}, _conversations.ConversationsStores, _old_homepage.OldHomepageStores, _review_show.ReviewShowStores);

},{"./conversations":214,"./old_homepage":216,"./review_show":217,"lodash":"lodash"}],216:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OldHomepageStores = exports.OldHomepageComponents = undefined;

var _like_store = require("../../react_stores/like_store");

var _like_store2 = _interopRequireDefault(_like_store);

var _comments_store = require("../../react_stores/comments_store");

var _comments_store2 = _interopRequireDefault(_comments_store);

var _comment_form = require("../../react_components/comment/comment_form");

var _comment_form2 = _interopRequireDefault(_comment_form);

var _comments = require("../../react_components/comment/comments");

var _comments2 = _interopRequireDefault(_comments);

var _like_button = require("../../react_components/like/like_button");

var _like_button2 = _interopRequireDefault(_like_button);

var _like_information = require("../../react_components/like/like_information");

var _like_information2 = _interopRequireDefault(_like_information);

var _like_simple_footer = require("../../react_components/like/like_simple_footer");

var _like_simple_footer2 = _interopRequireDefault(_like_simple_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OldHomepageComponents = exports.OldHomepageComponents = {
  CommentForm: _comment_form2.default,
  Comments: _comments2.default,
  LikeButton: _like_button2.default,
  LikeInformation: _like_information2.default,
  LikeSimpleFooter: _like_simple_footer2.default
};

var OldHomepageStores = exports.OldHomepageStores = {
  CommentsStore: _comments_store2.default,
  LikeStore: _like_store2.default
};

},{"../../react_components/comment/comment_form":84,"../../react_components/comment/comments":85,"../../react_components/like/like_button":126,"../../react_components/like/like_information":128,"../../react_components/like/like_simple_footer":129,"../../react_stores/comments_store":235,"../../react_stores/like_store":241}],217:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReviewShowStores = exports.ReviewShowComponents = undefined;

var _like_store = require("../../react_stores/like_store");

var _like_store2 = _interopRequireDefault(_like_store);

var _like_simple_footer = require("../../react_components/like/like_simple_footer");

var _like_simple_footer2 = _interopRequireDefault(_like_simple_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReviewShowComponents = exports.ReviewShowComponents = {
  LikeSimpleFooter: _like_simple_footer2.default
};

var ReviewShowStores = exports.ReviewShowStores = {
  LikeStore: _like_store2.default
};

},{"../../react_components/like/like_simple_footer":129,"../../react_stores/like_store":241}],218:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FriendFollowModuleStores = exports.FriendFollowModuleComponents = undefined;

var _friend_follow_module = require("../react_components/user_relationships/friend_follow_module");

var _friend_follow_module2 = _interopRequireDefault(_friend_follow_module);

var _friend_follow_module_store = require("../react_stores/user_relationships/friend_follow_module_store");

var _friend_follow_module_store2 = _interopRequireDefault(_friend_follow_module_store);

var _block_user_store = require("../react_stores/user/show/block_user_store");

var _block_user_store2 = _interopRequireDefault(_block_user_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FriendFollowModuleComponents = exports.FriendFollowModuleComponents = {
  FriendFollowModule: _friend_follow_module2.default
};

var FriendFollowModuleStores = exports.FriendFollowModuleStores = {
  FriendFollowModuleStore: _friend_follow_module_store2.default,
  BlockUserStore: _block_user_store2.default
};

},{"../react_components/user_relationships/friend_follow_module":208,"../react_stores/user/show/block_user_store":249,"../react_stores/user_relationships/friend_follow_module_store":253}],219:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlobalComponents = exports.GlobalStores = undefined;

var _google_ads_store = require("../react_stores/google_ads_store");

var _google_ads_store2 = _interopRequireDefault(_google_ads_store);

var _login_interstitial = require("../react_components/login/interstitial/login_interstitial");

var _login_interstitial2 = _interopRequireDefault(_login_interstitial);

var _stores_initializer = require("../react_components/stores_initializer");

var _stores_initializer2 = _interopRequireDefault(_stores_initializer);

var _get_a_copy_button = require("../react_components/buy_buttons/get_a_copy_button");

var _get_a_copy_button2 = _interopRequireDefault(_get_a_copy_button);

var _get_a_copy_interstitial = require("../react_components/buy_buttons/get_a_copy_interstitial");

var _get_a_copy_interstitial2 = _interopRequireDefault(_get_a_copy_interstitial);

var _get_a_copy_interstitial_wrapper = require("../react_components/buy_buttons/get_a_copy_interstitial_wrapper");

var _get_a_copy_interstitial_wrapper2 = _interopRequireDefault(_get_a_copy_interstitial_wrapper);

var _qualtrics_survey = require("../react_components/qualtrics/qualtrics_survey");

var _qualtrics_survey2 = _interopRequireDefault(_qualtrics_survey);

var _review_cta = require("../react_components/book/review_cta");

var _review_cta2 = _interopRequireDefault(_review_cta);

var _user_icon = require("../react_components/user/user_icon");

var _user_icon2 = _interopRequireDefault(_user_icon);

var _user_not_interested_store = require("../react_stores/user_not_interested_store");

var _user_not_interested_store2 = _interopRequireDefault(_user_not_interested_store);

var _user_shelves_store = require("../react_stores/user_shelves_store");

var _user_shelves_store2 = _interopRequireDefault(_user_shelves_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GlobalStores = exports.GlobalStores = {
  GoogleAdsStore: _google_ads_store2.default,
  UserNotInterestedStore: _user_not_interested_store2.default,
  UserShelvesStore: _user_shelves_store2.default
}; // This holds the stores and components that should be accessible site-wide.
// This file should be included in all React bundles.

var GlobalComponents = exports.GlobalComponents = {
  LoginInterstitial: _login_interstitial2.default,
  StoresInitializer: _stores_initializer2.default,
  GetACopyButton: _get_a_copy_button2.default,
  GetACopyInterstitial: _get_a_copy_interstitial2.default,
  GetACopyInterstitialWrapper: _get_a_copy_interstitial_wrapper2.default,
  QualtricsSurvey: _qualtrics_survey2.default,
  ReviewCta: _review_cta2.default,
  UserIcon: _user_icon2.default
};

},{"../react_components/book/review_cta":73,"../react_components/buy_buttons/get_a_copy_button":76,"../react_components/buy_buttons/get_a_copy_interstitial":77,"../react_components/buy_buttons/get_a_copy_interstitial_wrapper":78,"../react_components/login/interstitial/login_interstitial":132,"../react_components/qualtrics/qualtrics_survey":149,"../react_components/stores_initializer":188,"../react_components/user/user_icon":193,"../react_stores/google_ads_store":240,"../react_stores/user_not_interested_store":252,"../react_stores/user_shelves_store":254}],220:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewsComponents = undefined;

var _news_preview = require("../react_components/news/news_preview");

var _news_preview2 = _interopRequireDefault(_news_preview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewsComponents = exports.NewsComponents = {
  NewsPreview: _news_preview2.default
};

},{"../react_components/news/news_preview":140}],221:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReadingNotesStores = exports.ReadingNotesComponents = undefined;

var _annotated_books_landing_page = require("../react_components/reading_notes/annotated_books_landing_page");

var _annotated_books_landing_page2 = _interopRequireDefault(_annotated_books_landing_page);

var _author_follow_button = require("../react_components/author/author_follow_button");

var _author_follow_button2 = _interopRequireDefault(_author_follow_button);

var _comment_form = require("../react_components/comment/comment_form");

var _comment_form2 = _interopRequireDefault(_comment_form);

var _comments = require("../react_components/comment/comments");

var _comments2 = _interopRequireDefault(_comments);

var _like_button = require("../react_components/like/like_button");

var _like_button2 = _interopRequireDefault(_like_button);

var _like_information = require("../react_components/like/like_information");

var _like_information2 = _interopRequireDefault(_like_information);

var _reading_notes_annotator = require("../react_components/reading_notes/reading_notes_annotator");

var _reading_notes_annotator2 = _interopRequireDefault(_reading_notes_annotator);

var _reading_notes_header = require("../react_components/reading_notes/reading_notes_header");

var _reading_notes_header2 = _interopRequireDefault(_reading_notes_header);

var _reading_notes_shelving_modal = require("../react_components/reading_notes/reading_notes_shelving_modal");

var _reading_notes_shelving_modal2 = _interopRequireDefault(_reading_notes_shelving_modal);

var _reading_notes_shelving_modal_trigger = require("../react_components/reading_notes/reading_notes_shelving_modal_trigger");

var _reading_notes_shelving_modal_trigger2 = _interopRequireDefault(_reading_notes_shelving_modal_trigger);

var _user_follow_widget = require("../react_components/user/user_follow_widget");

var _user_follow_widget2 = _interopRequireDefault(_user_follow_widget);

var _user_icon = require("../react_components/user/user_icon");

var _user_icon2 = _interopRequireDefault(_user_icon);

var _want_to_read_button = require("../react_components/want_to_read/want_to_read_button");

var _want_to_read_button2 = _interopRequireDefault(_want_to_read_button);

var _want_to_read_with_stars = require("../react_components/want_to_read/want_to_read_with_stars");

var _want_to_read_with_stars2 = _interopRequireDefault(_want_to_read_with_stars);

var _annotated_books_store = require("../react_stores/reading_notes/annotated_books_store");

var _annotated_books_store2 = _interopRequireDefault(_annotated_books_store);

var _author_follow_store = require("../react_stores/author_follow_store");

var _author_follow_store2 = _interopRequireDefault(_author_follow_store);

var _comments_store = require("../react_stores/comments_store");

var _comments_store2 = _interopRequireDefault(_comments_store);

var _like_store = require("../react_stores/like_store");

var _like_store2 = _interopRequireDefault(_like_store);

var _shelvings_store = require("../react_stores/shelvings_store");

var _shelvings_store2 = _interopRequireDefault(_shelvings_store);

var _user_follow_store = require("../react_stores/user/user_follow_store");

var _user_follow_store2 = _interopRequireDefault(_user_follow_store);

var _user_shelves_store = require("../react_stores/user_shelves_store");

var _user_shelves_store2 = _interopRequireDefault(_user_shelves_store);

var _user_agent_capabilities_store = require("../react_stores/user_agent_capabilities_store");

var _user_agent_capabilities_store2 = _interopRequireDefault(_user_agent_capabilities_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReadingNotesComponents = exports.ReadingNotesComponents = {
  AnnotatedBooksLandingPage: _annotated_books_landing_page2.default,
  AuthorFollowButton: _author_follow_button2.default,
  CommentForm: _comment_form2.default,
  Comments: _comments2.default,
  LikeButton: _like_button2.default,
  LikeInformation: _like_information2.default,
  ReadingNotesAnnotator: _reading_notes_annotator2.default,
  ReadingNotesHeader: _reading_notes_header2.default,
  ReadingNotesShelvingModal: _reading_notes_shelving_modal2.default,
  ReadingNotesShelvingModalTrigger: _reading_notes_shelving_modal_trigger2.default,
  UserFollowWidget: _user_follow_widget2.default,
  UserIcon: _user_icon2.default,
  WantToReadButton: _want_to_read_button2.default,
  WantToReadWithStars: _want_to_read_with_stars2.default
};

var ReadingNotesStores = exports.ReadingNotesStores = {
  AnnotatedBooksStore: _annotated_books_store2.default,
  AuthorFollowStore: _author_follow_store2.default,
  CommentsStore: _comments_store2.default,
  LikeStore: _like_store2.default,
  ShelvingsStore: _shelvings_store2.default,
  UserFollowStore: _user_follow_store2.default,
  UserShelvesStore: _user_shelves_store2.default,
  UserAgentCapabilitiesStore: _user_agent_capabilities_store2.default
};

},{"../react_components/author/author_follow_button":71,"../react_components/comment/comment_form":84,"../react_components/comment/comments":85,"../react_components/like/like_button":126,"../react_components/like/like_information":128,"../react_components/reading_notes/annotated_books_landing_page":152,"../react_components/reading_notes/reading_notes_annotator":155,"../react_components/reading_notes/reading_notes_header":156,"../react_components/reading_notes/reading_notes_shelving_modal":157,"../react_components/reading_notes/reading_notes_shelving_modal_trigger":158,"../react_components/user/user_follow_widget":192,"../react_components/user/user_icon":193,"../react_components/want_to_read/want_to_read_button":209,"../react_components/want_to_read/want_to_read_with_stars":213,"../react_stores/author_follow_store":232,"../react_stores/comments_store":235,"../react_stores/like_store":241,"../react_stores/reading_notes/annotated_books_store":244,"../react_stores/shelvings_store":247,"../react_stores/user/user_follow_store":250,"../react_stores/user_agent_capabilities_store":251,"../react_stores/user_shelves_store":254}],222:[function(require,module,exports){
"use strict";

var _arrayPrototype = require("array.prototype.find");

var _arrayPrototype2 = _interopRequireDefault(_arrayPrototype);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_arrayPrototype2.default.shim();

},{"array.prototype.find":"array.prototype.find"}],223:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderComponents = exports.HeaderStores = undefined;

var _current_user_store = require("../react_stores/current_user_store");

var _current_user_store2 = _interopRequireDefault(_current_user_store);

var _favorite_genres_store = require("../react_stores/favorite_genres_store");

var _favorite_genres_store2 = _interopRequireDefault(_favorite_genres_store);

var _notifications_store = require("../react_stores/notifications_store");

var _notifications_store2 = _interopRequireDefault(_notifications_store);

var _shelvings_store = require("../react_stores/shelvings_store");

var _shelvings_store2 = _interopRequireDefault(_shelvings_store);

var _tabs_store = require("../react_stores/tabs_store");

var _tabs_store2 = _interopRequireDefault(_tabs_store);

var _flash_message = require("../react_components/flash_message");

var _flash_message2 = _interopRequireDefault(_flash_message);

var _featured_content_module = require("../react_components/featured_content_module");

var _featured_content_module2 = _interopRequireDefault(_featured_content_module);

var _page_skin = require("../react_components/page_skin");

var _page_skin2 = _interopRequireDefault(_page_skin);

var _google_banner_ad = require("../react_components/ads/google_banner_ad");

var _google_banner_ad2 = _interopRequireDefault(_google_banner_ad);

var _native_ad = require("../react_components/ads/native_ads/native_ad");

var _native_ad2 = _interopRequireDefault(_native_ad);

var _google_page_skin = require("../react_components/ads/google_page_skin");

var _google_page_skin2 = _interopRequireDefault(_google_page_skin);

var _google_featured_content_module = require("../react_components/ads/google_featured_content_module");

var _google_featured_content_module2 = _interopRequireDefault(_google_featured_content_module);

var _scroll_tracker = require("../react_components/scroll_tracker");

var _scroll_tracker2 = _interopRequireDefault(_scroll_tracker);

var _header_store_connector = require("../react_components/header/header_store_connector");

var _header_store_connector2 = _interopRequireDefault(_header_store_connector);

var _site_announcement = require("../react_components/site_announcement/site_announcement");

var _site_announcement2 = _interopRequireDefault(_site_announcement);

var _choice_site_announcement = require("../react_components/site_announcement/choice_site_announcement");

var _choice_site_announcement2 = _interopRequireDefault(_choice_site_announcement);

var _welcome_announcement = require("../react_components/site_announcement/welcome_announcement");

var _welcome_announcement2 = _interopRequireDefault(_welcome_announcement);

var _preview_broadcast = require("../react_components/group/preview_broadcast");

var _preview_broadcast2 = _interopRequireDefault(_preview_broadcast);

var _jobs_list = require("../react_components/jobs_list");

var _jobs_list2 = _interopRequireDefault(_jobs_list);

var _shareable_link_button = require("../react_components/shared/shareable_link_button");

var _shareable_link_button2 = _interopRequireDefault(_shareable_link_button);

var _quiz = require("../react_components/librarian_quiz/quiz");

var _quiz2 = _interopRequireDefault(_quiz);

var _editorial_blog_thumbnail = require("../react_components/home_page/editorial_blog_thumbnail");

var _editorial_blog_thumbnail2 = _interopRequireDefault(_editorial_blog_thumbnail);

var _share_dialog = require("../react_components/share_dialog");

var _share_dialog2 = _interopRequireDefault(_share_dialog);

var _share_social = require("../react_components/share_social");

var _share_social2 = _interopRequireDefault(_share_social);

var _share_dialog_store = require("../react_stores/share_dialog_store");

var _share_dialog_store2 = _interopRequireDefault(_share_dialog_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderStores = exports.HeaderStores = {
  CurrentUserStore: _current_user_store2.default,
  FavoriteGenresStore: _favorite_genres_store2.default,
  NotificationsStore: _notifications_store2.default,
  ShareDialogStore: _share_dialog_store2.default,
  ShelvingsStore: _shelvings_store2.default,
  TabsStore: _tabs_store2.default
};

// Temp placement of share dialog component and store

var HeaderComponents = exports.HeaderComponents = {
  FlashMessage: _flash_message2.default,
  HeaderStoreConnector: _header_store_connector2.default,
  PageSkin: _page_skin2.default,
  FeaturedContentModule: _featured_content_module2.default,
  GoogleBannerAd: _google_banner_ad2.default,
  GooglePageSkin: _google_page_skin2.default,
  GoogleFeaturedContentModule: _google_featured_content_module2.default,
  ScrollTracker: _scroll_tracker2.default,
  SiteAnnouncement: _site_announcement2.default,
  ChoiceSiteAnnouncement: _choice_site_announcement2.default,
  WelcomeAnnouncement: _welcome_announcement2.default,
  ShareDialog: _share_dialog2.default,
  ShareSocial: _share_social2.default,
  PreviewBroadcast: _preview_broadcast2.default,
  NativeAd: _native_ad2.default,
  JobsList: _jobs_list2.default,
  ShareableLinkButton: _shareable_link_button2.default,
  LibrarianQuiz: _quiz2.default,
  EditorialBlogThumbnail: _editorial_blog_thumbnail2.default
};

},{"../react_components/ads/google_banner_ad":57,"../react_components/ads/google_featured_content_module":58,"../react_components/ads/google_page_skin":59,"../react_components/ads/native_ads/native_ad":61,"../react_components/featured_content_module":98,"../react_components/flash_message":100,"../react_components/group/preview_broadcast":103,"../react_components/header/header_store_connector":112,"../react_components/home_page/editorial_blog_thumbnail":123,"../react_components/jobs_list":124,"../react_components/librarian_quiz/quiz":125,"../react_components/page_skin":141,"../react_components/scroll_tracker":160,"../react_components/share_dialog":168,"../react_components/share_social":169,"../react_components/shared/shareable_link_button":173,"../react_components/site_announcement/choice_site_announcement":182,"../react_components/site_announcement/site_announcement":184,"../react_components/site_announcement/welcome_announcement":185,"../react_stores/current_user_store":236,"../react_stores/favorite_genres_store":238,"../react_stores/notifications_store":243,"../react_stores/share_dialog_store":245,"../react_stores/shelvings_store":247,"../react_stores/tabs_store":248}],224:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  propTypes: {
    bemModifiers: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.string)])
  },
  // Expects `cls` to be a string holding a CSS class name. Returns string
  // holding that class, plus that class with the BEM modifier suffix(es)
  // (supplied as `bemModifiers` prop) appended.
  withBemModifiers: function withBemModifiers(cls) {
    var modifiers = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];

    if (modifiers === null) {
      modifiers = this.props.bemModifiers;
    }
    if (modifiers) {
      if (_lodash2.default.isString(modifiers)) {
        return cls + " " + cls + "--" + modifiers;
      } else if (_lodash2.default.isArray(modifiers)) {
        var retval = (0, _classnames2.default)(cls, _lodash2.default.map(modifiers, function (mod) {
          return cls + "--" + mod;
        }));
        return retval;
      }
    } else {
      return cls;
    }
  },
  withBemElement: function withBemElement(cls, elem) {
    if (this.props.bemModifiers) {
      if (_lodash2.default.isString(this.props.bemModifiers)) {
        return cls + "--" + this.props.bemModifiers + "__" + elem;
      } else if (_lodash2.default.isArray(this.props.bemModifiers)) {
        return (0, _classnames2.default)(_lodash2.default.map(this.props.bemModifiers, function (mod) {
          return cls + "--" + mod + "__" + elem;
        }));
      }
    } else {
      return cls + "__" + elem;
    }
  }
}; /*
     Bem modifiers allows class modifiers to be passed in from parent components
     to child components to change styling based on the parent component.
   */

},{"classnames":"classnames","lodash":"lodash","react":"react"}],225:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  Interface to check state of frontend Deploy Services.
*/
exports.default = {
  propTypes: {
    deployServices: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.string)
  },

  isFeatureEnabled: function isFeatureEnabled(featureCode) {
    return _lodash2.default.indexOf(this.deployServices(), featureCode) >= 0;
  },
  deployServices: function deployServices() {
    if (this.props.deployServices === undefined) {
      throw "trying to access Deploy Services from component, but component does not contain deployServices prop (" + this.constructor.displayName + ")";
    }
    return this.props.deployServices;
  }
};

},{"lodash":"lodash","react":"react"}],226:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (storeFactory) {
  return {
    getInitialState: function getInitialState() {
      this.store = storeFactory();
      return this.store.getInitialState();
    },
    componentWillMount: function componentWillMount() {
      this.actions = this.store.actions;
      this.unsubscribe = this.store.listen(this.onStoreChange);
    },
    componentWillUnmount: function componentWillUnmount() {
      this.unsubscribe();
    },
    onStoreChange: function onStoreChange(state) {
      this.setState(state);
    }
  };
};

},{}],227:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connectToLazyStore = connectToLazyStore;

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /*
                                                                                                                                                                                                                  A lazy store manages data partitioned by keys, where each key has a
                                                                                                                                                                                                                  sensible starting value that does not need an external source to initialize
                                                                                                                                                                                                                  it prior to use, e.g. a form would have default values before any user input.
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  Another important use case is for the absence of values. For example, instead
                                                                                                                                                                                                                  of requiring external code to initialize the starting value for all keys, a lazy
                                                                                                                                                                                                                  store only requires external code to initialize the non-absent values. For
                                                                                                                                                                                                                  example, if storing data about Likes or Comments, the external code would only
                                                                                                                                                                                                                  need to initialize the store with data for keys that have at least one Like
                                                                                                                                                                                                                  or Comment, leaving the rest to be lazily created in their empty state when needed.
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  If a store's data is not partitioned by keys, then it can just create its
                                                                                                                                                                                                                  state to the sensible starting value at creation time, and consumers do not
                                                                                                                                                                                                                  need to care about whether or not the store initialized itself or an external
                                                                                                                                                                                                                  call did. The fact that the keys are dynamic and unknown at initialization time
                                                                                                                                                                                                                  is why this extra layer is needed.
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  If the data for a particular key needs external information to initialize it,
                                                                                                                                                                                                                  then such initialization should be done eagerly before any components try to
                                                                                                                                                                                                                  connect to the store, removing the need for the store to be lazy.
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  Usage in a component:
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  ...
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  propTypes: {
                                                                                                                                                                                                                    keyToUse: React.PropTypes.string.isRequired,
                                                                                                                                                                                                                  },
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  mixins: [connectToLazyStore(MyStore, "keyToUse")]
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  ...
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  The lazy store should handle calls to getInitialState that include a single
                                                                                                                                                                                                                  param representing the key. If the key is not present in its data, it should
                                                                                                                                                                                                                  be set and returned. This set should not cause a trigger to any existing
                                                                                                                                                                                                                  listeners.
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  You can also namespace the state from the store under a different key so that
                                                                                                                                                                                                                  store state can more easily coexist in the same component.
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  mixins: [connectToLazyStore(MyStore, "uniqueId", {stateKey: "stateKey"})]
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  If you want to only listen to a specific value of the state, add a filterValue
                                                                                                                                                                                                                  param that will act as a filter for the substate you want to listen to.
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  mixins: [connectToLazyStore(MyStore,
                                                                                                                                                                                                                                              "uniqueId",
                                                                                                                                                                                                                                              {stateKey: "stateKey", filterValue: "specificStateValue"})]
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  */

function connectToLazyStore(store, keyPropName) {
  var _ref = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

  var _ref$stateKey = _ref.stateKey;
  var stateKey = _ref$stateKey === undefined ? null : _ref$stateKey;
  var _ref$filterValue = _ref.filterValue;
  var filterValue = _ref$filterValue === undefined ? null : _ref$filterValue;

  return {
    getInitialState: function getInitialState() {
      var value = store.getInitialState(_lodash2.default.get(this.props, keyPropName));
      if (filterValue) {
        value = value[filterValue];
      }
      if (!_lodash2.default.isNull(stateKey)) {
        value = _defineProperty({}, stateKey, value);
      }
      return value;
    },
    componentDidMount: function componentDidMount() {
      var _this = this;

      // This provides this.listenTo, which we need to use so
      // Reflux.ListenerMixin will cleanup on unmount
      _reflux2.default.utils.extend(this, _reflux2.default.ListenerMethods);

      this.listenTo(store, function (newState) {
        var incomingValue = newState[_lodash2.default.get(_this.props, keyPropName)];
        if (filterValue) {
          incomingValue = incomingValue[filterValue];
        }
        if (!_lodash2.default.isNull(stateKey)) {
          incomingValue = _defineProperty({}, stateKey, incomingValue);
        }
        _this.setState(incomingValue);
      });
    },

    componentWillUnmount: _reflux2.default.ListenerMixin.componentWillUnmount
  };
}

},{"lodash":"lodash","reflux":"reflux"}],228:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultHoverDelay = 250; /*
                             * Delayed hover behavior
                             * This is the react mixin version of the HoverIntent within shared_all_formats/
                             * hover_intent.js
                             */

exports.default = {
  onEnterIntent: function onEnterIntent(fn, delay) {
    if (!delay) {
      delay = defaultHoverDelay;
    }

    // Cancel any pending mouseleave action
    try {
      clearTimeout(this.leaveTimeout);
    } catch (e) {} /* Do nothing */

    // Set up a delayed call to the mouseenter callback
    this.hoverTimeout = _lodash2.default.delay(fn, delay);
  },
  onLeaveIntent: function onLeaveIntent(fn, delay) {
    if (!delay) {
      delay = defaultHoverDelay;
    }

    // Cancel any pending mouseenter action
    try {
      clearTimeout(this.hoverTimeout);
    } catch (e) {} /* Do nothing */

    // Set up a delayed call to the mouseleave callback
    this.leaveTimeout = _lodash2.default.delay(fn, delay);
  }
};

},{"lodash":"lodash"}],229:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _lodash = require("lodash");

var _data_tracking_helper = require("../modules/data_tracking/data_tracking_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This function is called on every component when it mounts and attaches 
 * click tracking data attributes that are provided by the trackingOptions props. 
 * The event listener is added to the top most element, that has enabledTracking = true
 */

exports.default = {
  componentDidMount: function componentDidMount() {
    var _this = this;

    var trackingOptions = this.props.trackingOptions;
    if (trackingOptions) {
      (function () {
        var node = _reactDom2.default.findDOMNode(_this);
        if (node) {
          // Store specified tracking values as data attributes on the component's DOM node
          (0, _lodash.each)((0, _lodash.keys)(trackingOptions), function (key) {
            var value = trackingOptions[key];
            if (!(0, _lodash.isUndefined)(value)) {
              node.setAttribute("data-tracking-" + key, JSON.stringify(value));
            }
          });

          if (trackingOptions.enableTracking === true) {
            // register click tracking for requested components
            node.addEventListener("click", _data_tracking_helper.handleDataTracking);
          }
        }
      })();
    }
  }
};

},{"../modules/data_tracking/data_tracking_helper":10,"lodash":"lodash","react-dom":"react-dom"}],230:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get_a_copy_actions = require("../../react_actions/buy_buttons/get_a_copy_actions");

var reducer = function reducer() {
  var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
  var action = arguments[1];

  switch (action.type) {
    case _get_a_copy_actions.GET_A_COPY_ACTIONS.LOADED_SUCCESS:
      return Object.assign({}, state, {
        activeGetACopyInterstitial: action.data
      });
    case _get_a_copy_actions.GET_A_COPY_ACTIONS.INTERSTITIAL_CLOSED:
      return Object.assign({}, state, {
        activeGetACopyInterstitial: null
      });
    default:
      return state;
  }
};

exports.default = reducer;

},{"../../react_actions/buy_buttons/get_a_copy_actions":27}],231:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _search_actions = require("../../react_actions/header/search_actions");

exports.default = function () {
  var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
  var action = arguments[1];

  switch (action.type) {
    case _search_actions.TOGGLE_SEARCH:
      return Object.assign({}, state, { searchIsActive: action.searchIsActive });
    default:
      return state;
  }
};

},{"../../react_actions/header/search_actions":35}],232:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _author_follow_actions = require("../react_actions/author_follow_actions");

var _author_follow_actions2 = _interopRequireDefault(_author_follow_actions);

var _newsfeed_updates_mixin = require("./shared/newsfeed_updates_mixin");

var _newsfeed_updates_mixin2 = _interopRequireDefault(_newsfeed_updates_mixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = new _freezerJs2.default({});

var getState = function getState() {
  return state.get();
};

var setResourceValue = function setResourceValue(resource, value) {
  return getState()[resource].set(value);
};

var getResourceValue = function getResourceValue(resource, key) {
  return getState()[resource][key];
};

var toggleAuthorFollowStoreData = function toggleAuthorFollowStoreData(resource) {
  var followingCount = getResourceValue(resource, "followingCount");
  var isFollowing = getResourceValue(resource, "isFollowing");
  var newValue = {
    isFollowing: !isFollowing,
    followingCount: isFollowing ? followingCount - 1 : followingCount + 1
  };
  setResourceValue(resource, newValue);
};

var toggleButtonEnabled = function toggleButtonEnabled(resource) {
  var oldValue = getResourceValue(resource, "buttonEnabled");
  setResourceValue(resource, { buttonEnabled: !oldValue });
};

var store = _reflux2.default.createStore({
  listenables: _author_follow_actions2.default,
  mixins: [(0, _newsfeed_updates_mixin2.default)(_newsfeed_updates_mixin.NEWSFEED_DEPENDENT_STORE_KEYS.AUTHOR_FOLLOWS)],
  getInitialState: getState,

  getState: getState,

  initializeWith: function initializeWith(rawData) {
    var newValue = _lodash2.default.transform(rawData, function (scrubbedData, authorFollow, authorId) {
      scrubbedData[authorId] = {
        isFollowing: authorFollow.isFollowing || false,
        followingCount: authorFollow.followingCount || 0,
        authorFollowingId: authorFollow.authorFollowingId || null,
        source: authorFollow.source || false,
        buttonEnabled: true
      };
    });
    getState().set(newValue);
  },
  updateWith: function updateWith(data) {
    this.initializeWith(data);
  },
  reset: function reset() {
    getState().reset({});
  },
  onFollow: function onFollow(resource) {
    var _this = this;

    // If we came from a knh page, include that in post for metrics counting in rails
    var source = getResourceValue(resource, "source");
    var fromAnnotatedBookPage = source === "AnnotatedBooksPage";
    var fromReadingNotesListPage = source === "ReadingNotesListPage";

    // Disable follow button
    toggleButtonEnabled(resource);
    this.trigger(this.getState());
    $j.post("/author_followings", {
      format: "json",
      id: resource,
      from_annotated_books_page: fromAnnotatedBookPage,
      from_reading_notes_list_page: fromReadingNotesListPage
    }).done(function (resp) {
      // POST /author_followings returns the url of the created author
      // following object
      var newValue = {
        authorFollowingId: parseInt(_lodash2.default.words(resp.url, /[0-9]+/)[0], 10)
      };
      setResourceValue(resource, newValue);
      toggleAuthorFollowStoreData(resource);
      toggleButtonEnabled(resource);
      _this.trigger(_this.getState());
    }).fail(function (error) {
      // Redirect to sign_in if authentication fails
      if (error && error.status === 403 && error.responseJSON) {
        location.href = error.responseJSON.redirect;
      }
    });
  },
  onUnFollow: function onUnFollow(resource) {
    var _this2 = this;

    // Disable unfollow button
    toggleButtonEnabled(resource);
    this.trigger(this.getState());
    $j.ajax({
      type: "DELETE",
      url: "/author_followings/" + getResourceValue(resource, "authorFollowingId"),
      data: {
        format: "json"
      }
    }).done(function () {
      var newValue = {
        authorFollowingId: null
      };
      setResourceValue(resource, newValue);
      toggleAuthorFollowStoreData(resource);
      toggleButtonEnabled(resource);
      _this2.trigger(_this2.getState());
    });
  }
});

exports.default = store;

},{"../react_actions/author_follow_actions":25,"./shared/newsfeed_updates_mixin":246,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],233:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _book_search_actions_factory = require("../react_actions/book_search_actions_factory");

var _book_search_actions_factory2 = _interopRequireDefault(_book_search_actions_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var factory = function factory() {
  var state = new _freezerJs2.default({ showLoadingSpinner: false,
    showResultsContainer: false,
    results: [],
    query: "",
    activeResult: null
  });
  var actions = (0, _book_search_actions_factory2.default)();

  var updateState = function updateState(results) {
    var values = state.get();
    values.results.reset(results);
  };

  var store = _reflux2.default.createStore({
    listenables: actions,
    getInitialState: state.get,
    getState: state.get,
    actions: actions,

    initializeWith: function initializeWith(data) {
      state.get().set("showLoadingSpinner", data.showLoadingSpinner).set("showResultsContainer", data.showResultsContainer).set("query", data.query).set("activeResult", data.activeResult).results.reset(data.results);
    },
    reset: function reset() {
      state.get().reset({});
    },
    setValue: function setValue(key, value) {
      var stateValues = state.get();
      stateValues.set(key, value);
    },
    onSelectSpecificResult: function onSelectSpecificResult(bookId) {
      var newActiveResult = _lodash2.default.find(this.getState().results, function (result) {
        return result.bookId === bookId;
      });
      this.setValue("activeResult", newActiveResult);
      this.trigger(this.getState());
    },
    onSetShowResultsContainer: function onSetShowResultsContainer(value) {
      this.setValue("showResultsContainer", value);
      this.setValue("activeResult", null);
      this.trigger(this.getState());
    },
    onSelectNextResult: function onSelectNextResult(maxResults) {
      var results = this.getState().results;
      var currentIndex = _lodash2.default.indexOf(results, this.getState().activeResult);
      this.setValue("activeResult", results[(currentIndex + 1) % maxResults]);
      this.trigger(this.getState());
    },
    onSelectPreviousResult: function onSelectPreviousResult(maxResults) {
      var results = this.getState().results;
      var activeResult = this.getState().activeResult;
      var currentIndex = _lodash2.default.indexOf(results, activeResult);
      if (currentIndex === 0 || activeResult === null) {
        this.setValue("activeResult", results[maxResults - 1]);
      } else {
        this.setValue("activeResult", results[(currentIndex - 1) % maxResults]);
      }
      this.trigger(this.getState());
    },
    onSearchResultsFound: function onSearchResultsFound(query, results) {
      updateState(results);
      this.setValue("query", query);
      this.setValue("showLoadingSpinner", false);
      this.setValue("activeResult", null);
      this.setValue("showResultsContainer", true);
      this.trigger(this.getState());
    },
    onSearch: function onSearch(searchValue, searchUrl) {
      this.setValue("showLoadingSpinner", true);
      this.trigger(this.getState());
      $j.ajax({
        url: searchUrl,
        data: { format: "json",
          q: searchValue },
        success: function success(resp) {
          actions.searchResultsFound(searchValue, resp);
        }
      });
    }
  });

  return store;
};
// ACTIONS

exports.default = factory;

},{"../react_actions/book_search_actions_factory":26,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],234:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require("redux");

var _reduxLogger = require("redux-logger");

var _reduxLogger2 = _interopRequireDefault(_reduxLogger);

var _env_utils = require("../../modules/env_utils");

var _env_utils2 = _interopRequireDefault(_env_utils);

var _reduxThunk = require("redux-thunk");

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _get_a_copy_reducer = require("../../react_reducers/buy_buttons/get_a_copy_reducer");

var _get_a_copy_reducer2 = _interopRequireDefault(_get_a_copy_reducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var middlewares = [_reduxThunk2.default]; /*
                                           This should be merged into a page-wide store.
                                           */

if (_env_utils2.default.isDevelopment() && _env_utils2.default.hasDom()) {
  middlewares.push((0, _reduxLogger2.default)());
}

var store = (0, _redux.createStore)(_get_a_copy_reducer2.default, {}, _redux.applyMiddleware.apply(undefined, middlewares));

exports.default = store;

},{"../../modules/env_utils":13,"../../react_reducers/buy_buttons/get_a_copy_reducer":230,"redux":"redux","redux-logger":"redux-logger","redux-thunk":"redux-thunk"}],235:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _gr_error_reporting = require("../modules/gr_error_reporting");

var _gr_error_reporting2 = _interopRequireDefault(_gr_error_reporting);

var _comment_actions = require("../react_actions/comment_actions");

var _comment_actions2 = _interopRequireDefault(_comment_actions);

var _newsfeed_updates_mixin = require("./shared/newsfeed_updates_mixin");

var _newsfeed_updates_mixin2 = _interopRequireDefault(_newsfeed_updates_mixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultState = {};
var state = new _freezerJs2.default(defaultState);
var MAX_TEXTAREA_ROWS = 2;
var MAX_COMMENTS_PER_PAGE = 10;

var getState = function getState() {
  return state.get();
};

var resetTo = function resetTo(data) {
  getState().reset(_lodash2.default.merge({}, defaultState, data));
};

var getStateForKey = function getStateForKey(key) {
  if (!_lodash2.default.has(getState(), key)) {
    getState().set(key, {
      numComments: 0,
      unsavedComment: "",
      comments: [],
      saveInProgress: false,
      showCommentButton: false,
      textareaRows: 1,
      showPagination: false,
      currentPage: 1,
      showSeeMoreLoadingSpinner: false
    });
  }
  return getState()[key];
};

var setDataForKey = function setDataForKey(key, data) {
  getStateForKey(key).set(data);
};

exports.default = _reflux2.default.createStore({
  listenables: _comment_actions2.default,
  mixins: [(0, _newsfeed_updates_mixin2.default)(_newsfeed_updates_mixin.NEWSFEED_DEPENDENT_STORE_KEYS.COMMENTS)],

  initializeWith: function initializeWith(data) {
    resetTo(data);
  },
  updateWith: function updateWith(data) {
    var transformedData = _lodash2.default.transform(data, function (result, commentData, key) {
      result[key] = {
        numComments: commentData.numComments || 0,
        unsavedComment: commentData.unsavedComment || "",
        comments: commentData.comments || [],
        showCommentButton: false,
        saveInProgress: false,
        textareaRows: 1,
        deletableByCurrentUser: commentData.deletableByCurrentUser,
        blockedByCurrentUser: commentData.blockedByCurrentUser || false
      };
    });
    getState().set(transformedData);
  },
  onTextareaFocusRequested: function onTextareaFocusRequested(subjectKey) {
    setDataForKey(subjectKey, {
      textareaFocusRequested: true
    });
    this.notifyListeners();
  },
  onTextareaFocused: function onTextareaFocused(subjectKey) {
    setDataForKey(subjectKey, { textareaRows: MAX_TEXTAREA_ROWS,
      textareaFocusRequested: false,
      showCommentButton: true });
    this.notifyListeners();
  },
  onTextareaUnfocused: function onTextareaUnfocused(subjectKey) {
    var comment = getStateForKey(subjectKey).unsavedComment;
    if (_lodash2.default.isEmpty(_lodash2.default.trim(comment))) {
      setDataForKey(subjectKey, { textareaRows: 1 });
    }
    this.notifyListeners();
  },
  onShowSeeMoreLoadingSpinner: function onShowSeeMoreLoadingSpinner(subjectKey) {
    setDataForKey(subjectKey, { showSeeMoreLoadingSpinner: true });
    this.notifyListeners();
  },
  onDeleteComment: function onDeleteComment(subjectKey, commentUri, commentData) {
    var _this = this;

    var subjectData = getStateForKey(subjectKey);
    var updatedNum = subjectData.numComments - 1;
    var commentIndex = _lodash2.default.findIndex(subjectData.comments, function (comment) {
      return comment.uri === commentUri;
    });
    if (commentIndex >= 0) {
      subjectData.set("numComments", updatedNum);
      subjectData.comments.splice(commentIndex, 1);
      if (!subjectData.showPagination) {
        this.notifyListeners();
      }
      $j.post("/comment/destroy?comment_uri=" + commentUri).done(function () {
        if (subjectData.showPagination) {
          if (getStateForKey(subjectKey).comments.length === 0 && subjectData.currentPage > 1) {
            commentData.page = subjectData.currentPage - 1;
            _comment_actions2.default.showCommentsForPage(commentData);
          } else if (subjectData.currentPage < Math.ceil(updatedNum / MAX_COMMENTS_PER_PAGE)) {
            commentData.page = subjectData.currentPage;
            _comment_actions2.default.showCommentsForPage(commentData);
          } else {
            _this.notifyListeners();
          }
        }
      });
    }
  },
  onAddNewComment: function onAddNewComment(commentData) {
    var _this2 = this;

    var comment = {
      body: getStateForKey(commentData.subjectKey).unsavedComment,
      authorUser: commentData.authorUser,
      updatedAtMessage: "Just now"
    };
    setDataForKey(commentData.subjectKey, { saveInProgress: true });

    this.notifyListeners();
    $j.post("/comment.json", {
      type: commentData.subject.type,
      id: commentData.subject.id,
      resource_uri: commentData.subject.uri,
      comment: {
        body_usertext: comment.body
      },
      digest_default: true,
      respect_update_feed_preference: true,
      react_framework: true
    }).done(function (resp) {
      var subjectData = getStateForKey(commentData.subjectKey);
      var updatedNum = subjectData.numComments + 1;
      subjectData.set({
        unsavedComment: "",
        saveInProgress: false,
        numComments: updatedNum,
        showCommentButton: false
      });
      if (subjectData.comments.length < MAX_COMMENTS_PER_PAGE) {
        var _comment = resp;
        subjectData.comments.push({
          createdAt: new Date(),
          body: _comment.body,
          deletableByCurrentUser: _comment.deletableByCurrentUser,
          blockedByCurrentUser: _comment.blockedByCurrentUser,
          authorUser: commentData.authorUser,
          updatedAtMessage: "Just now",
          uri: _comment.uri,
          flagForAbuseUrl: _comment.flagForAbuseUrl
        });
      } else {
        commentData.page = Math.ceil(updatedNum / MAX_COMMENTS_PER_PAGE);
        _comment_actions2.default.showCommentsForPage(commentData);
      }
      _this2.onTextareaUnfocused(commentData.subjectKey);
    }).fail(function (resp) {
      var errorMessage = null;
      if (resp.status === 404) {
        errorMessage = "Sorry, this post has been deleted.";
      } else {
        errorMessage = "Sorry, your comment cannot be posted. ";
        if (resp.responseJSON && resp.responseJSON.errors) {
          errorMessage += resp.responseJSON.errors.join(", ");
        }
      }

      if (resp.responseJSON && resp.responseJSON.errors && resp.responseJSON.errors.length === 1 && resp.responseJSON.errors.includes("There was a problem saving your comment.")) {
        // for blocked content, silently fail and fake adding the message to throw off spammers
        errorMessage = null;
        var subjectData = getStateForKey(commentData.subjectKey);
        subjectData.comments.push({
          createdAt: new Date(),
          body: {
            html: comment.body
          },
          deletableByCurrentUser: true,
          blockedByCurrentUser: false,
          authorUser: commentData.authorUser,
          updatedAtMessage: "Just now",
          uri: "",
          flagForAbuseUrl: "#"
        });

        setDataForKey(commentData.subjectKey, {
          unsavedComment: "",
          numComments: subjectData.numComments + 1
        });
      }

      if (errorMessage) {
        _gr_error_reporting2.default.notifyUser(errorMessage);
      }

      setDataForKey(commentData.subjectKey, { saveInProgress: false, showCommentButton: false });
      _comment_actions2.default.textareaUnfocused(commentData.subjectKey);
    });
  },
  onShowCommentsForPage: function onShowCommentsForPage(commentData) {
    var _this3 = this;

    var page = commentData.page > 0 ? commentData.page : 1;
    $j.get("/comment/index.json", {
      type: commentData.subject.type,
      id: commentData.subject.id,
      resource_uri: commentData.subject.uri,
      page: page,
      per_page: MAX_COMMENTS_PER_PAGE,
      reverse: true,
      react_framework: true
    }).done(function (resp) {
      setDataForKey(commentData.subjectKey, {
        comments: resp.comments,
        showPagination: true,
        currentPage: page,
        showSeeMoreLoadingSpinner: false
      });
      _this3.notifyListeners();
    });
  },
  onCommentEntered: function onCommentEntered(key, comment) {
    setDataForKey(key, { unsavedComment: comment });
    this.notifyListeners();
  },

  getState: getState,
  getInitialState: function getInitialState(key) {
    if (!_lodash2.default.isUndefined(key)) {
      return getStateForKey(key);
    } else {
      return getState();
    }
  },

  getInitialStateForKey: getStateForKey,

  reset: function reset() {
    resetTo({});
  },
  notifyListeners: function notifyListeners() {
    this.trigger(getState());
  }
});

},{"../modules/gr_error_reporting":15,"../react_actions/comment_actions":28,"./shared/newsfeed_updates_mixin":246,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],236:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _current_user_actions = require("../react_actions/current_user_actions");

var _current_user_actions2 = _interopRequireDefault(_current_user_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultState = { currentUser: {} };
var state = new _freezerJs2.default(defaultState);

var getState = function getState() {
  return state.get();
};

var resetTo = function resetTo(data) {
  getState().reset(_lodash2.default.merge({}, defaultState, data));
};

exports.default = _reflux2.default.createStore({
  listenables: [_current_user_actions2.default],

  initializeWith: function initializeWith(data) {
    _lodash2.default.each(_lodash2.default.keys(data), function (key) {
      if (!_lodash2.default.has(defaultState, key)) {
        throw new Error("Unexpected key passed to initializeWith. Received " + key + " Expected one of " + _lodash2.default.keys(defaultState));
      }
    });
    resetTo(data);
  },

  getState: getState,
  getInitialState: getState,

  onUpdatePreference: function onUpdatePreference(prefName, newValue) {
    $j.post("/user/update_preferences", {
      user: _defineProperty({}, prefName, newValue)
    });
  },
  reset: function reset() {
    resetTo({});
  }
});

},{"../react_actions/current_user_actions":29,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],237:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _favorite_genres_actions = require("../react_actions/favorite_genres_actions");

var _favorite_genres_actions2 = _interopRequireDefault(_favorite_genres_actions);

var _favorite_genres_form_actions = require("../react_actions/favorite_genres_form_actions");

var _favorite_genres_form_actions2 = _interopRequireDefault(_favorite_genres_form_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = new _freezerJs2.default({ selectedGenres: [] });

var getState = function getState() {
  return state.get();
};

var _reset = function _reset() {
  var data = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];

  getState().selectedGenres.reset(data);
};

var store = _reflux2.default.createStore({
  listenables: _favorite_genres_form_actions2.default,

  getInitialState: getState,

  getState: getState,

  // selectedGenres should be an array of genre names
  // e.g. ['Art', 'Fiction']
  initializeWith: function initializeWith() {
    for (var _len = arguments.length, selectedGenres = Array(_len), _key = 0; _key < _len; _key++) {
      selectedGenres[_key] = arguments[_key];
    }

    _reset(selectedGenres);
  },
  onSubmitSelectedGenres: function onSubmitSelectedGenres() {
    _favorite_genres_actions2.default.changeFavoriteGenres(getState().selectedGenres);
  },
  onSelectFavoriteGenre: function onSelectFavoriteGenre(selectedGenre) {
    if (_lodash2.default.includes(getState().selectedGenres, selectedGenre)) {
      return;
    }
    getState().selectedGenres.push(selectedGenre);
    this.notifyListeners();
  },
  onDeselectFavoriteGenre: function onDeselectFavoriteGenre(deselectedGenre) {
    getState().selectedGenres.shift(deselectedGenre);
    this.notifyListeners();
  },
  notifyListeners: function notifyListeners() {
    this.trigger(getState());
  },
  reset: function reset() {
    _reset();
  }
});

exports.default = store;

},{"../react_actions/favorite_genres_actions":31,"../react_actions/favorite_genres_form_actions":32,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],238:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _favorite_genres_actions = require("../react_actions/favorite_genres_actions");

var _favorite_genres_actions2 = _interopRequireDefault(_favorite_genres_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultState = { allGenres: [], favoriteGenres: [] };
var state = new _freezerJs2.default(defaultState);

var getState = function getState() {
  return state.get();
};

var _reset = function _reset(data) {
  getState().reset(_lodash2.default.merge({}, defaultState, data));
};

var serializeGenres = function serializeGenres(favoritedGenres) {
  return _lodash2.default.inject(getState().allGenres, function (data, genre) {
    var name = genre.name;
    data.favorites[name] = _lodash2.default.includes(favoritedGenres, name);
    return data;
  }, { favorites: {} });
};

exports.default = _reflux2.default.createStore({
  listenables: [_favorite_genres_actions2.default],

  initializeWith: function initializeWith(data) {
    _lodash2.default.each(_lodash2.default.keys(data), function (key) {
      if (!_lodash2.default.has(defaultState, key)) {
        throw new Error("Unexpected key passed to initializeWith. Received " + key + ". Expected one of " + _lodash2.default.keys(defaultState));
      }
    });
    _reset(data);
  },
  updateWith: function updateWith(data) {
    getState().set(data);
  },

  getState: getState,
  getInitialState: getState,

  reset: function reset() {
    _reset();
  },
  notifyListeners: function notifyListeners() {
    this.trigger(getState());
  },
  onChangeFavoriteGenres: function onChangeFavoriteGenres(favoritedGenres) {
    var _this = this;

    var afterChangesPersisted = function afterChangesPersisted() {
      getState().favoriteGenres.reset(favoritedGenres);
      _this.notifyListeners();
    };
    $j.post("/user/edit_fav_genres", _lodash2.default.merge(serializeGenres(favoritedGenres), { format: "json" }), afterChangesPersisted);
  }
});

},{"../react_actions/favorite_genres_actions":31,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],239:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _featured_genres_actions = require("../react_actions/featured_genres_actions");

var _featured_genres_actions2 = _interopRequireDefault(_featured_genres_actions);

var _shelvings_actions = require("../react_actions/shelvings_actions");

var _shelvings_actions2 = _interopRequireDefault(_shelvings_actions);

var _favorite_genres_store = require("../react_stores/favorite_genres_store");

var _favorite_genres_store2 = _interopRequireDefault(_favorite_genres_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = new _freezerJs2.default({});

var getState = function getState() {
  return state.get();
};

var store = _reflux2.default.createStore({
  listenables: _featured_genres_actions2.default,

  init: function init() {
    _favorite_genres_store2.default.listen(function () {
      _featured_genres_actions2.default.requestFeaturedBooks();
    });
  },
  initializeWith: function initializeWith(featuredGenreBookInfo) {
    state.get().reset({ featuredGenreBookInfo: featuredGenreBookInfo });
  },

  getInitialState: getState,

  getState: getState,

  onRequestFeaturedBooks: function onRequestFeaturedBooks() {
    var _this = this;

    if (_lodash2.default.isEmpty(_favorite_genres_store2.default.getState().favoriteGenres)) {
      this.saveNewFeaturedBooks([]);
      return;
    }
    if (!getState().requestedFeaturedBooksBefore) {
      $j.get("/genres/featured_books").done(function (resp) {
        _this.saveNewFeaturedBooks(resp.genres);
        _shelvings_actions2.default.addShelvings(resp.shelvings);
      }).fail(function (resp) {
        _featured_genres_actions2.default.displayError(resp);
      });
      getState().set("requestedFeaturedBooksBefore", true);
    }
  },
  onTrackMenuImpression: function onTrackMenuImpression() {
    $j.get("/dfp/browse_menu_impression");
  },
  saveNewFeaturedBooks: function saveNewFeaturedBooks(featuredGenreBookInfo) {
    getState().set("featuredGenreBookInfo", featuredGenreBookInfo);
    this.notifyListeners();
  },
  onDisplayError: function onDisplayError() {
    getState().set("errorMessage", "Error loading featured books in genre.");
    this.notifyListeners();
  },
  notifyListeners: function notifyListeners() {
    this.trigger(getState());
  },
  reset: function reset() {
    getState().reset({});
  }
});

exports.default = store;

},{"../react_actions/featured_genres_actions":33,"../react_actions/shelvings_actions":43,"../react_stores/favorite_genres_store":238,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],240:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CSA_ELEMENT_TYPE = exports.ImpressionCode = undefined;

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _data_tracking_actions = require("../react_actions/data_tracking/data_tracking_actions");

var _data_tracking_actions2 = _interopRequireDefault(_data_tracking_actions);

var _google_ads_actions = require("../react_actions/google_ads_actions");

var _google_ads_actions2 = _interopRequireDefault(_google_ads_actions);

var _newsfeed_actions = require("../react_actions/newsfeed_actions");

var _newsfeed_actions2 = _interopRequireDefault(_newsfeed_actions);

var _google_ad_helper = require("../modules/ads/google_ad_helper");

var _env_utils = require("../modules/env_utils");

var _env_utils2 = _interopRequireDefault(_env_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultState = {
  targeting: {},
  ads: {},
  nativeAds: {},
  device_type: null
}; // eslint-disable-line camelcase
var state = new _freezerJs2.default(defaultState);

var ImpressionCode = exports.ImpressionCode = {
  success: "0",
  dfpError: "1",
  monolithError: "2",
  empty: "3"
};

/** When adding, updating or removing attribute(s), please notify the Data Engineering team 
so that they can update the CSA query on their end. **/
var CSAElementAttributes = {
  adUnit: "ad",
  lineItemId: "l_id",
  campaignId: "c_id",
  type: "type",
  requestId: "r_id",
  sessionId: "s_id",
  slotId: "slot-id"
};

var CSA_ELEMENT_TYPE = exports.CSA_ELEMENT_TYPE = "DFP";

var getState = function getState() {
  return state.get();
};

var _resetTo = function _resetTo() {
  var data = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  getState().reset(_lodash2.default.merge({}, defaultState, data));
};

var getStateForKey = function getStateForKey(key) {
  if (!_lodash2.default.has(getState().ads, key)) {
    //throw error
    if (!_lodash2.default.has(getState().nativeAds, key)) {
      throw new ReferenceError("No such product existing for key " + key);
    }
    return getState().nativeAds[key];
  }
  return getState().ads[key];
};

var setDataForKey = function setDataForKey(key, data) {
  getStateForKey(key).set(data);
};

var adUnit = function adUnit(currentSlotIdState) {
  return currentSlotIdState.path.split("/", 3)[2];
};

/* eslint-disable camelcase */
var dfpTrackingInfo = function dfpTrackingInfo(currentSlotIdState) {
  return {
    ad_unit: adUnit(currentSlotIdState),
    line_item_id: currentSlotIdState.lineItemId,
    campaign_id: currentSlotIdState.campaignId,
    ad_device_type: currentSlotIdState.adDeviceType
  };
};
/* eslint-enable camelcase */

var ajaxTrackingCall = function ajaxTrackingCall(url, currentSlotIdState, additionalParams) {
  var data = _lodash2.default.merge(dfpTrackingInfo(currentSlotIdState), additionalParams);

  $j.ajax({
    url: url,
    type: "GET",
    data: data
  });
};

var setImpressionLogged = function setImpressionLogged(slotId) {
  setDataForKey(slotId, { impressionLogged: true });
};

/**
 * Tracks an element in DFP, Clickstream and CSA
 * @param {string} slotId Ad id.
 * @param {object} impressionCode Impression code to log in DFP.
 * @param {DOMNode} impressionElement The element to track in CSA.
 */
var trackImpression = function trackImpression(_ref) {
  var slotId = _ref.slotId;
  var impressionCode = _ref.impressionCode;
  var impressionElement = _ref.impressionElement;

  if (!slotId) {
    return;
  }

  var currentSlotIdState = getStateForKey(slotId);

  if (currentSlotIdState && !currentSlotIdState.impressionLogged) {
    ajaxTrackingCall(currentSlotIdState.pmetImpressionTrackUrl, currentSlotIdState, { impression_output: impressionCode } // eslint-disable-line camelcase
    );

    // CSA Impression
    trackImpressionInCSA({ currentSlotIdState: currentSlotIdState, impressionElement: impressionElement });

    setImpressionLogged(slotId);
  }
};

/**
 * Returns metadata object, which is used to set metadata attributes on
 * an element
 *
 * @param {object} currentSlotIdState The object which contains metadata.
 */
var getCSATrackingInfo = function getCSATrackingInfo(currentSlotIdState) {
  var _ref3;

  var _ref2 = window && window.ue || {};

  var id = _ref2.id;
  var sid = _ref2.sid;

  return _ref3 = {}, _defineProperty(_ref3, CSAElementAttributes.adUnit, adUnit(currentSlotIdState)), _defineProperty(_ref3, CSAElementAttributes.lineItemId, currentSlotIdState.lineItemId), _defineProperty(_ref3, CSAElementAttributes.campaignId, currentSlotIdState.campaignId), _defineProperty(_ref3, CSAElementAttributes.type, CSA_ELEMENT_TYPE), _defineProperty(_ref3, CSAElementAttributes.requestId, id), _defineProperty(_ref3, CSAElementAttributes.sessionId, sid), _defineProperty(_ref3, CSAElementAttributes.slotId, CSA_ELEMENT_TYPE), _ref3;
};

/**
 * Sets metadata attribute on the impression element and tracks it in CSA
 *
 * @param {object} currentSlotIdState The object which contains metadata.
 * @param {DOMNode} impressionElement The element to track in CSA.
 */
var trackImpressionInCSA = function trackImpressionInCSA(_ref4) {
  var currentSlotIdState = _ref4.currentSlotIdState;
  var impressionElement = _ref4.impressionElement;

  if (!impressionElement || !currentSlotIdState) {
    return;
  }

  if (window.csa) {
    (function () {

      var csaTrackingInfo = getCSATrackingInfo(currentSlotIdState);

      // setting impression attributes on the element
      Object.values(CSAElementAttributes).forEach(function (attribute) {
        if (csaTrackingInfo[attribute]) {
          impressionElement.setAttribute("data-csa-c-" + attribute, csaTrackingInfo[attribute]);
        }
      });

      // registering the element using CSA's programmatic API
      // For more details: https://info.analytics.a2z.com/#/docs/data_collection/csa/content_whitelisting
      window.csa("Content", { element: impressionElement });
    })();
  }
};

var handleClickTracker = function handleClickTracker(currentSlotIdState) {
  ajaxTrackingCall(currentSlotIdState.pmetClickTrackUrl, currentSlotIdState, {
    click_type: "click"
  }); // eslint-disable-line camelcase
};

var nativeAdGetUrl = function nativeAdGetUrl(resourceType) {
  switch (resourceType) {
    case "NewsfeedAd":
      return "/dfp/ajax_native_ad";
    case "PageSkin":
      return "/dfp/ajax_premium_campaign_page_skin";
    case "FeaturedContent":
      return "/dfp/ajax_premium_campaign_featured_content";
  }
};

exports.default = _reflux2.default.createStore({
  listenables: [_google_ads_actions2.default, { trackClickEvent: _data_tracking_actions2.default.trackClickEvent }],

  initializeWith: function initializeWith(data) {
    var _this = this;

    (0, _google_ad_helper.lazyLoadInit)();
    data = _lodash2.default.merge({}, { callbacksAttached: [] }, data);
    _resetTo(data);
    var gptSlots = [];
    var apsSlots = [];
    var a9Sizes = undefined;
    if (_env_utils2.default.hasDom() && !(0, _google_ad_helper.adSlotsDefined)()) {
      var ads = _lodash2.default.merge({}, this.getState().ads, this.getState().nativeAds);
      _lodash2.default.map(ads, function (ad, adId) {
        if (!ad.isLazyLoaded) {
          var isNativeAd = _lodash2.default.has(_this.getState().nativeAds, adId);
          (0, _google_ad_helper.defineSlot)(adId, ad.path, ad.dimensions, ad.adSizeMapping, isNativeAd);
          gptSlots.push((0, _google_ad_helper.slotToHash)(ad, adId));
          a9Sizes = (0, _google_ad_helper.getA9Sizes)(ad.dimensions);
          if (!_lodash2.default.isEmpty(a9Sizes)) {
            apsSlots.push((0, _google_ad_helper.slotToHash)(ad, adId, a9Sizes));
          }
        }
      });
      (0, _google_ad_helper.enableServices)();
      (0, _google_ad_helper.fetchApstagBids)(gptSlots, _lodash2.default.compact(apsSlots));
    }
  },
  resetTo: function resetTo(data) {
    _resetTo(data);
  },
  updateWith: function updateWith(data) {
    getState().set(_lodash2.default.merge({}, getState(), data));
  },
  onTrackClickEvent: function onTrackClickEvent(event, source) {
    var target = event.target;
    var dfp = undefined,
        pmet = undefined,
        dfpData = undefined,
        pmetData = undefined;
    var regex = /news/;
    var adId = JSON.parse(source.getAttribute("data-tracking-adId"));
    adId = adId ? adId : _lodash2.default.findKey(getState().nativeAds, function (ad) {
      return ad.path.match(regex);
    });

    //crawl up the source tree until you find the dfp and pmet tracking data
    if (adId) {
      while (target !== source) {
        if (target.getAttribute("data-tracking-dfp") && !dfp) {
          dfp = target.getAttribute("data-tracking-dfp");
          dfpData = JSON.parse(dfp);
          if (dfpData) {
            this.trackDfpClick(adId);
          }
        }
        if (target.getAttribute("data-tracking-pmet") && !pmet) {
          pmet = target.getAttribute("data-tracking-pmet");
          pmetData = JSON.parse(pmet);
          this.trackPmetClick(adId, pmetData);
        }
        target = target.parentNode;
      }
    }
  },
  mergeWith: function mergeWith(data) {
    getState().set(_lodash2.default.merge({}, getState(), data));
  },
  onHasAttachedDfpCallbackForSlot: function onHasAttachedDfpCallbackForSlot(adId) {
    this.getState().set("callbacksAttached", [].concat(_toConsumableArray(this.getState().callbacksAttached), [adId]));
  },
  onCheckCallbacksAttached: function onCheckCallbacksAttached(resolve, reject, slotsToCheck) {
    var result = _lodash2.default.reduce(["ads", "nativeAds"], function (result, adType) {
      var perAdType = _lodash2.default.reduce(_lodash2.default.keys(getState()[adType]), function (result, adId) {
        var intermediate = undefined;
        if (_lodash2.default.includes(slotsToCheck, adId)) {
          intermediate = getStateForKey(adId).isLazyLoaded || _lodash2.default.includes(getState().callbacksAttached, adId);
        } else {
          intermediate = true;
        }
        return result && intermediate;
      }, true);
      return result && perAdType;
    }, true);
    result ? resolve(true) : setTimeout(function () {
      return resolve(false);
    }, 500);
  },
  onRequestCreativeForSlot: function onRequestCreativeForSlot(slotId, paramsForCreative) {
    if (window.googletag && window.googletag.cmd) {
      window.googletag.cmd.push(function () {
        (0, _google_ad_helper.requestCreative)(slotId, paramsForCreative);
      });
    }
  },
  onRemoveAdSlot: function onRemoveAdSlot(slotId) {
    setDataForKey(slotId, {
      empty: true
    });
    this.notifyListeners();
  },
  onTrackImpression: function onTrackImpression(_ref5) {
    var slotId = _ref5.slotId;
    var impressionCode = _ref5.impressionCode;
    var impressionElement = _ref5.impressionElement;

    trackImpression({ slotId: slotId, impressionCode: impressionCode, impressionElement: impressionElement });
  },
  onAttachServedBannerAdAttributesAndTracking: function onAttachServedBannerAdAttributesAndTracking(_ref6) {
    var slotId = _ref6.slotId;
    var campaignId = _ref6.campaignId;
    var lineItemId = _ref6.lineItemId;
    var creative = _ref6.creative;
    var impressionCode = _ref6.impressionCode;
    var delayImpressionTracking = _ref6.delayImpressionTracking;
    var impressionElement = _ref6.impressionElement;

    setDataForKey(slotId, {
      campaignId: campaignId,
      lineItemId: lineItemId,
      creative: creative,
      impressionCode: impressionCode
    });
    this.notifyListeners();
    var currentSlotIdState = getStateForKey(slotId);
    if (!creative) {
      trackImpression({ slotId: slotId, impressionCode: ImpressionCode.dfpError });
      return;
    }

    if (!delayImpressionTracking) {
      //Track impression on pmet
      trackImpression({ slotId: slotId, impressionCode: impressionCode, impressionElement: impressionElement });
    }

    //ad click tracker to creative DOM object
    currentSlotIdState.creative.on("click", "a", function () {
      currentSlotIdState.creative.context.click();
      handleClickTracker(currentSlotIdState);
    });
  },
  onAttachServedNativeAdAttributesAndTracking: function onAttachServedNativeAdAttributesAndTracking(_ref7) {
    var slotId = _ref7.slotId;
    var campaignId = _ref7.campaignId;
    var lineItemId = _ref7.lineItemId;
    var creative = _ref7.creative;
    var sponsoredId = _ref7.sponsoredId;
    var impressionCode = _ref7.impressionCode;
    var dfpUrl = _ref7.dfpUrl;
    var adUnit = _ref7.adUnit;
    var impressionElement = _ref7.impressionElement;

    setDataForKey(slotId, { campaignId: campaignId, lineItemId: lineItemId, url: dfpUrl });
    var currentSlotIdState = getStateForKey(slotId);
    var resourceType = currentSlotIdState.resourceType;
    var url = nativeAdGetUrl(resourceType);
    if (!creative) {
      trackImpression({ slotId: slotId, impressionCode: ImpressionCode.dfpError });
      return;
    }

    if (currentSlotIdState.resourceType === "NewsfeedAd") {
      this.ajaxNewsfeedAd(slotId, lineItemId, sponsoredId, impressionCode, dfpUrl, adUnit, url, impressionElement);
    } else {
      this.ajaxPremiumCampaign(slotId, lineItemId, sponsoredId, impressionCode, dfpUrl, adUnit, url, impressionElement);
    }
  },
  ajaxNewsfeedAd: function ajaxNewsfeedAd(slotId, lineItemId, sponsoredId, impressionCode, dfpUrl, adUnit, url, impressionElement) {
    var _this2 = this;

    $j.ajax({
      type: "GET",
      url: url,
      /* eslint-disable camelcase */
      data: {
        format: "json",
        id: sponsoredId,
        line_item_id: lineItemId,
        ad_unit: adUnit,
        ad_device_type: "desktop",
        react: true
      }
    }). /* eslint-enable camelcase */
    done(function (json) {
      if (json.ok) {
        setDataForKey(slotId, json);
        _newsfeed_actions2.default.updateNativeAdSlot(getStateForKey(slotId).id, getStateForKey(slotId));
        _this2.notifyListeners();
        trackImpression({ slotId: slotId, impressionCode: impressionCode, impressionElement: impressionElement });
      } else {
        trackImpression({
          slotId: slotId,
          impressionCode: ImpressionCode.monolithError
        });
      }
    });
  },
  ajaxPremiumCampaign: function ajaxPremiumCampaign(slotId, lineItemId, sponsoredId, impressionCode, dfpUrl, adUnit, url, impressionElement) {
    var _this3 = this;

    $j.ajax({
      type: "GET",
      url: url,
      /* eslint-disable camelcase */
      data: {
        format: "json",
        id: sponsoredId,
        line_item_id: lineItemId,
        ad_unit: adUnit,
        ad_device_type: "desktop"
      }
    }). /* eslint-enable camelcase */
    done(function (json) {
      if (json.ok) {
        setDataForKey(slotId, json);
        _this3.notifyListeners(getState());

        //Track impression on pmet
        trackImpression({ slotId: slotId, impressionCode: impressionCode, impressionElement: impressionElement });
      } else {
        trackImpression({
          slotId: slotId,
          impressionCode: ImpressionCode.monolithError
        });
      }
    });
  },
  trackDfpClick: function trackDfpClick(slotId) {
    var currentSlotIdState = getStateForKey(slotId);
    var dfpClickUrl = currentSlotIdState.url;
    var queryParams = _lodash2.default.merge(dfpTrackingInfo(currentSlotIdState), {
      click_type: "click"
    }); // eslint-disable-line camelcase
    var encodedQueryParams = encodeURIComponent("?" + $j.param(queryParams));

    $j.ajax({
      type: "GET",
      url: dfpClickUrl + currentSlotIdState.pmetClickTrackUrl + encodedQueryParams
    });
  },
  trackPmetClick: function trackPmetClick(slotId, additionalParams) {
    var currentSlotIdState = getStateForKey(slotId);
    var queryParams = _lodash2.default.merge(dfpTrackingInfo(currentSlotIdState), additionalParams);

    $j.ajax({
      type: "GET",
      url: currentSlotIdState.pmetClickTrackUrl,
      data: queryParams
    });
  },
  notifyListeners: function notifyListeners() {
    this.trigger(getState());
  },
  getInitialState: function getInitialState(key) {
    if (!_lodash2.default.isUndefined(key)) {
      return getStateForKey(key);
    } else {
      return getState();
    }
  },

  getInitialStateForKey: getStateForKey,

  getState: getState,

  reset: _resetTo
});

},{"../modules/ads/google_ad_helper":3,"../modules/env_utils":13,"../react_actions/data_tracking/data_tracking_actions":30,"../react_actions/google_ads_actions":34,"../react_actions/newsfeed_actions":38,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],241:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _like_actions = require("../react_actions/like_actions");

var _like_actions2 = _interopRequireDefault(_like_actions);

var _newsfeed_updates_mixin = require("./shared/newsfeed_updates_mixin");

var _newsfeed_updates_mixin2 = _interopRequireDefault(_newsfeed_updates_mixin);

var _gr_error_reporting = require("../modules/gr_error_reporting");

var _gr_error_reporting2 = _interopRequireDefault(_gr_error_reporting);

var _ajax_helper = require("../modules/ajax/ajax_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = new _freezerJs2.default({});

var getState = function getState() {
  return state.get();
};

var getStateForKey = function getStateForKey(key) {
  if (!_lodash2.default.has(getState(), key)) {
    getState().set(key, {
      likeCount: 0,
      isLiked: false,
      showLoadingSpinner: false
    });
  }
  return getState()[key];
};

var setResourceValue = function setResourceValue(resource, key, value) {
  getState()[resource].set(key, value);
};

var getResourceValue = function getResourceValue(resource, key) {
  return getState()[resource][key];
};

var toggleLikeStoreData = function toggleLikeStoreData(resource) {
  var likeCount = getResourceValue(resource, "likeCount");
  var isLiked = getResourceValue(resource, "isLiked");
  setResourceValue(resource, "isLiked", !isLiked);
  setResourceValue(resource, "likeCount", getResourceValue(resource, "isLiked") ? likeCount + 1 : likeCount - 1);
};

var store = _reflux2.default.createStore({
  listenables: _like_actions2.default,
  mixins: [(0, _newsfeed_updates_mixin2.default)(_newsfeed_updates_mixin.NEWSFEED_DEPENDENT_STORE_KEYS.LIKES)],
  getState: getState,

  getInitialState: function getInitialState(key) {
    if (!_lodash2.default.isUndefined(key)) {
      return getStateForKey(key);
    } else {
      return getState();
    }
  },

  getInitialStateForKey: getStateForKey,

  reset: function reset() {
    state.get().reset({});
  },
  initializeWith: function initializeWith(data) {
    _lodash2.default.each(_lodash2.default.keys(data), function (key) {
      var scrubbedData = data[key];
      scrubbedData.likedBy = scrubbedData.likedBy || false;
      scrubbedData.likeCount = scrubbedData.likeCount || 0;
      scrubbedData.showLoadingSpinner = false;
      getState().set(key, scrubbedData);
    });
  },
  updateWith: function updateWith(data) {
    this.initializeWith(data);
  },
  triggerLoadingSpinner: function triggerLoadingSpinner(resource) {
    var oldValue = getResourceValue(resource, "showLoadingSpinner");
    setResourceValue(resource, "showLoadingSpinner", !oldValue);
  },
  onLike: function onLike(resource) {
    var _this = this;

    this.triggerLoadingSpinner(resource);
    this.trigger(this.getState());
    (0, _ajax_helper.httpPost)("/rating", {
      format: "json",
      data: {
        rating: {
          resource_type: getResourceValue(resource, "resourceType"),
          resource_id: getResourceValue(resource, "resourceId"),
          resource_uri: getResourceValue(resource, "resourceUri"),
          rating: 1
        }
      }
    }).done(function (resp) {
      toggleLikeStoreData(resource);
      setResourceValue(resource, "ratingId", resp.rating_id);
      _this.trigger(getState());
    }).fail(function (resp) {
      var message = resp.responseText;
      if (message) {
        _gr_error_reporting2.default.notifyUser(message);
      }
    }).always(function () {
      _this.triggerLoadingSpinner(resource);
      _this.trigger(getState());
    });
  },
  onUnLike: function onUnLike(resource) {
    var _this2 = this;

    this.triggerLoadingSpinner(resource);
    this.trigger(this.getState());
    var ratingId = getResourceValue(resource, "ratingId");
    var url = "";
    var data = {};
    if (ratingId) {
      url = "/rating/" + ratingId;
      data = {
        format: "json"
      };
    } else {
      url = "/rating/";
      data = {
        format: "json",
        resource_uri: getResourceValue(resource, "resourceUri")
      };
    }

    (0, _ajax_helper.httpDelete)(url, { data: data }).done(function () {
      toggleLikeStoreData(resource);
      _this2.trigger(getState());
    }).fail(function (resp) {
      var errorMessage = "Unable to unlike.";
      if (resp.status == 404) {
        errorMessage += " You may have already unliked.";
      } else if (resp.responseText) {
        errorMessage += resp.responseText;
      }
      errorMessage += " Please refresh the page and try again.";
      _gr_error_reporting2.default.notifyUser(errorMessage);
    }).always(function () {
      _this2.triggerLoadingSpinner(resource);
      _this2.trigger(getState());
    });
  }
});

exports.default = store;

},{"../modules/ajax/ajax_helper":4,"../modules/gr_error_reporting":15,"../react_actions/like_actions":36,"./shared/newsfeed_updates_mixin":246,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],242:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _modal_actions = require("../react_actions/modal_actions");

var _modal_actions2 = _interopRequireDefault(_modal_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = new _freezerJs2.default({});

var getState = function getState() {
  return state.get();
};

var store = _reflux2.default.createStore({
  listenables: _modal_actions2.default,

  getInitialState: getState,

  getState: getState,

  initializeWith: function initializeWith(data) {
    state.get().reset(data);
  },
  onOpenModal: function onOpenModal(modalId) {
    state.get().set("currentActiveModal", modalId);
    this.notifyListeners();
  },
  onCloseModal: function onCloseModal() {
    state.get().set("currentActiveModal", null);
    this.notifyListeners();
  },
  notifyListeners: function notifyListeners() {
    this.trigger(getState());
  },
  reset: function reset() {
    state.get().reset({});
  }
});

exports.default = store;

},{"../react_actions/modal_actions":37,"freezer-js":"freezer-js","reflux":"reflux"}],243:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _notifications_actions = require("../react_actions/notifications_actions");

var _notifications_actions2 = _interopRequireDefault(_notifications_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = new _freezerJs2.default({});

var getState = function getState() {
  return state.get();
};

var store = _reflux2.default.createStore({
  listenables: _notifications_actions2.default,

  getInitialState: getState,

  getState: getState,

  initializeWith: function initializeWith(data) {
    state.get().reset(data);
  },
  updateWith: function updateWith(data) {
    this.initializeWith(data);
  },
  onLoadNotifications: function onLoadNotifications(notifications) {
    state.get().set("notifications", notifications);
    state.get().set("unreadCount", 0);
    state.get().set("unreadCountMore", false);
    this.notifyListeners();
  },
  onLoadError: function onLoadError() {
    state.get().set("errorOccurred", true);
    this.notifyListeners();
  },
  onRequestNotifications: function onRequestNotifications() {
    if (!state.get().hasRequestedBefore) {
      $j.ajax({
        url: "/notifications/",
        type: "GET",
        success: function success(resp) {
          _notifications_actions2.default.loadNotifications(resp);
        },
        error: function error() {
          _notifications_actions2.default.loadError();
        }
      });
    }
    state.get().set("hasRequestedBefore", true);
  },
  notifyListeners: function notifyListeners() {
    this.trigger(getState());
  },
  reset: function reset() {
    state.get().reset({});
  }
});

exports.default = store;

},{"../react_actions/notifications_actions":39,"freezer-js":"freezer-js","reflux":"reflux"}],244:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _annotated_books_actions = require("../../react_actions/reading_notes/annotated_books_actions");

var _annotated_books_actions2 = _interopRequireDefault(_annotated_books_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = new _freezerJs2.default({
  annotatedBooksCollection: [],
  nextToken: null,
  showSpinner: true,
  showError: false
});

var getState = function getState() {
  return state.get();
};

var store = _reflux2.default.createStore({
  listenables: [_annotated_books_actions2.default],

  getInitialState: getState,

  getState: getState,

  updateWith: function updateWith(annotatedBooksCollection, nextToken) {
    var newCollection = _lodash2.default.union(state.get().annotatedBooksCollection, annotatedBooksCollection);

    newCollection = _lodash2.default.uniq(newCollection, function (annotatedBookData) {
      return annotatedBookData.asin;
    });

    getState().set({ annotatedBooksCollection: newCollection,
      nextToken: nextToken,
      showError: false });

    this.notifyListeners();
  },
  showSpinner: function showSpinner(spinnerState) {
    getState().set("showSpinner", spinnerState);
    this.notifyListeners();
  },
  showError: function showError() {
    getState().set("showError", true);
    this.notifyListeners();
  },
  notifyListeners: function notifyListeners() {
    this.trigger(getState());
  },
  reset: function reset() {
    getState().reset({});
  },
  onLoadAnnotatedBooks: function onLoadAnnotatedBooks(userId) {
    var _this = this;

    var path = "/notes/" + userId + "/load_more";
    this.showSpinner(true);

    var params = {};
    if (state.get().nextToken) {
      params.start_token = state.get().nextToken;
    }

    return $j.get(path, params).done(function (resp) {
      _this.updateWith(resp.annotated_books_collection, resp.next_token);
    }).fail(function () {
      _this.showError();
    }).always(function () {
      _this.showSpinner(false);
    });
  }
});

exports.default = store;

},{"../../react_actions/reading_notes/annotated_books_actions":40,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],245:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WARNING_SHARING_TEXT_LENGTH = exports.MAXIMUM_SHARING_TEXT_LENGTH = undefined;

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _share_dialog_actions = require("../react_actions/share_dialog_actions");

var _share_dialog_actions2 = _interopRequireDefault(_share_dialog_actions);

var _ajax_helper = require("../modules/ajax/ajax_helper");

var _string_helper = require("../modules/string_helper");

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = new _freezerJs2.default({});

var getState = function getState() {
  return state.get();
};

var MAXIMUM_SHARING_TEXT_LENGTH = exports.MAXIMUM_SHARING_TEXT_LENGTH = 420;
var WARNING_SHARING_TEXT_LENGTH = exports.WARNING_SHARING_TEXT_LENGTH = 100;

exports.default = _reflux2.default.createStore({

  listenables: [_share_dialog_actions2.default],

  getState: getState,

  getInitialState: function getInitialState() {
    return getState();
  },
  initializeWith: function initializeWith(data) {
    getState().reset(data);
  },
  onUpdateSharingTextInputValue: function onUpdateSharingTextInputValue(val) {
    var textTooLong = (0, _string_helper.astralLength)(val) > MAXIMUM_SHARING_TEXT_LENGTH;
    var disableShareModalButton = textTooLong;

    getState().set({
      sharingTextInputValue: val,
      shareModalButtonDisabled: disableShareModalButton,
      textTooLong: textTooLong
    });
    this.trigger(getState());
  },
  onSubmitShare: function onSubmitShare(sharingData, sharingTextInputValue) {
    var _this = this;

    getState().set({ shareModalButtonDisabled: true, error: false });
    this.trigger(getState());
    var sharingCreateData = {
      resource_id: sharingData.resourceId,
      resource_type: sharingData.resourceTypeFriendlyText,
      sharing_text: sharingTextInputValue
    };

    if (sharingData.sharerUserId) {
      sharingCreateData.sharer_user_id = sharingData.sharerUserId;
    }

    (0, _ajax_helper.httpPost)("/sharings", {
      format: "json",
      data: {
        sharing: sharingCreateData
      }
    }).done(function (response) {
      getState().set({
        shared: true,
        sharingTextInputValue: "",
        sharingUrl: response.sharingUrl,
        sharingDisplayName: response.sharingDisplayName
      });
    }).fail(function (error) {
      var errorText = (0, _lodash.get)(error, ["responseJSON", "message"]);
      getState().set({ error: true, errorText: errorText });
    }).always(function () {
      getState().set({ shareModalButtonDisabled: false });
      _this.trigger(getState());
    });
  },
  onOpenShareModal: function onOpenShareModal(resourceTypeIdentifier) {
    getState().set({ shared: false, error: false });
    this.trigger(getState());
    var openModalMetricByResourceType = "OpenSharingModal_" + resourceTypeIdentifier;
    (0, _ajax_helper.httpPost)("/track/track_click", {
      data: {
        feature: openModalMetricByResourceType
      }
    });
  },
  reset: function reset() {
    getState().reset({});
  }
});

},{"../modules/ajax/ajax_helper":4,"../modules/string_helper":22,"../react_actions/share_dialog_actions":42,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],246:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NEWSFEED_DEPENDENT_STORE_KEYS = undefined;

var _newsfeed_actions = require("../../react_actions/newsfeed_actions");

var _newsfeed_actions2 = _interopRequireDefault(_newsfeed_actions);

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
This mixin provides a reusable hook for stores to update when the newsfeed has
loaded additional updates. Example usage can be seen in any of the stores in
NEWSFEED_DEPENDENT_STORE_KEYS.

To add a new store, add the appropriate key/value in NEWSFEED_DEPENDENT_STORE_KEYS,
make sure the corresponding data is returned in newsfeed/all_stores_update_data
with the same value as the one defined in NEWSFEED_DEPENDENT_STORE_KEYS, and make
sure your store has an updateWith() method.
*/

var factory = function factory(dependentStoreKey) {
  var mixin = {
    init: function init() {
      if ((0, _lodash.includes)((0, _lodash.values)(NEWSFEED_DEPENDENT_STORE_KEYS), dependentStoreKey)) {
        this.listenTo(_newsfeed_actions2.default.newsfeedItemsLoaded, this.onNewsfeedItemsLoaded);
      }
    },
    onNewsfeedItemsLoaded: function onNewsfeedItemsLoaded(dependentStoreData) {
      if (dependentStoreKey && dependentStoreData[dependentStoreKey]) {
        this.updateWith(dependentStoreData[dependentStoreKey]);
        this.trigger(this.getState());
      }
    }
  };
  return mixin;
};

exports.default = factory;
var NEWSFEED_DEPENDENT_STORE_KEYS = exports.NEWSFEED_DEPENDENT_STORE_KEYS = {
  COMMENTS: "comments",
  LIKES: "likes",
  SHELVINGS: "shelvings",
  AUTHOR_FOLLOWS: "authorFollows"
};

},{"../../react_actions/newsfeed_actions":38,"lodash":"lodash"}],247:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _shelvings_actions = require("../react_actions/shelvings_actions");

var _shelvings_actions2 = _interopRequireDefault(_shelvings_actions);

var _reading_session_actions = require("../react_actions/reading_session_actions");

var _reading_session_actions2 = _interopRequireDefault(_reading_session_actions);

var _user_shelves_actions = require("../react_actions/user_shelves_actions");

var _user_shelves_actions2 = _interopRequireDefault(_user_shelves_actions);

var _newsfeed_updates_mixin = require("./shared/newsfeed_updates_mixin");

var _newsfeed_updates_mixin2 = _interopRequireDefault(_newsfeed_updates_mixin);

var _default_shelves = require("../modules/default_shelves");

var _book_origins = require("../modules/book_origins");

var _ajax_helper = require("../modules/ajax/ajax_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  This store maps book IDs to the current user's shelving data for that book.

  The same shelving could appear in ShelvingsStore multiple times. For example,
  if a user has shelved book ID 1, and book ID 2 is another edition of the same
  Work as book ID 1, ShelvingsStore might contain keys for 1, 2, or both:

  {1: {…,
       book: {
         bookId: 1,
         …
       }},
   2: {…,
       book: {
         bookId: 1,
         …
       }},
  }
*/

var state = new _freezerJs2.default({});

var getState = function getState() {
  return state.get();
};

var getStateForKey = function getStateForKey(key) {
  if (!_lodash2.default.has(getState(), key)) {
    getState().set(key, {
      exclusiveShelfName: null,
      nonExclusiveShelfNames: null,
      exclusiveShelfDisplayName: null,
      isShelvingInProgress: false,
      targetExclusiveShelfName: null
    });
  }
  return getState()[key];
};

// Update all states with a given book id included in them
var setStateForBookId = function setStateForBookId(bookId, data) {
  // merges with existing data
  getStateForKey(bookId).set(data);

  _lodash2.default.each(getState(), function (shelvingState, key) {
    if (shelvingState.book && shelvingState.book.bookId === bookId) {
      getStateForKey(key).set(data);
    }
  });
};

var addToExclusiveShelf = function addToExclusiveShelf(bookId, shelf, responseData) {
  setStateForBookId(bookId, { exclusiveShelfName: shelf.name,
    exclusiveShelfDisplayName: shelf.displayName });
  if (typeof responseData !== "undefined") {
    setStateForBookId(bookId, { book: responseData.book,
      updatedAt: Date.parse(responseData.updatedAt) });
  }
  _reading_session_actions2.default.refreshReadingSessions();
};

var deleteShelving = function deleteShelving(bookId, shelf, newShelf) {
  setStateForBookId(bookId, { exclusiveShelfName: null,
    exclusiveShelfDisplayName: null,
    rating: 0,
    nonExclusiveShelfNames: null });
  if (newShelf) {
    _user_shelves_actions2.default.removeNonExclusiveShelf(shelf.name);
  }
};

var unsetRating = function unsetRating(bookId) {
  setStateForBookId(bookId, { rating: 0 });
};

var setRating = function setRating(bookId, value) {
  var bookData = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

  addToReadShelfIfUnshelved(bookId, bookData);
  setStateForBookId(bookId, { rating: value });
};

var addToNonExclusiveShelf = function addToNonExclusiveShelf(bookId, shelf) {
  var bookData = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

  var state = getStateForKey(bookId);
  var shelfNames = _lodash2.default.clone(state.nonExclusiveShelfNames) || [];
  shelfNames.push(shelf.name);
  setStateForBookId(bookId, { nonExclusiveShelfNames: shelfNames });
  addToReadShelfIfUnshelved(bookId, bookData);
  _user_shelves_actions2.default.addNonExclusiveShelf(shelf.name);
};

var removeFromNonExclusiveShelf = function removeFromNonExclusiveShelf(bookId, shelf, newShelf) {
  var state = getStateForKey(bookId);
  var shelfNames = _lodash2.default.clone(state.nonExclusiveShelfNames);
  shelfNames = _lodash2.default.without(shelfNames, shelf.name);
  if (newShelf) {
    _user_shelves_actions2.default.removeNonExclusiveShelf(shelf.name);
  }
  setStateForBookId(bookId, { nonExclusiveShelfNames: shelfNames });
};

var addToReadShelfIfUnshelved = function addToReadShelfIfUnshelved(bookId) {
  var bookData = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];

  var state = getStateForKey(bookId);
  if (state.exclusiveShelfName === null) {
    addToExclusiveShelf(bookId, _default_shelves.DEFAULT_SHELVES.READ, bookData);
  }
};

var addToShelfRequest = function addToShelfRequest(data) {
  var origin = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
  var progress_update_text = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

  var args = data;
  if (origin) {
    args = _lodash2.default.merge({}, data, {
      book_origin: origin
    });
  }
  if (progress_update_text) {
    args = _lodash2.default.merge({}, args, {
      progress_update_text: progress_update_text
    });
  }
  args = _lodash2.default.merge({}, args, { v: 2 });
  return (0, _ajax_helper.httpPost)("/shelf/add_to_shelf.json", { data: args });
};

exports.default = _reflux2.default.createStore({
  listenables: _shelvings_actions2.default,
  mixins: [(0, _newsfeed_updates_mixin2.default)(_newsfeed_updates_mixin.NEWSFEED_DEPENDENT_STORE_KEYS.SHELVINGS)],

  getState: getState,

  getInitialState: function getInitialState(key) {
    if (!_lodash2.default.isUndefined(key)) {
      return getStateForKey(key);
    } else {
      return getState();
    }
  },
  initializeWith: function initializeWith(data) {
    state.get().reset(data);
    this.notifyListeners();
  },
  reset: function reset() {
    state.get().reset({});
  },
  notifyListeners: function notifyListeners() {
    this.trigger(getState());
  },
  updateWith: function updateWith(shelvings) {
    var shelvingData = _lodash2.default.transform(shelvings, function (result, shelving, key) {
      result[key].isShelvingInProgress = false;
      result[key].updatedAt = Date.parse(shelving.updatedAt);
      return result;
    }, shelvings);

    this.getState().set(shelvingData);
    this.notifyListeners();
  },
  onShelveBook: function onShelveBook(bookId, shelf) {
    var _this = this;

    var origin = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
    var progress_update_text = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];

    var currentCustomExclusiveShelf = getStateForKey(bookId).exclusiveShelfName;
    setStateForBookId(bookId, { isShelvingInProgress: true, targetExclusiveShelfName: shelf.name });
    var data = { book_id: bookId, name: shelf.name };
    this.notifyListeners();
    addToShelfRequest(data, origin, progress_update_text).done(function (responseData) {
      addToExclusiveShelf(bookId, shelf, responseData);
      responseData = responseData || {};
      responseData.shelves = {};
      responseData.shelves[(0, _default_shelves.getExclusiveShelfType)(shelf.name)] = [shelf.name];
      _shelvings_actions2.default.bookShelved(responseData);

      // if moving book to another exclusive shelf, remove it from the previous one
      if (currentCustomExclusiveShelf) {
        var shelves = {};
        shelves[(0, _default_shelves.getExclusiveShelfType)(currentCustomExclusiveShelf)] = [currentCustomExclusiveShelf];
        _shelvings_actions2.default.bookUnshelved({ shelves: shelves });
      }

      if (origin === _book_origins.BOOK_ORIGINS.CURRENTLY_READING_WIDGET) {
        _reading_session_actions2.default.shelveBookSuccess();
      }
    }).fail(function () {
      window.alert("There was an error adding the book to your shelf, please try again.");
    }).always(function () {
      setStateForBookId(bookId, { isShelvingInProgress: false, targetExclusiveShelfName: null });
      _this.notifyListeners();
    });
  },
  onUnshelveBook: function onUnshelveBook(bookId) {
    var _this2 = this;

    setStateForBookId(bookId, { isShelvingInProgress: true });
    this.notifyListeners();
    (0, _ajax_helper.httpPost)("/review/destroy", {
      data: {
        id: bookId
      }
    }).done(function () {
      var shelves = {};
      shelves[(0, _default_shelves.getExclusiveShelfType)(getStateForKey(bookId).exclusiveShelfName)] = [getStateForKey(bookId).exclusiveShelfName];
      shelves[_default_shelves.SHELF_TYPES.NONEXCLUSIVE] = getStateForKey(bookId).nonExclusiveShelfNames || [];
      _shelvings_actions2.default.bookUnshelved({ shelves: shelves });

      deleteShelving(bookId);
    }).fail(function (response) {
      if (response.status === 403 && response.getResponseHeader("errorType") === "frozen") {
        window.alert("Something went wrong with your request. Please try again later.");
      } else {
        window.alert("There was an error removing the book from your shelves, please try again.");
      }
    }).always(function () {
      setStateForBookId(bookId, { isShelvingInProgress: false });
      _this2.notifyListeners();
    });
  },
  onToggleNonExclusiveShelving: function onToggleNonExclusiveShelving(bookId, shelf, newShelf, title) {
    var _this3 = this;

    var exclusiveShelfName = getStateForKey(bookId).exclusiveShelfName;
    var nonExclusiveShelfNames = getStateForKey(bookId).nonExclusiveShelfNames;
    var isAddingToShelf = !_lodash2.default.includes(nonExclusiveShelfNames, shelf.name);
    var isBookShelved = getState()[bookId] && getStateForKey(bookId).exclusiveShelfName !== null;
    var bookData = { book: { bookId: bookId, title: title } };

    if (isAddingToShelf) {
      addToReadShelfIfUnshelved(bookId, bookData);
      addToNonExclusiveShelf(bookId, shelf, bookData);
    } else {
      removeFromNonExclusiveShelf(bookId, shelf, false);
    }
    this.notifyListeners();

    var data = {
      book_id: bookId,
      name: shelf.name,
      a: isAddingToShelf ? "" : "remove"
    };

    addToShelfRequest(data).done(function () {
      var shelves = {};
      if (isAddingToShelf) {
        // if book is not on an exclusive shelf already, also add it to the READ shelf
        shelves[_default_shelves.SHELF_TYPES.DEFAULT] = !exclusiveShelfName ? [_default_shelves.DEFAULT_SHELVES.READ.name] : [];
        shelves[_default_shelves.SHELF_TYPES.NONEXCLUSIVE] = [shelf.name];
        _shelvings_actions2.default.bookShelved({ shelves: shelves });
      } else {
        shelves[_default_shelves.SHELF_TYPES.NONEXCLUSIVE] = [shelf.name];
        _shelvings_actions2.default.bookUnshelved({ shelves: shelves });
      }
    }).fail(function () {
      window.alert("There was an error adding the book to your shelf, please try again.");
      if (!isBookShelved) {
        deleteShelving(bookId, shelf, newShelf);
      } else if (isAddingToShelf) {
        removeFromNonExclusiveShelf(bookId, shelf, newShelf);
      } else {
        addToNonExclusiveShelf(bookId, shelf, bookData);
      }
      _this3.notifyListeners();
    });
  },
  onRateBook: function onRateBook(bookId, rating, title) {
    var clickstreamRef = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];

    var _this4 = this;

    var ratingContainer = arguments[4];
    var handleClick = arguments[5];

    var prevRating = 0;
    var isBookShelved = false;
    var bookData = { book: { bookId: bookId, title: title } };
    if (getState()[bookId]) {
      prevRating = getStateForKey(bookId).rating;
      isBookShelved = getStateForKey(bookId).exclusiveShelfName !== null;
      if (prevRating === 0) {
        _shelvings_actions2.default.rateBook.newBook();
      }
    }
    setRating(bookId, rating, bookData);
    this.notifyListeners();

    var ratePostUrl = "/review/rate";
    var ratePostData = {
      format: "json",
      id: bookId,
      rating: rating,
      stars_click: true
    };
    if (clickstreamRef) {
      var clickstreamRefNumRating = clickstreamRef.replace("str", "st" + rating);
      ratePostUrl += "?ref=" + clickstreamRefNumRating;
    }
    var store = this;
    (0, _ajax_helper.httpPost)(ratePostUrl, {
      data: ratePostData,
      error: function error(xhr, aja_xOptions, thrownError) {
        if (xhr.status === 403 && xhr.getResponseHeader("errorType") === "frozen") {
          window.alert("This book has temporary limitations on submitting ratings and reviews. This may be because we've detected unusual behavior that doesn't follow our review guidelines.");
        } else if (xhr.status !== 403) {
          window.alert("There was an error saving your rating, please try again.");
        }
        if (prevRating > 0) {
          setRating(bookId, prevRating, bookData);
        } else if (isBookShelved) {
          unsetRating(bookId);
          _shelvings_actions2.default.rateBook.failed();
        } else {
          deleteShelving(bookId, null, false);
          _shelvings_actions2.default.rateBook.failed();
        }
        store.notifyListeners();
      },
      success: function success(response) {
        ratingContainer.focus();
        if (handleClick) {
          handleClick();
        }
        store.notifyListeners();
      }
    }).fail(function () {
      window.alert("There was an error saving your rating, please try again.");
      if (prevRating > 0) {
        setRating(bookId, prevRating, bookData);
      } else if (isBookShelved) {
        unsetRating(bookId);
        _shelvings_actions2.default.rateBook.failed();
      } else {
        deleteShelving(bookId, null, false);
        _shelvings_actions2.default.rateBook.failed();
      }
      _this4.notifyListeners();
    });
  },
  onAddShelvings: function onAddShelvings(shelvings) {
    this.updateWith(shelvings);
    this.notifyListeners();
  }
});

},{"../modules/ajax/ajax_helper":4,"../modules/book_origins":6,"../modules/default_shelves":12,"../react_actions/reading_session_actions":41,"../react_actions/shelvings_actions":43,"../react_actions/user_shelves_actions":50,"./shared/newsfeed_updates_mixin":246,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],248:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _tab_actions = require("../react_actions/tab_actions");

var _tab_actions2 = _interopRequireDefault(_tab_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = new _freezerJs2.default({});

var getState = function getState() {
  return state.get();
};

var store = _reflux2.default.createStore({
  listenables: _tab_actions2.default,

  getInitialState: getState,

  getState: getState,

  initializeWith: function initializeWith(groupsToActiveNames) {
    state.get().reset(groupsToActiveNames);
  },
  updateWith: function updateWith(data) {
    getState().set(data);
  },
  onDeselectTab: function onDeselectTab(tabName, tabGroupName) {
    if (state.get()[tabGroupName] === tabName) {
      state.get().set(tabGroupName, null);
      this.notifyListeners();
    }
  },
  onSelectTab: function onSelectTab(tabName, tabGroupName) {
    state.get().set(tabGroupName, tabName);
    this.notifyListeners();
  },
  notifyListeners: function notifyListeners() {
    this.trigger(getState());
  },
  reset: function reset() {
    state.get().reset({});
  }
});

exports.default = store;

},{"../react_actions/tab_actions":44,"freezer-js":"freezer-js","reflux":"reflux"}],249:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_ERROR_MESSAGE = undefined;

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _block_user_actions = require("../../../react_actions/user/show/block_user_actions");

var _block_user_actions2 = _interopRequireDefault(_block_user_actions);

var _friend_follow_module_store = require("../../user_relationships/friend_follow_module_store");

var _friend_follow_module_store2 = _interopRequireDefault(_friend_follow_module_store);

var _flash_message_helper = require("../../../modules/flash_message_helper");

var _ajax_helper = require("../../../modules/ajax/ajax_helper");

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultState = { blockInProgress: false };

var state = new _freezerJs2.default(defaultState);

var getState = function getState() {
  return state.get();
};

var DEFAULT_ERROR_MESSAGE = exports.DEFAULT_ERROR_MESSAGE = "Something went wrong with your request. Please\n  try again later.";

exports.default = _reflux2.default.createStore({
  listenables: [_block_user_actions2.default],

  getState: getState,

  getInitialState: function getInitialState() {
    return getState();
  },
  initializeWith: function initializeWith(data) {
    var newState = Object.assign({}, defaultState, data);
    getState().set(newState);
    this.trigger(getState());
  },

  // kind of a misnomer, since hitting block_member toggles blocked status, not
  // set it
  onBlockMember: function onBlockMember(id) {
    var _this = this;

    getState().set({ blockInProgress: true });
    this.trigger(getState());
    var message = undefined;
    return (0, _ajax_helper.httpPost)("/user/" + id + "/block_member", { data: { format: "json" } }).done(function (response) {
      (0, _flash_message_helper.flashSuccessMessage)(response.message);
      getState().set({ isBlocked: response.isBlocked });
      _friend_follow_module_store2.default.receiveUnfriend(id);
      _this.trigger(getState());
    }).fail(function (error) {
      message = (0, _lodash.get)(error, "message");
      if (!message) {
        message = DEFAULT_ERROR_MESSAGE;
      }
      (0, _flash_message_helper.flashErrorMessage)(message);
    }).always(function () {
      getState().set({ blockInProgress: false });
      _this.trigger(getState());
    });
  },
  reset: function reset() {
    getState().reset(defaultState);
  }
});

},{"../../../modules/ajax/ajax_helper":4,"../../../modules/flash_message_helper":14,"../../../react_actions/user/show/block_user_actions":45,"../../user_relationships/friend_follow_module_store":253,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],250:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _user_follow_actions = require("../../react_actions/user/user_follow_actions");

var _user_follow_actions2 = _interopRequireDefault(_user_follow_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = new _freezerJs2.default({});

var getState = function getState() {
  return state.get();
};

var getResourceValue = function getResourceValue(resource, key) {
  return getState()[resource][key];
};

var setRelationshipData = function setRelationshipData(userId, value) {
  return getState()[userId].set(value);
};

var getRelationshipData = function getRelationshipData(userId, key) {
  return getState()[userId][key];
};

var clearErrorState = function clearErrorState(userId) {
  setRelationshipData(userId, { error: null });
};

var toggleUserFollowStoreData = function toggleUserFollowStoreData(userId) {
  var isFollowing = getRelationshipData(userId, "isFollowing");
  var newValue = {
    isFollowing: !isFollowing
  };
  setRelationshipData(userId, newValue);
};

var enableButton = function enableButton(userId) {
  setRelationshipData(userId, { buttonEnabled: true });
};

var disableButton = function disableButton(userId) {
  setRelationshipData(userId, { buttonEnabled: false });
};

var store = _reflux2.default.createStore({
  listenables: _user_follow_actions2.default,
  getState: getState,
  getInitialState: getState,

  initializeWith: function initializeWith(rawData) {
    var newValue = _lodash2.default.transform(rawData, function (scrubbedData, userRelationship, userId) {
      scrubbedData[userId] = {
        error: null,
        buttonEnabled: true,
        isBlocked: userRelationship.isBlocked,
        allowsFollow: userRelationship.allowsFollow,
        source: userRelationship.source || false,
        // Valid follow status defined in modules/user/friend_status_values.js
        isFollowing: userRelationship.isFollowing,
        friendshipStatus: userRelationship.friendshipStatus
      };
    });
    getState().set(newValue);
  },
  updateWith: function updateWith(data) {
    this.initializeWith(data);
  },
  reset: function reset() {
    getState().reset({});
  },
  onFollow: function onFollow(userId) {
    var _this = this;

    // If we came from a Kindle Notes and Highlights page, include that in post for metrics counting in rails
    var source = getResourceValue(userId, "source");
    var fromAnnotatedBookPage = source === "AnnotatedBooksPage";
    var fromReadingNotesListPage = source === "ReadingNotesListPage";

    disableButton(userId);
    clearErrorState(userId);
    this.trigger(this.getState());
    $j.post("/user/" + userId + "/followers", {
      format: "json",
      from_annotated_books_page: fromAnnotatedBookPage,
      from_reading_notes_list_page: fromReadingNotesListPage
    }).done(function (resp) {
      // In both success and failure service responds with status 200
      // simple {status: "success"} message if successful
      // and 200 response {status: "error", "message": "blah"} if not
      if (resp.status === "success") {
        toggleUserFollowStoreData(userId);
      } else {
        // TODO-KCW-10739 - Better error state handling
        var data = { error: resp.message };
        setRelationshipData(userId, data);
      }
    }).always(function () {
      enableButton(userId);
      _this.trigger(_this.getState());
    });
  },
  onUnFollow: function onUnFollow(userId) {
    var _this2 = this;

    disableButton(userId);
    clearErrorState(userId);
    this.trigger(this.getState());
    $j.ajax({
      type: "DELETE",
      url: "/user/" + userId + "/followers/stop_following",
      data: {
        format: "json"
      }
    }).done(function () {
      toggleUserFollowStoreData(userId);
    }).fail(function () {
      // On fail, the service returns a 404 with empty head.
      // TODO-KCW-10739 - Better error state handling
    }).always(function () {
      enableButton(userId);
      _this2.trigger(_this2.getState());
    });
  }
});

exports.default = store;

},{"../../react_actions/user/user_follow_actions":46,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],251:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _user_agent_capabilities_actions = require("../react_actions/user_agent_capabilities_actions");

var _user_agent_capabilities_actions2 = _interopRequireDefault(_user_agent_capabilities_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultState = { touch: false };
var state = new _freezerJs2.default(defaultState);

exports.default = _reflux2.default.createStore({
  listenables: [_user_agent_capabilities_actions2.default],

  initializeWith: function initializeWith(data) {
    state.get().reset(data);
  },
  reset: function reset() {
    state.get().reset(defaultState);
  },
  getInitialState: function getInitialState() {
    return state.get();
  },
  onUserAgentGainsTouch: function onUserAgentGainsTouch() {
    state.get().set("touch", true);
    this.trigger(state.get());
  },
  onUserAgentLosesTouch: function onUserAgentLosesTouch() {
    state.get().set("touch", false);
    this.trigger(state.get());
  }
});

},{"../react_actions/user_agent_capabilities_actions":47,"freezer-js":"freezer-js","reflux":"reflux"}],252:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _ajax_helper = require("../modules/ajax/ajax_helper");

var _user_not_interested_actions = require("../react_actions/user_not_interested_actions");

var _user_not_interested_actions2 = _interopRequireDefault(_user_not_interested_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  A book with ID 0 is used to set default state. This book is never modified, it
  is only used to created other books with individual states as creatives appear
  from dfp.
*/
var DEFAULT_STATE = { default: { isFlashMessage: false, isClosed: false } }; /*
                                                                               This store allows users to make books as not interested. Not interested
                                                                               books will not show up in native ad slots
                                                                             */

var state = new _freezerJs2.default(DEFAULT_STATE);

var getState = function getState() {
  return state.get();
};

var _reset = function _reset(data) {
  getState().reset((0, _lodash.merge)({}, DEFAULT_STATE, data));
};

exports.default = _reflux2.default.createStore({
  listenables: [_user_not_interested_actions2.default],

  getState: getState,
  getInitialState: getState,

  reset: function reset() {
    _reset({});
  },
  setDataForKey: function setDataForKey(bookId, data) {
    var newState = {};
    newState[bookId] = data;
    getState().set((0, _lodash.merge)({}, getState(), newState));
  },
  onAddBookIDToState: function onAddBookIDToState(bookId) {
    this.setDataForKey(bookId, getState().default);
    this.trigger(getState());
  },
  onIsFlashMessageForBook: function onIsFlashMessageForBook(bookId) {
    getState()[bookId].isFlashMessage;
  },
  onCloseFlashMessage: function onCloseFlashMessage(bookId) {
    this.setDataForKey(bookId, { isClosed: true });
    this.trigger(getState());
  },
  userNotInterestedHttpPost: function userNotInterestedHttpPost(bookId) {
    return (0, _ajax_helper.httpPost)("/user_not_interested_works", {
      data: {
        user_not_interested_work: {
          book_id: bookId,
          source: "react"
        }
      }
    });
  },
  onUserNotInterested: function onUserNotInterested(bookId) {
    var _this = this;

    this.userNotInterestedHttpPost(bookId).done(function () {
      _this.setDataForKey(bookId, { isFlashMessage: true });
      _this.trigger(getState());
    }).fail(function () {
      window.alert("There was an error marking this book as not interested, please try again.");
    });
  },
  undoUserNotInterestedHttpDelete: function undoUserNotInterestedHttpDelete(bookId) {
    return (0, _ajax_helper.httpDelete)("/user_not_interested_works/undo", {
      data: {
        user_not_interested_work: { book_id: bookId }
      }
    });
  },
  onUndoUserNotInterested: function onUndoUserNotInterested(bookId) {
    var _this2 = this;

    this.undoUserNotInterestedHttpDelete(bookId).done(function () {
      _this2.setDataForKey(bookId, { isFlashMessage: false });
      _this2.trigger(getState());
    }).fail(function () {
      window.alert("There was an error undoing this action, please try again.");
    });
  }
});

},{"../modules/ajax/ajax_helper":4,"../react_actions/user_not_interested_actions":48,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],253:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _friend_follow_actions = require("../../react_actions/user_relationships/friend_follow_actions");

var _friend_follow_actions2 = _interopRequireDefault(_friend_follow_actions);

var _ajax_helper = require("../../modules/ajax/ajax_helper");

var _lodash = require("lodash");

var _flash_message_helper = require("../../modules/flash_message_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = new _freezerJs2.default({});

var getState = function getState() {
  return state.get();
};

exports.default = _reflux2.default.createStore({
  listenables: [_friend_follow_actions2.default],

  getState: getState,

  getInitialState: function getInitialState() {
    return getState();
  },
  initializeWith: function initializeWith(data) {
    getState().reset(data);
  },

  // before every ajax request, always set inProgress to true
  startAjaxRequest: function startAjaxRequest(id) {
    getState()[id].set({ inProgress: true });
    this.trigger(getState());
  },

  // after every ajax request, always reset inProgress to false
  finishAjaxRequest: function finishAjaxRequest(id) {
    getState()[id].set({ inProgress: false });
    this.trigger(getState());
  },

  // this is split off from ajax request cuz BlockUserStore uses this
  receiveUnfriend: function receiveUnfriend(id) {
    getState()[id].set({
      isFriend: false,
      isFollowing: false,
      isPendingFriendRequestTo: false
    });

    this.trigger(getState());
  },
  onUnfriend: function onUnfriend(id) {
    var _this = this;

    this.startAjaxRequest(id);

    (0, _ajax_helper.httpPost)("/friend/destroy/" + id + ".json").done(function () {
      _this.receiveUnfriend(id);
    }).fail(function (error) {
      (0, _flash_message_helper.flashErrorMessage)((0, _lodash.get)(error, "message", _ajax_helper.DEFAULT_ERROR_MESSAGE));
    }).always(function () {
      return _this.finishAjaxRequest(id);
    });
  },
  onCancelFriendRequest: function onCancelFriendRequest(id, friendRequestId) {
    var _this2 = this;

    this.startAjaxRequest(id);

    (0, _ajax_helper.httpPost)("/friend/cancel_request/" + friendRequestId + ".json").done(function () {
      getState()[id].set({
        isFollowing: false,
        isPendingFriendRequestTo: false
      });
    }).fail(function (error) {
      (0, _flash_message_helper.flashErrorMessage)((0, _lodash.get)(error, "message", _ajax_helper.DEFAULT_ERROR_MESSAGE));
    }).always(function () {
      return _this2.finishAjaxRequest(id);
    });
  },
  onFollow: function onFollow(id) {
    var _this3 = this;

    var data = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    this.startAjaxRequest(id);

    (0, _ajax_helper.httpPost)("/user/" + id + "/followers.json", { data: data }).done(function () {
      getState()[id].set({ isFollowing: true });
    }).fail(function (error) {
      (0, _flash_message_helper.flashErrorMessage)((0, _lodash.get)(error, "message", _ajax_helper.DEFAULT_ERROR_MESSAGE));
    }).always(function () {
      return _this3.finishAjaxRequest(id);
    });
  },
  onUnfollow: function onUnfollow(id) {
    var _this4 = this;

    this.startAjaxRequest(id);

    (0, _ajax_helper.httpDelete)("/user/" + id + "/followers/stop_following.json").done(function () {
      getState()[id].set({
        isFollowing: false,
        isPendingFriendRequestTo: false
      });
    }).fail(function (error) {
      (0, _flash_message_helper.flashErrorMessage)((0, _lodash.get)(error, "message", _ajax_helper.DEFAULT_ERROR_MESSAGE));
    }).always(function () {
      return _this4.finishAjaxRequest(id);
    });
  },
  onAcceptFriendRequest: function onAcceptFriendRequest(id, friendRequestId) {
    var _this5 = this;

    this.startAjaxRequest(id);

    (0, _ajax_helper.httpPost)("/friend/confirm_request.json", { data: { id: friendRequestId } }).done(function () {
      getState()[id].set({
        isFriend: true,
        isPendingFriendRequestFrom: false
      });
    }).fail(function (error) {
      (0, _flash_message_helper.flashErrorMessage)((0, _lodash.get)(error, "message", _ajax_helper.DEFAULT_ERROR_MESSAGE));
    }).always(function () {
      return _this5.finishAjaxRequest(id);
    });
  },
  reset: function reset() {
    getState().reset({});
  }
});

},{"../../modules/ajax/ajax_helper":4,"../../modules/flash_message_helper":14,"../../react_actions/user_relationships/friend_follow_actions":49,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],254:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _shelvings_actions = require("../react_actions/shelvings_actions");

var _shelvings_actions2 = _interopRequireDefault(_shelvings_actions);

var _user_shelves_actions = require("../react_actions/user_shelves_actions");

var _user_shelves_actions2 = _interopRequireDefault(_user_shelves_actions);

var _want_to_read_menu_actions = require("../react_actions/want_to_read_menu_actions");

var _want_to_read_menu_actions2 = _interopRequireDefault(_want_to_read_menu_actions);

var _default_shelves = require("../modules/default_shelves");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultState = { defaultShelves: [],
  customExclusiveShelves: [],
  nonExclusiveShelves: [] };
var state = new _freezerJs2.default(defaultState);

var getState = function getState() {
  return state.get();
};

var updateCount = function updateCount(shelfName, shelfType, countDelta) {
  var shelf = _lodash2.default.find(getState()[shelfType], { name: shelfName });
  if (shelf) {
    shelf.set("bookCount", shelf.bookCount + countDelta);
  }
};

exports.default = _reflux2.default.createStore({
  listenables: [_user_shelves_actions2.default, { bookShelved: _shelvings_actions2.default.bookShelved,
    bookUnshelved: _shelvings_actions2.default.bookUnshelved }],

  getInitialState: state.get,
  getState: getState,

  defaultShelves: function defaultShelves() {
    var shelves = getState().defaultShelves;
    if (shelves.length === 0) {
      return _default_shelves.DEFAULT_SHELVES;
    } else {
      return { READ: _lodash2.default.find(shelves, "name", "read"),
        CURRENTLY_READING: _lodash2.default.find(shelves, "name", "currently-reading"),
        WANT_TO_READ: _lodash2.default.find(shelves, "name", "to-read") };
    }
  },
  initializeWith: function initializeWith(shelves) {
    state.get().reset(shelves);
  },
  reset: function reset() {
    state.get().reset(defaultState);
  },
  updateWith: function updateWith(shelves) {
    state.get().reset(shelves);
  },
  onAddNonExclusiveShelf: function onAddNonExclusiveShelf(newShelfName) {
    var currentNonExclusiveShelves = _lodash2.default.clone(state.get().nonExclusiveShelves) || [];
    var shelfNames = _lodash2.default.map(currentNonExclusiveShelves, function (shelf) {
      return shelf.name;
    });
    if (!_lodash2.default.includes(shelfNames, newShelfName)) {
      currentNonExclusiveShelves.unshift({ name: newShelfName,
        url: "",
        displayName: newShelfName,
        bookCount: 0 });
      state.get().set("nonExclusiveShelves", currentNonExclusiveShelves);
      _want_to_read_menu_actions2.default.updateShelves();
      this.trigger(getState());
    }
  },
  onRemoveNonExclusiveShelf: function onRemoveNonExclusiveShelf(shelfNameToRemove) {
    var currentNonExclusiveShelves = _lodash2.default.clone(state.get().nonExclusiveShelves) || [];
    var shelfNames = _lodash2.default.map(currentNonExclusiveShelves, function (shelf) {
      return shelf.name;
    });
    if (_lodash2.default.includes(shelfNames, shelfNameToRemove)) {
      _lodash2.default.remove(currentNonExclusiveShelves, function (shelf) {
        return shelf.name === shelfNameToRemove;
      });
      state.get().set("nonExclusiveShelves", currentNonExclusiveShelves);
      _want_to_read_menu_actions2.default.updateShelves();
      this.trigger(getState());
    }
  },
  onBookShelved: function onBookShelved(options) {
    var shelves = options.shelves || {};
    _lodash2.default.each(shelves, function (shelfNames, shelfType) {
      _lodash2.default.each(shelfNames, function (shelfName) {
        updateCount(shelfName, shelfType, 1);
      });
    });
    this.trigger(getState());
  },
  onBookUnshelved: function onBookUnshelved(options) {
    var shelves = options.shelves || {};
    _lodash2.default.each(shelves, function (shelfNames, shelfType) {
      _lodash2.default.each(shelfNames, function (shelfName) {
        updateCount(shelfName, shelfType, -1);
      });
    });
    this.trigger(getState());
  }
});

},{"../modules/default_shelves":12,"../react_actions/shelvings_actions":43,"../react_actions/user_shelves_actions":50,"../react_actions/want_to_read_menu_actions":51,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],255:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _want_to_read_menu_actions = require("../react_actions/want_to_read_menu_actions");

var _want_to_read_menu_actions2 = _interopRequireDefault(_want_to_read_menu_actions);

var _user_shelves_store = require("./user_shelves_store");

var _user_shelves_store2 = _interopRequireDefault(_user_shelves_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SHOW_ADD_SHELF_TEXTBOX_KEY = "showAddShelfTextbox";

var defaultState = {};
var state = new _freezerJs2.default(defaultState);

var getState = function getState() {
  return state.get();
};

var getDisplayableExclusiveShelves = function getDisplayableExclusiveShelves(shelfNameFilter, userShelvesStoreState) {
  var displayableExclusiveShelves = [];
  var unselectedExclusiveShelves = userShelvesStoreState.defaultShelves.concat(userShelvesStoreState.customExclusiveShelves || []);

  if (!_lodash2.default.isEmpty(shelfNameFilter)) {
    displayableExclusiveShelves = _lodash2.default.filter(unselectedExclusiveShelves, function (shelf) {
      return shelf.name.match(new RegExp(shelfNameFilter, "i"));
    });
  } else {
    displayableExclusiveShelves = unselectedExclusiveShelves;
  }
  return displayableExclusiveShelves;
};

var getDisplayableNonExclusiveShelves = function getDisplayableNonExclusiveShelves(shelfNameFilter, userShelvesStoreState) {
  var displayableNonExclusiveShelves = [];
  if (!_lodash2.default.isEmpty(shelfNameFilter)) {
    displayableNonExclusiveShelves = _lodash2.default.filter(userShelvesStoreState.nonExclusiveShelves, function (shelf) {
      return shelf.name.match(new RegExp(shelfNameFilter, "i"));
    });
  } else {
    displayableNonExclusiveShelves = userShelvesStoreState.nonExclusiveShelves;
  }
  return displayableNonExclusiveShelves;
};

var getFilteredShelves = function getFilteredShelves(shelfNameFilter) {
  var userShelvesStoreState = _user_shelves_store2.default.getState();
  var displayableExclusiveShelves = getDisplayableExclusiveShelves(shelfNameFilter, userShelvesStoreState);
  var displayableNonExclusiveShelves = getDisplayableNonExclusiveShelves(shelfNameFilter, userShelvesStoreState);

  return {
    displayableExclusiveShelves: displayableExclusiveShelves,
    displayableNonExclusiveShelves: displayableNonExclusiveShelves,
    shelfNameFilter: shelfNameFilter
  };
};

var updateStateWithFilter = function updateStateWithFilter(shelfNameFilter, uniqueWTRButtonId) {
  getState().set(uniqueWTRButtonId, getFilteredShelves(shelfNameFilter));
};

var updateShelvesWithoutFilterChange = function updateShelvesWithoutFilterChange(uniqueWTRButtonId) {
  var shelfNameFilter = getState()[uniqueWTRButtonId].shelfNameFilter;
  getState().set(uniqueWTRButtonId, getFilteredShelves(shelfNameFilter));
};

var getStateForKey = function getStateForKey(key) {
  if (!_lodash2.default.has(getState(), key)) {
    updateStateWithFilter("", key);
  }
  return getState()[key];
};

var resetTo = function resetTo(data) {
  getState().reset(_lodash2.default.merge({}, defaultState, data));
};

exports.default = _reflux2.default.createStore({
  listenables: [_want_to_read_menu_actions2.default],
  getInitialState: function getInitialState(key) {
    if (!_lodash2.default.isUndefined(key)) {
      return getStateForKey(key);
    } else {
      return getState();
    }
  },

  getState: getState,

  initializeWith: function initializeWith(data) {
    resetTo(data);
  },
  reset: function reset() {
    resetTo(defaultState);
  },
  updateWith: function updateWith(data) {
    _lodash2.default.each(_lodash2.default.keys(data), function (key) {
      getState().set(key, data[key]);
    });
    this.notifyListeners();
  },
  notifyListeners: function notifyListeners() {
    this.trigger(getState());
  },
  onUpdateShelfNameFilter: function onUpdateShelfNameFilter(shelfNameFilter, uniqueWTRButtonId) {
    updateStateWithFilter(shelfNameFilter, uniqueWTRButtonId);
    getStateForKey(uniqueWTRButtonId).set(SHOW_ADD_SHELF_TEXTBOX_KEY, false);
    this.notifyListeners();
  },
  onOpenAddShelfTextbox: function onOpenAddShelfTextbox(uniqueWTRButtonId) {
    getStateForKey(uniqueWTRButtonId).set(SHOW_ADD_SHELF_TEXTBOX_KEY, true);
    this.notifyListeners();
  },
  onCloseAddShelfTextbox: function onCloseAddShelfTextbox(uniqueWTRButtonId) {
    getStateForKey(uniqueWTRButtonId).set(SHOW_ADD_SHELF_TEXTBOX_KEY, false);
    this.notifyListeners();
  },
  onUpdateShelves: function onUpdateShelves() {
    _lodash2.default.each(_lodash2.default.keys(getState()), function (uniqueWTRButtonId) {
      updateShelvesWithoutFilterChange(uniqueWTRButtonId);
    });
    this.notifyListeners();
  }
});

},{"../react_actions/want_to_read_menu_actions":51,"./user_shelves_store":254,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],256:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.loopAsync = loopAsync;
exports.mapAsync = mapAsync;
function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = void 0;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(Array.prototype.slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

function mapAsync(array, work, callback) {
  var length = array.length;
  var values = [];

  if (length === 0) return callback(null, values);

  var isDone = false,
      doneCount = 0;

  function done(index, error, value) {
    if (isDone) return;

    if (error) {
      isDone = true;
      callback(error);
    } else {
      values[index] = value;

      isDone = ++doneCount === length;

      if (isDone) callback(null, values);
    }
  }

  array.forEach(function (item, index) {
    work(item, index, function (error, value) {
      done(index, error, value);
    });
  });
}
},{}],257:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.ContextProvider = ContextProvider;
exports.ContextSubscriber = ContextSubscriber;

var _react = require('react');

// Works around issues with context updates failing to propagate.
// Caveat: the context value is expected to never change its identity.
// https://github.com/facebook/react/issues/2517
// https://github.com/reactjs/react-router/issues/470

var contextProviderShape = _react.PropTypes.shape({
  subscribe: _react.PropTypes.func.isRequired,
  eventIndex: _react.PropTypes.number.isRequired
});

function makeContextName(name) {
  return '@@contextSubscriber/' + name;
}

function ContextProvider(name) {
  var _childContextTypes, _ref2;

  var contextName = makeContextName(name);
  var listenersKey = contextName + '/listeners';
  var eventIndexKey = contextName + '/eventIndex';
  var subscribeKey = contextName + '/subscribe';

  return _ref2 = {
    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),

    getChildContext: function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextName] = {
        eventIndex: this[eventIndexKey],
        subscribe: this[subscribeKey]
      }, _ref;
    },
    componentWillMount: function componentWillMount() {
      this[listenersKey] = [];
      this[eventIndexKey] = 0;
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      this[eventIndexKey]++;
    },
    componentDidUpdate: function componentDidUpdate() {
      var _this = this;

      this[listenersKey].forEach(function (listener) {
        return listener(_this[eventIndexKey]);
      });
    }
  }, _ref2[subscribeKey] = function (listener) {
    var _this2 = this;

    // No need to immediately call listener here.
    this[listenersKey].push(listener);

    return function () {
      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
        return item !== listener;
      });
    };
  }, _ref2;
}

function ContextSubscriber(name) {
  var _contextTypes, _ref4;

  var contextName = makeContextName(name);
  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
  var handleContextUpdateKey = contextName + '/handleContextUpdate';
  var unsubscribeKey = contextName + '/unsubscribe';

  return _ref4 = {
    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),

    getInitialState: function getInitialState() {
      var _ref3;

      if (!this.context[contextName]) {
        return {};
      }

      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
    },
    componentDidMount: function componentDidMount() {
      if (!this.context[contextName]) {
        return;
      }

      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      var _setState;

      if (!this.context[contextName]) {
        return;
      }

      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
    },
    componentWillUnmount: function componentWillUnmount() {
      if (!this[unsubscribeKey]) {
        return;
      }

      this[unsubscribeKey]();
      this[unsubscribeKey] = null;
    }
  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
      var _setState2;

      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
    }
  }, _ref4;
}
},{"react":"react"}],258:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
exports.falsy = falsy;

var _react = require('react');

var func = _react.PropTypes.func,
    object = _react.PropTypes.object,
    arrayOf = _react.PropTypes.arrayOf,
    oneOfType = _react.PropTypes.oneOfType,
    element = _react.PropTypes.element,
    shape = _react.PropTypes.shape,
    string = _react.PropTypes.string;
function falsy(props, propName, componentName) {
  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}

var history = exports.history = shape({
  listen: func.isRequired,
  push: func.isRequired,
  replace: func.isRequired,
  go: func.isRequired,
  goBack: func.isRequired,
  goForward: func.isRequired
});

var component = exports.component = oneOfType([func, string]);
var components = exports.components = oneOfType([component, object]);
var route = exports.route = oneOfType([object, element]);
var routes = exports.routes = oneOfType([route, arrayOf(route)]);
},{"react":"react"}],259:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _PropTypes = require('./PropTypes');

var _ContextUtils = require('./ContextUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _React$PropTypes = _react2.default.PropTypes,
    bool = _React$PropTypes.bool,
    object = _React$PropTypes.object,
    string = _React$PropTypes.string,
    func = _React$PropTypes.func,
    oneOfType = _React$PropTypes.oneOfType;


function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
function isEmptyObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
  }return true;
}

function resolveToLocation(to, router) {
  return typeof to === 'function' ? to(router.location) : to;
}

/**
 * A <Link> is used to create an <a> element that links to a route.
 * When that route is active, the link gets the value of its
 * activeClassName prop.
 *
 * For example, assuming you have the following route:
 *
 *   <Route path="/posts/:postID" component={Post} />
 *
 * You could use the following component to link to that route:
 *
 *   <Link to={`/posts/${post.id}`} />
 *
 * Links may pass along location state and/or query string parameters
 * in the state/query props, respectively.
 *
 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
 */
var Link = _react2.default.createClass({
  displayName: 'Link',


  mixins: [(0, _ContextUtils.ContextSubscriber)('router')],

  contextTypes: {
    router: _PropTypes.routerShape
  },

  propTypes: {
    to: oneOfType([string, object, func]),
    query: object,
    hash: string,
    state: object,
    activeStyle: object,
    activeClassName: string,
    onlyActiveOnIndex: bool.isRequired,
    onClick: func,
    target: string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onlyActiveOnIndex: false,
      style: {}
    };
  },
  handleClick: function handleClick(event) {
    if (this.props.onClick) this.props.onClick(event);

    if (event.defaultPrevented) return;

    var router = this.context.router;

    !router ? "production" !== 'production' ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;

    // If target prop is set (e.g. to "_blank"), let browser handle link.
    /* istanbul ignore if: untestable with Karma */
    if (this.props.target) return;

    event.preventDefault();

    router.push(resolveToLocation(this.props.to, router));
  },
  render: function render() {
    var _props = this.props,
        to = _props.to,
        activeClassName = _props.activeClassName,
        activeStyle = _props.activeStyle,
        onlyActiveOnIndex = _props.onlyActiveOnIndex,
        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);

    // Ignore if rendered outside the context of router to simplify unit testing.


    var router = this.context.router;


    if (router) {
      // If user does not specify a `to` prop, return an empty anchor tag.
      if (to == null) {
        return _react2.default.createElement('a', props);
      }

      var toLocation = resolveToLocation(to, router);
      props.href = router.createHref(toLocation);

      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
        if (router.isActive(toLocation, onlyActiveOnIndex)) {
          if (activeClassName) {
            if (props.className) {
              props.className += ' ' + activeClassName;
            } else {
              props.className = activeClassName;
            }
          }

          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
        }
      }
    }

    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
  }
});

exports.default = Link;
module.exports = exports['default'];
},{"./ContextUtils":257,"./PropTypes":262,"invariant":296,"react":"react"}],260:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.compilePattern = compilePattern;
exports.matchPattern = matchPattern;
exports.getParamNames = getParamNames;
exports.getParams = getParams;
exports.formatPattern = formatPattern;

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function _compilePattern(pattern) {
  var regexpSource = '';
  var paramNames = [];
  var tokens = [];

  var match = void 0,
      lastIndex = 0,
      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
  while (match = matcher.exec(pattern)) {
    if (match.index !== lastIndex) {
      tokens.push(pattern.slice(lastIndex, match.index));
      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
    }

    if (match[1]) {
      regexpSource += '([^/]+)';
      paramNames.push(match[1]);
    } else if (match[0] === '**') {
      regexpSource += '(.*)';
      paramNames.push('splat');
    } else if (match[0] === '*') {
      regexpSource += '(.*?)';
      paramNames.push('splat');
    } else if (match[0] === '(') {
      regexpSource += '(?:';
    } else if (match[0] === ')') {
      regexpSource += ')?';
    }

    tokens.push(match[0]);

    lastIndex = matcher.lastIndex;
  }

  if (lastIndex !== pattern.length) {
    tokens.push(pattern.slice(lastIndex, pattern.length));
    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
  }

  return {
    pattern: pattern,
    regexpSource: regexpSource,
    paramNames: paramNames,
    tokens: tokens
  };
}

var CompiledPatternsCache = Object.create(null);

function compilePattern(pattern) {
  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);

  return CompiledPatternsCache[pattern];
}

/**
 * Attempts to match a pattern on the given pathname. Patterns may use
 * the following special characters:
 *
 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
 *                  captured string is considered a "param"
 * - ()             Wraps a segment of the URL that is optional
 * - *              Consumes (non-greedy) all characters up to the next
 *                  character in the pattern, or to the end of the URL if
 *                  there is none
 * - **             Consumes (greedy) all characters up to the next character
 *                  in the pattern, or to the end of the URL if there is none
 *
 *  The function calls callback(error, matched) when finished.
 * The return value is an object with the following properties:
 *
 * - remainingPathname
 * - paramNames
 * - paramValues
 */
function matchPattern(pattern, pathname) {
  // Ensure pattern starts with leading slash for consistency with pathname.
  if (pattern.charAt(0) !== '/') {
    pattern = '/' + pattern;
  }

  var _compilePattern2 = compilePattern(pattern),
      regexpSource = _compilePattern2.regexpSource,
      paramNames = _compilePattern2.paramNames,
      tokens = _compilePattern2.tokens;

  if (pattern.charAt(pattern.length - 1) !== '/') {
    regexpSource += '/?'; // Allow optional path separator at end.
  }

  // Special-case patterns like '*' for catch-all routes.
  if (tokens[tokens.length - 1] === '*') {
    regexpSource += '$';
  }

  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
  if (match == null) {
    return null;
  }

  var matchedPath = match[0];
  var remainingPathname = pathname.substr(matchedPath.length);

  if (remainingPathname) {
    // Require that the match ends at a path separator, if we didn't match
    // the full path, so any remaining pathname is a new path segment.
    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
      return null;
    }

    // If there is a remaining pathname, treat the path separator as part of
    // the remaining pathname for properly continuing the match.
    remainingPathname = '/' + remainingPathname;
  }

  return {
    remainingPathname: remainingPathname,
    paramNames: paramNames,
    paramValues: match.slice(1).map(function (v) {
      return v && decodeURIComponent(v);
    })
  };
}

function getParamNames(pattern) {
  return compilePattern(pattern).paramNames;
}

function getParams(pattern, pathname) {
  var match = matchPattern(pattern, pathname);
  if (!match) {
    return null;
  }

  var paramNames = match.paramNames,
      paramValues = match.paramValues;

  var params = {};

  paramNames.forEach(function (paramName, index) {
    params[paramName] = paramValues[index];
  });

  return params;
}

/**
 * Returns a version of the given pattern with params interpolated. Throws
 * if there is a dynamic segment of the pattern for which there is no param.
 */
function formatPattern(pattern, params) {
  params = params || {};

  var _compilePattern3 = compilePattern(pattern),
      tokens = _compilePattern3.tokens;

  var parenCount = 0,
      pathname = '',
      splatIndex = 0,
      parenHistory = [];

  var token = void 0,
      paramName = void 0,
      paramValue = void 0;
  for (var i = 0, len = tokens.length; i < len; ++i) {
    token = tokens[i];

    if (token === '*' || token === '**') {
      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;

      !(paramValue != null || parenCount > 0) ? "production" !== 'production' ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;

      if (paramValue != null) pathname += encodeURI(paramValue);
    } else if (token === '(') {
      parenHistory[parenCount] = '';
      parenCount += 1;
    } else if (token === ')') {
      var parenText = parenHistory.pop();
      parenCount -= 1;

      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
    } else if (token.charAt(0) === ':') {
      paramName = token.substring(1);
      paramValue = params[paramName];

      !(paramValue != null || parenCount > 0) ? "production" !== 'production' ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;

      if (paramValue == null) {
        if (parenCount) {
          parenHistory[parenCount - 1] = '';

          var curTokenIdx = tokens.indexOf(token);
          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
          var nextParenIdx = -1;

          for (var _i = 0; _i < tokensSubset.length; _i++) {
            if (tokensSubset[_i] == ')') {
              nextParenIdx = _i;
              break;
            }
          }

          !(nextParenIdx > 0) ? "production" !== 'production' ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;

          // jump to ending paren
          i = curTokenIdx + nextParenIdx - 1;
        }
      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
    } else {
      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
    }
  }

  !(parenCount <= 0) ? "production" !== 'production' ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;

  return pathname.replace(/\/+/g, '/');
}
},{"invariant":296}],261:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.isPromise = isPromise;
function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}
},{}],262:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.locationShape = exports.routerShape = undefined;

var _react = require('react');

var func = _react.PropTypes.func,
    object = _react.PropTypes.object,
    shape = _react.PropTypes.shape,
    string = _react.PropTypes.string;
var routerShape = exports.routerShape = shape({
  push: func.isRequired,
  replace: func.isRequired,
  go: func.isRequired,
  goBack: func.isRequired,
  goForward: func.isRequired,
  setRouteLeaveHook: func.isRequired,
  isActive: func.isRequired
});

var locationShape = exports.locationShape = shape({
  pathname: string.isRequired,
  search: string.isRequired,
  state: object,
  action: string.isRequired,
  key: string
});
},{"react":"react"}],263:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _RouteUtils = require('./RouteUtils');

var _InternalPropTypes = require('./InternalPropTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _React$PropTypes = _react2.default.PropTypes,
    string = _React$PropTypes.string,
    func = _React$PropTypes.func;

/**
 * A <Route> is used to declare which components are rendered to the
 * page when the URL matches a given pattern.
 *
 * Routes are arranged in a nested tree structure. When a new URL is
 * requested, the tree is searched depth-first to find a route whose
 * path matches the URL.  When one is found, all routes in the tree
 * that lead to it are considered "active" and their components are
 * rendered into the DOM, nested in the same order as in the tree.
 */
/* eslint-disable react/require-render-return */

var Route = _react2.default.createClass({
  displayName: 'Route',


  statics: {
    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
  },

  propTypes: {
    path: string,
    component: _InternalPropTypes.component,
    components: _InternalPropTypes.components,
    getComponent: func,
    getComponents: func
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
    !false ? "production" !== 'production' ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
  }
});

exports.default = Route;
module.exports = exports['default'];
},{"./InternalPropTypes":258,"./RouteUtils":264,"invariant":296,"react":"react"}],264:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.isReactChildren = isReactChildren;
exports.createRouteFromReactElement = createRouteFromReactElement;
exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
exports.createRoutes = createRoutes;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isValidChild(object) {
  return object == null || _react2.default.isValidElement(object);
}

function isReactChildren(object) {
  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
}

function createRoute(defaultProps, props) {
  return _extends({}, defaultProps, props);
}

function createRouteFromReactElement(element) {
  var type = element.type;
  var route = createRoute(type.defaultProps, element.props);

  if (route.children) {
    var childRoutes = createRoutesFromReactChildren(route.children, route);

    if (childRoutes.length) route.childRoutes = childRoutes;

    delete route.children;
  }

  return route;
}

/**
 * Creates and returns a routes object from the given ReactChildren. JSX
 * provides a convenient way to visualize how routes in the hierarchy are
 * nested.
 *
 *   import { Route, createRoutesFromReactChildren } from 'react-router'
 *
 *   const routes = createRoutesFromReactChildren(
 *     <Route component={App}>
 *       <Route path="home" component={Dashboard}/>
 *       <Route path="news" component={NewsFeed}/>
 *     </Route>
 *   )
 *
 * Note: This method is automatically used when you provide <Route> children
 * to a <Router> component.
 */
function createRoutesFromReactChildren(children, parentRoute) {
  var routes = [];

  _react2.default.Children.forEach(children, function (element) {
    if (_react2.default.isValidElement(element)) {
      // Component classes may have a static create* method.
      if (element.type.createRouteFromReactElement) {
        var route = element.type.createRouteFromReactElement(element, parentRoute);

        if (route) routes.push(route);
      } else {
        routes.push(createRouteFromReactElement(element));
      }
    }
  });

  return routes;
}

/**
 * Creates and returns an array of routes from the given object which
 * may be a JSX route, a plain object route, or an array of either.
 */
function createRoutes(routes) {
  if (isReactChildren(routes)) {
    routes = createRoutesFromReactChildren(routes);
  } else if (routes && !Array.isArray(routes)) {
    routes = [routes];
  }

  return routes;
}
},{"react":"react"}],265:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createTransitionManager2 = require('./createTransitionManager');

var _createTransitionManager3 = _interopRequireDefault(_createTransitionManager2);

var _InternalPropTypes = require('./InternalPropTypes');

var _RouterContext = require('./RouterContext');

var _RouterContext2 = _interopRequireDefault(_RouterContext);

var _RouteUtils = require('./RouteUtils');

var _RouterUtils = require('./RouterUtils');

var _routerWarning = require('./routerWarning');

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _React$PropTypes = _react2.default.PropTypes,
    func = _React$PropTypes.func,
    object = _React$PropTypes.object;

/**
 * A <Router> is a high-level API for automatically setting up
 * a router that renders a <RouterContext> with all the props
 * it needs each time the URL changes.
 */

var Router = _react2.default.createClass({
  displayName: 'Router',


  propTypes: {
    history: object,
    children: _InternalPropTypes.routes,
    routes: _InternalPropTypes.routes, // alias for children
    render: func,
    createElement: func,
    onError: func,
    onUpdate: func,

    // PRIVATE: For client-side rehydration of server match.
    matchContext: object
  },

  getDefaultProps: function getDefaultProps() {
    return {
      render: function render(props) {
        return _react2.default.createElement(_RouterContext2.default, props);
      }
    };
  },
  getInitialState: function getInitialState() {
    return {
      location: null,
      routes: null,
      params: null,
      components: null
    };
  },
  handleError: function handleError(error) {
    if (this.props.onError) {
      this.props.onError.call(this, error);
    } else {
      // Throw errors by default so we don't silently swallow them!
      throw error; // This error probably occurred in getChildRoutes or getComponents.
    }
  },
  createRouterObject: function createRouterObject(state) {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.router;
    }

    var history = this.props.history;

    return (0, _RouterUtils.createRouterObject)(history, this.transitionManager, state);
  },
  createTransitionManager: function createTransitionManager() {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.transitionManager;
    }

    var history = this.props.history;
    var _props = this.props,
        routes = _props.routes,
        children = _props.children;


    !history.getCurrentLocation ? "production" !== 'production' ? (0, _invariant2.default)(false, 'You have provided a history object created with history v2.x or ' + 'earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please upgrade to history v3.x.') : (0, _invariant2.default)(false) : void 0;

    return (0, _createTransitionManager3.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
  },
  componentWillMount: function componentWillMount() {
    var _this = this;

    this.transitionManager = this.createTransitionManager();
    this.router = this.createRouterObject(this.state);

    this._unlisten = this.transitionManager.listen(function (error, state) {
      if (error) {
        _this.handleError(error);
      } else {
        // Keep the identity of this.router because of a caveat in ContextUtils:
        // they only work if the object identity is preserved.
        (0, _RouterUtils.assignRouterState)(_this.router, state);
        _this.setState(state, _this.props.onUpdate);
      }
    });
  },


  /* istanbul ignore next: sanity check */
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    "production" !== 'production' ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;

    "production" !== 'production' ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlisten) this._unlisten();
  },
  render: function render() {
    var _state = this.state,
        location = _state.location,
        routes = _state.routes,
        params = _state.params,
        components = _state.components;

    var _props2 = this.props,
        createElement = _props2.createElement,
        render = _props2.render,
        props = _objectWithoutProperties(_props2, ['createElement', 'render']);

    if (location == null) return null; // Async match

    // Only forward non-Router-specific props to routing context, as those are
    // the only ones that might be custom routing context props.
    Object.keys(Router.propTypes).forEach(function (propType) {
      return delete props[propType];
    });

    return render(_extends({}, props, {
      router: this.router,
      location: location,
      routes: routes,
      params: params,
      components: components,
      createElement: createElement
    }));
  }
});

exports.default = Router;
module.exports = exports['default'];
},{"./InternalPropTypes":258,"./RouteUtils":264,"./RouterContext":266,"./RouterUtils":267,"./createTransitionManager":273,"./routerWarning":279,"invariant":296,"react":"react"}],266:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getRouteParams = require('./getRouteParams');

var _getRouteParams2 = _interopRequireDefault(_getRouteParams);

var _ContextUtils = require('./ContextUtils');

var _RouteUtils = require('./RouteUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _React$PropTypes = _react2.default.PropTypes,
    array = _React$PropTypes.array,
    func = _React$PropTypes.func,
    object = _React$PropTypes.object;

/**
 * A <RouterContext> renders the component tree for a given router state
 * and sets the history object and the current location in context.
 */

var RouterContext = _react2.default.createClass({
  displayName: 'RouterContext',


  mixins: [(0, _ContextUtils.ContextProvider)('router')],

  propTypes: {
    router: object.isRequired,
    location: object.isRequired,
    routes: array.isRequired,
    params: object.isRequired,
    components: array.isRequired,
    createElement: func.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      createElement: _react2.default.createElement
    };
  },


  childContextTypes: {
    router: object.isRequired
  },

  getChildContext: function getChildContext() {
    return {
      router: this.props.router
    };
  },
  createElement: function createElement(component, props) {
    return component == null ? null : this.props.createElement(component, props);
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        location = _props.location,
        routes = _props.routes,
        params = _props.params,
        components = _props.components,
        router = _props.router;

    var element = null;

    if (components) {
      element = components.reduceRight(function (element, components, index) {
        if (components == null) return element; // Don't create new children; use the grandchildren.

        var route = routes[index];
        var routeParams = (0, _getRouteParams2.default)(route, params);
        var props = {
          location: location,
          params: params,
          route: route,
          router: router,
          routeParams: routeParams,
          routes: routes
        };

        if ((0, _RouteUtils.isReactChildren)(element)) {
          props.children = element;
        } else if (element) {
          for (var prop in element) {
            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
          }
        }

        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
          var elements = {};

          for (var key in components) {
            if (Object.prototype.hasOwnProperty.call(components, key)) {
              // Pass through the key as a prop to createElement to allow
              // custom createElement functions to know which named component
              // they're rendering, for e.g. matching up to fetched data.
              elements[key] = _this.createElement(components[key], _extends({
                key: key }, props));
            }
          }

          return elements;
        }

        return _this.createElement(components, props);
      }, element);
    }

    !(element === null || element === false || _react2.default.isValidElement(element)) ? "production" !== 'production' ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;

    return element;
  }
});

exports.default = RouterContext;
module.exports = exports['default'];
},{"./ContextUtils":257,"./RouteUtils":264,"./getRouteParams":275,"invariant":296,"react":"react"}],267:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.createRouterObject = createRouterObject;
exports.assignRouterState = assignRouterState;
function createRouterObject(history, transitionManager, state) {
  var router = _extends({}, history, {
    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
    isActive: transitionManager.isActive
  });

  return assignRouterState(router, state);
}

function assignRouterState(router, _ref) {
  var location = _ref.location,
      params = _ref.params,
      routes = _ref.routes;

  router.location = location;
  router.params = params;
  router.routes = routes;

  return router;
}
},{}],268:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.runEnterHooks = runEnterHooks;
exports.runChangeHooks = runChangeHooks;
exports.runLeaveHooks = runLeaveHooks;

var _AsyncUtils = require('./AsyncUtils');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PendingHooks = function PendingHooks() {
  var _this = this;

  _classCallCheck(this, PendingHooks);

  this.hooks = [];

  this.add = function (hook) {
    return _this.hooks.push(hook);
  };

  this.remove = function (hook) {
    return _this.hooks = _this.hooks.filter(function (h) {
      return h !== hook;
    });
  };

  this.has = function (hook) {
    return _this.hooks.indexOf(hook) !== -1;
  };

  this.clear = function () {
    return _this.hooks = [];
  };
};

var enterHooks = new PendingHooks();
var changeHooks = new PendingHooks();

function createTransitionHook(hook, route, asyncArity, pendingHooks) {
  var isSync = hook.length < asyncArity;

  var transitionHook = function transitionHook() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    hook.apply(route, args);

    if (isSync) {
      var callback = args[args.length - 1];
      // Assume hook executes synchronously and
      // automatically call the callback.
      callback();
    }
  };

  pendingHooks.add(transitionHook);

  return transitionHook;
}

function getEnterHooks(routes) {
  return routes.reduce(function (hooks, route) {
    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
    return hooks;
  }, []);
}

function getChangeHooks(routes) {
  return routes.reduce(function (hooks, route) {
    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
    return hooks;
  }, []);
}

function runTransitionHooks(length, iter, callback) {
  if (!length) {
    callback();
    return;
  }

  var redirectInfo = void 0;
  function replace(location) {
    redirectInfo = location;
  }

  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
    iter(index, replace, function (error) {
      if (error || redirectInfo) {
        done(error, redirectInfo); // No need to continue.
      } else {
        next();
      }
    });
  }, callback);
}

/**
 * Runs all onEnter hooks in the given array of routes in order
 * with onEnter(nextState, replace, callback) and calls
 * callback(error, redirectInfo) when finished. The first hook
 * to use replace short-circuits the loop.
 *
 * If a hook needs to run asynchronously, it may use the callback
 * function. However, doing so will cause the transition to pause,
 * which could lead to a non-responsive UI if the hook is slow.
 */
function runEnterHooks(routes, nextState, callback) {
  enterHooks.clear();
  var hooks = getEnterHooks(routes);
  return runTransitionHooks(hooks.length, function (index, replace, next) {
    var wrappedNext = function wrappedNext() {
      if (enterHooks.has(hooks[index])) {
        next();
        enterHooks.remove(hooks[index]);
      }
    };
    hooks[index](nextState, replace, wrappedNext);
  }, callback);
}

/**
 * Runs all onChange hooks in the given array of routes in order
 * with onChange(prevState, nextState, replace, callback) and calls
 * callback(error, redirectInfo) when finished. The first hook
 * to use replace short-circuits the loop.
 *
 * If a hook needs to run asynchronously, it may use the callback
 * function. However, doing so will cause the transition to pause,
 * which could lead to a non-responsive UI if the hook is slow.
 */
function runChangeHooks(routes, state, nextState, callback) {
  changeHooks.clear();
  var hooks = getChangeHooks(routes);
  return runTransitionHooks(hooks.length, function (index, replace, next) {
    var wrappedNext = function wrappedNext() {
      if (changeHooks.has(hooks[index])) {
        next();
        changeHooks.remove(hooks[index]);
      }
    };
    hooks[index](state, nextState, replace, wrappedNext);
  }, callback);
}

/**
 * Runs all onLeave hooks in the given array of routes in order.
 */
function runLeaveHooks(routes, prevState) {
  for (var i = 0, len = routes.length; i < len; ++i) {
    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
  }
}
},{"./AsyncUtils":256}],269:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _createBrowserHistory = require('history/lib/createBrowserHistory');

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

var _createRouterHistory = require('./createRouterHistory');

var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
module.exports = exports['default'];
},{"./createRouterHistory":272,"history/lib/createBrowserHistory":290}],270:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _PatternUtils = require('./PatternUtils');

function routeParamsChanged(route, prevState, nextState) {
  if (!route.path) return false;

  var paramNames = (0, _PatternUtils.getParamNames)(route.path);

  return paramNames.some(function (paramName) {
    return prevState.params[paramName] !== nextState.params[paramName];
  });
}

/**
 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
 * the change from prevState to nextState. We leave routes if either
 * 1) they are not in the next state or 2) they are in the next state
 * but their params have changed (i.e. /users/123 => /users/456).
 *
 * leaveRoutes are ordered starting at the leaf route of the tree
 * we're leaving up to the common parent route. enterRoutes are ordered
 * from the top of the tree we're entering down to the leaf route.
 *
 * changeRoutes are any routes that didn't leave or enter during
 * the transition.
 */
function computeChangedRoutes(prevState, nextState) {
  var prevRoutes = prevState && prevState.routes;
  var nextRoutes = nextState.routes;

  var leaveRoutes = void 0,
      changeRoutes = void 0,
      enterRoutes = void 0;
  if (prevRoutes) {
    (function () {
      var parentIsLeaving = false;
      leaveRoutes = prevRoutes.filter(function (route) {
        if (parentIsLeaving) {
          return true;
        } else {
          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
          if (isLeaving) parentIsLeaving = true;
          return isLeaving;
        }
      });

      // onLeave hooks start at the leaf route.
      leaveRoutes.reverse();

      enterRoutes = [];
      changeRoutes = [];

      nextRoutes.forEach(function (route) {
        var isNew = prevRoutes.indexOf(route) === -1;
        var paramsChanged = leaveRoutes.indexOf(route) !== -1;

        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
      });
    })();
  } else {
    leaveRoutes = [];
    changeRoutes = [];
    enterRoutes = nextRoutes;
  }

  return {
    leaveRoutes: leaveRoutes,
    changeRoutes: changeRoutes,
    enterRoutes: enterRoutes
  };
}

exports.default = computeChangedRoutes;
module.exports = exports['default'];
},{"./PatternUtils":260}],271:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.default = createMemoryHistory;

var _useQueries = require('history/lib/useQueries');

var _useQueries2 = _interopRequireDefault(_useQueries);

var _useBasename = require('history/lib/useBasename');

var _useBasename2 = _interopRequireDefault(_useBasename);

var _createMemoryHistory = require('history/lib/createMemoryHistory');

var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createMemoryHistory(options) {
  // signatures and type checking differ between `useQueries` and
  // `createMemoryHistory`, have to create `memoryHistory` first because
  // `useQueries` doesn't understand the signature
  var memoryHistory = (0, _createMemoryHistory2.default)(options);
  var createHistory = function createHistory() {
    return memoryHistory;
  };
  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
  return history;
}
module.exports = exports['default'];
},{"history/lib/createMemoryHistory":292,"history/lib/useBasename":294,"history/lib/useQueries":295}],272:[function(require,module,exports){
'use strict';

exports.__esModule = true;

exports.default = function (createHistory) {
  var history = void 0;
  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
  return history;
};

var _useRouterHistory = require('./useRouterHistory');

var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

module.exports = exports['default'];
},{"./useRouterHistory":280}],273:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createTransitionManager;

var _routerWarning = require('./routerWarning');

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _computeChangedRoutes2 = require('./computeChangedRoutes');

var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);

var _TransitionUtils = require('./TransitionUtils');

var _isActive2 = require('./isActive');

var _isActive3 = _interopRequireDefault(_isActive2);

var _getComponents = require('./getComponents');

var _getComponents2 = _interopRequireDefault(_getComponents);

var _matchRoutes = require('./matchRoutes');

var _matchRoutes2 = _interopRequireDefault(_matchRoutes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hasAnyProperties(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
  }return false;
}

function createTransitionManager(history, routes) {
  var state = {};

  // Signature should be (location, indexOnly), but needs to support (path,
  // query, indexOnly)
  function isActive(location, indexOnly) {
    location = history.createLocation(location);

    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
  }

  var partialNextState = void 0;

  function match(location, callback) {
    if (partialNextState && partialNextState.location === location) {
      // Continue from where we left off.
      finishMatch(partialNextState, callback);
    } else {
      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
        if (error) {
          callback(error);
        } else if (nextState) {
          finishMatch(_extends({}, nextState, { location: location }), callback);
        } else {
          callback();
        }
      });
    }
  }

  function finishMatch(nextState, callback) {
    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
        leaveRoutes = _computeChangedRoutes.leaveRoutes,
        changeRoutes = _computeChangedRoutes.changeRoutes,
        enterRoutes = _computeChangedRoutes.enterRoutes;

    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);

    // Tear down confirmation hooks for left routes
    leaveRoutes.filter(function (route) {
      return enterRoutes.indexOf(route) === -1;
    }).forEach(removeListenBeforeHooksForRoute);

    // change and enter hooks are run in series
    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
    });

    function finishEnterHooks(error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      // TODO: Fetch components after state is updated.
      (0, _getComponents2.default)(nextState, function (error, components) {
        if (error) {
          callback(error);
        } else {
          // TODO: Make match a pure function and have some other API
          // for "match and update state".
          callback(null, null, state = _extends({}, nextState, { components: components }));
        }
      });
    }

    function handleErrorOrRedirect(error, redirectInfo) {
      if (error) callback(error);else callback(null, redirectInfo);
    }
  }

  var RouteGuid = 1;

  function getRouteID(route) {
    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return route.__id__ || create && (route.__id__ = RouteGuid++);
  }

  var RouteHooks = Object.create(null);

  function getRouteHooksForRoutes(routes) {
    return routes.map(function (route) {
      return RouteHooks[getRouteID(route)];
    }).filter(function (hook) {
      return hook;
    });
  }

  function transitionHook(location, callback) {
    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
      if (nextState == null) {
        // TODO: We didn't actually match anything, but hang
        // onto error/nextState so we don't have to matchRoutes
        // again in the listen callback.
        callback();
        return;
      }

      // Cache some state here so we don't have to
      // matchRoutes() again in the listen callback.
      partialNextState = _extends({}, nextState, { location: location });

      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);

      var result = void 0;
      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
        // Passing the location arg here indicates to
        // the user that this is a transition hook.
        result = hooks[i](location);
      }

      callback(result);
    });
  }

  /* istanbul ignore next: untestable with Karma */
  function beforeUnloadHook() {
    // Synchronously check to see if any route hooks want
    // to prevent the current window/tab from closing.
    if (state.routes) {
      var hooks = getRouteHooksForRoutes(state.routes);

      var message = void 0;
      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
        // Passing no args indicates to the user that this is a
        // beforeunload hook. We don't know the next location.
        message = hooks[i]();
      }

      return message;
    }
  }

  var unlistenBefore = void 0,
      unlistenBeforeUnload = void 0;

  function removeListenBeforeHooksForRoute(route) {
    var routeID = getRouteID(route);
    if (!routeID) {
      return;
    }

    delete RouteHooks[routeID];

    if (!hasAnyProperties(RouteHooks)) {
      // teardown transition & beforeunload hooks
      if (unlistenBefore) {
        unlistenBefore();
        unlistenBefore = null;
      }

      if (unlistenBeforeUnload) {
        unlistenBeforeUnload();
        unlistenBeforeUnload = null;
      }
    }
  }

  /**
   * Registers the given hook function to run before leaving the given route.
   *
   * During a normal transition, the hook function receives the next location
   * as its only argument and can return either a prompt message (string) to show the user,
   * to make sure they want to leave the page; or `false`, to prevent the transition.
   * Any other return value will have no effect.
   *
   * During the beforeunload event (in browsers) the hook receives no arguments.
   * In this case it must return a prompt message to prevent the transition.
   *
   * Returns a function that may be used to unbind the listener.
   */
  function listenBeforeLeavingRoute(route, hook) {
    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
    var routeID = getRouteID(route, true);

    RouteHooks[routeID] = hook;

    if (thereWereNoRouteHooks) {
      // setup transition & beforeunload hooks
      unlistenBefore = history.listenBefore(transitionHook);

      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
    }

    return function () {
      removeListenBeforeHooksForRoute(route);
    };
  }

  /**
   * This is the API for stateful environments. As the location
   * changes, we update state and call the listener. We can also
   * gracefully handle errors and redirects.
   */
  function listen(listener) {
    function historyListener(location) {
      if (state.location === location) {
        listener(null, state);
      } else {
        match(location, function (error, redirectLocation, nextState) {
          if (error) {
            listener(error);
          } else if (redirectLocation) {
            history.replace(redirectLocation);
          } else if (nextState) {
            listener(null, nextState);
          } else {
            "production" !== 'production' ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
          }
        });
      }
    }

    // TODO: Only use a single history listener. Otherwise we'll end up with
    // multiple concurrent calls to match.

    // Set up the history listener first in case the initial match redirects.
    var unsubscribe = history.listen(historyListener);

    if (state.location) {
      // Picking up on a matchContext.
      listener(null, state);
    } else {
      historyListener(history.getCurrentLocation());
    }

    return unsubscribe;
  }

  return {
    isActive: isActive,
    match: match,
    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
    listen: listen
  };
}
module.exports = exports['default'];
},{"./TransitionUtils":268,"./computeChangedRoutes":270,"./getComponents":274,"./isActive":276,"./matchRoutes":278,"./routerWarning":279}],274:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _AsyncUtils = require('./AsyncUtils');

var _PromiseUtils = require('./PromiseUtils');

function getComponentsForRoute(nextState, route, callback) {
  if (route.component || route.components) {
    callback(null, route.component || route.components);
    return;
  }

  var getComponent = route.getComponent || route.getComponents;
  if (getComponent) {
    var componentReturn = getComponent.call(route, nextState, callback);
    if ((0, _PromiseUtils.isPromise)(componentReturn)) componentReturn.then(function (component) {
      return callback(null, component);
    }, callback);
  } else {
    callback();
  }
}

/**
 * Asynchronously fetches all components needed for the given router
 * state and calls callback(error, components) when finished.
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getComponents method.
 */
function getComponents(nextState, callback) {
  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
    getComponentsForRoute(nextState, route, callback);
  }, callback);
}

exports.default = getComponents;
module.exports = exports['default'];
},{"./AsyncUtils":256,"./PromiseUtils":261}],275:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _PatternUtils = require('./PatternUtils');

/**
 * Extracts an object of params the given route cares about from
 * the given params object.
 */
function getRouteParams(route, params) {
  var routeParams = {};

  if (!route.path) return routeParams;

  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
    if (Object.prototype.hasOwnProperty.call(params, p)) {
      routeParams[p] = params[p];
    }
  });

  return routeParams;
}

exports.default = getRouteParams;
module.exports = exports['default'];
},{"./PatternUtils":260}],276:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isActive;

var _PatternUtils = require('./PatternUtils');

function deepEqual(a, b) {
  if (a == b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return deepEqual(item, b[index]);
    });
  }

  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
    for (var p in a) {
      if (!Object.prototype.hasOwnProperty.call(a, p)) {
        continue;
      }

      if (a[p] === undefined) {
        if (b[p] !== undefined) {
          return false;
        }
      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
        return false;
      } else if (!deepEqual(a[p], b[p])) {
        return false;
      }
    }

    return true;
  }

  return String(a) === String(b);
}

/**
 * Returns true if the current pathname matches the supplied one, net of
 * leading and trailing slash normalization. This is sufficient for an
 * indexOnly route match.
 */
function pathIsActive(pathname, currentPathname) {
  // Normalize leading slash for consistency. Leading slash on pathname has
  // already been normalized in isActive. See caveat there.
  if (currentPathname.charAt(0) !== '/') {
    currentPathname = '/' + currentPathname;
  }

  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
  // `/foo` as active, but in this case, we would already have failed the
  // match.
  if (pathname.charAt(pathname.length - 1) !== '/') {
    pathname += '/';
  }
  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
    currentPathname += '/';
  }

  return currentPathname === pathname;
}

/**
 * Returns true if the given pathname matches the active routes and params.
 */
function routeIsActive(pathname, routes, params) {
  var remainingPathname = pathname,
      paramNames = [],
      paramValues = [];

  // for...of would work here but it's probably slower post-transpilation.
  for (var i = 0, len = routes.length; i < len; ++i) {
    var route = routes[i];
    var pattern = route.path || '';

    if (pattern.charAt(0) === '/') {
      remainingPathname = pathname;
      paramNames = [];
      paramValues = [];
    }

    if (remainingPathname !== null && pattern) {
      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }

      if (remainingPathname === '') {
        // We have an exact match on the route. Just check that all the params
        // match.
        // FIXME: This doesn't work on repeated params.
        return paramNames.every(function (paramName, index) {
          return String(paramValues[index]) === String(params[paramName]);
        });
      }
    }
  }

  return false;
}

/**
 * Returns true if all key/value pairs in the given query are
 * currently active.
 */
function queryIsActive(query, activeQuery) {
  if (activeQuery == null) return query == null;

  if (query == null) return true;

  return deepEqual(query, activeQuery);
}

/**
 * Returns true if a <Link> to the given pathname/query combination is
 * currently active.
 */
function isActive(_ref, indexOnly, currentLocation, routes, params) {
  var pathname = _ref.pathname,
      query = _ref.query;

  if (currentLocation == null) return false;

  // TODO: This is a bit ugly. It keeps around support for treating pathnames
  // without preceding slashes as absolute paths, but possibly also works
  // around the same quirks with basenames as in matchRoutes.
  if (pathname.charAt(0) !== '/') {
    pathname = '/' + pathname;
  }

  if (!pathIsActive(pathname, currentLocation.pathname)) {
    // The path check is necessary and sufficient for indexOnly, but otherwise
    // we still need to check the routes.
    if (indexOnly || !routeIsActive(pathname, routes, params)) {
      return false;
    }
  }

  return queryIsActive(query, currentLocation.query);
}
module.exports = exports['default'];
},{"./PatternUtils":260}],277:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Actions = require('history/lib/Actions');

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _createMemoryHistory = require('./createMemoryHistory');

var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);

var _createTransitionManager = require('./createTransitionManager');

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _RouteUtils = require('./RouteUtils');

var _RouterUtils = require('./RouterUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * A high-level API to be used for server-side rendering.
 *
 * This function matches a location to a set of routes and calls
 * callback(error, redirectLocation, renderProps) when finished.
 *
 * Note: You probably don't want to use this in a browser unless you're using
 * server-side rendering with async routes.
 */
function match(_ref, callback) {
  var history = _ref.history,
      routes = _ref.routes,
      location = _ref.location,
      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);

  !(history || location) ? "production" !== 'production' ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;

  history = history ? history : (0, _createMemoryHistory2.default)(options);
  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));

  if (location) {
    // Allow match({ location: '/the/path', ... })
    location = history.createLocation(location);
  } else {
    location = history.getCurrentLocation();
  }

  transitionManager.match(location, function (error, redirectLocation, nextState) {
    var renderProps = void 0;

    if (nextState) {
      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager, nextState);
      renderProps = _extends({}, nextState, {
        router: router,
        matchContext: { transitionManager: transitionManager, router: router }
      });
    }

    callback(error, redirectLocation && history.createLocation(redirectLocation, _Actions.REPLACE), renderProps);
  });
}

exports.default = match;
module.exports = exports['default'];
},{"./RouteUtils":264,"./RouterUtils":267,"./createMemoryHistory":271,"./createTransitionManager":273,"history/lib/Actions":281,"invariant":296}],278:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = matchRoutes;

var _AsyncUtils = require('./AsyncUtils');

var _PromiseUtils = require('./PromiseUtils');

var _PatternUtils = require('./PatternUtils');

var _routerWarning = require('./routerWarning');

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _RouteUtils = require('./RouteUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getChildRoutes(route, location, paramNames, paramValues, callback) {
  if (route.childRoutes) {
    return [null, route.childRoutes];
  }
  if (!route.getChildRoutes) {
    return [];
  }

  var sync = true,
      result = void 0;

  var partialNextState = {
    location: location,
    params: createParams(paramNames, paramValues)
  };

  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
    if (sync) {
      result = [error, childRoutes];
      return;
    }

    callback(error, childRoutes);
  });

  if ((0, _PromiseUtils.isPromise)(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
    return callback(null, (0, _RouteUtils.createRoutes)(childRoutes));
  }, callback);

  sync = false;
  return result; // Might be undefined.
}

function getIndexRoute(route, location, paramNames, paramValues, callback) {
  if (route.indexRoute) {
    callback(null, route.indexRoute);
  } else if (route.getIndexRoute) {
    var partialNextState = {
      location: location,
      params: createParams(paramNames, paramValues)
    };

    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
    });

    if ((0, _PromiseUtils.isPromise)(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
      return callback(null, (0, _RouteUtils.createRoutes)(indexRoute)[0]);
    }, callback);
  } else if (route.childRoutes) {
    (function () {
      var pathless = route.childRoutes.filter(function (childRoute) {
        return !childRoute.path;
      });

      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
          if (error || indexRoute) {
            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
            done(error, routes);
          } else {
            next();
          }
        });
      }, function (err, routes) {
        callback(null, routes);
      });
    })();
  } else {
    callback();
  }
}

function assignParams(params, paramNames, paramValues) {
  return paramNames.reduce(function (params, paramName, index) {
    var paramValue = paramValues && paramValues[index];

    if (Array.isArray(params[paramName])) {
      params[paramName].push(paramValue);
    } else if (paramName in params) {
      params[paramName] = [params[paramName], paramValue];
    } else {
      params[paramName] = paramValue;
    }

    return params;
  }, params);
}

function createParams(paramNames, paramValues) {
  return assignParams({}, paramNames, paramValues);
}

function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
  var pattern = route.path || '';

  if (pattern.charAt(0) === '/') {
    remainingPathname = location.pathname;
    paramNames = [];
    paramValues = [];
  }

  // Only try to match the path if the route actually has a pattern, and if
  // we're not just searching for potential nested absolute paths.
  if (remainingPathname !== null && pattern) {
    try {
      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }
    } catch (error) {
      callback(error);
    }

    // By assumption, pattern is non-empty here, which is the prerequisite for
    // actually terminating a match.
    if (remainingPathname === '') {
      var _ret2 = function () {
        var match = {
          routes: [route],
          params: createParams(paramNames, paramValues)
        };

        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
          if (error) {
            callback(error);
          } else {
            if (Array.isArray(indexRoute)) {
              var _match$routes;

              "production" !== 'production' ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
                return !route.path;
              }), 'Index routes should not have paths') : void 0;
              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
            } else if (indexRoute) {
              "production" !== 'production' ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
              match.routes.push(indexRoute);
            }

            callback(null, match);
          }
        });

        return {
          v: void 0
        };
      }();

      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
    }
  }

  if (remainingPathname != null || route.childRoutes) {
    // Either a) this route matched at least some of the path or b)
    // we don't have to load this route's children asynchronously. In
    // either case continue checking for matches in the subtree.
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
      } else if (childRoutes) {
        // Check the child routes to see if any of them match.
        matchRoutes(childRoutes, location, function (error, match) {
          if (error) {
            callback(error);
          } else if (match) {
            // A child route matched! Augment the match and pass it up the stack.
            match.routes.unshift(route);
            callback(null, match);
          } else {
            callback();
          }
        }, remainingPathname, paramNames, paramValues);
      } else {
        callback();
      }
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

/**
 * Asynchronously matches the given location to a set of routes and calls
 * callback(error, state) when finished. The state object will have the
 * following properties:
 *
 * - routes       An array of routes that matched, in hierarchical order
 * - params       An object of URL parameters
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getChildRoutes method.
 */
function matchRoutes(routes, location, callback, remainingPathname) {
  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

  if (remainingPathname === undefined) {
    // TODO: This is a little bit ugly, but it works around a quirk in history
    // that strips the leading slash from pathnames when using basenames with
    // trailing slashes.
    if (location.pathname.charAt(0) !== '/') {
      location = _extends({}, location, {
        pathname: '/' + location.pathname
      });
    }
    remainingPathname = location.pathname;
  }

  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
      if (error || match) {
        done(error, match);
      } else {
        next();
      }
    });
  }, callback);
}
module.exports = exports['default'];
},{"./AsyncUtils":256,"./PatternUtils":260,"./PromiseUtils":261,"./RouteUtils":264,"./routerWarning":279}],279:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.default = routerWarning;
exports._resetWarned = _resetWarned;

var _warning = require('warning');

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var warned = {};

function routerWarning(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }

    warned[message] = true;
  }

  message = '[react-router] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
}

function _resetWarned() {
  warned = {};
}
},{"warning":299}],280:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.default = useRouterHistory;

var _useQueries = require('history/lib/useQueries');

var _useQueries2 = _interopRequireDefault(_useQueries);

var _useBasename = require('history/lib/useBasename');

var _useBasename2 = _interopRequireDefault(_useBasename);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useRouterHistory(createHistory) {
  return function (options) {
    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
    return history;
  };
}
module.exports = exports['default'];
},{"history/lib/useBasename":294,"history/lib/useQueries":295}],281:[function(require,module,exports){
'use strict';

exports.__esModule = true;
/**
 * Indicates that navigation was caused by a call to history.push.
 */
var PUSH = exports.PUSH = 'PUSH';

/**
 * Indicates that navigation was caused by a call to history.replace.
 */
var REPLACE = exports.REPLACE = 'REPLACE';

/**
 * Indicates that navigation was caused by some other action such
 * as using a browser's back/forward buttons and/or manually manipulating
 * the URL in a browser's location bar. This is the default.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
 * for more information.
 */
var POP = exports.POP = 'POP';
},{}],282:[function(require,module,exports){
"use strict";

exports.__esModule = true;
var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var isSync = false,
      hasNext = false,
      doneArgs = void 0;

  var done = function done() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    isDone = true;

    if (isSync) {
      // Iterate instead of recursing if possible.
      doneArgs = args;
      return;
    }

    callback.apply(undefined, args);
  };

  var next = function next() {
    if (isDone) return;

    hasNext = true;

    if (isSync) return; // Iterate instead of recursing if possible.

    isSync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work(currentTurn++, next, done);
    }

    isSync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(undefined, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  };

  next();
};
},{}],283:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;

var _LocationUtils = require('./LocationUtils');

var _DOMUtils = require('./DOMUtils');

var _DOMStateStorage = require('./DOMStateStorage');

var _PathUtils = require('./PathUtils');

var _ExecutionEnvironment = require('./ExecutionEnvironment');

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();

var _createLocation = function _createLocation(historyState) {
  var key = historyState && historyState.key;

  return (0, _LocationUtils.createLocation)({
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
  }, undefined, key);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  var historyState = void 0;
  try {
    historyState = window.history.state || {};
  } catch (error) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    historyState = {};
  }

  return _createLocation(historyState);
};

var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

var startListener = exports.startListener = function startListener(listener) {
  var handlePopState = function handlePopState(event) {
    if (event.state !== undefined) // Ignore extraneous popstate events in WebKit
      listener(_createLocation(event.state));
  };

  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
    return listener(getCurrentLocation());
  };

  if (needsHashchangeListener) {
    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
  }

  return function () {
    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

    if (needsHashchangeListener) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
    }
  };
};

var updateLocation = function updateLocation(location, updateState) {
  var state = location.state;
  var key = location.key;


  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);

  updateState({ key: key }, (0, _PathUtils.createPath)(location));
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.pushState(state, null, path);
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.replaceState(state, null, path);
  });
};

var go = exports.go = function go(n) {
  if (n) window.history.go(n);
};
},{"./DOMStateStorage":284,"./DOMUtils":285,"./ExecutionEnvironment":286,"./LocationUtils":287,"./PathUtils":288}],284:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.readState = exports.saveState = undefined;

var _warning = require('warning');

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuotaExceededErrors = {
  QuotaExceededError: true,
  QUOTA_EXCEEDED_ERR: true
};

var SecurityErrors = {
  SecurityError: true
};

var KeyPrefix = '@@History/';

var createKey = function createKey(key) {
  return KeyPrefix + key;
};

var saveState = exports.saveState = function saveState(key, state) {
  if (!window.sessionStorage) {
    // Session storage is not available or hidden.
    // sessionStorage is undefined in Internet Explorer when served via file protocol.
    "production" !== 'production' ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;

    return;
  }

  try {
    if (state == null) {
      window.sessionStorage.removeItem(createKey(key));
    } else {
      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
    }
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
      "production" !== 'production' ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;

      return;
    }

    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
      // Safari "private mode" throws QuotaExceededError.
      "production" !== 'production' ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;

      return;
    }

    throw error;
  }
};

var readState = exports.readState = function readState(key) {
  var json = void 0;
  try {
    json = window.sessionStorage.getItem(createKey(key));
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
      "production" !== 'production' ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;

      return undefined;
    }
  }

  if (json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      // Ignore invalid JSON.
    }
  }

  return undefined;
};
},{"warning":299}],285:[function(require,module,exports){
'use strict';

exports.__esModule = true;
var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};
},{}],286:[function(require,module,exports){
'use strict';

exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
},{}],287:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _warning = require('warning');

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = require('./PathUtils');

var _Actions = require('./Actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createQuery = exports.createQuery = function createQuery(props) {
  return _extends(Object.create(null), props);
};

var createLocation = exports.createLocation = function createLocation() {
  var input = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;

  "production" !== 'production' ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;

  var pathname = object.pathname || '/';
  var search = object.search || '';
  var hash = object.hash || '';
  var state = object.state;

  return {
    pathname: pathname,
    search: search,
    hash: hash,
    state: state,
    action: action,
    key: key
  };
};

var isDate = function isDate(object) {
  return Object.prototype.toString.call(object) === '[object Date]';
};

var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
  if (a === b) return true;

  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (typeofA !== typeofB) return false;

  !(typeofA !== 'function') ? "production" !== 'production' ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;

  // Not the same object, but same type.
  if (typeofA === 'object') {
    !!(isDate(a) && isDate(b)) ? "production" !== 'production' ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;

    if (!Array.isArray(a)) {
      var keysofA = Object.keys(a);
      var keysofB = Object.keys(b);
      return keysofA.length === keysofB.length && keysofA.every(function (key) {
        return statesAreEqual(a[key], b[key]);
      });
    }

    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return statesAreEqual(item, b[index]);
    });
  }

  // All other serializable types (string, number, boolean)
  // should be strict equal.
  return false;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.key === b.key &&
  // a.action === b.action && // Different action !== location change.
  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
};
},{"./Actions":281,"./PathUtils":288,"invariant":296,"warning":299}],288:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;

var _warning = require('warning');

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
  var _parsePath = parsePath(path);

  var pathname = _parsePath.pathname;
  var search = _parsePath.search;
  var hash = _parsePath.hash;


  return createPath({
    pathname: pathname,
    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
    hash: hash
  });
};

var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
  var _parsePath2 = parsePath(path);

  var pathname = _parsePath2.pathname;
  var search = _parsePath2.search;
  var hash = _parsePath2.hash;


  return createPath({
    pathname: pathname,
    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
      return prefix === '?' ? prefix : suffix;
    }),
    hash: hash
  });
};

var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
  var _parsePath3 = parsePath(path);

  var search = _parsePath3.search;

  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
  return match && match[1];
};

var extractPath = function extractPath(string) {
  var match = string.match(/^(https?:)?\/\/[^\/]*/);
  return match == null ? string : string.substring(match[0].length);
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = extractPath(path);
  var search = '';
  var hash = '';

  "production" !== 'production' ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substring(hashIndex);
    pathname = pathname.substring(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substring(searchIndex);
    pathname = pathname.substring(0, searchIndex);
  }

  if (pathname === '') pathname = '/';

  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  if (location == null || typeof location === 'string') return location;

  var basename = location.basename;
  var pathname = location.pathname;
  var search = location.search;
  var hash = location.hash;

  var path = (basename || '') + pathname;

  if (search && search !== '?') path += search;

  if (hash) path += hash;

  return path;
};
},{"warning":299}],289:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = require('./BrowserProtocol');

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _LocationUtils = require('./LocationUtils');

var _PathUtils = require('./PathUtils');

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  return (0, _LocationUtils.createLocation)(window.location);
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  window.location.href = (0, _PathUtils.createPath)(location);
  return false; // Don't update location
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  window.location.replace((0, _PathUtils.createPath)(location));
  return false; // Don't update location
};
},{"./BrowserProtocol":283,"./LocationUtils":287,"./PathUtils":288}],290:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = require('./ExecutionEnvironment');

var _BrowserProtocol = require('./BrowserProtocol');

var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);

var _RefreshProtocol = require('./RefreshProtocol');

var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);

var _DOMUtils = require('./DOMUtils');

var _createHistory = require('./createHistory');

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates and returns a history object that uses HTML5's history API
 * (pushState, replaceState, and the popstate event) to manage history.
 * This is the recommended method of managing history in browsers because
 * it provides the cleanest URLs.
 *
 * Note: In browsers that do not support the HTML5 history API full
 * page reloads will be used to preserve clean URLs. You can force this
 * behavior using { forceRefresh: true } in options.
 */
var createBrowserHistory = function createBrowserHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  !_ExecutionEnvironment.canUseDOM ? "production" !== 'production' ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;

  var getUserConfirmation = Protocol.getUserConfirmation;
  var getCurrentLocation = Protocol.getCurrentLocation;
  var pushLocation = Protocol.pushLocation;
  var replaceLocation = Protocol.replaceLocation;
  var go = Protocol.go;


  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen
  });
};

exports.default = createBrowserHistory;
},{"./BrowserProtocol":283,"./DOMUtils":285,"./ExecutionEnvironment":286,"./RefreshProtocol":289,"./createHistory":291,"invariant":296}],291:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _AsyncUtils = require('./AsyncUtils');

var _PathUtils = require('./PathUtils');

var _runTransitionHook = require('./runTransitionHook');

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _Actions = require('./Actions');

var _LocationUtils = require('./LocationUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createHistory = function createHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
  var getCurrentLocation = options.getCurrentLocation;
  var getUserConfirmation = options.getUserConfirmation;
  var pushLocation = options.pushLocation;
  var replaceLocation = options.replaceLocation;
  var go = options.go;
  var keyLength = options.keyLength;


  var currentLocation = void 0;
  var pendingLocation = void 0;
  var beforeListeners = [];
  var listeners = [];
  var allKeys = [];

  var getCurrentIndex = function getCurrentIndex() {
    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);

    if (currentLocation) return allKeys.indexOf(currentLocation.key);

    return -1;
  };

  var updateLocation = function updateLocation(nextLocation) {
    var currentIndex = getCurrentIndex();

    currentLocation = nextLocation;

    if (currentLocation.action === _Actions.PUSH) {
      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
    } else if (currentLocation.action === _Actions.REPLACE) {
      allKeys[currentIndex] = currentLocation.key;
    }

    listeners.forEach(function (listener) {
      return listener(currentLocation);
    });
  };

  var listenBefore = function listenBefore(listener) {
    beforeListeners.push(listener);

    return function () {
      return beforeListeners = beforeListeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var listen = function listen(listener) {
    listeners.push(listener);

    return function () {
      return listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
        return result != null ? done(result) : next();
      });
    }, function (message) {
      if (getUserConfirmation && typeof message === 'string') {
        getUserConfirmation(message, function (ok) {
          return callback(ok !== false);
        });
      } else {
        callback(message !== false);
      }
    });
  };

  var transitionTo = function transitionTo(nextLocation) {
    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do

    pendingLocation = nextLocation;

    confirmTransitionTo(nextLocation, function (ok) {
      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation

      pendingLocation = null;

      if (ok) {
        // Treat PUSH to same path like REPLACE to be consistent with browsers
        if (nextLocation.action === _Actions.PUSH) {
          var prevPath = (0, _PathUtils.createPath)(currentLocation);
          var nextPath = (0, _PathUtils.createPath)(nextLocation);

          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
        }

        if (nextLocation.action === _Actions.POP) {
          updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.PUSH) {
          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.REPLACE) {
          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
        }
      } else if (currentLocation && nextLocation.action === _Actions.POP) {
        var prevIndex = allKeys.indexOf(currentLocation.key);
        var nextIndex = allKeys.indexOf(nextLocation.key);

        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
      }
    });
  };

  var push = function push(input) {
    return transitionTo(createLocation(input, _Actions.PUSH));
  };

  var replace = function replace(input) {
    return transitionTo(createLocation(input, _Actions.REPLACE));
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength || 6);
  };

  var createHref = function createHref(location) {
    return (0, _PathUtils.createPath)(location);
  };

  var createLocation = function createLocation(location, action) {
    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
    return (0, _LocationUtils.createLocation)(location, action, key);
  };

  return {
    getCurrentLocation: getCurrentLocation,
    listenBefore: listenBefore,
    listen: listen,
    transitionTo: transitionTo,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    createKey: createKey,
    createPath: _PathUtils.createPath,
    createHref: createHref,
    createLocation: createLocation
  };
};

exports.default = createHistory;
},{"./Actions":281,"./AsyncUtils":282,"./LocationUtils":287,"./PathUtils":288,"./runTransitionHook":293}],292:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = require('warning');

var _warning2 = _interopRequireDefault(_warning);

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = require('./LocationUtils');

var _PathUtils = require('./PathUtils');

var _createHistory = require('./createHistory');

var _createHistory2 = _interopRequireDefault(_createHistory);

var _Actions = require('./Actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createStateStorage = function createStateStorage(entries) {
  return entries.filter(function (entry) {
    return entry.state;
  }).reduce(function (memo, entry) {
    memo[entry.key] = entry.state;
    return memo;
  }, {});
};

var createMemoryHistory = function createMemoryHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  if (Array.isArray(options)) {
    options = { entries: options };
  } else if (typeof options === 'string') {
    options = { entries: [options] };
  }

  var getCurrentLocation = function getCurrentLocation() {
    var entry = entries[current];
    var path = (0, _PathUtils.createPath)(entry);

    var key = void 0,
        state = void 0;
    if (entry.key) {
      key = entry.key;
      state = readState(key);
    }

    var init = (0, _PathUtils.parsePath)(path);

    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
  };

  var canGo = function canGo(n) {
    var index = current + n;
    return index >= 0 && index < entries.length;
  };

  var go = function go(n) {
    if (!n) return;

    if (!canGo(n)) {
      "production" !== 'production' ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;

      return;
    }

    current += n;
    var currentLocation = getCurrentLocation();

    // Change action to POP
    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
  };

  var pushLocation = function pushLocation(location) {
    current += 1;

    if (current < entries.length) entries.splice(current);

    entries.push(location);

    saveState(location.key, location.state);
  };

  var replaceLocation = function replaceLocation(location) {
    entries[current] = location;
    saveState(location.key, location.state);
  };

  var history = (0, _createHistory2.default)(_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var _options = options;
  var entries = _options.entries;
  var current = _options.current;


  if (typeof entries === 'string') {
    entries = [entries];
  } else if (!Array.isArray(entries)) {
    entries = ['/'];
  }

  entries = entries.map(function (entry) {
    return (0, _LocationUtils.createLocation)(entry);
  });

  if (current == null) {
    current = entries.length - 1;
  } else {
    !(current >= 0 && current < entries.length) ? "production" !== 'production' ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
  }

  var storage = createStateStorage(entries);

  var saveState = function saveState(key, state) {
    return storage[key] = state;
  };

  var readState = function readState(key) {
    return storage[key];
  };

  return _extends({}, history, {
    canGo: canGo
  });
};

exports.default = createMemoryHistory;
},{"./Actions":281,"./LocationUtils":287,"./PathUtils":288,"./createHistory":291,"invariant":296,"warning":299}],293:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _warning = require('warning');

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var runTransitionHook = function runTransitionHook(hook, location, callback) {
  var result = hook(location, callback);

  if (hook.length < 2) {
    // Assume the hook runs synchronously and automatically
    // call the callback with the return value.
    callback(result);
  } else {
    "production" !== 'production' ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
  }
};

exports.default = runTransitionHook;
},{"warning":299}],294:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _runTransitionHook = require('./runTransitionHook');

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _PathUtils = require('./PathUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useBasename = function useBasename(createHistory) {
  return function () {
    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var history = createHistory(options);
    var basename = options.basename;


    var addBasename = function addBasename(location) {
      if (!location) return location;

      if (basename && location.basename == null) {
        if (location.pathname.indexOf(basename) === 0) {
          location.pathname = location.pathname.substring(basename.length);
          location.basename = basename;

          if (location.pathname === '') location.pathname = '/';
        } else {
          location.basename = '';
        }
      }

      return location;
    };

    var prependBasename = function prependBasename(location) {
      if (!basename) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var pname = object.pathname;
      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
      var pathname = normalizedBasename + normalizedPathname;

      return _extends({}, object, {
        pathname: pathname
      });
    };

    // Override all read methods with basename-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return addBasename(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(addBasename(location));
      });
    };

    // Override all write methods with basename-aware versions.
    var push = function push(location) {
      return history.push(prependBasename(location));
    };

    var replace = function replace(location) {
      return history.replace(prependBasename(location));
    };

    var createPath = function createPath(location) {
      return history.createPath(prependBasename(location));
    };

    var createHref = function createHref(location) {
      return history.createHref(prependBasename(location));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useBasename;
},{"./PathUtils":288,"./runTransitionHook":293}],295:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _queryString = require('query-string');

var _runTransitionHook = require('./runTransitionHook');

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _LocationUtils = require('./LocationUtils');

var _PathUtils = require('./PathUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStringifyQuery = function defaultStringifyQuery(query) {
  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
};

var defaultParseQueryString = _queryString.parse;

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know how to handle URL queries.
 */
var useQueries = function useQueries(createHistory) {
  return function () {
    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var history = createHistory(options);
    var stringifyQuery = options.stringifyQuery;
    var parseQueryString = options.parseQueryString;


    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;

    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;

    var decodeQuery = function decodeQuery(location) {
      if (!location) return location;

      if (location.query == null) location.query = parseQueryString(location.search.substring(1));

      return location;
    };

    var encodeQuery = function encodeQuery(location, query) {
      if (query == null) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var queryString = stringifyQuery(query);
      var search = queryString ? '?' + queryString : '';

      return _extends({}, object, {
        search: search
      });
    };

    // Override all read methods with query-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return decodeQuery(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(decodeQuery(location));
      });
    };

    // Override all write methods with query-aware versions.
    var push = function push(location) {
      return history.push(encodeQuery(location, location.query));
    };

    var replace = function replace(location) {
      return history.replace(encodeQuery(location, location.query));
    };

    var createPath = function createPath(location) {
      return history.createPath(encodeQuery(location, location.query));
    };

    var createHref = function createHref(location) {
      return history.createHref(encodeQuery(location, location.query));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));

      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);

      return decodeQuery(newLocation);
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useQueries;
},{"./LocationUtils":287,"./PathUtils":288,"./runTransitionHook":293,"query-string":297}],296:[function(require,module,exports){
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use strict';

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if ("production" !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;

},{}],297:[function(require,module,exports){
'use strict';
var strictUriEncode = require('strict-uri-encode');
var objectAssign = require('object-assign');

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};

},{"object-assign":"object-assign","strict-uri-encode":298}],298:[function(require,module,exports){
'use strict';
module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};

},{}],299:[function(require,module,exports){
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

'use strict';

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if ("production" !== 'production') {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;

},{}],300:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule AutoFocusUtils
 * @typechecks static-only
 */

'use strict';

var ReactMount = require('./ReactMount');

var findDOMNode = require('./findDOMNode');
var focusNode = require('fbjs/lib/focusNode');

var Mixin = {
  componentDidMount: function () {
    if (this.props.autoFocus) {
      focusNode(findDOMNode(this));
    }
  }
};

var AutoFocusUtils = {
  Mixin: Mixin,

  focusDOMComponent: function () {
    focusNode(ReactMount.getNode(this._rootNodeID));
  }
};

module.exports = AutoFocusUtils;
},{"./ReactMount":364,"./findDOMNode":407,"fbjs/lib/focusNode":437}],301:[function(require,module,exports){
/**
 * Copyright 2013-2015 Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule BeforeInputEventPlugin
 * @typechecks static-only
 */

'use strict';

var EventConstants = require('./EventConstants');
var EventPropagators = require('./EventPropagators');
var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
var FallbackCompositionState = require('./FallbackCompositionState');
var SyntheticCompositionEvent = require('./SyntheticCompositionEvent');
var SyntheticInputEvent = require('./SyntheticInputEvent');

var keyOf = require('fbjs/lib/keyOf');

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

var topLevelTypes = EventConstants.topLevelTypes;

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onBeforeInput: null }),
      captured: keyOf({ onBeforeInputCapture: null })
    },
    dependencies: [topLevelTypes.topCompositionEnd, topLevelTypes.topKeyPress, topLevelTypes.topTextInput, topLevelTypes.topPaste]
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onCompositionEnd: null }),
      captured: keyOf({ onCompositionEndCapture: null })
    },
    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionEnd, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onCompositionStart: null }),
      captured: keyOf({ onCompositionStartCapture: null })
    },
    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionStart, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onCompositionUpdate: null }),
      captured: keyOf({ onCompositionUpdateCapture: null })
    },
    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionUpdate, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case topLevelTypes.topCompositionStart:
      return eventTypes.compositionStart;
    case topLevelTypes.topCompositionEnd:
      return eventTypes.compositionEnd;
    case topLevelTypes.topCompositionUpdate:
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === topLevelTypes.topKeyDown && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case topLevelTypes.topKeyUp:
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case topLevelTypes.topKeyDown:
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case topLevelTypes.topKeyPress:
    case topLevelTypes.topMouseDown:
    case topLevelTypes.topBlur:
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {DOMEventTarget} topLevelTarget The listening component root node.
 * @param {string} topLevelTargetID ID of `topLevelTarget`.
 * @param {object} nativeEvent Native browser event.
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(topLevelTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, topLevelTargetID, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case topLevelTypes.topCompositionEnd:
      return getDataFromCustomEvent(nativeEvent);
    case topLevelTypes.topKeyPress:
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case topLevelTypes.topTextInput:
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  if (currentComposition) {
    if (topLevelType === topLevelTypes.topCompositionEnd || isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case topLevelTypes.topPaste:
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case topLevelTypes.topKeyPress:
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case topLevelTypes.topCompositionEnd:
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {DOMEventTarget} topLevelTarget The listening component root node.
 * @param {string} topLevelTargetID ID of `topLevelTarget`.
 * @param {object} nativeEvent Native browser event.
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, topLevelTargetID, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {

  eventTypes: eventTypes,

  /**
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {DOMEventTarget} topLevelTarget The listening component root node.
   * @param {string} topLevelTargetID ID of `topLevelTarget`.
   * @param {object} nativeEvent Native browser event.
   * @return {*} An accumulation of synthetic events.
   * @see {EventPluginHub.extractEvents}
   */
  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;
},{"./EventConstants":313,"./EventPropagators":317,"./FallbackCompositionState":318,"./SyntheticCompositionEvent":389,"./SyntheticInputEvent":393,"fbjs/lib/ExecutionEnvironment":429,"fbjs/lib/keyOf":447}],302:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule CSSProperty
 */

'use strict';

/**
 * CSS properties which accept numbers but are not in units of "px".
 */
var isUnitlessNumber = {
  animationIterationCount: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  stopOpacity: true,
  strokeDashoffset: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;
},{}],303:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule CSSPropertyOperations
 * @typechecks static-only
 */

'use strict';

var CSSProperty = require('./CSSProperty');
var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
var ReactPerf = require('./ReactPerf');

var camelizeStyleName = require('fbjs/lib/camelizeStyleName');
var dangerousStyleValue = require('./dangerousStyleValue');
var hyphenateStyleName = require('fbjs/lib/hyphenateStyleName');
var memoizeStringOnly = require('fbjs/lib/memoizeStringOnly');
var warning = require('fbjs/lib/warning');

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if ("production" !== 'production') {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};

  var warnHyphenatedStyleName = function (name) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    "production" !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?', name, camelizeStyleName(name)) : undefined;
  };

  var warnBadVendoredStyleName = function (name) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    "production" !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1)) : undefined;
  };

  var warnStyleValueWithSemicolon = function (name, value) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    "production" !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon. ' + 'Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, '')) : undefined;
  };

  /**
   * @param {string} name
   * @param {*} value
   */
  var warnValidStyle = function (name, value) {
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {

  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @return {?string}
   */
  createMarkupForStyles: function (styles) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var styleValue = styles[styleName];
      if ("production" !== 'production') {
        warnValidStyle(styleName, styleValue);
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   */
  setValueForStyles: function (node, styles) {
    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      if ("production" !== 'production') {
        warnValidStyle(styleName, styles[styleName]);
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName]);
      if (styleName === 'float') {
        styleName = styleFloatAccessor;
      }
      if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }

};

ReactPerf.measureMethods(CSSPropertyOperations, 'CSSPropertyOperations', {
  setValueForStyles: 'setValueForStyles'
});

module.exports = CSSPropertyOperations;
},{"./CSSProperty":302,"./ReactPerf":370,"./dangerousStyleValue":404,"fbjs/lib/ExecutionEnvironment":429,"fbjs/lib/camelizeStyleName":431,"fbjs/lib/hyphenateStyleName":442,"fbjs/lib/memoizeStringOnly":449,"fbjs/lib/warning":454}],304:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule CallbackQueue
 */

'use strict';

var PooledClass = require('./PooledClass');

var assign = require('./Object.assign');
var invariant = require('fbjs/lib/invariant');

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */
function CallbackQueue() {
  this._callbacks = null;
  this._contexts = null;
}

assign(CallbackQueue.prototype, {

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */
  enqueue: function (callback, context) {
    this._callbacks = this._callbacks || [];
    this._contexts = this._contexts || [];
    this._callbacks.push(callback);
    this._contexts.push(context);
  },

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */
  notifyAll: function () {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    if (callbacks) {
      !(callbacks.length === contexts.length) ? "production" !== 'production' ? invariant(false, 'Mismatched list of contexts in callback queue') : invariant(false) : undefined;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i]);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  },

  /**
   * Resets the internal queue.
   *
   * @internal
   */
  reset: function () {
    this._callbacks = null;
    this._contexts = null;
  },

  /**
   * `PooledClass` looks for this.
   */
  destructor: function () {
    this.reset();
  }

});

PooledClass.addPoolingTo(CallbackQueue);

module.exports = CallbackQueue;
},{"./Object.assign":321,"./PooledClass":322,"fbjs/lib/invariant":443}],305:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ChangeEventPlugin
 */

'use strict';

var EventConstants = require('./EventConstants');
var EventPluginHub = require('./EventPluginHub');
var EventPropagators = require('./EventPropagators');
var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
var ReactUpdates = require('./ReactUpdates');
var SyntheticEvent = require('./SyntheticEvent');

var getEventTarget = require('./getEventTarget');
var isEventSupported = require('./isEventSupported');
var isTextInputElement = require('./isTextInputElement');
var keyOf = require('fbjs/lib/keyOf');

var topLevelTypes = EventConstants.topLevelTypes;

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onChange: null }),
      captured: keyOf({ onChangeCapture: null })
    },
    dependencies: [topLevelTypes.topBlur, topLevelTypes.topChange, topLevelTypes.topClick, topLevelTypes.topFocus, topLevelTypes.topInput, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topSelectionChange]
  }
};

/**
 * For IE shims
 */
var activeElement = null;
var activeElementID = null;
var activeElementValue = null;
var activeElementValueProp = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!('documentMode' in document) || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementID, nativeEvent, getEventTarget(nativeEvent));
  EventPropagators.accumulateTwoPhaseDispatches(event);

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetID) {
  activeElement = target;
  activeElementID = targetID;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementID = null;
}

function getTargetIDForChangeEvent(topLevelType, topLevelTarget, topLevelTargetID) {
  if (topLevelType === topLevelTypes.topChange) {
    return topLevelTargetID;
  }
}
function handleEventsForChangeEventIE8(topLevelType, topLevelTarget, topLevelTargetID) {
  if (topLevelType === topLevelTypes.topFocus) {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(topLevelTarget, topLevelTargetID);
  } else if (topLevelType === topLevelTypes.topBlur) {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events
  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
}

/**
 * (For old IE.) Replacement getter/setter for the `value` property that gets
 * set on the active element.
 */
var newValueProp = {
  get: function () {
    return activeElementValueProp.get.call(this);
  },
  set: function (val) {
    // Cast to a string so we can do equality checks.
    activeElementValue = '' + val;
    activeElementValueProp.set.call(this, val);
  }
};

/**
 * (For old IE.) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetID) {
  activeElement = target;
  activeElementID = targetID;
  activeElementValue = target.value;
  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');

  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
  // on DOM elements
  Object.defineProperty(activeElement, 'value', newValueProp);
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}

/**
 * (For old IE.) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }

  // delete restores the original property definition
  delete activeElement.value;
  activeElement.detachEvent('onpropertychange', handlePropertyChange);

  activeElement = null;
  activeElementID = null;
  activeElementValue = null;
  activeElementValueProp = null;
}

/**
 * (For old IE.) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  var value = nativeEvent.srcElement.value;
  if (value === activeElementValue) {
    return;
  }
  activeElementValue = value;

  manualDispatchChangeEvent(nativeEvent);
}

/**
 * If a `change` event should be fired, returns the target's ID.
 */
function getTargetIDForInputEvent(topLevelType, topLevelTarget, topLevelTargetID) {
  if (topLevelType === topLevelTypes.topInput) {
    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
    // what we want so fall through here and trigger an abstract event
    return topLevelTargetID;
  }
}

// For IE8 and IE9.
function handleEventsForInputEventIE(topLevelType, topLevelTarget, topLevelTargetID) {
  if (topLevelType === topLevelTypes.topFocus) {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(topLevelTarget, topLevelTargetID);
  } else if (topLevelType === topLevelTypes.topBlur) {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetIDForInputEventIE(topLevelType, topLevelTarget, topLevelTargetID) {
  if (topLevelType === topLevelTypes.topSelectionChange || topLevelType === topLevelTypes.topKeyUp || topLevelType === topLevelTypes.topKeyDown) {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    if (activeElement && activeElement.value !== activeElementValue) {
      activeElementValue = activeElement.value;
      return activeElementID;
    }
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetIDForClickEvent(topLevelType, topLevelTarget, topLevelTargetID) {
  if (topLevelType === topLevelTypes.topClick) {
    return topLevelTargetID;
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {

  eventTypes: eventTypes,

  /**
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {DOMEventTarget} topLevelTarget The listening component root node.
   * @param {string} topLevelTargetID ID of `topLevelTarget`.
   * @param {object} nativeEvent Native browser event.
   * @return {*} An accumulation of synthetic events.
   * @see {EventPluginHub.extractEvents}
   */
  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {

    var getTargetIDFunc, handleEventFunc;
    if (shouldUseChangeEvent(topLevelTarget)) {
      if (doesChangeEventBubble) {
        getTargetIDFunc = getTargetIDForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(topLevelTarget)) {
      if (isInputEventSupported) {
        getTargetIDFunc = getTargetIDForInputEvent;
      } else {
        getTargetIDFunc = getTargetIDForInputEventIE;
        handleEventFunc = handleEventsForInputEventIE;
      }
    } else if (shouldUseClickEvent(topLevelTarget)) {
      getTargetIDFunc = getTargetIDForClickEvent;
    }

    if (getTargetIDFunc) {
      var targetID = getTargetIDFunc(topLevelType, topLevelTarget, topLevelTargetID);
      if (targetID) {
        var event = SyntheticEvent.getPooled(eventTypes.change, targetID, nativeEvent, nativeEventTarget);
        event.type = 'change';
        EventPropagators.accumulateTwoPhaseDispatches(event);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, topLevelTarget, topLevelTargetID);
    }
  }

};

module.exports = ChangeEventPlugin;
},{"./EventConstants":313,"./EventPluginHub":314,"./EventPropagators":317,"./ReactUpdates":382,"./SyntheticEvent":391,"./getEventTarget":413,"./isEventSupported":418,"./isTextInputElement":419,"fbjs/lib/ExecutionEnvironment":429,"fbjs/lib/keyOf":447}],306:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ClientReactRootIndex
 * @typechecks
 */

'use strict';

var nextReactRootIndex = 0;

var ClientReactRootIndex = {
  createReactRootIndex: function () {
    return nextReactRootIndex++;
  }
};

module.exports = ClientReactRootIndex;
},{}],307:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DOMChildrenOperations
 * @typechecks static-only
 */

'use strict';

var Danger = require('./Danger');
var ReactMultiChildUpdateTypes = require('./ReactMultiChildUpdateTypes');
var ReactPerf = require('./ReactPerf');

var setInnerHTML = require('./setInnerHTML');
var setTextContent = require('./setTextContent');
var invariant = require('fbjs/lib/invariant');

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
function insertChildAt(parentNode, childNode, index) {
  // By exploiting arrays returning `undefined` for an undefined index, we can
  // rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. However, using `undefined` is not allowed by all
  // browsers so we must replace it with `null`.

  // fix render order error in safari
  // IE8 will throw error when index out of list size.
  var beforeChild = index >= parentNode.childNodes.length ? null : parentNode.childNodes.item(index);

  parentNode.insertBefore(childNode, beforeChild);
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {

  dangerouslyReplaceNodeWithMarkup: Danger.dangerouslyReplaceNodeWithMarkup,

  updateTextContent: setTextContent,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @param {array<string>} markupList List of markup strings.
   * @internal
   */
  processUpdates: function (updates, markupList) {
    var update;
    // Mapping from parent IDs to initial child orderings.
    var initialChildren = null;
    // List of children that will be moved or removed.
    var updatedChildren = null;

    for (var i = 0; i < updates.length; i++) {
      update = updates[i];
      if (update.type === ReactMultiChildUpdateTypes.MOVE_EXISTING || update.type === ReactMultiChildUpdateTypes.REMOVE_NODE) {
        var updatedIndex = update.fromIndex;
        var updatedChild = update.parentNode.childNodes[updatedIndex];
        var parentID = update.parentID;

        !updatedChild ? "production" !== 'production' ? invariant(false, 'processUpdates(): Unable to find child %s of element. This ' + 'probably means the DOM was unexpectedly mutated (e.g., by the ' + 'browser), usually due to forgetting a <tbody> when using tables, ' + 'nesting tags like <form>, <p>, or <a>, or using non-SVG elements ' + 'in an <svg> parent. Try inspecting the child nodes of the element ' + 'with React ID `%s`.', updatedIndex, parentID) : invariant(false) : undefined;

        initialChildren = initialChildren || {};
        initialChildren[parentID] = initialChildren[parentID] || [];
        initialChildren[parentID][updatedIndex] = updatedChild;

        updatedChildren = updatedChildren || [];
        updatedChildren.push(updatedChild);
      }
    }

    var renderedMarkup;
    // markupList is either a list of markup or just a list of elements
    if (markupList.length && typeof markupList[0] === 'string') {
      renderedMarkup = Danger.dangerouslyRenderMarkup(markupList);
    } else {
      renderedMarkup = markupList;
    }

    // Remove updated children first so that `toIndex` is consistent.
    if (updatedChildren) {
      for (var j = 0; j < updatedChildren.length; j++) {
        updatedChildren[j].parentNode.removeChild(updatedChildren[j]);
      }
    }

    for (var k = 0; k < updates.length; k++) {
      update = updates[k];
      switch (update.type) {
        case ReactMultiChildUpdateTypes.INSERT_MARKUP:
          insertChildAt(update.parentNode, renderedMarkup[update.markupIndex], update.toIndex);
          break;
        case ReactMultiChildUpdateTypes.MOVE_EXISTING:
          insertChildAt(update.parentNode, initialChildren[update.parentID][update.fromIndex], update.toIndex);
          break;
        case ReactMultiChildUpdateTypes.SET_MARKUP:
          setInnerHTML(update.parentNode, update.content);
          break;
        case ReactMultiChildUpdateTypes.TEXT_CONTENT:
          setTextContent(update.parentNode, update.content);
          break;
        case ReactMultiChildUpdateTypes.REMOVE_NODE:
          // Already removed by the for-loop above.
          break;
      }
    }
  }

};

ReactPerf.measureMethods(DOMChildrenOperations, 'DOMChildrenOperations', {
  updateTextContent: 'updateTextContent'
});

module.exports = DOMChildrenOperations;
},{"./Danger":310,"./ReactMultiChildUpdateTypes":366,"./ReactPerf":370,"./setInnerHTML":423,"./setTextContent":424,"fbjs/lib/invariant":443}],308:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DOMProperty
 * @typechecks static-only
 */

'use strict';

var invariant = require('fbjs/lib/invariant');

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_ATTRIBUTE: 0x1,
  MUST_USE_PROPERTY: 0x2,
  HAS_SIDE_EFFECTS: 0x4,
  HAS_BOOLEAN_VALUE: 0x8,
  HAS_NUMERIC_VALUE: 0x10,
  HAS_POSITIVE_NUMERIC_VALUE: 0x20 | 0x10,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x40,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ? "production" !== 'production' ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property ' + '\'%s\' which has already been injected. You may be accidentally ' + 'injecting the same DOM property config twice, or you may be ' + 'injecting two configs that have conflicting property names.', propName) : invariant(false) : undefined;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseAttribute: checkMask(propConfig, Injection.MUST_USE_ATTRIBUTE),
        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasSideEffects: checkMask(propConfig, Injection.HAS_SIDE_EFFECTS),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };

      !(!propertyInfo.mustUseAttribute || !propertyInfo.mustUseProperty) ? "production" !== 'production' ? invariant(false, 'DOMProperty: Cannot require using both attribute and property: %s', propName) : invariant(false) : undefined;
      !(propertyInfo.mustUseProperty || !propertyInfo.hasSideEffects) ? "production" !== 'production' ? invariant(false, 'DOMProperty: Properties that have side effects must use property: %s', propName) : invariant(false) : undefined;
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ? "production" !== 'production' ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or ' + 'numeric value, but not a combination: %s', propName) : invariant(false) : undefined;

      if ("production" !== 'production') {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if ("production" !== 'production') {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};
var defaultValueCache = {};

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {

  ID_ATTRIBUTE_NAME: 'data-reactid',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseAttribute:
   *   Whether the property must be accessed and mutated using `*Attribute()`.
   *   (This includes anything that fails `<propName> in <element>`.)
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasSideEffects:
   *   Whether or not setting a value causes side effects such as triggering
   *   resources to be loaded or text selection changes. If true, we read from
   *   the DOM before updating to ensure that the value is only set if it has
   *   changed.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   * @type {Object}
   */
  getPossibleStandardName: "production" !== 'production' ? {} : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  /**
   * Returns the default property value for a DOM property (i.e., not an
   * attribute). Most default values are '' or false, but not all. Worse yet,
   * some (in particular, `type`) vary depending on the type of element.
   *
   * TODO: Is it better to grab all the possible properties when creating an
   * element to avoid having to create the same element twice?
   */
  getDefaultValueForProperty: function (nodeName, prop) {
    var nodeDefaults = defaultValueCache[nodeName];
    var testElement;
    if (!nodeDefaults) {
      defaultValueCache[nodeName] = nodeDefaults = {};
    }
    if (!(prop in nodeDefaults)) {
      testElement = document.createElement(nodeName);
      nodeDefaults[prop] = testElement[prop];
    }
    return nodeDefaults[prop];
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;
},{"fbjs/lib/invariant":443}],309:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DOMPropertyOperations
 * @typechecks static-only
 */

'use strict';

var DOMProperty = require('./DOMProperty');
var ReactPerf = require('./ReactPerf');

var quoteAttributeValueForBrowser = require('./quoteAttributeValueForBrowser');
var warning = require('fbjs/lib/warning');

// Simplified subset
var VALID_ATTRIBUTE_NAME_REGEX = /^[a-zA-Z_][\w\.\-]*$/;
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
  "production" !== 'production' ? warning(false, 'Invalid attribute name: `%s`', attributeName) : undefined;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

if ("production" !== 'production') {
  var reactProps = {
    children: true,
    dangerouslySetInnerHTML: true,
    key: true,
    ref: true
  };
  var warnedProperties = {};

  var warnUnknownProperty = function (name) {
    if (reactProps.hasOwnProperty(name) && reactProps[name] || warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
      return;
    }

    warnedProperties[name] = true;
    var lowerCasedName = name.toLowerCase();

    // data-* attributes should be lowercase; suggest the lowercase version
    var standardName = DOMProperty.isCustomAttribute(lowerCasedName) ? lowerCasedName : DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ? DOMProperty.getPossibleStandardName[lowerCasedName] : null;

    // For now, only warn when we have a suggested correction. This prevents
    // logging too much when using transferPropsTo.
    "production" !== 'production' ? warning(standardName == null, 'Unknown DOM property %s. Did you mean %s?', name, standardName) : undefined;
  };
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {

  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    } else if ("production" !== 'production') {
      warnUnknownProperty(name);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
      } else if (propertyInfo.mustUseAttribute) {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      } else {
        var propName = propertyInfo.propertyName;
        // Must explicitly cast values for HAS_SIDE_EFFECTS-properties to the
        // property type before comparing; only `value` does and is string.
        if (!propertyInfo.hasSideEffects || '' + node[propName] !== '' + value) {
          // Contrary to `setAttribute`, object properties are properly
          // `toString`ed by IE8/9.
          node[propName] = value;
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
    } else if ("production" !== 'production') {
      warnUnknownProperty(name);
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseAttribute) {
        node.removeAttribute(propertyInfo.attributeName);
      } else {
        var propName = propertyInfo.propertyName;
        var defaultValue = DOMProperty.getDefaultValueForProperty(node.nodeName, propName);
        if (!propertyInfo.hasSideEffects || '' + node[propName] !== defaultValue) {
          node[propName] = defaultValue;
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    } else if ("production" !== 'production') {
      warnUnknownProperty(name);
    }
  }

};

ReactPerf.measureMethods(DOMPropertyOperations, 'DOMPropertyOperations', {
  setValueForProperty: 'setValueForProperty',
  setValueForAttribute: 'setValueForAttribute',
  deleteValueForProperty: 'deleteValueForProperty'
});

module.exports = DOMPropertyOperations;
},{"./DOMProperty":308,"./ReactPerf":370,"./quoteAttributeValueForBrowser":421,"fbjs/lib/warning":454}],310:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Danger
 * @typechecks static-only
 */

'use strict';

var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');

var createNodesFromMarkup = require('fbjs/lib/createNodesFromMarkup');
var emptyFunction = require('fbjs/lib/emptyFunction');
var getMarkupWrap = require('fbjs/lib/getMarkupWrap');
var invariant = require('fbjs/lib/invariant');

var OPEN_TAG_NAME_EXP = /^(<[^ \/>]+)/;
var RESULT_INDEX_ATTR = 'data-danger-index';

/**
 * Extracts the `nodeName` from a string of markup.
 *
 * NOTE: Extracting the `nodeName` does not require a regular expression match
 * because we make assumptions about React-generated markup (i.e. there are no
 * spaces surrounding the opening tag and there is at least one attribute).
 *
 * @param {string} markup String of markup.
 * @return {string} Node name of the supplied markup.
 * @see http://jsperf.com/extract-nodename
 */
function getNodeName(markup) {
  return markup.substring(1, markup.indexOf(' '));
}

var Danger = {

  /**
   * Renders markup into an array of nodes. The markup is expected to render
   * into a list of root nodes. Also, the length of `resultList` and
   * `markupList` should be the same.
   *
   * @param {array<string>} markupList List of markup strings to render.
   * @return {array<DOMElement>} List of rendered nodes.
   * @internal
   */
  dangerouslyRenderMarkup: function (markupList) {
    !ExecutionEnvironment.canUseDOM ? "production" !== 'production' ? invariant(false, 'dangerouslyRenderMarkup(...): Cannot render markup in a worker ' + 'thread. Make sure `window` and `document` are available globally ' + 'before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString for server rendering.') : invariant(false) : undefined;
    var nodeName;
    var markupByNodeName = {};
    // Group markup by `nodeName` if a wrap is necessary, else by '*'.
    for (var i = 0; i < markupList.length; i++) {
      !markupList[i] ? "production" !== 'production' ? invariant(false, 'dangerouslyRenderMarkup(...): Missing markup.') : invariant(false) : undefined;
      nodeName = getNodeName(markupList[i]);
      nodeName = getMarkupWrap(nodeName) ? nodeName : '*';
      markupByNodeName[nodeName] = markupByNodeName[nodeName] || [];
      markupByNodeName[nodeName][i] = markupList[i];
    }
    var resultList = [];
    var resultListAssignmentCount = 0;
    for (nodeName in markupByNodeName) {
      if (!markupByNodeName.hasOwnProperty(nodeName)) {
        continue;
      }
      var markupListByNodeName = markupByNodeName[nodeName];

      // This for-in loop skips the holes of the sparse array. The order of
      // iteration should follow the order of assignment, which happens to match
      // numerical index order, but we don't rely on that.
      var resultIndex;
      for (resultIndex in markupListByNodeName) {
        if (markupListByNodeName.hasOwnProperty(resultIndex)) {
          var markup = markupListByNodeName[resultIndex];

          // Push the requested markup with an additional RESULT_INDEX_ATTR
          // attribute.  If the markup does not start with a < character, it
          // will be discarded below (with an appropriate console.error).
          markupListByNodeName[resultIndex] = markup.replace(OPEN_TAG_NAME_EXP,
          // This index will be parsed back out below.
          '$1 ' + RESULT_INDEX_ATTR + '="' + resultIndex + '" ');
        }
      }

      // Render each group of markup with similar wrapping `nodeName`.
      var renderNodes = createNodesFromMarkup(markupListByNodeName.join(''), emptyFunction // Do nothing special with <script> tags.
      );

      for (var j = 0; j < renderNodes.length; ++j) {
        var renderNode = renderNodes[j];
        if (renderNode.hasAttribute && renderNode.hasAttribute(RESULT_INDEX_ATTR)) {

          resultIndex = +renderNode.getAttribute(RESULT_INDEX_ATTR);
          renderNode.removeAttribute(RESULT_INDEX_ATTR);

          !!resultList.hasOwnProperty(resultIndex) ? "production" !== 'production' ? invariant(false, 'Danger: Assigning to an already-occupied result index.') : invariant(false) : undefined;

          resultList[resultIndex] = renderNode;

          // This should match resultList.length and markupList.length when
          // we're done.
          resultListAssignmentCount += 1;
        } else if ("production" !== 'production') {
          console.error('Danger: Discarding unexpected node:', renderNode);
        }
      }
    }

    // Although resultList was populated out of order, it should now be a dense
    // array.
    !(resultListAssignmentCount === resultList.length) ? "production" !== 'production' ? invariant(false, 'Danger: Did not assign to every index of resultList.') : invariant(false) : undefined;

    !(resultList.length === markupList.length) ? "production" !== 'production' ? invariant(false, 'Danger: Expected markup to render %s nodes, but rendered %s.', markupList.length, resultList.length) : invariant(false) : undefined;

    return resultList;
  },

  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ? "production" !== 'production' ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a ' + 'worker thread. Make sure `window` and `document` are available ' + 'globally before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString() for server rendering.') : invariant(false) : undefined;
    !markup ? "production" !== 'production' ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : invariant(false) : undefined;
    !(oldChild.tagName.toLowerCase() !== 'html') ? "production" !== 'production' ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the ' + '<html> node. This is because browser quirks make this unreliable ' + 'and/or slow. If you want to render to the root you must use ' + 'server rendering. See ReactDOMServer.renderToString().') : invariant(false) : undefined;

    var newChild;
    if (typeof markup === 'string') {
      newChild = createNodesFromMarkup(markup, emptyFunction)[0];
    } else {
      newChild = markup;
    }
    oldChild.parentNode.replaceChild(newChild, oldChild);
  }

};

module.exports = Danger;
},{"fbjs/lib/ExecutionEnvironment":429,"fbjs/lib/createNodesFromMarkup":434,"fbjs/lib/emptyFunction":435,"fbjs/lib/getMarkupWrap":439,"fbjs/lib/invariant":443}],311:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DefaultEventPluginOrder
 */

'use strict';

var keyOf = require('fbjs/lib/keyOf');

/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */
var DefaultEventPluginOrder = [keyOf({ ResponderEventPlugin: null }), keyOf({ SimpleEventPlugin: null }), keyOf({ TapEventPlugin: null }), keyOf({ EnterLeaveEventPlugin: null }), keyOf({ ChangeEventPlugin: null }), keyOf({ SelectEventPlugin: null }), keyOf({ BeforeInputEventPlugin: null })];

module.exports = DefaultEventPluginOrder;
},{"fbjs/lib/keyOf":447}],312:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EnterLeaveEventPlugin
 * @typechecks static-only
 */

'use strict';

var EventConstants = require('./EventConstants');
var EventPropagators = require('./EventPropagators');
var SyntheticMouseEvent = require('./SyntheticMouseEvent');

var ReactMount = require('./ReactMount');
var keyOf = require('fbjs/lib/keyOf');

var topLevelTypes = EventConstants.topLevelTypes;
var getFirstReactDOM = ReactMount.getFirstReactDOM;

var eventTypes = {
  mouseEnter: {
    registrationName: keyOf({ onMouseEnter: null }),
    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
  },
  mouseLeave: {
    registrationName: keyOf({ onMouseLeave: null }),
    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
  }
};

var extractedEvents = [null, null];

var EnterLeaveEventPlugin = {

  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {DOMEventTarget} topLevelTarget The listening component root node.
   * @param {string} topLevelTargetID ID of `topLevelTarget`.
   * @param {object} nativeEvent Native browser event.
   * @return {*} An accumulation of synthetic events.
   * @see {EventPluginHub.extractEvents}
   */
  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
    if (topLevelType === topLevelTypes.topMouseOver && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== topLevelTypes.topMouseOut && topLevelType !== topLevelTypes.topMouseOver) {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (topLevelTarget.window === topLevelTarget) {
      // `topLevelTarget` is probably a window object.
      win = topLevelTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = topLevelTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    var fromID = '';
    var toID = '';
    if (topLevelType === topLevelTypes.topMouseOut) {
      from = topLevelTarget;
      fromID = topLevelTargetID;
      to = getFirstReactDOM(nativeEvent.relatedTarget || nativeEvent.toElement);
      if (to) {
        toID = ReactMount.getID(to);
      } else {
        to = win;
      }
      to = to || win;
    } else {
      from = win;
      to = topLevelTarget;
      toID = topLevelTargetID;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, fromID, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = from;
    leave.relatedTarget = to;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, toID, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = to;
    enter.relatedTarget = from;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, fromID, toID);

    extractedEvents[0] = leave;
    extractedEvents[1] = enter;

    return extractedEvents;
  }

};

module.exports = EnterLeaveEventPlugin;
},{"./EventConstants":313,"./EventPropagators":317,"./ReactMount":364,"./SyntheticMouseEvent":395,"fbjs/lib/keyOf":447}],313:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EventConstants
 */

'use strict';

var keyMirror = require('fbjs/lib/keyMirror');

var PropagationPhases = keyMirror({ bubbled: null, captured: null });

/**
 * Types of raw signals from the browser caught at the top level.
 */
var topLevelTypes = keyMirror({
  topAbort: null,
  topBlur: null,
  topCanPlay: null,
  topCanPlayThrough: null,
  topChange: null,
  topClick: null,
  topCompositionEnd: null,
  topCompositionStart: null,
  topCompositionUpdate: null,
  topContextMenu: null,
  topCopy: null,
  topCut: null,
  topDoubleClick: null,
  topDrag: null,
  topDragEnd: null,
  topDragEnter: null,
  topDragExit: null,
  topDragLeave: null,
  topDragOver: null,
  topDragStart: null,
  topDrop: null,
  topDurationChange: null,
  topEmptied: null,
  topEncrypted: null,
  topEnded: null,
  topError: null,
  topFocus: null,
  topInput: null,
  topKeyDown: null,
  topKeyPress: null,
  topKeyUp: null,
  topLoad: null,
  topLoadedData: null,
  topLoadedMetadata: null,
  topLoadStart: null,
  topMouseDown: null,
  topMouseMove: null,
  topMouseOut: null,
  topMouseOver: null,
  topMouseUp: null,
  topPaste: null,
  topPause: null,
  topPlay: null,
  topPlaying: null,
  topProgress: null,
  topRateChange: null,
  topReset: null,
  topScroll: null,
  topSeeked: null,
  topSeeking: null,
  topSelectionChange: null,
  topStalled: null,
  topSubmit: null,
  topSuspend: null,
  topTextInput: null,
  topTimeUpdate: null,
  topTouchCancel: null,
  topTouchEnd: null,
  topTouchMove: null,
  topTouchStart: null,
  topVolumeChange: null,
  topWaiting: null,
  topWheel: null
});

var EventConstants = {
  topLevelTypes: topLevelTypes,
  PropagationPhases: PropagationPhases
};

module.exports = EventConstants;
},{"fbjs/lib/keyMirror":446}],314:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EventPluginHub
 */

'use strict';

var EventPluginRegistry = require('./EventPluginRegistry');
var EventPluginUtils = require('./EventPluginUtils');
var ReactErrorUtils = require('./ReactErrorUtils');

var accumulateInto = require('./accumulateInto');
var forEachAccumulated = require('./forEachAccumulated');
var invariant = require('fbjs/lib/invariant');
var warning = require('fbjs/lib/warning');

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

/**
 * - `InstanceHandle`: [required] Module that performs logical traversals of DOM
 *   hierarchy given ids of the logical DOM elements involved.
 */
var InstanceHandle = null;

function validateInstanceHandle() {
  var valid = InstanceHandle && InstanceHandle.traverseTwoPhase && InstanceHandle.traverseEnterLeave;
  "production" !== 'production' ? warning(valid, 'InstanceHandle not injected before use!') : undefined;
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {

  /**
   * Methods for injecting dependencies.
   */
  injection: {

    /**
     * @param {object} InjectedMount
     * @public
     */
    injectMount: EventPluginUtils.injection.injectMount,

    /**
     * @param {object} InjectedInstanceHandle
     * @public
     */
    injectInstanceHandle: function (InjectedInstanceHandle) {
      InstanceHandle = InjectedInstanceHandle;
      if ("production" !== 'production') {
        validateInstanceHandle();
      }
    },

    getInstanceHandle: function () {
      if ("production" !== 'production') {
        validateInstanceHandle();
      }
      return InstanceHandle;
    },

    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName

  },

  eventNameDispatchConfigs: EventPluginRegistry.eventNameDispatchConfigs,

  registrationNameModules: EventPluginRegistry.registrationNameModules,

  /**
   * Stores `listener` at `listenerBank[registrationName][id]`. Is idempotent.
   *
   * @param {string} id ID of the DOM element.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {?function} listener The callback to store.
   */
  putListener: function (id, registrationName, listener) {
    !(typeof listener === 'function') ? "production" !== 'production' ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : invariant(false) : undefined;

    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[id] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(id, registrationName, listener);
    }
  },

  /**
   * @param {string} id ID of the DOM element.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (id, registrationName) {
    var bankForRegistrationName = listenerBank[registrationName];
    return bankForRegistrationName && bankForRegistrationName[id];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {string} id ID of the DOM element.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (id, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(id, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      delete bankForRegistrationName[id];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {string} id ID of the DOM element.
   */
  deleteAllListeners: function (id) {
    for (var registrationName in listenerBank) {
      if (!listenerBank[registrationName][id]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(id, registrationName);
      }

      delete listenerBank[registrationName][id];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {DOMEventTarget} topLevelTarget The listening component root node.
   * @param {string} topLevelTargetID ID of `topLevelTarget`.
   * @param {object} nativeEvent Native browser event.
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ? "production" !== 'production' ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing ' + 'an event queue. Support for this has not yet been implemented.') : invariant(false) : undefined;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }

};

module.exports = EventPluginHub;
},{"./EventPluginRegistry":315,"./EventPluginUtils":316,"./ReactErrorUtils":355,"./accumulateInto":401,"./forEachAccumulated":409,"fbjs/lib/invariant":443,"fbjs/lib/warning":454}],315:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EventPluginRegistry
 * @typechecks static-only
 */

'use strict';

var invariant = require('fbjs/lib/invariant');

/**
 * Injectable ordering of event plugins.
 */
var EventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!EventPluginOrder) {
    // Wait until an `EventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var PluginModule = namesToPlugins[pluginName];
    var pluginIndex = EventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ? "production" !== 'production' ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in ' + 'the plugin ordering, `%s`.', pluginName) : invariant(false) : undefined;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !PluginModule.extractEvents ? "production" !== 'production' ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` ' + 'method, but `%s` does not.', pluginName) : invariant(false) : undefined;
    EventPluginRegistry.plugins[pluginIndex] = PluginModule;
    var publishedEvents = PluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], PluginModule, eventName) ? "production" !== 'production' ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : invariant(false) : undefined;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, PluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ? "production" !== 'production' ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'event name, `%s`.', eventName) : invariant(false) : undefined;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, PluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, PluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, PluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ? "production" !== 'production' ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'registration name, `%s`.', registrationName) : invariant(false) : undefined;
  EventPluginRegistry.registrationNameModules[registrationName] = PluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = PluginModule.eventTypes[eventName].dependencies;
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {

  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (InjectedEventPluginOrder) {
    !!EventPluginOrder ? "production" !== 'production' ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than ' + 'once. You are likely trying to load more than one copy of React.') : invariant(false) : undefined;
    // Clone the ordering so it cannot be dynamically mutated.
    EventPluginOrder = Array.prototype.slice.call(InjectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var PluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== PluginModule) {
        !!namesToPlugins[pluginName] ? "production" !== 'production' ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins ' + 'using the same name, `%s`.', pluginName) : invariant(false) : undefined;
        namesToPlugins[pluginName] = PluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    for (var phase in dispatchConfig.phasedRegistrationNames) {
      if (!dispatchConfig.phasedRegistrationNames.hasOwnProperty(phase)) {
        continue;
      }
      var PluginModule = EventPluginRegistry.registrationNameModules[dispatchConfig.phasedRegistrationNames[phase]];
      if (PluginModule) {
        return PluginModule;
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    EventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }
  }

};

module.exports = EventPluginRegistry;
},{"fbjs/lib/invariant":443}],316:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EventPluginUtils
 */

'use strict';

var EventConstants = require('./EventConstants');
var ReactErrorUtils = require('./ReactErrorUtils');

var invariant = require('fbjs/lib/invariant');
var warning = require('fbjs/lib/warning');

/**
 * Injected dependencies:
 */

/**
 * - `Mount`: [required] Module that can convert between React dom IDs and
 *   actual node references.
 */
var injection = {
  Mount: null,
  injectMount: function (InjectedMount) {
    injection.Mount = InjectedMount;
    if ("production" !== 'production') {
      "production" !== 'production' ? warning(InjectedMount && InjectedMount.getNode && InjectedMount.getID, 'EventPluginUtils.injection.injectMount(...): Injected Mount ' + 'module is missing getNode or getID.') : undefined;
    }
  }
};

var topLevelTypes = EventConstants.topLevelTypes;

function isEndish(topLevelType) {
  return topLevelType === topLevelTypes.topMouseUp || topLevelType === topLevelTypes.topTouchEnd || topLevelType === topLevelTypes.topTouchCancel;
}

function isMoveish(topLevelType) {
  return topLevelType === topLevelTypes.topMouseMove || topLevelType === topLevelTypes.topTouchMove;
}
function isStartish(topLevelType) {
  return topLevelType === topLevelTypes.topMouseDown || topLevelType === topLevelTypes.topTouchStart;
}

var validateEventDispatches;
if ("production" !== 'production') {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchIDs = event._dispatchIDs;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var idsIsArr = Array.isArray(dispatchIDs);
    var IDsLen = idsIsArr ? dispatchIDs.length : dispatchIDs ? 1 : 0;
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    "production" !== 'production' ? warning(idsIsArr === listenersIsArr && IDsLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : undefined;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {string} domID DOM id to pass to the callback.
 */
function executeDispatch(event, simulated, listener, domID) {
  var type = event.type || 'unknown-event';
  event.currentTarget = injection.Mount.getNode(domID);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event, domID);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event, domID);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchIDs = event._dispatchIDs;
  if ("production" !== 'production') {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and IDs are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchIDs[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchIDs);
  }
  event._dispatchListeners = null;
  event._dispatchIDs = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchIDs = event._dispatchIDs;
  if ("production" !== 'production') {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and IDs are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchIDs[i])) {
        return dispatchIDs[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchIDs)) {
      return dispatchIDs;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchIDs = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if ("production" !== 'production') {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchID = event._dispatchIDs;
  !!Array.isArray(dispatchListener) ? "production" !== 'production' ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : invariant(false) : undefined;
  var res = dispatchListener ? dispatchListener(event, dispatchID) : null;
  event._dispatchListeners = null;
  event._dispatchIDs = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getNode: function (id) {
    return injection.Mount.getNode(id);
  },
  getID: function (node) {
    return injection.Mount.getID(node);
  },

  injection: injection
};

module.exports = EventPluginUtils;
},{"./EventConstants":313,"./ReactErrorUtils":355,"fbjs/lib/invariant":443,"fbjs/lib/warning":454}],317:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EventPropagators
 */

'use strict';

var EventConstants = require('./EventConstants');
var EventPluginHub = require('./EventPluginHub');

var warning = require('fbjs/lib/warning');

var accumulateInto = require('./accumulateInto');
var forEachAccumulated = require('./forEachAccumulated');

var PropagationPhases = EventConstants.PropagationPhases;
var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(id, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(id, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(domID, upwards, event) {
  if ("production" !== 'production') {
    "production" !== 'production' ? warning(domID, 'Dispatching id must not be null') : undefined;
  }
  var phase = upwards ? PropagationPhases.bubbled : PropagationPhases.captured;
  var listener = listenerAtPhase(domID, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchIDs = accumulateInto(event._dispatchIDs, domID);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginHub.injection.getInstanceHandle().traverseTwoPhase(event.dispatchMarker, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginHub.injection.getInstanceHandle().traverseTwoPhaseSkipTarget(event.dispatchMarker, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(id, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(id, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchIDs = accumulateInto(event._dispatchIDs, id);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event.dispatchMarker, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, fromID, toID) {
  EventPluginHub.injection.getInstanceHandle().traverseEnterLeave(fromID, toID, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;
},{"./EventConstants":313,"./EventPluginHub":314,"./accumulateInto":401,"./forEachAccumulated":409,"fbjs/lib/warning":454}],318:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule FallbackCompositionState
 * @typechecks static-only
 */

'use strict';

var PooledClass = require('./PooledClass');

var assign = require('./Object.assign');
var getTextContentAccessor = require('./getTextContentAccessor');

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;
},{"./Object.assign":321,"./PooledClass":322,"./getTextContentAccessor":416}],319:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule HTMLDOMPropertyConfig
 */

'use strict';

var DOMProperty = require('./DOMProperty');
var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');

var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;
var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_SIDE_EFFECTS = DOMProperty.injection.HAS_SIDE_EFFECTS;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var hasSVG;
if (ExecutionEnvironment.canUseDOM) {
  var implementation = document.implementation;
  hasSVG = implementation && implementation.hasFeature && implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#BasicStructure', '1.1');
}

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(/^(data|aria)-[a-z_][a-z\d_.\-]*$/),
  Properties: {
    /**
     * Standard Properties
     */
    accept: null,
    acceptCharset: null,
    accessKey: null,
    action: null,
    allowFullScreen: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
    allowTransparency: MUST_USE_ATTRIBUTE,
    alt: null,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: null,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
    cellPadding: null,
    cellSpacing: null,
    charSet: MUST_USE_ATTRIBUTE,
    challenge: MUST_USE_ATTRIBUTE,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    classID: MUST_USE_ATTRIBUTE,
    // To set className on SVG elements, it's necessary to use .setAttribute;
    // this works on HTML elements too in all browsers except IE8. Conveniently,
    // IE8 doesn't support SVG and so we can simply use the attribute in
    // browsers that support SVG and the property in browsers that don't,
    // regardless of whether the element is HTML or SVG.
    className: hasSVG ? MUST_USE_ATTRIBUTE : MUST_USE_PROPERTY,
    cols: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: null,
    content: null,
    contentEditable: null,
    contextMenu: MUST_USE_ATTRIBUTE,
    controls: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    coords: null,
    crossOrigin: null,
    data: null, // For `<object />` acts as `src`.
    dateTime: MUST_USE_ATTRIBUTE,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: null,
    disabled: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: null,
    encType: null,
    form: MUST_USE_ATTRIBUTE,
    formAction: MUST_USE_ATTRIBUTE,
    formEncType: MUST_USE_ATTRIBUTE,
    formMethod: MUST_USE_ATTRIBUTE,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: MUST_USE_ATTRIBUTE,
    frameBorder: MUST_USE_ATTRIBUTE,
    headers: null,
    height: MUST_USE_ATTRIBUTE,
    hidden: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
    high: null,
    href: null,
    hrefLang: null,
    htmlFor: null,
    httpEquiv: null,
    icon: null,
    id: MUST_USE_PROPERTY,
    inputMode: MUST_USE_ATTRIBUTE,
    integrity: null,
    is: MUST_USE_ATTRIBUTE,
    keyParams: MUST_USE_ATTRIBUTE,
    keyType: MUST_USE_ATTRIBUTE,
    kind: null,
    label: null,
    lang: null,
    list: MUST_USE_ATTRIBUTE,
    loop: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    low: null,
    manifest: MUST_USE_ATTRIBUTE,
    marginHeight: null,
    marginWidth: null,
    max: null,
    maxLength: MUST_USE_ATTRIBUTE,
    media: MUST_USE_ATTRIBUTE,
    mediaGroup: null,
    method: null,
    min: null,
    minLength: MUST_USE_ATTRIBUTE,
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: null,
    nonce: MUST_USE_ATTRIBUTE,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: null,
    pattern: null,
    placeholder: null,
    poster: null,
    preload: null,
    radioGroup: null,
    readOnly: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    rel: null,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: MUST_USE_ATTRIBUTE,
    rows: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: null,
    sandbox: null,
    scope: null,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: null,
    seamless: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: null,
    size: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
    sizes: MUST_USE_ATTRIBUTE,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: null,
    src: null,
    srcDoc: MUST_USE_PROPERTY,
    srcLang: null,
    srcSet: MUST_USE_ATTRIBUTE,
    start: HAS_NUMERIC_VALUE,
    step: null,
    style: null,
    summary: null,
    tabIndex: null,
    target: null,
    title: null,
    type: null,
    useMap: null,
    value: MUST_USE_PROPERTY | HAS_SIDE_EFFECTS,
    width: MUST_USE_ATTRIBUTE,
    wmode: MUST_USE_ATTRIBUTE,
    wrap: null,

    /**
     * RDFa Properties
     */
    about: MUST_USE_ATTRIBUTE,
    datatype: MUST_USE_ATTRIBUTE,
    inlist: MUST_USE_ATTRIBUTE,
    prefix: MUST_USE_ATTRIBUTE,
    // property is also supported for OpenGraph in meta tags.
    property: MUST_USE_ATTRIBUTE,
    resource: MUST_USE_ATTRIBUTE,
    'typeof': MUST_USE_ATTRIBUTE,
    vocab: MUST_USE_ATTRIBUTE,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: null,
    autoCorrect: null,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: null,
    // color is for Safari mask-icon link
    color: null,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: MUST_USE_ATTRIBUTE,
    itemScope: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
    itemType: MUST_USE_ATTRIBUTE,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: MUST_USE_ATTRIBUTE,
    itemRef: MUST_USE_ATTRIBUTE,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: null,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: MUST_USE_ATTRIBUTE,
    // IE-only attribute that controls focus behavior
    unselectable: MUST_USE_ATTRIBUTE
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {
    autoCapitalize: 'autocapitalize',
    autoComplete: 'autocomplete',
    autoCorrect: 'autocorrect',
    autoFocus: 'autofocus',
    autoPlay: 'autoplay',
    autoSave: 'autosave',
    // `encoding` is equivalent to `enctype`, IE8 lacks an `enctype` setter.
    // http://www.w3.org/TR/html5/forms.html#dom-fs-encoding
    encType: 'encoding',
    hrefLang: 'hreflang',
    radioGroup: 'radiogroup',
    spellCheck: 'spellcheck',
    srcDoc: 'srcdoc',
    srcSet: 'srcset'
  }
};

module.exports = HTMLDOMPropertyConfig;
},{"./DOMProperty":308,"fbjs/lib/ExecutionEnvironment":429}],320:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule LinkedValueUtils
 * @typechecks static-only
 */

'use strict';

var ReactPropTypes = require('./ReactPropTypes');
var ReactPropTypeLocations = require('./ReactPropTypeLocations');

var invariant = require('fbjs/lib/invariant');
var warning = require('fbjs/lib/warning');

var hasReadOnlyValue = {
  'button': true,
  'checkbox': true,
  'image': true,
  'hidden': true,
  'radio': true,
  'reset': true,
  'submit': true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ? "production" !== 'production' ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use ' + 'checkedLink, you probably don\'t want to use valueLink and vice versa.') : invariant(false) : undefined;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ? "production" !== 'production' ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want ' + 'to use value or onChange, you probably don\'t want to use valueLink.') : invariant(false) : undefined;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ? "production" !== 'production' ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. ' + 'If you want to use checked or onChange, you probably don\'t want to ' + 'use checkedLink') : invariant(false) : undefined;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: ReactPropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, ReactPropTypeLocations.prop);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
        "production" !== 'production' ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : undefined;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;
},{"./ReactPropTypeLocations":372,"./ReactPropTypes":373,"fbjs/lib/invariant":443,"fbjs/lib/warning":454}],321:[function(require,module,exports){
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Object.assign
 */

// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.assign

'use strict';

function assign(target, sources) {
  if (target == null) {
    throw new TypeError('Object.assign target cannot be null or undefined');
  }

  var to = Object(target);
  var hasOwnProperty = Object.prototype.hasOwnProperty;

  for (var nextIndex = 1; nextIndex < arguments.length; nextIndex++) {
    var nextSource = arguments[nextIndex];
    if (nextSource == null) {
      continue;
    }

    var from = Object(nextSource);

    // We don't currently support accessors nor proxies. Therefore this
    // copy cannot throw. If we ever supported this then we must handle
    // exceptions and side-effects. We don't support symbols so they won't
    // be transferred.

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }
  }

  return to;
}

module.exports = assign;
},{}],322:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule PooledClass
 */

'use strict';

var invariant = require('fbjs/lib/invariant');

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4, a5);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4, a5);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ? "production" !== 'production' ? invariant(false, 'Trying to release an instance into a pool of a different type.') : invariant(false) : undefined;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances (optional).
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler,
  fiveArgumentPooler: fiveArgumentPooler
};

module.exports = PooledClass;
},{"fbjs/lib/invariant":443}],323:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule React
 */

'use strict';

var ReactDOM = require('./ReactDOM');
var ReactDOMServer = require('./ReactDOMServer');
var ReactIsomorphic = require('./ReactIsomorphic');

var assign = require('./Object.assign');
var deprecated = require('./deprecated');

// `version` will be added here by ReactIsomorphic.
var React = {};

assign(React, ReactIsomorphic);

assign(React, {
  // ReactDOM
  findDOMNode: deprecated('findDOMNode', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.findDOMNode),
  render: deprecated('render', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.render),
  unmountComponentAtNode: deprecated('unmountComponentAtNode', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.unmountComponentAtNode),

  // ReactDOMServer
  renderToString: deprecated('renderToString', 'ReactDOMServer', 'react-dom/server', ReactDOMServer, ReactDOMServer.renderToString),
  renderToStaticMarkup: deprecated('renderToStaticMarkup', 'ReactDOMServer', 'react-dom/server', ReactDOMServer, ReactDOMServer.renderToStaticMarkup)
});

React.__SECRET_DOM_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactDOM;
React.__SECRET_DOM_SERVER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactDOMServer;

module.exports = React;
},{"./Object.assign":321,"./ReactDOM":334,"./ReactDOMServer":344,"./ReactIsomorphic":362,"./deprecated":405}],324:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactBrowserComponentMixin
 */

'use strict';

var ReactInstanceMap = require('./ReactInstanceMap');

var findDOMNode = require('./findDOMNode');
var warning = require('fbjs/lib/warning');

var didWarnKey = '_getDOMNodeDidWarn';

var ReactBrowserComponentMixin = {
  /**
   * Returns the DOM node rendered by this component.
   *
   * @return {DOMElement} The root node of this component.
   * @final
   * @protected
   */
  getDOMNode: function () {
    "production" !== 'production' ? warning(this.constructor[didWarnKey], '%s.getDOMNode(...) is deprecated. Please use ' + 'ReactDOM.findDOMNode(instance) instead.', ReactInstanceMap.get(this).getName() || this.tagName || 'Unknown') : undefined;
    this.constructor[didWarnKey] = true;
    return findDOMNode(this);
  }
};

module.exports = ReactBrowserComponentMixin;
},{"./ReactInstanceMap":361,"./findDOMNode":407,"fbjs/lib/warning":454}],325:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactBrowserEventEmitter
 * @typechecks static-only
 */

'use strict';

var EventConstants = require('./EventConstants');
var EventPluginHub = require('./EventPluginHub');
var EventPluginRegistry = require('./EventPluginRegistry');
var ReactEventEmitterMixin = require('./ReactEventEmitterMixin');
var ReactPerf = require('./ReactPerf');
var ViewportMetrics = require('./ViewportMetrics');

var assign = require('./Object.assign');
var isEventSupported = require('./isEventSupported');

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   ReactBrowserEventEmitter.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = assign({}, ReactEventEmitterMixin, {

  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    var topLevelTypes = EventConstants.topLevelTypes;
    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === topLevelTypes.topWheel) {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === topLevelTypes.topScroll) {

          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topScroll, 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topScroll, 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === topLevelTypes.topFocus || dependency === topLevelTypes.topBlur) {

          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topFocus, 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topBlur, 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topFocus, 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topBlur, 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening[topLevelTypes.topBlur] = true;
          isListening[topLevelTypes.topFocus] = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (!isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  },

  eventNameDispatchConfigs: EventPluginHub.eventNameDispatchConfigs,

  registrationNameModules: EventPluginHub.registrationNameModules,

  putListener: EventPluginHub.putListener,

  getListener: EventPluginHub.getListener,

  deleteListener: EventPluginHub.deleteListener,

  deleteAllListeners: EventPluginHub.deleteAllListeners

});

ReactPerf.measureMethods(ReactBrowserEventEmitter, 'ReactBrowserEventEmitter', {
  putListener: 'putListener',
  deleteListener: 'deleteListener'
});

module.exports = ReactBrowserEventEmitter;
},{"./EventConstants":313,"./EventPluginHub":314,"./EventPluginRegistry":315,"./Object.assign":321,"./ReactEventEmitterMixin":356,"./ReactPerf":370,"./ViewportMetrics":400,"./isEventSupported":418}],326:[function(require,module,exports){
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactChildReconciler
 * @typechecks static-only
 */

'use strict';

var ReactReconciler = require('./ReactReconciler');

var instantiateReactComponent = require('./instantiateReactComponent');
var shouldUpdateReactComponent = require('./shouldUpdateReactComponent');
var traverseAllChildren = require('./traverseAllChildren');
var warning = require('fbjs/lib/warning');

function instantiateChild(childInstances, child, name) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if ("production" !== 'production') {
    "production" !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', name) : undefined;
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, null);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context) {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};
    traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, transaction, context) {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return null;
    }
    var name;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      var prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          ReactReconciler.unmountComponent(prevChild, name);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, null);
        nextChildren[name] = nextChildInstance;
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        ReactReconciler.unmountComponent(prevChildren[name]);
      }
    }
    return nextChildren;
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild);
      }
    }
  }

};

module.exports = ReactChildReconciler;
},{"./ReactReconciler":375,"./instantiateReactComponent":417,"./shouldUpdateReactComponent":425,"./traverseAllChildren":426,"fbjs/lib/warning":454}],327:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactChildren
 */

'use strict';

var PooledClass = require('./PooledClass');
var ReactElement = require('./ReactElement');

var emptyFunction = require('fbjs/lib/emptyFunction');
var traverseAllChildren = require('./traverseAllChildren');

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/(?!\/)/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '//');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func;
  var context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result;
  var keyPrefix = bookKeeping.keyPrefix;
  var func = bookKeeping.func;
  var context = bookKeeping.context;

  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild !== child ? escapeUserProvidedKey(mappedChild.key || '') + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;
},{"./PooledClass":322,"./ReactElement":351,"./traverseAllChildren":426,"fbjs/lib/emptyFunction":435}],328:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactClass
 */

'use strict';

var ReactComponent = require('./ReactComponent');
var ReactElement = require('./ReactElement');
var ReactPropTypeLocations = require('./ReactPropTypeLocations');
var ReactPropTypeLocationNames = require('./ReactPropTypeLocationNames');
var ReactNoopUpdateQueue = require('./ReactNoopUpdateQueue');

var assign = require('./Object.assign');
var emptyObject = require('fbjs/lib/emptyObject');
var invariant = require('fbjs/lib/invariant');
var keyMirror = require('fbjs/lib/keyMirror');
var keyOf = require('fbjs/lib/keyOf');
var warning = require('fbjs/lib/warning');

var MIXINS_KEY = keyOf({ mixins: null });

/**
 * Policies that describe methods in `ReactClassInterface`.
 */
var SpecPolicy = keyMirror({
  /**
   * These methods may be defined only once by the class specification or mixin.
   */
  DEFINE_ONCE: null,
  /**
   * These methods may be defined by both the class specification and mixins.
   * Subsequent definitions will be chained. These methods must return void.
   */
  DEFINE_MANY: null,
  /**
   * These methods are overriding the base class.
   */
  OVERRIDE_BASE: null,
  /**
   * These methods are similar to DEFINE_MANY, except we assume they return
   * objects. We try to merge the keys of the return values of all the mixed in
   * functions. If there is a key conflict we throw.
   */
  DEFINE_MANY_MERGED: null
});

var injectedMixins = [];

var warnedSetProps = false;
function warnSetProps() {
  if (!warnedSetProps) {
    warnedSetProps = true;
    "production" !== 'production' ? warning(false, 'setProps(...) and replaceProps(...) are deprecated. ' + 'Instead, call render again at the top level.') : undefined;
  }
}

/**
 * Composite components are higher-level components that compose other composite
 * or native components.
 *
 * To create a new type of `ReactClass`, pass a specification of
 * your new class to `React.createClass`. The only requirement of your class
 * specification is that you implement a `render` method.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return <div>Hello World</div>;
 *     }
 *   });
 *
 * The class specification supports a specific protocol of methods that have
 * special meaning (e.g. `render`). See `ReactClassInterface` for
 * more the comprehensive protocol. Any other properties and methods in the
 * class specification will be available on the prototype.
 *
 * @interface ReactClassInterface
 * @internal
 */
var ReactClassInterface = {

  /**
   * An array of Mixin objects to include when defining your component.
   *
   * @type {array}
   * @optional
   */
  mixins: SpecPolicy.DEFINE_MANY,

  /**
   * An object containing properties and methods that should be defined on
   * the component's constructor instead of its prototype (static methods).
   *
   * @type {object}
   * @optional
   */
  statics: SpecPolicy.DEFINE_MANY,

  /**
   * Definition of prop types for this component.
   *
   * @type {object}
   * @optional
   */
  propTypes: SpecPolicy.DEFINE_MANY,

  /**
   * Definition of context types for this component.
   *
   * @type {object}
   * @optional
   */
  contextTypes: SpecPolicy.DEFINE_MANY,

  /**
   * Definition of context types this component sets for its children.
   *
   * @type {object}
   * @optional
   */
  childContextTypes: SpecPolicy.DEFINE_MANY,

  // ==== Definition methods ====

  /**
   * Invoked when the component is mounted. Values in the mapping will be set on
   * `this.props` if that prop is not specified (i.e. using an `in` check).
   *
   * This method is invoked before `getInitialState` and therefore cannot rely
   * on `this.state` or use `this.setState`.
   *
   * @return {object}
   * @optional
   */
  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,

  /**
   * Invoked once before the component is mounted. The return value will be used
   * as the initial value of `this.state`.
   *
   *   getInitialState: function() {
   *     return {
   *       isOn: false,
   *       fooBaz: new BazFoo()
   *     }
   *   }
   *
   * @return {object}
   * @optional
   */
  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,

  /**
   * @return {object}
   * @optional
   */
  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,

  /**
   * Uses props from `this.props` and state from `this.state` to render the
   * structure of the component.
   *
   * No guarantees are made about when or how often this method is invoked, so
   * it must not have side effects.
   *
   *   render: function() {
   *     var name = this.props.name;
   *     return <div>Hello, {name}!</div>;
   *   }
   *
   * @return {ReactComponent}
   * @nosideeffects
   * @required
   */
  render: SpecPolicy.DEFINE_ONCE,

  // ==== Delegate methods ====

  /**
   * Invoked when the component is initially created and about to be mounted.
   * This may have side effects, but any external subscriptions or data created
   * by this method must be cleaned up in `componentWillUnmount`.
   *
   * @optional
   */
  componentWillMount: SpecPolicy.DEFINE_MANY,

  /**
   * Invoked when the component has been mounted and has a DOM representation.
   * However, there is no guarantee that the DOM node is in the document.
   *
   * Use this as an opportunity to operate on the DOM when the component has
   * been mounted (initialized and rendered) for the first time.
   *
   * @param {DOMElement} rootNode DOM element representing the component.
   * @optional
   */
  componentDidMount: SpecPolicy.DEFINE_MANY,

  /**
   * Invoked before the component receives new props.
   *
   * Use this as an opportunity to react to a prop transition by updating the
   * state using `this.setState`. Current props are accessed via `this.props`.
   *
   *   componentWillReceiveProps: function(nextProps, nextContext) {
   *     this.setState({
   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
   *     });
   *   }
   *
   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
   * transition may cause a state change, but the opposite is not true. If you
   * need it, you are probably looking for `componentWillUpdate`.
   *
   * @param {object} nextProps
   * @optional
   */
  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,

  /**
   * Invoked while deciding if the component should be updated as a result of
   * receiving new props, state and/or context.
   *
   * Use this as an opportunity to `return false` when you're certain that the
   * transition to the new props/state/context will not require a component
   * update.
   *
   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
   *     return !equal(nextProps, this.props) ||
   *       !equal(nextState, this.state) ||
   *       !equal(nextContext, this.context);
   *   }
   *
   * @param {object} nextProps
   * @param {?object} nextState
   * @param {?object} nextContext
   * @return {boolean} True if the component should update.
   * @optional
   */
  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,

  /**
   * Invoked when the component is about to update due to a transition from
   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
   * and `nextContext`.
   *
   * Use this as an opportunity to perform preparation before an update occurs.
   *
   * NOTE: You **cannot** use `this.setState()` in this method.
   *
   * @param {object} nextProps
   * @param {?object} nextState
   * @param {?object} nextContext
   * @param {ReactReconcileTransaction} transaction
   * @optional
   */
  componentWillUpdate: SpecPolicy.DEFINE_MANY,

  /**
   * Invoked when the component's DOM representation has been updated.
   *
   * Use this as an opportunity to operate on the DOM when the component has
   * been updated.
   *
   * @param {object} prevProps
   * @param {?object} prevState
   * @param {?object} prevContext
   * @param {DOMElement} rootNode DOM element representing the component.
   * @optional
   */
  componentDidUpdate: SpecPolicy.DEFINE_MANY,

  /**
   * Invoked when the component is about to be removed from its parent and have
   * its DOM representation destroyed.
   *
   * Use this as an opportunity to deallocate any external resources.
   *
   * NOTE: There is no `componentDidUnmount` since your component will have been
   * destroyed by that point.
   *
   * @optional
   */
  componentWillUnmount: SpecPolicy.DEFINE_MANY,

  // ==== Advanced methods ====

  /**
   * Updates the component's currently mounted DOM representation.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   * @overridable
   */
  updateComponent: SpecPolicy.OVERRIDE_BASE

};

/**
 * Mapping from class specification keys to special processing functions.
 *
 * Although these are declared like instance properties in the specification
 * when defining classes using `React.createClass`, they are actually static
 * and are accessible on the constructor instead of the prototype. Despite
 * being static, they must be defined outside of the "statics" key under
 * which all other static methods are defined.
 */
var RESERVED_SPEC_KEYS = {
  displayName: function (Constructor, displayName) {
    Constructor.displayName = displayName;
  },
  mixins: function (Constructor, mixins) {
    if (mixins) {
      for (var i = 0; i < mixins.length; i++) {
        mixSpecIntoComponent(Constructor, mixins[i]);
      }
    }
  },
  childContextTypes: function (Constructor, childContextTypes) {
    if ("production" !== 'production') {
      validateTypeDef(Constructor, childContextTypes, ReactPropTypeLocations.childContext);
    }
    Constructor.childContextTypes = assign({}, Constructor.childContextTypes, childContextTypes);
  },
  contextTypes: function (Constructor, contextTypes) {
    if ("production" !== 'production') {
      validateTypeDef(Constructor, contextTypes, ReactPropTypeLocations.context);
    }
    Constructor.contextTypes = assign({}, Constructor.contextTypes, contextTypes);
  },
  /**
   * Special case getDefaultProps which should move into statics but requires
   * automatic merging.
   */
  getDefaultProps: function (Constructor, getDefaultProps) {
    if (Constructor.getDefaultProps) {
      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
    } else {
      Constructor.getDefaultProps = getDefaultProps;
    }
  },
  propTypes: function (Constructor, propTypes) {
    if ("production" !== 'production') {
      validateTypeDef(Constructor, propTypes, ReactPropTypeLocations.prop);
    }
    Constructor.propTypes = assign({}, Constructor.propTypes, propTypes);
  },
  statics: function (Constructor, statics) {
    mixStaticSpecIntoComponent(Constructor, statics);
  },
  autobind: function () {} };

// noop
function validateTypeDef(Constructor, typeDef, location) {
  for (var propName in typeDef) {
    if (typeDef.hasOwnProperty(propName)) {
      // use a warning instead of an invariant so components
      // don't show up in prod but not in __DEV__
      "production" !== 'production' ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : undefined;
    }
  }
}

function validateMethodOverride(proto, name) {
  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;

  // Disallow overriding of base class methods unless explicitly allowed.
  if (ReactClassMixin.hasOwnProperty(name)) {
    !(specPolicy === SpecPolicy.OVERRIDE_BASE) ? "production" !== 'production' ? invariant(false, 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name) : invariant(false) : undefined;
  }

  // Disallow defining methods more than once unless explicitly allowed.
  if (proto.hasOwnProperty(name)) {
    !(specPolicy === SpecPolicy.DEFINE_MANY || specPolicy === SpecPolicy.DEFINE_MANY_MERGED) ? "production" !== 'production' ? invariant(false, 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name) : invariant(false) : undefined;
  }
}

/**
 * Mixin helper which handles policy validation and reserved
 * specification keys when building React classses.
 */
function mixSpecIntoComponent(Constructor, spec) {
  if (!spec) {
    return;
  }

  !(typeof spec !== 'function') ? "production" !== 'production' ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component class as a mixin. Instead, just use a regular object.') : invariant(false) : undefined;
  !!ReactElement.isValidElement(spec) ? "production" !== 'production' ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component as a mixin. Instead, just use a regular object.') : invariant(false) : undefined;

  var proto = Constructor.prototype;

  // By handling mixins before any other properties, we ensure the same
  // chaining order is applied to methods with DEFINE_MANY policy, whether
  // mixins are listed before or after these methods in the spec.
  if (spec.hasOwnProperty(MIXINS_KEY)) {
    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
  }

  for (var name in spec) {
    if (!spec.hasOwnProperty(name)) {
      continue;
    }

    if (name === MIXINS_KEY) {
      // We have already handled mixins in a special case above.
      continue;
    }

    var property = spec[name];
    validateMethodOverride(proto, name);

    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
      RESERVED_SPEC_KEYS[name](Constructor, property);
    } else {
      // Setup methods on prototype:
      // The following member methods should not be automatically bound:
      // 1. Expected ReactClass methods (in the "interface").
      // 2. Overridden methods (that were mixed in).
      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
      var isAlreadyDefined = proto.hasOwnProperty(name);
      var isFunction = typeof property === 'function';
      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;

      if (shouldAutoBind) {
        if (!proto.__reactAutoBindMap) {
          proto.__reactAutoBindMap = {};
        }
        proto.__reactAutoBindMap[name] = property;
        proto[name] = property;
      } else {
        if (isAlreadyDefined) {
          var specPolicy = ReactClassInterface[name];

          // These cases should already be caught by validateMethodOverride.
          !(isReactClassMethod && (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)) ? "production" !== 'production' ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name) : invariant(false) : undefined;

          // For methods which are defined more than once, call the existing
          // methods before calling the new property, merging if appropriate.
          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
            proto[name] = createMergedResultFunction(proto[name], property);
          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
            proto[name] = createChainedFunction(proto[name], property);
          }
        } else {
          proto[name] = property;
          if ("production" !== 'production') {
            // Add verbose displayName to the function, which helps when looking
            // at profiling tools.
            if (typeof property === 'function' && spec.displayName) {
              proto[name].displayName = spec.displayName + '_' + name;
            }
          }
        }
      }
    }
  }
}

function mixStaticSpecIntoComponent(Constructor, statics) {
  if (!statics) {
    return;
  }
  for (var name in statics) {
    var property = statics[name];
    if (!statics.hasOwnProperty(name)) {
      continue;
    }

    var isReserved = (name in RESERVED_SPEC_KEYS);
    !!isReserved ? "production" !== 'production' ? invariant(false, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name) : invariant(false) : undefined;

    var isInherited = (name in Constructor);
    !!isInherited ? "production" !== 'production' ? invariant(false, 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name) : invariant(false) : undefined;
    Constructor[name] = property;
  }
}

/**
 * Merge two objects, but throw if both contain the same key.
 *
 * @param {object} one The first object, which is mutated.
 * @param {object} two The second object
 * @return {object} one after it has been mutated to contain everything in two.
 */
function mergeIntoWithNoDuplicateKeys(one, two) {
  !(one && two && typeof one === 'object' && typeof two === 'object') ? "production" !== 'production' ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : invariant(false) : undefined;

  for (var key in two) {
    if (two.hasOwnProperty(key)) {
      !(one[key] === undefined) ? "production" !== 'production' ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key) : invariant(false) : undefined;
      one[key] = two[key];
    }
  }
  return one;
}

/**
 * Creates a function that invokes two functions and merges their return values.
 *
 * @param {function} one Function to invoke first.
 * @param {function} two Function to invoke second.
 * @return {function} Function that invokes the two argument functions.
 * @private
 */
function createMergedResultFunction(one, two) {
  return function mergedResult() {
    var a = one.apply(this, arguments);
    var b = two.apply(this, arguments);
    if (a == null) {
      return b;
    } else if (b == null) {
      return a;
    }
    var c = {};
    mergeIntoWithNoDuplicateKeys(c, a);
    mergeIntoWithNoDuplicateKeys(c, b);
    return c;
  };
}

/**
 * Creates a function that invokes two functions and ignores their return vales.
 *
 * @param {function} one Function to invoke first.
 * @param {function} two Function to invoke second.
 * @return {function} Function that invokes the two argument functions.
 * @private
 */
function createChainedFunction(one, two) {
  return function chainedFunction() {
    one.apply(this, arguments);
    two.apply(this, arguments);
  };
}

/**
 * Binds a method to the component.
 *
 * @param {object} component Component whose method is going to be bound.
 * @param {function} method Method to be bound.
 * @return {function} The bound method.
 */
function bindAutoBindMethod(component, method) {
  var boundMethod = method.bind(component);
  if ("production" !== 'production') {
    boundMethod.__reactBoundContext = component;
    boundMethod.__reactBoundMethod = method;
    boundMethod.__reactBoundArguments = null;
    var componentName = component.constructor.displayName;
    var _bind = boundMethod.bind;
    /* eslint-disable block-scoped-var, no-undef */
    boundMethod.bind = function (newThis) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      // User is trying to bind() an autobound method; we effectively will
      // ignore the value of "this" that the user is trying to use, so
      // let's warn.
      if (newThis !== component && newThis !== null) {
        "production" !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : undefined;
      } else if (!args.length) {
        "production" !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : undefined;
        return boundMethod;
      }
      var reboundMethod = _bind.apply(boundMethod, arguments);
      reboundMethod.__reactBoundContext = component;
      reboundMethod.__reactBoundMethod = method;
      reboundMethod.__reactBoundArguments = args;
      return reboundMethod;
      /* eslint-enable */
    };
  }
  return boundMethod;
}

/**
 * Binds all auto-bound methods in a component.
 *
 * @param {object} component Component whose method is going to be bound.
 */
function bindAutoBindMethods(component) {
  for (var autoBindKey in component.__reactAutoBindMap) {
    if (component.__reactAutoBindMap.hasOwnProperty(autoBindKey)) {
      var method = component.__reactAutoBindMap[autoBindKey];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }
}

/**
 * Add more to the ReactClass base class. These are all legacy features and
 * therefore not already part of the modern ReactComponent.
 */
var ReactClassMixin = {

  /**
   * TODO: This will be deprecated because state should always keep a consistent
   * type signature and the only use case for this, is to avoid that.
   */
  replaceState: function (newState, callback) {
    this.updater.enqueueReplaceState(this, newState);
    if (callback) {
      this.updater.enqueueCallback(this, callback);
    }
  },

  /**
   * Checks whether or not this composite component is mounted.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function () {
    return this.updater.isMounted(this);
  },

  /**
   * Sets a subset of the props.
   *
   * @param {object} partialProps Subset of the next props.
   * @param {?function} callback Called after props are updated.
   * @final
   * @public
   * @deprecated
   */
  setProps: function (partialProps, callback) {
    if ("production" !== 'production') {
      warnSetProps();
    }
    this.updater.enqueueSetProps(this, partialProps);
    if (callback) {
      this.updater.enqueueCallback(this, callback);
    }
  },

  /**
   * Replace all the props.
   *
   * @param {object} newProps Subset of the next props.
   * @param {?function} callback Called after props are updated.
   * @final
   * @public
   * @deprecated
   */
  replaceProps: function (newProps, callback) {
    if ("production" !== 'production') {
      warnSetProps();
    }
    this.updater.enqueueReplaceProps(this, newProps);
    if (callback) {
      this.updater.enqueueCallback(this, callback);
    }
  }
};

var ReactClassComponent = function () {};
assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);

/**
 * Module for creating composite components.
 *
 * @class ReactClass
 */
var ReactClass = {

  /**
   * Creates a composite component class given a class specification.
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  createClass: function (spec) {
    var Constructor = function (props, context, updater) {
      // This constructor is overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if ("production" !== 'production') {
        "production" !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : undefined;
      }

      // Wire up auto-binding
      if (this.__reactAutoBindMap) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if ("production" !== 'production') {
        // We allow auto-mocks to proceed as if they're returning null.
        if (typeof initialState === 'undefined' && this.getInitialState._isMockFunction) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      !(typeof initialState === 'object' && !Array.isArray(initialState)) ? "production" !== 'production' ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : invariant(false) : undefined;

      this.state = initialState;
    };
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, spec);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if ("production" !== 'production') {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    !Constructor.prototype.render ? "production" !== 'production' ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : invariant(false) : undefined;

    if ("production" !== 'production') {
      "production" !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : undefined;
      "production" !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : undefined;
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  },

  injection: {
    injectMixin: function (mixin) {
      injectedMixins.push(mixin);
    }
  }

};

module.exports = ReactClass;
},{"./Object.assign":321,"./ReactComponent":329,"./ReactElement":351,"./ReactNoopUpdateQueue":368,"./ReactPropTypeLocationNames":371,"./ReactPropTypeLocations":372,"fbjs/lib/emptyObject":436,"fbjs/lib/invariant":443,"fbjs/lib/keyMirror":446,"fbjs/lib/keyOf":447,"fbjs/lib/warning":454}],329:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactComponent
 */

'use strict';

var ReactNoopUpdateQueue = require('./ReactNoopUpdateQueue');

var canDefineProperty = require('./canDefineProperty');
var emptyObject = require('fbjs/lib/emptyObject');
var invariant = require('fbjs/lib/invariant');
var warning = require('fbjs/lib/warning');

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ? "production" !== 'production' ? invariant(false, 'setState(...): takes an object of state variables to update or a ' + 'function which returns an object of state variables.') : invariant(false) : undefined;
  if ("production" !== 'production') {
    "production" !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : undefined;
  }
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback);
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback);
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if ("production" !== 'production') {
  var deprecatedAPIs = {
    getDOMNode: ['getDOMNode', 'Use ReactDOM.findDOMNode(component) instead.'],
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceProps: ['replaceProps', 'Instead, call render again at the top level.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).'],
    setProps: ['setProps', 'Instead, call render again at the top level.']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          "production" !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : undefined;
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

module.exports = ReactComponent;
},{"./ReactNoopUpdateQueue":368,"./canDefineProperty":403,"fbjs/lib/emptyObject":436,"fbjs/lib/invariant":443,"fbjs/lib/warning":454}],330:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactComponentBrowserEnvironment
 */

'use strict';

var ReactDOMIDOperations = require('./ReactDOMIDOperations');
var ReactMount = require('./ReactMount');

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {

  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkupByID: ReactDOMIDOperations.dangerouslyReplaceNodeWithMarkupByID,

  /**
   * If a particular environment requires that some resources be cleaned up,
   * specify this in the injected Mixin. In the DOM, we would likely want to
   * purge any cached node ID lookups.
   *
   * @private
   */
  unmountIDFromEnvironment: function (rootNodeID) {
    ReactMount.purgeID(rootNodeID);
  }

};

module.exports = ReactComponentBrowserEnvironment;
},{"./ReactDOMIDOperations":339,"./ReactMount":364}],331:[function(require,module,exports){
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactComponentEnvironment
 */

'use strict';

var invariant = require('fbjs/lib/invariant');

var injected = false;

var ReactComponentEnvironment = {

  /**
   * Optionally injectable environment dependent cleanup hook. (server vs.
   * browser etc). Example: A browser system caches DOM nodes based on component
   * ID and must remove that cache entry when this instance is unmounted.
   */
  unmountIDFromEnvironment: null,

  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkupByID: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ? "production" !== 'production' ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : invariant(false) : undefined;
      ReactComponentEnvironment.unmountIDFromEnvironment = environment.unmountIDFromEnvironment;
      ReactComponentEnvironment.replaceNodeWithMarkupByID = environment.replaceNodeWithMarkupByID;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }

};

module.exports = ReactComponentEnvironment;
},{"fbjs/lib/invariant":443}],332:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactCompositeComponent
 */

'use strict';

var ReactComponentEnvironment = require('./ReactComponentEnvironment');
var ReactCurrentOwner = require('./ReactCurrentOwner');
var ReactElement = require('./ReactElement');
var ReactInstanceMap = require('./ReactInstanceMap');
var ReactPerf = require('./ReactPerf');
var ReactPropTypeLocations = require('./ReactPropTypeLocations');
var ReactPropTypeLocationNames = require('./ReactPropTypeLocationNames');
var ReactReconciler = require('./ReactReconciler');
var ReactUpdateQueue = require('./ReactUpdateQueue');

var assign = require('./Object.assign');
var emptyObject = require('fbjs/lib/emptyObject');
var invariant = require('fbjs/lib/invariant');
var shouldUpdateReactComponent = require('./shouldUpdateReactComponent');
var warning = require('fbjs/lib/warning');

function getDeclarationErrorAddendum(component) {
  var owner = component._currentElement._owner || null;
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  return Component(this.props, this.context, this.updater);
};

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponentMixin = {

  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = null;
    this._instance = null;

    // See ReactUpdateQueue
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedComponent = null;

    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {string} rootID DOM ID of the root node.
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (rootID, transaction, context) {
    this._context = context;
    this._mountOrder = nextMountID++;
    this._rootNodeID = rootID;

    var publicProps = this._processProps(this._currentElement.props);
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    // Initialize the public class
    var inst;
    var renderedElement;

    // This is a way to detect if Component is a stateless arrow function
    // component, which is not newable. It might not be 100% reliable but is
    // something we can do until we start detecting that Component extends
    // React.Component. We already assume that typeof Component === 'function'.
    var canInstantiate = ('prototype' in Component);

    if (canInstantiate) {
      if ("production" !== 'production') {
        ReactCurrentOwner.current = this;
        try {
          inst = new Component(publicProps, publicContext, ReactUpdateQueue);
        } finally {
          ReactCurrentOwner.current = null;
        }
      } else {
        inst = new Component(publicProps, publicContext, ReactUpdateQueue);
      }
    }

    if (!canInstantiate || inst === null || inst === false || ReactElement.isValidElement(inst)) {
      renderedElement = inst;
      inst = new StatelessComponent(Component);
    }

    if ("production" !== 'production') {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        "production" !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`, returned ' + 'null/false from a stateless component, or tried to render an ' + 'element whose type is a function that isn\'t a React component.', Component.displayName || Component.name || 'Component') : undefined;
      } else {
        // We support ES6 inheriting from React.Component, the module pattern,
        // and stateless components, but not ES6 classes that don't extend
        "production" !== 'production' ? warning(Component.prototype && Component.prototype.isReactComponent || !canInstantiate || !(inst instanceof Component), '%s(...): React component classes must extend React.Component.', Component.displayName || Component.name || 'Component') : undefined;
      }
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = ReactUpdateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if ("production" !== 'production') {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      "production" !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : undefined;
      "production" !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : undefined;
      "production" !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : undefined;
      "production" !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : undefined;
      "production" !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : undefined;
      "production" !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : undefined;
      "production" !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : undefined;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ? "production" !== 'production' ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    if (inst.componentWillMount) {
      inst.componentWillMount();
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    this._renderedComponent = this._instantiateReactComponent(renderedElement);

    var markup = ReactReconciler.mountComponent(this._renderedComponent, rootID, transaction, this._processChildContext(context));
    if (inst.componentDidMount) {
      transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
    }

    return markup;
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function () {
    var inst = this._instance;

    if (inst.componentWillUnmount) {
      inst.componentWillUnmount();
    }

    ReactReconciler.unmountComponent(this._renderedComponent);
    this._renderedComponent = null;
    this._instance = null;

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = null;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var maskedContext = null;
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if ("production" !== 'production') {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkPropTypes(Component.contextTypes, maskedContext, ReactPropTypeLocations.context);
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext = inst.getChildContext && inst.getChildContext();
    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ? "production" !== 'production' ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
      if ("production" !== 'production') {
        this._checkPropTypes(Component.childContextTypes, childContext, ReactPropTypeLocations.childContext);
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ? "production" !== 'production' ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : invariant(false) : undefined;
      }
      return assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Processes props by setting default values for unspecified props and
   * asserting that the props are valid. Does not mutate its argument; returns
   * a new props object with defaults merged in.
   *
   * @param {object} newProps
   * @return {object}
   * @private
   */
  _processProps: function (newProps) {
    if ("production" !== 'production') {
      var Component = this._currentElement.type;
      if (Component.propTypes) {
        this._checkPropTypes(Component.propTypes, newProps, ReactPropTypeLocations.prop);
      }
    }
    return newProps;
  },

  /**
   * Assert that the props are valid
   *
   * @param {object} propTypes Map of prop name to a ReactPropType
   * @param {object} props
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkPropTypes: function (propTypes, props, location) {
    // TODO: Stop validating prop types here and only use the element
    // validation.
    var componentName = this.getName();
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error;
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          !(typeof propTypes[propName] === 'function') ? "production" !== 'production' ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually ' + 'from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : undefined;
          error = propTypes[propName](props, propName, componentName, location);
        } catch (ex) {
          error = ex;
        }
        if (error instanceof Error) {
          // We may want to extend this logic for similar errors in
          // top-level render calls, so I'm abstracting it away into
          // a function to minimize refactoring in the future
          var addendum = getDeclarationErrorAddendum(this);

          if (location === ReactPropTypeLocations.prop) {
            // Preface gives us something to blacklist in warning module
            "production" !== 'production' ? warning(false, 'Failed Composite propType: %s%s', error.message, addendum) : undefined;
          } else {
            "production" !== 'production' ? warning(false, 'Failed Context Types: %s%s', error.message, addendum) : undefined;
          }
        }
      }
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement || this._currentElement, transaction, this._context);
    }

    if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;

    var nextContext = this._context === nextUnmaskedContext ? inst.context : this._processContext(nextUnmaskedContext);
    var nextProps;

    // Distinguish between a props update versus a simple state update
    if (prevParentElement === nextParentElement) {
      // Skip checking prop types again -- we don't read inst.props to avoid
      // warning for DOM component props in this upgrade
      nextProps = nextParentElement.props;
    } else {
      nextProps = this._processProps(nextParentElement.props);
      // An update here will schedule an update but immediately set
      // _pendingStateQueue which will ensure that any state updates gets
      // immediately reconciled instead of waiting for the next batch.

      if (inst.componentWillReceiveProps) {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);

    var shouldUpdate = this._pendingForceUpdate || !inst.shouldComponentUpdate || inst.shouldComponentUpdate(nextProps, nextState, nextContext);

    if ("production" !== 'production') {
      "production" !== 'production' ? warning(typeof shouldUpdate !== 'undefined', '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : undefined;
    }

    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      inst.componentWillUpdate(nextProps, nextState, nextContext);
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();
    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      // These two IDs are actually the same! But nothing should rely on that.
      var thisID = this._rootNodeID;
      var prevComponentID = prevComponentInstance._rootNodeID;
      ReactReconciler.unmountComponent(prevComponentInstance);

      this._renderedComponent = this._instantiateReactComponent(nextRenderedElement);
      var nextMarkup = ReactReconciler.mountComponent(this._renderedComponent, thisID, transaction, this._processChildContext(context));
      this._replaceNodeWithMarkupByID(prevComponentID, nextMarkup);
    }
  },

  /**
   * @protected
   */
  _replaceNodeWithMarkupByID: function (prevComponentID, nextMarkup) {
    ReactComponentEnvironment.replaceNodeWithMarkupByID(prevComponentID, nextMarkup);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedComponent = inst.render();
    if ("production" !== 'production') {
      // We allow auto-mocks to proceed as if they're returning null.
      if (typeof renderedComponent === 'undefined' && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedComponent = null;
      }
    }

    return renderedComponent;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedComponent;
    ReactCurrentOwner.current = this;
    try {
      renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
    } finally {
      ReactCurrentOwner.current = null;
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedComponent === null || renderedComponent === false || ReactElement.isValidElement(renderedComponent)) ? "production" !== 'production' ? invariant(false, '%s.render(): A valid ReactComponent must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
    return renderedComponent;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ? "production" !== 'production' ? invariant(false, 'Stateless function components cannot have refs.') : invariant(false) : undefined;
    var publicComponentInstance = component.getPublicInstance();
    if ("production" !== 'production') {
      var componentName = component && component.getName ? component.getName() : 'a component';
      "production" !== 'production' ? warning(publicComponentInstance != null, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : undefined;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (inst instanceof StatelessComponent) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null

};

ReactPerf.measureMethods(ReactCompositeComponentMixin, 'ReactCompositeComponent', {
  mountComponent: 'mountComponent',
  updateComponent: 'updateComponent',
  _renderValidatedComponent: '_renderValidatedComponent'
});

var ReactCompositeComponent = {

  Mixin: ReactCompositeComponentMixin

};

module.exports = ReactCompositeComponent;
},{"./Object.assign":321,"./ReactComponentEnvironment":331,"./ReactCurrentOwner":333,"./ReactElement":351,"./ReactInstanceMap":361,"./ReactPerf":370,"./ReactPropTypeLocationNames":371,"./ReactPropTypeLocations":372,"./ReactReconciler":375,"./ReactUpdateQueue":381,"./shouldUpdateReactComponent":425,"fbjs/lib/emptyObject":436,"fbjs/lib/invariant":443,"fbjs/lib/warning":454}],333:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactCurrentOwner
 */

'use strict';

/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {

  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null

};

module.exports = ReactCurrentOwner;
},{}],334:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOM
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/

'use strict';

var ReactCurrentOwner = require('./ReactCurrentOwner');
var ReactDOMTextComponent = require('./ReactDOMTextComponent');
var ReactDefaultInjection = require('./ReactDefaultInjection');
var ReactInstanceHandles = require('./ReactInstanceHandles');
var ReactMount = require('./ReactMount');
var ReactPerf = require('./ReactPerf');
var ReactReconciler = require('./ReactReconciler');
var ReactUpdates = require('./ReactUpdates');
var ReactVersion = require('./ReactVersion');

var findDOMNode = require('./findDOMNode');
var renderSubtreeIntoContainer = require('./renderSubtreeIntoContainer');
var warning = require('fbjs/lib/warning');

ReactDefaultInjection.inject();

var render = ReactPerf.measure('React', 'render', ReactMount.render);

var React = {
  findDOMNode: findDOMNode,
  render: render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
/* eslint-enable camelcase */
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    CurrentOwner: ReactCurrentOwner,
    InstanceHandles: ReactInstanceHandles,
    Mount: ReactMount,
    Reconciler: ReactReconciler,
    TextComponent: ReactDOMTextComponent
  });
}

if ("production" !== 'production') {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {

    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        console.debug('Download the React DevTools for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    "production" !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : undefined;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.split, String.prototype.trim,

    // shams
    Object.create, Object.freeze];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        console.error('One or more ES5 shim/shams expected by React are not available: ' + 'https://fb.me/react-warning-polyfills');
        break;
      }
    }
  }
}

module.exports = React;
},{"./ReactCurrentOwner":333,"./ReactDOMTextComponent":345,"./ReactDefaultInjection":348,"./ReactInstanceHandles":360,"./ReactMount":364,"./ReactPerf":370,"./ReactReconciler":375,"./ReactUpdates":382,"./ReactVersion":383,"./findDOMNode":407,"./renderSubtreeIntoContainer":422,"fbjs/lib/ExecutionEnvironment":429,"fbjs/lib/warning":454}],335:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMButton
 */

'use strict';

var mouseListenerNames = {
  onClick: true,
  onDoubleClick: true,
  onMouseDown: true,
  onMouseMove: true,
  onMouseUp: true,

  onClickCapture: true,
  onDoubleClickCapture: true,
  onMouseDownCapture: true,
  onMouseMoveCapture: true,
  onMouseUpCapture: true
};

/**
 * Implements a <button> native component that does not receive mouse events
 * when `disabled` is set.
 */
var ReactDOMButton = {
  getNativeProps: function (inst, props, context) {
    if (!props.disabled) {
      return props;
    }

    // Copy the props, except the mouse listeners
    var nativeProps = {};
    for (var key in props) {
      if (props.hasOwnProperty(key) && !mouseListenerNames[key]) {
        nativeProps[key] = props[key];
      }
    }

    return nativeProps;
  }
};

module.exports = ReactDOMButton;
},{}],336:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMComponent
 * @typechecks static-only
 */

/* global hasOwnProperty:true */

'use strict';

var AutoFocusUtils = require('./AutoFocusUtils');
var CSSPropertyOperations = require('./CSSPropertyOperations');
var DOMProperty = require('./DOMProperty');
var DOMPropertyOperations = require('./DOMPropertyOperations');
var EventConstants = require('./EventConstants');
var ReactBrowserEventEmitter = require('./ReactBrowserEventEmitter');
var ReactComponentBrowserEnvironment = require('./ReactComponentBrowserEnvironment');
var ReactDOMButton = require('./ReactDOMButton');
var ReactDOMInput = require('./ReactDOMInput');
var ReactDOMOption = require('./ReactDOMOption');
var ReactDOMSelect = require('./ReactDOMSelect');
var ReactDOMTextarea = require('./ReactDOMTextarea');
var ReactMount = require('./ReactMount');
var ReactMultiChild = require('./ReactMultiChild');
var ReactPerf = require('./ReactPerf');
var ReactUpdateQueue = require('./ReactUpdateQueue');

var assign = require('./Object.assign');
var canDefineProperty = require('./canDefineProperty');
var escapeTextContentForBrowser = require('./escapeTextContentForBrowser');
var invariant = require('fbjs/lib/invariant');
var isEventSupported = require('./isEventSupported');
var keyOf = require('fbjs/lib/keyOf');
var setInnerHTML = require('./setInnerHTML');
var setTextContent = require('./setTextContent');
var shallowEqual = require('fbjs/lib/shallowEqual');
var validateDOMNesting = require('./validateDOMNesting');
var warning = require('fbjs/lib/warning');

var deleteListener = ReactBrowserEventEmitter.deleteListener;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = ReactBrowserEventEmitter.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { 'string': true, 'number': true };

var CHILDREN = keyOf({ children: null });
var STYLE = keyOf({ style: null });
var HTML = keyOf({ __html: null });

var ELEMENT_NODE_TYPE = 1;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

var legacyPropsDescriptor;
if ("production" !== 'production') {
  legacyPropsDescriptor = {
    props: {
      enumerable: false,
      get: function () {
        var component = this._reactInternalComponent;
        "production" !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .props of a DOM node; instead, ' + 'recreate the props as `render` did originally or read the DOM ' + 'properties/attributes directly from this node (e.g., ' + 'this.refs.box.className).%s', getDeclarationErrorAddendum(component)) : undefined;
        return component._currentElement.props;
      }
    }
  };
}

function legacyGetDOMNode() {
  if ("production" !== 'production') {
    var component = this._reactInternalComponent;
    "production" !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .getDOMNode() of a DOM node; ' + 'instead, use the node directly.%s', getDeclarationErrorAddendum(component)) : undefined;
  }
  return this;
}

function legacyIsMounted() {
  var component = this._reactInternalComponent;
  if ("production" !== 'production') {
    "production" !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .isMounted() of a DOM node.%s', getDeclarationErrorAddendum(component)) : undefined;
  }
  return !!component;
}

function legacySetStateEtc() {
  if ("production" !== 'production') {
    var component = this._reactInternalComponent;
    "production" !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .setState(), .replaceState(), or ' + '.forceUpdate() of a DOM node. This is a no-op.%s', getDeclarationErrorAddendum(component)) : undefined;
  }
}

function legacySetProps(partialProps, callback) {
  var component = this._reactInternalComponent;
  if ("production" !== 'production') {
    "production" !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .setProps() of a DOM node. ' + 'Instead, call ReactDOM.render again at the top level.%s', getDeclarationErrorAddendum(component)) : undefined;
  }
  if (!component) {
    return;
  }
  ReactUpdateQueue.enqueueSetPropsInternal(component, partialProps);
  if (callback) {
    ReactUpdateQueue.enqueueCallbackInternal(component, callback);
  }
}

function legacyReplaceProps(partialProps, callback) {
  var component = this._reactInternalComponent;
  if ("production" !== 'production') {
    "production" !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .replaceProps() of a DOM node. ' + 'Instead, call ReactDOM.render again at the top level.%s', getDeclarationErrorAddendum(component)) : undefined;
  }
  if (!component) {
    return;
  }
  ReactUpdateQueue.enqueueReplacePropsInternal(component, partialProps);
  if (callback) {
    ReactUpdateQueue.enqueueCallbackInternal(component, callback);
  }
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined becauses undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

  "production" !== 'production' ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : undefined;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if ("production" !== 'production') {
    if (voidElementTags[component._tag]) {
      "production" !== 'production' ? warning(props.children == null && props.dangerouslySetInnerHTML == null, '%s is a void element tag and must not have `children` or ' + 'use `props.dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : undefined;
    }
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ? "production" !== 'production' ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : invariant(false) : undefined;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ? "production" !== 'production' ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. ' + 'Please visit https://fb.me/react-invariant-dangerously-set-inner-html ' + 'for more information.') : invariant(false) : undefined;
  }
  if ("production" !== 'production') {
    "production" !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : undefined;
    "production" !== 'production' ? warning(!props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : undefined;
  }
  !(props.style == null || typeof props.style === 'object') ? "production" !== 'production' ? invariant(false, 'The `style` prop expects a mapping from style properties to values, ' + 'not a string. For example, style={{marginRight: spacing + \'em\'}} when ' + 'using JSX.%s', getDeclarationErrorAddendum(component)) : invariant(false) : undefined;
}

function enqueuePutListener(id, registrationName, listener, transaction) {
  if ("production" !== 'production') {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    "production" !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : undefined;
  }
  var container = ReactMount.findReactContainerForID(id);
  if (container) {
    var doc = container.nodeType === ELEMENT_NODE_TYPE ? container.ownerDocument : container;
    listenTo(registrationName, doc);
  }
  transaction.getReactMountReady().enqueue(putListener, {
    id: id,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  ReactBrowserEventEmitter.putListener(listenerToPut.id, listenerToPut.registrationName, listenerToPut.listener);
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ? "production" !== 'production' ? invariant(false, 'Must be mounted to trap events') : invariant(false) : undefined;
  var node = ReactMount.getNode(inst._rootNodeID);
  !node ? "production" !== 'production' ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : invariant(false) : undefined;

  switch (inst._tag) {
    case 'iframe':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
      break;
    case 'video':
    case 'audio':

      inst._wrapperState.listeners = [];
      // create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes[event], mediaEvents[event], node));
        }
      }

      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topReset, 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topSubmit, 'submit', node)];
      break;
  }
}

function mountReadyInputWrapper() {
  ReactDOMInput.mountReadyWrapper(this);
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special cased tags.

var omittedCloseTags = {
  'area': true,
  'base': true,
  'br': true,
  'col': true,
  'embed': true,
  'hr': true,
  'img': true,
  'input': true,
  'keygen': true,
  'link': true,
  'meta': true,
  'param': true,
  'source': true,
  'track': true,
  'wbr': true
};

// NOTE: menuitem's close tag should be omitted, but that causes problems.
var newlineEatingTags = {
  'listing': true,
  'pre': true,
  'textarea': true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = assign({
  'menuitem': true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = ({}).hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ? "production" !== 'production' ? invariant(false, 'Invalid tag: %s', tag) : invariant(false) : undefined;
    validatedTagCache[tag] = true;
  }
}

function processChildContextDev(context, inst) {
  // Pass down our tag name to child components for validation purposes
  context = assign({}, context);
  var info = context[validateDOMNesting.ancestorInfoContextKey];
  context[validateDOMNesting.ancestorInfoContextKey] = validateDOMNesting.updatedAncestorInfo(info, inst._tag, inst);
  return context;
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(tag) {
  validateDangerousTag(tag);
  this._tag = tag.toLowerCase();
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._rootNodeID = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._nodeWithLegacyProperties = null;
  if ("production" !== 'production') {
    this._unprocessedContextDev = null;
    this._processedContextDev = null;
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {

  construct: function (element) {
    this._currentElement = element;
  },

  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {string} rootID The root DOM ID for this node.
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (rootID, transaction, context) {
    this._rootNodeID = rootID;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'iframe':
      case 'img':
      case 'form':
      case 'video':
      case 'audio':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'button':
        props = ReactDOMButton.getNativeProps(this, props, context);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, context);
        props = ReactDOMInput.getNativeProps(this, props, context);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, context);
        props = ReactDOMOption.getNativeProps(this, props, context);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, context);
        props = ReactDOMSelect.getNativeProps(this, props, context);
        context = ReactDOMSelect.processChildContext(this, props, context);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, context);
        props = ReactDOMTextarea.getNativeProps(this, props, context);
        break;
    }

    assertValidProps(this, props);
    if ("production" !== 'production') {
      if (context[validateDOMNesting.ancestorInfoContextKey]) {
        validateDOMNesting(this._tag, this, context[validateDOMNesting.ancestorInfoContextKey]);
      }
    }

    if ("production" !== 'production') {
      this._unprocessedContextDev = context;
      this._processedContextDev = processChildContextDev(context, this);
      context = this._processedContextDev;
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = context[ReactMount.ownerDocumentContextKey];
      var el = ownerDocument.createElement(this._currentElement.type);
      DOMPropertyOperations.setAttributeForID(el, this._rootNodeID);
      // Populate node cache
      ReactMount.getID(el);
      this._updateDOMProperties({}, props, transaction, el);
      this._createInitialChildren(transaction, props, context, el);
      mountImage = el;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(mountReadyInputWrapper, this);
      // falls through
      case 'button':
      case 'select':
      case 'textarea':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this._rootNodeID, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if ("production" !== 'production') {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (propKey !== CHILDREN) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    var markupForID = DOMPropertyOperations.createMarkupForID(this._rootNodeID);
    return ret + ' ' + markupForID;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, el) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        setInnerHTML(el, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        setTextContent(el, contentToUse);
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          el.appendChild(mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a native DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'button':
        lastProps = ReactDOMButton.getNativeProps(this, lastProps);
        nextProps = ReactDOMButton.getNativeProps(this, nextProps);
        break;
      case 'input':
        ReactDOMInput.updateWrapper(this);
        lastProps = ReactDOMInput.getNativeProps(this, lastProps);
        nextProps = ReactDOMInput.getNativeProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getNativeProps(this, lastProps);
        nextProps = ReactDOMOption.getNativeProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getNativeProps(this, lastProps);
        nextProps = ReactDOMSelect.getNativeProps(this, nextProps);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        lastProps = ReactDOMTextarea.getNativeProps(this, lastProps);
        nextProps = ReactDOMTextarea.getNativeProps(this, nextProps);
        break;
    }

    if ("production" !== 'production') {
      // If the context is reference-equal to the old one, pass down the same
      // processed object so the update bailout in ReactReconciler behaves
      // correctly (and identically in dev and prod). See #5005.
      if (this._unprocessedContextDev !== context) {
        this._unprocessedContextDev = context;
        this._processedContextDev = processChildContextDev(context, this);
      }
      context = this._processedContextDev;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction, null);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    if (!canDefineProperty && this._nodeWithLegacyProperties) {
      this._nodeWithLegacyProperties.props = nextProps;
    }

    if (this._tag === 'select') {
      // <select> value update needs to occur after <option> children
      // reconciliation
      transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction, node) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey)) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this._rootNodeID, propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        if (!node) {
          node = ReactMount.getNode(this._rootNodeID);
        }
        DOMPropertyOperations.deleteValueForProperty(node, propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps[propKey];
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if ("production" !== 'production') {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this._rootNodeID, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this._rootNodeID, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!node) {
          node = ReactMount.getNode(this._rootNodeID);
        }
        if (propKey === CHILDREN) {
          nextProp = null;
        }
        DOMPropertyOperations.setValueForAttribute(node, propKey, nextProp);
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        if (!node) {
          node = ReactMount.getNode(this._rootNodeID);
        }
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertantly setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      if (!node) {
        node = ReactMount.getNode(this._rootNodeID);
      }
      CSSPropertyOperations.setValueForStyles(node, styleUpdates);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
    } else if (nextChildren != null) {
      this.updateChildren(nextChildren, transaction, context);
    }
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function () {
    switch (this._tag) {
      case 'iframe':
      case 'img':
      case 'form':
      case 'video':
      case 'audio':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'input':
        ReactDOMInput.unmountWrapper(this);
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
        !false ? "production" !== 'production' ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is ' + 'impossible to unmount some top-level components (eg <html>, ' + '<head>, and <body>) reliably and efficiently. To fix this, have a ' + 'single top-level component that never unmounts render these ' + 'elements.', this._tag) : invariant(false) : undefined;
        break;
    }

    this.unmountChildren();
    ReactBrowserEventEmitter.deleteAllListeners(this._rootNodeID);
    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
    this._rootNodeID = null;
    this._wrapperState = null;
    if (this._nodeWithLegacyProperties) {
      var node = this._nodeWithLegacyProperties;
      node._reactInternalComponent = null;
      this._nodeWithLegacyProperties = null;
    }
  },

  getPublicInstance: function () {
    if (!this._nodeWithLegacyProperties) {
      var node = ReactMount.getNode(this._rootNodeID);

      node._reactInternalComponent = this;
      node.getDOMNode = legacyGetDOMNode;
      node.isMounted = legacyIsMounted;
      node.setState = legacySetStateEtc;
      node.replaceState = legacySetStateEtc;
      node.forceUpdate = legacySetStateEtc;
      node.setProps = legacySetProps;
      node.replaceProps = legacyReplaceProps;

      if ("production" !== 'production') {
        if (canDefineProperty) {
          Object.defineProperties(node, legacyPropsDescriptor);
        } else {
          // updateComponent will update this property on subsequent renders
          node.props = this._currentElement.props;
        }
      } else {
        // updateComponent will update this property on subsequent renders
        node.props = this._currentElement.props;
      }

      this._nodeWithLegacyProperties = node;
    }
    return this._nodeWithLegacyProperties;
  }

};

ReactPerf.measureMethods(ReactDOMComponent, 'ReactDOMComponent', {
  mountComponent: 'mountComponent',
  updateComponent: 'updateComponent'
});

assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;
},{"./AutoFocusUtils":300,"./CSSPropertyOperations":303,"./DOMProperty":308,"./DOMPropertyOperations":309,"./EventConstants":313,"./Object.assign":321,"./ReactBrowserEventEmitter":325,"./ReactComponentBrowserEnvironment":330,"./ReactDOMButton":335,"./ReactDOMInput":340,"./ReactDOMOption":341,"./ReactDOMSelect":342,"./ReactDOMTextarea":346,"./ReactMount":364,"./ReactMultiChild":365,"./ReactPerf":370,"./ReactUpdateQueue":381,"./canDefineProperty":403,"./escapeTextContentForBrowser":406,"./isEventSupported":418,"./setInnerHTML":423,"./setTextContent":424,"./validateDOMNesting":427,"fbjs/lib/invariant":443,"fbjs/lib/keyOf":447,"fbjs/lib/shallowEqual":452,"fbjs/lib/warning":454}],337:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMFactories
 * @typechecks static-only
 */

'use strict';

var ReactElement = require('./ReactElement');
var ReactElementValidator = require('./ReactElementValidator');

var mapObject = require('fbjs/lib/mapObject');

/**
 * Create a factory that creates HTML tag elements.
 *
 * @param {string} tag Tag name (e.g. `div`).
 * @private
 */
function createDOMFactory(tag) {
  if ("production" !== 'production') {
    return ReactElementValidator.createFactory(tag);
  }
  return ReactElement.createFactory(tag);
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 * This is also accessible via `React.DOM`.
 *
 * @public
 */
var ReactDOMFactories = mapObject({
  a: 'a',
  abbr: 'abbr',
  address: 'address',
  area: 'area',
  article: 'article',
  aside: 'aside',
  audio: 'audio',
  b: 'b',
  base: 'base',
  bdi: 'bdi',
  bdo: 'bdo',
  big: 'big',
  blockquote: 'blockquote',
  body: 'body',
  br: 'br',
  button: 'button',
  canvas: 'canvas',
  caption: 'caption',
  cite: 'cite',
  code: 'code',
  col: 'col',
  colgroup: 'colgroup',
  data: 'data',
  datalist: 'datalist',
  dd: 'dd',
  del: 'del',
  details: 'details',
  dfn: 'dfn',
  dialog: 'dialog',
  div: 'div',
  dl: 'dl',
  dt: 'dt',
  em: 'em',
  embed: 'embed',
  fieldset: 'fieldset',
  figcaption: 'figcaption',
  figure: 'figure',
  footer: 'footer',
  form: 'form',
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  head: 'head',
  header: 'header',
  hgroup: 'hgroup',
  hr: 'hr',
  html: 'html',
  i: 'i',
  iframe: 'iframe',
  img: 'img',
  input: 'input',
  ins: 'ins',
  kbd: 'kbd',
  keygen: 'keygen',
  label: 'label',
  legend: 'legend',
  li: 'li',
  link: 'link',
  main: 'main',
  map: 'map',
  mark: 'mark',
  menu: 'menu',
  menuitem: 'menuitem',
  meta: 'meta',
  meter: 'meter',
  nav: 'nav',
  noscript: 'noscript',
  object: 'object',
  ol: 'ol',
  optgroup: 'optgroup',
  option: 'option',
  output: 'output',
  p: 'p',
  param: 'param',
  picture: 'picture',
  pre: 'pre',
  progress: 'progress',
  q: 'q',
  rp: 'rp',
  rt: 'rt',
  ruby: 'ruby',
  s: 's',
  samp: 'samp',
  script: 'script',
  section: 'section',
  select: 'select',
  small: 'small',
  source: 'source',
  span: 'span',
  strong: 'strong',
  style: 'style',
  sub: 'sub',
  summary: 'summary',
  sup: 'sup',
  table: 'table',
  tbody: 'tbody',
  td: 'td',
  textarea: 'textarea',
  tfoot: 'tfoot',
  th: 'th',
  thead: 'thead',
  time: 'time',
  title: 'title',
  tr: 'tr',
  track: 'track',
  u: 'u',
  ul: 'ul',
  'var': 'var',
  video: 'video',
  wbr: 'wbr',

  // SVG
  circle: 'circle',
  clipPath: 'clipPath',
  defs: 'defs',
  ellipse: 'ellipse',
  g: 'g',
  image: 'image',
  line: 'line',
  linearGradient: 'linearGradient',
  mask: 'mask',
  path: 'path',
  pattern: 'pattern',
  polygon: 'polygon',
  polyline: 'polyline',
  radialGradient: 'radialGradient',
  rect: 'rect',
  stop: 'stop',
  svg: 'svg',
  text: 'text',
  tspan: 'tspan'

}, createDOMFactory);

module.exports = ReactDOMFactories;
},{"./ReactElement":351,"./ReactElementValidator":352,"fbjs/lib/mapObject":448}],338:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMFeatureFlags
 */

'use strict';

var ReactDOMFeatureFlags = {
  useCreateElement: false
};

module.exports = ReactDOMFeatureFlags;
},{}],339:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMIDOperations
 * @typechecks static-only
 */

'use strict';

var DOMChildrenOperations = require('./DOMChildrenOperations');
var DOMPropertyOperations = require('./DOMPropertyOperations');
var ReactMount = require('./ReactMount');
var ReactPerf = require('./ReactPerf');

var invariant = require('fbjs/lib/invariant');

/**
 * Errors for properties that should not be updated with `updatePropertyByID()`.
 *
 * @type {object}
 * @private
 */
var INVALID_PROPERTY_ERRORS = {
  dangerouslySetInnerHTML: '`dangerouslySetInnerHTML` must be set using `updateInnerHTMLByID()`.',
  style: '`style` must be set using `updateStylesByID()`.'
};

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {

  /**
   * Updates a DOM node with new property values. This should only be used to
   * update DOM properties in `DOMProperty`.
   *
   * @param {string} id ID of the node to update.
   * @param {string} name A valid property name, see `DOMProperty`.
   * @param {*} value New value of the property.
   * @internal
   */
  updatePropertyByID: function (id, name, value) {
    var node = ReactMount.getNode(id);
    !!INVALID_PROPERTY_ERRORS.hasOwnProperty(name) ? "production" !== 'production' ? invariant(false, 'updatePropertyByID(...): %s', INVALID_PROPERTY_ERRORS[name]) : invariant(false) : undefined;

    // If we're updating to null or undefined, we should remove the property
    // from the DOM node instead of inadvertantly setting to a string. This
    // brings us in line with the same behavior we have on initial render.
    if (value != null) {
      DOMPropertyOperations.setValueForProperty(node, name, value);
    } else {
      DOMPropertyOperations.deleteValueForProperty(node, name);
    }
  },

  /**
   * Replaces a DOM node that exists in the document with markup.
   *
   * @param {string} id ID of child to be replaced.
   * @param {string} markup Dangerous markup to inject in place of child.
   * @internal
   * @see {Danger.dangerouslyReplaceNodeWithMarkup}
   */
  dangerouslyReplaceNodeWithMarkupByID: function (id, markup) {
    var node = ReactMount.getNode(id);
    DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup(node, markup);
  },

  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @param {array<string>} markup List of markup strings.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (updates, markup) {
    for (var i = 0; i < updates.length; i++) {
      updates[i].parentNode = ReactMount.getNode(updates[i].parentID);
    }
    DOMChildrenOperations.processUpdates(updates, markup);
  }
};

ReactPerf.measureMethods(ReactDOMIDOperations, 'ReactDOMIDOperations', {
  dangerouslyReplaceNodeWithMarkupByID: 'dangerouslyReplaceNodeWithMarkupByID',
  dangerouslyProcessChildrenUpdates: 'dangerouslyProcessChildrenUpdates'
});

module.exports = ReactDOMIDOperations;
},{"./DOMChildrenOperations":307,"./DOMPropertyOperations":309,"./ReactMount":364,"./ReactPerf":370,"fbjs/lib/invariant":443}],340:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMInput
 */

'use strict';

var ReactDOMIDOperations = require('./ReactDOMIDOperations');
var LinkedValueUtils = require('./LinkedValueUtils');
var ReactMount = require('./ReactMount');
var ReactUpdates = require('./ReactUpdates');

var assign = require('./Object.assign');
var invariant = require('fbjs/lib/invariant');

var instancesByReactID = {};

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

/**
 * Implements an <input> native component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getNativeProps: function (inst, props, context) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var nativeProps = assign({}, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return nativeProps;
  },

  mountWrapper: function (inst, props) {
    if ("production" !== 'production') {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.defaultChecked || false,
      initialValue: defaultValue != null ? defaultValue : null,
      onChange: _handleChange.bind(inst)
    };
  },

  mountReadyWrapper: function (inst) {
    // Can't be in mountWrapper or else server rendering leaks.
    instancesByReactID[inst._rootNodeID] = inst;
  },

  unmountWrapper: function (inst) {
    delete instancesByReactID[inst._rootNodeID];
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'checked', checked || false);
    }

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'value', '' + value);
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactMount.getNode(this._rootNodeID);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React with non-React.
      var otherID = ReactMount.getID(otherNode);
      !otherID ? "production" !== 'production' ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the ' + 'same `name` is not supported.') : invariant(false) : undefined;
      var otherInstance = instancesByReactID[otherID];
      !otherInstance ? "production" !== 'production' ? invariant(false, 'ReactDOMInput: Unknown radio button ID %s.', otherID) : invariant(false) : undefined;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;
},{"./LinkedValueUtils":320,"./Object.assign":321,"./ReactDOMIDOperations":339,"./ReactMount":364,"./ReactUpdates":382,"fbjs/lib/invariant":443}],341:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMOption
 */

'use strict';

var ReactChildren = require('./ReactChildren');
var ReactDOMSelect = require('./ReactDOMSelect');

var assign = require('./Object.assign');
var warning = require('fbjs/lib/warning');

var valueContextKey = ReactDOMSelect.valueContextKey;

/**
 * Implements an <option> native component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, context) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if ("production" !== 'production') {
      "production" !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : undefined;
    }

    // Look up whether this option is 'selected' via context
    var selectValue = context[valueContextKey];

    // If context key is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === '' + props.value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === '' + props.value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  getNativeProps: function (inst, props, context) {
    var nativeProps = assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      nativeProps.selected = inst._wrapperState.selected;
    }

    var content = '';

    // Flatten children and warn if they aren't strings or numbers;
    // invalid types are ignored.
    ReactChildren.forEach(props.children, function (child) {
      if (child == null) {
        return;
      }
      if (typeof child === 'string' || typeof child === 'number') {
        content += child;
      } else {
        "production" !== 'production' ? warning(false, 'Only strings and numbers are supported as <option> children.') : undefined;
      }
    });

    nativeProps.children = content;
    return nativeProps;
  }

};

module.exports = ReactDOMOption;
},{"./Object.assign":321,"./ReactChildren":327,"./ReactDOMSelect":342,"fbjs/lib/warning":454}],342:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMSelect
 */

'use strict';

var LinkedValueUtils = require('./LinkedValueUtils');
var ReactMount = require('./ReactMount');
var ReactUpdates = require('./ReactUpdates');

var assign = require('./Object.assign');
var warning = require('fbjs/lib/warning');

var valueContextKey = '__ReactDOMSelect_value$' + Math.random().toString(36).slice(2);

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, props, value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    if (props.multiple) {
      "production" !== 'production' ? warning(Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : undefined;
    } else {
      "production" !== 'production' ? warning(!Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : undefined;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactMount.getNode(inst._rootNodeID).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> native component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  valueContextKey: valueContextKey,

  getNativeProps: function (inst, props, context) {
    return assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if ("production" !== 'production') {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };
  },

  processChildContext: function (inst, props, context) {
    // Pass down initial value so initial generated markup has correct
    // `selected` attributes
    var childContext = assign({}, context);
    childContext[valueContextKey] = inst._wrapperState.initialValue;
    return childContext;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // the context value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  this._wrapperState.pendingUpdate = true;
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;
},{"./LinkedValueUtils":320,"./Object.assign":321,"./ReactMount":364,"./ReactUpdates":382,"fbjs/lib/warning":454}],343:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMSelection
 */

'use strict';

var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');

var getNodeForCharacterOffset = require('./getNodeForCharacterOffset');
var getTextContentAccessor = require('./getTextContentAccessor');

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (typeof offsets.end === 'undefined') {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = typeof offsets.end === 'undefined' ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;
},{"./getNodeForCharacterOffset":415,"./getTextContentAccessor":416,"fbjs/lib/ExecutionEnvironment":429}],344:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMServer
 */

'use strict';

var ReactDefaultInjection = require('./ReactDefaultInjection');
var ReactServerRendering = require('./ReactServerRendering');
var ReactVersion = require('./ReactVersion');

ReactDefaultInjection.inject();

var ReactDOMServer = {
  renderToString: ReactServerRendering.renderToString,
  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
  version: ReactVersion
};

module.exports = ReactDOMServer;
},{"./ReactDefaultInjection":348,"./ReactServerRendering":379,"./ReactVersion":383}],345:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMTextComponent
 * @typechecks static-only
 */

'use strict';

var DOMChildrenOperations = require('./DOMChildrenOperations');
var DOMPropertyOperations = require('./DOMPropertyOperations');
var ReactComponentBrowserEnvironment = require('./ReactComponentBrowserEnvironment');
var ReactMount = require('./ReactMount');

var assign = require('./Object.assign');
var escapeTextContentForBrowser = require('./escapeTextContentForBrowser');
var setTextContent = require('./setTextContent');
var validateDOMNesting = require('./validateDOMNesting');

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings in elements so that they can undergo
 * the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (props) {
  // This constructor and its argument is currently used by mocks.
};

assign(ReactDOMTextComponent.prototype, {

  /**
   * @param {ReactText} text
   * @internal
   */
  construct: function (text) {
    // TODO: This is really a ReactText (ReactNode), not a ReactElement
    this._currentElement = text;
    this._stringText = '' + text;

    // Properties
    this._rootNodeID = null;
    this._mountIndex = 0;
  },

  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {string} rootID DOM ID of the root node.
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (rootID, transaction, context) {
    if ("production" !== 'production') {
      if (context[validateDOMNesting.ancestorInfoContextKey]) {
        validateDOMNesting('span', null, context[validateDOMNesting.ancestorInfoContextKey]);
      }
    }

    this._rootNodeID = rootID;
    if (transaction.useCreateElement) {
      var ownerDocument = context[ReactMount.ownerDocumentContextKey];
      var el = ownerDocument.createElement('span');
      DOMPropertyOperations.setAttributeForID(el, rootID);
      // Populate node cache
      ReactMount.getID(el);
      setTextContent(el, this._stringText);
      return el;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this in a `span` for the reasons stated above, but
        // since this is a situation where React won't take over (static pages),
        // we can simply return the text as it is.
        return escapedText;
      }

      return '<span ' + DOMPropertyOperations.createMarkupForID(rootID) + '>' + escapedText + '</span>';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var node = ReactMount.getNode(this._rootNodeID);
        DOMChildrenOperations.updateTextContent(node, nextStringText);
      }
    }
  },

  unmountComponent: function () {
    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
  }

});

module.exports = ReactDOMTextComponent;
},{"./DOMChildrenOperations":307,"./DOMPropertyOperations":309,"./Object.assign":321,"./ReactComponentBrowserEnvironment":330,"./ReactMount":364,"./escapeTextContentForBrowser":406,"./setTextContent":424,"./validateDOMNesting":427}],346:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMTextarea
 */

'use strict';

var LinkedValueUtils = require('./LinkedValueUtils');
var ReactDOMIDOperations = require('./ReactDOMIDOperations');
var ReactUpdates = require('./ReactUpdates');

var assign = require('./Object.assign');
var invariant = require('fbjs/lib/invariant');
var warning = require('fbjs/lib/warning');

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> native component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getNativeProps: function (inst, props, context) {
    !(props.dangerouslySetInnerHTML == null) ? "production" !== 'production' ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : invariant(false) : undefined;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.
    var nativeProps = assign({}, props, {
      defaultValue: undefined,
      value: undefined,
      children: inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return nativeProps;
  },

  mountWrapper: function (inst, props) {
    if ("production" !== 'production') {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
    }

    var defaultValue = props.defaultValue;
    // TODO (yungsters): Remove support for children content in <textarea>.
    var children = props.children;
    if (children != null) {
      if ("production" !== 'production') {
        "production" !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : undefined;
      }
      !(defaultValue == null) ? "production" !== 'production' ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : invariant(false) : undefined;
      if (Array.isArray(children)) {
        !(children.length <= 1) ? "production" !== 'production' ? invariant(false, '<textarea> can only have at most one child.') : invariant(false) : undefined;
        children = children[0];
      }

      defaultValue = '' + children;
    }
    if (defaultValue == null) {
      defaultValue = '';
    }
    var value = LinkedValueUtils.getValue(props);

    inst._wrapperState = {
      // We save the initial value so that `ReactDOMComponent` doesn't update
      // `textContent` (unnecessary since we update value).
      // The initial value can be a boolean or object so that's why it's
      // forced to be a string.
      initialValue: '' + (value != null ? value : defaultValue),
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'value', '' + value);
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;
},{"./LinkedValueUtils":320,"./Object.assign":321,"./ReactDOMIDOperations":339,"./ReactUpdates":382,"fbjs/lib/invariant":443,"fbjs/lib/warning":454}],347:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDefaultBatchingStrategy
 */

'use strict';

var ReactUpdates = require('./ReactUpdates');
var Transaction = require('./Transaction');

var assign = require('./Object.assign');
var emptyFunction = require('fbjs/lib/emptyFunction');

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction.Mixin, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      callback(a, b, c, d, e);
    } else {
      transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;
},{"./Object.assign":321,"./ReactUpdates":382,"./Transaction":399,"fbjs/lib/emptyFunction":435}],348:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDefaultInjection
 */

'use strict';

var BeforeInputEventPlugin = require('./BeforeInputEventPlugin');
var ChangeEventPlugin = require('./ChangeEventPlugin');
var ClientReactRootIndex = require('./ClientReactRootIndex');
var DefaultEventPluginOrder = require('./DefaultEventPluginOrder');
var EnterLeaveEventPlugin = require('./EnterLeaveEventPlugin');
var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
var HTMLDOMPropertyConfig = require('./HTMLDOMPropertyConfig');
var ReactBrowserComponentMixin = require('./ReactBrowserComponentMixin');
var ReactComponentBrowserEnvironment = require('./ReactComponentBrowserEnvironment');
var ReactDefaultBatchingStrategy = require('./ReactDefaultBatchingStrategy');
var ReactDOMComponent = require('./ReactDOMComponent');
var ReactDOMTextComponent = require('./ReactDOMTextComponent');
var ReactEventListener = require('./ReactEventListener');
var ReactInjection = require('./ReactInjection');
var ReactInstanceHandles = require('./ReactInstanceHandles');
var ReactMount = require('./ReactMount');
var ReactReconcileTransaction = require('./ReactReconcileTransaction');
var SelectEventPlugin = require('./SelectEventPlugin');
var ServerReactRootIndex = require('./ServerReactRootIndex');
var SimpleEventPlugin = require('./SimpleEventPlugin');
var SVGDOMPropertyConfig = require('./SVGDOMPropertyConfig');

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginHub.injectInstanceHandle(ReactInstanceHandles);
  ReactInjection.EventPluginHub.injectMount(ReactMount);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.NativeComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.NativeComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.Class.injectMixin(ReactBrowserComponentMixin);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponent('noscript');

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.RootIndex.injectCreateReactRootIndex(ExecutionEnvironment.canUseDOM ? ClientReactRootIndex.createReactRootIndex : ServerReactRootIndex.createReactRootIndex);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);

  if ("production" !== 'production') {
    var url = ExecutionEnvironment.canUseDOM && window.location.href || '';
    if (/[?&]react_perf\b/.test(url)) {
      var ReactDefaultPerf = require('./ReactDefaultPerf');
      ReactDefaultPerf.start();
    }
  }
}

module.exports = {
  inject: inject
};
},{"./BeforeInputEventPlugin":301,"./ChangeEventPlugin":305,"./ClientReactRootIndex":306,"./DefaultEventPluginOrder":311,"./EnterLeaveEventPlugin":312,"./HTMLDOMPropertyConfig":319,"./ReactBrowserComponentMixin":324,"./ReactComponentBrowserEnvironment":330,"./ReactDOMComponent":336,"./ReactDOMTextComponent":345,"./ReactDefaultBatchingStrategy":347,"./ReactDefaultPerf":349,"./ReactEventListener":357,"./ReactInjection":358,"./ReactInstanceHandles":360,"./ReactMount":364,"./ReactReconcileTransaction":374,"./SVGDOMPropertyConfig":384,"./SelectEventPlugin":385,"./ServerReactRootIndex":386,"./SimpleEventPlugin":387,"fbjs/lib/ExecutionEnvironment":429}],349:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDefaultPerf
 * @typechecks static-only
 */

'use strict';

var DOMProperty = require('./DOMProperty');
var ReactDefaultPerfAnalysis = require('./ReactDefaultPerfAnalysis');
var ReactMount = require('./ReactMount');
var ReactPerf = require('./ReactPerf');

var performanceNow = require('fbjs/lib/performanceNow');

function roundFloat(val) {
  return Math.floor(val * 100) / 100;
}

function addValue(obj, key, val) {
  obj[key] = (obj[key] || 0) + val;
}

var ReactDefaultPerf = {
  _allMeasurements: [], // last item in the list is the current one
  _mountStack: [0],
  _injected: false,

  start: function () {
    if (!ReactDefaultPerf._injected) {
      ReactPerf.injection.injectMeasure(ReactDefaultPerf.measure);
    }

    ReactDefaultPerf._allMeasurements.length = 0;
    ReactPerf.enableMeasure = true;
  },

  stop: function () {
    ReactPerf.enableMeasure = false;
  },

  getLastMeasurements: function () {
    return ReactDefaultPerf._allMeasurements;
  },

  printExclusive: function (measurements) {
    measurements = measurements || ReactDefaultPerf._allMeasurements;
    var summary = ReactDefaultPerfAnalysis.getExclusiveSummary(measurements);
    console.table(summary.map(function (item) {
      return {
        'Component class name': item.componentName,
        'Total inclusive time (ms)': roundFloat(item.inclusive),
        'Exclusive mount time (ms)': roundFloat(item.exclusive),
        'Exclusive render time (ms)': roundFloat(item.render),
        'Mount time per instance (ms)': roundFloat(item.exclusive / item.count),
        'Render time per instance (ms)': roundFloat(item.render / item.count),
        'Instances': item.count
      };
    }));
    // TODO: ReactDefaultPerfAnalysis.getTotalTime() does not return the correct
    // number.
  },

  printInclusive: function (measurements) {
    measurements = measurements || ReactDefaultPerf._allMeasurements;
    var summary = ReactDefaultPerfAnalysis.getInclusiveSummary(measurements);
    console.table(summary.map(function (item) {
      return {
        'Owner > component': item.componentName,
        'Inclusive time (ms)': roundFloat(item.time),
        'Instances': item.count
      };
    }));
    console.log('Total time:', ReactDefaultPerfAnalysis.getTotalTime(measurements).toFixed(2) + ' ms');
  },

  getMeasurementsSummaryMap: function (measurements) {
    var summary = ReactDefaultPerfAnalysis.getInclusiveSummary(measurements, true);
    return summary.map(function (item) {
      return {
        'Owner > component': item.componentName,
        'Wasted time (ms)': item.time,
        'Instances': item.count
      };
    });
  },

  printWasted: function (measurements) {
    measurements = measurements || ReactDefaultPerf._allMeasurements;
    console.table(ReactDefaultPerf.getMeasurementsSummaryMap(measurements));
    console.log('Total time:', ReactDefaultPerfAnalysis.getTotalTime(measurements).toFixed(2) + ' ms');
  },

  printDOM: function (measurements) {
    measurements = measurements || ReactDefaultPerf._allMeasurements;
    var summary = ReactDefaultPerfAnalysis.getDOMSummary(measurements);
    console.table(summary.map(function (item) {
      var result = {};
      result[DOMProperty.ID_ATTRIBUTE_NAME] = item.id;
      result.type = item.type;
      result.args = JSON.stringify(item.args);
      return result;
    }));
    console.log('Total time:', ReactDefaultPerfAnalysis.getTotalTime(measurements).toFixed(2) + ' ms');
  },

  _recordWrite: function (id, fnName, totalTime, args) {
    // TODO: totalTime isn't that useful since it doesn't count paints/reflows
    var writes = ReactDefaultPerf._allMeasurements[ReactDefaultPerf._allMeasurements.length - 1].writes;
    writes[id] = writes[id] || [];
    writes[id].push({
      type: fnName,
      time: totalTime,
      args: args
    });
  },

  measure: function (moduleName, fnName, func) {
    return function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var totalTime;
      var rv;
      var start;

      if (fnName === '_renderNewRootComponent' || fnName === 'flushBatchedUpdates') {
        // A "measurement" is a set of metrics recorded for each flush. We want
        // to group the metrics for a given flush together so we can look at the
        // components that rendered and the DOM operations that actually
        // happened to determine the amount of "wasted work" performed.
        ReactDefaultPerf._allMeasurements.push({
          exclusive: {},
          inclusive: {},
          render: {},
          counts: {},
          writes: {},
          displayNames: {},
          totalTime: 0,
          created: {}
        });
        start = performanceNow();
        rv = func.apply(this, args);
        ReactDefaultPerf._allMeasurements[ReactDefaultPerf._allMeasurements.length - 1].totalTime = performanceNow() - start;
        return rv;
      } else if (fnName === '_mountImageIntoNode' || moduleName === 'ReactBrowserEventEmitter' || moduleName === 'ReactDOMIDOperations' || moduleName === 'CSSPropertyOperations' || moduleName === 'DOMChildrenOperations' || moduleName === 'DOMPropertyOperations') {
        start = performanceNow();
        rv = func.apply(this, args);
        totalTime = performanceNow() - start;

        if (fnName === '_mountImageIntoNode') {
          var mountID = ReactMount.getID(args[1]);
          ReactDefaultPerf._recordWrite(mountID, fnName, totalTime, args[0]);
        } else if (fnName === 'dangerouslyProcessChildrenUpdates') {
          // special format
          args[0].forEach(function (update) {
            var writeArgs = {};
            if (update.fromIndex !== null) {
              writeArgs.fromIndex = update.fromIndex;
            }
            if (update.toIndex !== null) {
              writeArgs.toIndex = update.toIndex;
            }
            if (update.textContent !== null) {
              writeArgs.textContent = update.textContent;
            }
            if (update.markupIndex !== null) {
              writeArgs.markup = args[1][update.markupIndex];
            }
            ReactDefaultPerf._recordWrite(update.parentID, update.type, totalTime, writeArgs);
          });
        } else {
          // basic format
          var id = args[0];
          if (typeof id === 'object') {
            id = ReactMount.getID(args[0]);
          }
          ReactDefaultPerf._recordWrite(id, fnName, totalTime, Array.prototype.slice.call(args, 1));
        }
        return rv;
      } else if (moduleName === 'ReactCompositeComponent' && (fnName === 'mountComponent' || fnName === 'updateComponent' || // TODO: receiveComponent()?
      fnName === '_renderValidatedComponent')) {

        if (this._currentElement.type === ReactMount.TopLevelWrapper) {
          return func.apply(this, args);
        }

        var rootNodeID = fnName === 'mountComponent' ? args[0] : this._rootNodeID;
        var isRender = fnName === '_renderValidatedComponent';
        var isMount = fnName === 'mountComponent';

        var mountStack = ReactDefaultPerf._mountStack;
        var entry = ReactDefaultPerf._allMeasurements[ReactDefaultPerf._allMeasurements.length - 1];

        if (isRender) {
          addValue(entry.counts, rootNodeID, 1);
        } else if (isMount) {
          entry.created[rootNodeID] = true;
          mountStack.push(0);
        }

        start = performanceNow();
        rv = func.apply(this, args);
        totalTime = performanceNow() - start;

        if (isRender) {
          addValue(entry.render, rootNodeID, totalTime);
        } else if (isMount) {
          var subMountTime = mountStack.pop();
          mountStack[mountStack.length - 1] += totalTime;
          addValue(entry.exclusive, rootNodeID, totalTime - subMountTime);
          addValue(entry.inclusive, rootNodeID, totalTime);
        } else {
          addValue(entry.inclusive, rootNodeID, totalTime);
        }

        entry.displayNames[rootNodeID] = {
          current: this.getName(),
          owner: this._currentElement._owner ? this._currentElement._owner.getName() : '<root>'
        };

        return rv;
      } else {
        return func.apply(this, args);
      }
    };
  }
};

module.exports = ReactDefaultPerf;
},{"./DOMProperty":308,"./ReactDefaultPerfAnalysis":350,"./ReactMount":364,"./ReactPerf":370,"fbjs/lib/performanceNow":451}],350:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDefaultPerfAnalysis
 */

'use strict';

var assign = require('./Object.assign');

// Don't try to save users less than 1.2ms (a number I made up)
var DONT_CARE_THRESHOLD = 1.2;
var DOM_OPERATION_TYPES = {
  '_mountImageIntoNode': 'set innerHTML',
  INSERT_MARKUP: 'set innerHTML',
  MOVE_EXISTING: 'move',
  REMOVE_NODE: 'remove',
  SET_MARKUP: 'set innerHTML',
  TEXT_CONTENT: 'set textContent',
  'setValueForProperty': 'update attribute',
  'setValueForAttribute': 'update attribute',
  'deleteValueForProperty': 'remove attribute',
  'dangerouslyReplaceNodeWithMarkupByID': 'replace'
};

function getTotalTime(measurements) {
  // TODO: return number of DOM ops? could be misleading.
  // TODO: measure dropped frames after reconcile?
  // TODO: log total time of each reconcile and the top-level component
  // class that triggered it.
  var totalTime = 0;
  for (var i = 0; i < measurements.length; i++) {
    var measurement = measurements[i];
    totalTime += measurement.totalTime;
  }
  return totalTime;
}

function getDOMSummary(measurements) {
  var items = [];
  measurements.forEach(function (measurement) {
    Object.keys(measurement.writes).forEach(function (id) {
      measurement.writes[id].forEach(function (write) {
        items.push({
          id: id,
          type: DOM_OPERATION_TYPES[write.type] || write.type,
          args: write.args
        });
      });
    });
  });
  return items;
}

function getExclusiveSummary(measurements) {
  var candidates = {};
  var displayName;

  for (var i = 0; i < measurements.length; i++) {
    var measurement = measurements[i];
    var allIDs = assign({}, measurement.exclusive, measurement.inclusive);

    for (var id in allIDs) {
      displayName = measurement.displayNames[id].current;

      candidates[displayName] = candidates[displayName] || {
        componentName: displayName,
        inclusive: 0,
        exclusive: 0,
        render: 0,
        count: 0
      };
      if (measurement.render[id]) {
        candidates[displayName].render += measurement.render[id];
      }
      if (measurement.exclusive[id]) {
        candidates[displayName].exclusive += measurement.exclusive[id];
      }
      if (measurement.inclusive[id]) {
        candidates[displayName].inclusive += measurement.inclusive[id];
      }
      if (measurement.counts[id]) {
        candidates[displayName].count += measurement.counts[id];
      }
    }
  }

  // Now make a sorted array with the results.
  var arr = [];
  for (displayName in candidates) {
    if (candidates[displayName].exclusive >= DONT_CARE_THRESHOLD) {
      arr.push(candidates[displayName]);
    }
  }

  arr.sort(function (a, b) {
    return b.exclusive - a.exclusive;
  });

  return arr;
}

function getInclusiveSummary(measurements, onlyClean) {
  var candidates = {};
  var inclusiveKey;

  for (var i = 0; i < measurements.length; i++) {
    var measurement = measurements[i];
    var allIDs = assign({}, measurement.exclusive, measurement.inclusive);
    var cleanComponents;

    if (onlyClean) {
      cleanComponents = getUnchangedComponents(measurement);
    }

    for (var id in allIDs) {
      if (onlyClean && !cleanComponents[id]) {
        continue;
      }

      var displayName = measurement.displayNames[id];

      // Inclusive time is not useful for many components without knowing where
      // they are instantiated. So we aggregate inclusive time with both the
      // owner and current displayName as the key.
      inclusiveKey = displayName.owner + ' > ' + displayName.current;

      candidates[inclusiveKey] = candidates[inclusiveKey] || {
        componentName: inclusiveKey,
        time: 0,
        count: 0
      };

      if (measurement.inclusive[id]) {
        candidates[inclusiveKey].time += measurement.inclusive[id];
      }
      if (measurement.counts[id]) {
        candidates[inclusiveKey].count += measurement.counts[id];
      }
    }
  }

  // Now make a sorted array with the results.
  var arr = [];
  for (inclusiveKey in candidates) {
    if (candidates[inclusiveKey].time >= DONT_CARE_THRESHOLD) {
      arr.push(candidates[inclusiveKey]);
    }
  }

  arr.sort(function (a, b) {
    return b.time - a.time;
  });

  return arr;
}

function getUnchangedComponents(measurement) {
  // For a given reconcile, look at which components did not actually
  // render anything to the DOM and return a mapping of their ID to
  // the amount of time it took to render the entire subtree.
  var cleanComponents = {};
  var dirtyLeafIDs = Object.keys(measurement.writes);
  var allIDs = assign({}, measurement.exclusive, measurement.inclusive);

  for (var id in allIDs) {
    var isDirty = false;
    // For each component that rendered, see if a component that triggered
    // a DOM op is in its subtree.
    for (var i = 0; i < dirtyLeafIDs.length; i++) {
      if (dirtyLeafIDs[i].indexOf(id) === 0) {
        isDirty = true;
        break;
      }
    }
    // check if component newly created
    if (measurement.created[id]) {
      isDirty = true;
    }
    if (!isDirty && measurement.counts[id] > 0) {
      cleanComponents[id] = true;
    }
  }
  return cleanComponents;
}

var ReactDefaultPerfAnalysis = {
  getExclusiveSummary: getExclusiveSummary,
  getInclusiveSummary: getInclusiveSummary,
  getDOMSummary: getDOMSummary,
  getTotalTime: getTotalTime
};

module.exports = ReactDefaultPerfAnalysis;
},{"./Object.assign":321}],351:[function(require,module,exports){
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactElement
 */

'use strict';

var ReactCurrentOwner = require('./ReactCurrentOwner');

var assign = require('./Object.assign');
var canDefineProperty = require('./canDefineProperty');

// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

/**
 * Base constructor for all React elements. This is only used to make this
 * work with a dynamic instanceof check. Nothing should live on this prototype.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if ("production" !== 'production') {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    Object.freeze(element.props);
    Object.freeze(element);
  }

  return element;
};

ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    ref = config.ref === undefined ? null : config.ref;
    key = config.key === undefined ? null : '' + config.key;
    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (typeof props[propName] === 'undefined') {
        props[propName] = defaultProps[propName];
      }
    }
  }

  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

ReactElement.cloneAndReplaceProps = function (oldElement, newProps) {
  var newElement = ReactElement(oldElement.type, oldElement.key, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, newProps);

  if ("production" !== 'production') {
    // If the key on the original is valid, then the clone is valid
    newElement._store.validated = oldElement._store.validated;
  }

  return newElement;
};

ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (config.ref !== undefined) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (config.key !== undefined) {
      key = '' + config.key;
    }
    // Remaining properties override existing props
    for (propName in config) {
      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;
},{"./Object.assign":321,"./ReactCurrentOwner":333,"./canDefineProperty":403}],352:[function(require,module,exports){
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactElementValidator
 */

/**
 * ReactElementValidator provides a wrapper around a element factory
 * which validates the props passed to the element. This is intended to be
 * used only in DEV and could be replaced by a static type checker for languages
 * that support it.
 */

'use strict';

var ReactElement = require('./ReactElement');
var ReactPropTypeLocations = require('./ReactPropTypeLocations');
var ReactPropTypeLocationNames = require('./ReactPropTypeLocationNames');
var ReactCurrentOwner = require('./ReactCurrentOwner');

var canDefineProperty = require('./canDefineProperty');
var getIteratorFn = require('./getIteratorFn');
var invariant = require('fbjs/lib/invariant');
var warning = require('fbjs/lib/warning');

function getDeclarationErrorAddendum() {
  if (ReactCurrentOwner.current) {
    var name = ReactCurrentOwner.current.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */
var ownerHasKeyUseWarning = {};

var loggedTypeFailures = {};

/**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */
function validateExplicitKey(element, parentType) {
  if (!element._store || element._store.validated || element.key != null) {
    return;
  }
  element._store.validated = true;

  var addenda = getAddendaForKeyUse('uniqueKey', element, parentType);
  if (addenda === null) {
    // we already showed the warning
    return;
  }
  "production" !== 'production' ? warning(false, 'Each child in an array or iterator should have a unique "key" prop.' + '%s%s%s', addenda.parentOrOwner || '', addenda.childOwner || '', addenda.url || '') : undefined;
}

/**
 * Shared warning and monitoring code for the key warnings.
 *
 * @internal
 * @param {string} messageType A key used for de-duping warnings.
 * @param {ReactElement} element Component that requires a key.
 * @param {*} parentType element's parent's type.
 * @returns {?object} A set of addenda to use in the warning message, or null
 * if the warning has already been shown before (and shouldn't be shown again).
 */
function getAddendaForKeyUse(messageType, element, parentType) {
  var addendum = getDeclarationErrorAddendum();
  if (!addendum) {
    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
    if (parentName) {
      addendum = ' Check the top-level render call using <' + parentName + '>.';
    }
  }

  var memoizer = ownerHasKeyUseWarning[messageType] || (ownerHasKeyUseWarning[messageType] = {});
  if (memoizer[addendum]) {
    return null;
  }
  memoizer[addendum] = true;

  var addenda = {
    parentOrOwner: addendum,
    url: ' See https://fb.me/react-warning-keys for more information.',
    childOwner: null
  };

  // Usually the current owner is the offender, but if it accepts children as a
  // property, it may be the creator of the child that's responsible for
  // assigning it a key.
  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
    // Give the component that originally created this child.
    addenda.childOwner = ' It was passed a child from ' + element._owner.getName() + '.';
  }

  return addenda;
}

/**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */
function validateChildKeys(node, parentType) {
  if (typeof node !== 'object') {
    return;
  }
  if (Array.isArray(node)) {
    for (var i = 0; i < node.length; i++) {
      var child = node[i];
      if (ReactElement.isValidElement(child)) {
        validateExplicitKey(child, parentType);
      }
    }
  } else if (ReactElement.isValidElement(node)) {
    // This element was passed in a valid location.
    if (node._store) {
      node._store.validated = true;
    }
  } else if (node) {
    var iteratorFn = getIteratorFn(node);
    // Entry iterators provide implicit keys.
    if (iteratorFn) {
      if (iteratorFn !== node.entries) {
        var iterator = iteratorFn.call(node);
        var step;
        while (!(step = iterator.next()).done) {
          if (ReactElement.isValidElement(step.value)) {
            validateExplicitKey(step.value, parentType);
          }
        }
      }
    }
  }
}

/**
 * Assert that the props are valid
 *
 * @param {string} componentName Name of the component for error messages.
 * @param {object} propTypes Map of prop name to a ReactPropType
 * @param {object} props
 * @param {string} location e.g. "prop", "context", "child context"
 * @private
 */
function checkPropTypes(componentName, propTypes, props, location) {
  for (var propName in propTypes) {
    if (propTypes.hasOwnProperty(propName)) {
      var error;
      // Prop type validation may throw. In case they do, we don't want to
      // fail the render phase where it didn't fail before. So we log it.
      // After these have been cleaned up, we'll let them throw.
      try {
        // This is intentionally an invariant that gets caught. It's the same
        // behavior as without this statement except with a better message.
        !(typeof propTypes[propName] === 'function') ? "production" !== 'production' ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : undefined;
        error = propTypes[propName](props, propName, componentName, location);
      } catch (ex) {
        error = ex;
      }
      "production" !== 'production' ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], propName, typeof error) : undefined;
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum();
        "production" !== 'production' ? warning(false, 'Failed propType: %s%s', error.message, addendum) : undefined;
      }
    }
  }
}

/**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */
function validatePropTypes(element) {
  var componentClass = element.type;
  if (typeof componentClass !== 'function') {
    return;
  }
  var name = componentClass.displayName || componentClass.name;
  if (componentClass.propTypes) {
    checkPropTypes(name, componentClass.propTypes, element.props, ReactPropTypeLocations.prop);
  }
  if (typeof componentClass.getDefaultProps === 'function') {
    "production" !== 'production' ? warning(componentClass.getDefaultProps.isReactClassApproved, 'getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.') : undefined;
  }
}

var ReactElementValidator = {

  createElement: function (type, props, children) {
    var validType = typeof type === 'string' || typeof type === 'function';
    // We warn in this case but don't throw. We expect the element creation to
    // succeed and there will likely be errors in render.
    "production" !== 'production' ? warning(validType, 'React.createElement: type should not be null, undefined, boolean, or ' + 'number. It should be a string (for DOM elements) or a ReactClass ' + '(for composite components).%s', getDeclarationErrorAddendum()) : undefined;

    var element = ReactElement.createElement.apply(this, arguments);

    // The result can be nullish if a mock or a custom function is used.
    // TODO: Drop this when these are no longer allowed as the type argument.
    if (element == null) {
      return element;
    }

    // Skip key warning if the type isn't valid since our key validation logic
    // doesn't expect a non-string/function type and can throw confusing errors.
    // We don't want exception behavior to differ between dev and prod.
    // (Rendering will throw with a helpful message and as soon as the type is
    // fixed, the key warnings will appear.)
    if (validType) {
      for (var i = 2; i < arguments.length; i++) {
        validateChildKeys(arguments[i], type);
      }
    }

    validatePropTypes(element);

    return element;
  },

  createFactory: function (type) {
    var validatedFactory = ReactElementValidator.createElement.bind(null, type);
    // Legacy hook TODO: Warn if this is accessed
    validatedFactory.type = type;

    if ("production" !== 'production') {
      if (canDefineProperty) {
        Object.defineProperty(validatedFactory, 'type', {
          enumerable: false,
          get: function () {
            "production" !== 'production' ? warning(false, 'Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.') : undefined;
            Object.defineProperty(this, 'type', {
              value: type
            });
            return type;
          }
        });
      }
    }

    return validatedFactory;
  },

  cloneElement: function (element, props, children) {
    var newElement = ReactElement.cloneElement.apply(this, arguments);
    for (var i = 2; i < arguments.length; i++) {
      validateChildKeys(arguments[i], newElement.type);
    }
    validatePropTypes(newElement);
    return newElement;
  }

};

module.exports = ReactElementValidator;
},{"./ReactCurrentOwner":333,"./ReactElement":351,"./ReactPropTypeLocationNames":371,"./ReactPropTypeLocations":372,"./canDefineProperty":403,"./getIteratorFn":414,"fbjs/lib/invariant":443,"fbjs/lib/warning":454}],353:[function(require,module,exports){
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactEmptyComponent
 */

'use strict';

var ReactElement = require('./ReactElement');
var ReactEmptyComponentRegistry = require('./ReactEmptyComponentRegistry');
var ReactReconciler = require('./ReactReconciler');

var assign = require('./Object.assign');

var placeholderElement;

var ReactEmptyComponentInjection = {
  injectEmptyComponent: function (component) {
    placeholderElement = ReactElement.createElement(component);
  }
};

var ReactEmptyComponent = function (instantiate) {
  this._currentElement = null;
  this._rootNodeID = null;
  this._renderedComponent = instantiate(placeholderElement);
};
assign(ReactEmptyComponent.prototype, {
  construct: function (element) {},
  mountComponent: function (rootID, transaction, context) {
    ReactEmptyComponentRegistry.registerNullComponentID(rootID);
    this._rootNodeID = rootID;
    return ReactReconciler.mountComponent(this._renderedComponent, rootID, transaction, context);
  },
  receiveComponent: function () {},
  unmountComponent: function (rootID, transaction, context) {
    ReactReconciler.unmountComponent(this._renderedComponent);
    ReactEmptyComponentRegistry.deregisterNullComponentID(this._rootNodeID);
    this._rootNodeID = null;
    this._renderedComponent = null;
  }
});

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;
},{"./Object.assign":321,"./ReactElement":351,"./ReactEmptyComponentRegistry":354,"./ReactReconciler":375}],354:[function(require,module,exports){
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactEmptyComponentRegistry
 */

'use strict';

// This registry keeps track of the React IDs of the components that rendered to
// `null` (in reality a placeholder such as `noscript`)
var nullComponentIDsRegistry = {};

/**
 * @param {string} id Component's `_rootNodeID`.
 * @return {boolean} True if the component is rendered to null.
 */
function isNullComponentID(id) {
  return !!nullComponentIDsRegistry[id];
}

/**
 * Mark the component as having rendered to null.
 * @param {string} id Component's `_rootNodeID`.
 */
function registerNullComponentID(id) {
  nullComponentIDsRegistry[id] = true;
}

/**
 * Unmark the component as having rendered to null: it renders to something now.
 * @param {string} id Component's `_rootNodeID`.
 */
function deregisterNullComponentID(id) {
  delete nullComponentIDsRegistry[id];
}

var ReactEmptyComponentRegistry = {
  isNullComponentID: isNullComponentID,
  registerNullComponentID: registerNullComponentID,
  deregisterNullComponentID: deregisterNullComponentID
};

module.exports = ReactEmptyComponentRegistry;
},{}],355:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactErrorUtils
 * @typechecks
 */

'use strict';

var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {?String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a, b) {
  try {
    return func(a, b);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
    return undefined;
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if ("production" !== 'production') {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a, b) {
      var boundFunc = func.bind(null, a, b);
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;
},{}],356:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactEventEmitterMixin
 */

'use strict';

var EventPluginHub = require('./EventPluginHub');

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {

  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {object} topLevelTarget The listening component root node.
   * @param {string} topLevelTargetID ID of `topLevelTarget`.
   * @param {object} nativeEvent Native environment event.
   */
  handleTopLevel: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;
},{"./EventPluginHub":314}],357:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactEventListener
 * @typechecks static-only
 */

'use strict';

var EventListener = require('fbjs/lib/EventListener');
var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
var PooledClass = require('./PooledClass');
var ReactInstanceHandles = require('./ReactInstanceHandles');
var ReactMount = require('./ReactMount');
var ReactUpdates = require('./ReactUpdates');

var assign = require('./Object.assign');
var getEventTarget = require('./getEventTarget');
var getUnboundedScrollPosition = require('fbjs/lib/getUnboundedScrollPosition');

var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * Finds the parent React component of `node`.
 *
 * @param {*} node
 * @return {?DOMEventTarget} Parent container, or `null` if the specified node
 *                           is not nested.
 */
function findParent(node) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  var nodeID = ReactMount.getID(node);
  var rootID = ReactInstanceHandles.getReactRootIDFromNodeID(nodeID);
  var container = ReactMount.findReactContainerForID(rootID);
  var parent = ReactMount.getFirstReactDOM(container);
  return parent;
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  // TODO: Re-enable event.path handling
  //
  // if (bookKeeping.nativeEvent.path && bookKeeping.nativeEvent.path.length > 1) {
  //   // New browsers have a path attribute on native events
  //   handleTopLevelWithPath(bookKeeping);
  // } else {
  //   // Legacy browsers don't have a path attribute on native events
  //   handleTopLevelWithoutPath(bookKeeping);
  // }

  void handleTopLevelWithPath; // temporarily unused
  handleTopLevelWithoutPath(bookKeeping);
}

// Legacy browsers don't have a path attribute on native events
function handleTopLevelWithoutPath(bookKeeping) {
  var topLevelTarget = ReactMount.getFirstReactDOM(getEventTarget(bookKeeping.nativeEvent)) || window;

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = topLevelTarget;
  while (ancestor) {
    bookKeeping.ancestors.push(ancestor);
    ancestor = findParent(ancestor);
  }

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    topLevelTarget = bookKeeping.ancestors[i];
    var topLevelTargetID = ReactMount.getID(topLevelTarget) || '';
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, topLevelTarget, topLevelTargetID, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

// New browsers have a path attribute on native events
function handleTopLevelWithPath(bookKeeping) {
  var path = bookKeeping.nativeEvent.path;
  var currentNativeTarget = path[0];
  var eventsFired = 0;
  for (var i = 0; i < path.length; i++) {
    var currentPathElement = path[i];
    if (currentPathElement.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE) {
      currentNativeTarget = path[i + 1];
    }
    // TODO: slow
    var reactParent = ReactMount.getFirstReactDOM(currentPathElement);
    if (reactParent === currentPathElement) {
      var currentPathElementID = ReactMount.getID(currentPathElement);
      var newRootID = ReactInstanceHandles.getReactRootIDFromNodeID(currentPathElementID);
      bookKeeping.ancestors.push(currentPathElement);

      var topLevelTargetID = ReactMount.getID(currentPathElement) || '';
      eventsFired++;
      ReactEventListener._handleTopLevel(bookKeeping.topLevelType, currentPathElement, topLevelTargetID, bookKeeping.nativeEvent, currentNativeTarget);

      // Jump to the root of this React render tree
      while (currentPathElementID !== newRootID) {
        i++;
        currentPathElement = path[i];
        currentPathElementID = ReactMount.getID(currentPathElement);
      }
    }
  }
  if (eventsFired === 0) {
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, window, '', bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} handle Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    var element = handle;
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} handle Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    var element = handle;
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;
},{"./Object.assign":321,"./PooledClass":322,"./ReactInstanceHandles":360,"./ReactMount":364,"./ReactUpdates":382,"./getEventTarget":413,"fbjs/lib/EventListener":428,"fbjs/lib/ExecutionEnvironment":429,"fbjs/lib/getUnboundedScrollPosition":440}],358:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactInjection
 */

'use strict';

var DOMProperty = require('./DOMProperty');
var EventPluginHub = require('./EventPluginHub');
var ReactComponentEnvironment = require('./ReactComponentEnvironment');
var ReactClass = require('./ReactClass');
var ReactEmptyComponent = require('./ReactEmptyComponent');
var ReactBrowserEventEmitter = require('./ReactBrowserEventEmitter');
var ReactNativeComponent = require('./ReactNativeComponent');
var ReactPerf = require('./ReactPerf');
var ReactRootIndex = require('./ReactRootIndex');
var ReactUpdates = require('./ReactUpdates');

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  Class: ReactClass.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  NativeComponent: ReactNativeComponent.injection,
  Perf: ReactPerf.injection,
  RootIndex: ReactRootIndex.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;
},{"./DOMProperty":308,"./EventPluginHub":314,"./ReactBrowserEventEmitter":325,"./ReactClass":328,"./ReactComponentEnvironment":331,"./ReactEmptyComponent":353,"./ReactNativeComponent":367,"./ReactPerf":370,"./ReactRootIndex":377,"./ReactUpdates":382}],359:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactInputSelection
 */

'use strict';

var ReactDOMSelection = require('./ReactDOMSelection');

var containsNode = require('fbjs/lib/containsNode');
var focusNode = require('fbjs/lib/focusNode');
var getActiveElement = require('fbjs/lib/getActiveElement');

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {

  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && (input.nodeName && input.nodeName.toLowerCase() === 'input')) {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (typeof end === 'undefined') {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && (input.nodeName && input.nodeName.toLowerCase() === 'input')) {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;
},{"./ReactDOMSelection":343,"fbjs/lib/containsNode":432,"fbjs/lib/focusNode":437,"fbjs/lib/getActiveElement":438}],360:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactInstanceHandles
 * @typechecks static-only
 */

'use strict';

var ReactRootIndex = require('./ReactRootIndex');

var invariant = require('fbjs/lib/invariant');

var SEPARATOR = '.';
var SEPARATOR_LENGTH = SEPARATOR.length;

/**
 * Maximum depth of traversals before we consider the possibility of a bad ID.
 */
var MAX_TREE_DEPTH = 10000;

/**
 * Creates a DOM ID prefix to use when mounting React components.
 *
 * @param {number} index A unique integer
 * @return {string} React root ID.
 * @internal
 */
function getReactRootIDString(index) {
  return SEPARATOR + index.toString(36);
}

/**
 * Checks if a character in the supplied ID is a separator or the end.
 *
 * @param {string} id A React DOM ID.
 * @param {number} index Index of the character to check.
 * @return {boolean} True if the character is a separator or end of the ID.
 * @private
 */
function isBoundary(id, index) {
  return id.charAt(index) === SEPARATOR || index === id.length;
}

/**
 * Checks if the supplied string is a valid React DOM ID.
 *
 * @param {string} id A React DOM ID, maybe.
 * @return {boolean} True if the string is a valid React DOM ID.
 * @private
 */
function isValidID(id) {
  return id === '' || id.charAt(0) === SEPARATOR && id.charAt(id.length - 1) !== SEPARATOR;
}

/**
 * Checks if the first ID is an ancestor of or equal to the second ID.
 *
 * @param {string} ancestorID
 * @param {string} descendantID
 * @return {boolean} True if `ancestorID` is an ancestor of `descendantID`.
 * @internal
 */
function isAncestorIDOf(ancestorID, descendantID) {
  return descendantID.indexOf(ancestorID) === 0 && isBoundary(descendantID, ancestorID.length);
}

/**
 * Gets the parent ID of the supplied React DOM ID, `id`.
 *
 * @param {string} id ID of a component.
 * @return {string} ID of the parent, or an empty string.
 * @private
 */
function getParentID(id) {
  return id ? id.substr(0, id.lastIndexOf(SEPARATOR)) : '';
}

/**
 * Gets the next DOM ID on the tree path from the supplied `ancestorID` to the
 * supplied `destinationID`. If they are equal, the ID is returned.
 *
 * @param {string} ancestorID ID of an ancestor node of `destinationID`.
 * @param {string} destinationID ID of the destination node.
 * @return {string} Next ID on the path from `ancestorID` to `destinationID`.
 * @private
 */
function getNextDescendantID(ancestorID, destinationID) {
  !(isValidID(ancestorID) && isValidID(destinationID)) ? "production" !== 'production' ? invariant(false, 'getNextDescendantID(%s, %s): Received an invalid React DOM ID.', ancestorID, destinationID) : invariant(false) : undefined;
  !isAncestorIDOf(ancestorID, destinationID) ? "production" !== 'production' ? invariant(false, 'getNextDescendantID(...): React has made an invalid assumption about ' + 'the DOM hierarchy. Expected `%s` to be an ancestor of `%s`.', ancestorID, destinationID) : invariant(false) : undefined;
  if (ancestorID === destinationID) {
    return ancestorID;
  }
  // Skip over the ancestor and the immediate separator. Traverse until we hit
  // another separator or we reach the end of `destinationID`.
  var start = ancestorID.length + SEPARATOR_LENGTH;
  var i;
  for (i = start; i < destinationID.length; i++) {
    if (isBoundary(destinationID, i)) {
      break;
    }
  }
  return destinationID.substr(0, i);
}

/**
 * Gets the nearest common ancestor ID of two IDs.
 *
 * Using this ID scheme, the nearest common ancestor ID is the longest common
 * prefix of the two IDs that immediately preceded a "marker" in both strings.
 *
 * @param {string} oneID
 * @param {string} twoID
 * @return {string} Nearest common ancestor ID, or the empty string if none.
 * @private
 */
function getFirstCommonAncestorID(oneID, twoID) {
  var minLength = Math.min(oneID.length, twoID.length);
  if (minLength === 0) {
    return '';
  }
  var lastCommonMarkerIndex = 0;
  // Use `<=` to traverse until the "EOL" of the shorter string.
  for (var i = 0; i <= minLength; i++) {
    if (isBoundary(oneID, i) && isBoundary(twoID, i)) {
      lastCommonMarkerIndex = i;
    } else if (oneID.charAt(i) !== twoID.charAt(i)) {
      break;
    }
  }
  var longestCommonID = oneID.substr(0, lastCommonMarkerIndex);
  !isValidID(longestCommonID) ? "production" !== 'production' ? invariant(false, 'getFirstCommonAncestorID(%s, %s): Expected a valid React DOM ID: %s', oneID, twoID, longestCommonID) : invariant(false) : undefined;
  return longestCommonID;
}

/**
 * Traverses the parent path between two IDs (either up or down). The IDs must
 * not be the same, and there must exist a parent path between them. If the
 * callback returns `false`, traversal is stopped.
 *
 * @param {?string} start ID at which to start traversal.
 * @param {?string} stop ID at which to end traversal.
 * @param {function} cb Callback to invoke each ID with.
 * @param {*} arg Argument to invoke the callback with.
 * @param {?boolean} skipFirst Whether or not to skip the first node.
 * @param {?boolean} skipLast Whether or not to skip the last node.
 * @private
 */
function traverseParentPath(start, stop, cb, arg, skipFirst, skipLast) {
  start = start || '';
  stop = stop || '';
  !(start !== stop) ? "production" !== 'production' ? invariant(false, 'traverseParentPath(...): Cannot traverse from and to the same ID, `%s`.', start) : invariant(false) : undefined;
  var traverseUp = isAncestorIDOf(stop, start);
  !(traverseUp || isAncestorIDOf(start, stop)) ? "production" !== 'production' ? invariant(false, 'traverseParentPath(%s, %s, ...): Cannot traverse from two IDs that do ' + 'not have a parent path.', start, stop) : invariant(false) : undefined;
  // Traverse from `start` to `stop` one depth at a time.
  var depth = 0;
  var traverse = traverseUp ? getParentID : getNextDescendantID;
  for (var id = start;; /* until break */id = traverse(id, stop)) {
    var ret;
    if ((!skipFirst || id !== start) && (!skipLast || id !== stop)) {
      ret = cb(id, traverseUp, arg);
    }
    if (ret === false || id === stop) {
      // Only break //after// visiting `stop`.
      break;
    }
    !(depth++ < MAX_TREE_DEPTH) ? "production" !== 'production' ? invariant(false, 'traverseParentPath(%s, %s, ...): Detected an infinite loop while ' + 'traversing the React DOM ID tree. This may be due to malformed IDs: %s', start, stop, id) : invariant(false) : undefined;
  }
}

/**
 * Manages the IDs assigned to DOM representations of React components. This
 * uses a specific scheme in order to traverse the DOM efficiently (e.g. in
 * order to simulate events).
 *
 * @internal
 */
var ReactInstanceHandles = {

  /**
   * Constructs a React root ID
   * @return {string} A React root ID.
   */
  createReactRootID: function () {
    return getReactRootIDString(ReactRootIndex.createReactRootIndex());
  },

  /**
   * Constructs a React ID by joining a root ID with a name.
   *
   * @param {string} rootID Root ID of a parent component.
   * @param {string} name A component's name (as flattened children).
   * @return {string} A React ID.
   * @internal
   */
  createReactID: function (rootID, name) {
    return rootID + name;
  },

  /**
   * Gets the DOM ID of the React component that is the root of the tree that
   * contains the React component with the supplied DOM ID.
   *
   * @param {string} id DOM ID of a React component.
   * @return {?string} DOM ID of the React component that is the root.
   * @internal
   */
  getReactRootIDFromNodeID: function (id) {
    if (id && id.charAt(0) === SEPARATOR && id.length > 1) {
      var index = id.indexOf(SEPARATOR, 1);
      return index > -1 ? id.substr(0, index) : id;
    }
    return null;
  },

  /**
   * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
   * should would receive a `mouseEnter` or `mouseLeave` event.
   *
   * NOTE: Does not invoke the callback on the nearest common ancestor because
   * nothing "entered" or "left" that element.
   *
   * @param {string} leaveID ID being left.
   * @param {string} enterID ID being entered.
   * @param {function} cb Callback to invoke on each entered/left ID.
   * @param {*} upArg Argument to invoke the callback with on left IDs.
   * @param {*} downArg Argument to invoke the callback with on entered IDs.
   * @internal
   */
  traverseEnterLeave: function (leaveID, enterID, cb, upArg, downArg) {
    var ancestorID = getFirstCommonAncestorID(leaveID, enterID);
    if (ancestorID !== leaveID) {
      traverseParentPath(leaveID, ancestorID, cb, upArg, false, true);
    }
    if (ancestorID !== enterID) {
      traverseParentPath(ancestorID, enterID, cb, downArg, true, false);
    }
  },

  /**
   * Simulates the traversal of a two-phase, capture/bubble event dispatch.
   *
   * NOTE: This traversal happens on IDs without touching the DOM.
   *
   * @param {string} targetID ID of the target node.
   * @param {function} cb Callback to invoke.
   * @param {*} arg Argument to invoke the callback with.
   * @internal
   */
  traverseTwoPhase: function (targetID, cb, arg) {
    if (targetID) {
      traverseParentPath('', targetID, cb, arg, true, false);
      traverseParentPath(targetID, '', cb, arg, false, true);
    }
  },

  /**
   * Same as `traverseTwoPhase` but skips the `targetID`.
   */
  traverseTwoPhaseSkipTarget: function (targetID, cb, arg) {
    if (targetID) {
      traverseParentPath('', targetID, cb, arg, true, true);
      traverseParentPath(targetID, '', cb, arg, true, true);
    }
  },

  /**
   * Traverse a node ID, calling the supplied `cb` for each ancestor ID. For
   * example, passing `.0.$row-0.1` would result in `cb` getting called
   * with `.0`, `.0.$row-0`, and `.0.$row-0.1`.
   *
   * NOTE: This traversal happens on IDs without touching the DOM.
   *
   * @param {string} targetID ID of the target node.
   * @param {function} cb Callback to invoke.
   * @param {*} arg Argument to invoke the callback with.
   * @internal
   */
  traverseAncestors: function (targetID, cb, arg) {
    traverseParentPath('', targetID, cb, arg, true, false);
  },

  getFirstCommonAncestorID: getFirstCommonAncestorID,

  /**
   * Exposed for unit testing.
   * @private
   */
  _getNextDescendantID: getNextDescendantID,

  isAncestorIDOf: isAncestorIDOf,

  SEPARATOR: SEPARATOR

};

module.exports = ReactInstanceHandles;
},{"./ReactRootIndex":377,"fbjs/lib/invariant":443}],361:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactInstanceMap
 */

'use strict';

/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
var ReactInstanceMap = {

  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }

};

module.exports = ReactInstanceMap;
},{}],362:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactIsomorphic
 */

'use strict';

var ReactChildren = require('./ReactChildren');
var ReactComponent = require('./ReactComponent');
var ReactClass = require('./ReactClass');
var ReactDOMFactories = require('./ReactDOMFactories');
var ReactElement = require('./ReactElement');
var ReactElementValidator = require('./ReactElementValidator');
var ReactPropTypes = require('./ReactPropTypes');
var ReactVersion = require('./ReactVersion');

var assign = require('./Object.assign');
var onlyChild = require('./onlyChild');

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if ("production" !== 'production') {
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var React = {

  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: ReactClass.createClass,
  createFactory: createFactory,
  createMixin: function (mixin) {
    // Currently a noop. Will be used to validate and trace mixins.
    return mixin;
  },

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Hook for JSX spread, don't use this for anything else.
  __spread: assign
};

module.exports = React;
},{"./Object.assign":321,"./ReactChildren":327,"./ReactClass":328,"./ReactComponent":329,"./ReactDOMFactories":337,"./ReactElement":351,"./ReactElementValidator":352,"./ReactPropTypes":373,"./ReactVersion":383,"./onlyChild":420}],363:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactMarkupChecksum
 */

'use strict';

var adler32 = require('./adler32');

var TAG_END = /\/?>/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags and self-closing tags)
    return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;
},{"./adler32":402}],364:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactMount
 */

'use strict';

var DOMProperty = require('./DOMProperty');
var ReactBrowserEventEmitter = require('./ReactBrowserEventEmitter');
var ReactCurrentOwner = require('./ReactCurrentOwner');
var ReactDOMFeatureFlags = require('./ReactDOMFeatureFlags');
var ReactElement = require('./ReactElement');
var ReactEmptyComponentRegistry = require('./ReactEmptyComponentRegistry');
var ReactInstanceHandles = require('./ReactInstanceHandles');
var ReactInstanceMap = require('./ReactInstanceMap');
var ReactMarkupChecksum = require('./ReactMarkupChecksum');
var ReactPerf = require('./ReactPerf');
var ReactReconciler = require('./ReactReconciler');
var ReactUpdateQueue = require('./ReactUpdateQueue');
var ReactUpdates = require('./ReactUpdates');

var assign = require('./Object.assign');
var emptyObject = require('fbjs/lib/emptyObject');
var containsNode = require('fbjs/lib/containsNode');
var instantiateReactComponent = require('./instantiateReactComponent');
var invariant = require('fbjs/lib/invariant');
var setInnerHTML = require('./setInnerHTML');
var shouldUpdateReactComponent = require('./shouldUpdateReactComponent');
var validateDOMNesting = require('./validateDOMNesting');
var warning = require('fbjs/lib/warning');

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var nodeCache = {};

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var ownerDocumentContextKey = '__ReactMount_ownerDocument$' + Math.random().toString(36).slice(2);

/** Mapping from reactRootID to React component instance. */
var instancesByReactRootID = {};

/** Mapping from reactRootID to `container` nodes. */
var containersByReactRootID = {};

if ("production" !== 'production') {
  /** __DEV__-only mapping from reactRootID to root elements. */
  var rootElementsByReactRootID = {};
}

// Used to store breadth-first search state in findComponentRoot.
var findComponentRootReusableArray = [];

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

/**
 * @param {DOMElement} container DOM element that may contain a React component.
 * @return {?string} A "reactRoot" ID, if a React component is rendered.
 */
function getReactRootID(container) {
  var rootElement = getReactRootElementInContainer(container);
  return rootElement && ReactMount.getID(rootElement);
}

/**
 * Accessing node[ATTR_NAME] or calling getAttribute(ATTR_NAME) on a form
 * element can return its control whose name or ID equals ATTR_NAME. All
 * DOM nodes support `getAttributeNode` but this can also get called on
 * other objects so just return '' if we're given something other than a
 * DOM node (such as window).
 *
 * @param {?DOMElement|DOMWindow|DOMDocument|DOMTextNode} node DOM node.
 * @return {string} ID of the supplied `domNode`.
 */
function getID(node) {
  var id = internalGetID(node);
  if (id) {
    if (nodeCache.hasOwnProperty(id)) {
      var cached = nodeCache[id];
      if (cached !== node) {
        !!isValid(cached, id) ? "production" !== 'production' ? invariant(false, 'ReactMount: Two valid but unequal nodes with the same `%s`: %s', ATTR_NAME, id) : invariant(false) : undefined;

        nodeCache[id] = node;
      }
    } else {
      nodeCache[id] = node;
    }
  }

  return id;
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node && node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Sets the React-specific ID of the given node.
 *
 * @param {DOMElement} node The DOM node whose ID will be set.
 * @param {string} id The value of the ID attribute.
 */
function setID(node, id) {
  var oldID = internalGetID(node);
  if (oldID !== id) {
    delete nodeCache[oldID];
  }
  node.setAttribute(ATTR_NAME, id);
  nodeCache[id] = node;
}

/**
 * Finds the node with the supplied React-generated DOM ID.
 *
 * @param {string} id A React-generated DOM ID.
 * @return {DOMElement} DOM node with the suppled `id`.
 * @internal
 */
function getNode(id) {
  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
    nodeCache[id] = ReactMount.findReactNodeByID(id);
  }
  return nodeCache[id];
}

/**
 * Finds the node with the supplied public React instance.
 *
 * @param {*} instance A public React instance.
 * @return {?DOMElement} DOM node with the suppled `id`.
 * @internal
 */
function getNodeFromInstance(instance) {
  var id = ReactInstanceMap.get(instance)._rootNodeID;
  if (ReactEmptyComponentRegistry.isNullComponentID(id)) {
    return null;
  }
  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
    nodeCache[id] = ReactMount.findReactNodeByID(id);
  }
  return nodeCache[id];
}

/**
 * A node is "valid" if it is contained by a currently mounted container.
 *
 * This means that the node does not have to be contained by a document in
 * order to be considered valid.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @param {string} id The expected ID of the node.
 * @return {boolean} Whether the node is contained by a mounted container.
 */
function isValid(node, id) {
  if (node) {
    !(internalGetID(node) === id) ? "production" !== 'production' ? invariant(false, 'ReactMount: Unexpected modification of `%s`', ATTR_NAME) : invariant(false) : undefined;

    var container = ReactMount.findReactContainerForID(id);
    if (container && containsNode(container, node)) {
      return true;
    }
  }

  return false;
}

/**
 * Causes the cache to forget about one React-specific ID.
 *
 * @param {string} id The ID to forget.
 */
function purgeID(id) {
  delete nodeCache[id];
}

var deepestNodeSoFar = null;
function findDeepestCachedAncestorImpl(ancestorID) {
  var ancestor = nodeCache[ancestorID];
  if (ancestor && isValid(ancestor, ancestorID)) {
    deepestNodeSoFar = ancestor;
  } else {
    // This node isn't populated in the cache, so presumably none of its
    // descendants are. Break out of the loop.
    return false;
  }
}

/**
 * Return the deepest cached node whose ID is a prefix of `targetID`.
 */
function findDeepestCachedAncestor(targetID) {
  deepestNodeSoFar = null;
  ReactInstanceHandles.traverseAncestors(targetID, findDeepestCachedAncestorImpl);

  var foundNode = deepestNodeSoFar;
  deepestNodeSoFar = null;
  return foundNode;
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {string} rootID DOM ID of the root node.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(componentInstance, rootID, container, transaction, shouldReuseMarkup, context) {
  if (ReactDOMFeatureFlags.useCreateElement) {
    context = assign({}, context);
    if (container.nodeType === DOC_NODE_TYPE) {
      context[ownerDocumentContextKey] = container;
    } else {
      context[ownerDocumentContextKey] = container.ownerDocument;
    }
  }
  if ("production" !== 'production') {
    if (context === emptyObject) {
      context = {};
    }
    var tag = container.nodeName.toLowerCase();
    context[validateDOMNesting.ancestorInfoContextKey] = validateDOMNesting.updatedAncestorInfo(null, tag, null);
  }
  var markup = ReactReconciler.mountComponent(componentInstance, rootID, transaction, context);
  componentInstance._renderedComponent._topLevelWrapper = componentInstance;
  ReactMount._mountImageIntoNode(markup, container, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {string} rootID DOM ID of the root node.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, rootID, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* forceHTML */shouldReuseMarkup);
  transaction.perform(mountComponentIntoNode, null, componentInstance, rootID, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container) {
  ReactReconciler.unmountComponent(instance);

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(node) {
  var reactRootID = getReactRootID(node);
  return reactRootID ? reactRootID !== ReactInstanceHandles.getReactRootIDFromNodeID(reactRootID) : false;
}

/**
 * Returns the first (deepest) ancestor of a node which is rendered by this copy
 * of React.
 */
function findFirstReactDOMImpl(node) {
  // This node might be from another React instance, so we make sure not to
  // examine the node cache here
  for (; node && node.parentNode !== node; node = node.parentNode) {
    if (node.nodeType !== 1) {
      // Not a DOMElement, therefore not a React component
      continue;
    }
    var nodeID = internalGetID(node);
    if (!nodeID) {
      continue;
    }
    var reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(nodeID);

    // If containersByReactRootID contains the container we find by crawling up
    // the tree, we know that this instance of React rendered the node.
    // nb. isValid's strategy (with containsNode) does not work because render
    // trees may be nested and we don't want a false positive in that case.
    var current = node;
    var lastID;
    do {
      lastID = internalGetID(current);
      current = current.parentNode;
      if (current == null) {
        // The passed-in node has been detached from the container it was
        // originally rendered into.
        return null;
      }
    } while (lastID !== reactRootID);

    if (current === containersByReactRootID[reactRootID]) {
      return node;
    }
  }
  return null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var TopLevelWrapper = function () {};
TopLevelWrapper.prototype.isReactComponent = {};
if ("production" !== 'production') {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  // this.props is actually a ReactElement
  return this.props;
};

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {

  TopLevelWrapper: TopLevelWrapper,

  /** Exposed for debugging purposes **/
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    if ("production" !== 'production') {
      // Record the root element in case it later gets transplanted.
      rootElementsByReactRootID[getReactRootID(container)] = getReactRootElementInContainer(container);
    }

    return prevComponent;
  },

  /**
   * Register a component into the instance map and starts scroll value
   * monitoring
   * @param {ReactComponent} nextComponent component instance to render
   * @param {DOMElement} container container to render into
   * @return {string} reactRoot ID prefix
   */
  _registerComponent: function (nextComponent, container) {
    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ? "production" !== 'production' ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : invariant(false) : undefined;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();

    var reactRootID = ReactMount.registerContainer(container);
    instancesByReactRootID[reactRootID] = nextComponent;
    return reactRootID;
  },

  /**
   * Render a new component into the DOM.
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
    "production" !== 'production' ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : undefined;

    var componentInstance = instantiateReactComponent(nextElement, null);
    var reactRootID = ReactMount._registerComponent(componentInstance, container);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, reactRootID, container, shouldReuseMarkup, context);

    if ("production" !== 'production') {
      // Record the root element in case it later gets transplanted.
      rootElementsByReactRootID[reactRootID] = getReactRootElementInContainer(container);
    }

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && parentComponent._reactInternalInstance != null) ? "production" !== 'production' ? invariant(false, 'parentComponent must be a valid React Component') : invariant(false) : undefined;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !ReactElement.isValidElement(nextElement) ? "production" !== 'production' ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing an element string, make sure to instantiate ' + 'it by passing it to React.createElement.' : typeof nextElement === 'function' ? ' Instead of passing a component class, make sure to instantiate ' + 'it by passing it to React.createElement.' :
    // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : invariant(false) : undefined;

    "production" !== 'production' ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : undefined;

    var nextWrappedElement = new ReactElement(TopLevelWrapper, null, null, null, null, null, nextElement);

    var prevComponent = instancesByReactRootID[getReactRootID(container)];

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if ("production" !== 'production') {
      "production" !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : undefined;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            "production" !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : undefined;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, parentComponent != null ? parentComponent._reactInternalInstance._processChildContext(parentComponent._reactInternalInstance._context) : emptyObject)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Registers a container node into which React components will be rendered.
   * This also creates the "reactRoot" ID that will be assigned to the element
   * rendered within.
   *
   * @param {DOMElement} container DOM element to register as a container.
   * @return {string} The "reactRoot" ID of elements rendered within.
   */
  registerContainer: function (container) {
    var reactRootID = getReactRootID(container);
    if (reactRootID) {
      // If one exists, make sure it is a valid "reactRoot" ID.
      reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(reactRootID);
    }
    if (!reactRootID) {
      // No valid "reactRoot" ID found, create one.
      reactRootID = ReactInstanceHandles.createReactRootID();
    }
    containersByReactRootID[reactRootID] = container;
    return reactRootID;
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
    "production" !== 'production' ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : undefined;

    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ? "production" !== 'production' ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : invariant(false) : undefined;

    var reactRootID = getReactRootID(container);
    var component = instancesByReactRootID[reactRootID];
    if (!component) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var containerID = internalGetID(container);
      var isContainerReactRoot = containerID && containerID === ReactInstanceHandles.getReactRootIDFromNodeID(containerID);

      if ("production" !== 'production') {
        "production" !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : undefined;
      }

      return false;
    }
    ReactUpdates.batchedUpdates(unmountComponentFromNode, component, container);
    delete instancesByReactRootID[reactRootID];
    delete containersByReactRootID[reactRootID];
    if ("production" !== 'production') {
      delete rootElementsByReactRootID[reactRootID];
    }
    return true;
  },

  /**
   * Finds the container DOM element that contains React component to which the
   * supplied DOM `id` belongs.
   *
   * @param {string} id The ID of an element rendered by a React component.
   * @return {?DOMElement} DOM element that contains the `id`.
   */
  findReactContainerForID: function (id) {
    var reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(id);
    var container = containersByReactRootID[reactRootID];

    if ("production" !== 'production') {
      var rootElement = rootElementsByReactRootID[reactRootID];
      if (rootElement && rootElement.parentNode !== container) {
        "production" !== 'production' ? warning(
        // Call internalGetID here because getID calls isValid which calls
        // findReactContainerForID (this function).
        internalGetID(rootElement) === reactRootID, 'ReactMount: Root element ID differed from reactRootID.') : undefined;
        var containerChild = container.firstChild;
        if (containerChild && reactRootID === internalGetID(containerChild)) {
          // If the container has a new child with the same ID as the old
          // root element, then rootElementsByReactRootID[reactRootID] is
          // just stale and needs to be updated. The case that deserves a
          // warning is when the container is empty.
          rootElementsByReactRootID[reactRootID] = containerChild;
        } else {
          "production" !== 'production' ? warning(false, 'ReactMount: Root element has been removed from its original ' + 'container. New container: %s', rootElement.parentNode) : undefined;
        }
      }
    }

    return container;
  },

  /**
   * Finds an element rendered by React with the supplied ID.
   *
   * @param {string} id ID of a DOM node in the React component.
   * @return {DOMElement} Root DOM node of the React component.
   */
  findReactNodeByID: function (id) {
    var reactRoot = ReactMount.findReactContainerForID(id);
    return ReactMount.findComponentRoot(reactRoot, id);
  },

  /**
   * Traverses up the ancestors of the supplied node to find a node that is a
   * DOM representation of a React component rendered by this copy of React.
   *
   * @param {*} node
   * @return {?DOMEventTarget}
   * @internal
   */
  getFirstReactDOM: function (node) {
    return findFirstReactDOMImpl(node);
  },

  /**
   * Finds a node with the supplied `targetID` inside of the supplied
   * `ancestorNode`.  Exploits the ID naming scheme to perform the search
   * quickly.
   *
   * @param {DOMEventTarget} ancestorNode Search from this root.
   * @pararm {string} targetID ID of the DOM representation of the component.
   * @return {DOMEventTarget} DOM node with the supplied `targetID`.
   * @internal
   */
  findComponentRoot: function (ancestorNode, targetID) {
    var firstChildren = findComponentRootReusableArray;
    var childIndex = 0;

    var deepestAncestor = findDeepestCachedAncestor(targetID) || ancestorNode;

    if ("production" !== 'production') {
      // This will throw on the next line; give an early warning
      "production" !== 'production' ? warning(deepestAncestor != null, 'React can\'t find the root component node for data-reactid value ' + '`%s`. If you\'re seeing this message, it probably means that ' + 'you\'ve loaded two copies of React on the page. At this time, only ' + 'a single copy of React can be loaded at a time.', targetID) : undefined;
    }

    firstChildren[0] = deepestAncestor.firstChild;
    firstChildren.length = 1;

    while (childIndex < firstChildren.length) {
      var child = firstChildren[childIndex++];
      var targetChild;

      while (child) {
        var childID = ReactMount.getID(child);
        if (childID) {
          // Even if we find the node we're looking for, we finish looping
          // through its siblings to ensure they're cached so that we don't have
          // to revisit this node again. Otherwise, we make n^2 calls to getID
          // when visiting the many children of a single node in order.

          if (targetID === childID) {
            targetChild = child;
          } else if (ReactInstanceHandles.isAncestorIDOf(childID, targetID)) {
            // If we find a child whose ID is an ancestor of the given ID,
            // then we can be sure that we only want to search the subtree
            // rooted at this child, so we can throw out the rest of the
            // search state.
            firstChildren.length = childIndex = 0;
            firstChildren.push(child.firstChild);
          }
        } else {
          // If this child had no ID, then there's a chance that it was
          // injected automatically by the browser, as when a `<table>`
          // element sprouts an extra `<tbody>` child as a side effect of
          // `.innerHTML` parsing. Optimistically continue down this
          // branch, but not before examining the other siblings.
          firstChildren.push(child.firstChild);
        }

        child = child.nextSibling;
      }

      if (targetChild) {
        // Emptying firstChildren/findComponentRootReusableArray is
        // not necessary for correctness, but it helps the GC reclaim
        // any nodes that were left at the end of the search.
        firstChildren.length = 0;

        return targetChild;
      }
    }

    firstChildren.length = 0;

    !false ? "production" !== 'production' ? invariant(false, 'findComponentRoot(..., %s): Unable to find element. This probably ' + 'means the DOM was unexpectedly mutated (e.g., by the browser), ' + 'usually due to forgetting a <tbody> when using tables, nesting tags ' + 'like <form>, <p>, or <a>, or using non-SVG elements in an <svg> ' + 'parent. ' + 'Try inspecting the child nodes of the element with React ID `%s`.', targetID, ReactMount.getID(ancestorNode)) : invariant(false) : undefined;
  },

  _mountImageIntoNode: function (markup, container, shouldReuseMarkup, transaction) {
    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ? "production" !== 'production' ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : invariant(false) : undefined;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if ("production" !== 'production') {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ? "production" !== 'production' ? invariant(false, 'You\'re trying to render a component to the document using ' + 'server rendering but the checksum was invalid. This usually ' + 'means you rendered a different component type or props on ' + 'the client from the one on the server, or your render() ' + 'methods are impure. React cannot handle this case due to ' + 'cross-browser quirks by rendering at the document root. You ' + 'should look for environment dependent code in your components ' + 'and ensure the props are the same client and server side:\n%s', difference) : invariant(false) : undefined;

        if ("production" !== 'production') {
          "production" !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : undefined;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ? "production" !== 'production' ? invariant(false, 'You\'re trying to render a component to the document but ' + 'you didn\'t use server rendering. We can\'t do this ' + 'without using server rendering due to cross-browser quirks. ' + 'See ReactDOMServer.renderToString() for server rendering.') : invariant(false) : undefined;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      container.appendChild(markup);
    } else {
      setInnerHTML(container, markup);
    }
  },

  ownerDocumentContextKey: ownerDocumentContextKey,

  /**
   * React ID utilities.
   */

  getReactRootID: getReactRootID,

  getID: getID,

  setID: setID,

  getNode: getNode,

  getNodeFromInstance: getNodeFromInstance,

  isValid: isValid,

  purgeID: purgeID
};

ReactPerf.measureMethods(ReactMount, 'ReactMount', {
  _renderNewRootComponent: '_renderNewRootComponent',
  _mountImageIntoNode: '_mountImageIntoNode'
});

module.exports = ReactMount;
},{"./DOMProperty":308,"./Object.assign":321,"./ReactBrowserEventEmitter":325,"./ReactCurrentOwner":333,"./ReactDOMFeatureFlags":338,"./ReactElement":351,"./ReactEmptyComponentRegistry":354,"./ReactInstanceHandles":360,"./ReactInstanceMap":361,"./ReactMarkupChecksum":363,"./ReactPerf":370,"./ReactReconciler":375,"./ReactUpdateQueue":381,"./ReactUpdates":382,"./instantiateReactComponent":417,"./setInnerHTML":423,"./shouldUpdateReactComponent":425,"./validateDOMNesting":427,"fbjs/lib/containsNode":432,"fbjs/lib/emptyObject":436,"fbjs/lib/invariant":443,"fbjs/lib/warning":454}],365:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactMultiChild
 * @typechecks static-only
 */

'use strict';

var ReactComponentEnvironment = require('./ReactComponentEnvironment');
var ReactMultiChildUpdateTypes = require('./ReactMultiChildUpdateTypes');

var ReactCurrentOwner = require('./ReactCurrentOwner');
var ReactReconciler = require('./ReactReconciler');
var ReactChildReconciler = require('./ReactChildReconciler');

var flattenChildren = require('./flattenChildren');

/**
 * Updating children of a component may trigger recursive updates. The depth is
 * used to batch recursive updates to render markup more efficiently.
 *
 * @type {number}
 * @private
 */
var updateDepth = 0;

/**
 * Queue of update configuration objects.
 *
 * Each object has a `type` property that is in `ReactMultiChildUpdateTypes`.
 *
 * @type {array<object>}
 * @private
 */
var updateQueue = [];

/**
 * Queue of markup to be rendered.
 *
 * @type {array<string>}
 * @private
 */
var markupQueue = [];

/**
 * Enqueues markup to be rendered and inserted at a supplied index.
 *
 * @param {string} parentID ID of the parent component.
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function enqueueInsertMarkup(parentID, markup, toIndex) {
  // NOTE: Null values reduce hidden classes.
  updateQueue.push({
    parentID: parentID,
    parentNode: null,
    type: ReactMultiChildUpdateTypes.INSERT_MARKUP,
    markupIndex: markupQueue.push(markup) - 1,
    content: null,
    fromIndex: null,
    toIndex: toIndex
  });
}

/**
 * Enqueues moving an existing element to another index.
 *
 * @param {string} parentID ID of the parent component.
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function enqueueMove(parentID, fromIndex, toIndex) {
  // NOTE: Null values reduce hidden classes.
  updateQueue.push({
    parentID: parentID,
    parentNode: null,
    type: ReactMultiChildUpdateTypes.MOVE_EXISTING,
    markupIndex: null,
    content: null,
    fromIndex: fromIndex,
    toIndex: toIndex
  });
}

/**
 * Enqueues removing an element at an index.
 *
 * @param {string} parentID ID of the parent component.
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function enqueueRemove(parentID, fromIndex) {
  // NOTE: Null values reduce hidden classes.
  updateQueue.push({
    parentID: parentID,
    parentNode: null,
    type: ReactMultiChildUpdateTypes.REMOVE_NODE,
    markupIndex: null,
    content: null,
    fromIndex: fromIndex,
    toIndex: null
  });
}

/**
 * Enqueues setting the markup of a node.
 *
 * @param {string} parentID ID of the parent component.
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function enqueueSetMarkup(parentID, markup) {
  // NOTE: Null values reduce hidden classes.
  updateQueue.push({
    parentID: parentID,
    parentNode: null,
    type: ReactMultiChildUpdateTypes.SET_MARKUP,
    markupIndex: null,
    content: markup,
    fromIndex: null,
    toIndex: null
  });
}

/**
 * Enqueues setting the text content.
 *
 * @param {string} parentID ID of the parent component.
 * @param {string} textContent Text content to set.
 * @private
 */
function enqueueTextContent(parentID, textContent) {
  // NOTE: Null values reduce hidden classes.
  updateQueue.push({
    parentID: parentID,
    parentNode: null,
    type: ReactMultiChildUpdateTypes.TEXT_CONTENT,
    markupIndex: null,
    content: textContent,
    fromIndex: null,
    toIndex: null
  });
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue() {
  if (updateQueue.length) {
    ReactComponentEnvironment.processChildrenUpdates(updateQueue, markupQueue);
    clearQueue();
  }
}

/**
 * Clears any enqueued updates.
 *
 * @private
 */
function clearQueue() {
  updateQueue.length = 0;
  markupQueue.length = 0;
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {

  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {

    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if ("production" !== 'production') {
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, transaction, context) {
      var nextChildren;
      if ("production" !== 'production') {
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements);
          } finally {
            ReactCurrentOwner.current = null;
          }
          return ReactChildReconciler.updateChildren(prevChildren, nextChildren, transaction, context);
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements);
      return ReactChildReconciler.updateChildren(prevChildren, nextChildren, transaction, context);
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;
      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          // Inlined for performance, see `ReactInstanceHandles.createReactID`.
          var rootID = this._rootNodeID + name;
          var mountImage = ReactReconciler.mountComponent(child, rootID, transaction, context);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }
      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      updateDepth++;
      var errorThrown = true;
      try {
        var prevChildren = this._renderedChildren;
        // Remove any rendered children.
        ReactChildReconciler.unmountChildren(prevChildren);
        // TODO: The setTextContent operation should be enough
        for (var name in prevChildren) {
          if (prevChildren.hasOwnProperty(name)) {
            this._unmountChild(prevChildren[name]);
          }
        }
        // Set new text content.
        this.setTextContent(nextContent);
        errorThrown = false;
      } finally {
        updateDepth--;
        if (!updateDepth) {
          if (errorThrown) {
            clearQueue();
          } else {
            processQueue();
          }
        }
      }
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      updateDepth++;
      var errorThrown = true;
      try {
        var prevChildren = this._renderedChildren;
        // Remove any rendered children.
        ReactChildReconciler.unmountChildren(prevChildren);
        for (var name in prevChildren) {
          if (prevChildren.hasOwnProperty(name)) {
            this._unmountChildByName(prevChildren[name], name);
          }
        }
        this.setMarkup(nextMarkup);
        errorThrown = false;
      } finally {
        updateDepth--;
        if (!updateDepth) {
          if (errorThrown) {
            clearQueue();
          } else {
            processQueue();
          }
        }
      }
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      updateDepth++;
      var errorThrown = true;
      try {
        this._updateChildren(nextNestedChildrenElements, transaction, context);
        errorThrown = false;
      } finally {
        updateDepth--;
        if (!updateDepth) {
          if (errorThrown) {
            clearQueue();
          } else {
            processQueue();
          }
        }
      }
    },

    /**
     * Improve performance by isolating this hot code path from the try/catch
     * block in `updateChildren`.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, transaction, context);
      this._renderedChildren = nextChildren;
      if (!nextChildren && !prevChildren) {
        return;
      }
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var lastIndex = 0;
      var nextIndex = 0;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          this.moveChild(prevChild, nextIndex, lastIndex);
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            this._unmountChild(prevChild);
          }
          // The child must be instantiated before it's mounted.
          this._mountChildByNameAtIndex(nextChild, name, nextIndex, transaction, context);
        }
        nextIndex++;
      }
      // Remove children that are no longer present.
      for (name in prevChildren) {
        if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
          this._unmountChild(prevChildren[name]);
        }
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted.
     *
     * @internal
     */
    unmountChildren: function () {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        enqueueMove(this._rootNodeID, child._mountIndex, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, mountImage) {
      enqueueInsertMarkup(this._rootNodeID, mountImage, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child) {
      enqueueRemove(this._rootNodeID, child._mountIndex);
    },

    /**
     * Sets this text content string.
     *
     * @param {string} textContent Text content to set.
     * @protected
     */
    setTextContent: function (textContent) {
      enqueueTextContent(this._rootNodeID, textContent);
    },

    /**
     * Sets this markup string.
     *
     * @param {string} markup Markup to set.
     * @protected
     */
    setMarkup: function (markup) {
      enqueueSetMarkup(this._rootNodeID, markup);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildByNameAtIndex: function (child, name, index, transaction, context) {
      // Inlined for performance, see `ReactInstanceHandles.createReactID`.
      var rootID = this._rootNodeID + name;
      var mountImage = ReactReconciler.mountComponent(child, rootID, transaction, context);
      child._mountIndex = index;
      this.createChild(child, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child) {
      this.removeChild(child);
      child._mountIndex = null;
    }

  }

};

module.exports = ReactMultiChild;
},{"./ReactChildReconciler":326,"./ReactComponentEnvironment":331,"./ReactCurrentOwner":333,"./ReactMultiChildUpdateTypes":366,"./ReactReconciler":375,"./flattenChildren":408}],366:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactMultiChildUpdateTypes
 */

'use strict';

var keyMirror = require('fbjs/lib/keyMirror');

/**
 * When a component's children are updated, a series of update configuration
 * objects are created in order to batch and serialize the required changes.
 *
 * Enumerates all the possible types of update configurations.
 *
 * @internal
 */
var ReactMultiChildUpdateTypes = keyMirror({
  INSERT_MARKUP: null,
  MOVE_EXISTING: null,
  REMOVE_NODE: null,
  SET_MARKUP: null,
  TEXT_CONTENT: null
});

module.exports = ReactMultiChildUpdateTypes;
},{"fbjs/lib/keyMirror":446}],367:[function(require,module,exports){
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactNativeComponent
 */

'use strict';

var assign = require('./Object.assign');
var invariant = require('fbjs/lib/invariant');

var autoGenerateWrapperClass = null;
var genericComponentClass = null;
// This registry keeps track of wrapper classes around native tags.
var tagToComponentClass = {};
var textComponentClass = null;

var ReactNativeComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  },
  // This accepts a keyed object with classes as values. Each key represents a
  // tag. That particular tag will use this class instead of the generic one.
  injectComponentClasses: function (componentClasses) {
    assign(tagToComponentClass, componentClasses);
  }
};

/**
 * Get a composite component wrapper class for a specific tag.
 *
 * @param {ReactElement} element The tag for which to get the class.
 * @return {function} The React class constructor function.
 */
function getComponentClassForElement(element) {
  if (typeof element.type === 'function') {
    return element.type;
  }
  var tag = element.type;
  var componentClass = tagToComponentClass[tag];
  if (componentClass == null) {
    tagToComponentClass[tag] = componentClass = autoGenerateWrapperClass(tag);
  }
  return componentClass;
}

/**
 * Get a native internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ? "production" !== 'production' ? invariant(false, 'There is no registered component for the tag %s', element.type) : invariant(false) : undefined;
  return new genericComponentClass(element.type, element.props);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactNativeComponent = {
  getComponentClassForElement: getComponentClassForElement,
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactNativeComponentInjection
};

module.exports = ReactNativeComponent;
},{"./Object.assign":321,"fbjs/lib/invariant":443}],368:[function(require,module,exports){
/**
 * Copyright 2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactNoopUpdateQueue
 */

'use strict';

var warning = require('fbjs/lib/warning');

function warnTDZ(publicInstance, callerName) {
  if ("production" !== 'production') {
    "production" !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor && publicInstance.constructor.displayName || '') : undefined;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnTDZ(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnTDZ(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnTDZ(publicInstance, 'setState');
  },

  /**
   * Sets a subset of the props.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialProps Subset of the next props.
   * @internal
   */
  enqueueSetProps: function (publicInstance, partialProps) {
    warnTDZ(publicInstance, 'setProps');
  },

  /**
   * Replaces all of the props.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} props New props.
   * @internal
   */
  enqueueReplaceProps: function (publicInstance, props) {
    warnTDZ(publicInstance, 'replaceProps');
  }

};

module.exports = ReactNoopUpdateQueue;
},{"fbjs/lib/warning":454}],369:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactOwner
 */

'use strict';

var invariant = require('fbjs/lib/invariant');

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {

  /**
   * @param {?object} object
   * @return {boolean} True if `object` is a valid owner.
   * @final
   */
  isValidOwner: function (object) {
    return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
  },

  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !ReactOwner.isValidOwner(owner) ? "production" !== 'production' ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might ' + 'be adding a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : undefined;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !ReactOwner.isValidOwner(owner) ? "production" !== 'production' ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might ' + 'be removing a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : undefined;
    // Check that `component` is still the current ref because we do not want to
    // detach the ref if another component stole it.
    if (owner.getPublicInstance().refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }

};

module.exports = ReactOwner;
},{"fbjs/lib/invariant":443}],370:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactPerf
 * @typechecks static-only
 */

'use strict';

/**
 * ReactPerf is a general AOP system designed to measure performance. This
 * module only has the hooks: see ReactDefaultPerf for the analysis tool.
 */
var ReactPerf = {
  /**
   * Boolean to enable/disable measurement. Set to false by default to prevent
   * accidental logging and perf loss.
   */
  enableMeasure: false,

  /**
   * Holds onto the measure function in use. By default, don't measure
   * anything, but we'll override this if we inject a measure function.
   */
  storedMeasure: _noMeasure,

  /**
   * @param {object} object
   * @param {string} objectName
   * @param {object<string>} methodNames
   */
  measureMethods: function (object, objectName, methodNames) {
    if ("production" !== 'production') {
      for (var key in methodNames) {
        if (!methodNames.hasOwnProperty(key)) {
          continue;
        }
        object[key] = ReactPerf.measure(objectName, methodNames[key], object[key]);
      }
    }
  },

  /**
   * Use this to wrap methods you want to measure. Zero overhead in production.
   *
   * @param {string} objName
   * @param {string} fnName
   * @param {function} func
   * @return {function}
   */
  measure: function (objName, fnName, func) {
    if ("production" !== 'production') {
      var measuredFunc = null;
      var wrapper = function () {
        if (ReactPerf.enableMeasure) {
          if (!measuredFunc) {
            measuredFunc = ReactPerf.storedMeasure(objName, fnName, func);
          }
          return measuredFunc.apply(this, arguments);
        }
        return func.apply(this, arguments);
      };
      wrapper.displayName = objName + '_' + fnName;
      return wrapper;
    }
    return func;
  },

  injection: {
    /**
     * @param {function} measure
     */
    injectMeasure: function (measure) {
      ReactPerf.storedMeasure = measure;
    }
  }
};

/**
 * Simply passes through the measured function, without measuring it.
 *
 * @param {string} objName
 * @param {string} fnName
 * @param {function} func
 * @return {function}
 */
function _noMeasure(objName, fnName, func) {
  return func;
}

module.exports = ReactPerf;
},{}],371:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactPropTypeLocationNames
 */

'use strict';

var ReactPropTypeLocationNames = {};

if ("production" !== 'production') {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
}

module.exports = ReactPropTypeLocationNames;
},{}],372:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactPropTypeLocations
 */

'use strict';

var keyMirror = require('fbjs/lib/keyMirror');

var ReactPropTypeLocations = keyMirror({
  prop: null,
  context: null,
  childContext: null
});

module.exports = ReactPropTypeLocations;
},{"fbjs/lib/keyMirror":446}],373:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactPropTypes
 */

'use strict';

var ReactElement = require('./ReactElement');
var ReactPropTypeLocationNames = require('./ReactPropTypeLocationNames');

var emptyFunction = require('fbjs/lib/emptyFunction');
var getIteratorFn = require('./getIteratorFn');

/**
 * Collection of methods that allow declaration and validation of props that are
 * supplied to React components. Example usage:
 *
 *   var Props = require('ReactPropTypes');
 *   var MyArticle = React.createClass({
 *     propTypes: {
 *       // An optional string prop named "description".
 *       description: Props.string,
 *
 *       // A required enum prop named "category".
 *       category: Props.oneOf(['News','Photos']).isRequired,
 *
 *       // A prop named "dialog" that requires an instance of Dialog.
 *       dialog: Props.instanceOf(Dialog).isRequired
 *     },
 *     render: function() { ... }
 *   });
 *
 * A more formal specification of how these methods are used:
 *
 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
 *   decl := ReactPropTypes.{type}(.isRequired)?
 *
 * Each and every declaration produces a function with the same signature. This
 * allows the creation of custom validation functions. For example:
 *
 *  var MyLink = React.createClass({
 *    propTypes: {
 *      // An optional string or URI prop named "href".
 *      href: function(props, propName, componentName) {
 *        var propValue = props[propName];
 *        if (propValue != null && typeof propValue !== 'string' &&
 *            !(propValue instanceof URI)) {
 *          return new Error(
 *            'Expected a string or an URI for ' + propName + ' in ' +
 *            componentName
 *          );
 *        }
 *      }
 *    },
 *    render: function() {...}
 *  });
 *
 * @internal
 */

var ANONYMOUS = '<<anonymous>>';

var ReactPropTypes = {
  array: createPrimitiveTypeChecker('array'),
  bool: createPrimitiveTypeChecker('boolean'),
  func: createPrimitiveTypeChecker('function'),
  number: createPrimitiveTypeChecker('number'),
  object: createPrimitiveTypeChecker('object'),
  string: createPrimitiveTypeChecker('string'),

  any: createAnyTypeChecker(),
  arrayOf: createArrayOfTypeChecker,
  element: createElementTypeChecker(),
  instanceOf: createInstanceTypeChecker,
  node: createNodeChecker(),
  objectOf: createObjectOfTypeChecker,
  oneOf: createEnumTypeChecker,
  oneOfType: createUnionTypeChecker,
  shape: createShapeTypeChecker
};

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    componentName = componentName || ANONYMOUS;
    propFullName = propFullName || propName;
    if (props[propName] == null) {
      var locationName = ReactPropTypeLocationNames[location];
      if (isRequired) {
        return new Error('Required ' + locationName + ' `' + propFullName + '` was not specified in ' + ('`' + componentName + '`.'));
      }
      return null;
    } else {
      return validate(props, propName, componentName, location, propFullName);
    }
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}

function createPrimitiveTypeChecker(expectedType) {
  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    var propType = getPropType(propValue);
    if (propType !== expectedType) {
      var locationName = ReactPropTypeLocationNames[location];
      // `propValue` being instance of, say, date/regexp, pass the 'object'
      // check, but we can offer a more precise error message here rather than
      // 'of type `object`'.
      var preciseType = getPreciseType(propValue);

      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createAnyTypeChecker() {
  return createChainableTypeChecker(emptyFunction.thatReturns(null));
}

function createArrayOfTypeChecker(typeChecker) {
  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    if (!Array.isArray(propValue)) {
      var locationName = ReactPropTypeLocationNames[location];
      var propType = getPropType(propValue);
      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
    }
    for (var i = 0; i < propValue.length; i++) {
      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']');
      if (error instanceof Error) {
        return error;
      }
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createElementTypeChecker() {
  function validate(props, propName, componentName, location, propFullName) {
    if (!ReactElement.isValidElement(props[propName])) {
      var locationName = ReactPropTypeLocationNames[location];
      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a single ReactElement.'));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createInstanceTypeChecker(expectedClass) {
  function validate(props, propName, componentName, location, propFullName) {
    if (!(props[propName] instanceof expectedClass)) {
      var locationName = ReactPropTypeLocationNames[location];
      var expectedClassName = expectedClass.name || ANONYMOUS;
      var actualClassName = getClassName(props[propName]);
      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createEnumTypeChecker(expectedValues) {
  if (!Array.isArray(expectedValues)) {
    return createChainableTypeChecker(function () {
      return new Error('Invalid argument supplied to oneOf, expected an instance of array.');
    });
  }

  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    for (var i = 0; i < expectedValues.length; i++) {
      if (propValue === expectedValues[i]) {
        return null;
      }
    }

    var locationName = ReactPropTypeLocationNames[location];
    var valuesString = JSON.stringify(expectedValues);
    return new Error('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
  }
  return createChainableTypeChecker(validate);
}

function createObjectOfTypeChecker(typeChecker) {
  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    var propType = getPropType(propValue);
    if (propType !== 'object') {
      var locationName = ReactPropTypeLocationNames[location];
      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
    }
    for (var key in propValue) {
      if (propValue.hasOwnProperty(key)) {
        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key);
        if (error instanceof Error) {
          return error;
        }
      }
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createUnionTypeChecker(arrayOfTypeCheckers) {
  if (!Array.isArray(arrayOfTypeCheckers)) {
    return createChainableTypeChecker(function () {
      return new Error('Invalid argument supplied to oneOfType, expected an instance of array.');
    });
  }

  function validate(props, propName, componentName, location, propFullName) {
    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (checker(props, propName, componentName, location, propFullName) == null) {
        return null;
      }
    }

    var locationName = ReactPropTypeLocationNames[location];
    return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
  }
  return createChainableTypeChecker(validate);
}

function createNodeChecker() {
  function validate(props, propName, componentName, location, propFullName) {
    if (!isNode(props[propName])) {
      var locationName = ReactPropTypeLocationNames[location];
      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createShapeTypeChecker(shapeTypes) {
  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    var propType = getPropType(propValue);
    if (propType !== 'object') {
      var locationName = ReactPropTypeLocationNames[location];
      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
    }
    for (var key in shapeTypes) {
      var checker = shapeTypes[key];
      if (!checker) {
        continue;
      }
      var error = checker(propValue, key, componentName, location, propFullName + '.' + key);
      if (error) {
        return error;
      }
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function isNode(propValue) {
  switch (typeof propValue) {
    case 'number':
    case 'string':
    case 'undefined':
      return true;
    case 'boolean':
      return !propValue;
    case 'object':
      if (Array.isArray(propValue)) {
        return propValue.every(isNode);
      }
      if (propValue === null || ReactElement.isValidElement(propValue)) {
        return true;
      }

      var iteratorFn = getIteratorFn(propValue);
      if (iteratorFn) {
        var iterator = iteratorFn.call(propValue);
        var step;
        if (iteratorFn !== propValue.entries) {
          while (!(step = iterator.next()).done) {
            if (!isNode(step.value)) {
              return false;
            }
          }
        } else {
          // Iterator will provide entry [k,v] tuples rather than values.
          while (!(step = iterator.next()).done) {
            var entry = step.value;
            if (entry) {
              if (!isNode(entry[1])) {
                return false;
              }
            }
          }
        }
      } else {
        return false;
      }

      return true;
    default:
      return false;
  }
}

// Equivalent of `typeof` but with special handling for array and regexp.
function getPropType(propValue) {
  var propType = typeof propValue;
  if (Array.isArray(propValue)) {
    return 'array';
  }
  if (propValue instanceof RegExp) {
    // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return 'object';
  }
  return propType;
}

// This handles more types than `getPropType`. Only used for error messages.
// See `createPrimitiveTypeChecker`.
function getPreciseType(propValue) {
  var propType = getPropType(propValue);
  if (propType === 'object') {
    if (propValue instanceof Date) {
      return 'date';
    } else if (propValue instanceof RegExp) {
      return 'regexp';
    }
  }
  return propType;
}

// Returns class name of the object, if any.
function getClassName(propValue) {
  if (!propValue.constructor || !propValue.constructor.name) {
    return '<<anonymous>>';
  }
  return propValue.constructor.name;
}

module.exports = ReactPropTypes;
},{"./ReactElement":351,"./ReactPropTypeLocationNames":371,"./getIteratorFn":414,"fbjs/lib/emptyFunction":435}],374:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactReconcileTransaction
 * @typechecks static-only
 */

'use strict';

var CallbackQueue = require('./CallbackQueue');
var PooledClass = require('./PooledClass');
var ReactBrowserEventEmitter = require('./ReactBrowserEventEmitter');
var ReactDOMFeatureFlags = require('./ReactDOMFeatureFlags');
var ReactInputSelection = require('./ReactInputSelection');
var Transaction = require('./Transaction');

var assign = require('./Object.assign');

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(forceHTML) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = !forceHTML && ReactDOMFeatureFlags.useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

assign(ReactReconcileTransaction.prototype, Transaction.Mixin, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;
},{"./CallbackQueue":304,"./Object.assign":321,"./PooledClass":322,"./ReactBrowserEventEmitter":325,"./ReactDOMFeatureFlags":338,"./ReactInputSelection":359,"./Transaction":399}],375:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactReconciler
 */

'use strict';

var ReactRef = require('./ReactRef');

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {string} rootID DOM ID of the root node.
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, rootID, transaction, context) {
    var markup = internalInstance.mountComponent(rootID, transaction, context);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    return markup;
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance) {
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent();
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction) {
    internalInstance.performUpdateIfNecessary(transaction);
  }

};

module.exports = ReactReconciler;
},{"./ReactRef":376}],376:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactRef
 */

'use strict';

var ReactOwner = require('./ReactOwner');

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || element === false) {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;

  return(
    // This has a few false positives w/r/t empty components.
    prevEmpty || nextEmpty || nextElement._owner !== prevElement._owner || nextElement.ref !== prevElement.ref
  );
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || element === false) {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;
},{"./ReactOwner":369}],377:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactRootIndex
 * @typechecks
 */

'use strict';

var ReactRootIndexInjection = {
  /**
   * @param {function} _createReactRootIndex
   */
  injectCreateReactRootIndex: function (_createReactRootIndex) {
    ReactRootIndex.createReactRootIndex = _createReactRootIndex;
  }
};

var ReactRootIndex = {
  createReactRootIndex: null,
  injection: ReactRootIndexInjection
};

module.exports = ReactRootIndex;
},{}],378:[function(require,module,exports){
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactServerBatchingStrategy
 * @typechecks
 */

'use strict';

var ReactServerBatchingStrategy = {
  isBatchingUpdates: false,
  batchedUpdates: function (callback) {
    // Don't do anything here. During the server rendering we don't want to
    // schedule any updates. We will simply ignore them.
  }
};

module.exports = ReactServerBatchingStrategy;
},{}],379:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks static-only
 * @providesModule ReactServerRendering
 */
'use strict';

var ReactDefaultBatchingStrategy = require('./ReactDefaultBatchingStrategy');
var ReactElement = require('./ReactElement');
var ReactInstanceHandles = require('./ReactInstanceHandles');
var ReactMarkupChecksum = require('./ReactMarkupChecksum');
var ReactServerBatchingStrategy = require('./ReactServerBatchingStrategy');
var ReactServerRenderingTransaction = require('./ReactServerRenderingTransaction');
var ReactUpdates = require('./ReactUpdates');

var emptyObject = require('fbjs/lib/emptyObject');
var instantiateReactComponent = require('./instantiateReactComponent');
var invariant = require('fbjs/lib/invariant');

/**
 * @param {ReactElement} element
 * @return {string} the HTML markup
 */
function renderToString(element) {
  !ReactElement.isValidElement(element) ? "production" !== 'production' ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : invariant(false) : undefined;

  var transaction;
  try {
    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);

    var id = ReactInstanceHandles.createReactRootID();
    transaction = ReactServerRenderingTransaction.getPooled(false);

    return transaction.perform(function () {
      var componentInstance = instantiateReactComponent(element, null);
      var markup = componentInstance.mountComponent(id, transaction, emptyObject);
      return ReactMarkupChecksum.addChecksumToMarkup(markup);
    }, null);
  } finally {
    ReactServerRenderingTransaction.release(transaction);
    // Revert to the DOM batching strategy since these two renderers
    // currently share these stateful modules.
    ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
  }
}

/**
 * @param {ReactElement} element
 * @return {string} the HTML markup, without the extra React ID and checksum
 * (for generating static pages)
 */
function renderToStaticMarkup(element) {
  !ReactElement.isValidElement(element) ? "production" !== 'production' ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : invariant(false) : undefined;

  var transaction;
  try {
    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);

    var id = ReactInstanceHandles.createReactRootID();
    transaction = ReactServerRenderingTransaction.getPooled(true);

    return transaction.perform(function () {
      var componentInstance = instantiateReactComponent(element, null);
      return componentInstance.mountComponent(id, transaction, emptyObject);
    }, null);
  } finally {
    ReactServerRenderingTransaction.release(transaction);
    // Revert to the DOM batching strategy since these two renderers
    // currently share these stateful modules.
    ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
  }
}

module.exports = {
  renderToString: renderToString,
  renderToStaticMarkup: renderToStaticMarkup
};
},{"./ReactDefaultBatchingStrategy":347,"./ReactElement":351,"./ReactInstanceHandles":360,"./ReactMarkupChecksum":363,"./ReactServerBatchingStrategy":378,"./ReactServerRenderingTransaction":380,"./ReactUpdates":382,"./instantiateReactComponent":417,"fbjs/lib/emptyObject":436,"fbjs/lib/invariant":443}],380:[function(require,module,exports){
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactServerRenderingTransaction
 * @typechecks
 */

'use strict';

var PooledClass = require('./PooledClass');
var CallbackQueue = require('./CallbackQueue');
var Transaction = require('./Transaction');

var assign = require('./Object.assign');
var emptyFunction = require('fbjs/lib/emptyFunction');

/**
 * Provides a `CallbackQueue` queue for collecting `onDOMReady` callbacks
 * during the performing of the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  close: emptyFunction
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [ON_DOM_READY_QUEUEING];

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = false;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

assign(ReactServerRenderingTransaction.prototype, Transaction.Mixin, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;
},{"./CallbackQueue":304,"./Object.assign":321,"./PooledClass":322,"./Transaction":399,"fbjs/lib/emptyFunction":435}],381:[function(require,module,exports){
/**
 * Copyright 2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactUpdateQueue
 */

'use strict';

var ReactCurrentOwner = require('./ReactCurrentOwner');
var ReactElement = require('./ReactElement');
var ReactInstanceMap = require('./ReactInstanceMap');
var ReactUpdates = require('./ReactUpdates');

var assign = require('./Object.assign');
var invariant = require('fbjs/lib/invariant');
var warning = require('fbjs/lib/warning');

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if ("production" !== 'production') {
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      "production" !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor.displayName) : undefined;
    }
    return null;
  }

  if ("production" !== 'production') {
    "production" !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition ' + '(such as within `render`). Render methods should be a pure function ' + 'of props and state.', callerName) : undefined;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if ("production" !== 'production') {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        "production" !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : undefined;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {
    !(typeof callback === 'function') ? "production" !== 'production' ? invariant(false, 'enqueueCallback(...): You called `setProps`, `replaceProps`, ' + '`setState`, `replaceState`, or `forceUpdate` with a callback that ' + 'isn\'t callable.') : invariant(false) : undefined;
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    !(typeof callback === 'function') ? "production" !== 'production' ? invariant(false, 'enqueueCallback(...): You called `setProps`, `replaceProps`, ' + '`setState`, `replaceState`, or `forceUpdate` with a callback that ' + 'isn\'t callable.') : invariant(false) : undefined;
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the props.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialProps Subset of the next props.
   * @internal
   */
  enqueueSetProps: function (publicInstance, partialProps) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setProps');
    if (!internalInstance) {
      return;
    }
    ReactUpdateQueue.enqueueSetPropsInternal(internalInstance, partialProps);
  },

  enqueueSetPropsInternal: function (internalInstance, partialProps) {
    var topLevelWrapper = internalInstance._topLevelWrapper;
    !topLevelWrapper ? "production" !== 'production' ? invariant(false, 'setProps(...): You called `setProps` on a ' + 'component with a parent. This is an anti-pattern since props will ' + 'get reactively updated when rendered. Instead, change the owner\'s ' + '`render` method to pass the correct value as props to the component ' + 'where it is created.') : invariant(false) : undefined;

    // Merge with the pending element if it exists, otherwise with existing
    // element props.
    var wrapElement = topLevelWrapper._pendingElement || topLevelWrapper._currentElement;
    var element = wrapElement.props;
    var props = assign({}, element.props, partialProps);
    topLevelWrapper._pendingElement = ReactElement.cloneAndReplaceProps(wrapElement, ReactElement.cloneAndReplaceProps(element, props));

    enqueueUpdate(topLevelWrapper);
  },

  /**
   * Replaces all of the props.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} props New props.
   * @internal
   */
  enqueueReplaceProps: function (publicInstance, props) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceProps');
    if (!internalInstance) {
      return;
    }
    ReactUpdateQueue.enqueueReplacePropsInternal(internalInstance, props);
  },

  enqueueReplacePropsInternal: function (internalInstance, props) {
    var topLevelWrapper = internalInstance._topLevelWrapper;
    !topLevelWrapper ? "production" !== 'production' ? invariant(false, 'replaceProps(...): You called `replaceProps` on a ' + 'component with a parent. This is an anti-pattern since props will ' + 'get reactively updated when rendered. Instead, change the owner\'s ' + '`render` method to pass the correct value as props to the component ' + 'where it is created.') : invariant(false) : undefined;

    // Merge with the pending element if it exists, otherwise with existing
    // element props.
    var wrapElement = topLevelWrapper._pendingElement || topLevelWrapper._currentElement;
    var element = wrapElement.props;
    topLevelWrapper._pendingElement = ReactElement.cloneAndReplaceProps(wrapElement, ReactElement.cloneAndReplaceProps(element, props));

    enqueueUpdate(topLevelWrapper);
  },

  enqueueElementInternal: function (internalInstance, newElement) {
    internalInstance._pendingElement = newElement;
    enqueueUpdate(internalInstance);
  }

};

module.exports = ReactUpdateQueue;
},{"./Object.assign":321,"./ReactCurrentOwner":333,"./ReactElement":351,"./ReactInstanceMap":361,"./ReactUpdates":382,"fbjs/lib/invariant":443,"fbjs/lib/warning":454}],382:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactUpdates
 */

'use strict';

var CallbackQueue = require('./CallbackQueue');
var PooledClass = require('./PooledClass');
var ReactPerf = require('./ReactPerf');
var ReactReconciler = require('./ReactReconciler');
var Transaction = require('./Transaction');

var assign = require('./Object.assign');
var invariant = require('fbjs/lib/invariant');

var dirtyComponents = [];
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ? "production" !== 'production' ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching ' + 'strategy') : invariant(false) : undefined;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled( /* forceHTML */false);
}

assign(ReactUpdatesFlushTransaction.prototype, Transaction.Mixin, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.Mixin.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ? "production" !== 'production' ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to ' + 'match dirty-components array length (%s).', len, dirtyComponents.length) : invariant(false) : undefined;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction);

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};
flushBatchedUpdates = ReactPerf.measure('ReactUpdates', 'flushBatchedUpdates', flushBatchedUpdates);

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setProps, setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  !batchingStrategy.isBatchingUpdates ? "production" !== 'production' ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context where' + 'updates are not being batched.') : invariant(false) : undefined;
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ? "production" !== 'production' ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : invariant(false) : undefined;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ? "production" !== 'production' ? invariant(false, 'ReactUpdates: must provide a batching strategy') : invariant(false) : undefined;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ? "production" !== 'production' ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : invariant(false) : undefined;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ? "production" !== 'production' ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : invariant(false) : undefined;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;
},{"./CallbackQueue":304,"./Object.assign":321,"./PooledClass":322,"./ReactPerf":370,"./ReactReconciler":375,"./Transaction":399,"fbjs/lib/invariant":443}],383:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactVersion
 */

'use strict';

module.exports = '0.14.3';
},{}],384:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SVGDOMPropertyConfig
 */

'use strict';

var DOMProperty = require('./DOMProperty');

var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;

var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

var SVGDOMPropertyConfig = {
  Properties: {
    clipPath: MUST_USE_ATTRIBUTE,
    cx: MUST_USE_ATTRIBUTE,
    cy: MUST_USE_ATTRIBUTE,
    d: MUST_USE_ATTRIBUTE,
    dx: MUST_USE_ATTRIBUTE,
    dy: MUST_USE_ATTRIBUTE,
    fill: MUST_USE_ATTRIBUTE,
    fillOpacity: MUST_USE_ATTRIBUTE,
    fontFamily: MUST_USE_ATTRIBUTE,
    fontSize: MUST_USE_ATTRIBUTE,
    fx: MUST_USE_ATTRIBUTE,
    fy: MUST_USE_ATTRIBUTE,
    gradientTransform: MUST_USE_ATTRIBUTE,
    gradientUnits: MUST_USE_ATTRIBUTE,
    markerEnd: MUST_USE_ATTRIBUTE,
    markerMid: MUST_USE_ATTRIBUTE,
    markerStart: MUST_USE_ATTRIBUTE,
    offset: MUST_USE_ATTRIBUTE,
    opacity: MUST_USE_ATTRIBUTE,
    patternContentUnits: MUST_USE_ATTRIBUTE,
    patternUnits: MUST_USE_ATTRIBUTE,
    points: MUST_USE_ATTRIBUTE,
    preserveAspectRatio: MUST_USE_ATTRIBUTE,
    r: MUST_USE_ATTRIBUTE,
    rx: MUST_USE_ATTRIBUTE,
    ry: MUST_USE_ATTRIBUTE,
    spreadMethod: MUST_USE_ATTRIBUTE,
    stopColor: MUST_USE_ATTRIBUTE,
    stopOpacity: MUST_USE_ATTRIBUTE,
    stroke: MUST_USE_ATTRIBUTE,
    strokeDasharray: MUST_USE_ATTRIBUTE,
    strokeLinecap: MUST_USE_ATTRIBUTE,
    strokeOpacity: MUST_USE_ATTRIBUTE,
    strokeWidth: MUST_USE_ATTRIBUTE,
    textAnchor: MUST_USE_ATTRIBUTE,
    transform: MUST_USE_ATTRIBUTE,
    version: MUST_USE_ATTRIBUTE,
    viewBox: MUST_USE_ATTRIBUTE,
    x1: MUST_USE_ATTRIBUTE,
    x2: MUST_USE_ATTRIBUTE,
    x: MUST_USE_ATTRIBUTE,
    xlinkActuate: MUST_USE_ATTRIBUTE,
    xlinkArcrole: MUST_USE_ATTRIBUTE,
    xlinkHref: MUST_USE_ATTRIBUTE,
    xlinkRole: MUST_USE_ATTRIBUTE,
    xlinkShow: MUST_USE_ATTRIBUTE,
    xlinkTitle: MUST_USE_ATTRIBUTE,
    xlinkType: MUST_USE_ATTRIBUTE,
    xmlBase: MUST_USE_ATTRIBUTE,
    xmlLang: MUST_USE_ATTRIBUTE,
    xmlSpace: MUST_USE_ATTRIBUTE,
    y1: MUST_USE_ATTRIBUTE,
    y2: MUST_USE_ATTRIBUTE,
    y: MUST_USE_ATTRIBUTE
  },
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {
    clipPath: 'clip-path',
    fillOpacity: 'fill-opacity',
    fontFamily: 'font-family',
    fontSize: 'font-size',
    gradientTransform: 'gradientTransform',
    gradientUnits: 'gradientUnits',
    markerEnd: 'marker-end',
    markerMid: 'marker-mid',
    markerStart: 'marker-start',
    patternContentUnits: 'patternContentUnits',
    patternUnits: 'patternUnits',
    preserveAspectRatio: 'preserveAspectRatio',
    spreadMethod: 'spreadMethod',
    stopColor: 'stop-color',
    stopOpacity: 'stop-opacity',
    strokeDasharray: 'stroke-dasharray',
    strokeLinecap: 'stroke-linecap',
    strokeOpacity: 'stroke-opacity',
    strokeWidth: 'stroke-width',
    textAnchor: 'text-anchor',
    viewBox: 'viewBox',
    xlinkActuate: 'xlink:actuate',
    xlinkArcrole: 'xlink:arcrole',
    xlinkHref: 'xlink:href',
    xlinkRole: 'xlink:role',
    xlinkShow: 'xlink:show',
    xlinkTitle: 'xlink:title',
    xlinkType: 'xlink:type',
    xmlBase: 'xml:base',
    xmlLang: 'xml:lang',
    xmlSpace: 'xml:space'
  }
};

module.exports = SVGDOMPropertyConfig;
},{"./DOMProperty":308}],385:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SelectEventPlugin
 */

'use strict';

var EventConstants = require('./EventConstants');
var EventPropagators = require('./EventPropagators');
var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
var ReactInputSelection = require('./ReactInputSelection');
var SyntheticEvent = require('./SyntheticEvent');

var getActiveElement = require('fbjs/lib/getActiveElement');
var isTextInputElement = require('./isTextInputElement');
var keyOf = require('fbjs/lib/keyOf');
var shallowEqual = require('fbjs/lib/shallowEqual');

var topLevelTypes = EventConstants.topLevelTypes;

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onSelect: null }),
      captured: keyOf({ onSelectCapture: null })
    },
    dependencies: [topLevelTypes.topBlur, topLevelTypes.topContextMenu, topLevelTypes.topFocus, topLevelTypes.topKeyDown, topLevelTypes.topMouseDown, topLevelTypes.topMouseUp, topLevelTypes.topSelectionChange]
  }
};

var activeElement = null;
var activeElementID = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events.
var hasListener = false;
var ON_SELECT_KEY = keyOf({ onSelect: null });

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementID, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {

  eventTypes: eventTypes,

  /**
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {DOMEventTarget} topLevelTarget The listening component root node.
   * @param {string} topLevelTargetID ID of `topLevelTarget`.
   * @param {object} nativeEvent Native browser event.
   * @return {*} An accumulation of synthetic events.
   * @see {EventPluginHub.extractEvents}
   */
  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    switch (topLevelType) {
      // Track the input node that has focus.
      case topLevelTypes.topFocus:
        if (isTextInputElement(topLevelTarget) || topLevelTarget.contentEditable === 'true') {
          activeElement = topLevelTarget;
          activeElementID = topLevelTargetID;
          lastSelection = null;
        }
        break;
      case topLevelTypes.topBlur:
        activeElement = null;
        activeElementID = null;
        lastSelection = null;
        break;

      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case topLevelTypes.topMouseDown:
        mouseDown = true;
        break;
      case topLevelTypes.topContextMenu:
      case topLevelTypes.topMouseUp:
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);

      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case topLevelTypes.topSelectionChange:
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case topLevelTypes.topKeyDown:
      case topLevelTypes.topKeyUp:
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (id, registrationName, listener) {
    if (registrationName === ON_SELECT_KEY) {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;
},{"./EventConstants":313,"./EventPropagators":317,"./ReactInputSelection":359,"./SyntheticEvent":391,"./isTextInputElement":419,"fbjs/lib/ExecutionEnvironment":429,"fbjs/lib/getActiveElement":438,"fbjs/lib/keyOf":447,"fbjs/lib/shallowEqual":452}],386:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ServerReactRootIndex
 * @typechecks
 */

'use strict';

/**
 * Size of the reactRoot ID space. We generate random numbers for React root
 * IDs and if there's a collision the events and DOM update system will
 * get confused. In the future we need a way to generate GUIDs but for
 * now this will work on a smaller scale.
 */
var GLOBAL_MOUNT_POINT_MAX = Math.pow(2, 53);

var ServerReactRootIndex = {
  createReactRootIndex: function () {
    return Math.ceil(Math.random() * GLOBAL_MOUNT_POINT_MAX);
  }
};

module.exports = ServerReactRootIndex;
},{}],387:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SimpleEventPlugin
 */

'use strict';

var EventConstants = require('./EventConstants');
var EventListener = require('fbjs/lib/EventListener');
var EventPropagators = require('./EventPropagators');
var ReactMount = require('./ReactMount');
var SyntheticClipboardEvent = require('./SyntheticClipboardEvent');
var SyntheticEvent = require('./SyntheticEvent');
var SyntheticFocusEvent = require('./SyntheticFocusEvent');
var SyntheticKeyboardEvent = require('./SyntheticKeyboardEvent');
var SyntheticMouseEvent = require('./SyntheticMouseEvent');
var SyntheticDragEvent = require('./SyntheticDragEvent');
var SyntheticTouchEvent = require('./SyntheticTouchEvent');
var SyntheticUIEvent = require('./SyntheticUIEvent');
var SyntheticWheelEvent = require('./SyntheticWheelEvent');

var emptyFunction = require('fbjs/lib/emptyFunction');
var getEventCharCode = require('./getEventCharCode');
var invariant = require('fbjs/lib/invariant');
var keyOf = require('fbjs/lib/keyOf');

var topLevelTypes = EventConstants.topLevelTypes;

var eventTypes = {
  abort: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onAbort: true }),
      captured: keyOf({ onAbortCapture: true })
    }
  },
  blur: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onBlur: true }),
      captured: keyOf({ onBlurCapture: true })
    }
  },
  canPlay: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onCanPlay: true }),
      captured: keyOf({ onCanPlayCapture: true })
    }
  },
  canPlayThrough: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onCanPlayThrough: true }),
      captured: keyOf({ onCanPlayThroughCapture: true })
    }
  },
  click: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onClick: true }),
      captured: keyOf({ onClickCapture: true })
    }
  },
  contextMenu: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onContextMenu: true }),
      captured: keyOf({ onContextMenuCapture: true })
    }
  },
  copy: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onCopy: true }),
      captured: keyOf({ onCopyCapture: true })
    }
  },
  cut: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onCut: true }),
      captured: keyOf({ onCutCapture: true })
    }
  },
  doubleClick: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDoubleClick: true }),
      captured: keyOf({ onDoubleClickCapture: true })
    }
  },
  drag: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDrag: true }),
      captured: keyOf({ onDragCapture: true })
    }
  },
  dragEnd: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDragEnd: true }),
      captured: keyOf({ onDragEndCapture: true })
    }
  },
  dragEnter: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDragEnter: true }),
      captured: keyOf({ onDragEnterCapture: true })
    }
  },
  dragExit: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDragExit: true }),
      captured: keyOf({ onDragExitCapture: true })
    }
  },
  dragLeave: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDragLeave: true }),
      captured: keyOf({ onDragLeaveCapture: true })
    }
  },
  dragOver: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDragOver: true }),
      captured: keyOf({ onDragOverCapture: true })
    }
  },
  dragStart: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDragStart: true }),
      captured: keyOf({ onDragStartCapture: true })
    }
  },
  drop: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDrop: true }),
      captured: keyOf({ onDropCapture: true })
    }
  },
  durationChange: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDurationChange: true }),
      captured: keyOf({ onDurationChangeCapture: true })
    }
  },
  emptied: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onEmptied: true }),
      captured: keyOf({ onEmptiedCapture: true })
    }
  },
  encrypted: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onEncrypted: true }),
      captured: keyOf({ onEncryptedCapture: true })
    }
  },
  ended: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onEnded: true }),
      captured: keyOf({ onEndedCapture: true })
    }
  },
  error: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onError: true }),
      captured: keyOf({ onErrorCapture: true })
    }
  },
  focus: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onFocus: true }),
      captured: keyOf({ onFocusCapture: true })
    }
  },
  input: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onInput: true }),
      captured: keyOf({ onInputCapture: true })
    }
  },
  keyDown: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onKeyDown: true }),
      captured: keyOf({ onKeyDownCapture: true })
    }
  },
  keyPress: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onKeyPress: true }),
      captured: keyOf({ onKeyPressCapture: true })
    }
  },
  keyUp: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onKeyUp: true }),
      captured: keyOf({ onKeyUpCapture: true })
    }
  },
  load: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onLoad: true }),
      captured: keyOf({ onLoadCapture: true })
    }
  },
  loadedData: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onLoadedData: true }),
      captured: keyOf({ onLoadedDataCapture: true })
    }
  },
  loadedMetadata: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onLoadedMetadata: true }),
      captured: keyOf({ onLoadedMetadataCapture: true })
    }
  },
  loadStart: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onLoadStart: true }),
      captured: keyOf({ onLoadStartCapture: true })
    }
  },
  // Note: We do not allow listening to mouseOver events. Instead, use the
  // onMouseEnter/onMouseLeave created by `EnterLeaveEventPlugin`.
  mouseDown: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onMouseDown: true }),
      captured: keyOf({ onMouseDownCapture: true })
    }
  },
  mouseMove: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onMouseMove: true }),
      captured: keyOf({ onMouseMoveCapture: true })
    }
  },
  mouseOut: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onMouseOut: true }),
      captured: keyOf({ onMouseOutCapture: true })
    }
  },
  mouseOver: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onMouseOver: true }),
      captured: keyOf({ onMouseOverCapture: true })
    }
  },
  mouseUp: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onMouseUp: true }),
      captured: keyOf({ onMouseUpCapture: true })
    }
  },
  paste: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onPaste: true }),
      captured: keyOf({ onPasteCapture: true })
    }
  },
  pause: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onPause: true }),
      captured: keyOf({ onPauseCapture: true })
    }
  },
  play: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onPlay: true }),
      captured: keyOf({ onPlayCapture: true })
    }
  },
  playing: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onPlaying: true }),
      captured: keyOf({ onPlayingCapture: true })
    }
  },
  progress: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onProgress: true }),
      captured: keyOf({ onProgressCapture: true })
    }
  },
  rateChange: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onRateChange: true }),
      captured: keyOf({ onRateChangeCapture: true })
    }
  },
  reset: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onReset: true }),
      captured: keyOf({ onResetCapture: true })
    }
  },
  scroll: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onScroll: true }),
      captured: keyOf({ onScrollCapture: true })
    }
  },
  seeked: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onSeeked: true }),
      captured: keyOf({ onSeekedCapture: true })
    }
  },
  seeking: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onSeeking: true }),
      captured: keyOf({ onSeekingCapture: true })
    }
  },
  stalled: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onStalled: true }),
      captured: keyOf({ onStalledCapture: true })
    }
  },
  submit: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onSubmit: true }),
      captured: keyOf({ onSubmitCapture: true })
    }
  },
  suspend: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onSuspend: true }),
      captured: keyOf({ onSuspendCapture: true })
    }
  },
  timeUpdate: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onTimeUpdate: true }),
      captured: keyOf({ onTimeUpdateCapture: true })
    }
  },
  touchCancel: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onTouchCancel: true }),
      captured: keyOf({ onTouchCancelCapture: true })
    }
  },
  touchEnd: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onTouchEnd: true }),
      captured: keyOf({ onTouchEndCapture: true })
    }
  },
  touchMove: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onTouchMove: true }),
      captured: keyOf({ onTouchMoveCapture: true })
    }
  },
  touchStart: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onTouchStart: true }),
      captured: keyOf({ onTouchStartCapture: true })
    }
  },
  volumeChange: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onVolumeChange: true }),
      captured: keyOf({ onVolumeChangeCapture: true })
    }
  },
  waiting: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onWaiting: true }),
      captured: keyOf({ onWaitingCapture: true })
    }
  },
  wheel: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onWheel: true }),
      captured: keyOf({ onWheelCapture: true })
    }
  }
};

var topLevelEventsToDispatchConfig = {
  topAbort: eventTypes.abort,
  topBlur: eventTypes.blur,
  topCanPlay: eventTypes.canPlay,
  topCanPlayThrough: eventTypes.canPlayThrough,
  topClick: eventTypes.click,
  topContextMenu: eventTypes.contextMenu,
  topCopy: eventTypes.copy,
  topCut: eventTypes.cut,
  topDoubleClick: eventTypes.doubleClick,
  topDrag: eventTypes.drag,
  topDragEnd: eventTypes.dragEnd,
  topDragEnter: eventTypes.dragEnter,
  topDragExit: eventTypes.dragExit,
  topDragLeave: eventTypes.dragLeave,
  topDragOver: eventTypes.dragOver,
  topDragStart: eventTypes.dragStart,
  topDrop: eventTypes.drop,
  topDurationChange: eventTypes.durationChange,
  topEmptied: eventTypes.emptied,
  topEncrypted: eventTypes.encrypted,
  topEnded: eventTypes.ended,
  topError: eventTypes.error,
  topFocus: eventTypes.focus,
  topInput: eventTypes.input,
  topKeyDown: eventTypes.keyDown,
  topKeyPress: eventTypes.keyPress,
  topKeyUp: eventTypes.keyUp,
  topLoad: eventTypes.load,
  topLoadedData: eventTypes.loadedData,
  topLoadedMetadata: eventTypes.loadedMetadata,
  topLoadStart: eventTypes.loadStart,
  topMouseDown: eventTypes.mouseDown,
  topMouseMove: eventTypes.mouseMove,
  topMouseOut: eventTypes.mouseOut,
  topMouseOver: eventTypes.mouseOver,
  topMouseUp: eventTypes.mouseUp,
  topPaste: eventTypes.paste,
  topPause: eventTypes.pause,
  topPlay: eventTypes.play,
  topPlaying: eventTypes.playing,
  topProgress: eventTypes.progress,
  topRateChange: eventTypes.rateChange,
  topReset: eventTypes.reset,
  topScroll: eventTypes.scroll,
  topSeeked: eventTypes.seeked,
  topSeeking: eventTypes.seeking,
  topStalled: eventTypes.stalled,
  topSubmit: eventTypes.submit,
  topSuspend: eventTypes.suspend,
  topTimeUpdate: eventTypes.timeUpdate,
  topTouchCancel: eventTypes.touchCancel,
  topTouchEnd: eventTypes.touchEnd,
  topTouchMove: eventTypes.touchMove,
  topTouchStart: eventTypes.touchStart,
  topVolumeChange: eventTypes.volumeChange,
  topWaiting: eventTypes.waiting,
  topWheel: eventTypes.wheel
};

for (var type in topLevelEventsToDispatchConfig) {
  topLevelEventsToDispatchConfig[type].dependencies = [type];
}

var ON_CLICK_KEY = keyOf({ onClick: null });
var onClickListeners = {};

var SimpleEventPlugin = {

  eventTypes: eventTypes,

  /**
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {DOMEventTarget} topLevelTarget The listening component root node.
   * @param {string} topLevelTargetID ID of `topLevelTarget`.
   * @param {object} nativeEvent Native browser event.
   * @return {*} An accumulation of synthetic events.
   * @see {EventPluginHub.extractEvents}
   */
  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case topLevelTypes.topAbort:
      case topLevelTypes.topCanPlay:
      case topLevelTypes.topCanPlayThrough:
      case topLevelTypes.topDurationChange:
      case topLevelTypes.topEmptied:
      case topLevelTypes.topEncrypted:
      case topLevelTypes.topEnded:
      case topLevelTypes.topError:
      case topLevelTypes.topInput:
      case topLevelTypes.topLoad:
      case topLevelTypes.topLoadedData:
      case topLevelTypes.topLoadedMetadata:
      case topLevelTypes.topLoadStart:
      case topLevelTypes.topPause:
      case topLevelTypes.topPlay:
      case topLevelTypes.topPlaying:
      case topLevelTypes.topProgress:
      case topLevelTypes.topRateChange:
      case topLevelTypes.topReset:
      case topLevelTypes.topSeeked:
      case topLevelTypes.topSeeking:
      case topLevelTypes.topStalled:
      case topLevelTypes.topSubmit:
      case topLevelTypes.topSuspend:
      case topLevelTypes.topTimeUpdate:
      case topLevelTypes.topVolumeChange:
      case topLevelTypes.topWaiting:
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case topLevelTypes.topKeyPress:
        // FireFox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case topLevelTypes.topKeyDown:
      case topLevelTypes.topKeyUp:
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case topLevelTypes.topBlur:
      case topLevelTypes.topFocus:
        EventConstructor = SyntheticFocusEvent;
        break;
      case topLevelTypes.topClick:
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case topLevelTypes.topContextMenu:
      case topLevelTypes.topDoubleClick:
      case topLevelTypes.topMouseDown:
      case topLevelTypes.topMouseMove:
      case topLevelTypes.topMouseOut:
      case topLevelTypes.topMouseOver:
      case topLevelTypes.topMouseUp:
        EventConstructor = SyntheticMouseEvent;
        break;
      case topLevelTypes.topDrag:
      case topLevelTypes.topDragEnd:
      case topLevelTypes.topDragEnter:
      case topLevelTypes.topDragExit:
      case topLevelTypes.topDragLeave:
      case topLevelTypes.topDragOver:
      case topLevelTypes.topDragStart:
      case topLevelTypes.topDrop:
        EventConstructor = SyntheticDragEvent;
        break;
      case topLevelTypes.topTouchCancel:
      case topLevelTypes.topTouchEnd:
      case topLevelTypes.topTouchMove:
      case topLevelTypes.topTouchStart:
        EventConstructor = SyntheticTouchEvent;
        break;
      case topLevelTypes.topScroll:
        EventConstructor = SyntheticUIEvent;
        break;
      case topLevelTypes.topWheel:
        EventConstructor = SyntheticWheelEvent;
        break;
      case topLevelTypes.topCopy:
      case topLevelTypes.topCut:
      case topLevelTypes.topPaste:
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ? "production" !== 'production' ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : invariant(false) : undefined;
    var event = EventConstructor.getPooled(dispatchConfig, topLevelTargetID, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (id, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    if (registrationName === ON_CLICK_KEY) {
      var node = ReactMount.getNode(id);
      if (!onClickListeners[id]) {
        onClickListeners[id] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (id, registrationName) {
    if (registrationName === ON_CLICK_KEY) {
      onClickListeners[id].remove();
      delete onClickListeners[id];
    }
  }

};

module.exports = SimpleEventPlugin;
},{"./EventConstants":313,"./EventPropagators":317,"./ReactMount":364,"./SyntheticClipboardEvent":388,"./SyntheticDragEvent":390,"./SyntheticEvent":391,"./SyntheticFocusEvent":392,"./SyntheticKeyboardEvent":394,"./SyntheticMouseEvent":395,"./SyntheticTouchEvent":396,"./SyntheticUIEvent":397,"./SyntheticWheelEvent":398,"./getEventCharCode":410,"fbjs/lib/EventListener":428,"fbjs/lib/emptyFunction":435,"fbjs/lib/invariant":443,"fbjs/lib/keyOf":447}],388:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticClipboardEvent
 * @typechecks static-only
 */

'use strict';

var SyntheticEvent = require('./SyntheticEvent');

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;
},{"./SyntheticEvent":391}],389:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticCompositionEvent
 * @typechecks static-only
 */

'use strict';

var SyntheticEvent = require('./SyntheticEvent');

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;
},{"./SyntheticEvent":391}],390:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticDragEvent
 * @typechecks static-only
 */

'use strict';

var SyntheticMouseEvent = require('./SyntheticMouseEvent');

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;
},{"./SyntheticMouseEvent":395}],391:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticEvent
 * @typechecks static-only
 */

'use strict';

var PooledClass = require('./PooledClass');

var assign = require('./Object.assign');
var emptyFunction = require('fbjs/lib/emptyFunction');
var warning = require('fbjs/lib/warning');

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 */
function SyntheticEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  this.dispatchConfig = dispatchConfig;
  this.dispatchMarker = dispatchMarker;
  this.nativeEvent = nativeEvent;
  this.target = nativeEventTarget;
  this.currentTarget = nativeEventTarget;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      this[propName] = nativeEvent[propName];
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
}

assign(SyntheticEvent.prototype, {

  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if ("production" !== 'production') {
      "production" !== 'production' ? warning(event, 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re calling `preventDefault` on a ' + 'released/nullified synthetic event. This is a no-op. See ' + 'https://fb.me/react-event-pooling for more information.') : undefined;
    }
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
    } else {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if ("production" !== 'production') {
      "production" !== 'production' ? warning(event, 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re calling `stopPropagation` on a ' + 'released/nullified synthetic event. This is a no-op. See ' + 'https://fb.me/react-event-pooling for more information.') : undefined;
    }
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
    } else {
      event.cancelBubble = true;
    }
    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      this[propName] = null;
    }
    this.dispatchConfig = null;
    this.dispatchMarker = null;
    this.nativeEvent = null;
  }

});

SyntheticEvent.Interface = EventInterface;

/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var prototype = Object.create(Super.prototype);
  assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;
},{"./Object.assign":321,"./PooledClass":322,"fbjs/lib/emptyFunction":435,"fbjs/lib/warning":454}],392:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticFocusEvent
 * @typechecks static-only
 */

'use strict';

var SyntheticUIEvent = require('./SyntheticUIEvent');

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;
},{"./SyntheticUIEvent":397}],393:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticInputEvent
 * @typechecks static-only
 */

'use strict';

var SyntheticEvent = require('./SyntheticEvent');

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;
},{"./SyntheticEvent":391}],394:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticKeyboardEvent
 * @typechecks static-only
 */

'use strict';

var SyntheticUIEvent = require('./SyntheticUIEvent');

var getEventCharCode = require('./getEventCharCode');
var getEventKey = require('./getEventKey');
var getEventModifierState = require('./getEventModifierState');

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;
},{"./SyntheticUIEvent":397,"./getEventCharCode":410,"./getEventKey":411,"./getEventModifierState":412}],395:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticMouseEvent
 * @typechecks static-only
 */

'use strict';

var SyntheticUIEvent = require('./SyntheticUIEvent');
var ViewportMetrics = require('./ViewportMetrics');

var getEventModifierState = require('./getEventModifierState');

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;
},{"./SyntheticUIEvent":397,"./ViewportMetrics":400,"./getEventModifierState":412}],396:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticTouchEvent
 * @typechecks static-only
 */

'use strict';

var SyntheticUIEvent = require('./SyntheticUIEvent');

var getEventModifierState = require('./getEventModifierState');

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;
},{"./SyntheticUIEvent":397,"./getEventModifierState":412}],397:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticUIEvent
 * @typechecks static-only
 */

'use strict';

var SyntheticEvent = require('./SyntheticEvent');

var getEventTarget = require('./getEventTarget');

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target != null && target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;
},{"./SyntheticEvent":391,"./getEventTarget":413}],398:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticWheelEvent
 * @typechecks static-only
 */

'use strict';

var SyntheticMouseEvent = require('./SyntheticMouseEvent');

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX :
    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY :
    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY :
    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;
},{"./SyntheticMouseEvent":395}],399:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Transaction
 */

'use strict';

var invariant = require('fbjs/lib/invariant');

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var Mixin = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    !!this.isInTransaction() ? "production" !== 'production' ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there ' + 'is already an outstanding transaction.') : invariant(false) : undefined;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = Transaction.OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === Transaction.OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ? "production" !== 'production' ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : invariant(false) : undefined;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== Transaction.OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

var Transaction = {

  Mixin: Mixin,

  /**
   * Token to look for to determine if an error occurred.
   */
  OBSERVED_ERROR: {}

};

module.exports = Transaction;
},{"fbjs/lib/invariant":443}],400:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ViewportMetrics
 */

'use strict';

var ViewportMetrics = {

  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }

};

module.exports = ViewportMetrics;
},{}],401:[function(require,module,exports){
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule accumulateInto
 */

'use strict';

var invariant = require('fbjs/lib/invariant');

/**
 *
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ? "production" !== 'production' ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : invariant(false) : undefined;
  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  var currentIsArray = Array.isArray(current);
  var nextIsArray = Array.isArray(next);

  if (currentIsArray && nextIsArray) {
    current.push.apply(current, next);
    return current;
  }

  if (currentIsArray) {
    current.push(next);
    return current;
  }

  if (nextIsArray) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;
},{"fbjs/lib/invariant":443}],402:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule adler32
 */

'use strict';

var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    for (; i < Math.min(i + 4096, m); i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;
},{}],403:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule canDefineProperty
 */

'use strict';

var canDefineProperty = false;
if ("production" !== 'production') {
  try {
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;
},{}],404:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule dangerousStyleValue
 * @typechecks static-only
 */

'use strict';

var CSSProperty = require('./CSSProperty');

var isUnitlessNumber = CSSProperty.isUnitlessNumber;

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;
},{"./CSSProperty":302}],405:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule deprecated
 */

'use strict';

var assign = require('./Object.assign');
var warning = require('fbjs/lib/warning');

/**
 * This will log a single deprecation notice per function and forward the call
 * on to the new API.
 *
 * @param {string} fnName The name of the function
 * @param {string} newModule The module that fn will exist in
 * @param {string} newPackage The module that fn will exist in
 * @param {*} ctx The context this forwarded call should run in
 * @param {function} fn The function to forward on to
 * @return {function} The function that will warn once and then call fn
 */
function deprecated(fnName, newModule, newPackage, ctx, fn) {
  var warned = false;
  if ("production" !== 'production') {
    var newFn = function () {
      "production" !== 'production' ? warning(warned,
      // Require examples in this string must be split to prevent React's
      // build tools from mistaking them for real requires.
      // Otherwise the build tools will attempt to build a '%s' module.
      'React.%s is deprecated. Please use %s.%s from require' + '(\'%s\') ' + 'instead.', fnName, newModule, fnName, newPackage) : undefined;
      warned = true;
      return fn.apply(ctx, arguments);
    };
    // We need to make sure all properties of the original fn are copied over.
    // In particular, this is needed to support PropTypes
    return assign(newFn, fn);
  }

  return fn;
}

module.exports = deprecated;
},{"./Object.assign":321,"fbjs/lib/warning":454}],406:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule escapeTextContentForBrowser
 */

'use strict';

var ESCAPE_LOOKUP = {
  '&': '&amp;',
  '>': '&gt;',
  '<': '&lt;',
  '"': '&quot;',
  '\'': '&#x27;'
};

var ESCAPE_REGEX = /[&><"']/g;

function escaper(match) {
  return ESCAPE_LOOKUP[match];
}

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  return ('' + text).replace(ESCAPE_REGEX, escaper);
}

module.exports = escapeTextContentForBrowser;
},{}],407:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule findDOMNode
 * @typechecks static-only
 */

'use strict';

var ReactCurrentOwner = require('./ReactCurrentOwner');
var ReactInstanceMap = require('./ReactInstanceMap');
var ReactMount = require('./ReactMount');

var invariant = require('fbjs/lib/invariant');
var warning = require('fbjs/lib/warning');

/**
 * Returns the DOM node rendered by this element.
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if ("production" !== 'production') {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      "production" !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing getDOMNode or findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : undefined;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }
  if (ReactInstanceMap.has(componentOrElement)) {
    return ReactMount.getNodeFromInstance(componentOrElement);
  }
  !(componentOrElement.render == null || typeof componentOrElement.render !== 'function') ? "production" !== 'production' ? invariant(false, 'findDOMNode was called on an unmounted component.') : invariant(false) : undefined;
  !false ? "production" !== 'production' ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : invariant(false) : undefined;
}

module.exports = findDOMNode;
},{"./ReactCurrentOwner":333,"./ReactInstanceMap":361,"./ReactMount":364,"fbjs/lib/invariant":443,"fbjs/lib/warning":454}],408:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule flattenChildren
 */

'use strict';

var traverseAllChildren = require('./traverseAllChildren');
var warning = require('fbjs/lib/warning');

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 */
function flattenSingleChildIntoContext(traverseContext, child, name) {
  // We found a component instance.
  var result = traverseContext;
  var keyUnique = result[name] === undefined;
  if ("production" !== 'production') {
    "production" !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', name) : undefined;
  }
  if (keyUnique && child != null) {
    result[name] = child;
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children) {
  if (children == null) {
    return children;
  }
  var result = {};
  traverseAllChildren(children, flattenSingleChildIntoContext, result);
  return result;
}

module.exports = flattenChildren;
},{"./traverseAllChildren":426,"fbjs/lib/warning":454}],409:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule forEachAccumulated
 */

'use strict';

/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */
var forEachAccumulated = function (arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
};

module.exports = forEachAccumulated;
},{}],410:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getEventCharCode
 * @typechecks static-only
 */

'use strict';

/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */
function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;
},{}],411:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getEventKey
 * @typechecks static-only
 */

'use strict';

var getEventCharCode = require('./getEventCharCode');

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  'Esc': 'Escape',
  'Spacebar': ' ',
  'Left': 'ArrowLeft',
  'Up': 'ArrowUp',
  'Right': 'ArrowRight',
  'Down': 'ArrowDown',
  'Del': 'Delete',
  'Win': 'OS',
  'Menu': 'ContextMenu',
  'Apps': 'ContextMenu',
  'Scroll': 'ScrollLock',
  'MozPrintableKey': 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;
},{"./getEventCharCode":410}],412:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getEventModifierState
 * @typechecks static-only
 */

'use strict';

/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  'Alt': 'altKey',
  'Control': 'ctrlKey',
  'Meta': 'metaKey',
  'Shift': 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;
},{}],413:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getEventTarget
 * @typechecks static-only
 */

'use strict';

/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */
function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;
  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;
},{}],414:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getIteratorFn
 * @typechecks static-only
 */

'use strict';

/* global Symbol */
var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;
},{}],415:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getNodeForCharacterOffset
 */

'use strict';

/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */
function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;
},{}],416:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getTextContentAccessor
 */

'use strict';

var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;
},{"fbjs/lib/ExecutionEnvironment":429}],417:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule instantiateReactComponent
 * @typechecks static-only
 */

'use strict';

var ReactCompositeComponent = require('./ReactCompositeComponent');
var ReactEmptyComponent = require('./ReactEmptyComponent');
var ReactNativeComponent = require('./ReactNativeComponent');

var assign = require('./Object.assign');
var invariant = require('fbjs/lib/invariant');
var warning = require('fbjs/lib/warning');

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function () {};
assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent.Mixin, {
  _instantiateReactComponent: instantiateReactComponent
});

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node) {
  var instance;

  if (node === null || node === false) {
    instance = new ReactEmptyComponent(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ? "production" !== 'production' ? invariant(false, 'Element type is invalid: expected a string (for built-in components) ' + 'or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : invariant(false) : undefined;

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactNativeComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);
    } else {
      instance = new ReactCompositeComponentWrapper();
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactNativeComponent.createInstanceForText(node);
  } else {
    !false ? "production" !== 'production' ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : invariant(false) : undefined;
  }

  if ("production" !== 'production') {
    "production" !== 'production' ? warning(typeof instance.construct === 'function' && typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : undefined;
  }

  // Sets up the instance. This can probably just move into the constructor now.
  instance.construct(node);

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if ("production" !== 'production') {
    instance._isOwnerNecessary = false;
    instance._warnedAboutRefsInRender = false;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if ("production" !== 'production') {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

module.exports = instantiateReactComponent;
},{"./Object.assign":321,"./ReactCompositeComponent":332,"./ReactEmptyComponent":353,"./ReactNativeComponent":367,"fbjs/lib/invariant":443,"fbjs/lib/warning":454}],418:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isEventSupported
 */

'use strict';

var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = (eventName in document);

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;
},{"fbjs/lib/ExecutionEnvironment":429}],419:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isTextInputElement
 */

'use strict';

/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */
var supportedInputTypes = {
  'color': true,
  'date': true,
  'datetime': true,
  'datetime-local': true,
  'email': true,
  'month': true,
  'number': true,
  'password': true,
  'range': true,
  'search': true,
  'tel': true,
  'text': true,
  'time': true,
  'url': true,
  'week': true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName && (nodeName === 'input' && supportedInputTypes[elem.type] || nodeName === 'textarea');
}

module.exports = isTextInputElement;
},{}],420:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule onlyChild
 */
'use strict';

var ReactElement = require('./ReactElement');

var invariant = require('fbjs/lib/invariant');

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection. The current implementation of this
 * function assumes that a single child gets passed without a wrapper, but the
 * purpose of this helper function is to abstract away the particular structure
 * of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactComponent} The first and only `ReactComponent` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ? "production" !== 'production' ? invariant(false, 'onlyChild must be passed a children with exactly one child.') : invariant(false) : undefined;
  return children;
}

module.exports = onlyChild;
},{"./ReactElement":351,"fbjs/lib/invariant":443}],421:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule quoteAttributeValueForBrowser
 */

'use strict';

var escapeTextContentForBrowser = require('./escapeTextContentForBrowser');

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;
},{"./escapeTextContentForBrowser":406}],422:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
* @providesModule renderSubtreeIntoContainer
*/

'use strict';

var ReactMount = require('./ReactMount');

module.exports = ReactMount.renderSubtreeIntoContainer;
},{"./ReactMount":364}],423:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule setInnerHTML
 */

/* globals MSApp */

'use strict';

var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = function (node, html) {
  node.innerHTML = html;
};

// Win8 apps: Allow all html to be inserted
if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
  setInnerHTML = function (node, html) {
    MSApp.execUnsafeLocalFunction(function () {
      node.innerHTML = html;
    });
  };
}

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xFEFF) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
}

module.exports = setInnerHTML;
},{"fbjs/lib/ExecutionEnvironment":429}],424:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule setTextContent
 */

'use strict';

var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
var escapeTextContentForBrowser = require('./escapeTextContentForBrowser');
var setInnerHTML = require('./setInnerHTML');

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;
},{"./escapeTextContentForBrowser":406,"./setInnerHTML":423,"fbjs/lib/ExecutionEnvironment":429}],425:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule shouldUpdateReactComponent
 * @typechecks static-only
 */

'use strict';

/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */
function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
  return false;
}

module.exports = shouldUpdateReactComponent;
},{}],426:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule traverseAllChildren
 */

'use strict';

var ReactCurrentOwner = require('./ReactCurrentOwner');
var ReactElement = require('./ReactElement');
var ReactInstanceHandles = require('./ReactInstanceHandles');

var getIteratorFn = require('./getIteratorFn');
var invariant = require('fbjs/lib/invariant');
var warning = require('fbjs/lib/warning');

var SEPARATOR = ReactInstanceHandles.SEPARATOR;
var SUBSEPARATOR = ':';

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var userProvidedKeyEscaperLookup = {
  '=': '=0',
  '.': '=1',
  ':': '=2'
};

var userProvidedKeyEscapeRegex = /[=.:]/g;

var didWarnAboutMaps = false;

function userProvidedKeyEscaper(match) {
  return userProvidedKeyEscaperLookup[match];
}

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  if (component && component.key != null) {
    // Explicit key
    return wrapUserProvidedKey(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * Escape a component key so that it is safe to use in a reactid.
 *
 * @param {*} text Component key to be escaped.
 * @return {string} An escaped string.
 */
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, userProvidedKeyEscaper);
}

/**
 * Wrap a `key` value explicitly provided by the user to distinguish it from
 * implicitly-generated keys generated by a component's index in its parent.
 *
 * @param {string} key Value of a user-provided `key` attribute
 * @return {string}
 */
function wrapUserProvidedKey(key) {
  return '$' + escapeUserProvidedKey(key);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' || ReactElement.isValidElement(children)) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if ("production" !== 'production') {
          "production" !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.') : undefined;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + wrapUserProvidedKey(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if ("production" !== 'production') {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
      !false ? "production" !== 'production' ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : invariant(false) : undefined;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;
},{"./ReactCurrentOwner":333,"./ReactElement":351,"./ReactInstanceHandles":360,"./getIteratorFn":414,"fbjs/lib/invariant":443,"fbjs/lib/warning":454}],427:[function(require,module,exports){
/**
 * Copyright 2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule validateDOMNesting
 */

'use strict';

var assign = require('./Object.assign');
var emptyFunction = require('fbjs/lib/emptyFunction');
var warning = require('fbjs/lib/warning');

var validateDOMNesting = emptyFunction;

if ("production" !== 'production') {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    parentTag: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.parentTag = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':

      case 'pre':
      case 'listing':

      case 'table':

      case 'hr':

      case 'xmp':

      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    /*eslint-disable space-after-keywords */
    do {
      /*eslint-enable space-after-keywords */
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.parentTag;
    var parentTag = parentInfo && parentInfo.tag;

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        "production" !== 'production' ? warning(false, 'validateDOMNesting(...): <%s> cannot appear as a child of <%s>. ' + 'See %s.%s', childTag, ancestorTag, ownerInfo, info) : undefined;
      } else {
        "production" !== 'production' ? warning(false, 'validateDOMNesting(...): <%s> cannot appear as a descendant of ' + '<%s>. See %s.', childTag, ancestorTag, ownerInfo) : undefined;
      }
    }
  };

  validateDOMNesting.ancestorInfoContextKey = '__validateDOMNesting_ancestorInfo$' + Math.random().toString(36).slice(2);

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.parentTag;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;
},{"./Object.assign":321,"fbjs/lib/emptyFunction":435,"fbjs/lib/warning":454}],428:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @providesModule EventListener
 * @typechecks
 */

'use strict';

var emptyFunction = require('./emptyFunction');

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function (target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function () {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function () {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function (target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function () {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if ("production" !== 'production') {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function () {}
};

module.exports = EventListener;
},{"./emptyFunction":435}],429:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ExecutionEnvironment
 */

'use strict';

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;
},{}],430:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule camelize
 * @typechecks
 */

"use strict";

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;
},{}],431:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule camelizeStyleName
 * @typechecks
 */

'use strict';

var camelize = require('./camelize');

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;
},{"./camelize":430}],432:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule containsNode
 * @typechecks
 */

'use strict';

var isTextNode = require('./isTextNode');

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 *
 * @param {?DOMNode} outerNode Outer DOM node.
 * @param {?DOMNode} innerNode Inner DOM node.
 * @return {boolean} True if `outerNode` contains or is `innerNode`.
 */
function containsNode(_x, _x2) {
  var _again = true;

  _function: while (_again) {
    var outerNode = _x,
        innerNode = _x2;
    _again = false;

    if (!outerNode || !innerNode) {
      return false;
    } else if (outerNode === innerNode) {
      return true;
    } else if (isTextNode(outerNode)) {
      return false;
    } else if (isTextNode(innerNode)) {
      _x = outerNode;
      _x2 = innerNode.parentNode;
      _again = true;
      continue _function;
    } else if (outerNode.contains) {
      return outerNode.contains(innerNode);
    } else if (outerNode.compareDocumentPosition) {
      return !!(outerNode.compareDocumentPosition(innerNode) & 16);
    } else {
      return false;
    }
  }
}

module.exports = containsNode;
},{"./isTextNode":445}],433:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule createArrayFromMixed
 * @typechecks
 */

'use strict';

var toArray = require('./toArray');

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return(
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;
},{"./toArray":453}],434:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule createNodesFromMarkup
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

'use strict';

var ExecutionEnvironment = require('./ExecutionEnvironment');

var createArrayFromMixed = require('./createArrayFromMixed');
var getMarkupWrap = require('./getMarkupWrap');
var invariant = require('./invariant');

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ? "production" !== 'production' ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : undefined;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ? "production" !== 'production' ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : undefined;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = createArrayFromMixed(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;
},{"./ExecutionEnvironment":429,"./createArrayFromMixed":433,"./getMarkupWrap":439,"./invariant":443}],435:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule emptyFunction
 */

"use strict";

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
function emptyFunction() {}

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;
},{}],436:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule emptyObject
 */

'use strict';

var emptyObject = {};

if ("production" !== 'production') {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;
},{}],437:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule focusNode
 */

'use strict';

/**
 * @param {DOMElement} node input/textarea to focus
 */
function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;
},{}],438:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getActiveElement
 * @typechecks
 */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not yet defined.
 */
'use strict';

function getActiveElement() /*?DOMElement*/{
  if (typeof document === 'undefined') {
    return null;
  }

  try {
    return document.activeElement || document.body;
  } catch (e) {
    return document.body;
  }
}

module.exports = getActiveElement;
},{}],439:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getMarkupWrap
 */

/*eslint-disable fb-www/unsafe-html */

'use strict';

var ExecutionEnvironment = require('./ExecutionEnvironment');

var invariant = require('./invariant');

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ? "production" !== 'production' ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : undefined;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;
},{"./ExecutionEnvironment":429,"./invariant":443}],440:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getUnboundedScrollPosition
 * @typechecks
 */

'use strict';

/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */
function getUnboundedScrollPosition(scrollable) {
  if (scrollable === window) {
    return {
      x: window.pageXOffset || document.documentElement.scrollLeft,
      y: window.pageYOffset || document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;
},{}],441:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule hyphenate
 * @typechecks
 */

'use strict';

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;
},{}],442:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule hyphenateStyleName
 * @typechecks
 */

'use strict';

var hyphenate = require('./hyphenate');

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;
},{"./hyphenate":441}],443:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule invariant
 */

'use strict';

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function (condition, format, a, b, c, d, e, f) {
  if ("production" !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error('Invariant Violation: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;
},{}],444:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isNode
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
'use strict';

function isNode(object) {
  return !!(object && (typeof Node === 'function' ? object instanceof Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;
},{}],445:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isTextNode
 * @typechecks
 */

'use strict';

var isNode = require('./isNode');

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;
},{"./isNode":444}],446:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyMirror
 * @typechecks static-only
 */

'use strict';

var invariant = require('./invariant');

/**
 * Constructs an enumeration with keys equal to their value.
 *
 * For example:
 *
 *   var COLORS = keyMirror({blue: null, red: null});
 *   var myColor = COLORS.blue;
 *   var isColorValid = !!COLORS[myColor];
 *
 * The last line could not be performed if the values of the generated enum were
 * not equal to their keys.
 *
 *   Input:  {key1: val1, key2: val2}
 *   Output: {key1: key1, key2: key2}
 *
 * @param {object} obj
 * @return {object}
 */
var keyMirror = function (obj) {
  var ret = {};
  var key;
  !(obj instanceof Object && !Array.isArray(obj)) ? "production" !== 'production' ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : undefined;
  for (key in obj) {
    if (!obj.hasOwnProperty(key)) {
      continue;
    }
    ret[key] = key;
  }
  return ret;
};

module.exports = keyMirror;
},{"./invariant":443}],447:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyOf
 */

/**
 * Allows extraction of a minified key. Let's the build system minify keys
 * without losing the ability to dynamically use key strings as values
 * themselves. Pass in an object with a single key/val pair and it will return
 * you the string key of that single record. Suppose you want to grab the
 * value for a key 'className' inside of an object. Key/val minification may
 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
 * reuse those resolutions.
 */
"use strict";

var keyOf = function (oneKeyObj) {
  var key;
  for (key in oneKeyObj) {
    if (!oneKeyObj.hasOwnProperty(key)) {
      continue;
    }
    return key;
  }
  return null;
};

module.exports = keyOf;
},{}],448:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule mapObject
 */

'use strict';

var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * Executes the provided `callback` once for each enumerable own property in the
 * object and constructs a new object from the results. The `callback` is
 * invoked with three arguments:
 *
 *  - the property value
 *  - the property name
 *  - the object being traversed
 *
 * Properties that are added after the call to `mapObject` will not be visited
 * by `callback`. If the values of existing properties are changed, the value
 * passed to `callback` will be the value at the time `mapObject` visits them.
 * Properties that are deleted before being visited are not visited.
 *
 * @grep function objectMap()
 * @grep function objMap()
 *
 * @param {?object} object
 * @param {function} callback
 * @param {*} context
 * @return {?object}
 */
function mapObject(object, callback, context) {
  if (!object) {
    return null;
  }
  var result = {};
  for (var name in object) {
    if (hasOwnProperty.call(object, name)) {
      result[name] = callback.call(context, object[name], name, object);
    }
  }
  return result;
}

module.exports = mapObject;
},{}],449:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule memoizeStringOnly
 * @typechecks static-only
 */

'use strict';

/**
 * Memoizes the return value of a function that accepts one string argument.
 *
 * @param {function} callback
 * @return {function}
 */
function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;
},{}],450:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule performance
 * @typechecks
 */

'use strict';

var ExecutionEnvironment = require('./ExecutionEnvironment');

var performance;

if (ExecutionEnvironment.canUseDOM) {
  performance = window.performance || window.msPerformance || window.webkitPerformance;
}

module.exports = performance || {};
},{"./ExecutionEnvironment":429}],451:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule performanceNow
 * @typechecks
 */

'use strict';

var performance = require('./performance');
var curPerformance = performance;

/**
 * Detect if we can use `window.performance.now()` and gracefully fallback to
 * `Date.now()` if it doesn't exist. We need to support Firefox < 15 for now
 * because of Facebook's testing infrastructure.
 */
if (!curPerformance || !curPerformance.now) {
  curPerformance = Date;
}

var performanceNow = curPerformance.now.bind(curPerformance);

module.exports = performanceNow;
},{"./performance":450}],452:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule shallowEqual
 * @typechecks
 * 
 */

'use strict';

var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;
},{}],453:[function(require,module,exports){
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule toArray
 * @typechecks
 */

'use strict';

var invariant = require('./invariant');

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browse builtin objects can report typeof 'function' (e.g. NodeList in
  // old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ? "production" !== 'production' ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : undefined;

  !(typeof length === 'number') ? "production" !== 'production' ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : undefined;

  !(length === 0 || length - 1 in obj) ? "production" !== 'production' ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : undefined;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

module.exports = toArray;
},{"./invariant":443}],454:[function(require,module,exports){
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule warning
 */

'use strict';

var emptyFunction = require('./emptyFunction');

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if ("production" !== 'production') {
  warning = function (condition, format) {
    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    }
  };
}

module.exports = warning;
},{"./emptyFunction":435}]},{},[56])

